/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 89091:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWarningreact = function SvgWarningreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Warning icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    fillRule: "evenodd",
    d: "m7.048 2.526-5.326 9.89a1 1 0 0 0 .881 1.475h10.652a1 1 0 0 0 .88-1.474L8.809 2.526a1 1 0 0 0-1.76 0Zm.17 3.443h1.5v3.9h-1.5v-3.9Zm0 5.2h1.5v1.3h-1.5v-1.3Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgWarningreact);

/***/ }),

/***/ 8553:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCalendar24Pxreact = function SvgCalendar24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "betterV2 calendar",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#292B29",
    clipPath: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17 8h-2V6h-2v2h-2V6H9v2H7c-.6 0-1 .4-1 1v2h12V9c0-.6-.4-1-1-1ZM6 17c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-4H6v4Z"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCalendar24Pxreact);

/***/ }),

/***/ 77044:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMail24Pxreact = function SvgMail24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "betterV2 mail",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    fillRule: "evenodd",
    d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6Zm-2 0-8 4.99L4 6h16Zm-8 7L4 8v10h16V8l-8 5Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgMail24Pxreact);

/***/ }),

/***/ 42822:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPerc24Pxreact = function SvgPerc24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    "aria-label": "betterV2 percentage",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    d: "M11.36 9.656C11.36 8.168 10.176 7 8.688 7 7.2 7 6 8.168 6 9.656c0 1.52 1.2 2.656 2.688 2.656 1.488 0 2.672-1.136 2.672-2.656Zm-4.4 8.848h1.424l8.288-11.328h-1.424L6.96 18.504Zm2.976-8.848c0 .72-.56 1.264-1.248 1.264a1.247 1.247 0 0 1-1.264-1.264c0-.72.56-1.264 1.264-1.264.688 0 1.248.544 1.248 1.264ZM17.6 16.04c0-1.488-1.184-2.656-2.672-2.656-1.488 0-2.688 1.168-2.688 2.656 0 1.52 1.2 2.656 2.688 2.656 1.488 0 2.672-1.136 2.672-2.656Zm-1.424 0c0 .72-.56 1.264-1.248 1.264a1.247 1.247 0 0 1-1.264-1.264c0-.72.56-1.264 1.264-1.264.688 0 1.248.544 1.248 1.264Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPerc24Pxreact);

/***/ }),

/***/ 99519:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPound24Pxreact = function SvgPound24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "betterV2 pound",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    d: "M12 1.5C6.202 1.5 1.5 6.202 1.5 12S6.202 22.5 12 22.5 22.5 17.798 22.5 12 17.798 1.5 12 1.5Zm0 19.219A8.72 8.72 0 0 1 3.281 12 8.72 8.72 0 0 1 12 3.281 8.72 8.72 0 0 1 20.719 12 8.72 8.72 0 0 1 12 20.719Zm3.234-4.917h-4.223v-.11c.642-.404 1.029-1.182 1.029-2.136 0-.33-.052-.654-.124-.96h2.31a.188.188 0 0 0 .188-.188v-.703a.188.188 0 0 0-.187-.188h-2.625c-.17-.53-.315-1.07-.315-1.652 0-1.02.797-1.645 2.047-1.645.504 0 .996.096 1.415.246a.186.186 0 0 0 .249-.178v-.926a.19.19 0 0 0-.122-.176 4.733 4.733 0 0 0-1.648-.298c-2.177 0-3.55 1.043-3.55 2.82 0 .616.161 1.219.341 1.807H8.767a.188.188 0 0 0-.188.187v.704c0 .103.085.187.188.187h1.572c.08.345.139.689.139 1.036 0 1.06-.675 1.952-1.707 2.208a.188.188 0 0 0-.143.183v.902c0 .103.085.187.188.187h6.42a.188.188 0 0 0 .187-.187v-.933a.188.188 0 0 0-.188-.187Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPound24Pxreact);

/***/ }),

/***/ 56368:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseIcon24Pxreact = function SvgCloseIcon24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#292B29",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17 7 7 17m10 0L7 7"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseIcon24Pxreact);

/***/ }),

/***/ 11891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCurrencyreact = function SvgCurrencyreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Currency icon",
    viewBox: "0 0 9 12",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    d: "M1.68 7.12H.736V5.792h.944V3.92c0-1.003.336-1.824 1.008-2.464C3.371.806 4.218.48 5.232.48c.725 0 1.37.16 1.936.48.565.32 1.013.736 1.344 1.248L7.264 3.36a2.588 2.588 0 0 0-.848-.816 2.08 2.08 0 0 0-1.168-.336c-.512 0-.933.16-1.264.48-.33.32-.496.73-.496 1.232v1.872h3.104V7.12H3.488v2.192c0 .459-.139.8-.416 1.024h5.472V12H.72v-1.664h.24c.224 0 .4-.09.528-.272.128-.181.192-.427.192-.736V7.12Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCurrencyreact);

/***/ }),

/***/ 93791:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMail24Pxreact = function SvgMail24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Email icon",
    viewBox: "0 0 24 24",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    fillRule: "evenodd",
    d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6Zm-2 0-8 4.99L4 6h16Zm-8 7L4 8v10h16V8l-8 5Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgMail24Pxreact);

/***/ }),

/***/ 83414:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMonthreact = function SvgMonthreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Month icon",
    viewBox: "0 0 24 24",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "WindowText",
    d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgMonthreact);

/***/ }),

/***/ 73991:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPercentageSignreact = function SvgPercentageSignreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Percentage sign icon",
    viewBox: "0 0 12 13",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    d: "M5.384 3.152c0 .757-.261 1.392-.784 1.904-.512.501-1.141.752-1.888.752-.746 0-1.381-.25-1.904-.752C.286 4.544.024 3.909.024 3.152c0-.747.262-1.376.784-1.888A2.62 2.62 0 0 1 2.712.496c.747 0 1.376.256 1.888.768.523.512.784 1.141.784 1.888ZM.984 12 9.272.672h1.424L2.408 12H.984Zm2.608-7.952a1.22 1.22 0 0 0 .368-.896c0-.352-.122-.65-.368-.896a1.167 1.167 0 0 0-.88-.368c-.352 0-.65.123-.896.368a1.186 1.186 0 0 0-.368.896c0 .363.123.667.368.912.246.235.544.352.896.352s.646-.123.88-.368Zm8.032 5.488c0 .757-.261 1.392-.784 1.904-.512.501-1.141.752-1.888.752-.746 0-1.381-.25-1.904-.752-.522-.512-.784-1.147-.784-1.904 0-.747.262-1.376.784-1.888a2.62 2.62 0 0 1 1.904-.768c.747 0 1.376.256 1.888.768.523.512.784 1.141.784 1.888Zm-1.792.912c.246-.245.368-.55.368-.912 0-.363-.122-.661-.368-.896a1.167 1.167 0 0 0-.88-.368c-.352 0-.65.123-.896.368a1.186 1.186 0 0 0-.368.896c0 .363.123.667.368.912.246.235.544.352.896.352s.646-.117.88-.352Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPercentageSignreact);

/***/ }),

/***/ 25784:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCancelreact = function SvgCancelreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    "aria-label": "Cancel icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#292B29",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M11 1 1 11m10 0L1 1"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCancelreact);

/***/ }),

/***/ 10377:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseBetterv2React = function SvgCloseBetterv2React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Cancel icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseBetterv2React);

/***/ }),

/***/ 36209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSearchBetterv2React = function SvgSearchBetterv2React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Search icon",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#A4A8A4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m17.57 19-3.55-3.62 1.43-1.4L19 17.61 17.57 19Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11 7.18c2.18 0 3.82 1.64 3.82 3.82 0 2.18-1.64 3.82-3.82 3.82-2.18 0-3.82-1.64-3.82-3.82 0-2.18 1.64-3.82 3.82-3.82ZM11 5c-3.36 0-6 2.58-6 6s2.64 6 6 6 6-2.58 6-6-2.64-6-6-6Z"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSearchBetterv2React);

/***/ }),

/***/ 83862:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSearchIcon21Pxreact = function SvgSearchIcon21Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    "aria-label": "Search icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    fillRule: "evenodd",
    d: "M8 1.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5ZM.25 8a7.75 7.75 0 1 1 13.735 4.924l6.545 6.546a.75.75 0 1 1-1.06 1.06l-6.546-6.545A7.75 7.75 0 0 1 .25 8Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSearchIcon21Pxreact);

/***/ }),

/***/ 70772:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTrustpilotreact = function SvgTrustpilotreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 18,
    fill: "none",
    "aria-label": "trustpilot logo",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#FFFDFA"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.797 6.377h7.346v1.386h-2.885v7.784H22.67V7.763h-2.872V6.377Zm7.028 2.53h1.36v1.284h.025c.047-.19.13-.37.247-.526a2.387 2.387 0 0 1 1.024-.81c.206-.084.426-.128.648-.129.117-.002.233.002.35.012.064.01.128.018.197.026v1.413a6.492 6.492 0 0 0-.312-.045 2.548 2.548 0 0 0-.311-.02 1.65 1.65 0 0 0-.693.149c-.218.1-.412.25-.565.436-.172.21-.302.452-.384.711a3.108 3.108 0 0 0-.14.977v3.159h-1.446V8.907Zm10.5 6.64H35.9v-.926h-.026a2.009 2.009 0 0 1-.794.802 2.14 2.14 0 0 1-1.074.302c-.864 0-1.49-.216-1.875-.647-.385-.431-.577-1.084-.576-1.958V8.907h1.446v4.07c0 .583.11.993.33 1.23.221.237.53.357.929.36.26.009.521-.04.763-.14a1.346 1.346 0 0 0 .769-.95c.056-.236.084-.478.082-.72v-3.85h1.45v6.64Zm2.464-2.132c.043.428.204.728.483.898.304.179.652.269 1.004.26.155-.002.31-.013.464-.033.167-.02.332-.06.489-.122a.912.912 0 0 0 .374-.263.637.637 0 0 0 .134-.456.654.654 0 0 0-.203-.462 1.41 1.41 0 0 0-.49-.29 4.797 4.797 0 0 0-.68-.186c-.255-.05-.514-.106-.775-.167a7.228 7.228 0 0 1-.781-.218 2.51 2.51 0 0 1-.674-.346 1.595 1.595 0 0 1-.476-.56 1.8 1.8 0 0 1-.178-.84c-.011-.323.08-.64.26-.906.175-.246.402-.448.665-.592a2.85 2.85 0 0 1 .89-.315 5.2 5.2 0 0 1 .934-.09 4.3 4.3 0 0 1 .972.11c.297.067.581.187.838.352.251.164.464.381.623.636.174.287.28.61.312.944h-1.516c-.068-.351-.227-.587-.476-.706a1.968 1.968 0 0 0-.858-.18c-.121.001-.242.01-.363.026a1.634 1.634 0 0 0-.393.096.824.824 0 0 0-.312.205.495.495 0 0 0-.128.353.562.562 0 0 0 .184.437c.142.123.306.216.483.277.222.078.45.14.68.185.256.052.519.108.788.168.262.06.52.132.776.218.242.08.472.196.68.346.199.147.363.335.482.553.13.253.194.536.184.822 0 .393-.089.727-.266 1.001a2.116 2.116 0 0 1-.693.668 3.118 3.118 0 0 1-.947.373 4.75 4.75 0 0 1-1.03.115 4.42 4.42 0 0 1-1.152-.141c-.33-.084-.64-.23-.915-.43a2.065 2.065 0 0 1-.61-.72 2.3 2.3 0 0 1-.235-1.02h1.452Zm4.778-4.508h1.093v-1.99h1.449v1.99h1.31v1.092h-1.31v3.544c0 .133.006.266.02.398.009.1.04.196.089.282.049.08.122.14.21.174.122.044.253.063.383.058.102 0 .204 0 .305-.007.103-.004.205-.02.305-.045v1.13l-.47.052a4.123 4.123 0 0 1-.47.025 3.16 3.16 0 0 1-.922-.109 1.225 1.225 0 0 1-.546-.323 1.114 1.114 0 0 1-.267-.533 4.008 4.008 0 0 1-.083-.732V9.999h-1.095V8.907Zm4.866 0h1.374v.899h.026c.183-.365.483-.657.852-.828a2.802 2.802 0 0 1 1.181-.25c.466-.011.929.083 1.354.275.374.175.702.434.96.758.26.334.455.715.572 1.123.13.447.195.91.192 1.375 0 .437-.057.872-.171 1.293a3.39 3.39 0 0 1-.522 1.111 2.617 2.617 0 0 1-.883.77c-.355.194-.775.29-1.258.29-.213 0-.426-.02-.635-.058a2.71 2.71 0 0 1-.61-.186 2.397 2.397 0 0 1-.54-.328 1.806 1.806 0 0 1-.414-.468h-.025v3.313h-1.45l-.003-9.09Zm5.058 3.326c0-.295-.038-.588-.115-.873a2.388 2.388 0 0 0-.34-.75 1.778 1.778 0 0 0-.572-.526 1.542 1.542 0 0 0-.788-.2c-.61 0-1.07.214-1.379.642-.309.428-.463.997-.464 1.707a3.43 3.43 0 0 0 .121.931c.07.268.193.519.36.739.155.201.352.367.575.487.242.125.51.186.782.18.292.01.582-.061.838-.205a1.78 1.78 0 0 0 .566-.533c.152-.226.261-.478.32-.745.065-.28.098-.566.098-.854h-.002Zm2.554-5.856h1.452v1.386h-1.449l-.003-1.386Zm0 2.53h1.452v6.64h-1.449l-.003-6.64Zm2.744-2.53h1.449v9.17H59.79l-.002-9.17Zm5.884 9.35a3.55 3.55 0 0 1-1.402-.265 2.987 2.987 0 0 1-1.042-.726 3.101 3.101 0 0 1-.647-1.103 4.56 4.56 0 0 1 0-2.813c.137-.41.358-.786.648-1.104.292-.313.647-.56 1.041-.724a3.885 3.885 0 0 1 2.809 0c.394.165.75.412 1.042.726.29.318.51.694.648 1.104a4.562 4.562 0 0 1 0 2.813c-.137.41-.358.786-.648 1.104a3 3 0 0 1-1.042.723 3.554 3.554 0 0 1-1.405.264h-.002Zm0-1.157a1.651 1.651 0 0 0 1.424-.745c.154-.228.268-.482.336-.75a3.419 3.419 0 0 0 0-1.702 2.298 2.298 0 0 0-.337-.752 1.805 1.805 0 0 0-.585-.532 1.814 1.814 0 0 0-1.677 0 1.803 1.803 0 0 0-.585.532c-.156.228-.27.483-.336.752a3.398 3.398 0 0 0 0 1.701c.067.269.181.523.336.752.153.222.352.406.585.539.258.142.548.213.841.205h-.002Zm3.736-5.663h1.093v-1.99h1.449v1.99h1.309v1.092h-1.31v3.544c0 .133.006.266.02.398.009.1.04.196.09.282a.42.42 0 0 0 .208.174c.124.044.254.063.385.058.101 0 .203 0 .304-.007a1.49 1.49 0 0 0 .305-.045v1.13l-.47.052a4.123 4.123 0 0 1-.47.025 3.171 3.171 0 0 1-.922-.109 1.223 1.223 0 0 1-.546-.323 1.113 1.113 0 0 1-.267-.533 4.017 4.017 0 0 1-.082-.732V9.999h-1.093l-.003-1.092ZM18.105 6.378l-6.635-.001L9.42 0 7.37 6.376.734 6.375l5.369 3.942-2.05 6.378 5.368-3.941 5.366 3.941-2.05-6.376 5.368-3.941Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m13.203 11.764-.465-1.446-3.316 2.435 3.781-.99Z"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTrustpilotreact);

/***/ }),

/***/ 77454:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAddDarkreact = function SvgAddDarkreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAddDarkreact);

/***/ }),

/***/ 50434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAddreact = function SvgAddreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Add icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 3.833C9 3.373 8.552 3 8 3s-1 .373-1 .833V7H4a1 1 0 0 0 0 2h3v3.167c0 .46.448.833 1 .833s1-.373 1-.833V9h3a1 1 0 1 0 0-2H9V3.833Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAddreact);

/***/ }),

/***/ 70070:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAlertreact = function SvgAlertreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    "aria-label": "Alert icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#A32600",
    fillRule: "evenodd",
    d: "M11.99 2.055C6.47 2.055 2 6.659 2 12.332c0 5.674 4.47 10.278 9.99 10.278 5.53 0 10.01-4.604 10.01-10.277 0-5.674-4.48-10.278-10.01-10.278ZM13 13.36V7.194h-2v6.166h2Zm0 4.111v-2.055h-2v2.055h2Zm-9-5.139c0 4.543 3.58 8.223 8 8.223s8-3.68 8-8.223c0-4.542-3.58-8.222-8-8.222s-8 3.68-8 8.223Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAlertreact);

/***/ }),

/***/ 11070:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowreact = function SvgArrowreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    "aria-label": "Add icon",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible"
    },
    role: "img"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M0 0h500v500H0z"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    stroke: "#073126",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 30,
    d: "M57.596-26.955-.001 26.955l-57.596-53.91",
    style: {
      display: "block"
    },
    transform: "translate(250 353.19)"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    opacity: 0.8,
    style: {
      display: "block"
    }
  }, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    stroke: "#004733",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 30,
    d: "m307.596 248.163-57.597 53.91-57.596-53.91",
    opacity: 1
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    opacity: 0.5,
    style: {
      display: "block"
    }
  }, _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    stroke: "#017848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 30,
    d: "m307.596 169.062-57.597 53.912-57.596-53.912",
    opacity: 1
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowreact);

/***/ }),

/***/ 69554:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowForwardreact = function SvgArrowForwardreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Forward arrow",
    viewBox: "0 0 24 24",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowForwardreact);

/***/ }),

/***/ 55982:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowLeft24Pxreact = function SvgArrowLeft24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    fill: "none",
    "aria-label": "Left arrow",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "m5.5 0-5 5 5 5V0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowLeft24Pxreact);

/***/ }),

/***/ 48854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowRight24Pxreact = function SvgArrowRight24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    fill: "none",
    "aria-label": "Right arrow",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "m.5 10 5-5-5-5v10Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowRight24Pxreact);

/***/ }),

/***/ 63327:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _circle, _path, _path2, _path3, _path4, _path5, _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAvatarreact = function SvgAvatarreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Avatar icon",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#041942"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#E2B8A1",
    d: "M12.386 18.559 11.34 22.06l-5.725-3.85 2.622-3.188 4.149 3.536Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#E2B8A1",
    d: "M19.123 14.16c-.266-.366-.382-.83-.465-1.262-.116-.53-.232-1.062-.15-1.61.034-.199.05-.381.084-.58.016-.1.016-.216.05-.316.415-2.257-2.008-4.796-4.58-5.759a7.138 7.138 0 0 0-9.178 4.182c-1.377 3.685.498 7.801 4.182 9.179l4.995 1.184c1.43.331 2.26-.332 3.173-1.826l.71-2.163c.714.282 1.71-.3 1.179-1.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#50C087",
    d: "M16.816 2.243c-.697.1-1.31.432-1.759.913a10.899 10.899 0 0 0-1.776-.68C9.066 1.248 5.067 3.82 3.623 7.588a8.694 8.694 0 0 0-.547 3.667c.116 1.527.73 2.988 1.875 4.017.116.1 1.809 1.477 1.858 1.427l4.73-5.626a9.37 9.37 0 0 0 .266-1.328c.182-1.494 1.991-2.722 3.468-2.19l.797.298c.464.183.979.266 1.51.2a2.921 2.921 0 0 0 2.506-3.287 2.926 2.926 0 0 0-3.27-2.523Z"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "url(#a)",
    d: "M16.816 2.243c-.697.1-1.31.432-1.759.913a10.899 10.899 0 0 0-1.776-.68C9.066 1.248 5.067 3.82 3.623 7.588a8.694 8.694 0 0 0-.547 3.667c.116 1.527.73 2.988 1.875 4.017.116.1 1.809 1.477 1.858 1.427l4.73-5.626a9.37 9.37 0 0 0 .266-1.328c.182-1.494 1.991-2.722 3.468-2.19l.797.298c.464.183.979.266 1.51.2a2.921 2.921 0 0 0 2.506-3.287 2.926 2.926 0 0 0-3.27-2.523Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#E2B8A1",
    d: "M10.112 13.646a1.626 1.626 0 1 0 0-3.253 1.626 1.626 0 0 0 0 3.253Z"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "url(#b)",
    d: "m12.388 18.647-2.124-.713s.166 1.941 1.61 2.356l.514-1.643Z"
  })), _mask || (_mask = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "c",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 11.999,
    cy: 12,
    fill: "#00414C",
    rx: 11.999,
    ry: 12
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FF7396",
    d: "M3.088 17.235C1.996 17.8.933 18.72.54 19.109l3.052 7.068c2.477.543 7.697 1.361 8.762.294 1.33-1.334.766-3.033-.047-3.617-.814-.584-.996-1.046-4.277-3.851-3.281-2.806-3.575-2.475-4.94-1.768Z"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "a",
    x1: 20.51,
    x2: 2.929,
    y1: 7.867,
    y2: 10.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.238,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.311,
    stopColor: "#F9FBFB",
    stopOpacity: 0.096
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.406,
    stopColor: "#E9EEF0",
    stopOpacity: 0.22
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.512,
    stopColor: "#CED9DE",
    stopOpacity: 0.36
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.628,
    stopColor: "#A9BBC5",
    stopOpacity: 0.512
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.751,
    stopColor: "#7995A5",
    stopOpacity: 0.673
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.877,
    stopColor: "#3F687E",
    stopOpacity: 0.839
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#003654"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "b",
    x1: 10.777,
    x2: 11.359,
    y1: 19.898,
    y2: 18.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.034,
    stopColor: "#F7F6F4",
    stopOpacity: 0.024
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.176,
    stopColor: "#DAD3CE",
    stopOpacity: 0.124
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.324,
    stopColor: "#C2B6AE",
    stopOpacity: 0.227
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.476,
    stopColor: "#AFA095",
    stopOpacity: 0.333
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.634,
    stopColor: "#A19083",
    stopOpacity: 0.444
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.803,
    stopColor: "#9A8778",
    stopOpacity: 0.562
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#978475",
    stopOpacity: 0.7
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAvatarreact);

/***/ }),

/***/ 77977:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBetterLogoV2React = function SvgBetterLogoV2React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 24,
    fill: "none",
    "aria-label": "Better logo",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFDFA",
    fillRule: "evenodd",
    d: "M.242 10.767v1.863l8.643 3.705v-5.568c0-4.116-1.666-7.42-4.411-7.42-2.562 0-4.232 3.298-4.232 7.42ZM23.53 23.586V10.14h-.006c0-5.534-2.28-10.142-6.037-10.142-3.993 0-6.361 4.6-6.361 10.142v7.11l12.404 6.335Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#FFFDFA",
    clipPath: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M106.318 9.796V5.194h-5.287v18.414h5.287V12.634c.492-1.656 2.798-3.206 6.124-2.43V4.825c-2.765 0-5.144 1.917-6.124 4.973M79.512 17.9V8.843h3.603V5.234l-3.603.004V.854L69.5 8.294v-6.48l-8.366 6.628v.407h3.152v10.088c0 3.205 2.24 4.898 5.287 4.898 1.33 0 2.45-.257 3.464-.881v-3.795c-.492.296-1.086.518-1.75.518-1.118 0-1.785-.59-1.785-1.622V8.846h4.795V18.9c0 3.24 2.24 4.933 5.32 4.933 1.367 0 2.484-.185 3.57-.881v-3.83a3.584 3.584 0 0 1-1.856.552c-1.121-.006-1.822-.631-1.822-1.773m8.885-4.048c0-3.02 1.823-5.044 4.025-5.044 1.612 0 2.416.92 2.416 1.806 0 1.288-.98 2.581-6.44 3.24m10.812-3.901c0-2.836-2.765-5.23-6.616-5.23-5.111 0-9.24 3.941-9.24 9.686 0 5.412 4.234 9.427 9.558 9.427 2.278-.005 4.588-.7 6.268-1.954v-4.899c-1.75 1.55-4.096 2.396-5.986 2.396-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554m-49.24 3.932c0-3.02 1.818-5.044 4.027-5.044 1.61 0 2.416.92 2.416 1.806 0 1.288-.98 2.581-6.44 3.24m10.812-3.9c0-2.836-2.766-5.23-6.617-5.23-5.111 0-9.24 3.942-9.24 9.686 0 5.412 4.234 9.427 9.559 9.427 2.277-.005 4.587-.7 6.267-1.954V17.02c-1.75 1.549-4.096 2.395-5.986 2.395-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554M35.337 19.3h-3.99v-5.597h3.99c1.644 0 3.01 1.068 3.01 2.87 0 1.695-1.368 2.724-3.01 2.724m-3.99-15.02h3.709c1.573 0 2.833 1.03 2.833 2.613 0 1.695-1.262 2.724-2.834 2.724h-3.708V4.276Zm8.61 7.213c2.03-.958 3.397-2.836 3.397-5.084C43.352 2.542 40.13 0 36.036 0H25.922v23.608H36.49c4.058 0 7.248-2.613 7.248-6.593 0-2.542-1.541-4.566-3.781-5.523"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M106.318 9.796V5.194h-5.287v18.414h5.287V12.634c.492-1.656 2.798-3.206 6.124-2.43V4.825c-2.765 0-5.144 1.917-6.124 4.973m-56.348 4.09c0-3.02 1.818-5.044 4.027-5.044 1.61 0 2.416.92 2.416 1.806 0 1.288-.98 2.581-6.44 3.24m10.812-3.9c0-2.836-2.766-5.23-6.617-5.23-5.111 0-9.24 3.942-9.24 9.686 0 5.412 4.234 9.427 9.559 9.427 2.277-.005 4.587-.7 6.267-1.954V17.02c-1.75 1.549-4.096 2.395-5.986 2.395-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554M79.512 17.9V8.843h3.603V5.234l-3.603.04V.853L69.5 8.294v-6.48l-8.366 6.628v.407h3.152v10.088c0 3.205 2.24 4.898 5.287 4.898 1.33 0 2.45-.257 3.464-.881v-3.795c-.492.296-1.086.518-1.75.518-1.118 0-1.785-.59-1.785-1.622V8.846h4.795V18.9c0 3.24 2.24 4.933 5.32 4.933 1.367 0 2.484-.185 3.57-.881v-3.83a3.584 3.584 0 0 1-1.856.552c-1.121-.006-1.822-.631-1.822-1.773M35.337 19.3h-3.99v-5.597h3.99c1.644 0 3.01 1.068 3.01 2.87 0 1.695-1.368 2.724-3.01 2.724m-3.99-15.02h3.709c1.573 0 2.833 1.03 2.833 2.613 0 1.695-1.262 2.724-2.834 2.724h-3.708V4.276Zm8.61 7.213c2.03-.958 3.397-2.836 3.397-5.084C43.352 2.542 40.13 0 36.036 0H25.922v23.608H36.49c4.058 0 7.248-2.613 7.248-6.593 0-2.542-1.541-4.566-3.781-5.523m78.982 8.92c0 .931-.539 1.686-1.398 1.686-.859 0-1.398-.755-1.398-1.686 0-.931.536-1.73 1.398-1.73.862 0 1.398.798 1.398 1.73Zm1.723.006c0-1.744-1.403-3.159-3.12-3.158-1.861 0-3.12 1.415-3.12 3.158 0 1.743 1.356 3.184 3.119 3.184 1.763 0 3.12-1.368 3.12-3.184m4.778 3.185c2.021 0 2.605-1.412 2.605-2.756v-3.415h-1.772v3.45c.019.734-.322 1.206-.921 1.206-.64 0-.981-.49-.976-1.205v-3.451h-1.781v3.414c0 1.399.728 2.756 2.846 2.756m3.349-.074h1.771v-2.307s.607.255 1.138 1.014c.618.885.771 1.293.771 1.293h2.057s-.693-1.268-1.383-2.057c-.91-1.04-1.595-1.295-1.595-1.295s.974-.397 1.707-1.302c.631-.78.831-1.447.831-1.447h-1.907s-.056.468-.583 1.254c-.528.786-1.036 1.034-1.036 1.034v-4.031h-1.771v7.844Zm-17.24-6.268c-1.697 0-2.947 1.303-2.947 3.211 0 1.798 1.326 3.131 3.299 3.131.757-.001 1.524-.32 2.082-.736v-1.627c-.581.514-1.36.886-1.988.883-.635-.004-1.65-.257-1.646-1.834-.02-1.088.558-1.62 1.133-1.612.554.009 1.029.265 1.129 1.317l1.508-.547c-.146-1.595-1.515-2.185-2.57-2.185"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M107.678 23.603c.533 0 .966-.456.966-1.018 0-.561-.433-1.017-.966-1.017-.534 0-.967.456-.967 1.017 0 .562.433 1.018.967 1.018Zm13.843 0c.534 0 .967-.456.967-1.018 0-.561-.433-1.017-.967-1.017-.533 0-.966.456-.966 1.017 0 .562.433 1.018.966 1.018Z"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M25.922 0h108.72v24H25.922z"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgBetterLogoV2React);

/***/ }),

/***/ 96225:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBetterLogoreact = function SvgBetterLogoreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Better logo",
    viewBox: "0 0 166 24",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#logo_green0_1654_8280)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#logo_green1_1654_8280)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#logo_green2_1654_8280)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#017848",
    clipPath: "url(#logo_green3_1654_8280)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M79.816 9.854V5.228h-5.314v18.51h5.314V12.706c.495-1.665 2.813-3.222 6.156-2.444V4.86c-2.78 0-5.17 1.927-6.156 4.998M52.865 18V8.894h3.622V5.268l-3.622.004V.865L42.801 8.343V1.83l-8.41 6.662v.41h3.169v10.14c0 3.221 2.251 4.923 5.314 4.923 1.337 0 2.463-.258 3.482-.886v-3.814c-.495.297-1.092.52-1.759.52-1.125 0-1.794-.592-1.794-1.63V8.9h4.82v10.105c0 3.257 2.25 4.959 5.346 4.959 1.375 0 2.497-.186 3.589-.886v-3.85a3.602 3.602 0 0 1-1.865.556c-1.127-.007-1.832-.635-1.832-1.783m8.938-4.069c0-3.036 1.832-5.07 4.046-5.07 1.62 0 2.428.925 2.428 1.815 0 1.295-.985 2.595-6.474 3.257m10.869-3.922c0-2.85-2.78-5.256-6.651-5.256-5.137 0-9.287 3.962-9.287 9.736 0 5.44 4.256 9.476 9.607 9.476 2.29-.005 4.612-.705 6.3-1.965V17.08c-1.759 1.558-4.117 2.409-6.017 2.409-1.9 0-3.553-1.11-4.328-2.885 6.964-.516 10.378-3.036 10.378-6.588m47.144 4.294c0 2.818-1.633 5.103-4.231 5.103-2.599 0-4.232-2.285-4.232-5.102 0-2.818 1.622-5.233 4.232-5.233 2.609 0 4.231 2.413 4.231 5.233Zm5.213.02c0-5.278-4.245-9.56-9.442-9.557-5.63.002-9.442 4.282-9.442 9.556 0 5.275 4.104 9.636 9.44 9.636 5.336 0 9.441-4.14 9.441-9.636M23.17 13.967c0-3.036 1.828-5.07 4.049-5.07 1.617 0 2.428.925 2.428 1.815 0 1.295-.985 2.595-6.474 3.257m10.869-3.922c0-2.85-2.78-5.256-6.65-5.256-5.138 0-9.288 3.961-9.288 9.736 0 5.44 4.256 9.475 9.608 9.475 2.289-.004 4.61-.704 6.3-1.964v-4.924c-1.76 1.558-4.117 2.409-6.018 2.409-1.9 0-3.553-1.11-4.328-2.885 6.964-.516 10.378-3.036 10.378-6.588m105.435 13.915c6.117 0 7.882-4.273 7.882-8.34V5.29h-5.36v10.442c.057 2.22-.977 3.648-2.789 3.648-1.935 0-2.97-1.481-2.952-3.648V5.291h-5.391v10.33c0 4.234 2.205 8.342 8.613 8.342m10.157-.226h5.358v-6.983s1.839.772 3.445 3.069c1.872 2.678 2.334 3.914 2.334 3.914H167s-2.097-3.838-4.185-6.225c-2.753-3.146-4.826-3.917-4.826-3.917s2.946-1.202 5.164-3.94c1.911-2.36 2.515-4.38 2.515-4.38h-5.77s-.17 1.415-1.765 3.794c-1.598 2.38-3.136 3.13-3.136 3.13V0h-5.358v23.737ZM97.466 4.773c-5.137 0-8.92 3.942-8.92 9.717 0 5.44 4.013 9.475 9.985 9.475 2.289-.005 4.612-.97 6.3-2.23v-4.923c-1.759 1.558-4.117 2.683-6.017 2.673-1.92-.011-4.991-.778-4.98-5.55-.06-3.29 1.688-4.904 3.429-4.876 1.677.026 3.113.8 3.416 3.982l4.563-1.652c-.442-4.826-4.585-6.612-7.776-6.612M8.464 19.406h-4.01v-5.625h4.01c1.652 0 3.025 1.074 3.025 2.885 0 1.704-1.375 2.738-3.025 2.738M4.454 4.305H8.18c1.582 0 2.848 1.037 2.848 2.627 0 1.704-1.268 2.739-2.848 2.739H4.453V4.305Zm8.654 7.251c2.04-.962 3.414-2.85 3.414-5.11C16.52 2.562 13.282.007 9.166.007H-1v23.73H9.624c4.079 0 7.285-2.627 7.285-6.627 0-2.555-1.55-4.59-3.8-5.552"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M79.816 9.854V5.228h-5.314v18.51h5.314V12.706c.495-1.665 2.813-3.222 6.156-2.444V4.86c-2.78 0-5.17 1.927-6.156 4.998M23.17 13.967c0-3.036 1.828-5.07 4.049-5.07 1.617 0 2.428.925 2.428 1.815 0 1.295-.985 2.595-6.474 3.257m10.869-3.922c0-2.85-2.78-5.256-6.65-5.256-5.138 0-9.288 3.961-9.288 9.736 0 5.44 4.256 9.475 9.608 9.475 2.289-.004 4.61-.704 6.3-1.964v-4.924c-1.76 1.558-4.117 2.409-6.018 2.409-1.9 0-3.553-1.11-4.328-2.885 6.964-.516 10.378-3.036 10.378-6.588M52.865 18V8.894h3.622V5.268l-3.622.04V.864L42.801 8.343V1.83l-8.41 6.662v.41h3.169v10.14c0 3.221 2.251 4.923 5.314 4.923 1.337 0 2.463-.258 3.482-.886v-3.814c-.495.297-1.092.52-1.759.52-1.125 0-1.794-.592-1.794-1.63V8.9h4.82v10.105c0 3.257 2.25 4.959 5.346 4.959 1.375 0 2.497-.186 3.589-.886v-3.85a3.602 3.602 0 0 1-1.865.556c-1.127-.007-1.832-.635-1.832-1.783M8.464 19.406h-4.01v-5.625h4.01c1.652 0 3.025 1.074 3.025 2.885 0 1.704-1.375 2.738-3.025 2.738M4.454 4.305H8.18c1.582 0 2.848 1.037 2.848 2.627 0 1.704-1.268 2.739-2.848 2.739H4.453V4.305Zm8.654 7.251c2.04-.962 3.414-2.85 3.414-5.11C16.52 2.562 13.282.007 9.166.007H-1v23.73H9.624c4.079 0 7.285-2.627 7.285-6.627 0-2.555-1.55-4.59-3.8-5.552m72.633 12.407c1.615 0 2.926-1.378 2.926-3.078s-1.31-3.078-2.926-3.078c-1.615 0-2.925 1.379-2.925 3.078 0 1.7 1.31 3.078 2.925 3.078Zm41.885 0c1.615 0 2.926-1.378 2.926-3.078s-1.311-3.078-2.926-3.078c-1.615 0-2.925 1.379-2.925 3.078 0 1.7 1.31 3.078 2.925 3.078Z"
  })))))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgBetterLogoreact);

/***/ }),

/***/ 23488:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBorrowingreact = function SvgBorrowingreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    "aria-label": "decorative borrowing icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M23.337 11.791h-2.284v3.343h3.712c.496 0 .901.442.901.983 0 .54-.405.983-.901.983h-6.237c-.496 0-.901-.442-.901-.983 0-.54.405-.983.901-.983h.466V11.79h-.571c-.466 0-.857-.426-.857-.934 0-.524.391-.95.857-.95h.571V8.449c0-2.212 1.548-3.949 3.727-3.949.571 0 1.232.05 1.893.393.421.213.647.574.647 1.016 0 .54-.406 1-.902.918-.466-.082-.902-.344-1.623-.344-1.037 0-1.683.54-1.683 2.179v1.245h2.284c.466 0 .842.426.842.95 0 .508-.376.934-.842.934ZM33.776 22.08c-1.87-1.096-3.439.529-4.03 1.14-1.245 1.29-2.745 2.565-3.504 3.192a2.63 2.63 0 0 0-1.052-.23c-2.314-.125-5.96-.542-6.872-1.084-.98-.583-1.765-1.152-2.458-1.654-1.99-1.442-3.56-2.58-7.474-2.58-1.134 0-2.129.314-3.09.619-.988.312-1.92.608-3.046.608A2.252 2.252 0 0 0 0 24.34v5.726a2.252 2.252 0 0 0 2.25 2.25c2.14 0 5.484.11 6.222.357 1.33.443 4.447 2.291 5.536 2.966l.042.024c.394.22.84.335 1.292.335h10.4c1.1 0 2.324-1.018 2.748-1.723 1.364-2.262 6.254-8.42 6.303-8.482a1.05 1.05 0 0 0 .113-.179c.634-1.267.148-2.787-1.13-3.535Zm-8.035 11.873h-10.4a.622.622 0 0 1-.282-.068c-.385-.238-4.169-2.561-5.94-3.152-1.318-.439-5.954-.461-6.869-.461a.205.205 0 0 1-.205-.205V24.34c0-.113.092-.205.205-.205 1.44 0 2.622-.374 3.662-.703.889-.281 1.656-.524 2.474-.524 3.25 0 4.388.825 6.274 2.192.728.527 1.553 1.124 2.612 1.755.532.317 1.414.565 2.402.758 2.123.416 4.739.576 5.431.612a.799.799 0 0 0 .054.002.615.615 0 0 1 0 1.226l-.054.002-7.739.408c-.616-.023-2.07-1.053-3.037-1.736-.25-.178-.494-.348-.734-.514-.523-.361-1.022-.686-1.479-.915a1.023 1.023 0 0 0-.914 1.83c.527.263 1.216.751 1.946 1.268 1.534 1.087 2.984 2.113 4.239 2.113l.054-.001 7.749-.409a2.662 2.662 0 0 0 2.46-3.595c.82-.68 2.297-1.946 3.569-3.262.871-.902 1.219-.976 1.525-.797.27.16.47.47.365.782-.68.858-5.023 6.36-6.37 8.594-.18.296-.78.71-.998.732Z"
  })), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 21.617,
    cy: 11.25,
    r: 10.25,
    stroke: "#017848",
    strokeWidth: 2
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgBorrowingreact);

/***/ }),

/***/ 65849:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCalendarreact = function SvgCalendarreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFDFA",
    fillRule: "evenodd",
    d: "M15.166 2.5h-.833V.833h-1.667V2.5H4.333V.833H2.666V2.5h-.833C.917 2.5.167 3.25.167 4.167V17.5c0 .917.75 1.667 1.666 1.667h13.334c.916 0 1.666-.75 1.666-1.667V4.167c0-.917-.75-1.667-1.666-1.667Zm0 15H1.833V8.334h13.333V17.5ZM1.833 6.667h13.333v-2.5H1.833v2.5Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCalendarreact);

/***/ }),

/***/ 46764:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckNewreact = function SvgCheckNewreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#017848",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m20.333 7-10 10-5-5"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCheckNewreact);

/***/ }),

/***/ 48636:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckCircleOutline24Pxreact = function SvgCheckCircleOutline24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Tick icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    fillRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm-2-5.83 6.59-6.59L18 9l-8 8-4-4 1.41-1.41L10 14.17Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCheckCircleOutline24Pxreact);

/***/ }),

/***/ 55065:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckmarkreact = function SvgCheckmarkreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Checkmark icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    fillRule: "evenodd",
    d: "M10 6a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4h-4Zm4.646 3.646L11 13.293l-1.646-1.646-.708.707L11 14.707l4.354-4.353-.707-.708Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCheckmarkreact);

/***/ }),

/***/ 42582:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronDownreact = function SvgChevronDownreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Chevron down icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#042759",
    fillRule: "evenodd",
    d: "M12 5c-.28 0-.53.11-.71.29L8 8.59l-3.29-3.3a1.003 1.003 0 0 0-1.42 1.42l4 4c.18.18.43.29.71.29.28 0 .53-.11.71-.29l4-4A1.003 1.003 0 0 0 12 5Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgChevronDownreact);

/***/ }),

/***/ 17838:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronLeftBlackreact = function SvgChevronLeftBlackreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none",
    "aria-label": "Left arrow",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "m6 0 1.4 1.4L2.8 6l4.6 4.6L6 12 0 6l6-6Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgChevronLeftBlackreact);

/***/ }),

/***/ 5074:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronLeftreact = function SvgChevronLeftreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.41 7 7.7 1.71c.19-.18.3-.43.3-.71A1.003 1.003 0 0 0 6.29.29l-6 6C.11 6.47 0 6.72 0 7c0 .28.11.53.29.71l6 6a1.003 1.003 0 0 0 1.42-1.42L2.41 7Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgChevronLeftreact);

/***/ }),

/***/ 51809:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronRightBlackreact = function SvgChevronRightBlackreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none",
    "aria-label": "Right arrow",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M1.4 12 0 10.6 4.6 6 0 1.4 1.4 0l6 6-6 6Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgChevronRightBlackreact);

/***/ }),

/***/ 14720:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronRightreact = function SvgChevronRightreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m7.71 6.29-6-6A1.003 1.003 0 0 0 .29 1.71L5.59 7 .3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71l6-6C7.89 7.53 8 7.28 8 7c0-.28-.11-.53-.29-.71Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgChevronRightreact);

/***/ }),

/***/ 34565:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronUpreact = function SvgChevronUpreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Chevron up icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#042759",
    fillRule: "evenodd",
    d: "M4.001 11c.28 0 .53-.11.71-.29l3.29-3.3 3.29 3.3a1.003 1.003 0 0 0 1.42-1.42l-4-4a.997.997 0 0 0-.71-.29c-.28 0-.53.11-.71.29l-4 4a1.003 1.003 0 0 0 .71 1.71Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgChevronUpreact);

/***/ }),

/***/ 47582:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronreact = function SvgChevronreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    fill: "none",
    "aria-label": "Chevron icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#042759",
    fillRule: "evenodd",
    d: "M13 0c-.28 0-.53.11-.71.29L7 5.59 1.71.29A1.003 1.003 0 0 0 .29 1.71l6 6c.18.18.43.29.71.29.28 0 .53-.11.71-.29l6-6A1.003 1.003 0 0 0 13 0Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgChevronreact);

/***/ }),

/***/ 67297:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCircleCrossreact = function SvgCircleCrossreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Circle cross icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#F33C31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Zm5-2.25 4.5 4.5m0-4.5-4.5 4.5"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCircleCrossreact);

/***/ }),

/***/ 9168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCircleExclamationreact = function SvgCircleExclamationreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Circle exclamation icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#292B29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 13v2"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#000",
    stroke: "#292B29",
    d: "M12.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#292B29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 19.25a7.25 7.25 0 1 0 0-14.5 7.25 7.25 0 0 0 0 14.5Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCircleExclamationreact);

/***/ }),

/***/ 57876:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCircleTickreact = function SvgCircleTickreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Circle tick icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#2ACE93",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2ACE93",
    d: "M15.129 9a.898.898 0 0 0-.615.24l-3.03 3.785-.996-.876a.899.899 0 0 0-.617-.24.9.9 0 0 0-.616.239.793.793 0 0 0-.255.579c0 .217.092.425.256.579l1.613 1.454c.163.154.384.24.616.24a.898.898 0 0 0 .615-.24l3.645-4.363a.782.782 0 0 0 .189-.892.873.873 0 0 0-.805-.505Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCircleTickreact);

/***/ }),

/***/ 27497:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgClockreact = function SvgClockreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    "aria-label": "clock icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    fillRule: "evenodd",
    d: "M12 2.006h8v2.667h-8V2.006Zm2.667 17.333v-8h2.666v8h-2.666Zm10.706-8.826 1.894-1.894c-.574-.68-1.2-1.32-1.88-1.88l-1.894 1.894A11.949 11.949 0 0 0 16 5.993c-6.627 0-12 5.373-12 12 0 6.626 5.36 12 12 12s12-5.374 12-12c0-2.814-.987-5.414-2.627-7.48ZM6.667 18.005A9.326 9.326 0 0 0 16 27.339a9.326 9.326 0 0 0 9.333-9.333A9.327 9.327 0 0 0 16 8.673a9.327 9.327 0 0 0-9.333 9.333Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgClockreact);

/***/ }),

/***/ 98502:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseCrossreact = function SvgCloseCrossreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    "aria-label": "Close cross icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#042759",
    fillRule: "evenodd",
    d: "M6.41 5 9.7 1.71c.19-.18.3-.43.3-.71A1.003 1.003 0 0 0 8.29.29L5 3.59 1.71.29A1.003 1.003 0 0 0 .29 1.71L3.59 5 .3 8.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L5 6.41 8.29 9.7c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L6.41 5Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseCrossreact);

/***/ }),

/***/ 77205:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseDarkSmallreact = function SvgCloseDarkSmallreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M6.173 4.992 10 8.782l-1.17 1.18L5.006 6.17 1.209 10 .04 8.83l3.788-3.827L0 1.209 1.17.04l3.824 3.785L8.782 0l1.18 1.17-3.789 3.822Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseDarkSmallreact);

/***/ }),

/***/ 13238:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseDarkreact = function SvgCloseDarkreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M8.643 6.988 14 12.294l-1.637 1.652-5.356-5.308L1.693 14l-1.64-1.64L5.36 7.005 0 1.692 1.64.053l5.352 5.3L12.294 0l1.652 1.637-5.303 5.351Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseDarkreact);

/***/ }),

/***/ 91948:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseNewreact = function SvgCloseNewreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#F96140",
    d: "M19.167 6.41 17.757 5l-5.59 5.59L6.577 5l-1.41 1.41 5.59 5.59-5.59 5.59L6.577 19l5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59 5.59-5.59Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseNewreact);

/***/ }),

/***/ 61148:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseSmallreact = function SvgCloseSmallreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#042759",
    d: "M6.173 4.992 10 8.782l-1.17 1.18L5.006 6.17 1.209 10 .04 8.83l3.788-3.827L0 1.209 1.17.04l3.824 3.785L8.782 0l1.18 1.17-3.789 3.822Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseSmallreact);

/***/ }),

/***/ 71302:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseV3Smallreact = function SvgCloseV3Smallreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M7.59 1 5 3.59 2.41 1 1 2.41 3.59 5 1 7.59 2.41 9 5 6.41 7.59 9 9 7.59 6.41 5 9 2.41 7.59 1Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseV3Smallreact);

/***/ }),

/***/ 79984:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCloseV3React = function SvgCloseV3React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M6.59 0 4 2.59 1.41 0 0 1.41 2.59 4 0 6.59 1.41 8 4 5.41 6.59 8 8 6.59 5.41 4 8 1.41 6.59 0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCloseV3React);

/***/ }),

/***/ 60251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgClosereact = function SvgClosereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    "aria-label": "Close icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m7.41 6 4.29-4.29c.19-.18.3-.43.3-.71a1.003 1.003 0 0 0-1.71-.71L6 4.59 1.71.29A1.003 1.003 0 0 0 .29 1.71L4.59 6 .3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L6 7.41l4.29 4.29c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L7.41 6Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgClosereact);

/***/ }),

/***/ 25014:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDeleteBucketreact = function SvgDeleteBucketreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Delete bucket icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    fillRule: "evenodd",
    d: "m14.5 3 1 1H19v2H5V4h3.5l1-1h5ZM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM8 9h8v10H8V9Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgDeleteBucketreact);

/***/ }),

/***/ 29303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDocumentreact = function SvgDocumentreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    "aria-label": "decorative document icon",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#clip0_893_8463)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M35.579 13.747 18.703.247a1.124 1.124 0 0 0-1.406 0L.42 13.747a1.125 1.125 0 0 0 .698 2.003h2.25v19.125A1.125 1.125 0 0 0 4.494 36h27.001a1.125 1.125 0 0 0 1.125-1.125V15.75h2.25a1.124 1.124 0 0 0 .709-2.003Zm-4.084-.248a1.125 1.125 0 0 0-1.125 1.125V33.75H5.619V14.624A1.125 1.125 0 0 0 4.494 13.5h-.169l13.67-10.935L31.662 13.5h-.168Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#017848",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14.5 21h7m-7 3h7m-7 3h7"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    fillRule: "evenodd",
    d: "M12 11h8l6 6v12c0 1.1-.9 2-2 2H11.99c-1.1 0-1.99-.9-1.99-2l.01-16c0-1.1.89-2 1.99-2Zm0 2v16h12V18h-5v-5h-7Z",
    clipRule: "evenodd"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgDocumentreact);

/***/ }),

/***/ 21352:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDonereact = function SvgDonereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    "aria-label": "Done icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "m8.8 16.342-4.2-4.317-1.4 1.439 5.6 5.755 12-12.333-1.4-1.439L8.8 16.342Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgDonereact);

/***/ }),

/***/ 9785:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDotreact = function SvgDotreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    fill: "none",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgDotreact);

/***/ }),

/***/ 47877:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDownReskinreact = function SvgDownReskinreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "m16 8-1.41-1.41L9 12.17V0H7v12.17L1.42 6.58 0 8l8 8 8-8Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgDownReskinreact);

/***/ }),

/***/ 31343:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDownloadreact = function SvgDownloadreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "m17.5 8.95-5 5-5-5"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M13.5 5h-2v5h2V5Zm3 11h-8v2h8v-2Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgDownloadreact);

/***/ }),

/***/ 47699:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFacebook2024React = function SvgFacebook2024React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    "aria-label": "facebook icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#B24A00",
    opacity: 0.05,
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    fillRule: "evenodd",
    d: "M27 19.324h-1.269c-.995 0-1.188.492-1.188 1.212v1.589h2.374l-.31 2.49h-2.064V31H22.07v-6.386H20v-2.49h2.07V20.29c0-2.13 1.252-3.29 3.08-3.29.877 0 1.63.067 1.85.098v2.226Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgFacebook2024React);

/***/ }),

/***/ 90260:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFacebookreact = function SvgFacebookreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 14,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    fillRule: "evenodd",
    d: "M7 2.324H5.731c-.995 0-1.188.492-1.188 1.212v1.589h2.374l-.31 2.49H4.543V14H2.07V7.614H0v-2.49h2.07V3.29C2.07 1.16 3.321 0 5.15 0 6.028 0 6.78.067 7 .098v2.226Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgFacebookreact);

/***/ }),

/***/ 9526:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFilterListreact = function SvgFilterListreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "filtering icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    fillRule: "evenodd",
    d: "M3 6v2h18V6H3Zm7 12h4v-2h-4v2Zm8-5H6v-2h12v2Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgFilterListreact);

/***/ }),

/***/ 59189:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgHomereact = function SvgHomereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    "aria-label": "decorative home icon",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#clip0_893_8471)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M35.103 13.376 18.683.24a1.093 1.093 0 0 0-1.367 0L.895 13.376a1.095 1.095 0 0 0 .679 1.948h2.189v18.608a1.095 1.095 0 0 0 1.095 1.095H31.13a1.094 1.094 0 0 0 1.095-1.095V15.324h2.189a1.094 1.094 0 0 0 .69-1.948Zm-3.973-.241a1.095 1.095 0 0 0-1.095 1.094v18.609H5.953V14.229a1.095 1.095 0 0 0-1.094-1.094h-.164l13.3-10.64 13.299 10.64h-.164Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFDFA",
    d: "M28.114 31.134H8.654v3.892h19.46v-3.892Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    stroke: "#017848",
    strokeWidth: 0.973,
    d: "M19.193 15.57a.443.443 0 0 0-.043.011l-7.265 1.888c-.19.052-.315.201-.312.366v15.108c0 .172.14.323.34.366l7.266 1.51a.52.52 0 0 0 .392-.068.36.36 0 0 0 .175-.298V15.947a.35.35 0 0 0-.152-.285.52.52 0 0 0-.359-.093h-.042Zm-.355.896V33.97l-6.357-1.322V18.12l6.357-1.653Zm1.816.614v.755h3.633v14.73h-3.633v.755h4.087c.25 0 .454-.17.454-.377V17.458c0-.208-.204-.378-.454-.378h-4.087Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#017848",
    strokeLinecap: "round",
    strokeWidth: 1.946,
    d: "M16.34 25.2v1.605"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgHomereact);

/***/ }),

/***/ 46472:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconAnalysisreact = function SvgIconAnalysisreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    "aria-label": "analysis icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    stroke: "#017848",
    strokeWidth: 0.3,
    d: "M49.775 41.695H42.41l-4.958-7.526a13.981 13.981 0 0 0 5.428-10.45h5.017l-1.031.77a.622.622 0 1 0 .744.997l2.535-1.89a.624.624 0 0 0 0-.999l-2.535-1.89a.622.622 0 1 0-.744.998l1.031.769H42.88C42.554 15.044 36.408 9.1 28.899 9.1c-7.51 0-13.656 5.944-13.982 13.374h-3.922a2.084 2.084 0 0 0-4.072.623 2.085 2.085 0 0 0 4.072.623h3.922a13.982 13.982 0 0 0 1.944 6.523 1.647 1.647 0 0 1-.243 2.021 2.009 2.009 0 0 0-2.243.41l-7.752 7.753a3.504 3.504 0 0 0 0 4.948 3.487 3.487 0 0 0 2.473 1.024 3.48 3.48 0 0 0 2.473-1.024l7.752-7.752c.606-.606.74-1.505.41-2.244a1.647 1.647 0 0 1 2.022-.242 13.983 13.983 0 0 0 7.146 1.958 13.9 13.9 0 0 0 7.536-2.206l5.118 7.772a.62.62 0 0 0 .52.28h7.7a.623.623 0 1 0 0-1.246h.002ZM36.769 33.13l-1.082-1.642a10.782 10.782 0 0 0 3.99-7.765h1.962a12.738 12.738 0 0 1-4.87 9.407Zm-4.94-5.238 2.162 3.285a9.493 9.493 0 0 1-5.09 1.473c-5.057 0-9.207-3.95-9.528-8.927h1.763a2.087 2.087 0 0 0 2.783 1.304l2.09 2.507a2.07 2.07 0 0 0-.335 1.128c0 1.15.935 2.084 2.084 2.084a2.086 2.086 0 0 0 2.083-2.084c0-.8-.453-1.495-1.115-1.844l1.375-7.568c.17-.02.332-.061.484-.121l2.203 2.796a2.086 2.086 0 0 0 1.72 3.259c.933 0 1.724-.616 1.988-1.461h1.935a9.536 9.536 0 0 1-3.43 6.72l-2.133-3.236a.622.622 0 0 0-1.039.685Zm4.667-5.413a2.087 2.087 0 0 0-2.73-1.324l-2.203-2.796a2.086 2.086 0 0 0-1.72-3.259 2.086 2.086 0 0 0-2.084 2.084c0 .8.454 1.495 1.116 1.844L27.5 26.595c-.188.024-.37.07-.537.141l-2.09-2.506c.212-.327.335-.713.335-1.129a2.086 2.086 0 0 0-2.084-2.083c-.932 0-1.723.615-1.988 1.46h-1.763c.323-4.976 4.471-8.927 9.528-8.927s9.207 3.95 9.527 8.927h-1.934.002Zm-1.988-.216a.84.84 0 0 1 0 1.678.84.84 0 0 1 0-1.678Zm-4.665-4.24a.84.84 0 0 1-.84-.84.84.84 0 0 1 .84-.839.84.84 0 0 1 .84.84.84.84 0 0 1-.84.839Zm-2.085 9.8a.84.84 0 1 1-.84.84.84.84 0 0 1 .84-.84Zm-4.634-3.884a.84.84 0 0 1-.84-.84.84.84 0 1 1 .84.84Zm5.777-13.59c6.823 0 12.411 5.387 12.736 12.13h-1.962c-.323-5.663-5.033-10.172-10.775-10.172-5.743 0-10.452 4.509-10.776 10.171h-1.962c.326-6.742 5.913-12.129 12.736-12.129h.003Zm-19.89 13.59a.84.84 0 0 1-.84-.84.84.84 0 0 1 .84-.838.84.84 0 0 1 .839.839.84.84 0 0 1-.84.84Zm9.436 12.805-7.752 7.752a2.257 2.257 0 0 1-3.188 0 2.257 2.257 0 0 1 0-3.188l7.752-7.752a.768.768 0 0 1 1.084 0l2.105 2.106a.768.768 0 0 1 0 1.084l-.001-.002Zm10.456-.894c-2.296 0-4.547-.617-6.51-1.783a2.871 2.871 0 0 0-3.441.342l-1.358-1.358a2.874 2.874 0 0 0 .341-3.442 12.726 12.726 0 0 1-1.766-5.886h1.96c.323 5.662 5.033 10.17 10.776 10.17 2.122 0 4.103-.615 5.774-1.678l1.079 1.636a12.679 12.679 0 0 1-6.854 2.002l-.001-.003ZM50.4 38.04a.623.623 0 0 1-.623.623h-6.385a.623.623 0 1 1 0-1.246h6.385c.343 0 .623.278.623.623Zm0 2.14a.623.623 0 0 1-.623.623h-6.385a.623.623 0 1 1 0-1.246h6.385c.343 0 .623.278.623.623Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgIconAnalysisreact);

/***/ }),

/***/ 61527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconContactreact = function SvgIconContactreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    "aria-label": "contact icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    fillRule: "evenodd",
    stroke: "#017848",
    strokeWidth: 0.7,
    d: "M34.774 42.119c.38.656.454 1.4.272 2.08a2.73 2.73 0 0 1-1.274 1.662l-.028.014-3.869 2.234c-4.22 2.435-9.422-.38-13.796-5.302-1.663-1.868-3.213-4.05-4.548-6.36-1.334-2.308-2.444-4.743-3.23-7.118-2.076-6.247-1.916-12.157 2.308-14.592l3.892-2.248.028-.014a2.73 2.73 0 0 1 2.051-.258 2.73 2.73 0 0 1 1.663 1.274c.004.01.014.023.018.033.197.416.478.899.782 1.428 1.35 2.337 3.19 5.53 1.129 7.203l-2.45 1.985c-.425.342-.735.782-.861 1.246-.108.393-.07.81.15 1.199l5.802 10.045c0 .01.01.014.014.024.225.374.562.604.946.707.464.122.998.075 1.508-.122l2.946-1.128c2.477-.951 4.323 2.243 5.676 4.58.314.543.6 1.04.843 1.395.01.01.014.024.019.033h.009Zm6.566-30.417a1.586 1.586 0 0 1 1.587 1.588 1.585 1.585 0 0 1-1.587 1.587 1.585 1.585 0 0 1-1.588-1.588 1.585 1.585 0 0 1 1.588-1.587Zm.426 1.166a.602.602 0 0 0-1.03.426c0 .169.065.319.178.426a.6.6 0 0 0 1.03-.426.583.583 0 0 0-.178-.426Zm-4.543-1.166a1.586 1.586 0 0 1 1.588 1.588 1.585 1.585 0 0 1-1.588 1.587 1.585 1.585 0 0 1-1.587-1.588 1.586 1.586 0 0 1 1.587-1.587Zm.427 1.166a.602.602 0 0 0-1.03.426.61.61 0 0 0 .604.604.61.61 0 0 0 .604-.604.583.583 0 0 0-.178-.426Zm-4.543-1.166a1.586 1.586 0 0 0-1.588 1.588 1.585 1.585 0 0 0 1.588 1.587 1.585 1.585 0 0 0 1.587-1.588 1.585 1.585 0 0 0-1.587-1.587Zm.426 1.166a.602.602 0 0 0-1.03.426c0 .169.065.319.178.426a.6.6 0 0 0 1.03-.426.583.583 0 0 0-.178-.426Zm1.414 5.948c-.112.815-.374 1.381-.698 1.807.38-.112.769-.248 1.143-.407.89-.38 1.719-.89 2.323-1.503a.49.49 0 0 1 .314-.146c1.84-.15 3.465-.81 4.627-1.784 1.114-.932 1.789-2.159 1.789-3.494 0-1.437-.787-2.753-2.06-3.709-1.317-.988-3.139-1.597-5.162-1.597s-3.85.614-5.16 1.597c-1.274.956-2.061 2.272-2.061 3.71 0 1.09.45 2.107 1.222 2.95.82.894 1.99 1.597 3.377 1.995a.49.49 0 0 1 .346.58Zm-2.468 2.046c.52-.342 1.166-.773 1.42-1.807-1.185-.403-2.225-1.012-3.04-1.776h-5.264l10.926 10.926L47.447 17.28h-3.873a5.36 5.36 0 0 1-.295.262c-1.274 1.068-3.03 1.798-5.002 1.995-.684.65-1.574 1.19-2.505 1.587-1.082.464-2.244.745-3.232.806a.5.5 0 0 1-.45-.206.496.496 0 0 1 .122-.689 7.44 7.44 0 0 1 .263-.177l.004.004Zm-7.39-4.57c-.323 0-.618.13-.829.346-.21.21-.346.506-.346.829v15.089c0 .323.13.618.346.829.211.21.506.346.83.346h22.877a1.184 1.184 0 0 0 1.175-1.175v-15.09a1.184 1.184 0 0 0-1.175-1.175H44.45c.627-.89.983-1.91.983-2.997 0-1.765-.941-3.353-2.459-4.496C41.494 7.688 39.462 7 37.224 7c-2.24 0-4.272.688-5.752 1.798-1.517 1.143-2.458 2.73-2.458 4.496 0 1.087.356 2.108.988 2.997h-4.913Zm22.367 16.451-7.034-7.034-3.545 3.545a.495.495 0 0 1-.698 0l-3.545-3.545-7.034 7.034h21.856Zm-6.336-7.732 7.034-7.034v14.064l-7.034-7.034v.004Zm-16.218 7.035 7.034-7.035-7.034-7.034v14.069Zm9.188 11.9a1.73 1.73 0 0 0-.168-1.321 23.47 23.47 0 0 1-.871-1.438c-1.176-2.028-2.778-4.8-4.473-4.15l-2.945 1.13c-.698.266-1.448.332-2.117.154a2.497 2.497 0 0 1-1.541-1.161c-.005-.01-.014-.02-.019-.028l-5.802-10.046a2.514 2.514 0 0 1-.253-1.943c.178-.665.609-1.284 1.19-1.757l2.449-1.985c1.41-1.143-.188-3.92-1.358-5.948-.328-.567-.623-1.082-.815-1.484a1.757 1.757 0 0 0-1.054-.792 1.757 1.757 0 0 0-1.307.16c-.009 0-.014.009-.023.013l-3.892 2.248C7.36 17.753 7.298 23.213 9.227 29.04c.768 2.323 1.855 4.692 3.147 6.936 1.298 2.243 2.806 4.364 4.43 6.196 4.08 4.584 8.838 7.258 12.57 5.104l3.869-2.234s.018-.009.023-.014a1.76 1.76 0 0 0 .815-1.068l.01-.014Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgIconContactreact);

/***/ }),

/***/ 30214:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconKeyboardTapreact = function SvgIconKeyboardTapreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    "aria-label": "keyboard tapping icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M22.299 32.53a.927.927 0 0 0 .356.101.84.84 0 0 0 .763-.457.813.813 0 0 0-.407-1.12 1.438 1.438 0 0 1-.764-1.272v-8.554c0-.815.662-1.475 1.426-1.475h8.553c.815 0 1.476.662 1.476 1.475v8.554c0 .254-.052.457-.203.662-.255.408-.102.917.254 1.12.408.254.917.1 1.12-.255.255-.457.408-.967.408-1.527v-8.554a3.086 3.086 0 0 0-3.107-3.106l-8.45.002a3.086 3.086 0 0 0-3.106 3.106v8.554c0 1.169.663 2.237 1.68 2.746Zm26.776-14.405h-8.55a3.086 3.086 0 0 0-3.107 3.106v8.553a3.086 3.086 0 0 0 3.106 3.106h8.553a3.086 3.086 0 0 0 3.107-3.106l-.002-8.555a3.085 3.085 0 0 0-3.107-3.104Zm1.426 11.657c0 .815-.662 1.426-1.426 1.426h-8.55a1.423 1.423 0 0 1-1.427-1.426v-8.553c0-.816.663-1.426 1.426-1.426h8.553c.816 0 1.426.662 1.426 1.425l-.002 8.554ZM15.475 18.125h-8.55a3.087 3.087 0 0 0-3.107 3.106v8.553a3.086 3.086 0 0 0 3.106 3.106h8.553a3.086 3.086 0 0 0 3.107-3.106l-.002-8.555a3.085 3.085 0 0 0-3.107-3.104Zm1.478 11.657c0 .815-.662 1.426-1.426 1.426H6.924A1.423 1.423 0 0 1 5.5 29.782v-8.553c0-.816.662-1.426 1.425-1.426h8.554c.815 0 1.426.662 1.426 1.425l-.003 8.554h.052Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M39.047 35.075c-.458 0-.865.153-1.273.356a2.656 2.656 0 0 0-2.444-1.579 2.7 2.7 0 0 0-1.324.356c-.458-.815-1.325-1.426-2.343-1.426-.356 0-.712.052-1.018.203v-5.09a2.716 2.716 0 0 0-2.699-2.7 2.717 2.717 0 0 0-2.698 2.7V40.01l-1.528-1.426c-.509-.509-1.22-.712-1.935-.712-.712.052-1.374.356-1.833.917a2.544 2.544 0 0 0 0 3.31l5.345 6.516c1.482 1.836 3.568 2.802 5.758 2.802h4.174a6.496 6.496 0 0 0 6.517-6.517v-7.127a2.717 2.717 0 0 0-2.7-2.699Zm1.018 9.826c0 2.647-2.19 4.836-4.836 4.836h-4.174c-1.73 0-3.361-.763-4.43-2.088l-5.345-6.514a.926.926 0 0 1 0-1.221c.153-.203.408-.307.663-.356.254 0 .509.051.711.254l2.954 2.748c.254.203.61.307.916.154.307-.154.51-.408.51-.764V27.948a1.02 1.02 0 0 1 1.018-1.018c.56 0 1.018.457 1.018 1.018v9.215c0 .458.356.816.815.816a.805.805 0 0 0 .816-.816v-1.68c0-.56.457-1.018 1.018-1.018.56 0 1.018.457 1.018 1.018v2.392c0 .458.356.816.815.816a.805.805 0 0 0 .816-.816v-1.374c0-.56.457-1.018 1.018-1.018.56 0 1.018.457 1.018 1.018v2.088c0 .458.356.816.815.816a.805.805 0 0 0 .816-.816v-.865c0-.56.457-1.018 1.018-1.018.56 0 1.018.457 1.018 1.018l-.006 7.177ZM28 14.509a.805.805 0 0 0 .815-.815v-3.156c0-.51-.358-.865-.815-.865a.805.805 0 0 0-.815.815v3.156c0 .509.358.865.815.865Zm-4.582.711a.743.743 0 0 0 .662.357.817.817 0 0 0 .458-.154c.355-.254.457-.763.202-1.17l-1.781-2.598c-.255-.356-.764-.457-1.172-.203-.356.255-.457.764-.203 1.171l1.834 2.598Zm8.502.359a.743.743 0 0 0 .662-.356l1.781-2.597c.255-.356.154-.917-.202-1.171-.408-.255-.917-.154-1.172.202l-1.781 2.598c-.255.355-.154.916.202 1.17a.987.987 0 0 0 .51.154Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgIconKeyboardTapreact);

/***/ }),

/***/ 8855:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconPercentagereact = function SvgIconPercentagereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    "aria-label": "percentage symbol icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M28.51 19.855a8.654 8.654 0 1 0-8.655 8.654 8.664 8.664 0 0 0 8.654-8.654Zm-15.273 0a6.618 6.618 0 1 1 6.618 6.618 6.626 6.626 0 0 1-6.618-6.618Zm22.909 7.635a8.654 8.654 0 1 0 8.654 8.655 8.664 8.664 0 0 0-8.654-8.654Zm0 15.273a6.618 6.618 0 1 1 6.618-6.618 6.625 6.625 0 0 1-6.618 6.618Zm2.084-30.378a1.02 1.02 0 0 0-1.409.293L17.475 42.206a1.018 1.018 0 1 0 1.703 1.115l19.347-29.527a1.018 1.018 0 0 0-.294-1.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M39.92 32.37a1.018 1.018 0 0 0-1.44 0l-2.335 2.336-2.334-2.335a1.018 1.018 0 0 0-1.44 1.44l2.335 2.334-2.335 2.335a1.019 1.019 0 1 0 1.44 1.44l2.334-2.335 2.335 2.335a1.018 1.018 0 0 0 1.44-1.44l-2.335-2.335 2.335-2.334a1.018 1.018 0 0 0 0-1.44Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgIconPercentagereact);

/***/ }),

/***/ 80904:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoDarkSmallreact = function SvgInfoDarkSmallreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M4 12c.79 0 1.43-.55 1.43-1.23 0-.678-.64-1.228-1.43-1.228-.788 0-1.43.55-1.43 1.229C2.57 11.449 3.213 12 4 12Zm.106-12C5.29 0 6.328.333 7.023.94c.652.568.99 1.35.977 2.258-.02 1.36-.983 2.254-1.757 2.972-1.035.958-1.084 1.488-1.07 2.141H2.882c-.007-1.45.023-2.09 1.637-3.41.655-.535 1.172-.958 1.1-1.79-.065-.792-.834-1.206-1.56-1.206-.81 0-1.758.518-1.758 1.98H0C0 1.524 1.613 0 4.106 0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoDarkSmallreact);

/***/ }),

/***/ 57791:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoDarkreact = function SvgInfoDarkreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M6 16c1.186 0 2.145-.734 2.145-1.639S7.186 12.722 6 12.722c-1.182 0-2.145.734-2.145 1.64C3.855 15.266 4.818 16 6 16Zm.158-16c1.778 0 3.334.444 4.376 1.252.978.758 1.484 1.8 1.465 3.012-.029 1.814-1.473 3.005-2.634 3.962-1.553 1.279-1.627 1.985-1.604 2.856H4.32c-.01-1.934.035-2.786 2.457-4.547.98-.713 1.756-1.277 1.65-2.388C8.33 3.092 7.176 2.54 6.088 2.54c-1.216 0-2.638.69-2.638 2.639H0C0 2.032 2.419 0 6.158 0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoDarkreact);

/***/ }),

/***/ 89732:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoExclusivereact = function SvgInfoExclusivereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Info exclusive icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFDFA",
    fillRule: "evenodd",
    d: "M6 2a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6Zm2.8 4.3H7.3V5h1.5v1.3Zm0 4.997H7.3V7.6h1.5v3.697Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoExclusivereact);

/***/ }),

/***/ 94130:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoFilledreact = function SvgInfoFilledreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    fillRule: "evenodd",
    d: "M1.333 8A6.67 6.67 0 0 1 8 1.333 6.669 6.669 0 0 1 14.667 8 6.67 6.67 0 0 1 8 14.667 6.67 6.67 0 0 1 1.333 8Zm6-3.333h1.334V6H7.333V4.667Zm0 2.666h1.334v4H7.333v-4Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoFilledreact);

/***/ }),

/***/ 39060:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoGreyreact = function SvgInfoGreyreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    fillRule: "evenodd",
    d: "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.669 6.669 0 0 0 8 1.333Zm-.667 3.334V6h1.334V4.667H7.333Zm0 2.666v4h1.334v-4H7.333ZM2.667 8A5.34 5.34 0 0 0 8 13.333 5.34 5.34 0 0 0 13.333 8 5.34 5.34 0 0 0 8 2.667 5.34 5.34 0 0 0 2.667 8Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoGreyreact);

/***/ }),

/***/ 74053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoSmallreact = function SvgInfoSmallreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#042759",
    d: "M4 12c.79 0 1.43-.55 1.43-1.23 0-.678-.64-1.228-1.43-1.228-.788 0-1.43.55-1.43 1.229C2.57 11.449 3.213 12 4 12Zm.106-12C5.29 0 6.328.333 7.023.94c.652.568.99 1.35.977 2.258-.02 1.36-.983 2.254-1.757 2.972-1.035.958-1.084 1.488-1.07 2.141H2.882c-.007-1.45.023-2.09 1.637-3.41.655-.535 1.172-.958 1.1-1.79-.065-.792-.834-1.206-1.56-1.206-.81 0-1.758.518-1.758 1.98H0C0 1.524 1.613 0 4.106 0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoSmallreact);

/***/ }),

/***/ 76904:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoV3Smallreact = function SvgInfoV3Smallreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M4 4h2v6H4zm0-4h2v2H4z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoV3Smallreact);

/***/ }),

/***/ 74953:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoV3React = function SvgInfoV3React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 10,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M0 4h2v6H0zm0-4h2v2H0z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoV3React);

/***/ }),

/***/ 40935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInforeact = function SvgInforeact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 15,
    fill: "none",
    "aria-label": "Info icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.62 10.02v-.66c0-.693.127-1.273.38-1.74.267-.467.733-.96 1.4-1.48.667-.507 1.133-.927 1.4-1.26.28-.333.42-.747.42-1.24 0-.507-.18-.893-.54-1.16-.347-.267-.847-.4-1.5-.4-.587 0-1.147.087-1.68.26-.533.173-1.067.393-1.6.66L0 1.12c.613-.333 1.28-.6 2-.8A8.355 8.355 0 0 1 4.38 0C5.727 0 6.767.327 7.5.98c.733.64 1.1 1.487 1.1 2.54 0 .573-.093 1.067-.28 1.48-.173.4-.44.773-.8 1.12a14.02 14.02 0 0 1-1.26 1.1c-.413.32-.727.593-.94.82a1.97 1.97 0 0 0-.44.68c-.08.213-.12.48-.12.8v.5H2.62Zm-.38 3.18c0-.56.147-.953.44-1.18.307-.24.673-.36 1.1-.36.413 0 .767.12 1.06.36.307.227.46.62.46 1.18 0 .547-.153.94-.46 1.18a1.62 1.62 0 0 1-1.06.36c-.427 0-.793-.12-1.1-.36-.293-.24-.44-.633-.44-1.18Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInforeact);

/***/ }),

/***/ 1247:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInstagram2024React = function SvgInstagram2024React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    "aria-label": "instagram icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#B24A00",
    opacity: 0.05,
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    d: "M24 15.802c2.67 0 2.986.01 4.04.058.976.045 1.505.207 1.858.344.466.182.8.399 1.15.748.35.35.566.684.748 1.15.137.353.3.882.344 1.857.048 1.055.058 1.37.058 4.041 0 2.67-.01 2.986-.058 4.04-.045.976-.207 1.505-.345 1.858-.18.466-.398.8-.748 1.15-.35.35-.683.566-1.15.748-.352.137-.881.3-1.856.344-1.055.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-.976-.045-1.505-.207-1.858-.344a3.1 3.1 0 0 1-1.15-.748 3.1 3.1 0 0 1-.748-1.15c-.137-.353-.3-.882-.344-1.857-.048-1.055-.058-1.37-.058-4.041 0-2.67.01-2.986.058-4.04.045-.976.207-1.505.344-1.858.182-.466.398-.8.748-1.15a3.1 3.1 0 0 1 1.15-.748c.353-.137.882-.3 1.857-.344 1.055-.048 1.37-.058 4.041-.058ZM24 14c-2.716 0-3.056.011-4.123.06-1.064.049-1.791.218-2.427.465a4.902 4.902 0 0 0-1.772 1.153 4.902 4.902 0 0 0-1.153 1.772c-.247.636-.416 1.363-.465 2.427C14.011 20.944 14 21.284 14 24s.011 3.056.06 4.123c.049 1.064.218 1.791.465 2.427a4.901 4.901 0 0 0 1.153 1.772 4.901 4.901 0 0 0 1.772 1.153c.636.247 1.363.416 2.427.465 1.067.049 1.407.06 4.123.06s3.056-.011 4.123-.06c1.064-.049 1.791-.218 2.427-.465a4.902 4.902 0 0 0 1.772-1.153 4.902 4.902 0 0 0 1.153-1.772c.247-.636.416-1.363.465-2.427.049-1.067.06-1.407.06-4.123s-.011-3.056-.06-4.123c-.049-1.064-.218-1.791-.465-2.427a4.903 4.903 0 0 0-1.153-1.772 4.903 4.903 0 0 0-1.772-1.153c-.636-.247-1.363-.416-2.427-.465C27.056 14.011 26.716 14 24 14Zm0 4.865a5.135 5.135 0 1 0 0 10.27 5.135 5.135 0 0 0 0-10.27Zm0 8.468a3.333 3.333 0 1 1 0-6.666 3.333 3.333 0 0 1 0 6.666Zm6.538-8.671a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInstagram2024React);

/***/ }),

/***/ 83580:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInstagramreact = function SvgInstagramreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M10 1.802c2.67 0 2.986.01 4.04.058.976.045 1.505.208 1.858.344.466.182.8.399 1.15.748.35.35.566.684.748 1.15.137.353.3.882.344 1.857.048 1.055.058 1.37.058 4.041 0 2.67-.01 2.986-.058 4.04-.045.976-.207 1.505-.345 1.858-.18.466-.398.8-.748 1.15-.35.35-.683.566-1.15.748-.352.137-.881.3-1.856.344-1.055.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-.976-.045-1.505-.207-1.858-.344a3.098 3.098 0 0 1-1.15-.748 3.099 3.099 0 0 1-.748-1.15c-.137-.353-.3-.882-.344-1.857-.048-1.055-.058-1.37-.058-4.041 0-2.67.01-2.986.058-4.04.045-.976.207-1.505.344-1.858.182-.466.399-.8.748-1.15.35-.35.684-.566 1.15-.748.353-.136.882-.3 1.857-.344 1.055-.048 1.37-.058 4.041-.058ZM10 0C7.284 0 6.944.012 5.877.06 4.813.11 4.086.278 3.45.525a4.902 4.902 0 0 0-1.772 1.153A4.902 4.902 0 0 0 .525 3.45C.278 4.086.109 4.813.06 5.877.011 6.944 0 7.284 0 10s.011 3.056.06 4.123c.049 1.064.218 1.791.465 2.427a4.901 4.901 0 0 0 1.153 1.772 4.901 4.901 0 0 0 1.772 1.153c.636.247 1.363.416 2.427.465 1.067.048 1.407.06 4.123.06s3.056-.012 4.123-.06c1.064-.049 1.791-.218 2.427-.465a4.902 4.902 0 0 0 1.772-1.153 4.902 4.902 0 0 0 1.153-1.772c.247-.636.416-1.363.465-2.427.048-1.067.06-1.407.06-4.123s-.012-3.056-.06-4.123c-.049-1.064-.218-1.791-.465-2.427a4.903 4.903 0 0 0-1.153-1.772A4.902 4.902 0 0 0 16.55.525C15.914.278 15.187.109 14.123.06 13.056.012 12.716 0 10 0Zm0 4.865a5.135 5.135 0 1 0 0 10.27 5.135 5.135 0 0 0 0-10.27Zm0 8.468a3.333 3.333 0 1 1 0-6.666 3.333 3.333 0 0 1 0 6.666Zm6.538-8.671a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInstagramreact);

/***/ }),

/***/ 55433:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInvalidreact = function SvgInvalidreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    "aria-label": "Invalid icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#F33C31",
    fillRule: "evenodd",
    d: "m7.41 6 4.29-4.29c.19-.18.3-.43.3-.71a1.003 1.003 0 0 0-1.71-.71L6 4.59 1.71.29A1.003 1.003 0 0 0 .29 1.71L4.59 6 .3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L6 7.41l4.29 4.29c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L7.41 6Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInvalidreact);

/***/ }),

/***/ 23081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgItemCompletereact = function SvgItemCompletereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Item complete icon",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "#DEFFE4",
    stroke: "#2ACE93"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2ACE93",
    fillRule: "evenodd",
    d: "M10.909 5.818a.725.725 0 0 0-.516.211l-3.12 3.127-1.666-1.672a.73.73 0 0 0-1.033 1.033l2.182 2.181a.726.726 0 0 0 .517.211c.203 0 .385-.08.516-.21l3.636-3.637a.73.73 0 0 0-.516-1.244Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgItemCompletereact);

/***/ }),

/***/ 98164:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgItemDisabledreact = function SvgItemDisabledreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Item disabled icon",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "#F1F2F8",
    stroke: "#D8DFE9"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgItemDisabledreact);

/***/ }),

/***/ 30692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgKeyboardArrowDown24Pxreact = function SvgKeyboardArrowDown24Pxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "m7.41 8.295 4.59 4.58 4.59-4.58L18 9.705l-6 6-6-6 1.41-1.41Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgKeyboardArrowDown24Pxreact);

/***/ }),

/***/ 51244:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLeftreact = function SvgLeftreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    fill: "none",
    "aria-label": "Left icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.99 5.99H4.41L7.7 2.7a1.003 1.003 0 0 0-1.42-1.42l-5 5a1.014 1.014 0 0 0 0 1.42l5 5a1.003 1.003 0 0 0 1.42-1.42L4.41 7.99H14c.55 0 1-.45 1-1s-.46-1-1.01-1Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgLeftreact);

/***/ }),

/***/ 61478:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAccordMortgagesreact = function SvgAccordMortgagesreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 20,
    "aria-label": "Accord mortgages icon",
    className: "logo-svg",
    viewBox: "0 0 689.8 141.7",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    className: "accord-logo-text"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M233.3 60c-1 .2-2.1.4-3.3.5-1.2.1-2.5.2-3.9.2-2.7 0-5.1-.2-7.2-.6v-14H200V60c-1 .2-2.1.4-3.3.5-1.2.1-2.5.2-3.9.2-2.7 0-5.1-.2-7.2-.6V27c0-8.1 2.4-14.2 7.1-18.3 4.7-4.1 11.6-6.1 20.5-6.1 3.3 0 6.7.3 10.4 1s6.9 1.5 9.6 2.5V60zM219 34.6v-19c-2.3-.6-4.8-.9-7.6-.9-7.7 0-11.5 4.4-11.5 13.2v6.6H219zm65 11.9c.7 1.3 1.3 3.1 1.9 5.3.6 2.2 1.1 4.4 1.4 6.6-2 .8-4.3 1.5-6.8 2.1-2.5.6-5.6.9-9.3.9-4.7 0-8.8-.7-12.4-2.2-3.5-1.4-6.5-3.5-8.9-6.1s-4.2-5.7-5.4-9.3c-1.2-3.6-1.8-7.5-1.8-11.8 0-4.3.6-8.3 1.8-11.9 1.2-3.6 3-6.7 5.4-9.3 2.4-2.6 5.3-4.6 8.9-6.1 3.5-1.4 7.7-2.2 12.4-2.2 3.7 0 6.8.3 9.3.9 2.5.6 4.7 1.3 6.8 2.1-.3 2.2-.7 4.4-1.4 6.6-.6 2.2-1.2 4-1.9 5.3-1.7-.6-3.4-1.1-5.2-1.5-1.8-.4-4-.6-6.5-.6-2 0-3.9.3-5.7.9-1.8.6-3.3 1.5-4.6 2.9-1.3 1.3-2.3 3.1-3.1 5.2-.8 2.1-1.1 4.8-1.1 7.9 0 3.1.4 5.7 1.1 7.9.8 2.1 1.8 3.8 3.1 5.1 1.3 1.3 2.8 2.2 4.6 2.8 1.8.6 3.7.9 5.7.9 2.5 0 4.7-.2 6.5-.7 1.8-.6 3.5-1.1 5.2-1.7zm48.9 0c.7 1.3 1.3 3.1 1.9 5.3.6 2.2 1.1 4.4 1.4 6.6-2 .8-4.3 1.5-6.8 2.1-2.5.6-5.6.9-9.3.9-4.7 0-8.8-.7-12.4-2.2-3.5-1.4-6.5-3.5-8.9-6.1s-4.2-5.7-5.4-9.3c-1.2-3.6-1.8-7.5-1.8-11.8 0-4.3.6-8.3 1.8-11.9 1.2-3.6 3-6.7 5.4-9.3 2.4-2.6 5.3-4.6 8.9-6.1 3.5-1.4 7.7-2.2 12.4-2.2 3.7 0 6.8.3 9.3.9 2.5.6 4.7 1.3 6.8 2.1-.3 2.2-.7 4.4-1.4 6.6-.6 2.2-1.2 4-1.9 5.3-1.7-.6-3.4-1.1-5.2-1.5-1.8-.4-4-.6-6.5-.6-2 0-3.9.3-5.7.9-1.8.6-3.3 1.5-4.6 2.9-1.3 1.3-2.3 3.1-3.1 5.2-.8 2.1-1.1 4.8-1.1 7.9 0 3.1.4 5.7 1.1 7.9.8 2.1 1.8 3.8 3.1 5.1 1.3 1.3 2.8 2.2 4.6 2.8 1.8.6 3.7.9 5.7.9 2.5 0 4.7-.2 6.5-.7 1.8-.6 3.5-1.1 5.2-1.7zm35 14.8c-4.6 0-8.5-.7-11.9-2.2-3.4-1.4-6.2-3.5-8.5-6.1s-4-5.7-5.1-9.3c-1.2-3.6-1.7-7.5-1.7-11.8 0-4.3.6-8.3 1.7-11.9 1.2-3.6 2.9-6.7 5.1-9.3 2.3-2.6 5.1-4.6 8.5-6.1 3.4-1.4 7.4-2.2 11.9-2.2s8.5.7 11.9 2.2c3.4 1.4 6.2 3.5 8.5 6.1 2.3 2.6 4 5.7 5.1 9.3 1.2 3.6 1.7 7.5 1.7 11.9 0 4.3-.6 8.2-1.7 11.8-1.2 3.6-2.9 6.7-5.1 9.3-2.3 2.6-5.1 4.6-8.5 6.1-3.4 1.5-7.4 2.2-11.9 2.2zm-12.4-29.4c0 5.6 1 10 3.1 13.1 2.1 3.1 5.1 4.6 9.3 4.6 4.1 0 7.2-1.5 9.3-4.6 2.1-3.1 3.1-7.4 3.1-13.1 0-5.6-1-10-3.1-13s-5.1-4.6-9.3-4.6c-4.1 0-7.2 1.5-9.3 4.6-2.1 3-3.1 7.4-3.1 13zM455.7 60c-1.3.2-2.7.4-4.3.5-1.6.1-3 .2-4.3.2-1.3 0-2.7-.1-4.3-.2-1.6-.1-3-.3-4.3-.5l-14.7-24.8c4.1-1.4 7.3-3.2 9.4-5.4 2.2-2.1 3.3-4.7 3.3-7.9 0-5.8-4-8.7-11.9-8.7-.8 0-1.6 0-2.5.1-.9.1-1.8.2-2.9.3V60c-1.1.2-2.2.4-3.3.5-1.1.1-2.4.2-3.8.2-2.7 0-5.1-.2-7.3-.6V4c3.5-.4 7-.7 10.7-.9 3.7-.3 6.8-.4 9.3-.4 8.7 0 15.3 1.5 20 4.5 4.7 3 7 7.6 7 13.7 0 3.5-1 6.7-3 9.6-2 3-4.9 5.4-8.6 7.3L455.7 60zm6.4-56c1.3-.2 2.8-.4 4.4-.5 1.7-.1 3.4-.3 5.1-.4 1.7-.1 3.4-.2 5-.3 1.6-.1 3.1-.1 4.4-.1 5.5 0 10.2.7 14.1 2.2 3.9 1.4 7.2 3.5 9.7 6 2.5 2.6 4.4 5.6 5.6 9.2 1.2 3.6 1.8 7.5 1.8 11.9 0 4.3-.6 8.3-1.8 11.9-1.2 3.6-3.1 6.7-5.6 9.3-2.5 2.6-5.8 4.6-9.7 6.1-3.9 1.4-8.7 2.2-14.1 2.2-1.3 0-2.8 0-4.4-.1-1.6-.1-3.3-.2-5-.3-1.7-.1-3.4-.2-5.1-.4-1.7-.1-3.1-.3-4.4-.5V4zm14.7 44.7c1.2.1 2.2.3 3.1.3.9.1 2 .1 3.3.1 4.6 0 8-1.4 10.5-4.1 2.4-2.7 3.6-7.1 3.6-13.1s-1.2-10.3-3.6-13.1c-2.4-2.7-5.9-4.1-10.5-4.1-1.2 0-2.3 0-3.3.1-.9.1-2 .2-3.1.3v33.6z",
    className: "orangeone"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M220.8 126.2c-1.6.4-3.2.5-4.8.5-1.8 0-3.4-.2-4.7-.5-1.6-4.6-3.4-8.9-5.4-13.1-2-4.2-4.1-7.9-6.2-11.3l-.4 36c-1.1.2-2.2.4-3.3.5-1.1.1-2.3.2-3.8.2-2.7 0-5.1-.2-7.2-.6l1.1-56c1.8-.4 4-.6 6.6-.6 2.5 0 4.7.2 6.6.6 1.2 1.6 2.6 3.5 4.1 5.7 1.5 2.2 3 4.6 4.4 7.2 1.5 2.6 2.9 5.3 4.3 8.1s2.7 5.5 4 8.2c1.1-2.7 2.3-5.4 3.6-8.2 1.3-2.8 2.7-5.5 4.1-8.1 1.4-2.6 2.8-5 4.2-7.2 1.4-2.2 2.7-4.1 4-5.7 1-.2 2-.4 3.1-.5 1-.1 2.2-.2 3.5-.2 2.5 0 4.7.2 6.6.6l1.1 56c-2.1.4-4.5.6-7.3.6-1.4 0-2.6-.1-3.7-.2s-2.2-.3-3.3-.5l-.4-36.2c-2.1 3.5-4.1 7.3-6 11.5-1.7 4.3-3.4 8.6-4.8 13.2zm61.7 12.9c-4.6 0-8.5-.7-11.9-2.2-3.4-1.4-6.2-3.5-8.5-6.1s-4-5.7-5.1-9.3c-1.2-3.6-1.7-7.5-1.7-11.8 0-4.3.6-8.3 1.7-11.9 1.2-3.6 2.9-6.7 5.1-9.3 2.3-2.6 5.1-4.6 8.5-6.1 3.4-1.4 7.4-2.2 11.9-2.2s8.5.7 11.9 2.2c3.4 1.4 6.2 3.5 8.5 6.1 2.3 2.6 4 5.7 5.1 9.3 1.2 3.6 1.7 7.5 1.7 11.9 0 4.3-.6 8.2-1.7 11.8-1.2 3.6-2.9 6.7-5.1 9.3-2.3 2.6-5.1 4.6-8.5 6.1-3.4 1.4-7.4 2.2-11.9 2.2zm-12.4-29.4c0 5.6 1 10 3.1 13.1s5.1 4.6 9.3 4.6c4.1 0 7.2-1.5 9.3-4.6s3.1-7.4 3.1-13.1c0-5.6-1-10-3.1-13s-5.1-4.6-9.3-4.6c-4.1 0-7.2 1.5-9.3 4.6s-3.1 7.4-3.1 13zm100.1 28.1c-1.3.2-2.7.4-4.3.5-1.6.1-3 .2-4.3.2-1.3 0-2.7-.1-4.3-.2-1.6-.1-3-.3-4.3-.5L338.1 113c4.1-1.4 7.3-3.2 9.4-5.4 2.2-2.1 3.3-4.7 3.3-7.9 0-5.8-4-8.7-11.9-8.7-.8 0-1.6 0-2.5.1-.9.1-1.8.2-2.9.3v46.3c-1.1.2-2.2.4-3.3.5-1.1.1-2.4.2-3.8.2-2.7 0-5.1-.2-7.3-.6v-56c3.5-.4 7-.7 10.7-.9 3.7-.3 6.8-.4 9.3-.4 8.7 0 15.3 1.5 20 4.5 4.7 3 7 7.6 7 13.7 0 3.5-1 6.7-3 9.6-2 3-4.9 5.4-8.6 7.3l15.7 22.2zm2.4-56h47.9c.2 1 .4 2 .5 3.1.1 1 .2 2 .2 3 0 .9-.1 1.9-.2 3-.1 1-.3 2.1-.5 3.1h-16.6v43.9c-2.2.4-4.6.6-7.4.6-2.7 0-5.2-.2-7.4-.6v-44h-16.6c-.2-1-.4-2-.5-3.1-.1-1-.2-2-.2-3 0-.9.1-1.9.2-3l.6-3zm87.4 27.5c.9-.2 2.1-.4 3.4-.5 1.3-.1 2.5-.2 3.5-.2s2.2.1 3.5.2c1.3.1 2.5.3 3.4.5v27c-2.1.8-4.7 1.5-7.9 2-3.1.5-6.9.8-11.2.8-5 0-9.3-.7-13-2.2-3.7-1.4-6.8-3.5-9.2-6.1-2.5-2.6-4.3-5.7-5.5-9.3-1.2-3.6-1.8-7.5-1.8-11.8 0-4.3.6-8.3 1.8-11.9 1.2-3.6 3-6.7 5.5-9.3 2.5-2.6 5.5-4.6 9.2-6.1 3.7-1.4 8-2.2 13-2.2 3 0 5.8.2 8.5.7 2.7.5 5.3 1.2 7.9 2.2-.3 2.2-.7 4.4-1.4 6.6-.6 2.2-1.2 4-1.9 5.3-1.7-.6-3.5-1.1-5.4-1.5-1.9-.4-4.1-.6-6.7-.6-2.3 0-4.4.3-6.3.9-1.9.6-3.6 1.5-4.9 2.9-1.4 1.3-2.4 3.1-3.2 5.2-.8 2.1-1.1 4.8-1.1 7.9 0 3 .4 5.6 1.1 7.8.7 2.2 1.8 3.9 3.1 5.3 1.4 1.3 3 2.3 4.9 2.9 1.9.6 4 .9 6.3.9.9 0 1.7 0 2.5-.1s1.4-.2 1.8-.3v-17zm71.8 28.5c-1 .2-2.1.4-3.3.5-1.2.1-2.5.2-3.9.2-2.7 0-5.1-.2-7.2-.6V124h-19.1v13.9c-1 .2-2.1.4-3.3.5-1.2.1-2.5.2-3.9.2-2.7 0-5.1-.2-7.2-.6v-32.9c0-8.1 2.4-14.2 7.1-18.3 4.7-4.1 11.6-6.1 20.5-6.1 3.3 0 6.7.3 10.4 1s6.9 1.5 9.6 2.5v53.6zm-14.3-25.4v-19c-2.3-.6-4.8-.9-7.6-.9-7.7 0-11.5 4.4-11.5 13.2v6.6h19.1zm58.1-3.1c.9-.2 2.1-.4 3.4-.5 1.3-.1 2.5-.2 3.5-.2s2.2.1 3.5.2c1.3.1 2.5.3 3.4.5v27c-2.1.8-4.7 1.5-7.9 2-3.1.5-6.9.8-11.2.8-5 0-9.3-.7-13-2.2-3.7-1.4-6.8-3.5-9.2-6.1-2.5-2.6-4.3-5.7-5.5-9.3-1.2-3.6-1.8-7.5-1.8-11.8 0-4.3.6-8.3 1.8-11.9 1.2-3.6 3-6.7 5.5-9.3 2.5-2.6 5.5-4.6 9.2-6.1 3.7-1.4 8-2.2 13-2.2 3 0 5.8.2 8.5.7 2.7.5 5.3 1.2 7.9 2.2-.3 2.2-.7 4.4-1.4 6.6-.6 2.2-1.2 4-1.9 5.3-1.7-.6-3.5-1.1-5.4-1.5-1.9-.4-4.1-.6-6.7-.6-2.3 0-4.4.3-6.3.9-1.9.6-3.6 1.5-4.9 2.9-1.4 1.3-2.4 3.1-3.2 5.2-.8 2.1-1.1 4.8-1.1 7.9 0 3 .4 5.6 1.1 7.8.7 2.2 1.8 3.9 3.1 5.3 1.4 1.3 3 2.3 4.9 2.9 1.9.6 4 .9 6.3.9.9 0 1.7 0 2.5-.1s1.4-.2 1.8-.3v-17zm37.8 5.7c0 4.5 1 7.6 3 9.4 2 1.8 5.5 2.7 10.4 2.7 2.1 0 4.4-.1 6.8-.3 2.5-.2 4.7-.5 6.6-.8.3.9.5 1.9.7 2.9.2 1 .3 2 .3 3 0 1.9-.2 3.7-.5 5.5-4.5 1.1-9.4 1.6-14.7 1.6-4.8 0-8.8-.5-12.2-1.4-3.4-.9-6.2-2.4-8.3-4.4-2.1-2-3.7-4.6-4.7-7.9-1-3.2-1.5-7.2-1.5-11.9V81.8h40.4c.4 1.7.7 3.7.7 6.1 0 2.5-.2 4.5-.7 6.1h-26.2v10h22c.2.8.4 1.7.5 2.8.1 1 .2 2 .2 2.8 0 .8-.1 1.7-.2 2.8-.1 1-.3 2-.5 2.8h-22.1zm47.7-1.4c-4-1.2-7.2-3.1-9.4-5.6-2.2-2.5-3.4-5.8-3.4-9.8 0-2.7.5-5.1 1.6-7.3s2.6-4.1 4.7-5.6c2-1.6 4.4-2.7 7.2-3.6 2.8-.8 5.9-1.2 9.4-1.2 1.4 0 2.8.1 4.4.2 1.6.1 3.1.3 4.6.5 1.5.2 2.9.5 4.3.8 1.3.3 2.5.7 3.5 1-.3 2.1-.7 4.2-1.3 6.4-.6 2.2-1.2 4-2 5.4-2.1-.8-4.5-1.5-7.2-2s-4.9-.8-6.8-.8c-2.4 0-4.3.4-5.7 1.2-1.4.8-2.2 2.1-2.2 3.7 0 1.4.6 2.6 1.8 3.4 1.2.8 2.6 1.5 4.3 2l7.4 2.2c4.5 1.3 7.9 3.2 10.1 5.6 2.3 2.4 3.4 5.8 3.4 10.1 0 5.9-2.2 10.4-6.7 13.8-4.4 3.3-10.5 5-18.3 5-3.3 0-6.5-.3-9.8-.8-3.3-.5-5.9-1.1-7.9-1.8.3-2.2.7-4.4 1.4-6.6.6-2.2 1.2-4 1.9-5.3.9.4 1.9.7 3 1 1.1.3 2.3.6 3.6.9 1.3.3 2.6.5 4 .7 1.3.2 2.6.3 3.8.3 2.9 0 5.3-.5 7.3-1.4 2-.9 2.9-2.3 2.9-4.3 0-1.7-.7-3-2.1-3.9-1.4-.9-3.2-1.7-5.4-2.4l-6.4-1.8z",
    className: "orangetwo"
  }))), _g2 || (_g2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    className: "icon-squircles"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#F68B1F",
    d: "M93.7 2.4C100.6.9 108.4 0 116.5 0c8.2 0 15.9.8 22.8 2.4 1.5 6.9 2.4 14.7 2.4 22.8 0 8.2-.8 15.9-2.4 22.8-6.9 1.5-14.7 2.4-22.8 2.4-8.2 0-15.9-.8-22.8-2.4-1.5-6.9-2.4-14.7-2.4-22.8 0-8.2.9-15.9 2.4-22.8",
    className: "grey"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "url(#a)",
    d: "M139.4 2.4c1.5 6.9 2.4 14.7 2.4 22.8 0 8.2-.8 15.9-2.4 22.8-6.9 1.5-14.7 2.4-22.8 2.4-8.2 0-15.9-.8-22.8-2.4l45.6-45.6z",
    className: "grey"
  }))), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#F36C21",
    d: "M48 48c6.9-1.5 14.7-2.4 22.8-2.4 8.2 0 15.9.8 22.8 2.4 1.5 6.9 2.4 14.7 2.4 22.8 0 8.2-.8 15.9-2.4 22.8-6.9 1.5-14.7 2.4-22.8 2.4-8.2 0-15.9-.8-22.8-2.4-1.5-6.9-2.4-14.7-2.4-22.8.1-8.1.9-15.8 2.4-22.8",
    className: "grey"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "url(#b)",
    d: "M93.7 48c1.5 6.9 2.4 14.7 2.4 22.8 0 8.2-.8 15.9-2.4 22.8C86.8 95.1 79 96 70.9 96c-8.2 0-15.9-.8-22.8-2.4L93.7 48z",
    className: "grey"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#969696",
    d: "M2.4 93.7c6.9-1.5 14.7-2.4 22.8-2.4 8.2 0 15.9.8 22.8 2.4 1.5 6.9 2.4 14.7 2.4 22.8 0 8.2-.8 15.9-2.4 22.8-6.9 1.5-14.7 2.4-22.8 2.4-8.2 0-15.9-.8-22.8-2.4C.8 132.4 0 124.7 0 116.5c0-8.1.8-15.9 2.4-22.8",
    className: "grey"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "url(#c)",
    d: "M48 93.7c1.5 6.9 2.4 14.7 2.4 22.8 0 8.2-.8 15.9-2.4 22.8-6.9 1.5-14.7 2.4-22.8 2.4-8.2 0-15.9-.8-22.8-2.4L48 93.7z",
    className: "grey"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#F68B1F",
    d: "M48 2.4c1.5 6.9 2.4 14.7 2.4 22.8 0 8.2-.8 15.9-2.4 22.8-6.9 1.5-14.7 2.4-22.8 2.4-8.2 0-15.9-.9-22.8-2.4C.8 41.1 0 33.4 0 25.2 0 17 .8 9.3 2.4 2.4 9.3.8 17 0 25.2 0 33.4 0 41.1.8 48 2.4",
    className: "grey"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "url(#d)",
    d: "M48 48c-6.9 1.5-14.7 2.4-22.8 2.4-8.2 0-15.9-.9-22.8-2.4C.8 41.1 0 33.4 0 25.2 0 17 .8 9.3 2.4 2.4L48 48z",
    className: "grey"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAccordMortgagesreact);

/***/ }),

/***/ 82698:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAldermorereact = function SvgAldermorereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 117,
    height: 19,
    "aria-label": "Aldemore icon",
    viewBox: "0 0 600 87.8",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", {
    id: "style2",
    type: "text/css"
  }, ".st1{fill:#000008}")), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "g22",
    transform: "translate(-20.9 -278.7)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path4",
    fill: "#ffda00",
    d: "M443.2 333.2c0-18.4 14.9-33.3 33.3-33.3s33.3 14.9 33.3 33.3-14.9 33.3-33.3 33.3c-18.4.1-33.3-14.9-33.3-33.3"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path6",
    d: "M20.9 353h5.6l26.2-74.3h19L98 353h6.1v11.5H72.7V353h9.1l-4.6-14H47.3L43 353h9v11.5H20.9zM73 326.7l-11.3-32.5-10.4 32.5z",
    className: "st1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "polygon8",
    d: "M107.9 290.3v-11.6h23.9V353h7v11.5h-30.9V353h7.1v-62.7z",
    className: "st1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path10",
    d: "M189 290.3h-7.2v-11.6h23.7V353h6.9v11.5h-23.2l-.3-6.3c-6.6 6.4-10.3 8.2-17.5 8.2-17 0-28.7-13.4-28.7-32.9 0-20.1 11.5-33.9 28.1-33.9 6.6 0 10.4 1.8 18.3 8.2v-17.5zm-29.4 42.6c0 12.1 5.8 20.5 14.2 20.5 9.7 0 16-7.9 16-19.8 0-11.8-6.7-20.6-15.7-20.6-8.8 0-14.5 7.9-14.5 19.9",
    className: "st1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path12",
    d: "M233.2 337.9c2.3 10.8 7 15.5 15.8 15.5 6.4 0 9.8-2.1 13.3-8h16.9c-1.4 4.3-2.3 6.1-3.6 8.1-4.9 8-15.3 13-26.5 13-19.1 0-32.9-13.8-32.9-33 0-18.9 13.9-33.6 31.8-33.6 13 0 24.9 8 29.4 19.7 1.5 4.3 2.2 8.4 2.4 18.3zm29.4-11.4c-1.8-9.3-6.4-13.5-14.7-13.5-8.6 0-12.9 3.9-15.1 13.5z",
    className: "st1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path14",
    d: "M284.6 301.6h22.8v8.6c5.2-7.3 9.8-10.4 15.8-10.4 1.6 0 2.6.1 4.8.8v13.9h-2.3c-11.7-.5-17.4 5-17.9 17.9V353h8v11.5h-31.1V353h7v-39.8h-7.1z",
    className: "st1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path16",
    d: "M332.5 301.6h22.3v6.3c7.2-6.4 11-8.1 18.2-8.1 9.2 0 14.2 2.7 18.7 10.1 7.7-7.9 12.1-10.3 19.2-10.3 8.5 0 16.8 4.5 20.5 11.3 1.9 3.5 2.6 7.1 2.6 13.9V353h6.7v11.5h-30V353h7v-26.2c0-8.1-4-13.3-10.3-13.3-6.8 0-12.2 6.6-12.2 15.1V353h6.7v11.5h-30.4V353h7.3v-24.4c0-9.5-3.9-14.8-11-14.8-7.3 0-11.7 6-11.7 16V353h6.5v11.5h-30V353h7.3v-39.8h-7.2v-11.6z",
    className: "st1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path18",
    d: "M513.8 301.6h22.8v8.6c5.2-7.3 9.8-10.4 15.8-10.4 1.6 0 2.6.1 4.8.8v13.9h-2.3c-11.7-.5-17.4 5-17.9 17.9V353h8v11.5h-31.1V353h7v-39.8h-7.1z",
    className: "st1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path20",
    d: "M574.2 337.9c2.3 10.8 7 15.5 15.9 15.5 6.4 0 9.8-2.1 13.3-8h16.9c-1.4 4.3-2.3 6.1-3.6 8.1-4.9 8-15.3 13-26.5 13-19.1 0-32.9-13.8-32.9-33 0-18.9 13.9-33.6 31.8-33.6 13 0 24.9 8 29.4 19.7 1.5 4.3 2.2 8.4 2.4 18.3zm31-11.4c-1.8-9.3-6.4-13.5-14.7-13.5-8.6 0-12.9 3.9-15.1 13.5z",
    className: "st1"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAldermorereact);

/***/ }),

/***/ 50730:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCoventryreact = function SvgCoventryreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 103,
    height: 32,
    "aria-label": "Coventry icon",
    viewBox: "0 0 600.1 178.7",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", {
    id: "style179",
    type: "text/css"
  }, ".st7{fill-rule:evenodd;clip-rule:evenodd;fill:#00a6e2}.st8{fill:#25479e}.st8,.st9{fill-rule:evenodd;clip-rule:evenodd}")), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path181",
    fill: "#28479e",
    fillRule: "evenodd",
    d: "M476 44.5c-.6 1.8-1.2 3.6-2.1 5.3-1.6 3-2.7 6.3-3.3 9.6 1 .6 2.1.5 3.2.4.4 0 .7-.1 1.1-.1.9-.2 1.2-.9 1.5-1.6.4-1 .8-1.9 1.2-2.9.9-2 1.8-4.1 2.6-6.2.1-.1.1-.3.2-.5.6-1.6 1.2-3.1 2.3-4.5 1.1 1.9 1.6 3.7.9 5.7-.6 1.8-1 3.6-.9 5.5v2.4c0 .6 0 1.2.2 1.9.5.2 31.4 0 31.4 0s.7-2.5 0-3.6c-.5-.1-1-.1-1.5-.1-1.2 0-2.3 0-3.1-1.3v-1.6c-4.1-4.1-7.7-8.7-11-13.4 0 0 0-.1-.1-.1-.5-.7-1-1.4-.5-2.2 1.8-2.8 1-5.3-.9-7.6-2.1-2.5-2.4-5.4-2.8-8.4 0-.5-.1-.9-.2-1.4 2.5 1.1 2.6 1 4.1-1.3.2-.3.4-.6.7-.7 1.5-.5 2.1-1.7 2.5-3.1.2-.8.8-1.4 1.3-2 0-.9.2-1.7.5-2.5.6-1.6 1-3.3-.1-4.8v-.1c-1.6-2.2-3.2-4.4-5.9-5.3h-2.6c-3.4.9-6.4 2.7-9.3 4.7-4.8 3.2-7.8 7.4-8.3 13.3-.1 1.2-.5 2.2-1.2 3.2-2.2 3.2-2.2 5.6-.1 8.8.3.4.6.9.9 1.3l.6.9c.9 1.3 1 2.7.1 4.1-.4.6-.8 1.3-1.2 1.9-.2.3-.4.6-.5.8.3.3.7.3 1.1.3.3 0 .6 0 1 .2-.8 1.7-1.3 3.3-1.8 5zm22.7 3c3.1 1.1 4.7 3.3 5.3 6.4-2.3.9-4.4-1.7-5.3-6.4zm0 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path183",
    fill: "#009fdf",
    fillRule: "evenodd",
    d: "M560.4 79.8c-1.4 3.5-2.2 7.2-2.6 10.9-.3 3.9-1.5 7.6-2.7 11.3-.2.6-.6 1.2-.4 2 4.8.8 9.4 2 13.9 3.9 3 1.2 5.8 2.7 8.6 4.3 1.5.9 2.4 2.2 2 3.9-1.9 8.7-4.4 17.2-8.1 25.3-2.1 4.7-6.2 7.3-11.1 8.5-.8.2-1.7.4-2.7.7v-8.7c.1 0 .1-.1.2-.1 2.4.2 4.4-.3 5.7-2.5.3-.5.9-.9 1.6-1 1.9-.4 2.6-1.6 2.9-3.4.7-4.1 1.5-8.1 2.3-12.2.5-2.6 0-3.2-2.5-3.9-4.2-1.1-8.6-1.3-12.9-2-3.5-.6-6.9-1.7-10.1-3.2-2-1-4.8-.3-5.7 1.7-3.4 7.2-8.4 13.5-12.1 20.5-2.6 5.1-4.9 10.2-7.2 15.3-1.1 2.4-.7 4.5.8 6.5 1.7 2.4 3.4 4.8 4.8 7.4.1.2.2.5.4.9h-9.2c0-3.6-1.6-6.4-4.2-8.7h3.8V143c.7-2.6 1.5-5.2 2.2-7.8 2-6.8 3.2-13.7 4.8-20.6.1-.4 0-.8 0-1.2-2.4.1-8.6.3-8.6.3V69.9h50.6c-1.7 3.2-3.1 6.5-4.5 9.9zm0 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path185",
    fill: "#245eaf",
    fillRule: "evenodd",
    d: "m514.5 101.5-68.3.2s.2-16 .1-23.1c.8-1 .9-1.7 1.7-2.7-.5-.6-1-.7-1.7-.7v-3l68.2-.1zm0 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path187",
    fill: "#295aad",
    fillRule: "evenodd",
    d: "M514.4 72.2V55.7c4.6.8 9.3 1.9 13.7 3.7 2.5 1 3.1 2.6 2.3 5.2-.1.3-.2.6-.3 1.1 1.7-.4 3.2-1 4.5-2 6.2-5.2 12.3-10.5 18.7-15.5 8.5-6.5 18.1-8.4 28.5-6 2.7.6 5.4.9 8.1.8 3.3-.2 6.6.2 10.2.7-1.5 1.4-3.2 2.3-4.8 3.2-1.6.9-2.4 2-2.6 3.8-.7 5.9-1.6 11.7-2.5 17.5-.1.4-.5 3.7-.8 4h-15.2c-.6-4-3.4-5.9-5.5-7-1.5 1.4-4 4.8-4.9 7-7.9-.2-49.4 0-49.4 0zm0 0",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path189",
    fill: "#1c77c1",
    fillRule: "evenodd",
    d: "M514.5 101.5s-.1 6.1-.1 12.1c-10.3.7-19.2-.2-29.6-1.8-.5 2-1.1 4-1.5 6-1.1 4.9-2.3 9.7-4.5 14.2-.8 1.6-.5 3.2.6 4.7 4.7 6.5 9.4 13.1 14.1 19.6.2.3.3.6.5.9-1.7 0-7.3-.1-8.7 0-2.4-5.9-6.2-10.8-10.7-15.2-2-2-4.2-3.8-6.4-5.5-1.5-1.1-2.1-2.3-1.7-4.3.7-3.3 1.7-6.6 1.1-10.1-.7-4.1-2.9-7.1-6.7-9.4-3.7 5.6-8.8 9.5-14.5 12.7-.6-.9-.5-2-.5-3v-18.3c0-.6.1-1.2-.3-1.8-1.1-.3-2.2-.1-3.3-.2-.7 0-1.5.1-2.1-.5v-.3h74.3zm0 0",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path191",
    fill: "#009ad9",
    fillRule: "evenodd",
    d: "M514.4 59.4v12.8c-2.2.3-64.6 0-68.1 0-.5-.5-.5-1.1 0-1.6.7.1 1.5.2 2.2.3 2.8.6 5.5.3 8.1-1 3.3-1.6 6.9-2.4 10.7-2.8.8-2.7 2.8-4.9 3.3-7.8h4.7c.3.7-.1 1.3-.5 1.9-.7 1.2-.7 2.3.1 3.4.5.7.7 1.5 1.3 2.2 2.6.7 5.3 1 8.3 1.7-1.9-2.5-1.7-5.3-2.1-7.9-.1-.5-.2-1.1.4-1.4h31.6zm0 0",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path193",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M474.2 67.2c-.4.2-.7.1-1.1-.1-.2-.5 0-.7.4-.9.5.2.8.5.7 1zm0 0",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path195",
    d: "M446.2 101.5c0 7.7.1 15.5.1 23 0 .3 0 .7-.1 1-5.3 3.8-9 8.8-11.6 14.7-2 4.5-3.5 9.1-4.4 13.9-.2 1-.1 2-.1 3.1-.2.3-.5.5-.9.5-2 0-4 .5-5.9-.4-.2-1.1 0-2.1.4-3.2 2-6.8 4.5-13.4 6.1-20.2.5-2.1.6-4.3.5-6.4-.1-1.1.2-1.9.9-2.6 4.8-5.3 7.7-11.4 8.7-18.5.2-1.5.1-3.3.1-4.8h6.2zm0 0",
    className: "st7"
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path197",
    d: "M446.3 70.7v4.6c-4.9 0-7.2 1.6-9 6.3-2 5.1-2.9 10.5-3 16 0 1.4-.1 2.8-.1 4.2-.4.7-1 .7-1.7.7h-10.2c-.5 0-1.1-.1-1.5-.5-.3-9.5.9-18.7 8.4-25.5 4.6-4.5 10.4-6.6 17.1-5.8zm0 0",
    className: "st8"
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path199",
    d: "M391.3 54.1h2.5v111.8c-.8.2-1.6.1-2.5 0zm0 0",
    className: "st9"
  })), _path11 || (_path11 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path201",
    fill: "#0095d6",
    fillRule: "evenodd",
    d: "M589.3 72.2c-.5 4-.4 5.2-1.1 9.1-.5 3.2-3.9 5.1-7.1 4.3-1.6-.4-3.1-1.1-4.6-1.8-1.2-.5-1.6-1.6-1.4-2.6.5-3.9 0-5.3-.9-9h15.1zm0 0",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path203",
    d: "M434 101.6c-.1 6.4-2.2 12.1-5.7 17.4-2.5 3.8-7.3 4.5-10.4 1.7.2-.5.8-.5 1.2-.6 2.7-.9 4.1-2.9 3.6-5.7-.4-2.5-1.2-5-1.7-7.6-.3-1.6-.7-3.6-.5-5.2 4.1-.1 12.9 0 13.5 0zm0 0",
    className: "st7"
  })), _path13 || (_path13 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path205",
    d: "M440 101.5c-.7-6.4-.1-11.3 2.9-18.4 1.1-2.6 3.3-4.5 3.3-4.5s.2 22.5 0 23c-2-.1-4.2-.1-6.2-.1zm0 0",
    className: "st8"
  })), _path14 || (_path14 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path207",
    fill: "#019bdc",
    fillRule: "evenodd",
    d: "M493.8 157.3c2.2 2.6 3.7 5.6 5.4 8.7h-9c-.4-.4-.4-.9-.5-1.5-.3-1.9-.7-3.7-2.9-4.6-1-.4-1.5-1.5-1.7-2.6.1-.1 7.4-.1 8.7 0zm0 0",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path209",
    fill: "#1279c1",
    fillRule: "evenodd",
    d: "M423.4 157.3h6.7c.7 3.2 3.5 5.4 4.4 8.7h-8.3c-.4-.6-.2-1.2-.2-1.7.1-1.9-.1-3.7-1.8-5-.5-.6-.8-1.3-.8-2zm0 0",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path211",
    fill: "#1d77c0",
    fillRule: "evenodd",
    d: "M515.9 157.3h-3.8c-1.1-1-1.2-2.3-.6-3.3 2-3.5 3.1-7.2 4.4-10.9zm0 0",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path213",
    d: "M0 72.8c.3-1.9.6-3.7 1-5.6 2-7.7 8.9-13 17.7-13.6 10.7-.8 18.9 5.2 21.3 15.6.1.5.2.9.3 1.6H29.6c-.4-.9-.7-1.9-1.2-2.9-1.8-3.5-5.3-5.2-9.4-4.7-3.9.5-6.6 3-7.5 6.8-.6 2.9-.6 5.8-.6 8.8 0 4.3-.2 8.5.4 12.7.6 4.8 3.4 7.7 7.9 8.2 4.7.6 8.3-1.7 10-6.3.2-.4.3-.8.5-1.4h10.6c-.6 4.2-2.1 7.8-4.8 10.9-8.5 9.7-25.8 8.2-32.5-2.7C1.3 97.5.7 94.5.3 91.4c-.1-.5.1-1-.3-1.4zm0 53.4c5.7-.2 11.4-.3 17.1.1 4.1.3 7.4 2.2 8.9 6.3 1.4 3.7 1.1 7.3-1.5 10.5-.9 1-2 1.8-3.4 2.5 2.9 1.3 4.9 3.2 5.8 6 2.5 7.6-2.5 14.4-10.8 14.5H0zm4.4 36v-14.5h3.8c2.9-.1 5.8-.1 8.6.1 4.2.4 6.5 3.4 6.3 7.4-.1 4-2.8 6.8-7.2 7-2.6.1-5.3.1-7.9 0H4.4zm0-32.2v13.7h4.5c2.5 0 5.1.1 7.6-.2 4-.6 6.1-3.1 6-7-.1-3.7-2.3-6.3-6.2-6.5-2.8-.2-5.5-.1-8.3-.1-1.1.1-2.3.1-3.6.1zm159 44.9c1.9 2.1 4.4 3.1 6.9 3.8h4.7s0-.1.1-.1c.1-.1.1-.1.2-.1 5.6-1.4 8.6-4.8 8.8-10.6.2-5.2.1-10.5.1-15.7v-13.6h-4.1v2.8c-.1-.1-.2-.2-.3-.2l-.3-.3c-5.5-5.3-14.3-3-16.3 4.3-1.1 4-1.1 8.1-.4 12.2.6 3.8 2.3 6.9 6.3 8.1 4 1.2 7.6.7 10.6-2.4 0 0 .1-.1.2-.1h.2v1.7c0 1.5 0 3-.2 4.4-.6 3.8-3.3 6-7.1 6.1-2.7.1-4.9-.9-6.9-2.7zm3.9-29c-.7 1.9-.8 4-.8 6.1 0 2 0 4.1.7 6.1 1.1 3 3 4.3 6.4 4.3 3 0 5-1.4 5.8-4.4 1.1-4 1.1-8 0-12-.8-2.9-2.9-4.2-6-4.2-3.1-.1-5.1 1.2-6.1 4.1zm56.9-37h-9.5c-7.1-11.1-14.3-22.1-21.7-33.6v33.6h-10.6V54.2h9.5c7 10.9 14.2 21.9 21.5 33.3V54.2h10.7v54.7zm96.8-.1-12.1-23.5c.1-.1.2-.1.3-.2.1-.1.2-.2.4-.2 9.3-3.9 11-13.6 8-20.8-2.9-6.7-8.3-9.8-15.4-10-5.1-.2-10.2-.1-15.3-.1h-6.6c-.2 0-.5 0-.6.2v54.6h10.6V87.1h7.7l10.6 21.7zm-30.7-45.1v14.4h4.7c2 0 4.1 0 6.2-.1 4.2-.2 7-3.3 6.9-7.4-.1-4-3-6.8-7.2-7h-9.1c-.5.1-1 .1-1.5.1zM45.5 80.5v1.9c-.1 2.5.1 5.9.3 9.4.1 1.2.3 2.4.6 3.6 2 8 9 13.4 18.1 14 10.7.7 19.7-6.3 21-16.7.9-7 .6-14.1.2-21.2-.7-11.2-10.1-17.7-19.3-17.9-10.2-.2-18.5 6-20.3 15.5-.6 3.6-.6 7.2-.6 11.4zm29.8 3.2v-2.3c0-.9 0-1.8-.1-2.7 0-2.8-.1-5.5-.6-8.3-.8-4.4-4.3-7.3-8.7-7.3-4.8 0-8.4 2.6-9.1 7.2-1.1 7.2-1 14.5-.1 21.7.6 5.1 4.3 7.8 9.4 7.7 4.6-.1 8-3.2 8.6-8.1.5-2.6.6-5.2.6-7.9zm97.9-20H148v12.8h21.4v9.6H148v13.2h25.2v9.6h-35.9V54.3h35.9zm-40.3-9.6c-6.1 18.3-12.1 36.5-18.1 54.7h-8.1c-6-18.1-12-36.4-18-54.7h11.1c3.6 11.7 7.2 23.5 11 35.6 3.7-12.1 7.4-23.8 11-35.6zm222.8 0h11.6c-.5 1.1-1 2-1.4 2.9-4.8 9.4-9.6 18.9-14.4 28.3-.4.8-.6 1.5-.6 2.4v21.1h-10.7V87.9c0-1-.2-1.9-.7-2.8-5.1-10-10.2-20.1-15.4-30.1l-.4-.8h11.6c3.3 7.1 6.7 14.4 10.2 21.9 3.5-7.5 6.8-14.7 10.2-22zm-109.9 9.6h-14.3v-9.5h39.2v9.4h-14.2v45.2h-10.8V63.7zM109 126.2v15c-.1 0-.2-.1-.3-.1-.1-.1-.2-.1-.2-.2-3-3.1-6.7-3.4-10.6-2.4-3.8 1-5.5 4-6.2 7.6-.8 4.3-.9 8.6.2 12.8 1.6 6.8 9.5 9.8 15.2 5.7.5-.3.9-.7 1.3-1.1.2-.2.5-.5.8-.7v3h3.8v-39.7h-4zm0 26.2v-.8c-.1-2.1-.2-4.3-1.1-6.4-1.1-2.5-3.1-3.5-5.7-3.6-2.6 0-4.9.8-5.9 3.4-1.7 4.7-1.7 9.5 0 14.2 1 2.6 3.2 3.5 5.9 3.4 2.6 0 4.7-1.1 5.7-3.7 1-2 1-4.2 1.1-6.5zm119.1-22.3-2.7 2.7c-2.8-2.5-6.1-3.5-9.8-3.4-5.4.2-8.7 3.9-7.8 8.8.4 2.2 1.7 3.5 3.7 4.4 2.6 1.1 5.5 1.2 8.3 1.7 2.2.4 4.3.8 6.1 2.2 5.3 4 5.4 12.3.3 16.7-5.9 5-18.6 3.8-23.6-2.2.9-.9 1.9-1.8 3-2.8 3.1 3.4 7.2 4.5 11.8 4.2 1.3-.1 2.5-.3 3.7-.8 3.3-1.2 4.8-3.9 4.5-7.7-.3-3.1-2.2-4.9-5.6-5.5-2.5-.5-5-.7-7.5-1.3-7.8-1.7-11.1-8.3-7.8-15.4 1-2.2 2.7-3.9 5-4.8 6.1-2.3 12-2 17.4 2 .1.5.5.8 1 1.2zm77.5 23.2h18.3c.2-3.2-.1-6.2-1.4-9.1-1.8-3.8-4.8-5.8-9-6.1-4-.3-7.6.8-9.7 4.4-3.6 6.1-3.7 12.6-.4 18.7 3.7 6.7 14.4 7 20 .8l-2.6-2.3c-4.9 3.4-8.8 3.9-12 1.8-2.4-1.5-3.9-5.3-3.2-8.2zm6.9-11.8c-4.4 0-7.3 3.5-7.1 8.6h14.4c.1-5.3-2.8-8.6-7.3-8.6zm-55.7 16.8c.5-1.9.6-3.9.7-6.6 0-1-.1-2.6-.4-4.2-1-5.7-5.1-9.3-10.7-9.5-5.6-.1-9.9 3.3-11 8.9-.8 3.7-.8 7.5.2 11.2 1.3 5.1 5.3 8.1 10.6 8.2 5.1.1 9.2-3 10.6-8zm-4-.5c.5-1.8.6-3.7.6-5.7 0-1.4 0-3.1-.4-4.7-.7-3.3-3.2-5.5-6.6-5.6-3.4-.1-6.1 1.8-6.9 5.1-.9 3.7-.9 7.5.1 11.1.8 3 3.5 4.8 6.6 4.8 3.3-.1 5.7-1.9 6.6-5zm92.8 19.9v-3.2l.2-.2c3.5.4 5.1-1.5 5.9-4.5.4-1.4 1-2.8 1.5-4.3-3.2-8.8-6.5-17.8-9.9-26.9h4.4c2.4 7.2 4.9 14.4 7.5 22 2.6-7.6 5-14.7 7.5-22h4.4c-1.2 3.4-2.4 6.8-3.7 10.1-3 8.1-5.9 16.2-8.9 24.3-1.3 3.7-4.1 5.2-8.9 4.7zM34.9 138.5h4v11.6c0 2.1 0 4.2.1 6.3.2 4.1 2.7 6.4 6.7 6.3 3.9 0 6.6-2.5 6.7-6.4.1-5.6 0-11.2 0-16.8v-.9h4v27.3c-1.2.3-2.4.1-3.7.1-.4-.9 0-1.8-.3-2.8-2.3 2.3-5.1 3.3-8.2 3.2-5.4-.2-9.1-3.6-9.2-9-.2-6.3-.1-12.5-.1-18.9zM155.7 166h-3.8c-.4-.6-.2-1.2-.2-1.7v-15.8c-.1-5.1-4.1-7.9-9.1-6.4-2.7.8-4.4 3.1-4.4 6.3v17.5c-1.3.2-2.6.1-4 .1v-27.5h3.9v2.5c.7 0 .9-.5 1.3-.8 3.5-2.5 7.2-2.8 11.1-1.2 3.6 1.5 5.2 4.7 5.3 8.4 0 6.2-.1 12.3-.1 18.6zm125.9-6.3c.8.8 1.7 1.6 2.5 2.4-4.1 5.5-13.5 5.6-18 .4-4.3-5.1-4.4-15.4 0-20.5 4.4-5.3 13.5-5.3 18.1.2-.9.8-1.7 1.6-2.7 2.5-2.2-2.6-4.9-3.6-8.2-2.9-3.5.7-5.4 3.2-6.1 6.5-.5 2.6-.5 5.2 0 7.9.6 3 2.3 5.2 5.3 6.1 3.1.9 5.9.4 8.2-2 .2-.2.4-.3.6-.5 0 0 .1 0 .3-.1zm59.8-21.2v3.2h-5.8v17.1c.1 2.6 1.3 3.7 3.8 3.8h2v3.3c-6.8 1.3-10-2.3-9.9-7.5v-16.6h-3.4v-3.2h3.3v-8.5h4.1v8.5h5.9zM77.6 126.2h3.8v33.1c.2 2.3 1.2 3.2 3.5 3.3h2.3c.3 1.1.1 2.2.1 3.4-1.9.1-3.7.3-5.5-.3-2.6-.8-4.3-3-4.3-6-.1-11.1 0-22.1 0-33.1 0-.2.1-.3.1-.4zm43.9 12.3h3.9v27.4h-3.9zm168.8 0h3.9v27.4c-1.3.2-2.6.1-3.9 0zm-225.1 0H69v27.4h-3.8zm224.9-12.4h4.4v4.4h-4.4zm-168.8 0h4.4v4.4h-4.4zm-56.4 0h4.4v4.4h-4.4z",
    className: "st9"
  })), _path18 || (_path18 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    id: "path215",
    fill: "#fefefe",
    fillRule: "evenodd",
    d: "M482.9 59.4c.2 3.3 0 6.7 2.4 9.7-3.3-.6-6.4-1.2-9.5-1.7-.6-1.2-1-2.5-1.9-3.7-.5-.6-.1-1.4.2-2.1.4-.7.7-1.5 1.1-2.2 2.2-4.1 3.6-8.5 5.5-12.7.5-1.2 1.2-2.4 1.9-3.8 1.4 2.5 2.5 4.9 1.1 7.7-.6 1.2-.7 2.6-.7 4-.3 1.5 0 3-.2 4.4.1.2.1.3.1.4zm0 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCoventryreact);

/***/ }),

/***/ 9396:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgHalifaxreact = function SvgHalifaxreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 16,
    fill: "none",
    "aria-label": "Halifax icon",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#1E5EAA",
    d: "M.093 8v2.283h1.036V8.535h1.554v1.748H3.72V5.718H2.683v1.894H1.13V5.718H.093v2.283zm5.212-1.362-1.223 3.641c.18.012.36.015.539.01h.533l.265-.853 1.533.021.261.816.525.01c.367.008.524-.004.524-.033 0-.033-.282-.88-1.277-3.839l-.227-.666-.574-.01-.577-.008-.302.91zm1.127 1.144c.08.24.152.481.218.724.004.042-.07.056-.435.067a2.002 2.002 0 0 1-.473-.023c.012-.195.055-.387.129-.568l.232-.75c.041-.128.078-.197.093-.165.087.234.166.472.236.713v.002zm2.2.219v2.282h2.7v-.961H9.703v-3.6h-1.07v2.279zm3.221 0v2.282h1.036V5.718h-1.036v2.283zm1.81 0v2.282h1.036V8.535h1.664v-.928h-1.664V6.68h1.995v-.966h-3.032v2.287zm4.252-2.272c-.22.666-.444 1.332-.67 1.997l-.839 2.505c-.014.042.079.052.518.052h.533l.248-.811c.015-.038.187-.042.784-.038l.767.01.259.837h2.113l.197-.327.42-.686c.18-.298.229-.354.266-.316.027.027.228.337.44.686l.4.645h1.174l-.111-.179a66.662 66.662 0 0 0-.57-.88l-.788-1.234 1.461-2.257-.576-.01c-.539-.009-.576-.005-.632.066a26.72 26.72 0 0 0-.425.682 8.086 8.086 0 0 1-.394.616c-.01 0-.211-.308-.443-.686l-.42-.687h-.581a6.647 6.647 0 0 0-.584.015c.36.586.733 1.165 1.117 1.737.127.173.233.36.315.56-.01.025-.208.337-.44.695l-.659 1.013c-.186.291-.24.354-.265.304a93.649 93.649 0 0 1-.746-2.183l-.713-2.122-.58-.01a8.046 8.046 0 0 0-.58.002l.004.004zm.796 1.935.221.713a.42.42 0 0 1 .027.175c-.304.034-.61.03-.914-.014a.265.265 0 0 1 .015-.16c.306-.995.42-1.332.447-1.299.08.191.145.387.203.587v-.002z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#1D2545",
    d: "m20.35 11.739 4.39 4.265h-8.963l-4.539-4.823 8.53-.004.582.562zm0-7.478L24.737 0h-8.96l-4.539 4.823 8.53.004.582-.566z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#1E5EAA",
    d: "M4.39 11.74 0 16h8.959l4.538-4.823-8.532-.004-.576.566zm0-7.479L0 .001h8.959l4.538 4.822-8.532.004-.576-.566zm24.97 3.74v8h3.627V9.882h5.442V16h3.626V0H38.43v6.637h-5.442V0H29.36v8zm18.27-4.786-4.278 12.744c0 .027.842.041 1.88.041h1.865l.933-2.992 5.363.063.466 1.431.456 1.432 1.84.041c1.285.027 1.84-.012 1.84-.116 0-.117-.984-3.084-4.47-13.451L52.732.063 50.722.02l-2.023-.025-1.07 3.219zm3.95 4.005c.414 1.29.752 2.434.766 2.538.013.156-.248.196-1.53.235-.855.013-1.595-.012-1.657-.076-.077-.077.104-.86.456-1.992l.816-2.627c.146-.458.27-.687.324-.583.051.091.427 1.223.829 2.511l-.005-.006zm7.708.78v8h9.458v-3.383h-5.698V0h-3.76v8zm11.274 0v8h3.626V0h-3.626v8zm6.347 0v8h3.627V9.883h5.831v-3.25h-5.831V3.381h6.996V.001H76.907l.002 8zM91.81.042c0 .027-1.049 3.173-2.346 7l-2.605 7.78-.323 1c-.052.155.27.182 1.813.182h1.865l.881-2.836c.052-.128.663-.155 2.746-.128l2.694.041.907 2.925h7.399l.683-1.144 1.478-2.407c.622-1.04.804-1.248.932-1.103.092.092.788 1.186 1.542 2.407l1.399 2.252h4.12l-.39-.624c-.207-.34-1.115-1.727-1.995-3.084l-2.191-3.398-.58-.923 5.118-7.907-2.02-.041c-1.892-.025-2.02-.013-2.217.235-.104.145-.777 1.223-1.492 2.392-.713 1.186-1.335 2.148-1.374 2.16-.042 0-.738-1.082-1.555-2.407L104.831 0h-2.035c-1.127 0-2.047.027-2.047.052 0 .052.777 1.276 3.912 6.088.649.988 1.14 1.873 1.099 1.964-.042.092-.726 1.186-1.542 2.435l-2.302 3.547c-.649 1.015-.842 1.236-.933 1.067-.062-.104-1.243-3.551-2.617-7.648L95.864.063 93.83.02c-1.115-.01-2.02-.01-2.02.014v.008zm2.785 6.791.777 2.497c.08.193.112.403.091.611-.128.146-3.123.08-3.2-.052a.898.898 0 0 1 .053-.56c1.077-3.486 1.477-4.656 1.568-4.552.274.672.512 1.359.713 2.056h-.002z"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h115v16H0z"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgHalifaxreact);

/***/ }),

/***/ 6682:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgHsbcreact = function SvgHsbcreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 24,
    "aria-label": "HSBC icon",
    viewBox: "0 0 315.9 85",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M42.6 0h85v85h-85z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#db0011",
    d: "M170.1 42.6 127.6 0v85.1zm-85 0L127.6 0h-85z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#db0011",
    d: "m0 42.6 42.6 42.5V0zm85.1 0L42.6 85.1h85z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M207.4 45.1H192v15.2h-7.7V24.7h7.7v14.6h15.4V24.7h7.7v35.6h-7.7V45.1zM233.7 61c-7.7 0-14-3.1-14.1-11.6h7.7c.1 3.8 2.3 6.1 6.5 6.1 3.1 0 6.7-1.6 6.7-5.1 0-2.8-2.4-3.6-6.4-4.8l-2.6-.7c-5.6-1.6-11.2-3.8-11.2-10.2 0-7.9 7.4-10.6 14.1-10.6 6.9 0 12.9 2.4 13 10.3h-7.7c-.3-3.2-2.2-5.1-5.8-5.1-2.9 0-5.7 1.5-5.7 4.7 0 2.6 2.4 3.4 7.4 5l3 .9c6.1 1.9 10 4 10 10-.1 8-7.9 11.1-14.9 11.1zm19.2-36.2h12.4c2.3-.1 4.7 0 7 .4 4.3 1 7.6 3.8 7.6 8.6 0 4.6-2.9 6.9-7.1 8 4.8.9 8.4 3.3 8.4 8.6 0 8.1-8 9.9-14.2 9.9h-14l-.1-35.5zm12.4 14.8c3.4 0 6.9-.7 6.9-4.8 0-3.7-3.2-4.7-6.4-4.7h-5.4v9.5h4.9zM266 55c3.6 0 7.1-.8 7.1-5.2s-3-5.2-6.7-5.2h-6.1V55h5.7zm35.2 6c-11.5 0-16.6-7.3-16.6-18.2s5.7-18.8 17-18.8c7.1 0 14 3.2 14.2 11.2h-8c-.4-3.6-2.8-5.4-6.2-5.4-7 0-9.1 7.5-9.1 13.2 0 5.7 2.1 12.3 8.8 12.3 3.5 0 6.1-1.9 6.6-5.5h8c-.8 8.2-7.3 11.2-14.7 11.2z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgHsbcreact);

/***/ }),

/***/ 17434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLeedsBuildingSocietyreact = function SvgLeedsBuildingSocietyreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 25,
    "aria-label": "Leeds icon",
    viewBox: "0 0 600 125",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fcd900",
    d: "M0 0h78.5L0 55.3z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#f5b32d",
    d: "M78.5 0H157v55.3z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#182745",
    d: "M567.4 122.6c1.1.8 2.3 1.4 3.5 1.8 1.3.4 2.7.6 4.3.6 2 0 3.7-.4 5.1-1.2 1.3-.8 2.5-1.8 3.4-3.1.9-1.3 1.7-2.7 2.4-4.3.6-1.6 1.3-3.2 2-4.8L600 82.7h-9.5l-6.6 18.4-7.3-18.4h-10.2l13.3 28.8-.9 2.4c-.6 1.4-1.2 2.5-1.8 3.1-.6.6-1.4.9-2.4.9-.7 0-1.4-.1-2-.4-.6-.3-1.1-.6-1.6-1zm-20.5-21.9c0 1.8.2 3.5.6 5 .4 1.5 1 2.8 1.9 3.8.9 1.1 2 1.9 3.4 2.5 1.4.6 3.1.9 5.2.9 3.3 0 6.4-1.1 9.2-3.4l-3.6-5.5c-.6.4-1.2.8-1.9 1.1-.7.3-1.4.5-2.4.5-1.2 0-2.1-.4-2.6-1.1-.6-.8-.8-1.9-.8-3.3V89.7h7.5v-7h-7.5v-8.8H547v8.8h-4.6v7h4.6zm-28-6.5c0-.6.1-1.3.4-1.9.3-.6.7-1.2 1.2-1.8.5-.5 1.2-1 2-1.3.8-.4 1.7-.5 2.7-.5 1 0 1.9.2 2.7.5.7.4 1.4.8 1.9 1.3s.9 1.1 1.1 1.8c.2.6.4 1.3.4 1.9zm16.4 8.8c-.7.5-1.7 1.1-3.2 1.8-1.4.7-3.3 1-5.7 1-2.4 0-4.2-.6-5.6-1.8-1.3-1.2-2-2.6-2.1-4.1h20.7v-1.5c0-2.4-.3-4.7-.9-6.7-.6-2.1-1.5-3.8-2.8-5.3-1.2-1.5-2.7-2.6-4.5-3.4-1.8-.8-3.9-1.2-6.2-1.2-2.4 0-4.5.4-6.3 1.3-1.8.9-3.4 2-4.7 3.4-1.3 1.4-2.3 3.1-3 4.9-.7 1.9-1 3.8-1 5.9 0 2.3.4 4.4 1.1 6.4.7 1.9 1.8 3.6 3.2 4.9 1.4 1.4 3.1 2.4 5.1 3.2 2 .8 4.2 1.1 6.7 1.1 1.9 0 3.5-.2 5-.5 1.4-.4 2.7-.8 3.8-1.2 1.1-.5 1.9-.9 2.6-1.4.7-.5 1.2-.8 1.5-1zm-38.4 8.9h8.9V82.8h-8.9zm-.3-33.5h9.6v-8h-9.6zm-9.2 23.8c-.6.7-1.4 1.4-2.5 2-1 .6-2.3.9-3.9.9-1.1 0-2-.2-2.9-.7-.8-.5-1.6-1-2.2-1.8-.6-.7-1.1-1.6-1.4-2.5-.3-.9-.5-1.9-.5-2.8 0-1 .2-2 .5-3 .3-.9.8-1.7 1.4-2.5.6-.7 1.3-1.3 2.2-1.7.8-.4 1.8-.7 2.9-.7 1.6 0 2.8.3 3.8.9 1 .6 1.8 1.2 2.4 2l5.4-5.8c-1.3-1.5-3-2.6-4.9-3.5-1.9-.9-4.2-1.3-6.9-1.3-2.3 0-4.4.4-6.3 1.2-1.9.8-3.6 1.9-5 3.3s-2.5 3.1-3.3 4.9c-.8 1.9-1.2 3.9-1.2 6.1 0 2.3.4 4.4 1.1 6.3.8 1.9 1.8 3.6 3.2 4.9 1.4 1.4 3 2.5 4.9 3.2 1.9.8 4.1 1.1 6.4 1.1 2.7 0 5-.5 7-1.4 2-1 3.6-2.1 4.8-3.4zm-55.2 1.1c.8 1.9 1.8 3.5 3.2 4.9 1.4 1.4 3 2.5 4.9 3.4 1.9.8 4 1.2 6.4 1.2 2.3 0 4.4-.4 6.3-1.2 1.9-.8 3.5-1.9 4.9-3.4 1.4-1.4 2.4-3.1 3.2-4.9.8-1.9 1.1-3.9 1.1-6.1 0-2.2-.4-4.2-1.1-6.1-.8-1.9-1.8-3.5-3.2-4.9-1.4-1.4-3-2.5-4.9-3.3-1.9-.8-4-1.2-6.3-1.2s-4.4.4-6.4 1.2c-1.9.8-3.6 1.9-4.9 3.3-1.4 1.4-2.4 3.1-3.2 4.9-.8 1.9-1.1 3.9-1.1 6.1 0 2.2.4 4.2 1.1 6.1zm11.5 1.1c-.9-.4-1.6-1-2.2-1.8-.6-.7-1-1.6-1.3-2.5-.3-.9-.5-1.9-.5-2.9s.2-2 .5-2.9c.3-.9.8-1.8 1.3-2.5.6-.7 1.3-1.3 2.2-1.7.9-.4 1.9-.7 3-.7s2.1.2 3 .7c.9.4 1.6 1 2.2 1.7.6.7 1 1.6 1.3 2.5.3.9.4 1.9.4 2.9s-.1 2-.4 2.9c-.3.9-.7 1.8-1.3 2.5-.6.7-1.3 1.3-2.2 1.8-.9.4-1.9.7-3 .7s-2.1-.2-3-.7zm-48.6 1.6c.8.9 1.7 1.7 2.8 2.5 1.1.8 2.3 1.6 3.7 2.2 1.4.6 2.9 1.2 4.6 1.6 1.7.4 3.6.6 5.7.6 2.2 0 4.3-.3 6.2-1 1.9-.6 3.6-1.5 5-2.7 1.4-1.2 2.6-2.5 3.4-4.1.8-1.6 1.2-3.3 1.2-5.2 0-2.2-.4-4-1.1-5.5-.7-1.5-1.6-2.8-2.8-3.8-1.2-1-2.5-1.9-3.9-2.5-1.5-.6-3-1.1-4.5-1.5-2.6-.6-4.7-1.3-6.2-2.2-1.5-.9-2.2-2-2.2-3.4 0-.5.2-1 .5-1.5s.7-.9 1.2-1.2c.5-.4 1.1-.6 1.7-.8.6-.2 1.3-.3 2-.3 1 0 1.9.1 2.8.4.9.2 1.7.6 2.5.9.8.3 1.4.8 2 1.2.6.4 1.1.8 1.6 1.2l5.4-6c-.4-.4-.9-.9-1.6-1.5-.7-.6-1.7-1.3-2.8-1.9-1.1-.6-2.5-1.1-4.1-1.6-1.6-.5-3.5-.7-5.6-.7-2.6 0-4.8.3-6.7 1-1.9.7-3.5 1.6-4.7 2.8-1.3 1.2-2.2 2.5-2.8 4.1-.6 1.5-.9 3.2-.9 4.9 0 1.6.3 3 .8 4.3.5 1.3 1.3 2.4 2.3 3.4 1 1 2.1 1.8 3.5 2.5 1.3.7 2.8 1.2 4.4 1.6 3.2.8 5.6 1.7 7.1 2.5s2.2 2 2.2 3.6c0 .7-.2 1.3-.5 1.9-.4.6-.8 1-1.4 1.4-.6.4-1.2.7-1.9.9-.7.2-1.4.3-2.1.3-1.2 0-2.3-.2-3.4-.5s-2-.7-2.9-1.2c-.9-.5-1.7-1-2.4-1.6-.7-.6-1.4-1.2-1.9-1.8zM373 98.9c0 1.9-.5 3.3-1.5 4.2-1 .9-2.4 1.3-4.2 1.3-1.9 0-3.4-.6-4.4-1.9-1-1.2-1.5-2.9-1.5-5 0-1.1.2-2.1.5-3.1s.8-1.8 1.4-2.5c.6-.7 1.4-1.3 2.4-1.7 1-.4 2.1-.7 3.4-.7 1 0 1.7.1 2.3.2.6.1 1.2.3 1.7.5v8.7zm-18.2 23c1.6 1.1 3.4 1.9 5.3 2.4s4.2.7 6.8.7c4.6 0 8.2-1.2 10.9-3.4 2.6-2.3 4-5.9 4-10.7V84.3c-1.7-.6-3.7-1.1-5.9-1.6s-4.5-.6-6.9-.6c-2.5 0-4.8.4-6.9 1.1-2 .7-3.8 1.8-5.3 3.2-1.5 1.4-2.6 3-3.4 5-.8 1.9-1.2 4.1-1.2 6.4 0 2 .3 3.9.9 5.6.6 1.7 1.5 3.2 2.6 4.4 1.1 1.2 2.5 2.2 4.1 2.9 1.6.7 3.5 1 5.6 1 3.1 0 5.6-.8 7.5-2.4v2c0 2.2-.6 3.8-1.7 4.8-1.2 1.1-2.8 1.6-4.8 1.6-1.6 0-3-.2-4.3-.6-1.3-.4-2.5-.9-3.7-1.6zm-34.8-10h8.9V96.2c0-.9.1-1.7.4-2.5.2-.8.6-1.4 1.1-2 .5-.6 1.1-1 1.9-1.4.7-.4 1.6-.5 2.6-.5 1.4 0 2.6.5 3.4 1.4.8 1 1.2 2.2 1.2 3.9v16.8h8.9v-18c0-3.9-1-6.8-3-8.8-2-2-4.6-3-8-3-1.7 0-3.3.4-4.9 1.1-1.6.7-2.8 1.6-3.8 2.8l-.2-3.2h-8.6v29.1zm-14.6 0h8.9V82.8h-8.9zm-.3-33.5h9.6v-8h-9.6zm-14.2 20.3c0 .8-.1 1.6-.3 2.4-.2.8-.6 1.5-1 2.1-.5.6-1.1 1-1.8 1.4-.7.4-1.6.5-2.6.5-2.1 0-3.6-.7-4.7-2-1-1.3-1.6-3.1-1.6-5.2 0-2.4.6-4.4 1.9-5.9 1.3-1.5 3-2.3 5.3-2.3 1.1 0 2 .1 2.7.2.7.2 1.4.4 2 .8l.1 8zm.6 13.2h8.3V70.5h-8.9v12.7c-.8-.3-1.6-.5-2.4-.7-.8-.2-1.9-.3-3.3-.3-1.7 0-3.5.3-5.3 1-1.8.6-3.4 1.6-4.9 2.9-1.5 1.3-2.7 2.9-3.6 4.9-.9 2-1.4 4.3-1.4 6.9 0 2.3.3 4.4 1 6.2.7 1.8 1.6 3.4 2.7 4.7 1.1 1.3 2.5 2.3 4 3 1.6.7 3.2 1.1 5 1.1 1.8 0 3.4-.4 4.9-1.1 1.4-.7 2.6-1.6 3.5-2.7zm-34.5 0h8.9V70.5H257zm-14.5 0h8.9V82.8h-8.9zm-.3-33.5h9.6v-8h-9.6zm-33.7 22.4c0 3.9 1 6.8 2.9 8.8 1.9 2 4.6 3 8 3 1.7 0 3.3-.4 4.9-1.1 1.6-.7 2.8-1.6 3.8-2.8l.2 3.1h8.6V82.7H228v15.7c0 .8-.1 1.6-.4 2.4-.2.8-.6 1.5-1.1 2.1-.5.6-1.1 1-1.8 1.4-.7.4-1.5.5-2.4.5-1.6 0-2.8-.5-3.6-1.4-.8-1-1.2-2.3-1.2-3.9V82.7h-8.9zm-26.9 3.9V93.9h6.1c.7 0 1.5.1 2.3.2.8.1 1.6.4 2.3.8.7.4 1.3.9 1.7 1.6.5.7.7 1.6.7 2.7 0 1.2-.2 2.2-.7 2.9-.5.7-1.1 1.2-1.8 1.6-.7.4-1.5.6-2.3.7-.8.1-1.6.2-2.2.2h-6.1zm0-17.7v-9.3h5.5c.7 0 1.3.1 2 .2s1.3.4 1.8.7c.5.4 1 .8 1.3 1.4.3.6.5 1.4.5 2.3 0 .9-.2 1.6-.5 2.2-.3.6-.8 1.1-1.3 1.4-.5.4-1.1.6-1.8.8-.7.2-1.4.2-2.1.2h-5.4zm-9.1 24.9H188c2.5 0 4.7-.2 6.7-.7 2-.4 3.7-1.1 5.1-2.1 1.4-1 2.5-2.2 3.2-3.7.8-1.5 1.1-3.3 1.1-5.5 0-1.7-.3-3.1-.9-4.3-.6-1.2-1.3-2.2-2.2-3-.9-.8-1.8-1.4-2.8-1.9-1-.4-1.8-.7-2.6-.9.5-.1 1.1-.4 1.8-.8s1.4-1 2-1.7c.6-.7 1.2-1.6 1.7-2.6s.7-2.2.7-3.5c0-1.4-.2-2.8-.7-4.1-.5-1.3-1.3-2.5-2.4-3.4-1.1-.9-2.6-1.8-4.3-2.4-1.8-.6-4-.9-6.5-.9h-15.5v41.5zm-40.9-3.3c1.4 1.5 3.3 2.5 5.7 3.2 2.3.7 4.8 1.1 7.4 1.1 1.6 0 3.2-.2 4.8-.6 1.6-.4 2.9-.9 4.2-1.7 1.2-.8 2.2-1.7 2.9-2.9.7-1.2 1.1-2.5 1.1-4.2 0-2.4-.7-4.3-2-5.8-1.3-1.4-3.5-2.6-6.5-3.4-2.2-.6-3.9-1.1-5.2-1.6-1.3-.5-1.9-1.2-1.9-2.1 0-.7.3-1.2.9-1.6.6-.4 1.6-.6 3-.6 1.5 0 2.9.2 4.1.7 1.2.5 2.3 1.1 3.3 1.7l3.8-5.9c-1.6-1.1-3.3-1.9-5.2-2.5-1.9-.6-4-.8-6.5-.8-1.7 0-3.4.2-4.9.7-1.5.4-2.8 1.1-3.9 1.9-1.1.8-2 1.8-2.6 2.9-.6 1.1-.9 2.3-.9 3.7 0 1.3.3 2.5.8 3.5s1.2 1.8 2 2.5 1.8 1.3 2.9 1.8c1.1.5 2.2.9 3.3 1.1 1.4.4 2.5.7 3.4 1 .9.3 1.6.6 2.1.8.5.3.8.6 1 .9.2.3.3.7.3 1 0 1-.4 1.6-1.3 1.9-.9.3-2 .5-3.3.5-1.4 0-3-.3-4.5-.9-1.6-.6-2.8-1.3-3.8-2.2zm-12.8-9.9c0 .8-.1 1.6-.3 2.4-.2.8-.6 1.5-1 2.1-.5.6-1.1 1-1.8 1.4-.7.4-1.6.5-2.6.5-2.1 0-3.6-.7-4.7-2-1-1.3-1.6-3.1-1.6-5.2 0-2.4.6-4.4 1.9-5.9 1.3-1.5 3-2.3 5.3-2.3 1.1 0 2 .1 2.7.2.7.2 1.4.4 2 .8l.1 8zm.6 13.2h8.3V70.5h-8.9v12.7c-.8-.3-1.6-.5-2.4-.7-.8-.2-1.9-.3-3.3-.3-1.7 0-3.5.3-5.3 1-1.8.6-3.4 1.6-4.9 2.9-1.5 1.3-2.7 2.9-3.6 4.9-.9 2-1.4 4.3-1.4 6.9 0 2.3.3 4.4 1 6.2.7 1.8 1.6 3.4 2.7 4.7 1.1 1.3 2.5 2.3 4 3 1.6.7 3.2 1.1 5 1.1 1.8 0 3.4-.4 4.9-1.1 1.4-.7 2.6-1.6 3.5-2.7zM73.3 94.2c0-.6.1-1.3.4-1.9.3-.6.7-1.2 1.2-1.8.5-.5 1.2-1 2-1.3.8-.4 1.7-.5 2.7-.5 1 0 1.9.2 2.7.5.7.4 1.4.8 1.9 1.3s.9 1.1 1.1 1.8c.2.6.4 1.3.4 1.9zm16.5 8.8c-.7.5-1.7 1.1-3.2 1.8-1.4.7-3.3 1-5.7 1-2.4 0-4.2-.6-5.6-1.8-1.3-1.2-2-2.6-2.1-4.1h20.9v-1.5c0-2.4-.3-4.7-.9-6.7-.6-2.1-1.5-3.8-2.8-5.3-1.2-1.5-2.7-2.6-4.5-3.4-1.8-.8-3.9-1.2-6.2-1.2-2.4 0-4.5.4-6.3 1.3-1.9.8-3.4 2-4.7 3.4-1.3 1.4-2.3 3.1-3 4.9-.7 1.9-1 3.8-1 5.9 0 2.3.4 4.4 1.1 6.4.7 1.9 1.8 3.6 3.2 4.9 1.4 1.4 3.1 2.4 5.1 3.2 2 .8 4.2 1.1 6.7 1.1 1.9 0 3.5-.2 5-.5 1.4-.4 2.7-.8 3.8-1.2 1.1-.5 1.9-.9 2.6-1.4.7-.5 1.2-.8 1.5-1zm-49.7-8.8c0-.6.1-1.3.4-1.9.3-.6.7-1.2 1.2-1.8.5-.5 1.2-1 2-1.3.8-.4 1.7-.5 2.7-.5 1 0 1.9.2 2.7.5.7.4 1.4.8 1.9 1.3s.9 1.1 1.1 1.8c.2.6.4 1.3.4 1.9zm16.5 8.8c-.7.5-1.7 1.1-3.2 1.8-1.4.7-3.3 1-5.7 1-2.4 0-4.2-.6-5.6-1.8-1.3-1.2-2-2.6-2.1-4.1h20.7v-1.5c0-2.4-.3-4.7-.9-6.7-.6-2.1-1.5-3.8-2.8-5.3-1.2-1.5-2.7-2.6-4.5-3.4-1.8-.8-3.9-1.2-6.2-1.2-2.4 0-4.5.4-6.3 1.3-1.9.8-3.4 2-4.7 3.4-1.3 1.4-2.3 3.1-3 4.9-.7 1.8-1 3.8-1 5.9 0 2.3.4 4.4 1.1 6.4.7 1.9 1.8 3.6 3.2 4.9 1.4 1.4 3.1 2.4 5.1 3.2 2 .8 4.2 1.1 6.7 1.1 1.9 0 3.5-.2 5-.5 1.4-.4 2.7-.8 3.8-1.2 1.1-.5 1.9-.9 2.6-1.4.7-.5 1.2-.8 1.5-1zM0 111.9h29.2v-8.4H9.4V70.4H0z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgLeedsBuildingSocietyreact);

/***/ }),

/***/ 3038:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPreciseMortgagesreact = function SvgPreciseMortgagesreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 34,
    "aria-label": "Precise mortgages icon",
    viewBox: "0 0 319.25 104.828",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#C80045",
    d: "M36.868 11.82h.325c.613 0 .995-.381.995-.995V.996c0-.614-.382-.996-.995-.996h-.325c-.614 0-.996.382-.996.996v9.829c0 .614.382.995.996.995m4.38.355.319.057c.605.106 1.047-.204 1.153-.808l1.707-9.68c.107-.604-.202-1.047-.807-1.153l-.319-.056c-.605-.107-1.047.203-1.153.807l-1.707 9.681c-.107.604.202 1.046.807 1.152m4.253 1.11.305.112c.576.209 1.065-.019 1.276-.595l3.361-9.237c.211-.577-.017-1.067-.595-1.277l-.304-.11c-.577-.211-1.066.018-1.276.595l-3.362 9.237c-.211.576.017 1.066.595 1.275m3.994 1.831.28.163c.533.307 1.054.167 1.36-.365l4.914-8.512c.308-.533.169-1.053-.363-1.361l-.281-.162c-.532-.307-1.053-.166-1.36.365l-4.915 8.513c-.307.532-.167 1.052.365 1.359m3.616 2.498.248.209c.47.394 1.008.347 1.402-.123l6.318-7.53c.396-.471.349-1.008-.122-1.403l-.249-.208c-.47-.395-1.007-.347-1.401.122l-6.319 7.53c-.395.47-.347 1.008.123 1.403m3.127 3.087.209.25c.394.469.931.516 1.401.122l7.53-6.319c.471-.394.518-.932.123-1.402l-.208-.248c-.395-.472-.932-.518-1.404-.122L56.36 19.3c-.47.394-.517.931-.122 1.401m2.544 3.584.162.28c.308.533.829.672 1.36.365l8.512-4.915c.532-.307.672-.828.365-1.36l-.162-.28c-.307-.533-.829-.671-1.36-.365l-8.513 4.916c-.532.306-.671.827-.364 1.359m.162 25.21-.162.281c-.308.532-.168 1.052.364 1.359l8.512 4.914c.532.308 1.053.168 1.361-.363l.162-.282c.307-.53.167-1.052-.365-1.358l-8.513-4.917c-.532-.306-1.052-.166-1.359.366m-2.497 3.615-.209.248c-.395.471-.348 1.008.123 1.402l7.529 6.319c.471.396 1.009.348 1.403-.122l.209-.249c.394-.47.347-1.008-.123-1.402l-7.53-6.318c-.471-.396-1.008-.348-1.402.122m-3.088 3.127-.248.209c-.47.395-.518.932-.123 1.402l6.318 7.53c.395.47.932.518 1.402.122l.249-.208c.471-.395.518-.931.122-1.403l-6.317-7.53c-.396-.469-.933-.516-1.403-.122m-3.583 2.544-.28.163c-.533.307-.672.827-.366 1.359l4.916 8.512c.307.532.828.672 1.359.366l.281-.163c.533-.308.672-.829.364-1.359l-4.914-8.514c-.308-.532-.829-.671-1.36-.364m-3.971 1.883-.305.112c-.577.209-.805.697-.595 1.275l3.362 9.235c.21.578.699.808 1.276.596l.305-.11c.577-.211.805-.7.595-1.276l-3.362-9.238c-.21-.576-.699-.803-1.276-.594m-4.237 1.165-.319.057c-.605.106-.914.547-.808 1.151l1.707 9.681c.107.605.548.914 1.153.808l.32-.057c.605-.107.913-.549.807-1.153l-1.707-9.681c-.107-.604-.548-.912-1.153-.806m-4.375.411h-.325c-.613 0-.995.381-.995.995v9.829c0 .615.382.996.995.996h.325c.614 0 .996-.381.996-.996v-9.829c0-.614-.382-.995-.996-.995m-4.381-.354-.319-.057c-.605-.106-1.047.203-1.153.808l-1.707 9.679c-.107.605.202 1.047.808 1.154l.319.056c.605.106 1.047-.203 1.153-.807l1.707-9.681c.107-.604-.202-1.046-.808-1.152m-4.252-1.11-.305-.112c-.577-.209-1.065.019-1.276.595l-3.361 9.237c-.211.576.017 1.066.595 1.277l.304.11c.577.211 1.066-.019 1.276-.596l3.362-9.236c.21-.578-.018-1.066-.595-1.275m-3.994-1.832-.281-.163c-.532-.307-1.053-.168-1.36.365l-4.914 8.512c-.307.531-.168 1.053.364 1.359l.281.164c.532.307 1.052.166 1.359-.366l4.916-8.512c.306-.532.167-1.052-.365-1.359m-3.616-2.498-.249-.209c-.47-.394-1.007-.347-1.401.123l-6.318 7.53c-.396.471-.349 1.008.122 1.402l.248.209c.47.395 1.008.347 1.403-.122l6.318-7.53c.395-.471.347-1.008-.123-1.403m-3.127-3.088-.209-.248c-.394-.47-.932-.518-1.401-.122l-7.53 6.318c-.471.394-.519.931-.123 1.402l.207.248c.396.472.933.518 1.404.122l7.53-6.317c.469-.395.517-.932.122-1.403m-2.544-3.582-.162-.281c-.308-.532-.828-.672-1.36-.365l-8.512 4.916c-.532.307-.672.828-.365 1.359l.162.281c.308.532.828.672 1.36.363l8.513-4.914c.532-.306.671-.827.364-1.359m-1.883-3.972-.111-.305c-.209-.577-.699-.805-1.275-.594l-9.237 3.361c-.577.211-.806.699-.595 1.277l.11.304c.211.577.7.806 1.277.595l9.237-3.361c.577-.211.804-.699.594-1.277m-1.164-4.237-.057-.319c-.106-.605-.548-.914-1.152-.808l-9.68 1.707c-.605.107-.915.548-.809 1.153l.057.321c.107.604.549.913 1.154.806l9.681-1.707c.604-.107.912-.548.806-1.153m-.411-4.375v-.324c0-.614-.381-.996-.995-.996H.996c-.614 0-.996.382-.996.996v.324c0 .615.382.996.996.996h9.83c.614 0 .995-.381.995-.996m.354-4.38.057-.319c.106-.605-.203-1.048-.808-1.153l-9.679-1.707c-.605-.107-1.048.202-1.154.807l-.057.32c-.106.604.204 1.047.808 1.153l9.681 1.707c.604.107 1.046-.202 1.152-.808m1.11-4.252.111-.305c.21-.577-.018-1.066-.595-1.276l-9.236-3.361c-.578-.211-1.066.017-1.277.595l-.111.304c-.21.577.019 1.065.596 1.276l9.237 3.361c.576.211 1.066-.017 1.275-.594m1.832-3.995.162-.28c.308-.533.168-1.053-.364-1.36L6.403 18.01c-.533-.307-1.053-.168-1.361.364l-.162.281c-.307.532-.167 1.053.365 1.359l8.513 4.916c.532.306 1.052.167 1.359-.365m2.497-3.615.209-.25c.395-.469.347-1.006-.123-1.4l-7.53-6.319c-.47-.395-1.008-.348-1.403.123l-.208.248c-.394.469-.347 1.008.123 1.402l7.53 6.318c.47.395 1.007.348 1.402-.122m3.087-3.127.249-.209c.47-.395.517-.933.123-1.402l-6.319-7.53c-.394-.47-.932-.518-1.402-.122l-.248.207c-.472.396-.518.932-.123 1.404l6.318 7.53c.395.469.932.517 1.402.122m3.584-2.544.281-.163c.532-.307.671-.828.365-1.359l-4.915-8.513c-.308-.531-.828-.671-1.36-.365l-.281.162c-.532.309-.671.829-.363 1.36l4.914 8.513c.306.532.827.672 1.359.365m3.971-1.883.305-.112c.576-.209.804-.698.595-1.275l-3.362-9.237c-.21-.576-.699-.805-1.277-.594l-.304.11c-.577.21-.805.7-.595 1.276l3.362 9.238c.209.576.698.803 1.276.594m4.237-1.165.319-.057c.605-.106.914-.547.808-1.152l-1.707-9.679c-.107-.606-.548-.915-1.153-.809l-.32.057c-.605.107-.914.549-.807 1.153l1.707 9.681c.106.604.548.912 1.153.806"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0A0D3D",
    d: "M67.635 42.587h.325c.613 0 .995-.381.995-.995v-9.83c0-.614-.382-.996-.995-.996h-.325c-.614 0-.996.382-.996.996v9.83c0 .614.382.995.996.995m4.38.355.319.057c.605.106 1.047-.204 1.153-.808l1.707-9.68c.107-.605-.202-1.047-.807-1.154l-.319-.057c-.605-.106-1.047.205-1.153.808l-1.707 9.681c-.107.604.202 1.047.807 1.153m4.252 1.11.305.11c.576.211 1.065-.017 1.276-.594l3.361-9.236c.211-.578-.017-1.066-.595-1.277l-.304-.111c-.577-.21-1.066.018-1.276.596l-3.362 9.237c-.211.576.018 1.064.595 1.275m3.995 1.831.28.161c.533.308 1.054.169 1.361-.363l4.914-8.512c.307-.533.168-1.054-.364-1.361l-.281-.162c-.532-.308-1.053-.167-1.359.364l-4.916 8.513c-.307.532-.167 1.053.365 1.36m3.616 2.497.248.209c.471.395 1.008.347 1.402-.123l6.319-7.53c.395-.469.348-1.008-.123-1.402l-.248-.209c-.471-.394-1.008-.347-1.402.124l-6.319 7.529c-.396.471-.347 1.008.123 1.402m3.127 3.088.209.248c.395.471.932.518 1.401.124l7.53-6.319c.471-.395.518-.932.123-1.403l-.208-.248c-.395-.471-.932-.517-1.403-.122l-7.53 6.317c-.469.395-.517.932-.122 1.403m2.543 3.583.162.282c.308.531.829.671 1.36.364l8.512-4.915c.532-.308.672-.828.365-1.36l-.162-.28c-.307-.533-.829-.672-1.36-.365l-8.513 4.915c-.532.306-.671.828-.364 1.359m1.884 3.971.111.305c.209.577.698.805 1.275.595l9.236-3.362c.578-.209.806-.699.596-1.275l-.11-.306c-.211-.576-.7-.804-1.277-.595l-9.237 3.363c-.577.209-.804.698-.594 1.275m1.164 4.237.057.319c.106.605.548.914 1.152.808l9.68-1.707c.605-.107.915-.548.809-1.153l-.057-.319c-.107-.606-.549-.914-1.154-.808l-9.681 1.707c-.604.107-.912.547-.806 1.153m.411 4.375v.325c0 .613.381.995.995.995h9.83c.614 0 .996-.382.996-.995v-.325c0-.614-.382-.995-.996-.995h-9.83c-.614 0-.995.381-.995.995m-.355 4.38-.057.32c-.106.604.204 1.047.808 1.153l9.68 1.707c.605.107 1.047-.202 1.153-.808l.057-.318c.106-.606-.204-1.047-.808-1.154l-9.68-1.706c-.605-.108-1.047.202-1.153.806m-1.11 4.253-.111.305c-.21.576.018 1.065.595 1.275l9.236 3.362c.577.21 1.066-.018 1.277-.595l.111-.305c.209-.576-.019-1.066-.597-1.275l-9.236-3.363c-.577-.21-1.066.018-1.275.596m-1.831 3.994-.162.28c-.308.533-.168 1.054.364 1.361l8.512 4.914c.532.307 1.053.168 1.361-.364l.162-.281c.307-.532.167-1.053-.365-1.359l-8.513-4.916c-.532-.306-1.052-.167-1.359.365m-2.497 3.617-.209.248c-.394.471-.347 1.008.123 1.402l7.53 6.318c.47.395 1.008.349 1.403-.122l.208-.248c.394-.471.347-1.008-.123-1.403l-7.53-6.318c-.47-.395-1.008-.348-1.402.123m-3.088 3.127-.248.209c-.47.394-.518.931-.123 1.4l6.318 7.531c.395.471.932.518 1.403.123l.248-.208c.471-.395.518-.933.122-1.403l-6.317-7.53c-.395-.469-.932-.517-1.403-.122m-3.584 2.543-.28.161c-.533.308-.672.829-.366 1.36l4.916 8.513c.307.532.828.672 1.359.365l.281-.162c.533-.308.671-.829.364-1.361l-4.914-8.513c-.307-.531-.828-.67-1.36-.363m-3.97 1.882-.305.112c-.577.209-.805.698-.595 1.275l3.362 9.237c.21.576.699.806 1.276.595l.305-.111c.577-.21.805-.699.595-1.276l-3.362-9.238c-.21-.576-.699-.803-1.276-.594m-4.237 1.165-.319.057c-.605.106-.914.547-.808 1.153l1.707 9.679c.107.605.548.916 1.153.809l.32-.056c.605-.107.913-.549.807-1.155l-1.707-9.681c-.107-.604-.549-.912-1.153-.806m-4.376.412h-.325c-.614 0-.995.381-.995.995v9.83c0 .613.381.996.995.996h.325c.614 0 .996-.383.996-.996v-9.83c0-.614-.382-.995-.996-.995m-4.38-.355-.319-.057c-.606-.106-1.047.203-1.153.808l-1.707 9.679c-.107.606.202 1.048.807 1.155l.319.057c.605.106 1.047-.205 1.153-.809l1.707-9.68c.107-.605-.202-1.047-.807-1.153m-4.252-1.11-.305-.112c-.576-.209-1.066.019-1.276.596l-3.361 9.236c-.211.578.017 1.066.595 1.277l.304.111c.577.21 1.066-.019 1.276-.596l3.362-9.237c.21-.576-.018-1.066-.595-1.275m-3.994-1.832-.28-.161c-.533-.308-1.054-.169-1.361.363l-4.914 8.512c-.307.533-.169 1.054.364 1.361l.281.162c.531.308 1.053.167 1.359-.364l4.915-8.514c.307-.531.168-1.052-.364-1.359m-3.616-2.497-.249-.209c-.47-.395-1.007-.347-1.401.123l-6.318 7.53c-.396.469-.348 1.008.122 1.402l.248.209c.47.394 1.008.347 1.402-.124l6.319-7.53c.395-.47.347-1.006-.123-1.401m-3.127-3.087-.209-.248c-.394-.471-.932-.518-1.401-.124l-7.53 6.319c-.471.395-.518.932-.124 1.403l.209.248c.395.47.932.517 1.403.122l7.53-6.317c.469-.395.517-.932.122-1.403m-2.544-3.584-.162-.28c-.308-.533-.828-.671-1.36-.365l-8.512 4.915c-.532.307-.672.828-.365 1.36l.162.28c.308.533.828.672 1.36.365l8.513-4.914c.532-.308.671-.829.364-1.361m-.162-25.209.162-.282c.308-.531.168-1.052-.364-1.359l-8.512-4.914c-.533-.307-1.053-.168-1.361.364l-.162.281c-.307.532-.167 1.051.365 1.359l8.513 4.915c.532.307 1.052.168 1.359-.364m2.497-3.617.209-.248c.395-.471.347-1.008-.123-1.402l-7.53-6.318c-.47-.395-1.008-.348-1.403.122l-.209.248c-.393.471-.346 1.008.124 1.403l7.53 6.318c.47.395 1.007.348 1.402-.123m3.087-3.127.249-.209c.47-.394.517-.931.123-1.401l-6.319-7.529c-.394-.472-.932-.519-1.402-.124l-.248.208c-.471.395-.518.933-.123 1.403l6.318 7.53c.395.469.932.517 1.402.122m3.584-2.544.28-.161c.533-.308.672-.83.365-1.36l-4.915-8.513c-.307-.532-.828-.672-1.359-.364l-.281.161c-.533.308-.671.829-.365 1.361l4.915 8.513c.307.531.828.67 1.36.363m3.971-1.883.305-.11c.576-.211.804-.699.595-1.276l-3.362-9.236c-.21-.578-.699-.806-1.276-.596l-.305.111c-.577.21-.805.699-.595 1.277l3.362 9.236c.209.577.699.805 1.276.594m4.237-1.164.319-.057c.605-.106.914-.549.808-1.153l-1.707-9.68c-.107-.604-.548-.915-1.153-.808l-.32.056c-.605.107-.913.549-.807 1.155l1.707 9.68c.107.605.547.913 1.153.807"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#C80045",
    d: "M121.687 67.553c.04-.6.4-.92 1-.92h1.08c.6 0 .96.24 1.16.76l7.038 15.758c.64 1.439 1.4 3.439 1.4 3.439h.08s.72-2 1.36-3.439l7.039-15.758c.239-.52.56-.76 1.159-.76h1.08c.6 0 .96.32 1 .92l2.12 26.155c.04.68-.28 1.04-.96 1.04h-.8c-.6 0-.96-.32-1-.92l-1.48-18.756c-.119-1.52-.119-3.919-.119-3.919h-.08s-.8 2.479-1.44 3.919l-6.319 13.677c-.2.52-.56.76-1.12.76h-.96c-.6 0-.96-.24-1.159-.76l-6.28-13.677c-.599-1.4-1.479-3.999-1.479-3.999h-.08s0 2.479-.12 3.999l-1.48 18.756c-.04.6-.4.92-1 .92h-.8c-.68 0-1-.36-.96-1.04l2.12-26.155zm39.278 6.598c5.879 0 10.638 4.48 10.638 10.439 0 6.079-4.759 10.637-10.598 10.637-5.879 0-10.638-4.558-10.638-10.637 0-5.959 4.759-10.439 10.598-10.439m.04 18.637c4.279 0 7.799-3.52 7.799-8.198 0-4.56-3.52-7.999-7.799-7.999-4.319 0-7.839 3.439-7.839 7.999 0 4.678 3.52 8.198 7.839 8.198m14.162-17.157c0-.64.36-.999 1-.999h.72c.599 0 .959.359.959.999v2.72c0 .88-.159 1.599-.159 1.599h.08c.959-2.919 3.279-5.438 6.479-5.438.719 0 1.039.319 1.039.96v.72c0 .639-.44 1-1.119 1-4.24 0-6.28 4.838-6.28 9.038v7.518c0 .64-.32 1-.959 1h-.76c-.64 0-1-.36-1-1V75.631zm13.119 1.44h-1.68c-.64 0-.96-.32-.96-.96v-.32c0-.64.32-1 .96-1h1.72v-4.719c0-.64.36-1 1-1h.72c.639 0 .96.36.96 1v4.719h4.079c.639 0 1 .36 1 1v.32c0 .64-.361.96-1 .96h-4.079v10.078c0 4.639 2.839 5.199 4.399 5.279.799.081 1.08.32 1.08 1v.52c0 .64-.321.96-1.12.96-4.399 0-7.079-2.68-7.079-7.399V77.071zm13.16 22.596c.88.401 2.439 1.04 4.679 1.04 3.719 0 6.919-1.839 6.919-6.319v-2.079c0-.76.12-1.439.12-1.439h-.08c-1.2 2.279-3.24 3.758-6.399 3.758-5.399 0-8.958-4.239-8.958-10.438 0-5.919 3.279-10.038 8.878-10.038 5.199 0 6.559 3.679 6.559 3.679h.08s-.08-.28-.08-.679v-1.64c0-.52.32-.88.96-.88h.64c.639 0 .999.36.999.999v18.638c0 6.398-4.759 8.878-9.558 8.878-2.079 0-4.12-.44-5.799-1.199-.6-.281-.76-.681-.48-1.281l.24-.559c.28-.521.64-.68 1.28-.441m11.638-15.277c0-5.959-2.88-7.799-6.239-7.799-4.079 0-6.319 2.88-6.319 7.519 0 5.04 2.6 8.079 6.559 8.079 3.199 0 5.999-1.96 5.999-7.799m18.201-1.961h1.16v-.639c0-3.879-2.12-5.199-4.959-5.199-2.24 0-3.96.839-4.88 1.4-.559.279-.999.199-1.359-.32l-.24-.401c-.32-.519-.24-1.039.279-1.359 1.041-.64 3.28-1.76 6.399-1.76 4.8 0 7.479 2.68 7.479 7.719v11.878c0 .639-.319 1-.96 1h-.639c-.64 0-1-.321-1-1v-1.6c0-.92.12-1.519.12-1.519h-.08c.04 0-1.8 4.598-6.799 4.598-3.399 0-6.799-1.999-6.799-5.879 0-6.558 8.399-6.919 12.278-6.919m-4.999 10.519c3.879 0 6.159-3.999 6.159-7.519v-.96h-1.12c-3.16 0-9.518.121-9.518 4.64 0 1.879 1.479 3.839 4.479 3.839m16.039 6.719c.88.401 2.441 1.04 4.68 1.04 3.72 0 6.919-1.839 6.919-6.319v-2.079c0-.76.12-1.439.12-1.439h-.08c-1.2 2.279-3.239 3.758-6.399 3.758-5.399 0-8.958-4.239-8.958-10.438 0-5.919 3.279-10.038 8.878-10.038 5.199 0 6.559 3.679 6.559 3.679h.08s-.08-.28-.08-.679v-1.64c0-.52.319-.88.96-.88h.64c.639 0 1 .36 1 .999v18.638c0 6.398-4.76 8.878-9.559 8.878-2.08 0-4.119-.44-5.799-1.199-.6-.281-.76-.681-.48-1.281l.24-.559c.28-.521.64-.68 1.279-.441m11.639-15.277c0-5.959-2.88-7.799-6.239-7.799-4.079 0-6.319 2.88-6.319 7.519 0 5.04 2.6 8.079 6.559 8.079 3.199 0 5.999-1.96 5.999-7.799m16.239-10.239c5.36 0 8.399 3.88 8.399 9.599 0 .56-.44 1-1.039 1h-14.478c.12 5.119 3.639 8.038 7.799 8.038 2.52 0 4.358-1.119 5.278-1.84.561-.359 1-.279 1.321.241l.319.48c.28.479.2.959-.279 1.319-1.08.8-3.48 2.24-6.719 2.24-5.999 0-10.519-4.32-10.519-10.518 0-6.599 4.48-10.559 9.918-10.559m5.64 8.559c-.16-4.239-2.72-6.318-5.72-6.318-3.359 0-6.278 2.239-6.918 6.318h12.638zm5.082 8.839.319-.4c.361-.48.801-.52 1.361-.161.88.681 2.719 1.84 5.319 1.84 2.239 0 4.079-1.119 4.079-3.239 0-4.52-10.759-3.159-10.759-9.798 0-3.72 3.16-5.639 6.839-5.639 2.88 0 4.68 1.04 5.52 1.639.519.32.599.8.28 1.32l-.28.44c-.321.56-.8.6-1.36.28-.76-.52-2.2-1.28-4.319-1.28-2.12 0-3.96.92-3.96 3.12 0 4.639 10.719 3.159 10.719 9.878 0 3.319-2.8 5.679-6.799 5.679-3.52 0-5.8-1.48-6.799-2.32-.48-.359-.52-.839-.16-1.359"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0A0D3D",
    d: "M119.048 6.843c0-1.12.56-1.751 1.68-1.751h15.332c8.821 0 15.191 5.741 15.191 14.842 0 9.171-6.37 15.052-15.191 15.052h-12.181v17.572c0 1.12-.631 1.75-1.68 1.75h-1.471c-1.12 0-1.68-.63-1.68-1.75V6.843zm16.382 23.802c6.581 0 10.851-3.99 10.851-10.711 0-6.651-4.27-10.501-10.781-10.501h-11.621v21.212h11.551zm20.928-9.801c0-1.12.63-1.75 1.75-1.75h1.26c1.051 0 1.68.63 1.68 1.75v4.76c0 1.541-.28 2.801-.28 2.801h.14c1.68-5.111 5.741-9.521 11.342-9.521 1.26 0 1.82.56 1.82 1.68v1.26c0 1.12-.77 1.75-1.961 1.75-7.42 0-10.991 8.471-10.991 15.822v13.161c0 1.12-.56 1.75-1.68 1.75h-1.33c-1.12 0-1.75-.63-1.75-1.75V20.844zm35.492-2.59c9.381 0 14.701 6.79 14.701 16.801 0 .98-.769 1.75-1.82 1.75h-25.343c.21 8.961 6.371 14.073 13.652 14.073 4.41 0 7.63-1.961 9.241-3.222.98-.629 1.75-.489 2.31.421l.56.84c.49.84.35 1.68-.49 2.31-1.89 1.401-6.09 3.921-11.761 3.921-10.501 0-18.412-7.561-18.412-18.413 0-11.551 7.84-18.481 17.362-18.481m9.871 14.981c-.28-7.421-4.761-11.061-10.011-11.061-5.881 0-10.991 3.92-12.112 11.061h22.123zm27.158-14.981c6.021 0 9.941 2.59 11.691 3.99.84.631.911 1.47.21 2.381l-.49.77c-.63.98-1.4.98-2.38.35-1.54-1.19-4.621-3.22-8.891-3.22-7.701 0-13.721 5.81-13.721 14.211 0 8.331 6.02 14.142 13.791 14.142 4.9 0 8.261-2.311 9.941-3.711.911-.7 1.68-.56 2.31.42l.49.7c.561.91.351 1.68-.42 2.381-1.82 1.47-6.02 4.481-12.531 4.481-10.501 0-18.481-7.492-18.481-18.413 0-10.851 8.05-18.482 18.481-18.482m18.898-8.891v-2.52c0-1.121.56-1.751 1.68-1.751h1.75c1.12 0 1.681.63 1.681 1.751v2.52c0 1.12-.561 1.68-1.681 1.68h-1.75c-1.12 0-1.68-.56-1.68-1.68m.14 11.481c0-1.12.63-1.75 1.75-1.75h1.33c1.12 0 1.681.63 1.681 1.75v31.713c0 1.12-.561 1.75-1.681 1.75h-1.33c-1.12 0-1.75-.63-1.75-1.75V20.844zm11.34 27.863.56-.7c.629-.84 1.4-.91 2.379-.28 1.541 1.19 4.761 3.22 9.312 3.22 3.92 0 7.141-1.96 7.141-5.67 0-7.911-18.832-5.531-18.832-17.152 0-6.511 5.53-9.871 11.971-9.871 5.04 0 8.191 1.82 9.661 2.87.91.56 1.05 1.4.49 2.311l-.49.77c-.56.98-1.4 1.049-2.38.489-1.331-.909-3.851-2.24-7.561-2.24s-6.931 1.61-6.931 5.461c0 8.121 18.762 5.53 18.762 17.292 0 5.811-4.9 9.941-11.901 9.941-6.16 0-10.151-2.59-11.902-4.06-.84-.631-.91-1.471-.279-2.381m45.292-30.453c9.381 0 14.701 6.79 14.701 16.801 0 .98-.769 1.75-1.82 1.75h-25.343c.21 8.961 6.371 14.073 13.651 14.073 4.411 0 7.631-1.961 9.242-3.222.98-.629 1.75-.489 2.31.421l.56.84c.49.84.35 1.68-.49 2.31-1.89 1.401-6.09 3.921-11.761 3.921-10.501 0-18.412-7.561-18.412-18.413 0-11.551 7.84-18.481 17.362-18.481m9.871 14.981c-.28-7.421-4.761-11.061-10.012-11.061-5.88 0-10.991 3.92-12.111 11.061h22.123z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPreciseMortgagesreact);

/***/ }),

/***/ 71718:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSantanderreact = function SvgSantanderreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 20,
    "aria-label": "Santander icon",
    viewBox: "0 0 240.5 45.5",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#ea1d25",
    d: "M31.5 19.5c-.1-1.5-.5-3-1.3-4.3L23.4 3.3c-.5-.9-.9-1.9-1.1-2.9l-.3.5c-1.7 2.9-1.7 6.6 0 9.5l5.5 9.5c1.7 2.9 1.7 6.6 0 9.5l-.3.5c-.2-1-.6-2-1.1-2.9l-5-8.7-3.2-5.6c-.5-.9-.9-1.9-1.1-2.9l-.3.5c-1.7 2.9-1.7 6.5 0 9.5l5.5 9.5c1.7 2.9 1.7 6.6 0 9.5l-.3.5c-.2-1-.6-2-1.1-2.9l-6.9-11.9c-.9-1.6-1.3-3.4-1.3-5.2C5.1 21.2 0 25.3 0 30c0 6.6 9.8 11.9 21.9 11.9 12.1 0 21.9-5.3 21.9-11.9.1-4.5-4.9-8.6-12.3-10.5zm20.7 20.3c.1-1.7.3-2.8.8-4.2 2.3 1.1 5.3 1.6 7.5 1.6 3.8 0 6-1.2 6-3.7 0-2.4-1.6-3.5-5.4-5.2l-2.1-.8c-3.9-1.7-6.5-3.9-6.5-8.2 0-4.7 3.3-7.7 9.9-7.7 2.7 0 5.2.4 7.5 1.2-.1 1.6-.4 2.9-.8 4.1-2.2-.8-4.9-1.2-6.8-1.2-3.6 0-5.2 1.4-5.2 3.6 0 2.1 1.6 3.4 4.5 4.6l2.2.9c5.2 2.2 7.4 4.6 7.4 8.6 0 4.7-3.6 8-10.6 8-3.3 0-6.1-.5-8.4-1.6zm41.1-19.7v20.6h-4.2l-.2-2.5c-1.2 1.8-2.9 3-5.8 3-5.4 0-9.1-4-9.1-10.9 0-7.2 3.9-11.4 11.5-11.4 3 .1 5.5.4 7.8 1.2zM88.8 36V23.1c-.9-.2-2-.2-3.3-.2-4.7 0-6.9 2.9-6.9 7.5 0 4.2 1.7 7.2 5.7 7.2 1.9-.1 3.3-.7 4.5-1.6zm27.7-9.1v13.8H112v-13c0-3.3-1.1-4.8-5.6-4.8-1.1 0-2.3.1-3.6.3v17.5h-4.5V20.1c2.9-.7 6.1-1.2 8.2-1.2 7.6.1 10 3 10 8zm12.6 10.5c1.3 0 2.6-.2 3.5-.6-.1 1.2-.3 2.6-.5 3.8-1.2.5-2.6.7-3.8.7-4.4 0-7.2-2-7.2-7V12.6c1.4-.5 3.1-.7 4.5-.7v7.8h7.2c-.1 1.4-.2 2.7-.4 3.9h-6.8v10.1c0 2.6 1.3 3.7 3.5 3.7zm24.3-17.3v20.6h-4.2l-.2-2.5c-1.2 1.8-2.9 3-5.8 3-5.4 0-9.1-4-9.1-10.9 0-7.2 3.9-11.4 11.5-11.4 3 .1 5.4.4 7.8 1.2zM148.8 36V23.1c-.9-.2-2-.2-3.3-.2-4.7 0-6.9 2.9-6.9 7.5 0 4.2 1.7 7.2 5.7 7.2 1.9-.1 3.4-.7 4.5-1.6zm27.8-9.1v13.8H172v-13c0-3.3-1.1-4.8-5.6-4.8-1.1 0-2.3.1-3.6.3v17.5h-4.5V20.1c2.9-.7 6.1-1.2 8.2-1.2 7.6.1 10.1 3 10.1 8zm22.9-15v28.8h-4.2l-.2-2.6c-1.2 1.9-2.9 3.1-5.9 3.1-5.4 0-9.1-4-9.1-10.9 0-7.2 3.9-11.4 11.5-11.4 1.2 0 2.3.1 3.4.3v-6.8c1.4-.4 3-.5 4.5-.5zM195 36V23.3c-1.2-.2-2.4-.4-3.6-.4-4.5 0-6.6 2.8-6.6 7.5 0 4.2 1.7 7.2 5.7 7.2 1.8-.1 3.3-.7 4.5-1.6zm27.3-4.1h-14.5c.6 3.7 2.7 5.4 6.8 5.4 2.5 0 5-.5 7.2-1.6-.2 1.2-.4 2.8-.7 4.1-2.1.9-4.2 1.3-6.7 1.3-7.6 0-11.2-4.2-11.2-11.2 0-6.1 2.8-11 10-11 6.5 0 9.3 4.2 9.3 9.4 0 1.4 0 2.4-.2 3.6zm-14.5-3.8H218c0-3.4-1.8-5.4-4.9-5.4-3.3.1-5 1.9-5.3 5.4zm30.4-8.9c0 1.4-.2 3-.4 3.9-1.1-.1-2.1-.2-3.4-.2-1.1 0-2.2.1-3.3.2v17.6h-4.5V20.1c1.9-.7 5.2-1.2 7.7-1.2 1.3.1 2.9.1 3.9.3z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSantanderreact);

/***/ }),

/***/ 67414:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTogetherreact = function SvgTogetherreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 26,
    "aria-label": "Together icon",
    viewBox: "0 0 160 41.48",
    role: "img"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".cls-2{fill:#3f2c59}"))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#f9b114",
    d: "M160 24.07a3.37 3.37 0 1 1-3.37-3.37 3.36 3.36 0 0 1 3.37 3.37"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M26 22.83a5.06 5.06 0 1 1 5.05-5.06A5 5 0 0 1 26 22.83m0-15.37a10.31 10.31 0 1 0 10.35 10.31A10.31 10.31 0 0 0 26 7.46m48.14 8.31a3.47 3.47 0 0 0-.24-1.25 3.52 3.52 0 0 0-.72-1.16 3.64 3.64 0 0 0-1.24-.88 4 4 0 0 0-1.77-.36 4.25 4.25 0 0 0-1.8.36 3.77 3.77 0 0 0-1.29.88 3.42 3.42 0 0 0-.76 1.16 3.73 3.73 0 0 0-.32 1.25zm5.18 9.59c-.2.12-.56.36-1 .68a7.55 7.55 0 0 1-1.72.92 13.79 13.79 0 0 1-2.49.8 13.52 13.52 0 0 1-3.29.36 12.08 12.08 0 0 1-4.45-.76A9.68 9.68 0 0 1 63 25.24 9.36 9.36 0 0 1 60.9 22a12 12 0 0 1-.72-4.22 11.75 11.75 0 0 1 .68-3.89 9 9 0 0 1 2-3.25A9.39 9.39 0 0 1 66 8.39a10 10 0 0 1 4.21-.85 9.75 9.75 0 0 1 4.09.81 8.71 8.71 0 0 1 3 2.28 10.37 10.37 0 0 1 1.85 3.49 15.82 15.82 0 0 1 .6 4.46v1H66a3.72 3.72 0 0 0 1.36 2.73A5.51 5.51 0 0 0 71 23.47a9 9 0 0 0 3.73-.68 11.46 11.46 0 0 0 2.09-1.17zM98.09 0H104v10a6.58 6.58 0 0 1 2.53-1.73 8.74 8.74 0 0 1 3.17-.6 7.23 7.23 0 0 1 5.34 2 7.92 7.92 0 0 1 2 5.86V27.4h-5.9v-11a3.72 3.72 0 0 0-.88-2.65 2.88 2.88 0 0 0-2.29-1 3.71 3.71 0 0 0-1.68.36 3.59 3.59 0 0 0-1.24.92 4 4 0 0 0-.73 1.33 5.35 5.35 0 0 0-.24 1.6v10.4h-5.95V0zm34.71 15.77a3.47 3.47 0 0 0-.24-1.25 3.52 3.52 0 0 0-.72-1.16 3.79 3.79 0 0 0-1.25-.88 4 4 0 0 0-1.76-.36 4.27 4.27 0 0 0-1.81.36 3.82 3.82 0 0 0-1.28.88 3.61 3.61 0 0 0-.77 1.16 3.73 3.73 0 0 0-.28 1.25zm5.2 9.59c-.2.12-.56.36-1 .68a7.55 7.55 0 0 1-1.72.92 14.33 14.33 0 0 1-2.49.8 13.58 13.58 0 0 1-3.29.36 12 12 0 0 1-4.45-.76 9.72 9.72 0 0 1-3.38-2.12 9.33 9.33 0 0 1-2.11-3.24 12 12 0 0 1-.72-4.22 11.75 11.75 0 0 1 .68-3.89 9.46 9.46 0 0 1 5.09-5.49 10 10 0 0 1 4.22-.85 9.78 9.78 0 0 1 4.09.81 8.81 8.81 0 0 1 3 2.28 10.36 10.36 0 0 1 1.84 3.49 15.82 15.82 0 0 1 .6 4.46v1h-13.75a3.73 3.73 0 0 0 1.39 2.72 5.49 5.49 0 0 0 3.69 1.16 9 9 0 0 0 3.73-.68 11.83 11.83 0 0 0 2.09-1.17zm2.62-17.22h5.9v2.41a8.42 8.42 0 0 1 2-1.88 5.7 5.7 0 0 1 3.37-.93 11.67 11.67 0 0 1 1.32.08 5.37 5.37 0 0 1 1.08.28l-1 5.22a6.83 6.83 0 0 0-2.13-.28 4.73 4.73 0 0 0-3.41 1.24 4.82 4.82 0 0 0-1.28 3.57v9.55h-5.94V8.14z",
    className: "cls-2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.05 13H0V8.39h3.05V2.57H9v5.82h5V13H9v7.62a3.78 3.78 0 0 0 .56 2.17 2 2 0 0 0 1.76.76 3.75 3.75 0 0 0 1.57-.32 7.69 7.69 0 0 0 1.24-.72l2.37 3.61a9.55 9.55 0 0 1-6.1 2.21 8.73 8.73 0 0 1-3.45-.61 6.05 6.05 0 0 1-2.25-1.64 6.25 6.25 0 0 1-1.24-2.53 14.05 14.05 0 0 1-.36-3.29zm80.28 0h-3V8.39h3V2.57h5.94v5.82h5V13h-5v7.62a3.78 3.78 0 0 0 .56 2.17 2 2 0 0 0 1.76.76 3.75 3.75 0 0 0 1.57-.32 7.69 7.69 0 0 0 1.24-.72l2.37 3.61a9.55 9.55 0 0 1-6.1 2.21 8.73 8.73 0 0 1-3.45-.61 6.05 6.05 0 0 1-2.22-1.6 6.25 6.25 0 0 1-1.24-2.53 14.05 14.05 0 0 1-.36-3.29V13zm-31.7 8.22a4.81 4.81 0 0 1-8.22-3.41 4.82 4.82 0 1 1 9.63 0 4.62 4.62 0 0 1-1.41 3.41m7.07-3.37a10.6 10.6 0 0 0-1.29-5l-.12-.2v-.08l3.37-3.85L57 5.06l-3.68 3.65a10.46 10.46 0 0 0-15.57 9.14A10.56 10.56 0 0 0 41.56 26a11.83 11.83 0 0 0 5.1 2.36 16.75 16.75 0 0 0 1.85.25 3.93 3.93 0 0 1 1.2.24 3.7 3.7 0 0 1 1.72 1.36A3.61 3.61 0 0 1 52 32.3a4 4 0 0 1-1.09 2.7 3.84 3.84 0 0 1-2.73 1.12A4 4 0 0 1 45.46 35a3.87 3.87 0 0 1-1.13-2.77v-.08H39v.12a9.19 9.19 0 0 0 18.37 0A9 9 0 0 0 54.8 26a10.41 10.41 0 0 0 3.9-8.11m96.57-12.96a2.43 2.43 0 0 1 .73-1.68 2.26 2.26 0 0 1 1.68-.68 2.45 2.45 0 0 1 1.69.68 2.26 2.26 0 0 1 .63 1.68 2.43 2.43 0 0 1-.68 1.69 2.28 2.28 0 0 1-1.69.68 2.43 2.43 0 0 1-1.63-.68 2.15 2.15 0 0 1-.73-1.69zm2.36-2a2 2 0 0 0-1.44.6 2 2 0 0 0-.6 1.44 2 2 0 0 0 .6 1.45 2 2 0 0 0 1.44.6 2 2 0 0 0 2.05-2.05 2 2 0 0 0-.6-1.44 2 2 0 0 0-1.45-.64z",
    className: "cls-2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M158 5.06a.73.73 0 0 0 .45-.25.64.64 0 0 0 .16-.48 1.18 1.18 0 0 0-.08-.4l-.25-.24a1 1 0 0 0-.36-.08h-1.04v2.61h.36V5.06h.36l.72 1.16h.45zm.24-.69a.34.34 0 0 1-.08.24.87.87 0 0 1-.2.12.51.51 0 0 1-.24 0h-.48V4h.84c.08 0 .12.08.12.12a.43.43 0 0 1-.01.25z",
    className: "cls-2"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTogetherreact);

/***/ }),

/***/ 44924:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _g, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTsbreact = function SvgTsbreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 29,
    "aria-label": "TSB icon",
    viewBox: "0 0 385.1 141.4",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#26358C",
    d: "M314.4 0c-26 0-48.6 14-60.9 34.8 6.2 10.5 9.8 22.8 9.8 35.8 0 13.1-3.6 25.3-9.8 35.8 12.3 20.9 35 34.9 60.9 34.9 39 0 70.7-31.6 70.7-70.7 0-39-31.7-70.6-70.7-70.6z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0068B3",
    d: "M253.5 34.8C241.2 14 218.5 0 192.5 0s-48.6 14-60.9 34.8c6.2 10.5 9.8 22.8 9.8 35.8 0 13.1-3.6 25.3-9.8 35.8 12.3 20.9 35 34.9 60.9 34.9 26 0 48.6-14 60.9-34.9-6.2-10.5-9.8-22.8-9.8-35.8.1-13 3.7-25.2 9.9-35.8z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#36BCEE",
    d: "M131.6 34.8C119.3 14 96.6 0 70.7 0 31.6 0 0 31.6 0 70.7c0 39 31.6 70.7 70.7 70.7 26 0 48.6-14 60.9-34.9-6.2-10.5-9.8-22.8-9.8-35.8.1-13.1 3.6-25.3 9.8-35.9z"
  })), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#005C9E"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M131.6 106.5c6.2-10.5 9.8-22.8 9.8-35.8 0-13.1-3.6-25.3-9.8-35.8-6.2 10.5-9.8 22.8-9.8 35.8.1 13.1 3.6 25.3 9.8 35.8z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M131.6 106.5c-6.4-10.8-9.8-23.2-9.8-35.8 0-12.6 3.4-25 9.8-35.8 6.4 10.8 9.8 23.2 9.8 35.8 0 12.6-3.4 25-9.8 35.8zm0-71.6c-6.4 10.8-9.8 23.2-9.8 35.8 0 12.6 3.4 25 9.8 35.8 6.4-10.8 9.8-23.2 9.8-35.8 0-12.6-3.4-25-9.8-35.8z"
  }))), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#002F60",
    d: "M253.5 106.5c6.2-10.5 9.8-22.7 9.8-35.8 0-13.1-3.6-25.3-9.8-35.8-6.2 10.5-9.8 22.8-9.8 35.8 0 13.1 3.6 25.3 9.8 35.8z"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFF",
    d: "M97.3 46H76.7v63H62.5V46H42.4V33.1h54.9V46zm192.5-12.9h26.6c10.1.1 12.8.2 16.4 1.3 7.6 2.3 13 9 13 17.3 0 3.3-.7 7.4-2.9 10.3-2.4 3.1-5.4 4.7-9.5 5.5 8.4 1.5 15.7 8.3 15.7 20 0 8.7-3.9 16.4-13 19.7-4.8 1.7-8.6 1.8-17.2 1.8h-29.1V33.1zm14 11.6v18.9h4.4c4 0 6.9 0 8.6-.1 3.5 0 7.1-.1 9.7-1.5 3-1.5 5-4.4 5-7.9 0-2.9-1.5-5.8-4.4-7.5-3-1.7-4.5-1.8-14.8-1.9h-8.5zm0 29.6v22.5h13.5c8.4 0 10.6 0 14.3-2.6 1.9-1.4 3.4-4.3 3.4-7.9 0-1.7-.3-3.8-1.4-5.7-3.4-6.1-11.4-6.2-16.2-6.2l-13.6-.1zM199.8 64l-7.8-1.7c-6.8-1.3-13.9-2.6-13.9-9 0-5.8 6.6-9.2 14.2-9.2 11.4 0 16.4 6.7 19.1 10.6l11.2-8.9c-5.4-7.1-13.8-14.3-29.5-14.3-17.7 0-29.8 9.2-29.8 23.5 0 12.5 9.3 17.1 12.7 18.4 2.3 1 4.7 1.5 9.5 2.7l9.1 1.9c6.8 1.6 7 1.7 8.8 2.3 2.3 1 5.7 2.7 5.7 7.5 0 2.6-1 6.4-6.4 8.6-2.7 1.1-5.4 1.3-8.1 1.3-15.1 0-20.9-7.8-23-10.9L160 95.5c5.7 8.7 13.9 11.9 18.8 13.4 4.6 1.3 9.3 1.7 13.4 1.7 16 0 32-6.9 32-24.2.1-16.1-14.2-20.3-24.4-22.4z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTsbreact);

/***/ }),

/***/ 80022:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLinkedin2024React = function SvgLinkedin2024React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    "aria-label": "linkedin icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#B24A00",
    opacity: 0.05,
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    fillRule: "evenodd",
    d: "M32.002 31.933h-3.315v-4.85c0-1.157-.021-2.645-1.723-2.645-1.725 0-1.988 1.26-1.988 2.562v4.933h-3.312V21.96h3.178v1.363h.046c.442-.784 1.523-1.611 3.136-1.611 3.358 0 3.978 2.065 3.978 4.752v5.47ZM17.924 20.596c-1.066 0-1.924-.806-1.924-1.798 0-.993.858-1.798 1.924-1.798 1.06 0 1.922.805 1.922 1.798 0 .992-.862 1.798-1.922 1.798Zm1.66 11.336h-3.318v-9.975h3.319v9.975Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgLinkedin2024React);

/***/ }),

/***/ 45103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLinkedinreact = function SvgLinkedinreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    fillRule: "evenodd",
    d: "M16.002 14.933h-3.315v-4.85c0-1.157-.021-2.645-1.723-2.645-1.725 0-1.988 1.26-1.988 2.562v4.933H5.664V4.958h3.179v1.364h.045c.442-.784 1.524-1.611 3.136-1.611 3.358 0 3.978 2.065 3.978 4.752v5.47ZM1.924 3.596C.859 3.596 0 2.79 0 1.798 0 .805.859 0 1.924 0c1.06 0 1.922.805 1.922 1.798 0 .992-.862 1.798-1.922 1.798Zm1.66 11.336H.267V4.957h3.319v9.975Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgLinkedinreact);

/***/ }),

/***/ 70868:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogoBetter2024NoSizereact = function SvgLogoBetter2024NoSizereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "better.co.uk logo",
    viewBox: "0 0 135 24",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    fillRule: "evenodd",
    d: "M.242 10.768v1.862l8.643 3.706v-5.568c0-4.116-1.666-7.42-4.411-7.42-2.562 0-4.232 3.298-4.232 7.42ZM23.53 23.587V10.142h-.006C23.523 4.608 21.243 0 17.486 0c-3.993 0-6.361 4.6-6.361 10.142v7.11l12.404 6.335Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#292B29",
    clipPath: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M106.318 9.797V5.195h-5.287v18.414h5.287V12.635c.492-1.656 2.798-3.206 6.124-2.43V4.826c-2.765 0-5.144 1.917-6.124 4.972M79.512 17.9V8.843h3.603V5.234l-3.603.004V.854L69.5 8.294v-6.48l-8.366 6.628v.407h3.152v10.088c0 3.205 2.24 4.898 5.287 4.898 1.33 0 2.45-.257 3.464-.881v-3.795c-.492.296-1.086.518-1.75.518-1.118 0-1.785-.59-1.785-1.622V8.846h4.795V18.9c0 3.24 2.24 4.933 5.32 4.933 1.367 0 2.484-.185 3.57-.881v-3.83a3.584 3.584 0 0 1-1.856.552c-1.121-.006-1.822-.631-1.822-1.773m8.885-4.048c0-3.02 1.823-5.044 4.025-5.044 1.612 0 2.416.92 2.416 1.806 0 1.288-.98 2.581-6.44 3.24m10.812-3.901c0-2.836-2.765-5.23-6.616-5.23-5.111 0-9.24 3.941-9.24 9.686 0 5.412 4.234 9.427 9.558 9.427 2.278-.005 4.588-.7 6.268-1.954v-4.899c-1.75 1.55-4.096 2.396-5.986 2.396-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554m-49.24 3.931c0-3.02 1.818-5.044 4.027-5.044 1.61 0 2.416.92 2.416 1.806 0 1.289-.98 2.581-6.44 3.24m10.813-3.901c0-2.836-2.766-5.23-6.617-5.23-5.111 0-9.24 3.942-9.24 9.686 0 5.412 4.234 9.427 9.559 9.427 2.277-.005 4.587-.7 6.267-1.954v-4.899c-1.75 1.55-4.096 2.396-5.986 2.396-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554M35.337 19.3h-3.99v-5.597h3.99c1.644 0 3.01 1.068 3.01 2.87 0 1.695-1.368 2.724-3.01 2.724m-3.99-15.02h3.709c1.573 0 2.833 1.03 2.833 2.613 0 1.695-1.262 2.724-2.834 2.724h-3.708V4.276Zm8.61 7.213c2.03-.958 3.397-2.836 3.397-5.084C43.352 2.542 40.13 0 36.036 0H25.922v23.608H36.49c4.058 0 7.248-2.613 7.248-6.593 0-2.542-1.541-4.566-3.781-5.523"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M106.318 9.797V5.195h-5.287v18.414h5.287V12.635c.492-1.656 2.798-3.206 6.124-2.43V4.826c-2.765 0-5.144 1.917-6.124 4.972M49.97 13.887c0-3.02 1.818-5.044 4.027-5.044 1.61 0 2.416.92 2.416 1.806 0 1.289-.98 2.581-6.44 3.24m10.813-3.901c0-2.836-2.766-5.23-6.617-5.23-5.111 0-9.24 3.942-9.24 9.686 0 5.412 4.234 9.427 9.559 9.427 2.277-.005 4.587-.7 6.267-1.954v-4.899c-1.75 1.55-4.096 2.396-5.986 2.396-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554m18.724 7.91V8.843h3.603V5.234l-3.603.04V.853L69.5 8.294v-6.48l-8.366 6.628v.407h3.152v10.088c0 3.205 2.24 4.898 5.287 4.898 1.33 0 2.45-.257 3.464-.881v-3.795c-.492.296-1.086.518-1.75.518-1.118 0-1.785-.59-1.785-1.622V8.846h4.795V18.9c0 3.24 2.24 4.933 5.32 4.933 1.367 0 2.484-.185 3.57-.881v-3.83a3.584 3.584 0 0 1-1.856.552c-1.121-.006-1.822-.631-1.822-1.773M35.337 19.3h-3.99v-5.597h3.99c1.644 0 3.01 1.068 3.01 2.87 0 1.695-1.368 2.724-3.01 2.724m-3.99-15.02h3.709c1.573 0 2.833 1.03 2.833 2.613 0 1.695-1.262 2.724-2.834 2.724h-3.708V4.276Zm8.61 7.213c2.03-.958 3.397-2.836 3.397-5.084C43.352 2.542 40.13 0 36.036 0H25.922v23.608H36.49c4.058 0 7.248-2.613 7.248-6.593 0-2.542-1.541-4.566-3.781-5.523m78.982 8.92c0 .931-.539 1.686-1.398 1.686-.859 0-1.398-.755-1.398-1.686 0-.931.536-1.73 1.398-1.73.862 0 1.398.798 1.398 1.73Zm1.723.006c0-1.744-1.403-3.159-3.12-3.158-1.861 0-3.12 1.415-3.12 3.158 0 1.743 1.356 3.184 3.119 3.184 1.763 0 3.12-1.368 3.12-3.184m4.778 3.184c2.021 0 2.605-1.412 2.605-2.756V17.43h-1.772v3.45c.019.734-.322 1.206-.921 1.206-.64 0-.981-.49-.976-1.205V17.43h-1.781v3.414c0 1.399.728 2.756 2.846 2.756m3.349-.073h1.771V21.22s.607.255 1.138 1.015c.618.885.771 1.293.771 1.293h2.057s-.693-1.268-1.383-2.057c-.91-1.04-1.595-1.295-1.595-1.295s.974-.397 1.707-1.302c.631-.78.831-1.447.831-1.447h-1.907s-.056.468-.583 1.254c-.528.786-1.036 1.035-1.036 1.035v-4.032h-1.771v7.844Zm-17.24-6.267c-1.697 0-2.947 1.303-2.947 3.211 0 1.798 1.326 3.131 3.299 3.131.757-.001 1.524-.32 2.082-.736v-1.627c-.581.514-1.36.886-1.988.883-.635-.004-1.65-.257-1.646-1.834-.02-1.088.558-1.62 1.133-1.612.554.009 1.029.265 1.129 1.317l1.508-.547c-.146-1.595-1.515-2.185-2.57-2.185"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M107.678 23.602c.533 0 .966-.456.966-1.017 0-.562-.433-1.018-.966-1.018-.534 0-.967.456-.967 1.018 0 .561.433 1.017.967 1.017Zm13.843 0c.534 0 .967-.456.967-1.017 0-.562-.433-1.018-.967-1.018-.533 0-.966.456-.966 1.018 0 .561.433 1.017.966 1.017Z"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M25.922 0h108.72v24H25.922z"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgLogoBetter2024NoSizereact);

/***/ }),

/***/ 99865:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogoBetter2024React = function SvgLogoBetter2024React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 24,
    fill: "none",
    "aria-label": "better.co.uk logo",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    fillRule: "evenodd",
    d: "M.242 10.768v1.862l8.643 3.706v-5.568c0-4.116-1.666-7.42-4.411-7.42-2.562 0-4.232 3.298-4.232 7.42ZM23.53 23.587V10.142h-.006C23.523 4.608 21.243 0 17.486 0c-3.993 0-6.361 4.6-6.361 10.142v7.11l12.404 6.335Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#292B29",
    clipPath: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M106.318 9.797V5.195h-5.287v18.414h5.287V12.635c.492-1.656 2.798-3.206 6.124-2.43V4.826c-2.765 0-5.144 1.917-6.124 4.972M79.512 17.9V8.843h3.603V5.234l-3.603.004V.854L69.5 8.294v-6.48l-8.366 6.628v.407h3.152v10.088c0 3.205 2.24 4.898 5.287 4.898 1.33 0 2.45-.257 3.464-.881v-3.795c-.492.296-1.086.518-1.75.518-1.118 0-1.785-.59-1.785-1.622V8.846h4.795V18.9c0 3.24 2.24 4.933 5.32 4.933 1.367 0 2.484-.185 3.57-.881v-3.83a3.584 3.584 0 0 1-1.856.552c-1.121-.006-1.822-.631-1.822-1.773m8.885-4.048c0-3.02 1.823-5.044 4.025-5.044 1.612 0 2.416.92 2.416 1.806 0 1.288-.98 2.581-6.44 3.24m10.812-3.901c0-2.836-2.765-5.23-6.616-5.23-5.111 0-9.24 3.941-9.24 9.686 0 5.412 4.234 9.427 9.558 9.427 2.278-.005 4.588-.7 6.268-1.954v-4.899c-1.75 1.55-4.096 2.396-5.986 2.396-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554m-49.24 3.931c0-3.02 1.818-5.044 4.027-5.044 1.61 0 2.416.92 2.416 1.806 0 1.289-.98 2.581-6.44 3.24m10.813-3.901c0-2.836-2.766-5.23-6.617-5.23-5.111 0-9.24 3.942-9.24 9.686 0 5.412 4.234 9.427 9.559 9.427 2.277-.005 4.587-.7 6.267-1.954v-4.899c-1.75 1.55-4.096 2.396-5.986 2.396-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554M35.337 19.3h-3.99v-5.597h3.99c1.644 0 3.01 1.068 3.01 2.87 0 1.695-1.368 2.724-3.01 2.724m-3.99-15.02h3.709c1.573 0 2.833 1.03 2.833 2.613 0 1.695-1.262 2.724-2.834 2.724h-3.708V4.276Zm8.61 7.213c2.03-.958 3.397-2.836 3.397-5.084C43.352 2.542 40.13 0 36.036 0H25.922v23.608H36.49c4.058 0 7.248-2.613 7.248-6.593 0-2.542-1.541-4.566-3.781-5.523"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M106.318 9.797V5.195h-5.287v18.414h5.287V12.635c.492-1.656 2.798-3.206 6.124-2.43V4.826c-2.765 0-5.144 1.917-6.124 4.972M49.97 13.887c0-3.02 1.818-5.044 4.027-5.044 1.61 0 2.416.92 2.416 1.806 0 1.289-.98 2.581-6.44 3.24m10.813-3.901c0-2.836-2.766-5.23-6.617-5.23-5.111 0-9.24 3.942-9.24 9.686 0 5.412 4.234 9.427 9.559 9.427 2.277-.005 4.587-.7 6.267-1.954v-4.899c-1.75 1.55-4.096 2.396-5.986 2.396-1.89 0-3.535-1.103-4.306-2.87 6.928-.513 10.325-3.02 10.325-6.554m18.724 7.91V8.843h3.603V5.234l-3.603.04V.853L69.5 8.294v-6.48l-8.366 6.628v.407h3.152v10.088c0 3.205 2.24 4.898 5.287 4.898 1.33 0 2.45-.257 3.464-.881v-3.795c-.492.296-1.086.518-1.75.518-1.118 0-1.785-.59-1.785-1.622V8.846h4.795V18.9c0 3.24 2.24 4.933 5.32 4.933 1.367 0 2.484-.185 3.57-.881v-3.83a3.584 3.584 0 0 1-1.856.552c-1.121-.006-1.822-.631-1.822-1.773M35.337 19.3h-3.99v-5.597h3.99c1.644 0 3.01 1.068 3.01 2.87 0 1.695-1.368 2.724-3.01 2.724m-3.99-15.02h3.709c1.573 0 2.833 1.03 2.833 2.613 0 1.695-1.262 2.724-2.834 2.724h-3.708V4.276Zm8.61 7.213c2.03-.958 3.397-2.836 3.397-5.084C43.352 2.542 40.13 0 36.036 0H25.922v23.608H36.49c4.058 0 7.248-2.613 7.248-6.593 0-2.542-1.541-4.566-3.781-5.523m78.982 8.92c0 .931-.539 1.686-1.398 1.686-.859 0-1.398-.755-1.398-1.686 0-.931.536-1.73 1.398-1.73.862 0 1.398.798 1.398 1.73Zm1.723.006c0-1.744-1.403-3.159-3.12-3.158-1.861 0-3.12 1.415-3.12 3.158 0 1.743 1.356 3.184 3.119 3.184 1.763 0 3.12-1.368 3.12-3.184m4.778 3.184c2.021 0 2.605-1.412 2.605-2.756V17.43h-1.772v3.45c.019.734-.322 1.206-.921 1.206-.64 0-.981-.49-.976-1.205V17.43h-1.781v3.414c0 1.399.728 2.756 2.846 2.756m3.349-.073h1.771V21.22s.607.255 1.138 1.015c.618.885.771 1.293.771 1.293h2.057s-.693-1.268-1.383-2.057c-.91-1.04-1.595-1.295-1.595-1.295s.974-.397 1.707-1.302c.631-.78.831-1.447.831-1.447h-1.907s-.056.468-.583 1.254c-.528.786-1.036 1.035-1.036 1.035v-4.032h-1.771v7.844Zm-17.24-6.267c-1.697 0-2.947 1.303-2.947 3.211 0 1.798 1.326 3.131 3.299 3.131.757-.001 1.524-.32 2.082-.736v-1.627c-.581.514-1.36.886-1.988.883-.635-.004-1.65-.257-1.646-1.834-.02-1.088.558-1.62 1.133-1.612.554.009 1.029.265 1.129 1.317l1.508-.547c-.146-1.595-1.515-2.185-2.57-2.185"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M107.678 23.602c.533 0 .966-.456.966-1.017 0-.562-.433-1.018-.966-1.018-.534 0-.967.456-.967 1.018 0 .561.433 1.017.967 1.017Zm13.843 0c.534 0 .967-.456.967-1.017 0-.562-.433-1.018-.967-1.018-.533 0-.966.456-.966 1.018 0 .561.433 1.017.966 1.017Z"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M25.922 0h108.72v24H25.922z"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgLogoBetter2024React);

/***/ }),

/***/ 34261:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMonzoreact = function SvgMonzoreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Monzo logo",
    viewBox: "122.9 116.63 960.67 170",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FF4F40",
    d: "M123 282.3v-161h42.9v21.6a47.6 47.6 0 0 1 43.8-24.6 49 49 0 0 1 44.7 25.8c16.8-17.7 29.7-25.8 49.8-25.8 36.3 0 56.7 20.4 56.7 57.9v106.1h-46.2v-87.2c0-22.5-4.8-32.7-22.5-32.7-18 0-27.6 11-27.6 32.7v87.2H218v-87.2c0-22.5-4.8-32.7-22.5-32.7-18 0-27.6 11-27.6 32.7v87.2h-45Zm292.6-140a85 85 0 1 1 93.2 138 83.5 83.5 0 0 1-33.2 6.3 79.6 79.6 0 0 1-61-25.8 84.2 84.2 0 0 1-23.6-59.4 82.6 82.6 0 0 1 24.6-59.1Zm60.3 99.3a39.8 39.8 0 1 0-38.1-39.6 38.9 38.9 0 0 0 38 39.6Zm115.3 40.7v-161h45l-.6 21.6a50.1 50.1 0 0 1 46.2-24.6c33.3 0 54.9 21 54.9 57.9v106.1h-47.4v-87.2c0-22.5-4.8-32.7-23.1-32.7-18.6 0-28.5 11-28.5 32.7v87.2h-46.5Zm346.6-140.1a85 85 0 1 1 93.2 138 83.6 83.6 0 0 1-33.2 6.4 79.6 79.6 0 0 1-61-25.8 84.2 84.2 0 0 1-23.6-59.4 82.6 82.6 0 0 1 24.6-59.2Zm60.3 99.3A39.8 39.8 0 1 0 960 202a38.9 38.9 0 0 0 38.1 39.5Zm-226.9 40.8v-33.5l66.3-85.9h-66.3v-41.6H891v38l-58.5 81.4h59.7v41.6h-121Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgMonzoreact);

/***/ }),

/***/ 17665:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgNotchreact = function SvgNotchreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 6,
    fill: "none",
    "aria-label": "Notch icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h2v6H0z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgNotchreact);

/***/ }),

/***/ 30344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPadlockreact = function SvgPadlockreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    "aria-label": "padlock icon",
    role: "img"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "b",
    width: 44,
    height: 44,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0V0Z"
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#565D5A",
    mask: "url(#b)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.688 24.063c0 1.124-.54 2.123-1.375 2.75v4.812a2.062 2.062 0 0 1-4.125 0v-4.813a3.437 3.437 0 1 1 5.5-2.75Zm13.75-14.438a1.375 1.375 0 1 1-2.751 0 1.375 1.375 0 0 1 2.75 0Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11 8.25a8.25 8.25 0 1 1 16.5 0v.041a8.937 8.937 0 0 1 7.563-4.166v.003a8.937 8.937 0 0 1 4.812 16.47v10.34a4.812 4.812 0 0 1-4.125 4.764v.048a5.5 5.5 0 0 1-5.5 5.5h-22a5.5 5.5 0 0 1-5.5-5.5V17.875a5.5 5.5 0 0 1 5.5-5.5H11V8.25Zm22 27.038a4.81 4.81 0 0 1-2.75-4.348v-2.412c0-.74.216-1.464.622-2.084a3.733 3.733 0 0 1-.198-1.195 3.744 3.744 0 0 0-.424-3.28v-1.374a8.937 8.937 0 0 1-3.887-5.47H8.25a2.75 2.75 0 0 0-2.75 2.75V35.75a2.75 2.75 0 0 0 2.75 2.75h22A2.75 2.75 0 0 0 33 35.75v-.462ZM24.062 8.25a4.813 4.813 0 1 0-9.625 0v4.125h9.626V8.25Zm11-1.376A6.188 6.188 0 0 0 33 18.897v3.069a1.01 1.01 0 0 0 .296.715l.431.426a.995.995 0 0 1 0 1.43.979.979 0 0 0 0 1.416.994.994 0 0 1 0 1.43l-.431.426a.984.984 0 0 0-.296.715v2.412a2.062 2.062 0 0 0 4.125 0v-12.04a6.187 6.187 0 0 0-2.063-12.022Z"
  })))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPadlockreact);

/***/ }),

/***/ 35615:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPhoneGreenreact = function SvgPhoneGreenreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    "aria-label": "decorative phone icon",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#clip0_893_8547)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    stroke: "#017848",
    strokeWidth: 2
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    fillRule: "evenodd",
    d: "M21.43 21.93c1.12.37 2.32.57 3.57.57.55 0 1 .45 1 1V27c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1l-2.2 2.21c1.44 2.84 3.76 5.15 6.59 6.59l2.2-2.2c.2-.19.45-.29.71-.29.1 0 .21.02.31.05Zm-9.45-7.35c-.23-.83-.38-1.7-.45-2.58h-1.5c.09 1.32.35 2.58.75 3.79l1.2-1.21ZM24 25.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51ZM23 10v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z",
    clipRule: "evenodd"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPhoneGreenreact);

/***/ }),

/***/ 32577:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPhonereact = function SvgPhonereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFDFA",
    fillRule: "evenodd",
    d: "M1.333.5H4.25c.458 0 .833.375.833.833 0 1.042.167 2.042.475 2.975a.836.836 0 0 1-.208.85L3.517 6.992a12.624 12.624 0 0 0 5.491 5.491l1.834-1.833a.854.854 0 0 1 .591-.242.7.7 0 0 1 .259.042 9.506 9.506 0 0 0 2.975.475c.458 0 .833.375.833.833v2.909a.836.836 0 0 1-.833.833C6.842 15.5.5 9.158.5 1.333.5.875.875.5 1.333.5ZM3.45 2.167c.05.741.175 1.466.375 2.158l-1 1c-.342-1-.558-2.058-.633-3.158H3.45Zm8.217 10.016c.708.2 1.433.325 2.166.375V13.8a12.856 12.856 0 0 1-3.166-.625l1-.992Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgPhonereact);

/***/ }),

/***/ 75216:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgQuotereact = function SvgQuotereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    fill: "none",
    "aria-label": "quote",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#DFE0DC",
    d: "m16 0-2.373 6.51c.609.243 1.136.648 1.582 1.216.487.568.73 1.197.73 1.886 0 .933-.304 1.704-.912 2.312-.609.608-1.38.912-2.312.912-.933 0-1.704-.304-2.312-.912-.568-.608-.852-1.379-.852-2.312 0-.527.122-1.054.365-1.582L13.445 0H16ZM6.449 0 4.076 6.51c.608.243 1.136.648 1.582 1.216.486.568.73 1.197.73 1.886 0 .933-.304 1.704-.913 2.312-.608.608-1.379.912-2.311.912-.933 0-1.704-.304-2.312-.912C.284 11.316 0 10.545 0 9.612c0-.527.122-1.054.365-1.582L3.894 0h2.555Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgQuotereact);

/***/ }),

/***/ 33407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRadioreact = function SvgRadioreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Radio icon",
    viewBox: "0 0 8 8",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRadioreact);

/***/ }),

/***/ 35833:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRemoveDarkreact = function SvgRemoveDarkreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M19 13.5H5v-2h14v2Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRemoveDarkreact);

/***/ }),

/***/ 85909:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRemovereact = function SvgRemovereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Remove icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M5.76 4.347c-.325-.326-.905-.273-1.295.117-.391.391-.444.971-.118 1.297L6.586 8l-2.121 2.121a1 1 0 1 0 1.414 1.415L8 9.414l2.24 2.24c.325.325.905.272 1.296-.118.39-.391.443-.971.117-1.297L9.414 8l2.122-2.121a1 1 0 0 0-1.415-1.415L8 6.586l-2.24-2.24Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRemovereact);

/***/ }),

/***/ 98267:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRightReskinreact = function SvgRightReskinreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M8 0 6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRightReskinreact);

/***/ }),

/***/ 22906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRightreact = function SvgRightreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    fill: "none",
    "aria-label": "Right icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m14.7 6.29-5-5a.965.965 0 0 0-.71-.3 1.003 1.003 0 0 0-.71 1.71l3.29 3.29H1.99c-.55 0-1 .45-1 1s.45 1 1 1h9.59l-3.29 3.29a1.003 1.003 0 0 0 1.42 1.42l5-5c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRightreact);

/***/ }),

/***/ 60626:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRocketreact = function SvgRocketreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    "aria-label": "rocket icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F8EBC9",
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    d: "M46.868 15.967a26.197 26.197 0 0 0-5.7-.634 13.768 13.768 0 0 0-10 3.434 1200.524 1200.524 0 0 0-5.316 5.35c-2.017-.217-6.8-.334-10 2.9a1.667 1.667 0 0 0 0 2.35l18.833 18.866a1.667 1.667 0 0 0 2.35 0c3.25-3.333 3.15-8.033 2.95-10l5.35-5.333c5.317-5.317 2.9-15.3 2.8-15.717a1.667 1.667 0 0 0-1.267-1.216ZM42.935 30.55l-5.933 5.9a1.667 1.667 0 0 0-.45 1.5 11.35 11.35 0 0 1-.9 6.567l-16.117-16.15a11.116 11.116 0 0 1 6.667-.834 1.666 1.666 0 0 0 1.45-.533s2.333-2.417 5.85-5.933a11.017 11.017 0 0 1 7.666-2.4c1.302.006 2.6.118 3.884.333.4 2.383 1.033 8.4-2.117 11.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    d: "M38.216 29.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Zm-17.883 9.5C17 40.334 17 47 17 47a13.017 13.017 0 0 0 8.333-3.333l-5-5Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRocketreact);

/***/ }),

/***/ 80244:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSearchreact = function SvgSearchreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    "aria-label": "decorative search icon",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#clip0_893_8478)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M35.579 13.747 18.703.247a1.124 1.124 0 0 0-1.406 0L.42 13.747a1.125 1.125 0 0 0 .698 2.003h2.25v19.125A1.125 1.125 0 0 0 4.494 36h27.001a1.125 1.125 0 0 0 1.125-1.125V15.75h2.25a1.124 1.124 0 0 0 .709-2.003Zm-4.084-.248a1.125 1.125 0 0 0-1.125 1.125V33.75H5.619V14.624A1.125 1.125 0 0 0 4.494 13.5h-.169l13.67-10.935L31.662 13.5h-.168Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    fillRule: "evenodd",
    d: "M24.186 19.093a7.03 7.03 0 0 1-1.104 3.767L28 27.762 25.762 30l-4.918-4.918a6.989 6.989 0 0 1-3.767 1.104c-3.909 0-7.077-3.169-7.077-7.093A7.083 7.083 0 0 1 17.093 12a7.083 7.083 0 0 1 7.093 7.093Zm-11.344-.462a3.79 3.79 0 0 0 3.79 3.79 3.79 3.79 0 0 0 3.789-3.79 3.79 3.79 0 0 0-3.79-3.789 3.79 3.79 0 0 0-3.789 3.79Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M23.02 23.01c.693-1.104 1.166-2.53 1.166-3.917A7.083 7.083 0 0 0 17.093 12 7.083 7.083 0 0 0 10 19.093c0 3.924 3.168 7.093 7.077 7.093 1.387 0 3.598-.832 4.603-1.837l4.866 4.867 1.34-1.34-4.867-4.866Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFDFA",
    d: "M17.105 24.316a5.212 5.212 0 0 1-5.21-5.211 5.212 5.212 0 0 1 5.21-5.21 5.212 5.212 0 0 1 5.21 5.21 5.212 5.212 0 0 1-5.21 5.21Z"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSearchreact);

/***/ }),

/***/ 48228:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSendreact = function SvgSendreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Send icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m1.5 10 .01-7 20.99 9-20.99 9-.01-7 15-2-15-2Zm2.01-3.97 7.51 3.22-7.52-1 .01-2.22Zm7.5 8.72L3.5 17.97v-2.22l7.51-1Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSendreact);

/***/ }),

/***/ 13740:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgShieldreact = function SvgShieldreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    "aria-label": "shield icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F8EBC9",
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    fillRule: "evenodd",
    d: "m32 13.667-15 6.667v10c0 9.25 6.4 17.9 15 20 8.6-2.1 15-10.75 15-20v-10l-15-6.667Zm11.667 16.667c0 7.533-4.967 14.483-11.667 16.55-6.7-2.067-11.667-9.017-11.667-16.55V22.5L32 17.317 43.667 22.5v7.834ZM22 33.667l2.35-2.35 4.317 4.3L39.65 24.634 42 27 28.667 40.334 22 33.667Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgShieldreact);

/***/ }),

/***/ 7837:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSuitcasereact = function SvgSuitcasereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    fill: "none",
    "aria-label": "suitcase icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 64,
    height: 64,
    y: 0.5,
    fill: "#F8EBC9",
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    fillRule: "evenodd",
    d: "M48.67 27.167a3.322 3.322 0 0 0-3.334-3.333h-6.667V20.5a3.322 3.322 0 0 0-3.333-3.333h-6.667a3.322 3.322 0 0 0-3.333 3.333v3.334h-6.667a3.308 3.308 0 0 0-3.316 3.333L15.336 45.5a3.322 3.322 0 0 0 3.333 3.334h26.667a3.322 3.322 0 0 0 3.333-3.334V27.167Zm-13.334-3.333V20.5h-6.667v3.334h6.667Zm-16.667 3.333V45.5h26.667V27.167H18.669Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSuitcasereact);

/***/ }),

/***/ 35356:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgThumbsUpreact = function SvgThumbsUpreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    "aria-label": "thumbs-up icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F8EBC9",
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    fillRule: "evenodd",
    d: "M26.997 48.666h15a3.31 3.31 0 0 0 3.067-2.033l5.033-11.75c.15-.383.234-.783.234-1.217v-3.333c0-1.833-1.5-3.333-3.334-3.333H36.481l1.583-7.617.05-.533c0-.684-.283-1.317-.733-1.767l-1.767-1.75-10.983 10.983c-.6.6-.967 1.434-.967 2.35v16.667c0 1.833 1.5 3.333 3.333 3.333Zm0-20 7.234-7.233-2.234 8.9h15v3.333l-5 11.667h-15V28.666Zm-6.666 0h-6.667v20h6.667v-20Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgThumbsUpreact);

/***/ }),

/***/ 33937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTickGreenreact = function SvgTickGreenreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    fill: "none",
    "aria-label": "Tick icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M11.8 1 4.6 8.2 1 4.6"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTickGreenreact);

/***/ }),

/***/ 93301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTickLowContactreact = function SvgTickLowContactreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "2 2 20 20",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m17.8 8-7.2 7.2L7 11.6"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTickLowContactreact);

/***/ }),

/***/ 54277:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTickReskinreact = function SvgTickReskinreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "m8.8 15.9-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4L8.8 15.9Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTickReskinreact);

/***/ }),

/***/ 62851:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTickreact = function SvgTickreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    fill: "none",
    "aria-label": "Tick icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M13.548 0c-.384 0-.753.144-1.025.4L5.808 6.708 2.479 3.581a1.498 1.498 0 0 0-1.027-.4 1.496 1.496 0 0 0-1.027.398A1.322 1.322 0 0 0 0 4.545c0 .362.154.709.427.965L4.781 9.6c.272.256.641.4 1.027.4.385 0 .754-.144 1.026-.4l7.74-7.272c.416-.39.54-.977.315-1.486C14.665.332 14.136 0 13.55 0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTickreact);

/***/ }),

/***/ 22082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTiktok2024React = function SvgTiktok2024React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    "aria-label": "tiktok icon",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#B24A00",
    opacity: 0.05,
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#B24A00",
    d: "M28.596 17.82a4.278 4.278 0 0 1-1.06-2.82h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48v-3.16c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7v-6.29a7.35 7.35 0 0 0 4.3 1.38V19.3s-1.88.09-3.24-1.48Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTiktok2024React);

/***/ }),

/***/ 5569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTiktokreact = function SvgTiktokreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M16.596 5.82A4.278 4.278 0 0 1 15.536 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTiktokreact);

/***/ }),

/***/ 10993:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTimelineTickreact = function SvgTimelineTickreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.44,
    height: 20,
    fill: "none",
    "aria-label": "Timeline tick icon",
    viewBox: "0 0 14 10",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M13 0c-.28 0-.53.11-.71.29L5 7.59l-3.29-3.3A1.003 1.003 0 0 0 .29 5.71l4 4c.18.18.43.29.71.29.28 0 .53-.11.71-.29l8-8A1.003 1.003 0 0 0 13 0Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTimelineTickreact);

/***/ }),

/***/ 41071:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTooltipreact = function SvgTooltipreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M9 5h2v2H9V5Zm0 4h2v6H9V9Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    fillRule: "evenodd",
    d: "M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10Zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTooltipreact);

/***/ }),

/***/ 56110:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTrayreact = function SvgTrayreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#D8DFE9",
    d: "M3.59 6.89A2.4 2.4 0 0 1 5.933 5h27.332a2.4 2.4 0 0 1 2.345 1.89L39.2 23.4v15.2a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 38.6V23.4L3.59 6.89Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#F1F2F8",
    stroke: "#D8DFE9",
    d: "M38.7 23.9v14.7a1.9 1.9 0 0 1-1.9 1.9H2.4a1.9 1.9 0 0 1-1.9-1.9V23.9h7.77a1.9 1.9 0 0 1 1.058.323l4.487 3.01a2.9 2.9 0 0 0 1.616.493h8.338a2.9 2.9 0 0 0 1.616-.492l4.487-3.012a1.9 1.9 0 0 1 1.059-.322H38.7Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFBF5",
    d: "M22.04 9.967 19.842 16l-2.196-6.033L12 8.131l5.96-1.836L19.844 0l2.196 6.295L28 8.131l-5.96 1.836Zm12.082 8.312L32.914 22.2l-1.208-3.921-3.106-1.194 3.279-1.193 1.035-4.092 1.208 4.092 3.278 1.193-3.278 1.194Z"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTrayreact);

/***/ }),

/***/ 14332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTriangleExclamationreact = function SvgTriangleExclamationreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Triangle exlamation icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#F69F00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.952 16.354 6.263-10.497c.738-1.472 2.839-1.472 3.576 0l6.258 10.497a2 2 0 0 1-1.788 2.896H5.74a2 2 0 0 1-1.788-2.896Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#F69F00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 10v2"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#000",
    stroke: "#F69F00",
    d: "M12.5 16a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTriangleExclamationreact);

/***/ }),

/***/ 94221:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTwitterreact = function SvgTwitterreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    fillRule: "evenodd",
    d: "M16 1.42a7.003 7.003 0 0 1-1.886.477c.678-.375 1.199-.968 1.444-1.676a6.925 6.925 0 0 1-2.085.736A3.412 3.412 0 0 0 11.078 0C9.264 0 7.796 1.356 7.796 3.03c0 .237.029.468.085.69C5.152 3.593 2.733 2.387 1.114.554a2.842 2.842 0 0 0-.445 1.523c0 1.051.58 1.979 1.46 2.522A3.476 3.476 0 0 1 .644 4.22v.038c0 1.468 1.131 2.692 2.633 2.97a3.547 3.547 0 0 1-1.482.053C2.21 8.484 3.423 9.36 4.86 9.384a6.943 6.943 0 0 1-4.077 1.297c-.265 0-.526-.014-.783-.042A9.865 9.865 0 0 0 5.032 12c6.038 0 9.34-4.616 9.34-8.62 0-.13-.004-.262-.01-.392A6.398 6.398 0 0 0 16 1.42Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTwitterreact);

/***/ }),

/***/ 20099:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgUnknownProfilereact = function SvgUnknownProfilereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Unkown profile icon",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#041942"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 5v.657A8.983 8.983 0 0 0 12 21a8.983 8.983 0 0 0 7-3.343V17a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgUnknownProfilereact);

/***/ }),

/***/ 63434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgUpReskinreact = function SvgUpReskinreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "m.333 8 1.36 1.41 5.395-5.58V16h1.93V3.83l5.384 5.59L15.772 8l-7.72-8L.334 8Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgUpReskinreact);

/***/ }),

/***/ 43144:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgValidreact = function SvgValidreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    fill: "none",
    "aria-label": "Valid icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#2ACE93",
    fillRule: "evenodd",
    d: "M13 0c-.28 0-.53.11-.71.29L5 7.59l-3.29-3.3A1.003 1.003 0 0 0 .29 5.71l4 4c.18.18.43.29.71.29.28 0 .53-.11.71-.29l8-8A1.003 1.003 0 0 0 13 0Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgValidreact);

/***/ }),

/***/ 48875:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWritingreact = function SvgWritingreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    "aria-label": "decorative writing icon",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#clip0_893_8540)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    fillRule: "evenodd",
    d: "M3.524 0h14.095L28 10.5v22.143C28 34.581 26.6 36 24.662 36H3.501C1.561 36 0 34.652 0 32.714l.018-29.19C.018 1.586 1.586 0 3.524 0ZM2 2v32h24V10H16V2H2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    fillRule: "evenodd",
    d: "M35.697 12.538a1.032 1.032 0 0 1 0 1.461l-2.031 2.031-3.886-3.886 2.031-2.03a1.032 1.032 0 0 1 1.461 0l2.425 2.424Zm-6.954.643L18.382 23.542v3.886h3.886L32.63 17.066l-3.887-3.885Zm-7.336 12.174h-.953v-.953l8.29-8.29.953.954-8.29 8.29Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFDFA",
    d: "M21.407 25.354h-.954V24.4l8.29-8.29.954.953-8.29 8.29Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#017848",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M5.285 24.982c1.143-1.415 2.513-2.078 4.501-2.078 1.805 0 3.034.904 4.084 2.17C15.5 26.81 17.5 26.81 19 26.31"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgWritingreact);

/***/ }),

/***/ 8133:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowDownreact = function SvgArrowDownreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Arrow down",
    viewBox: "0 0 20 20",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M5.833 7.917 10 12.083l4.166-4.166H5.833Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowDownreact);

/***/ }),

/***/ 66999:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronDownreact = function SvgChevronDownreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Chevron down",
    viewBox: "0 0 24 24",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M6 10.4 7.4 9l4.6 4.6L16.6 9l1.4 1.4-6 6-6-6Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgChevronDownreact);

/***/ }),

/***/ 43519:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFaviconreact = function SvgFaviconreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#1EE07F",
    rx: 8
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "M24 12v24L64 7.375V64H40.01L40 40H24v24H0V30l24-18Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgFaviconreact);

/***/ }),

/***/ 25184:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowreact = function SvgArrowreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Arrow icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#041942",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.75 6.75 5.5 5.25-5.5 5.25M19 12H4.75"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowreact);

/***/ }),

/***/ 33280:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgEmmareact = function SvgEmmareact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    height: 24,
    fill: "none",
    "aria-label": "Emma logo",
    viewBox: "0 0 111 31",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M43.755 21.395v3.752H30.827V4.596h12.928V8.16H34.8v4.787h8.066v3.721H34.8V21.4h8.955v-.006Zm16.423-4.359v8.116h-3.917V16.68c0-1.868-.774-2.802-2.315-2.802-.9 0-1.597.271-2.085.813-.487.548-.728 1.301-.728 2.26v8.197h-3.917V10.884h3.61v1.742c.754-1.38 2.14-2.069 4.164-2.069 1.914 0 3.31.673 4.189 2.014 1.23-1.34 2.833-2.014 4.796-2.014 1.693 0 2.989.517 3.888 1.552.899 1.035 1.35 2.416 1.35 4.138v8.905h-3.917V16.68c0-1.868-.773-2.802-2.315-2.802-.92 0-1.617.276-2.095.829-.472.557-.708 1.33-.708 2.33Zm25.785 0v8.116h-3.917V16.68c0-1.868-.774-2.802-2.315-2.802-.9 0-1.597.271-2.085.813-.487.548-.728 1.301-.728 2.26v8.197h-3.917V10.884h3.616v1.742c.753-1.38 2.14-2.069 4.163-2.069 1.914 0 3.31.673 4.194 2.014 1.23-1.34 2.833-2.014 4.801-2.014 1.693 0 2.989.517 3.888 1.552.899 1.035 1.35 2.416 1.35 4.138v8.905h-3.917V16.68c0-1.868-.773-2.802-2.315-2.802-.92 0-1.617.276-2.094.829-.483.557-.724 1.33-.724 2.33Zm16.866 8.468c-1.562 0-2.763-.593-3.611-1.387-.854-.798-1.176-1.617-1.176-2.938a3.94 3.94 0 0 1 1.401-3.058c.879-.743 2.175-1.17 4.018-1.462.422-.045.839-.085 1.261-.13.316-.03.628-.066.944-.096l.387-.04c.171-.015.447-.07.573-.226.326-.402.22-1.29.02-1.718-.312-.652-.965-.939-1.653-.994a4.196 4.196 0 0 0-.356-.015c-1.562 0-2.888 1.185-3.049 2.35l-3.325-.462c.126-1.396.693-2.566 1.703-3.51 1.009-.944 2.536-1.417 4.575-1.417 2.024 0 3.551.462 4.576 1.386 1.029.925 1.547 2.236 1.547 3.923v6.725c0 1.07-.096 2.094.17 2.727l-3.666-.005c-.015 0-.015.03-.015-.19 0-.126.01-.322.01-.654.005-.266-.01-.462-.01-.738-.869 1.27-2.25 1.929-4.324 1.929Zm4.018-6.76-3.134.391c-1.422.256-1.994 1.025-1.994 1.894 0 1 .622 1.652 2.024 1.652 1.079 0 1.838-.306 2.42-.884.588-.582.678-1.522.678-2.48v-.573h.006ZM0 24.836c.352-1.19 1.14-2.074 2.004-2.923 1.371-1.341 1.351-1.949.216-3.516-.558-.768-1.055-1.632-1.336-2.531-.276-.884.09-1.753.738-2.456.322-.347.628-.708.934-1.075.558-.678.613-1.406.427-2.27-.25-1.18-.296-2.4-.457-3.606-.06-.452-.14-.914-.311-1.336-.251-.643-.648-1.236-.874-1.889-.377-1.08-.025-2.094.844-2.747.849-.633 1.979-.688 2.863.045.617.513 1.16.538 1.883.357C8.719.442 10.517.542 12.31.964c.311.076.763-.025 1.024-.216C14.5-.105 15.61-.22 16.564.492c1.03.774 1.346 1.974.633 3.29-.698 1.28-1.13 2.531-.96 4.023.08.683-.16 1.441-.401 2.11-.352.974-.206 1.797.462 2.556.24.27.477.542.718.818 1.17 1.351 1.23 2.888.16 4.345-.381.517-.803 1-1.144 1.541-.533.854-.468 1.452.195 2.2.352.397.739.759 1.11 1.14a5.082 5.082 0 0 1 .548 6.364c-.88 1.29-2.18 1.753-3.918 1.1-2.24-.839-4.51-.95-6.825-.648-.628.08-1.24.306-1.843.512-2.823.96-4.36.15-5.133-2.717-.025-.1-.106-.186-.156-.281C0 26.172 0 25.504 0 24.835Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgEmmareact);

/***/ }),

/***/ 34958:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgEveningstandardreact = function SvgEveningstandardreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    fill: "none",
    "aria-label": "Evening Standard logo",
    viewBox: "0 0 235 28",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M37.953 12.51V9.569c0-1.608-.51-2.275-1.293-2.275-1.097 0-1.762 1.373-1.92 5.255h3.212v-.04Zm14.961-1.177c0-1.372-.822-1.804-1.723-1.804-.627 0-1.371.314-1.645.51v9.608c0 1.177.43 1.49 1.41 1.686v.314h-7.951v-.314c.548-.117 1.292-.51 1.292-1.764V8.902c0-1.294-.352-1.608-1.292-1.804v-.314h6.737l-.157 2.941C50.525 8 52.131 6.51 54.363 6.51c1.959 0 3.956.941 3.956 4.274v8.785c0 .94.157 1.568 1.097 1.764v.314h-7.52v-.314c.705-.156 1.136-.666 1.136-1.764v-8.236h-.118Zm7.99-2.47c0-.941-.274-1.608-1.214-1.804v-.314h6.502V19.53c0 .942.352 1.648 1.292 1.765v.314h-7.911v-.314c.94-.117 1.292-.823 1.292-1.765V8.863h.04Zm5.444-5.883c0 1.569-1.292 2.824-2.859 2.824a2.81 2.81 0 0 1-2.82-2.824c0-1.529 1.293-2.784 2.82-2.784 1.567 0 2.86 1.216 2.86 2.784Zm11.241 8.353c0-1.372-.822-1.804-1.723-1.804-.627 0-1.371.314-1.645.51v9.608c0 1.177.391 1.49 1.41 1.686v.314h-7.794v-.314c.509-.117 1.096-.51 1.096-1.764V8.902c0-1.294-.352-1.608-1.292-1.804v-.314h6.736l-.156 2.941C75.16 8 76.767 6.51 78.999 6.51c1.959 0 3.956.941 3.956 4.274v8.785c0 .94.157 1.568 1.097 1.764v.314h-7.52v-.314c.705-.156 1.136-.666 1.136-1.764v-8.236h-.079Zm14.727-.078c0-2.824-.314-4.04-1.293-4.04-1.018 0-1.41 1.256-1.41 4.04v.47c0 2.824.392 4.04 1.41 4.04.94 0 1.293-1.255 1.293-4.04v-.47Zm52.013 7.765c-.509 1.294-2.154 2.784-4.778 2.784-2.742 0-3.486-1.765-3.486-3.49V7.686h-1.292v-.353c1.958-.313 4.739-1.96 6.266-3.608h.314v3.06h2.898v.94h-2.898v10.197c0 .98.47 1.568 1.41 1.568.626 0 1.135-.313 1.331-.588l.235.118Zm24.558-7.687c0-1.372-.823-1.804-1.724-1.804-.626 0-1.37.314-1.645.51v9.608c0 1.177.392 1.49 1.41 1.686v.314h-7.872v-.314c.548-.117 1.175-.51 1.175-1.764V8.902c0-1.294-.353-1.608-1.293-1.804v-.314h6.737l-.157 2.941c.94-1.725 2.546-3.215 4.779-3.215 1.958 0 3.956.941 3.956 4.274v8.785c0 .94.156 1.568 1.096 1.764v.314h-7.598v-.314c.705-.156 1.136-.666 1.136-1.764v-8.236Zm16.097 6.589c0 1.255-1.096 1.843-1.801 1.843-1.489 0-2.233-1.06-2.233-2.745V9.686c0-1.608 1.058-2.274 2.154-2.274.94 0 1.919.706 1.919 2.039v8.47h-.039ZM2.389 3.765c0-1.216-.47-2.236-2.389-2.392v-.51h16.41v5.333h-.547c-1.841-3.02-2.429-4.47-4.348-4.47H8.421v9.137h1.292c2.076 0 2.742-.902 3.76-3.412h.47v7.647h-.47c-1.057-2.51-1.684-3.412-3.76-3.412H8.421v7.49c0 1.06.392 1.608 1.958 1.608h.862c3.016 0 3.877-2 5.836-5.294h.509l-.588 6.196H0v-.51C1.92 21.02 2.39 20 2.39 18.785V3.764Zm189.293 17.882v-.314c-1.254-.196-1.41-.823-1.41-1.764V.902h-6.894v.392c1.41.157 1.606.235 1.606 1.02v5.333c-.509-.627-1.723-1.137-3.251-1.137-3.172 0-6.501 2.51-6.501 8 0 5.098 2.232 7.53 5.444 7.53 2.428 0 3.799-1.491 4.269-2.51v2.156h6.737v-.039Zm36.66-3.725c0 1.294-1.097 1.843-1.841 1.843-1.488 0-2.233-1.06-2.233-2.745V9.686c0-1.608 1.058-2.274 2.154-2.274.94 0 1.92.706 1.92 2.039v8.47ZM235 21.647v-.314c-1.253-.196-1.371-.823-1.371-1.764V.902h-6.893v.392c1.41.157 1.606.235 1.606 1.02v5.333c-.509-.627-1.724-1.137-3.251-1.137-3.173 0-6.502 2.51-6.502 8 0 5.098 2.233 7.53 5.444 7.53 2.429 0 3.8-1.491 4.27-2.51v2.156H235v-.039Zm-35.563-2.196v-6.863c-.274 1.53-2.507 1.883-2.507 4.55v.117c0 1.294.901 2.274 2.037 2.274.117-.039.274-.078.47-.078Zm13.356-8.431v8c0 1.411.391 2 1.645 2.274v.314h-8.147v-.314c.509-.117 1.175-.47 1.175-1.765V8.863c0-.941-.353-1.608-1.293-1.804v-.314h6.698c-.078 1.412-.078 2.353-.078 4.275Zm6.188-1.765c0 1.568-1.293 2.823-2.859 2.823a2.81 2.81 0 0 1-2.82-2.823c0-1.53 1.253-2.784 2.82-2.784 1.566 0 2.859 1.254 2.859 2.784ZM152.163 19.45v-6.863c-.275 1.53-2.507 1.883-2.507 4.55v.117c0 1.294.901 2.274 2.037 2.274.117-.039.274-.078.47-.078Zm-67.798-8c0-3.059 2.938-4.98 6.658-4.98a9.58 9.58 0 0 1 3.251.549c.392.039.784.039 1.175.039 1.45 0 2.781-.275 4.073-.863v2.51h-.156c-.744-.079-2.781-.745-4.191-1.294 1.488.902 2.507 2.274 2.507 4.039 0 3.137-2.938 5.059-6.62 5.059-3.446.039-6.697-1.608-6.697-5.059Zm3.212 4.392c-.275.235-.47.55-.47.941 0 .47.274.902 1.331.902l5.68.079c3.72.039 4.856 2.117 4.856 3.843 0 4.549-5.209 6.392-8.969 6.392-4.74 0-6.423-1.412-6.423-3.098 0-1.02 1.018-2.04 3.094-2.04.274 0 .548.04.861.08l.04.078a2.12 2.12 0 0 0-.823 1.647c0 1.215 1.136 2.47 4.23 2.47 3.055 0 4.974-1.255 4.974-2.627 0-1.177-.822-1.647-2.937-1.726l-4.27-.196c-3.133-.157-4.308-1.647-4.308-3.372 0-1.216 1.019-2.824 2.82-3.412l.314.04Zm36.19-3.686c-1.645-1.177-3.016-2.824-3.016-5.059 0-3.804 3.368-6.51 8.225-6.51 2.115 0 4.112.51 5.444.98l-.157 4.903h-.587c-1.489-3.216-2.507-4.98-4.7-4.98-1.684 0-2.938 1.136-2.938 2.94 0 1.216.823 2.236 1.959 3.06l3.094 2.274c2.389 1.725 3.838 3.058 3.838 5.49 0 4.196-4.073 6.667-8.186 6.667-2.624 0-5.052-.745-6.227-1.412l-.235-5.53h.587c1.802 3.843 3.329 6.04 5.758 6.04 1.606 0 2.898-1.02 2.898-2.942 0-1.49-1.136-2.51-2.624-3.607l-3.133-2.314Zm-80.88 4.666c-.783 2.746-2.937 5.138-6.854 5.138-4.465 0-6.893-3.294-6.893-7.059 0-4.784 2.898-8.392 7.638-8.392 3.485 0 6.07 2.157 6.07 6.392v.588h-8.107c0 3.843 1.84 5.333 3.916 5.333 1.41 0 2.82-.51 3.917-2.078l.314.078Zm116.639 3.295c-.979 1.059-2.507 1.843-4.387 1.843-1.841 0-2.781-.824-2.976-2.079-.745 1.177-1.959 2.04-3.8 2.04-2.31 0-3.955-1.57-3.955-3.765 0-2.628 1.801-3.608 4.66-4.353 2.311-.588 3.173-1.412 3.173-3.177v-.117c0-1.804-1.488-3.02-3.29-3.02-.47 0-.901.079-1.371.196 1.332.118 2.428 1.216 2.428 2.55 0 1.45-1.175 2.587-2.663 2.587-1.41 0-2.467-1.098-2.467-2.51 0-2.391 3.29-3.882 6.893-3.882 3.486 0 5.718 1.412 5.718 3.961 0 .04 0 3.412-.078 8.628 0 .627.274 1.098.94 1.098.274 0 .627-.079.979-.275l.196.275Zm47.274 0c-.979 1.059-2.507 1.843-4.387 1.843-1.84 0-2.78-.824-2.976-2.079-.744 1.177-1.959 2.04-3.799 2.04-2.311 0-3.956-1.57-3.956-3.765 0-2.628 1.801-3.608 4.661-4.353 2.31-.588 3.172-1.412 3.172-3.177v-.117c0-1.804-1.488-3.02-3.29-3.02-.47 0-.901.079-1.371.196 1.332.118 2.429 1.216 2.429 2.55 0 1.45-1.175 2.587-2.664 2.587-1.371 0-2.467-1.098-2.467-2.51 0-2.391 3.29-3.882 6.893-3.882 3.525 0 5.718 1.412 5.718 3.961 0 .04 0 3.412-.039 8.628 0 .627.274 1.098.94 1.098.274 0 .588-.079.979-.275l.157.275Zm-181.538 1.53h-4.308L16.92 9.215c-.43-1.294-.94-1.922-1.528-2.118v-.314h9.048v.314c-1.567.275-2.154.863-1.723 2.275l2.741 9.098 2.272-8.157c.196-.745.313-1.334.313-1.883 0-.98-.665-1.215-1.488-1.333v-.314h4.622v.314c-.823.275-1.41.706-2.194 3.098l-3.72 11.451Zm89.183-5.765c.039-.039.039-.078.039-.156-.039-.04-.078-.079-.117-.079h-.079c-.039 0-.078.04-.039.079 0 .117.078.156.196.156Zm-9.283-4.51c-.156-.039-.274-.078-.391-.078-.157-.04-.353-.04-.509-.078-.079-.04-.118-.04-.196 0l.391.235s.04 0 .04.04h.078c.196 0 .352 0 .548-.04 0-.04 0-.04.039-.078Zm4.113-1.529v.04c0 .039.039.078.078.078.039.039.079.039.118 0 .117-.079.235-.118.352-.157.314-.078.627-.157.979-.04h.04c.039 0 .078-.038.039-.078 0-.039-.039-.039-.039-.039a.561.561 0 0 0-.275-.078h-.391a2.54 2.54 0 0 0-.784.117c0 .079-.078.118-.117.157Zm5.797 2.118c.039-.079.039-.157.078-.236v-.078a.183.183 0 0 0-.313 0c-.04.079-.079.196-.04.275 0 .039 0 .039.04.078a.765.765 0 0 0 .352.353c.039.04.118.04.157.078.078.04.196.118.274.197.117.078.157.235.157.352 0 .04 0 .079.039.118a.435.435 0 0 0 0-.314c-.079-.117-.118-.196-.196-.313l-.235-.236c-.196-.078-.235-.196-.313-.274Zm-1.724 8.196c-.039.04-.078.04-.117.078a.637.637 0 0 1-.274.157c-.118.04-.235.04-.353.04h-.705a.356.356 0 0 0-.313.156c-.079.079-.118.157 0 .275.039.078.117.078.196.078.078 0 .117-.078.117-.157v-.039c.078-.04.196-.078.313-.117h.275a.79.79 0 0 0 .43-.118c.04-.04.079-.079.157-.079a1.04 1.04 0 0 0 .235-.196c0-.039 0-.039.039-.078Zm-2.663-6.667c0 .079 0 .157.039.196.039.118.078.236.078.353 0 .079.04.196.079.275.117.235.274.431.391.666.079.157.157.353.235.51a.66.66 0 0 0-.039.47c.039 0 .039-.038.039-.078.04-.117.04-.235.157-.313.078-.079.078-.157.039-.236-.078-.196-.156-.392-.313-.588-.118-.157-.235-.353-.353-.51a1.453 1.453 0 0 1-.195-.431c.039-.079 0-.235-.157-.314Zm5.483-4.627c0-.04 0-.04-.039-.04-.196 0-.392-.039-.627-.039-.195 0-.391 0-.587.04h-.157a9.178 9.178 0 0 0-1.018.156c-.235.04-.431.118-.666.157-.352.079-.666.196-1.018.314-.274.118-.588.196-.862.314-.039 0-.078.039-.117.039-.04 0-.04.04-.079.078a.833.833 0 0 0 .235.157l.118-.078c.078-.04.196-.118.274-.157.235-.078.47-.196.666-.275.196-.078.391-.156.587-.196.235-.078.47-.117.666-.196a8.65 8.65 0 0 1 .979-.196c.47-.039.94-.078 1.41-.078h.235Zm-1.88 6.706c.079.078.118.078.196.078h.157c.196-.078.274-.314.196-.51 0-.039-.04-.078-.04-.117a.432.432 0 0 1 0-.314c.04-.079.118-.157.157-.235.118-.157.235-.236.392-.353.196-.157.352-.353.391-.589a.329.329 0 0 0 0-.274l-.039-.04s-.039 0-.039.04-.039.078-.039.157c-.039.078-.039.157-.078.196a.922.922 0 0 1-.275.274 1.532 1.532 0 0 0-.391.314c-.196.157-.392.353-.509.588-.118.157-.157.353-.118.55a.5.5 0 0 1 .039.235Zm-9.047-8.824c-1.175-1.02-2.037-2.235-2.546-3.686-.039 0-.039 0-.078.04a.296.296 0 0 0-.079.195c0 .118 0 .235.039.314.079.196.196.431.314.627.196.353.391.667.626.98.157.197.353.432.51.628.274.314.587.55.9.784.079.04.118.079.157.118.039.04.078.04.157 0Zm-.157 18.667c.039-.04.039-.079.039-.079 0-.078.039-.196.039-.274 0-.157.04-.314.079-.431.078-.236.156-.432.235-.667.078-.235.156-.47.235-.667.039-.157.117-.314.156-.47a188.151 188.151 0 0 0 .353-1.06c0-.038.039-.078.039-.117.039-.04.039-.118.039-.157 0-.078.039-.157.079-.235 0-.04.039-.078.039-.118.039-.078.039-.157-.039-.235 0-.04-.04-.04-.079-.04a.56.56 0 0 0-.078.236c0 .079-.078.079-.118.04-.156-.158-.235-.354-.274-.589 0-.078-.039-.157-.039-.235 0-.079-.039-.118-.078-.118 0 .04-.039.04-.039.078v.314c0 .118.039.196.039.314v.667c0 .157 0 .274-.039.431 0 .118 0 .235-.04.353-.039.353-.156.706-.235 1.059-.039.196-.117.392-.156.588-.039.235-.118.431-.196.667a1.841 1.841 0 0 0-.118.666v.118c.079-.118.118-.078.157-.04ZM103.087 8c-.079.078-.079.235-.04.314.04.117.118.196.235.274.04 0 .079.04.079.04v.235c.039.196.117.235.313.235h.431c.078 0 .157-.04.235-.078.235-.118.509-.236.744-.393 0 0 .039-.039.078-.039-.078-.039-.117-.039-.156-.039-.118-.04-.274-.078-.392-.157-.196-.078-.392-.196-.627-.314a4.332 4.332 0 0 1-.587-.313 2.155 2.155 0 0 1-.353-.275c-.156-.157-.313-.314-.43-.51 0-.039-.04-.039-.04-.078 0-.04-.039-.04-.078 0 0 .078 0 .196.039.274 0 .118.079.236.157.353.157.157.274.314.392.471Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M105.828 8.078c.04-.039.04-.078 0-.078a7.99 7.99 0 0 1-.705-.51c-.352-.235-.744-.47-1.057-.784-.196-.196-.431-.353-.627-.55-.117-.156-.274-.313-.391-.47a3.362 3.362 0 0 1-.51-.98 1.419 1.419 0 0 1-.078-.902v-.079c0-.117-.039-.196-.078-.313 0-.04-.039-.079-.079-.118-.078.079-.117.157-.156.235-.118.314-.079.628 0 .98.078.354.235.667.391.981.04.04.04.079.079.118-.079.157-.079.157-.039.314.039.117.078.235.195.313.118.118.196.236.353.353.157.118.274.275.431.353l.94.588c.313.197.666.314.979.432l.352.117Zm2.155 1.334c.039 0 .039-.04.039-.04v-.078c0-.274 0-.51-.039-.784-.04-.196-.04-.432-.118-.628a2.895 2.895 0 0 0-.196-.627c-.078-.235-.196-.47-.313-.706-.078-.196-.196-.392-.274-.588-.118-.236-.274-.47-.431-.745-.039-.079-.118-.157-.157-.275l-.078-.078v.078c0 .04.039.079.078.118.039.157.118.353.157.51.078.196.117.392.157.588.039.196.039.392.039.588.039.275-.039.55-.118.824a1.796 1.796 0 0 1-.196.392c-.078.157-.156.314-.313.431v.04c.039 0 .078.039.157.039.235.039.431.117.666.235.274.157.509.353.783.549l.117.118.04.039Zm-1.528 6.117c-.078.079-.196.157-.274.236a4.184 4.184 0 0 0-.431.353c-.157.117-.078.117-.313.039-.039 0-.079-.04-.118-.079-.078-.039-.117-.117-.196-.156l-.117-.118c-.118-.196-.274-.431-.313-.627l-.04-.04c-.039 0-.078-.039-.117-.039 0 .04-.039.04-.039.079-.079.156-.157.313-.274.43-.157.197-.275.432-.392.668a7.713 7.713 0 0 0-.235.549c0 .039-.039.078 0 .156.039 0 .078-.039.117-.039.079-.039.157-.039.196-.039.196 0 .392.04.549.078.274.079.548.079.783-.078.157-.079.274-.118.431-.196.117-.04.274-.078.391-.078.235 0 .431-.04.666-.04h.079c.117-.039.235-.078.352-.157.118-.039.196-.157.313-.157l.04-.039c.235-.157.391-.392.548-.627.039-.04.039-.079 0-.118h-.039c-.039 0-.079.04-.118.04-.078.039-.196.039-.274.078-.235 0-.431.04-.666.04a1.348 1.348 0 0 0-.509-.119Zm-1.958 11.883c-.118.078-.118.078-.274.117-.157.04-.353.04-.51.079-.195 0-.391.04-.587.04h-.039l-.039.038c-.04.079-.04.157 0 .196 0 .04.039.079.078.079h3.682c.078 0 .078-.04.078-.079v-.078c0-.118-.039-.157-.118-.157-.117-.04-.235-.04-.391-.078h-.118c-.039-.118-.039-.236-.156-.314h-.157c-.078 0-.118 0-.196.04a.431.431 0 0 1-.313 0 1.373 1.373 0 0 1-.509-.315c-.04-.039-.079-.117-.118-.157 0-.039-.039-.078-.039-.117-.039-.078-.078-.157-.039-.275v-.117c0-.157-.118-.236-.274-.236h-.079c-.078 0-.156-.039-.196-.156v-.118c.04-.118.079-.235.157-.353.157-.314.274-.667.353-.98.039-.275.117-.51.156-.785.039-.157.079-.313.079-.47 0-.236.039-.47.117-.667.039-.157.078-.314.118-.51v-.117c0-.157-.04-.314 0-.471-.118-.04-.118-.04-.196.04 0 0 0 .038-.039.078-.157.313-.275.588-.431.902a1.079 1.079 0 0 0-.118.51c0 .195.039.352.039.548v.393c-.039.117-.039.274-.078.392-.039.196-.117.353-.157.549a1.835 1.835 0 0 1-.235.588c0 .04-.039.04-.039.078-.078.079-.117.197-.196.275-.078.196-.078.353.04.51.117.157.195.353.274.549.039.117.078.235.156.353.196.039.235.117.314.196Zm-1.058-18.118c-.078.04-.078.118-.078.196.078.196.196.392.392.51-.079.157-.196.274-.196.47 0 .157.039.353.117.471h.039c.196-.039.392 0 .549.04.078.039.156.039.274 0 .117-.04.235-.04.392-.04h.313a.084.084 0 0 0 .078-.078c0-.079-.039-.118-.078-.196-.039-.118-.078-.196-.039-.314l.039-.04c.157-.078.313-.117.509-.156.039 0 .039 0 .039-.04-.039 0-.078-.039-.117-.039-.118 0-.235-.039-.353 0-.196 0-.352-.078-.509-.117-.039 0-.039-.04-.078-.04l-.118-.235c0-.039 0-.078.039-.117a1.03 1.03 0 0 1 .353-.196c.157-.04.313-.079.431-.118.078-.04.156-.04.235-.04.078 0 .117 0 .156.04.118.118.235.235.314.431.039.157.117.314.156.47.04.118.079.275.118.432v.392h.039c.118 0 .235-.039.353-.078.313-.118.587-.118.861.04.118.078.235.117.314.195.039.04.078.04.117.079h.039v-.04s0-.039-.039-.039l-.47-.706a4.21 4.21 0 0 0-.587-.862c-.157-.196-.314-.393-.51-.55-.039-.039-.078-.078-.117-.078-.196-.117-.431-.157-.627-.235a.25.25 0 0 0-.235 0l.118.157c-.039 0-.079 0-.118.039-.156 0-.274.04-.391.078-.118.04-.275.079-.392.157h-.039a3.252 3.252 0 0 1-.823.236.534.534 0 0 1-.47-.079Zm-.235 1.883c-.078 0-.117.078-.196.117a.216.216 0 0 0-.117.196v.196c.078.118.117.275.196.392.156.236.313.471.548.628 0 0 0 .04.039.04-.039.077-.117.117-.156.156a.614.614 0 0 1-.627.118c-.039 0-.078-.04-.118-.04-.117-.039-.235-.039-.313.079l-.117.118a.588.588 0 0 0-.157.43v.197c0 .118 0 .274-.078.353 0 .078.078.157.156.157a.335.335 0 0 0 .274 0 .741.741 0 0 1 .314-.079h.156c.04 0 .079-.039.079-.078 0-.079 0-.157-.039-.235-.04-.04-.079-.079-.157-.079-.039 0-.078.04-.118 0-.078 0-.156 0-.235.079-.039.039-.078.078-.156.039 0-.196.039-.353.156-.47.079-.08.157-.158.275-.158a1.14 1.14 0 0 1 .352-.078 1.91 1.91 0 0 0 .431-.157h.078v.079c0 .078-.039.156-.078.274v.235a.485.485 0 0 0 .235.314l.039.04-.039.078c-.039.078-.039.117-.078.196-.04.157-.04.313.078.431.078.079.157.196.274.235.078.04.118.04.157 0a1.28 1.28 0 0 1 .626-.274c.079 0 .157-.079.196-.118.079-.157.196-.274.274-.431a.929.929 0 0 1 .314-.353.357.357 0 0 0 .117-.275c0-.117.039-.235.039-.313.04-.118.079-.196.118-.314a.856.856 0 0 1 .117-.196s.04-.04.04-.079h-.079a1.14 1.14 0 0 1-.352-.078c-.039 0-.039-.04-.079-.04a.66.66 0 0 0-.391-.117h-.118s-.039 0-.078-.039c.039-.04.078-.04.078-.04a.25.25 0 0 1 .235 0c.118.04.235.08.353.118.078.04.196.04.274.118.078.04.117 0 .157-.04.039-.038.078-.038.117-.078.039.079 0 .118.039.157 0 .079.039.118.039.196v.079c0 .117.04.196.079.314.039.078.078.196.117.274l.118.235a.4.4 0 0 0 .235.196v-.078c0-.04-.039-.079-.079-.118-.078-.157-.156-.274-.235-.431 0-.04-.039-.079-.039-.118 0-.157-.039-.314-.039-.47 0-.196.039-.432.039-.628 0-.078 0-.157.039-.235v-.118c-.078-.039-.156-.078-.195-.117-.04 0-.079-.04-.157-.04l-.039.04.039.039c.039 0 .039.04.078.04 0 0 .039.038 0 .038 0 .04-.039.04-.078.04s-.078 0-.118-.04c-.039 0-.078-.039-.117-.039-.039 0-.118.079-.118.118l.04.039h.078c.078 0 .157 0 .235.04 0 .117 0 .156-.078.156-.118 0-.275.04-.392 0-.039 0-.039 0-.039.04 0 .038 0 .078.039.078h.196c.039 0 .078.039.117.078v.079s-.039.039-.039 0a.725.725 0 0 1-.274-.079.725.725 0 0 1-.274-.078c-.079-.04-.118-.079-.196-.118-.039 0-.078-.04-.118 0-.156.078-.352.157-.509.235a1.585 1.585 0 0 1-.352.196.25.25 0 0 1-.235 0c-.157-.078-.314-.156-.431-.313a3.509 3.509 0 0 1-.313-.51c-.04-.079-.04-.196 0-.314-.079 0-.04-.04-.079-.117Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M107.983 7.373v-.197c-.079-.235-.157-.51-.235-.745a412.34 412.34 0 0 1-.47-.94c0-.04-.04-.04-.04-.08-.078-.156-.195-.274-.274-.43-.117-.236-.274-.471-.391-.706-.079-.118-.118-.236-.196-.353-.118-.236-.235-.432-.353-.667l-.235-.47c-.078-.158-.117-.275-.196-.432-.039-.078-.039-.157-.078-.235-.078-.275-.196-.51-.313-.785a2.697 2.697 0 0 0-.118-.313c-.039-.079-.078-.196-.117-.275-.079-.157-.157-.353-.275-.51a.605.605 0 0 0-.313-.235h-.078a.355.355 0 0 0-.313.157c-.157.118-.236.314-.275.51-.039.117-.039.627-.039.745 0 .039 0 .078-.039.078a.837.837 0 0 0-.47-.157.41.41 0 0 0-.352.196c0 .04-.04.079-.04.118a1.75 1.75 0 0 0-.039 1.177c.078.196.157.352.235.549.118.313.274.588.47.862.157.275.353.55.509.785.157.235.275.431.431.627.196.275.47.51.705.745l.353.353c.196.157.431.314.626.47 0 0 .04 0 .04.04h.039v-.04c0-.039 0-.039-.039-.078-.079-.078-.157-.117-.196-.196-.079-.078-.196-.157-.274-.235l-.235-.235c-.196-.196-.392-.353-.549-.589-.078-.117-.196-.235-.313-.353-.196-.196-.313-.431-.509-.666-.314-.432-.51-.902-.705-1.412-.118-.275-.157-.588-.235-.902a1.125 1.125 0 0 1 0-.51c0-.078.039-.117.078-.196.039-.078.078-.118.196-.078.078 0 .117.039.156.117.079.275.118.55.236.824.117.392.274.784.43 1.137.196.392.392.745.666 1.098.274.392.588.745.94 1.059l.196.196c.118.079.235.196.353.275.039.039.078 0 .078-.04-.118-.156-.235-.313-.392-.47a7.985 7.985 0 0 1-.509-.706c-.078-.157-.157-.275-.235-.431L104.81 4a10.078 10.078 0 0 1-.431-.941c0-.04 0-.04-.039-.079-.078-.117-.078-.196-.117-.313-.04-.157-.079-.275-.118-.432-.078-.196-.117-.392-.157-.588-.039-.235-.039-.47-.039-.745 0-.118.039-.235.118-.314l.078-.078c.039-.04.118-.04.157 0a.48.48 0 0 1 .196.196c.078.157.195.353.274.51.156.353.313.706.509 1.059.078.156.157.352.274.51.157.313.353.627.509.94.157.275.314.51.47.746.157.235.314.47.47.745.157.235.274.47.392.666l.235.47c.117.354.274.707.392 1.02Zm-2.86 13.803c.04 0 .079 0 .079-.039v-.078a1.125 1.125 0 0 1 0-.51l.039-.196c0-.079 0-.157-.039-.235-.079-.236-.157-.51-.118-.745 0-.432.039-.863.157-1.295 0-.117.078-.196.196-.235.078-.04.196-.078.274-.117.117-.04.157 0 .196.117v.04l.039.274c.117.47.196.902.235 1.372v.04c.039.196.078.392.039.588v.431c.078 0 .078-.039.118-.078l.117-.353c.078-.275.118-.55.157-.824.039-.196.039-.392.078-.588v-.431c0-.314-.039-.588-.039-.902 0-.079 0-.157.078-.196.079-.118.157-.196.274-.314 0-.04.04-.04 0-.079-.078 0-.156.079-.195.118l-.823.47c-.039 0-.078.04-.078.04-.235.118-.509.157-.705.314-.039 0-.079.039-.079.039-.156.04-.352.078-.509.118a3.26 3.26 0 0 0-.666.196c-.078.039-.156.039-.235.039-.196 0-.43.04-.626-.04a1.398 1.398 0 0 1-.353-.156c-.039 0-.039-.04-.078-.079-.039-.078-.039-.117 0-.157.039-.039.117-.039.157 0 .039.04.117.079.195.079.157.04.275.078.431.118.235.039.509.039.744-.118a.549.549 0 0 1 .235-.078c.157 0 .314-.079.431-.079.196-.04.392-.118.588-.196.078-.04.156-.04.235-.078.274-.118.587-.275.861-.393.235-.117.47-.235.666-.392 0 0 .039-.039 0-.039h-.039c-.117.04-.235.118-.313.157a1.384 1.384 0 0 1-.666.157c-.157 0-.274 0-.431.078-.157.079-.274.118-.431.196-.039.04-.117.04-.156.079-.079 0-.118.039-.157.039a.655.655 0 0 1-.47-.04c-.157-.038-.274-.078-.431-.078a.733.733 0 0 0-.313.079c-.118.039-.274.039-.392.039-.117 0-.235-.078-.313-.157 0 0-.039-.04-.039-.078-.04-.04-.04-.118 0-.197.078-.195.156-.392.274-.588.039-.039.039-.078.078-.117.078-.118.157-.196.196-.314.117-.196.274-.392.431-.55l.078-.077v-.04h-.039c-.039.04-.118.079-.157.118-.274.235-.548.51-.744.823 0 .04-.039.079-.078.079h-.039c-.314-.079-.549 0-.823.196a6.692 6.692 0 0 0-.548.47c-.079.079-.118.157-.196.197-.118.078-.235.157-.392.157-.039 0-.078.039-.117.039l.078.078c.157.04.274.079.431.079.117 0 .235-.04.313-.04a.558.558 0 0 0 .235-.078l.235-.118c.196-.274.196-.274.313-.314-.117.236-.195.471-.274.706-.039.04-.078.04-.156.079a1.741 1.741 0 0 0-.588.47l-.078.079a4.203 4.203 0 0 0-.431.392l-.039.04c0 .039-.039.117-.039.156 0 .04 0 .118.039.157v.04c-.079.117-.079.156.039.235l.039.039c0 .196.039.196.235.274 0 .04 0 .04.039.079.079.157.196.157.314.078l.078-.078c.039-.118.157-.157.235-.236.117-.039.196-.156.235-.235.039-.078.078-.196.117-.274 0-.079.04-.157.118-.197.039.079.039.118.078.197 0 .117.079.156.157.196.078.039.157.039.274.078.078 0 .196 0 .274-.078.04-.04.118-.079.157-.118.235-.157.47-.353.705-.55.039-.038.078-.038.118-.038.117-.04.274-.04.391-.079h.078c.04 0 .079-.039.079 0v.157c-.039.196-.079.353-.079.55 0 .352.079.705.236 1.058.039.078.078.118.078.157a.5.5 0 0 1 .039.235c0 .236.039.431.039.667-.039 0 0 .078.039.117Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M105.123 21.177c-.039-.079-.078-.118-.078-.197-.039-.235-.078-.431-.039-.666 0-.079 0-.157-.039-.236a.3.3 0 0 1-.079-.156 2.47 2.47 0 0 1-.235-1.06c0-.195 0-.391.079-.548 0-.04.039-.118 0-.157-.039-.04-.079 0-.079 0h-.078c-.117.04-.274.04-.392.078-.039 0-.078.04-.117.04-.235.196-.47.353-.705.549-.039.039-.118.078-.157.117a.562.562 0 0 1-.274.079c-.078 0-.157-.04-.274-.079-.078-.039-.157-.078-.157-.196 0-.078-.039-.117-.078-.196a.217.217 0 0 0-.118.196 1.918 1.918 0 0 1-.117.275c-.039.117-.157.196-.235.235a.352.352 0 0 0-.235.235c0 .04-.039.079-.078.079-.118.117-.235.078-.314-.079 0-.039 0-.039-.039-.078-.196-.04-.196-.079-.235-.275l-.039-.039c-.118-.078-.157-.118-.039-.235v-.04c0-.039-.039-.117-.039-.156 0-.079.039-.118.039-.157l.039-.04c.157-.117.313-.274.431-.392l.078-.078c.157-.196.392-.353.588-.47.039-.04.078-.04.156-.079.079-.235.157-.47.274-.706-.156.04-.156.04-.313.314l-.235.117c-.078.04-.157.04-.235.079a.97.97 0 0 1-.313.04c-.157 0-.314-.04-.431-.08-.039 0-.039-.038-.078-.078.039 0 .078-.039.117-.039.157 0 .274-.04.392-.157l.196-.196c.156-.196.352-.353.548-.47a.888.888 0 0 1 .822-.197h.04c0-.039.039-.039.078-.078a5.05 5.05 0 0 1 .744-.823c.039-.04.118-.079.157-.118h.039v.039c0 .04-.039.079-.078.079a2.924 2.924 0 0 0-.431.549c-.079.117-.118.196-.196.313-.039.04-.078.079-.078.118-.079.196-.157.392-.275.588-.039.078-.039.118 0 .196 0 .04.04.04.04.079.078.117.156.157.313.157.117 0 .274 0 .392-.04.117-.039.195-.039.313-.078.157 0 .313 0 .431.078.156.079.313.04.47.04.039 0 .117-.04.156-.04.079 0 .118-.039.157-.078.157-.079.274-.157.431-.196a1.38 1.38 0 0 1 .431-.079c.235.04.47-.039.666-.156l.313-.157h.039v.039c-.235.117-.431.274-.666.392-.274.118-.587.274-.861.392a.551.551 0 0 1-.235.079c-.196.078-.392.117-.588.196-.157.039-.274.078-.431.078-.078 0-.156.04-.235.079a1.21 1.21 0 0 1-.744.117c-.157-.04-.274-.078-.431-.117-.078-.04-.117-.04-.196-.079-.078-.04-.117-.04-.156 0a.12.12 0 0 0 0 .157c0 .04.039.04.078.078.118.04.235.118.353.157.195.04.43.04.626.04.079 0 .157-.04.235-.04.235-.078.47-.117.666-.196.157-.04.353-.078.509-.117.039 0 .079 0 .079-.04.235-.117.47-.196.705-.313.039 0 .078 0 .078-.04.274-.156.548-.274.822-.47.079-.04.118-.079.196-.118.039.04.039.04 0 .078-.078.118-.156.236-.274.314a.3.3 0 0 0-.078.196c.039.275.039.589.039.902v.432c-.039.196-.039.392-.078.588-.04.274-.118.549-.157.823a48.69 48.69 0 0 1-.118.353c0 .04-.039.079-.117.079v-.432c0-.196 0-.392-.039-.588v-.039c-.039-.47-.157-.902-.235-1.373 0-.078-.039-.156-.039-.274v-.04c-.04-.117-.079-.117-.196-.117-.118.04-.196.079-.274.118-.079.039-.157.157-.196.235a4.857 4.857 0 0 0-.157 1.294c0 .275.039.51.118.745a.5.5 0 0 1 .039.235l-.039.197c-.04.157-.04.352 0 .51v.078c.039.117 0 .157-.04.117Zm2.86-13.804a7.196 7.196 0 0 1-.392-.98l-.235-.471c-.118-.236-.274-.471-.392-.667-.156-.235-.313-.47-.47-.745-.156-.235-.313-.47-.47-.745-.156-.314-.352-.628-.509-.941-.078-.157-.157-.353-.274-.51-.196-.353-.313-.706-.509-1.06-.079-.156-.157-.352-.274-.509a.48.48 0 0 0-.196-.196c-.039-.04-.118-.04-.157 0-.039 0-.039.04-.078.078a.443.443 0 0 0-.118.314c0 .235 0 .47.039.745.04.196.079.392.157.589.039.156.078.274.118.43.039.119.078.236.117.315 0 .039.039.039.039.078.118.314.274.627.431.941.118.275.274.55.47.824.078.117.157.274.235.431.157.235.313.47.509.706.118.157.235.314.392.47 0 .04-.039.04-.078.04-.118-.079-.235-.196-.353-.275a36.225 36.225 0 0 0-.196-.196c-.352-.314-.666-.706-.94-1.059-.235-.353-.47-.705-.666-1.098-.195-.353-.313-.745-.43-1.137l-.235-.823c-.04-.079-.04-.118-.157-.118-.078 0-.157 0-.196.078-.039.079-.039.118-.078.196a1.125 1.125 0 0 0 0 .51c.078.314.117.588.235.902.196.47.391.98.705 1.412.156.235.313.47.509.667.117.117.196.235.313.353.157.196.353.392.549.588l.235.235c.078.079.156.157.274.235.078.079.156.118.196.196 0 0 .039.04.039.079v.04h-.039s-.04 0-.04-.04c-.195-.157-.43-.314-.626-.47l-.353-.354c-.235-.235-.47-.47-.705-.745a6.169 6.169 0 0 1-.431-.627c-.156-.275-.352-.51-.509-.784-.156-.275-.313-.589-.47-.863-.078-.157-.156-.353-.235-.55-.156-.391-.156-.823.039-1.176 0-.039.04-.078.04-.117a.41.41 0 0 1 .352-.196c.157 0 .313.039.47.156.039-.039.039-.039.039-.078 0-.235 0-.51.039-.745a.942.942 0 0 1 .275-.51c.078-.078.195-.118.313-.157h.078c.118.04.235.118.314.236.117.156.195.313.274.51.039.078.078.195.117.274.039.117.079.235.118.314.078.274.196.51.313.784a.56.56 0 0 1 .078.235c.04.157.118.275.196.432l.235.47c.118.235.235.431.353.667.078.117.117.235.196.353.117.235.274.47.391.706.079.156.196.274.274.431 0 .04.04.04.04.078l.47.942c.117.235.156.47.235.745.039 0 .039.078 0 .157Zm-4.779 3.804c.039.078 0 .117 0 .156a.435.435 0 0 0 0 .314c.079.196.196.353.314.51.117.157.274.235.43.314a.25.25 0 0 0 .235 0c.118-.04.235-.118.353-.197.157-.117.352-.156.509-.235h.118c.078.04.156.079.195.118.079.04.157.078.275.078a.73.73 0 0 1 .274.079h.039c.039-.04 0-.04 0-.079-.039-.039-.039-.078-.118-.078h-.195c-.04 0-.04-.04-.04-.079s.04-.039.04-.039c.117.04.274 0 .391 0 .079 0 .118-.039.079-.157-.079-.039-.157-.039-.235-.039h-.079s-.039 0-.039-.04c0-.038.039-.117.118-.117.039 0 .078.04.117.04.039 0 .078.039.118.039.039 0 .039-.04.078-.04v-.039c0-.039-.039-.039-.078-.039l-.04-.04.04-.038c.039 0 .078 0 .156.039.079.04.118.078.196.117v.118c0 .079-.039.157-.039.235 0 .197-.039.432-.039.628 0 .157.039.314.039.47 0 .04.039.079.039.118.078.157.157.275.235.431.039.04.039.079.078.118v.079a1.073 1.073 0 0 1-.235-.197l-.117-.235c-.039-.078-.078-.196-.118-.274a.742.742 0 0 1-.078-.314v-.079c0-.078-.039-.117-.039-.196 0-.039 0-.117-.039-.156-.039.039-.079.078-.118.078-.039.04-.117.04-.156.04-.079-.04-.196-.08-.275-.118l-.352-.118a.25.25 0 0 0-.235 0c-.039 0-.039.04-.078.04.039 0 .039.038.078.038h.117c.118 0 .275.04.392.118.039 0 .039.04.078.04.118.038.196.078.353.078h.078c0 .039 0 .039-.039.078-.039.079-.078.118-.117.196-.04.118-.079.196-.118.314-.039.117-.039.235-.039.314a.354.354 0 0 1-.118.274c-.117.118-.235.235-.313.353-.078.157-.196.275-.274.431a.216.216 0 0 1-.196.118c-.235.04-.431.118-.627.275-.039.039-.078.039-.156 0-.118-.04-.196-.157-.274-.236-.118-.157-.118-.274-.079-.431 0-.079.039-.118.079-.196l.039-.079-.039-.039a.606.606 0 0 1-.235-.313.246.246 0 0 1 0-.236c.039-.078.039-.157.078-.274v-.079h-.078c-.118.079-.275.118-.431.157-.118.04-.235.079-.353.079-.117 0-.196.078-.274.156-.078.157-.157.314-.157.471.079 0 .118 0 .157-.04a.556.556 0 0 1 .235-.078h.118c.078 0 .117 0 .156.079a.5.5 0 0 1 .039.235c0 .04-.039.079-.078.079h-.157c-.117 0-.195 0-.313.078a.333.333 0 0 1-.274 0c-.078-.04-.157-.079-.157-.157.079-.118.118-.235.079-.353v-.196a.59.59 0 0 1 .156-.431l.118-.118c.078-.078.196-.118.313-.078.039 0 .078.039.118.039.195.078.43.039.626-.118.079-.039.118-.118.157-.157 0 0 0-.039-.039-.039a1.685 1.685 0 0 1-.549-.627c-.078-.118-.117-.275-.195-.393-.04-.078-.04-.156 0-.196 0-.078.039-.156.117-.196.157-.078.196-.117.274-.156Zm.235-1.883c.196.118.392.079.588.079.274-.04.548-.118.822-.236 0 0 .039 0 .039-.039.118-.078.275-.118.392-.157.118-.039.274-.078.392-.078.039 0 .078 0 .117-.04l-.117-.156h.235c.235.039.431.117.626.235.04.04.079.04.118.078.196.157.352.353.509.55.235.274.392.548.588.862.156.236.274.51.47.706 0 0 0 .04.039.04v.039h-.039c-.04 0-.079-.04-.118-.079-.117-.078-.196-.118-.313-.196a.956.956 0 0 0-.862-.04 1.12 1.12 0 0 1-.352.08h-.04v-.393c-.039-.157-.078-.274-.117-.431-.039-.157-.118-.314-.157-.47-.078-.158-.156-.315-.313-.432-.039-.04-.118-.079-.157-.04-.078 0-.156.04-.235.04-.156.039-.274.078-.431.117-.117.04-.235.079-.352.196-.039.04-.039.079-.039.118 0 .078.078.157.117.235 0 0 .039.04.079.04.156.078.352.156.509.117h.352c.039 0 .079 0 .118.04 0 .039-.039.039-.039.039a1.95 1.95 0 0 0-.51.156s-.039 0-.039.04a.419.419 0 0 0 .039.313c.04.079.04.118.079.196 0 .04 0 .079-.079.079h-.313c-.117 0-.274 0-.392.04h-.274c-.196-.04-.352-.08-.548-.04h-.039a1.038 1.038 0 0 1-.118-.47c0-.197.079-.314.196-.471-.196-.118-.313-.314-.392-.51-.156-.04-.117-.078-.039-.157Zm1.058 18.118c-.079-.079-.118-.196-.196-.275a1.402 1.402 0 0 1-.157-.353 1.042 1.042 0 0 0-.274-.549c-.117-.157-.157-.313-.039-.51a.451.451 0 0 1 .196-.274s.039-.04.039-.078l.235-.589c.039-.196.117-.392.157-.549.039-.117.039-.274.078-.392a.672.672 0 0 0 0-.392c0-.196-.039-.353-.039-.549 0-.157.039-.353.117-.51l.431-.902s.039-.039.039-.078c.039-.079.039-.079.196-.04-.039.157 0 .314 0 .471v.118c-.039.157-.078.314-.117.51a1.978 1.978 0 0 0-.118.666c0 .157-.039.314-.078.47-.039.275-.118.55-.157.785-.078.353-.157.667-.352.98a1.365 1.365 0 0 0-.157.354v.117c0 .079.078.157.196.157h.078c.157-.04.274.04.274.235v.118c0 .078 0 .157.039.274 0 .04.04.079.04.118a.545.545 0 0 0 .117.157c.157.157.313.235.509.314a.436.436 0 0 0 .314 0c.078 0 .117-.04.195-.04h.157c.078.079.078.197.157.314h.117c.118 0 .235.04.392.079.078 0 .117.078.117.157v.078c0 .078-.039.078-.078.078h-3.682a.084.084 0 0 1-.078-.078c-.039-.078-.039-.157 0-.196 0-.04.039-.04.039-.04h.039c.196 0 .392-.039.588-.039a2.3 2.3 0 0 0 .509-.078c0 .078.039.04.157-.04Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M106.455 15.53h.47c.235 0 .431-.04.666-.04a.728.728 0 0 0 .274-.078c.039 0 .078-.04.117-.04h.04c.039.04.039.079 0 .118-.157.236-.314.47-.549.628l-.039.039c-.117.04-.196.117-.313.157a1.367 1.367 0 0 0-.353.157h-.078c-.235.039-.431.078-.666.039-.157 0-.274 0-.392.078-.156.04-.274.079-.43.196-.235.157-.51.157-.784.079-.196-.079-.391-.079-.548-.079-.078 0-.157 0-.196.04-.039 0-.078.039-.117.039-.04-.04 0-.079 0-.157.078-.196.156-.353.235-.55.117-.234.235-.47.391-.666.079-.157.157-.274.274-.431 0 0 .04-.04.04-.079l.117.04.039.039c.079.235.196.431.314.627l.117.118a.687.687 0 0 0 .196.157c.039.039.078.039.117.078.196.079.157.079.314-.039.156-.118.313-.235.431-.353.117.079.195 0 .313-.118Zm1.527-6.118-.078-.079-.117-.117c-.275-.196-.51-.392-.784-.55a1.929 1.929 0 0 0-.666-.235c-.039 0-.078 0-.156-.039v-.039c.156-.118.235-.275.313-.431.039-.118.118-.275.196-.393.078-.274.157-.549.117-.823 0-.196 0-.392-.039-.588a3.281 3.281 0 0 0-.156-.589c-.079-.156-.118-.353-.157-.51 0-.039-.039-.078-.078-.117v-.078c.039.039.078.039.078.078.039.078.117.157.157.274.156.236.274.471.43.746.118.196.196.392.275.588.117.235.195.47.313.706.078.196.157.431.196.627.039.196.078.432.117.628.039.274.039.51.039.784v.078c.079.04.04.079 0 .079Zm-2.154-1.334c-.117-.039-.274-.078-.391-.117-.353-.118-.666-.236-.98-.432l-.94-.588c-.156-.117-.274-.235-.43-.353l-.353-.353a.856.856 0 0 1-.196-.313c-.039-.157-.039-.157.039-.314 0-.04-.039-.079-.078-.118-.157-.314-.313-.627-.392-.98-.078-.314-.117-.628 0-.98.04-.079.079-.157.157-.236.039.04.078.079.078.118 0 .117.079.196.079.313v.079c-.079.314-.039.588.078.902.118.353.274.667.509.98.118.157.274.314.392.47.196.197.431.354.627.55.313.314.705.51 1.057.784.235.157.47.314.705.51.078 0 .078.04.039.078ZM103.087 8c-.118-.157-.235-.314-.353-.431-.078-.079-.117-.236-.157-.353 0-.079-.039-.196-.039-.275.039-.039.039 0 .079 0 0 0 .039.04.039.079.117.196.274.353.431.51.117.078.235.196.352.274.196.118.392.235.588.314.195.078.43.196.626.313.118.079.274.118.392.157.039 0 .078.04.157.04-.04.039-.04.039-.079.039-.235.117-.509.235-.744.392a.556.556 0 0 1-.235.078h-.431c-.196 0-.235-.039-.313-.235-.039-.078 0-.157 0-.235-.039 0-.039-.04-.078-.04-.118-.078-.196-.156-.235-.274-.079-.157-.079-.275 0-.353Zm1.997 17.412c-.039-.04-.039-.079-.078-.118v-.117a2 2 0 0 1 .117-.667c.079-.236.157-.432.196-.667.039-.196.118-.392.157-.588.078-.353.196-.706.235-1.059 0-.118.039-.235.039-.353 0-.157.039-.274.039-.431v-.667c0-.117-.039-.196-.039-.314v-.313c0-.04.039-.04.039-.079.039.04.078.079.078.118 0 .078.04.157.04.235.039.236.117.431.274.588.039.04.078.04.117-.039.039-.078.039-.157.079-.235.039 0 .039 0 .078.04a.5.5 0 0 1 .039.234c0 .04-.039.079-.039.118-.039.079-.039.157-.078.235 0 .079-.04.118-.04.157 0 .04-.039.079-.039.118 0 .117-.078.235-.117.353l-.235.706c-.039.156-.118.313-.157.47-.078.236-.157.47-.235.667-.078.235-.157.431-.235.667-.039.157-.078.313-.078.431 0 .078 0 .196-.039.274-.118.197-.118.197-.118.236Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M105.241 6.745c-.078.04-.118 0-.118 0a.539.539 0 0 1-.156-.118 8.528 8.528 0 0 1-.901-.784c-.196-.196-.353-.431-.509-.627a8.372 8.372 0 0 1-.627-.98c-.117-.197-.196-.393-.313-.628-.039-.118-.039-.235-.039-.314 0-.078 0-.118.078-.196 0 0 .039 0 .078-.04a7.975 7.975 0 0 0 2.507 3.687Zm9.047 8.824v-.196c-.039-.196.04-.393.118-.55.117-.235.313-.43.509-.588.118-.078.274-.196.392-.313.117-.079.196-.197.274-.275.039-.04.039-.118.078-.196 0-.04.039-.078.039-.157l.04-.04s.039 0 .039.04a.337.337 0 0 1 0 .275 1.557 1.557 0 0 1-.392.588c-.117.117-.274.196-.392.353-.039.078-.117.157-.156.235-.079.079-.079.196 0 .314 0 .04.039.078.039.118.078.196 0 .43-.196.51-.039.039-.117.039-.157 0-.078-.04-.156-.08-.235-.118Zm1.88-6.706h-.117c-.47 0-.94 0-1.41.078a8.65 8.65 0 0 0-.979.196c-.235.079-.47.118-.666.196-.196.079-.392.118-.588.196-.235.079-.47.197-.665.275-.118.04-.196.118-.275.157l-.117.078c-.078-.039-.157-.117-.235-.157l.078-.078c.039-.04.079-.04.118-.04.274-.117.587-.235.861-.313.353-.118.666-.235 1.019-.314.235-.039.47-.078.666-.157a9.095 9.095 0 0 1 1.018-.156h.157c.195 0 .391 0 .587-.04.196 0 .392 0 .627.04-.079 0-.079 0-.079.039Zm-5.483 4.627c.118.079.196.236.235.353.039.118.157.353.196.431.117.157.235.354.352.51.118.196.235.393.314.589.039.078.039.156-.039.235-.079.078-.118.196-.157.314 0 .039 0 .039-.039.078-.079-.157-.039-.314.039-.47-.078-.197-.157-.353-.235-.51-.118-.236-.274-.432-.392-.667-.039-.079-.078-.157-.078-.275 0-.117-.078-.235-.078-.352-.079-.079-.118-.157-.118-.236Zm2.663 6.667v.078c-.078.079-.117.157-.235.196-.039 0-.078.079-.156.079a.893.893 0 0 1-.431.117h-.274c-.118 0-.196.04-.314.079v.04c0 .078-.039.117-.117.156-.078 0-.157 0-.196-.079-.078-.117-.078-.195 0-.274.078-.078.196-.118.313-.157h.705c.118 0 .235-.039.353-.039.078 0 .196-.079.274-.157-.039 0 0 0 .078-.04Zm1.724-8.196c.078.078.156.196.235.235.078.04.196.118.235.196.078.079.117.196.196.314.078.117.039.196 0 .314-.079-.04-.04-.079-.04-.118-.039-.157-.078-.274-.156-.353-.079-.078-.196-.118-.274-.196-.04-.04-.079-.04-.157-.079a.772.772 0 0 1-.353-.352c0-.04-.039-.04-.039-.079 0-.078 0-.196.039-.274a.184.184 0 0 1 .314 0v.078a.435.435 0 0 1 0 .314Zm-5.797-2.118c.039-.078.078-.078.118-.078.274-.079.509-.157.783-.118h.392c.078 0 .156.04.274.079l.039.039c0 .039 0 .078-.039.078h-.039c-.314-.117-.666-.04-.98.04-.117.039-.235.078-.352.156-.078.04-.078.04-.118 0l-.078-.078c.039-.079.039-.079 0-.118Zm-4.112 1.53-.04.039c-.195.039-.352.039-.548.039h-.078s-.039 0-.039-.04l-.392-.234h.196c.156.039.313.078.509.078.117.04.235.078.392.118Zm9.282 4.51c-.117 0-.157-.04-.235-.118-.039-.04 0-.079.039-.079h.079c.039 0 .117.04.117.079.039 0 0 .078 0 .117Zm-.039.823c-.039 0-.039 0 0 0-.039 0-.039 0 0 0Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M108.1 16.706c-.039-.078-.039-.157-.039-.235h.391c.118 0 .275-.04.392-.079.118-.039.235-.078.392-.157-.079.118-.079.118-.157.196a6.385 6.385 0 0 1-.509.236c-.078.039-.196.039-.274.078-.079 0-.157 0-.196-.04Zm4.857.078c-.04-.078-.04-.156-.079-.196-.039-.157-.156-.196-.274-.235h-.47c-.196 0-.392 0-.548-.118-.079-.039-.157-.078-.235-.078-.039 0-.079 0-.079-.079 0-.156-.078-.274-.156-.43-.157-.471-.47-.903-.744-1.295-.04-.079-.079-.118-.118-.196a1.455 1.455 0 0 1-.196-.431c-.039-.079-.039-.157-.078-.275h-.039c-.079.04-.196.078-.314.118a5.538 5.538 0 0 1-.861.196c-.039 0-.079 0-.118.039a1.41 1.41 0 0 1-.783.235h-.118v.079h.079c.235.039.431.039.666.039.156 0 .195.04.195.157 0 .078-.039.157-.078.274-.078.196-.235.353-.392.47-.039.04-.117.08-.156.119 0 .078.078.117.117.117h.118c.078 0 .117 0 .196.04-.04.117-.04.117-.079.156l-.117.118c-.039.04-.039.117.039.157.039 0 .078.039.117.039h.235c.157-.04.314-.118.47-.157.04 0 .04-.04.079 0-.079.118-.118.196-.235.275a1.678 1.678 0 0 1-.862.235c-.196 0-.196 0-.196-.196 0-.04-.039-.079-.078-.079-.118.04-.196.157-.118.275 0 .04.04.078.079.078v.353a.518.518 0 0 0 .196.235c.117.04.235.079.352.079.196 0 .392-.04.548-.079.196-.078.392-.156.51-.313l.117-.236c.118-.196.157-.392.235-.588.039-.078 0-.196 0-.274-.039-.079-.039-.118-.078-.196-.039-.079-.039-.157-.079-.236a.414.414 0 0 1 .04-.313.305.305 0 0 1 .156-.157c.039 0 .079 0 .079.039 0 0 .039.04.039.079.078.235.196.43.352.627.196.235.392.431.627.667a.84.84 0 0 1 .117.196c0 .039 0 .078.04.117.078.196.117.236.313.196.078 0 .157 0 .235.04.117.078.274.078.392.117.117 0 .195.079.313.118.039.04.078.078.157.078.156.04.274.079.43.118.235.078.47.157.745.157a.329.329 0 0 0 0 .274v.04c0 .039 0 .078-.04.117l-.078.079c-.039.039-.078.117-.117.157a.925.925 0 0 0-.118.784l.118.47c.078.275.117.55.078.863 0 0 0 .04.039.04h.078a.525.525 0 0 0 .118-.157c.039-.079.039-.197.078-.314a3.196 3.196 0 0 0 0-.863c0-.078-.039-.118-.039-.196-.039-.235-.039-.275.157-.353.039-.04.117-.078.156-.118.079-.078.118-.157.04-.274 0-.04-.04-.079-.04-.079.04-.039.118-.078.157-.156.039-.04 0-.118.039-.197.039-.039.079-.039.079-.078 0-.078-.079-.118-.118-.196h.274c.118 0 .157-.079.079-.196 0-.04-.04-.04-.04-.078.04 0 .079 0 .079-.04.078-.039.078-.078.039-.157-.039-.039-.078-.078-.157-.078-.078-.04-.196-.04-.274-.04-.039-.078 0-.117.039-.156h.157c.039 0 .078 0 .078-.04.079-.039.118-.117 0-.195-.039 0-.039-.04-.078-.04l-.235-.117c-.118-.079-.196-.04-.313.039l-.079.078a.82.82 0 0 0-.156.236.421.421 0 0 0-.118.274v.196c0 .079-.078.157-.157.118-.156.117-.274.117-.43.078Zm7.676-6.156c-.039-.118-.078-.236-.196-.314-.078-.079-.156-.118-.235-.196-.078-.079-.195-.118-.313-.157-.235-.118-.47-.196-.666-.275-.039 0-.039 0-.078-.039-.157-.04-.353-.078-.509-.157-.079-.039-.157-.039-.235-.078-.314-.079-.588-.157-.901-.196-.196-.04-.392 0-.548-.079h-.862c-.118 0-.235 0-.353.04-.235.039-.43.039-.665.078-.235.04-.431.078-.666.118-.235.039-.509.078-.744.196-.392.156-.823.235-1.215.353-.235.078-.509.156-.744.235a1.32 1.32 0 0 1-.783.04c-.118-.04-.274-.04-.392-.04 0 0-.039.04-.078.04 0 .038 0 .038.039.078.078.039.157.039.235.078.157.04.274.078.392.196h-.431c-.157.04-.274 0-.431.04a.63.63 0 0 1-.431-.197l-.156-.157-.079-.078h-.078l-.039.04a.56.56 0 0 0 .078.234c.039.118.078.236.078.353 0 .04 0 .04-.039.079h-.039c-.117-.04-.196-.157-.235-.236-.157-.196-.274-.43-.392-.666-.117-.157-.156-.353-.195-.588v-.157c0-.04-.04-.04-.04-.04h-.078l-.039.04c-.078.117-.078.235-.078.353v.666c0 .04 0 .079-.04.079-.039-.04-.078-.04-.078-.04-.039-.039-.117-.078-.157-.156-.039-.04-.078-.04-.117 0-.039.117 0 .274 0 .392 0 .039.039.078.039.117.078.118.118.196.196.314.039.04.039.118.078.157a.3.3 0 0 1 .079.157c0 .078.039.157.039.196V12a1.74 1.74 0 0 1-.235.627 3.286 3.286 0 0 0-.314.471c0 .04-.039.04 0 .079.079 0 .118-.04.157-.118.039-.04.078-.118.157-.157 0 0 .039-.04.078-.04.078 0 .118-.078.196-.117.078-.04.117-.04.196-.04.117.04.235.08.313.158.039.078.118.117.157.196.078.078.156.118.235.04.078-.04.156-.04.235-.08.235-.039.47 0 .666.158.039 0 .039.039.078.039.039.039.078.039.117 0 .196-.157.353-.353.47-.55.04-.039.079-.117.118-.156.117.039.274.039.392.078.235.04.47-.039.665-.157a.303.303 0 0 0 .157-.156c0-.04.039-.04.078-.079h.196c.118 0 .235 0 .314-.04.195-.078.391-.156.587-.274.039 0 .078-.039.118-.078.039-.04.039-.079.078-.118.117.04.196.04.313 0 .274-.039.509-.117.627-.392h.117c.235 0 .431 0 .627-.04.118 0 .274-.077.353-.117.039-.039.078-.078.078-.117v-.04h.078c.196.04.353.079.549.118.156.04.313.04.47 0 .156-.04.156-.078.078-.196 0-.04-.039-.04-.039-.079h.156c.157.04.353.04.51.04h.274c.156 0 .274 0 .431-.04.078 0 .156-.039.195-.039.079 0 .079-.117.079-.157 0-.039-.039-.078-.079-.117 0 0 0-.04-.039-.04h.079c.195.04.352.04.548.079.47.04.94.04 1.449 0 0 .118 0 .079.039.079Zm-9.791 1.137h-.079c-.039 0-.078-.04-.156 0-.04.039 0 .117-.04.196l-.117.117v.118c-.039.04-.118.079-.157.118v.235c-.039.04-.078.04-.117.04-.039 0-.079-.04-.079-.08-.078-.038-.117-.078-.195-.117a.663.663 0 0 1-.196-.157c-.157-.235-.314-.431-.431-.666v-.079c.157-.078.313-.117.47-.117h.274c.235 0 .47-.04.705-.079h.078c.04 0 .079 0 .079.079-.039.078 0 .235-.039.392Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgEveningstandardreact);

/***/ }),

/***/ 50353:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgForbesreact = function SvgForbesreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    fill: "none",
    "aria-label": "FOrbes logo",
    viewBox: "0 0 167 22",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M85.994 20.636h1.752l1.662-3.78h6.04l1.662 3.78h1.77l-5.75-12.96h-1.405l-5.73 12.96Zm4.072-5.312 2.354-5.348 2.355 5.348h-4.71Zm10.637 5.312h3.723c3.98 0 6.9-2.774 6.9-6.48 0-3.706-2.92-6.48-6.9-6.48h-3.723v12.96Zm1.698-1.587V9.264h2.025c3.122 0 5.184 2.082 5.184 4.893s-2.063 4.892-5.184 4.892h-2.025Zm15.007 1.587h1.424l5.512-12.96H122.5l-4.362 10.295-4.381-10.295h-1.879l5.53 12.96Zm8.838 0h1.698V7.676h-1.698v12.96Zm4.075-2.118c.676 1.333 2.41 2.337 4.545 2.337 2.41 0 4.126-1.386 4.126-3.596 0-1.916-1.096-3.011-3.012-3.741l-1.57-.602c-1.315-.493-1.953-.987-1.953-2.082 0-1.076 1.058-1.789 2.337-1.789 1.114 0 1.917.493 2.573 1.277l1.242-1.095c-.803-1.04-2.155-1.77-3.779-1.77-2.318 0-4.053 1.333-4.053 3.45 0 1.77.913 2.83 2.939 3.577l1.716.657c1.206.456 1.862 1.15 1.862 2.19 0 1.206-1.059 1.936-2.391 1.936-1.459 0-2.519-.676-3.213-1.77l-1.369 1.021Zm23.669-4.362c0-3.76-2.957-6.7-6.699-6.7-3.723 0-6.699 2.94-6.699 6.7 0 3.76 2.976 6.699 6.699 6.699 3.743 0 6.699-2.939 6.699-6.7Zm-11.682 0c0-2.847 2.155-5.092 4.983-5.092 2.847 0 5.002 2.245 5.002 5.092 0 2.847-2.155 5.092-5.002 5.092-2.828.001-4.983-2.244-4.983-5.092Zm14.242 6.48h1.698V14.74h1.258l4.983 5.896h2.136l-4.983-5.914c1.99-.292 3.194-1.57 3.194-3.468 0-2.135-1.478-3.576-3.869-3.576h-4.417v12.957Zm1.698-7.41v-3.98h2.518c1.478 0 2.373.694 2.373 2.008 0 1.296-.895 1.971-2.373 1.971h-2.518Zm-77.625 1.1c-.492-.982-1.392-1.646-3.276-2.44-1.54-.648-2.318-1.089-2.793-1.606-.385-.417-.5-.762-.459-1.384.034-.58.18-.925.54-1.31.467-.5 1.106-.672 1.876-.508 1.261.262 2.064 1.138 2.76 2.981.246.655.278.68.72.516l.28-.106-.008-.754c-.008-.417-.024-1.293-.05-1.94l-.032-1.205-.213-.09c-1.155-.492-3.35-.795-4.775-.664-1.621.148-2.816.664-3.735 1.614-.909.943-1.326 2.056-1.253 3.375.057 1.088.384 1.875 1.057 2.555.622.639 1.147.942 2.645 1.523 2.416.942 3.062 1.507 3.054 2.67 0 .984-.523 1.704-1.474 2.04-.336.122-1.196.122-1.655 0-1.204-.32-2.121-1.36-2.908-3.293l-.205-.492-.238.008a1.25 1.25 0 0 0-.393.09l-.163.075.015.844c.008.466.034 1.442.05 2.178l.033 1.327.271.114c.549.238 2.203.598 3.235.713.132.016.835.016 1.573.008 1.277-.016 1.367-.026 2.015-.19 1.9-.499 3.129-1.556 3.668-3.161.164-.492.189-.648.213-1.376.036-.966-.055-1.474-.375-2.112Zm-14.675-7.97c-1.598-.803-4.07-.746-5.88.14-1.713.836-2.892 2.227-3.547 4.193-.344 1.024-.45 1.85-.417 3.178.023.835.057 1.27.147 1.663.671 3.015 2.744 5.062 5.627 5.585.638.115 2.08.115 2.727.008.917-.163 1.974-.565 2.645-1.023.811-.549 1.655-1.376 1.655-1.639 0-.155-.278-.516-.401-.516-.05 0-.278.115-.5.262-.795.516-1.557.73-2.621.73-1.458 0-2.391-.368-3.317-1.303-.409-.417-.582-.639-.794-1.056-.467-.91-.72-1.95-.762-3.13l-.016-.507 4.308-.016 4.308-.016.016-.295a7.254 7.254 0 0 0-.05-.933c-.27-2.623-1.327-4.425-3.128-5.325Zm-4.342 5.306-1.09.016v-.238c0-.131.042-.474.083-.761.36-2.342 1.236-3.751 2.334-3.751 1.008 0 1.63 1.383 1.761 3.922l.033.72-1.015.034a77.25 77.25 0 0 1-2.106.058ZM50.334 6.077c-.345-.074-.656-.082-1.319-.065-1.008.033-1.696.189-2.45.533a6.79 6.79 0 0 1-.482.213c-.016 0-.016-1.524.008-3.375C46.115.763 46.107 0 46.05 0c-.19 0-6.135 1.13-6.2 1.179-.049.041-.065.163-.057.352.016.327-.016.303.705.467.22.049.474.147.565.212.245.173.442.55.58 1.081.107.417.123.72.173 3.58.05 2.916.041 5.905-.041 11.392l-.033 2.277.426.098c.614.14 2.384.435 2.956.492.845.09 2.826.073 3.448-.016 2.736-.41 4.792-1.998 5.75-4.422a10.7 10.7 0 0 0 .581-2.367c.099-.86.042-2.588-.106-3.285-.565-2.662-2.22-4.496-4.463-4.963ZM46.18 19.82c-.074-.197-.163-7.02-.131-9.746l.024-2.13.385-.114a3.25 3.25 0 0 1 .91-.114c.491 0 .556.016.974.22.999.492 1.686 1.729 2.007 3.596.114.688.131 2.58.023 3.407-.261 2.03-.925 3.678-1.81 4.471-.352.32-.68.483-1.106.565-.303.057-.401.057-.95.016-.227-.015-.277-.04-.326-.171Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M39.222 5.766c-.68 0-1.04.073-1.589.327-1 .459-1.744 1.204-2.416 2.416l-.213.377.024-.672c.016-.368.041-1.056.057-1.53l.024-.86h-.14c-.18 0-5.954 1.154-6.126 1.227-.114.05-.131.099-.131.376 0 .288.016.32.131.345.075.016.337.065.59.114.508.098.664.18.876.459.386.515.467 1.417.467 5.258 0 3.137-.065 4.701-.22 5.192-.18.598-.508.909-1.073 1.007-.18.033-.427.083-.533.107l-.205.04-.016.402c-.008.278.008.418.057.45.041.025 2.015.042 4.381.034l4.308-.016.016-.45c.008-.247 0-.451-.033-.451-.337 0-1.36-.14-1.523-.205-.484-.204-.72-.638-.82-1.523-.122-1.04-.188-3.629-.155-5.74.033-2.138.033-2.146.164-2.294.31-.336 1.106-.598 1.81-.598.565 0 1.155.148 1.777.443.303.147.573.246.614.238.083-.034 1.49-3.767 1.49-3.94.012-.271-.79-.533-1.593-.533Z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M28.722 12.26c-.303-2.588-1.4-4.479-3.21-5.544-2.005-1.179-5.061-1.253-7.232-.163-1.564.785-2.85 2.3-3.414 4.038-.59 1.793-.59 4.152 0 5.987.376 1.17.883 2.03 1.67 2.81.943.933 2.179 1.53 3.588 1.735.508.075 2.096.075 2.621 0 .246-.033.671-.131.95-.204 2.564-.746 4.308-2.712 4.906-5.528.155-.673.212-2.344.121-3.13Zm-6.477 7.748c-1.588.475-2.727-1.04-3.17-4.217-.14-1.024-.14-3.824 0-4.997.311-2.554 1.097-3.849 2.342-3.857.557 0 .868.14 1.31.573 1.041 1.049 1.541 3.054 1.532 6.209-.008 2.514-.254 4.095-.819 5.167-.278.516-.785 1-1.195 1.122Z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M7.699 1.982h1.834c2.104 0 2.448.041 3.194.41 1.08.532 1.867 1.58 2.563 3.406.277.746.277.736.9.549l.418-.122-.041-2.687c-.024-1.474-.057-2.792-.073-2.924l-.041-.23L8.418.368C3.996.36.294.368.195.384L0 .417l.016.475.016.474.614.075c.794.098 1.269.319 1.548.728.63.925.746 2.187.746 8.165 0 6.372-.132 7.92-.746 8.723-.319.417-.573.549-1.285.679-.933.172-.901.147-.901.631 0 .27.024.41.073.435.106.041 10.385.049 10.491 0 .14-.057.13-.811-.008-.884-.057-.033-.401-.098-.77-.156-.37-.057-.777-.147-.9-.204-.672-.295-1.05-1.106-1.188-2.572-.098-1.05-.18-2.99-.18-4.423v-1.31l.622.016c1.335.041 2.023.114 2.302.238.606.27 1.088 1.007 1.342 2.048l.132.557.474.016.475.016V7.158l-.475.016-.474.016-.14.549c-.27 1.072-.704 1.727-1.352 2.03-.261.123-.45.156-1.08.197-.418.024-1 .05-1.303.05h-.54V8.28c0-1.736.09-5.422.155-5.995l.036-.304Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgForbesreact);

/***/ }),

/***/ 14745:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMoveiqreact = function SvgMoveiqreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    fill: "none",
    "aria-label": "Moveiq logo",
    viewBox: "0 0 102 31",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M4.58 11.398h.428v2.584h.075c1.383-1.957 3.401-3.1 5.905-3.1 2.43 0 4.597.885 5.643 3.174 1.122-1.662 3.14-3.175 5.83-3.175 4.11 0 7.064 1.883 7.064 6.829v12.773h-.728c-2.53 0-4.58-2.026-4.58-4.524v-6.292c0-2.548-.224-4.651-3.251-4.651-2.99 0-3.55 2.435-3.55 4.835v10.632h-.727c-2.53 0-4.58-2.026-4.58-4.524v-6.182c0-2.215.149-4.761-3.216-4.761-1.046 0-3.588.664-3.588 4.392v11.075H4.58c-2.53 0-4.58-2.026-4.58-4.524V15.921c0-2.498 2.05-4.523 4.58-4.523Zm36.645-.517c6.092 0 10.016 3.989 10.016 10.078 0 6.054-3.924 10.04-10.016 10.04-6.054 0-9.978-3.986-9.978-10.04 0-6.091 3.924-10.078 9.978-10.078Zm0 16.169c3.626 0 4.71-3.064 4.71-6.091 0-3.064-1.084-6.128-4.71-6.128-3.587 0-4.671 3.064-4.671 6.128 0 3.027 1.084 6.09 4.671 6.09Zm22.276 3.433H60.87c-1.957 0-3.699-1.23-4.333-3.059L52.02 14.392c-.51-1.468.595-2.994 2.166-2.994h2.365l4.073 13.03h.075l4.074-13.03h5.268l-6.54 19.085Zm11.25-8.27c.15 3.323 1.794 4.836 4.747 4.836 2.13 0 3.849-1.291 4.185-2.473h4.671C86.86 29.08 83.684 31 79.311 31c-6.092 0-9.867-4.134-9.867-10.04 0-5.722 3.999-10.078 9.867-10.078 6.577 0 9.755 5.463 9.38 11.332H74.75Zm8.633-3.322c-.486-2.657-1.643-4.059-4.223-4.059-3.363 0-4.335 2.584-4.41 4.06h8.633Zm13.31-14.524c-1.414 0-1.946 1.189-1.946 2.428 0 1.18.532 2.369 1.946 2.369.231 0 .522 0 .633-.1l-.673-.604.733-.773.813.733c.26-.357.44-.892.44-1.625 0-1.239-.53-2.428-1.946-2.428Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M91.995 0c-1.808 0-3.274 1.448-3.274 3.233v9.44h12.831V0h-9.557Zm.175 10.303h-1.575V5.898h1.576v4.405Zm0-5.52h-1.575V3.227h1.576v1.556Zm8.005 5.42-.731.764-1.014-.911c-.471.267-1.063.416-1.736.416-2.217 0-3.521-1.636-3.521-3.677 0-2.101 1.304-3.736 3.521-3.736 2.218 0 3.522 1.635 3.522 3.736 0 1.02-.33 1.932-.933 2.606l.892.803Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgMoveiqreact);

/***/ }),

/***/ 37682:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBurgerreact = function SvgBurgerreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 20",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "current",
    d: "M25.946 2.703H0V0h25.946v2.703Zm0 5.946H0v2.702h25.946V8.65Zm0 8.648H0V20h25.946v-2.703Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgBurgerreact);

/***/ }),

/***/ 47724:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgClosereact = function SvgClosereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "current",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17 7 7 17m10 0L7 7"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgClosereact);

/***/ }),

/***/ 70825:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowV3Blackreact = function SvgArrowV3Blackreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#000",
    d: "m7 14.5 5-5 5 5H7Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowV3Blackreact);

/***/ }),

/***/ 6437:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBurgerreact = function SvgBurgerreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 20",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "current",
    d: "M25.946 2.703H0V0h25.946v2.703Zm0 5.946H0v2.702h25.946V8.65Zm0 8.648H0V20h25.946v-2.703Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgBurgerreact);

/***/ }),

/***/ 11372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgClosereact = function SvgClosereact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "current",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17 7 7 17m10 0L7 7"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgClosereact);

/***/ }),

/***/ 81034:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowreact = function SvgArrowreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m1 5 4-4 4 4"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowreact);

/***/ }),

/***/ 13166:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowV3Blackreact = function SvgArrowV3Blackreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#000",
    d: "m7 14.5 5-5 5 5H7Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowV3Blackreact);

/***/ }),

/***/ 46685:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowV3React = function SvgArrowV3React(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFFDFA",
    d: "m7 14.5 5-5 5 5H7Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowV3React);

/***/ }),

/***/ 83856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTrustpilotreact = function SvgTrustpilotreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 72,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#01B676",
    fillRule: "evenodd",
    d: "M110.101 28.317h24.9v25.064h-24.9V28.317Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "m122.84 45.535 3.881-.986 1.621 5.007-5.502-4.02Zm9.046-7.203h-6.848l-2.081-6.882-2.119 6.882h-6.849l5.562 4.251-2.119 6.882 5.562-4.25 3.406-2.632 5.486-4.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#01B676",
    fillRule: "evenodd",
    d: "M82.87 28.317h24.9v25.064h-24.9V28.317Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "m95.608 45.535 3.882-.986 1.621 5.007-5.503-4.02Zm9.047-7.203h-6.85l-2.08-6.882-2.119 6.882h-6.849l5.562 4.251-2.118 6.882 5.562-4.25 3.405-2.632 5.487-4.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#01B676",
    fillRule: "evenodd",
    d: "M55.63 28.317h24.9v25.064h-24.9V28.317Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "m68.369 45.535 3.881-.986 1.62 5.007-5.501-4.02Zm9.046-7.203h-6.849l-2.08-6.882-2.12 6.882h-6.848l5.562 4.251-2.12 6.882 5.563-4.25 3.406-2.632 5.486-4.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#01B676",
    fillRule: "evenodd",
    d: "M28.39 28.317h24.9v25.064h-24.9V28.317Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "m41.137 45.535 3.881-.986 1.62 5.007-5.501-4.02Zm9.046-7.203h-6.849l-2.08-6.882-2.12 6.882h-6.848l5.562 4.251-2.12 6.882 5.563-4.25 3.406-2.632 5.486-4.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#01B676",
    fillRule: "evenodd",
    d: "M1.158 28.317h24.9v25.064h-24.9V28.317Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "m13.897 45.535 3.881-.986 1.621 5.007-5.502-4.02Zm9.054-7.203h-6.848l-2.081-6.882-2.119 6.882H5.054l5.562 4.251-2.119 6.882 5.563-4.25 3.405-2.632 5.486-4.25Z"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "a",
    width: 83,
    height: 21,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M82.705 0H.579v20.382h82.126V0Z"
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#000",
    d: "M22.161 7.221h8.318v1.57h-3.266v8.813h-1.8V8.791h-3.252V7.22Zm7.958 2.865h1.54v1.454h.029c.053-.215.148-.418.279-.596.145-.2.315-.378.508-.53.197-.161.417-.291.652-.386.233-.096.482-.146.734-.147.132-.002.264.002.395.014l.224.03v1.6a7.36 7.36 0 0 0-.353-.052 2.883 2.883 0 0 0-.353-.022 1.866 1.866 0 0 0-.784.168 1.805 1.805 0 0 0-.64.494 2.43 2.43 0 0 0-.435.806 3.52 3.52 0 0 0-.158 1.105v3.577h-1.638v-7.515Zm11.89 7.518h-1.613v-1.048h-.029c-.207.384-.52.7-.9.909a2.41 2.41 0 0 1-1.215.341c-.979 0-1.687-.244-2.123-.732-.436-.488-.654-1.228-.652-2.218v-4.77h1.637v4.61c0 .66.125 1.123.374 1.392.25.269.6.404 1.05.407.297.01.592-.044.865-.159.218-.097.41-.244.561-.43.15-.189.255-.41.31-.646a3.39 3.39 0 0 0 .093-.815v-4.36h1.64l.002 7.52Zm2.79-2.413c.048.484.23.824.547 1.017a2.13 2.13 0 0 0 1.136.293 4.2 4.2 0 0 0 .526-.036 2.25 2.25 0 0 0 .554-.138 1.03 1.03 0 0 0 .424-.299.722.722 0 0 0 .151-.516.74.74 0 0 0-.23-.523 1.596 1.596 0 0 0-.554-.327 5.412 5.412 0 0 0-.77-.211 28.37 28.37 0 0 1-.878-.19 8.176 8.176 0 0 1-.885-.246 2.846 2.846 0 0 1-.763-.393 1.807 1.807 0 0 1-.54-.633 2.038 2.038 0 0 1-.2-.952 1.72 1.72 0 0 1 .294-1.026 2.26 2.26 0 0 1 .753-.67 3.234 3.234 0 0 1 1.008-.357 5.89 5.89 0 0 1 1.057-.101c.37-.002.74.04 1.1.123.338.077.66.213.95.4.285.185.525.431.706.72.197.325.317.69.352 1.069h-1.716c-.076-.398-.256-.665-.54-.8a2.23 2.23 0 0 0-.97-.204 3.373 3.373 0 0 0-.41.03 1.849 1.849 0 0 0-.447.109.932.932 0 0 0-.353.232.56.56 0 0 0-.145.4.637.637 0 0 0 .209.495c.16.138.346.244.547.312.25.09.508.16.77.21.29.06.587.122.892.19.297.068.59.15.878.247.275.09.535.223.77.393.225.165.412.379.547.626.147.286.219.607.208.93 0 .446-.1.824-.302 1.134-.2.31-.47.568-.785.756a3.53 3.53 0 0 1-1.072.422 5.38 5.38 0 0 1-1.166.131 5.03 5.03 0 0 1-1.304-.16 3.007 3.007 0 0 1-1.036-.488 2.338 2.338 0 0 1-.691-.814 2.604 2.604 0 0 1-.266-1.155h1.644Zm5.41-5.105h1.238V7.832h1.64v2.254h1.483v1.236h-1.482v4.014c-.001.15.006.3.022.45.01.114.044.222.1.32a.48.48 0 0 0 .238.196c.14.05.287.073.435.067.115 0 .23 0 .345-.008a1.7 1.7 0 0 0 .346-.051v1.28c-.183.019-.363.038-.533.058-.177.02-.355.03-.532.029a3.578 3.578 0 0 1-1.044-.124 1.389 1.389 0 0 1-.619-.366 1.261 1.261 0 0 1-.302-.604 4.55 4.55 0 0 1-.094-.828v-4.433h-1.24v-1.236Zm5.51 0h1.557v1.018h.029a2.04 2.04 0 0 1 .964-.938c.42-.19.877-.287 1.338-.283a3.528 3.528 0 0 1 1.533.312 3.03 3.03 0 0 1 1.087.858c.295.378.515.81.648 1.272.147.506.22 1.03.217 1.556 0 .495-.065.988-.194 1.466a3.838 3.838 0 0 1-.59 1.257 2.963 2.963 0 0 1-1 .873c-.403.218-.878.327-1.425.327a3.96 3.96 0 0 1-.72-.066 3.073 3.073 0 0 1-.69-.21 2.711 2.711 0 0 1-.612-.371 2.043 2.043 0 0 1-.468-.53h-.029v3.75h-1.642l-.003-10.291Zm5.727 3.767c0-.334-.043-.667-.13-.99a2.704 2.704 0 0 0-.385-.849 2.013 2.013 0 0 0-.648-.596 1.748 1.748 0 0 0-.892-.225c-.69 0-1.21.242-1.56.726-.35.485-.526 1.13-.526 1.934-.003.356.043.71.137 1.054.08.303.217.587.406.836.177.228.4.416.653.552.273.141.577.21.884.204.332.01.66-.07.95-.232.255-.152.474-.358.64-.604.173-.255.296-.542.363-.843.073-.317.11-.642.111-.967h-.003ZM64.34 7.22h1.643v1.57h-1.64l-.003-1.57Zm0 2.865h1.643v7.518h-1.64l-.003-7.518Zm3.106-2.865h1.641v10.383h-1.638L67.446 7.22Zm6.663 10.587a4.018 4.018 0 0 1-1.587-.3 3.382 3.382 0 0 1-1.18-.822 3.514 3.514 0 0 1-.733-1.249 5.165 5.165 0 0 1 0-3.184c.155-.464.405-.89.733-1.25a3.4 3.4 0 0 1 1.18-.82 4.4 4.4 0 0 1 3.18 0c.447.186.849.466 1.18.822.328.36.579.786.734 1.25a5.165 5.165 0 0 1 0 3.185c-.155.464-.406.89-.734 1.25a3.364 3.364 0 0 1-1.18.818 4.022 4.022 0 0 1-1.59.3h-.003Zm0-1.31c.331.01.659-.07.95-.231.263-.151.49-.36.662-.611a2.69 2.69 0 0 0 .382-.85 3.871 3.871 0 0 0 0-1.928 2.6 2.6 0 0 0-.382-.85 2.042 2.042 0 0 0-.662-.604 2.054 2.054 0 0 0-1.9 0 2.04 2.04 0 0 0-.662.603 2.587 2.587 0 0 0-.381.851 3.848 3.848 0 0 0 0 1.927c.076.304.206.592.381.85.172.252.399.461.662.612.292.16.62.24.953.232h-.003Zm4.23-6.412h1.238V7.832h1.64v2.254H82.7v1.236h-1.482v4.014c-.001.15.006.3.022.45a.78.78 0 0 0 .1.32c.056.09.14.16.237.196.14.05.288.073.435.067.116 0 .23 0 .346-.008.116-.005.232-.022.345-.051v1.28a41.79 41.79 0 0 0-.533.058c-.176.02-.354.03-.532.029a3.59 3.59 0 0 1-1.044-.124 1.385 1.385 0 0 1-.618-.366 1.26 1.26 0 0 1-.302-.604 4.55 4.55 0 0 1-.094-.828v-4.433h-1.237l-.003-1.236Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#23AD7A",
    d: "m20.249 7.222-7.514-.002L10.414 0 8.093 7.22.579 7.218l6.079 4.464-2.321 7.222 6.078-4.463 6.076 4.463-2.321-7.22 6.079-4.462Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#00532C",
    d: "m14.696 13.32-.526-1.636-3.755 2.757 4.281-1.12Z"
  }))), _path12 || (_path12 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#000",
    d: "M.53 63.428v.678h2.887v7.672h.792v-7.672h2.899v-.678H.529Zm6.145 2.315v6.035h.734v-3.216c0-.32.054-.612.163-.877.108-.273.26-.507.454-.702.202-.195.438-.343.71-.444.272-.11.574-.156.908-.14v-.737c-.543-.024-1.013.097-1.409.362-.388.265-.675.643-.861 1.135H7.35v-1.416h-.676Zm8.54 6.035v-6.035h-.734v3.17c0 .304-.035.604-.105.9-.07.29-.178.546-.326.772-.147.227-.334.41-.559.55a1.58 1.58 0 0 1-.814.2c-.583 0-.994-.141-1.235-.422-.232-.28-.357-.694-.372-1.24v-3.93h-.734v3.919c0 .358.039.678.117.959.077.28.198.518.36.713.171.195.389.343.653.444.271.11.597.164.978.164.45 0 .857-.105 1.222-.316a2.11 2.11 0 0 0 .85-.935h.023v1.087h.676Zm4.984-4.269h.734a2.192 2.192 0 0 0-.198-.853 1.751 1.751 0 0 0-.478-.609 1.876 1.876 0 0 0-.687-.362 2.87 2.87 0 0 0-.838-.117c-.264 0-.532.031-.803.094-.264.062-.505.16-.722.292a1.647 1.647 0 0 0-.536.526 1.49 1.49 0 0 0-.198.784c0 .257.043.476.128.655.086.171.202.32.35.444.155.117.334.219.535.304.202.078.423.148.664.21l.943.211c.163.04.322.086.477.14.163.055.307.126.431.211a.84.84 0 0 1 .291.304.788.788 0 0 1 .117.445.89.89 0 0 1-.163.538 1.24 1.24 0 0 1-.396.35 1.77 1.77 0 0 1-.536.2 2.667 2.667 0 0 1-.547.058c-.489 0-.9-.125-1.234-.374-.326-.257-.505-.636-.536-1.135h-.733c.062.741.31 1.28.745 1.614.442.336 1.017.503 1.723.503.28 0 .563-.03.85-.093.287-.063.543-.164.768-.304a1.87 1.87 0 0 0 .571-.562 1.54 1.54 0 0 0 .221-.842c0-.265-.05-.495-.151-.69a1.535 1.535 0 0 0-.396-.491 1.799 1.799 0 0 0-.547-.316 2.517 2.517 0 0 0-.617-.175l-.978-.223a6.855 6.855 0 0 1-.408-.117 2.198 2.198 0 0 1-.407-.198 1.211 1.211 0 0 1-.315-.281.744.744 0 0 1-.116-.421.89.89 0 0 1 .128-.491.938.938 0 0 1 .338-.316c.14-.086.29-.144.454-.176.17-.039.337-.058.5-.058.21 0 .408.027.594.082.186.047.35.124.49.234.147.109.263.25.348.42.086.164.132.36.14.585Zm3.172-1.766v-1.812h-.733v1.812H21.59v.62h1.048v4.129c-.008.515.085.87.28 1.064.193.187.535.281 1.024.281.108 0 .217-.004.326-.012.108-.008.217-.011.326-.011v-.62c-.21.023-.42.035-.629.035-.264-.016-.43-.09-.5-.222-.063-.14-.094-.332-.094-.574v-4.07h1.223v-.62H23.37Zm2.793 3.287h-.791c-.024.515.042.955.198 1.322.163.366.391.666.686.9a3 3 0 0 0 1.072.526c.419.11.873.164 1.362.164a4.91 4.91 0 0 0 1.257-.14c.35-.086.64-.199.874-.34a1.95 1.95 0 0 0 .559-.49c.14-.18.244-.355.314-.527a1.74 1.74 0 0 0 .14-.503 2.68 2.68 0 0 0 .034-.374c0-.343-.058-.635-.174-.877a1.635 1.635 0 0 0-.466-.608 2.428 2.428 0 0 0-.687-.421 5.157 5.157 0 0 0-.827-.293l-2.025-.503a3.245 3.245 0 0 1-.49-.152 1.472 1.472 0 0 1-.395-.245 1.163 1.163 0 0 1-.28-.363 1.323 1.323 0 0 1-.093-.515c0-.311.058-.573.175-.783a1.42 1.42 0 0 1 .454-.503c.194-.133.415-.226.664-.28a3.3 3.3 0 0 1 .791-.094c.295 0 .575.042.839.128.271.078.508.199.71.363.21.156.376.355.5.596.132.234.206.511.222.83h.791c0-.428-.085-.802-.256-1.122a2.356 2.356 0 0 0-.663-.819 2.89 2.89 0 0 0-.978-.491 4.16 4.16 0 0 0-1.176-.164c-.582 0-1.06.086-1.432.258-.373.163-.668.366-.885.608-.21.241-.354.499-.431.772-.078.273-.117.51-.117.713 0 .328.05.604.152.83.108.227.248.418.419.574.17.156.369.28.594.374.233.093.47.171.71.234l1.851.456c.194.047.392.11.594.187.202.07.384.164.547.28.171.118.307.262.408.434.108.171.163.374.163.608 0 .304-.074.565-.221.783a1.92 1.92 0 0 1-.56.527c-.217.132-.453.23-.71.292a3.017 3.017 0 0 1-.71.094c-.38 0-.737-.035-1.07-.106a2.533 2.533 0 0 1-.874-.374 1.782 1.782 0 0 1-.57-.69c-.14-.288-.206-.647-.199-1.076Zm11.06-1.392h.733c-.085-.694-.353-1.212-.803-1.555-.442-.343-.986-.515-1.63-.515a2.79 2.79 0 0 0-1.223.257 2.674 2.674 0 0 0-.884.69 2.98 2.98 0 0 0-.548 1.018 3.946 3.946 0 0 0-.186 1.228c0 .437.062.85.186 1.24.125.382.307.717.548 1.006.24.288.535.518.884.69a2.9 2.9 0 0 0 1.223.245c.683 0 1.242-.202 1.677-.608.434-.413.702-.986.803-1.72h-.733a2.017 2.017 0 0 1-.571 1.24 1.777 1.777 0 0 1-.536.351 1.62 1.62 0 0 1-.64.13c-.35 0-.656-.075-.92-.223a2.08 2.08 0 0 1-.663-.585 2.852 2.852 0 0 1-.396-.819 3.57 3.57 0 0 1-.128-.947c0-.32.042-.632.128-.936.093-.312.225-.588.396-.83.178-.242.4-.437.663-.585.264-.148.57-.222.92-.222.489 0 .87.129 1.141.386.272.257.458.612.559 1.064Zm4.338-1.45c.349 0 .655.074.92.222.263.148.48.343.651.585.179.242.31.518.396.83.093.304.14.616.14.936 0 .32-.047.636-.14.947a2.505 2.505 0 0 1-.396.819c-.17.242-.388.437-.652.585-.264.148-.57.222-.92.222-.349 0-.655-.074-.92-.222a2.082 2.082 0 0 1-.663-.585 2.857 2.857 0 0 1-.396-.819 3.57 3.57 0 0 1-.128-.947c0-.32.043-.632.128-.936a2.83 2.83 0 0 1 .396-.83c.179-.242.4-.437.664-.585.264-.148.57-.222.92-.222Zm0-.62a2.79 2.79 0 0 0-1.223.257c-.35.172-.644.402-.885.69-.24.289-.423.628-.547 1.018a3.946 3.946 0 0 0-.186 1.228c0 .437.062.85.186 1.24.124.382.307.717.547 1.006.24.288.536.518.885.69.357.163.765.245 1.223.245a2.83 2.83 0 0 0 1.21-.245c.358-.172.656-.402.897-.69.24-.289.423-.624.547-1.006.124-.39.187-.803.187-1.24 0-.437-.063-.846-.187-1.228a2.985 2.985 0 0 0-.547-1.018 2.637 2.637 0 0 0-.897-.69 2.714 2.714 0 0 0-1.21-.257Zm3.931.175v6.035h.733v-3.216c0-.32.055-.612.163-.877a2.06 2.06 0 0 1 .455-.702c.201-.195.438-.343.71-.444a2.12 2.12 0 0 1 .908-.14v-.737c-.543-.024-1.013.097-1.409.362-.388.265-.675.643-.861 1.135h-.024v-1.416h-.675Zm7.787 2.597h-3.888c.03-.273.093-.538.186-.795.1-.266.233-.496.396-.69.163-.203.36-.363.594-.48.232-.125.5-.187.803-.187.295 0 .559.062.792.187.233.117.43.277.593.48.163.194.288.42.373.678.093.257.144.526.151.807Zm-3.888.62h4.622a4.733 4.733 0 0 0-.117-1.24 3.055 3.055 0 0 0-.465-1.088 2.385 2.385 0 0 0-.827-.772c-.341-.195-.753-.292-1.234-.292-.474 0-.885.094-1.234.28-.342.18-.621.422-.839.726-.217.296-.38.635-.489 1.017a4.56 4.56 0 0 0-.15 1.17c0 .429.05.838.15 1.228.11.382.272.721.49 1.018.217.288.496.518.838.69.35.163.76.245 1.234.245.76 0 1.347-.187 1.758-.561.42-.374.706-.905.862-1.59h-.734c-.116.467-.326.841-.629 1.122-.302.28-.721.421-1.257.421-.35 0-.648-.074-.897-.222a2.036 2.036 0 0 1-.617-.562 2.368 2.368 0 0 1-.36-.76 3.525 3.525 0 0 1-.105-.83Zm9.452-.176h2.469v-3.602h-.024l-2.445 3.602Zm4.774 1.053H62.57v1.941h-1.257v-1.941H57.82v-1.322l3.493-4.924h1.257v5.193h1.048v1.053Zm1.195.363h1.619v1.578h-1.619V70.2Zm5.674-5.72c-.357 0-.66.11-.908.328-.248.21-.372.518-.372.924 0 .39.12.69.36.9.241.203.548.304.92.304.373 0 .68-.1.92-.304.24-.21.36-.51.36-.9 0-.406-.123-.714-.372-.924a1.328 1.328 0 0 0-.908-.328Zm0 7.462a3.68 3.68 0 0 1-1.152-.175 2.707 2.707 0 0 1-.909-.503 2.444 2.444 0 0 1-.605-.819 2.66 2.66 0 0 1-.21-1.076c0-.514.132-.947.396-1.298a1.952 1.952 0 0 1 1.095-.702v-.023a1.785 1.785 0 0 1-.862-.644 1.857 1.857 0 0 1-.291-1.04c0-.702.217-1.248.652-1.638.442-.398 1.071-.596 1.886-.596s1.44.199 1.875.596c.442.39.663.936.663 1.638 0 .397-.1.744-.302 1.04-.194.289-.478.503-.85.644v.023a1.89 1.89 0 0 1 1.082.702c.272.35.408.784.408 1.298 0 .398-.074.757-.221 1.076-.14.32-.338.593-.594.819a2.69 2.69 0 0 1-.92.503c-.35.117-.73.175-1.14.175Zm0-1.052c.443 0 .811-.133 1.106-.398.295-.265.443-.64.443-1.123 0-.452-.148-.803-.443-1.052-.295-.258-.663-.386-1.106-.386-.442 0-.81.128-1.106.386-.295.25-.442.6-.442 1.052 0 .484.147.858.442 1.123.295.265.664.398 1.106.398Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTrustpilotreact);

/***/ }),

/***/ 2989:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCrossreact = function SvgCrossreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Cross icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#292B29",
    d: "M17 17h-1.655l-3.37-4.398L8.543 17H7l4.168-5.226L7.283 7h1.612l3.114 3.96L15.148 7H16.7l-3.885 4.733L17 17Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCrossreact);

/***/ }),

/***/ 647:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoFilledreact = function SvgInfoFilledreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Info filled icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    fillRule: "evenodd",
    d: "M1.333 8A6.67 6.67 0 0 1 8 1.333 6.669 6.669 0 0 1 14.667 8 6.67 6.67 0 0 1 8 14.667 6.67 6.67 0 0 1 1.333 8Zm6-3.333h1.334V6H7.333V4.667Zm0 2.666h1.334v4H7.333v-4Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInfoFilledreact);

/***/ }),

/***/ 8159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInforeact = function SvgInforeact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "Info icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#6F7672",
    fillRule: "evenodd",
    d: "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.669 6.669 0 0 0 8 1.333Zm-.667 3.334V6h1.334V4.667H7.333Zm0 2.666v4h1.334v-4H7.333ZM2.667 8A5.34 5.34 0 0 0 8 13.333 5.34 5.34 0 0 0 13.333 8 5.34 5.34 0 0 0 8 2.667 5.34 5.34 0 0 0 2.667 8Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgInforeact);

/***/ }),

/***/ 42121:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTickreact = function SvgTickreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "Tick icon",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#017848",
    d: "m17.796 5.868 1.608 1.128-6.973 10.056h-1.607l-3.888-5.448 1.608-1.5 3.083 2.88 6.168-7.116Z"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTickreact);

/***/ }),

/***/ 70546:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTrustpilotreact = function SvgTrustpilotreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 16,
    fill: "none",
    "aria-label": "Rated excellent on Trustpilot",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#45556F",
    d: "M3.234 5.146c.975 0 1.694.187 2.156.561.47.367.704.924.704 1.672 0 .418-.077.766-.231 1.045a1.954 1.954 0 0 1-.594.671c-.235.161-.484.29-.748.385L6.677 13H5.522L3.619 9.755H2.057V13h-.99V5.146h2.167Zm-.055.858H2.057v2.915h1.177c.638 0 1.104-.125 1.397-.374.293-.257.44-.63.44-1.122 0-.513-.154-.876-.462-1.089-.308-.22-.785-.33-1.43-.33Zm6.832 1.001c.718 0 1.25.158 1.595.473.344.315.517.818.517 1.507V13h-.704l-.187-.836h-.044c-.257.323-.528.561-.814.715-.279.154-.668.231-1.166.231-.536 0-.98-.14-1.331-.418-.352-.286-.528-.73-.528-1.331 0-.587.23-1.038.693-1.353.462-.323 1.173-.499 2.134-.528l1-.033v-.352c0-.491-.106-.832-.318-1.023-.213-.19-.514-.286-.902-.286a2.7 2.7 0 0 0-.88.143 5.62 5.62 0 0 0-.781.308l-.297-.726c.256-.14.56-.257.913-.352a3.908 3.908 0 0 1 1.1-.154Zm.286 3.146c-.734.03-1.243.147-1.53.352-.278.205-.417.495-.417.869 0 .33.099.572.297.726.205.154.465.231.78.231.5 0 .914-.136 1.244-.407.33-.279.495-.704.495-1.276v-.528l-.87.033Zm5.616 2.167c.146 0 .297-.011.45-.033.155-.03.28-.059.375-.088v.737a1.54 1.54 0 0 1-.44.121 2.91 2.91 0 0 1-.55.055 2.34 2.34 0 0 1-.858-.154 1.355 1.355 0 0 1-.627-.561c-.162-.264-.242-.634-.242-1.111V7.852h-.836V7.39l.847-.385.385-1.254h.572v1.353h1.705v.748h-1.705v3.41c0 .36.084.627.253.803a.93.93 0 0 0 .67.253Zm4.282-5.324c.506 0 .94.11 1.298.33.367.22.646.532.836.935.198.396.297.862.297 1.397v.583H18.59c.015.667.184 1.177.506 1.529.33.345.789.517 1.375.517.374 0 .704-.033.99-.099.294-.073.594-.176.902-.308v.847c-.3.132-.597.227-.89.286a4.816 4.816 0 0 1-1.046.099c-.557 0-1.052-.114-1.485-.341a2.422 2.422 0 0 1-1-1.012c-.235-.455-.353-1.008-.353-1.661 0-.645.107-1.199.32-1.661.22-.462.524-.818.912-1.067.396-.25.855-.374 1.375-.374Zm-.01.792c-.463 0-.83.15-1.1.451-.265.293-.422.704-.474 1.232h3.003c-.007-.499-.124-.902-.352-1.21-.227-.315-.586-.473-1.078-.473Zm6.032 5.324c-.733 0-1.32-.253-1.76-.759-.44-.513-.66-1.276-.66-2.288 0-1.012.22-1.775.66-2.288.448-.52 1.038-.781 1.771-.781.455 0 .825.084 1.111.253.294.169.532.374.715.616h.066a10.816 10.816 0 0 0-.044-.418 6.208 6.208 0 0 1-.022-.451V4.64h.968V13h-.78l-.144-.792h-.044c-.176.25-.41.462-.704.638-.293.176-.67.264-1.133.264Zm.154-.803c.624 0 1.06-.169 1.31-.506.256-.345.384-.862.384-1.551v-.176c0-.733-.12-1.294-.363-1.683-.242-.396-.689-.594-1.342-.594-.52 0-.913.209-1.177.627-.256.41-.385.964-.385 1.661 0 .704.129 1.25.385 1.639.264.389.66.583 1.188.583Zm63.576-2.266c0 .975-.25 1.73-.748 2.266-.492.535-1.159.803-2.002.803-.52 0-.987-.117-1.397-.352a2.546 2.546 0 0 1-.957-1.045c-.235-.462-.352-1.02-.352-1.672 0-.975.245-1.727.737-2.255.491-.528 1.158-.792 2.002-.792.535 0 1.004.121 1.408.363.41.235.73.58.957 1.034.234.447.352.997.352 1.65Zm-4.455 0c0 .697.135 1.25.407 1.661.278.403.718.605 1.32.605.594 0 1.03-.202 1.309-.605.278-.41.418-.964.418-1.661 0-.697-.14-1.243-.418-1.639-.279-.396-.719-.594-1.32-.594-.602 0-1.038.198-1.31.594-.27.396-.406.942-.406 1.639Zm8.827-3.047c.704 0 1.236.172 1.595.517.36.337.539.887.539 1.65V13h-.957V9.227c0-.946-.44-1.419-1.32-1.419-.653 0-1.104.183-1.353.55-.25.367-.374.895-.374 1.584V13h-.968V7.104h.78l.144.803h.055c.19-.308.455-.535.792-.682a2.54 2.54 0 0 1 1.067-.231Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0B0E2D",
    d: "M38.306 13H33.84V5.146h4.466v1.177h-3.058v2.002h2.86v1.177h-2.86v2.31h3.058V13Zm2.823-3.047L39.16 7.038h1.573l1.298 2.024 1.298-2.024h1.573l-1.99 2.915L45.001 13h-1.574l-1.397-2.167L40.634 13h-1.573l2.068-3.047Zm7.063 3.157c-.858 0-1.533-.246-2.024-.737-.492-.491-.737-1.265-.737-2.321 0-.733.12-1.327.363-1.782.249-.462.59-.8 1.023-1.012.432-.22.927-.33 1.485-.33.374 0 .707.037 1 .11.294.073.543.161.749.264l-.407 1.089a6.137 6.137 0 0 0-.682-.22 2.363 2.363 0 0 0-.66-.099c-.968 0-1.452.656-1.452 1.969 0 .638.12 1.118.363 1.441.249.323.605.484 1.067.484.33 0 .623-.04.88-.121.256-.08.502-.19.737-.33v1.199a2.822 2.822 0 0 1-.737.297c-.257.066-.58.099-.968.099Zm5.5-6.182c.799 0 1.43.238 1.891.715.47.477.704 1.14.704 1.991v.704H52.35c.015.543.165.964.451 1.265.286.293.682.44 1.188.44.382 0 .726-.037 1.034-.11a5.79 5.79 0 0 0 .946-.341v1.111a4.01 4.01 0 0 1-.913.308 5.609 5.609 0 0 1-1.133.099c-.579 0-1.096-.11-1.55-.33a2.49 2.49 0 0 1-1.057-1.023c-.249-.455-.374-1.02-.374-1.694 0-1.02.253-1.797.76-2.332.505-.535 1.169-.803 1.99-.803Zm0 1.023c-.375 0-.679.121-.914.363-.227.235-.359.587-.396 1.056h2.563c-.007-.41-.113-.748-.319-1.012-.198-.271-.51-.407-.935-.407ZM59.07 13h-1.386V4.64h1.386V13Zm3.158 0h-1.386V4.64h1.386V13Zm4.17-6.072c.8 0 1.43.238 1.892.715.47.477.704 1.14.704 1.991v.704h-3.938c.015.543.165.964.451 1.265.286.293.682.44 1.188.44.382 0 .726-.037 1.034-.11a5.79 5.79 0 0 0 .946-.341v1.111a4.01 4.01 0 0 1-.913.308 5.61 5.61 0 0 1-1.133.099c-.579 0-1.096-.11-1.55-.33a2.489 2.489 0 0 1-1.057-1.023c-.249-.455-.374-1.02-.374-1.694 0-1.02.253-1.797.76-2.332.505-.535 1.169-.803 1.99-.803Zm0 1.023c-.374 0-.678.121-.913.363-.227.235-.359.587-.396 1.056h2.563c-.007-.41-.113-.748-.319-1.012-.198-.271-.51-.407-.935-.407Zm7.184-1.023c.667 0 1.188.172 1.562.517.381.345.572.902.572 1.672V13H74.33V9.392c0-.895-.367-1.342-1.1-1.342-.557 0-.939.176-1.144.528-.205.352-.308.854-.308 1.507V13h-1.386V7.038h1.067l.198.781h.077c.19-.308.451-.532.781-.671a2.64 2.64 0 0 1 1.067-.22Zm6.178 5.071c.168 0 .333-.015.495-.044.168-.037.322-.077.462-.121v1.034a2.58 2.58 0 0 1-.572.165c-.235.051-.48.077-.737.077-.338 0-.646-.055-.924-.165a1.36 1.36 0 0 1-.66-.594c-.162-.279-.242-.667-.242-1.166V8.083h-.803v-.605l.88-.484.44-1.265h.869v1.309h1.694v1.045h-1.694v3.091c0 .279.073.488.22.627a.822.822 0 0 0 .572.198Z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#242531",
    fillRule: "evenodd",
    d: "M167.594 7.918h.981V6.15h1.299v1.77h1.174v.97h-1.174v3.15c0 .136.006.254.017.353a.617.617 0 0 0 .08.251c.041.069.104.12.188.154a.922.922 0 0 0 .342.052c.091 0 .182-.002.273-.006a1.36 1.36 0 0 0 .274-.04v1.004c-.144.015-.285.03-.422.046a3.798 3.798 0 0 1-.421.023c-.342 0-.618-.033-.827-.097a1.102 1.102 0 0 1-.49-.286.984.984 0 0 1-.239-.473 3.497 3.497 0 0 1-.074-.65V8.887h-.981v-.97Zm-3.351 5.034a1.486 1.486 0 0 0 1.277-.662c.137-.198.237-.42.302-.667a2.972 2.972 0 0 0 0-1.513 2.025 2.025 0 0 0-.302-.667 1.614 1.614 0 0 0-.525-.474 1.487 1.487 0 0 0-.752-.183c-.289 0-.539.061-.752.183-.213.122-.387.28-.524.474a2.005 2.005 0 0 0-.302.667 2.995 2.995 0 0 0 0 1.513c.064.247.165.47.302.667.137.198.311.358.524.48.213.121.463.182.752.182Zm0 1.028c-.471 0-.891-.078-1.259-.234a2.685 2.685 0 0 1-.935-.645 2.752 2.752 0 0 1-.581-.981c-.133-.38-.2-.8-.2-1.256 0-.449.067-.863.2-1.244.133-.38.326-.708.581-.981.255-.274.566-.49.935-.645a3.204 3.204 0 0 1 1.259-.234c.471 0 .891.078 1.26.234.368.156.68.37.934.645.255.273.449.6.582.981.132.38.199.795.199 1.244 0 .457-.067.875-.199 1.256-.133.38-.327.707-.582.981a2.68 2.68 0 0 1-.934.645 3.211 3.211 0 0 1-1.26.234Zm-5.277-.16h1.299V5.671h-1.299v8.15Zm-2.459 0h1.299v-5.9h-1.299v5.9Zm0-6.916h1.299V5.671h-1.299v1.233Zm-2.292 3.97c0-.265-.034-.524-.103-.775a2.117 2.117 0 0 0-.307-.668 1.596 1.596 0 0 0-.513-.468 1.394 1.394 0 0 0-.707-.177c-.547 0-.959.19-1.237.57-.277.382-.416.887-.416 1.519 0 .297.036.572.109.827.072.255.18.474.324.657.145.182.318.327.519.433.201.107.435.16.701.16.296 0 .547-.06.752-.182a1.61 1.61 0 0 0 .508-.474 1.94 1.94 0 0 0 .284-.662c.057-.247.086-.5.086-.76Zm-4.536-2.954h1.231v.798h.022a1.61 1.61 0 0 1 .764-.736 2.54 2.54 0 0 1 1.06-.222c.463 0 .868.082 1.214.245.346.164.632.388.86.674.228.285.399.618.513.998.114.38.171.788.171 1.221 0 .396-.051.78-.154 1.153a2.986 2.986 0 0 1-.467.987 2.339 2.339 0 0 1-.792.685c-.319.171-.695.257-1.128.257-.19 0-.38-.017-.57-.052a2.452 2.452 0 0 1-.547-.165 2.143 2.143 0 0 1-.485-.291 1.6 1.6 0 0 1-.37-.416h-.023V16h-1.299V7.92Zm-4.365-.002h.98V6.15h1.299v1.77h1.174v.97h-1.174v3.15c0 .136.006.254.017.353a.617.617 0 0 0 .08.251.38.38 0 0 0 .188.154.926.926 0 0 0 .342.052c.091 0 .183-.002.274-.006a1.36 1.36 0 0 0 .273-.04v1.004c-.144.015-.285.03-.421.046a3.83 3.83 0 0 1-.422.023c-.342 0-.618-.033-.827-.097a1.102 1.102 0 0 1-.49-.286.984.984 0 0 1-.239-.473 3.497 3.497 0 0 1-.074-.65V8.887h-.98v-.97Zm-4.285 4.007c.038.381.182.647.433.8.25.152.551.228.9.228.122 0 .26-.01.416-.029a1.82 1.82 0 0 0 .439-.108.82.82 0 0 0 .336-.234.562.562 0 0 0 .12-.405.577.577 0 0 0-.182-.411 1.272 1.272 0 0 0-.439-.257 4.281 4.281 0 0 0-.61-.165c-.228-.046-.46-.096-.695-.149a6.394 6.394 0 0 1-.701-.194 2.244 2.244 0 0 1-.604-.308 1.426 1.426 0 0 1-.428-.497c-.106-.201-.159-.45-.159-.747 0-.32.077-.588.233-.805a1.8 1.8 0 0 1 .593-.525c.239-.133.505-.226.798-.28.292-.052.571-.08.838-.08.303 0 .594.033.872.098.277.065.528.17.752.314.224.144.41.333.558.565.148.232.241.511.28.838h-1.357c-.061-.311-.203-.52-.427-.627a1.773 1.773 0 0 0-.77-.16 2.74 2.74 0 0 0-.324.023 1.511 1.511 0 0 0-.354.085.745.745 0 0 0-.279.183.437.437 0 0 0-.114.314c0 .16.055.289.165.388.11.099.255.18.433.245.179.065.382.12.61.166.228.045.464.095.707.148.235.053.467.118.695.194.228.076.431.179.61.308.178.13.323.293.433.491.11.198.165.441.165.73 0 .35-.079.647-.239.89a1.9 1.9 0 0 1-.621.594 2.83 2.83 0 0 1-.849.331 4.269 4.269 0 0 1-1.955-.023 2.4 2.4 0 0 1-.821-.382 1.843 1.843 0 0 1-.547-.64 2.04 2.04 0 0 1-.211-.907h1.3Zm-2.211 1.896h-1.277v-.822h-.022c-.16.297-.397.535-.713.713a1.931 1.931 0 0 1-.963.269c-.775 0-1.335-.192-1.681-.577-.346-.384-.519-.964-.519-1.74V7.92h1.3v3.618c0 .518.098.883.296 1.096.198.213.475.32.832.32.274 0 .502-.042.684-.126a1.2 1.2 0 0 0 .69-.845c.049-.197.074-.41.074-.639V7.92h1.299v5.9Zm-9.417-5.901h1.219v1.14h.023a1.32 1.32 0 0 1 .222-.467 2.24 2.24 0 0 1 .399-.417 2.02 2.02 0 0 1 .519-.302c.19-.076.384-.114.581-.114a2.845 2.845 0 0 1 .49.034V9.05a6.202 6.202 0 0 0-.279-.04 2.345 2.345 0 0 0-.279-.017 1.48 1.48 0 0 0-.621.132 1.423 1.423 0 0 0-.507.388 1.881 1.881 0 0 0-.342.633 2.73 2.73 0 0 0-.126.867v2.808h-1.299v-5.9Zm-6.304-2.249h6.588v1.233h-2.588v6.916h-1.424V6.904h-2.576V5.671Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#01B676",
    fillRule: "evenodd",
    d: "m121.579 5.668-5.951-.001L113.79 0l-1.839 5.666H106l4.815 3.503-1.839 5.668 4.814-3.502 4.813 3.502-1.838-5.667 4.814-3.502Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#00542D",
    fillRule: "evenodd",
    d: "m116.992 10.4-.402-1.235-2.866 2.08 3.268-.846Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTrustpilotreact);

/***/ }),

/***/ 74725:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowreact = function SvgArrowreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: "#041942",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.75 6.75 5.5 5.25-5.5 5.25M19 12H4.75"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgArrowreact);

/***/ }),

/***/ 75679:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCrossreact = function SvgCrossreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#042759",
    fillRule: "evenodd",
    d: "M12.95 4.11a.75.75 0 0 0-1.06-1.06L8 6.94 4.11 3.05a.75.75 0 0 0-1.06 1.06L6.94 8l-3.89 3.89a.75.75 0 0 0 1.06 1.06L8 9.06l3.89 3.89a.75.75 0 1 0 1.06-1.06L9.06 8l3.89-3.89Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgCrossreact);

/***/ }),

/***/ 70975:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTrustpilotreact = function SvgTrustpilotreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126 31",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#191919",
    d: "M33.075 11.07h12.743v2.364h-5.01v13.29h-2.756v-13.29h-4.988V11.07h.01zm12.199 4.32h2.355v2.187h.044c.078-.31.223-.608.434-.895a4.117 4.117 0 0 1 1.766-1.381 3.074 3.074 0 0 1 1.122-.22c.29 0 .5.01.611.021.112.011.223.034.345.045v2.408a8.063 8.063 0 0 0-.545-.077 4.64 4.64 0 0 0-.544-.033c-.422 0-.822.088-1.2.254-.378.165-.7.42-.978.74-.277.331-.5.729-.666 1.215-.167.486-.245 1.039-.245 1.668v5.392h-2.51V15.39h.01zm18.22 11.335h-2.466v-1.58h-.045c-.31.574-.766 1.027-1.377 1.37-.611.342-1.234.519-1.867.519-1.5 0-2.588-.365-3.255-1.105-.667-.74-1-1.856-1-3.347V15.39h2.51v6.949c0 .994.19 1.701.579 2.11.377.409.922.618 1.61.618.534 0 .967-.077 1.323-.243.355-.165.644-.375.855-.651.222-.266.378-.597.478-.973.1-.375.144-.784.144-1.226v-6.573h2.511v11.324zm4.278-3.635c.077.729.355 1.237.833 1.536.489.287 1.066.441 1.744.441.233 0 .5-.022.8-.055.3-.033.589-.11.844-.21.267-.1.478-.254.656-.453.167-.199.244-.453.233-.773a1.065 1.065 0 0 0-.355-.784c-.222-.21-.5-.365-.845-.498a8.513 8.513 0 0 0-1.177-.32c-.445-.088-.89-.188-1.345-.287-.466-.1-.922-.232-1.355-.376a4.147 4.147 0 0 1-1.167-.596 2.628 2.628 0 0 1-.822-.95c-.21-.387-.31-.862-.31-1.437 0-.618.155-1.127.455-1.546.3-.42.689-.752 1.144-1.006a5.35 5.35 0 0 1 1.544-.541 9.454 9.454 0 0 1 1.622-.155c.59 0 1.156.067 1.69.188.532.122 1.021.32 1.455.608.433.276.788.64 1.077 1.082.29.442.467.984.545 1.613h-2.622c-.123-.596-.39-1.005-.823-1.204-.433-.21-.933-.31-1.488-.31a4.7 4.7 0 0 0-.634.045 3.483 3.483 0 0 0-.688.166 1.494 1.494 0 0 0-.545.353.852.852 0 0 0-.222.608c0 .31.111.552.322.74.211.188.49.343.833.475a8.44 8.44 0 0 0 1.178.32c.445.089.9.188 1.367.288.455.1.9.232 1.344.375.444.144.833.343 1.178.597.344.254.622.563.833.939.211.376.322.85.322 1.403 0 .674-.155 1.237-.466 1.712a3.7 3.7 0 0 1-1.2 1.138 5.66 5.66 0 0 1-1.645.641c-.6.133-1.2.199-1.788.199a7.629 7.629 0 0 1-2-.243c-.611-.166-1.145-.409-1.589-.73-.444-.33-.8-.74-1.055-1.225-.256-.487-.39-1.072-.411-1.746h2.533v-.022zm8.288-7.7h1.9v-3.403h2.51v3.403h2.267v1.867H80.47v6.054c0 .265.012.486.034.685.022.188.078.353.155.486.078.132.2.232.367.298.167.066.378.1.667.1.177 0 .355 0 .533-.011.178-.011.355-.034.533-.078v1.934c-.278.033-.555.055-.81.088a6.532 6.532 0 0 1-.812.044c-.667 0-1.2-.066-1.6-.188-.4-.121-.722-.309-.944-.552-.233-.243-.378-.541-.467-.906a6.775 6.775 0 0 1-.144-1.248v-6.684h-1.9v-1.89h-.022zm8.455 0h2.377v1.535h.045c.355-.663.844-1.127 1.477-1.414a4.892 4.892 0 0 1 2.056-.43c.9 0 1.677.154 2.344.474a4.58 4.58 0 0 1 1.666 1.293c.445.552.767 1.193.99 1.922a8.06 8.06 0 0 1 .332 2.342c0 .763-.1 1.503-.3 2.21a5.9 5.9 0 0 1-.9 1.9c-.4.552-.91.983-1.533 1.315-.622.331-1.344.497-2.188.497a6.17 6.17 0 0 1-1.1-.1 4.862 4.862 0 0 1-1.056-.32 3.815 3.815 0 0 1-.933-.563 3.507 3.507 0 0 1-.722-.796h-.045v5.657h-2.51V15.39zm8.777 5.678c0-.508-.067-1.005-.2-1.491a4.012 4.012 0 0 0-.6-1.282 3.05 3.05 0 0 0-.99-.895 2.784 2.784 0 0 0-1.366-.342c-1.055 0-1.855.364-2.388 1.094-.534.729-.8 1.7-.8 2.916 0 .575.066 1.105.21 1.591.145.486.345.906.634 1.26.278.353.611.63 1 .828.389.21.844.31 1.355.31.578 0 1.056-.122 1.456-.354.4-.232.722-.541.977-.906.256-.376.445-.795.556-1.27.1-.476.156-.962.156-1.459zm4.432-9.998h2.511v2.364h-2.51V11.07zm0 4.32h2.511v11.335h-2.51V15.39zm4.756-4.32h2.51v15.655h-2.51V11.07zm10.21 15.964c-.911 0-1.722-.155-2.433-.453a5.373 5.373 0 0 1-1.811-1.237 5.381 5.381 0 0 1-1.122-1.89 7.255 7.255 0 0 1-.39-2.408c0-.862.134-1.657.39-2.386a5.381 5.381 0 0 1 1.122-1.89c.489-.53 1.1-.938 1.81-1.237.712-.298 1.523-.453 2.434-.453.91 0 1.722.155 2.433.453a5.373 5.373 0 0 1 1.81 1.238c.49.53.867 1.16 1.123 1.889a7.17 7.17 0 0 1 .389 2.386c0 .873-.134 1.68-.39 2.408a5.381 5.381 0 0 1-1.121 1.89c-.489.53-1.1.939-1.811 1.237-.711.298-1.522.453-2.433.453zm0-1.978c.555 0 1.044-.121 1.455-.353a3.09 3.09 0 0 0 1.011-.917c.267-.376.456-.807.589-1.282.122-.475.189-.96.189-1.458a5.89 5.89 0 0 0-.189-1.447 3.77 3.77 0 0 0-.589-1.282 3.059 3.059 0 0 0-1.01-.906c-.412-.232-.9-.353-1.456-.353-.556 0-1.045.121-1.456.353a3.184 3.184 0 0 0-1.01.906 3.993 3.993 0 0 0-.59 1.282 5.882 5.882 0 0 0-.188 1.447c0 .497.066.983.188 1.458.123.475.323.906.59 1.282.266.376.6.685 1.01.917.411.243.9.353 1.456.353zm6.488-9.666h1.9v-3.403h2.51v3.403h2.267v1.867h-2.266v6.054c0 .265.01.486.033.685.022.188.078.353.156.486a.71.71 0 0 0 .366.298c.167.066.378.1.667.1.178 0 .355 0 .533-.011.178-.011.356-.034.533-.078v1.934c-.277.033-.555.055-.81.088a6.532 6.532 0 0 1-.812.044c-.666 0-1.2-.066-1.6-.188-.4-.121-.722-.309-.944-.552-.233-.243-.378-.541-.466-.906a6.775 6.775 0 0 1-.145-1.248v-6.684h-1.9v-1.89h-.022z",
    className: "tp-logo__text"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#00B67A",
    d: "M30.142 11.07h-11.51L15.076.177 11.51 11.07 0 11.059l9.321 6.74L5.755 28.68l9.321-6.728 9.31 6.728-3.555-10.882 9.31-6.728z",
    className: "tp-logo__star"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#005128",
    d: "m21.631 20.262-.8-2.464-5.755 4.154z",
    className: "tp-logo__star-notch"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgTrustpilotreact);

/***/ }),

/***/ 18050:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWhatsappreact = function SvgWhatsappreact(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    "aria-label": "whatsapp logo",
    role: "img"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "a",
    width: 24,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0V.5Z"
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.746 1.447a11.374 11.374 0 0 1 7.799 3.162 11.286 11.286 0 0 1 3.49 7.786 11.37 11.37 0 0 1-2.828 7.926 11.298 11.298 0 0 1-8.527 3.853c-1.705 0-3.395-.384-4.925-1.12L.807 24.375a.088.088 0 0 1-.103-.097l1.004-6.015a11.386 11.386 0 0 1-1.387-5.127 11.29 11.29 0 0 1 3.096-8.128 11.296 11.296 0 0 1 8.273-3.562h.056Zm-.063 1.972c-.09 0-.182.001-.273.004-5.176.148-9.267 4.48-9.118 9.657a9.402 9.402 0 0 0 1.287 4.487l.173.294-.744 4.08 4.039-.953.305.16a9.396 9.396 0 0 0 4.597 1.05c5.176-.148 9.267-4.48 9.118-9.657-.146-5.085-4.33-9.122-9.384-9.122ZM7.755 7.321c.19.006.38.012.546.024.203.014.427.03.626.513.236.572.747 2 .814 2.145.067.145.11.313.009.5-.101.188-.153.306-.3.468-.148.162-.311.363-.443.486-.147.138-.3.288-.143.579.157.29.7 1.242 1.525 2.025 1.06 1.005 1.91 1.337 2.247 1.495a.75.75 0 0 0 .312.084.419.419 0 0 0 .31-.145c.178-.18.713-.804.938-1.09.117-.15.224-.204.34-.204.092 0 .19.034.306.08.258.103 1.639.836 1.92.988.28.151.468.229.536.35.068.121.05.692-.208 1.351-.258.66-1.442 1.267-1.966 1.298-.154.01-.305.03-.501.03-.475 0-1.216-.124-2.899-.85-2.863-1.232-4.602-4.262-4.738-4.456-.137-.195-1.117-1.583-1.074-2.988.043-1.404.801-2.071 1.071-2.349.26-.266.556-.334.748-.334h.024Z",
    clipRule: "evenodd"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgWhatsappreact);

/***/ }),

/***/ 80458:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ZzadiPwYzicJFQxsktXe","clearInlineWhitespaceWrapper":"ZzadiPwYzicJFQxsktXe","container":"vZdYyN0G8sxdxSgox5Bo","background":"_nYv5DDcdW5OHUuhgTpW","header":"l13zcYVwHVGcRkv74odO","spacer":"WM_G0fcr_t4hijZNJD4a","take-me-home":"nm1IkHZf8_lKbCXSZy5U","takeMeHome":"nm1IkHZf8_lKbCXSZy5U","explainer":"sc8QYl48omeo9xKW76Qc"});

/***/ }),

/***/ 15634:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ROW4A4ydKkzv70FkmDuA","clearInlineWhitespaceWrapper":"ROW4A4ydKkzv70FkmDuA","accordion":"tqvOQ8sA0q8BCbo7_jXn","accordion-item":"BBRqt_4IEjS14tUJBGCR","accordionItem":"BBRqt_4IEjS14tUJBGCR","accordion-item-header":"VwuGQIYDADjycZf0Syq9","accordionItemHeader":"VwuGQIYDADjycZf0Syq9","accordion-icon":"xsnKXBRAHxaqxz7jvCgl","accordionIcon":"xsnKXBRAHxaqxz7jvCgl","accordion-button":"KAVj0SO76zT6ha2ow6Q7","accordionButton":"KAVj0SO76zT6ha2ow6Q7","accordion-content":"tp3mX_WnrmG0rqJB0F1N","accordionContent":"tp3mX_WnrmG0rqJB0F1N","accordion-content-show":"hCbtKhr5sezrKuUNxMfe","accordionContentShow":"hCbtKhr5sezrKuUNxMfe"});

/***/ }),

/***/ 93161:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"_WCAQARFZZT1Aeuum3tW","clearInlineWhitespaceWrapper":"_WCAQARFZZT1Aeuum3tW","enabled":"bYVBfnbdWcVKXSzu371P","disabled":"ueNshxIIMMQi2E6grnrV"});

/***/ }),

/***/ 67874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"Gec55pHJoB0G6UFA33sU","clearInlineWhitespaceWrapper":"Gec55pHJoB0G6UFA33sU","avatars":"W9qp0w5ebsrFR_eWOIEL","avatar":"S3JoTj1gi8hZ0h01PzRA"});

/***/ }),

/***/ 43404:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"uDCqe8j9Svp0zLolXM94","clearInlineWhitespaceWrapper":"uDCqe8j9Svp0zLolXM94","button":"Fa5CBKB07fjxBMZ4lz19","color-primary":"bBnddrJwf7FV_RPyCwgH","colorPrimary":"bBnddrJwf7FV_RPyCwgH","color-darkGreen":"RHEqaEDscxjdj7M_uanc","colorDarkGreen":"RHEqaEDscxjdj7M_uanc","color-tertiary":"ejENGeJBc4gmlsyYWehq","colorTertiary":"ejENGeJBc4gmlsyYWehq","color-secondary":"inFIYITgDuLSc6FOIuwc","colorSecondary":"inFIYITgDuLSc6FOIuwc","color-tertiaryLight":"Xdt2uDGPdhFQ9w0gX3fn","colorTertiaryLight":"Xdt2uDGPdhFQ9w0gX3fn","color-ghost":"kdy7xKjKeMGEjNeA4U9E","colorGhost":"kdy7xKjKeMGEjNeA4U9E","color-lime":"WBJBRfhjXre1s69YDJPc","colorLime":"WBJBRfhjXre1s69YDJPc","color-black":"e2McaZT_7AlRJZRiTEjd","colorBlack":"e2McaZT_7AlRJZRiTEjd","color-destructive":"i0QXPp2YlO3MymuW7kqU","colorDestructive":"i0QXPp2YlO3MymuW7kqU","color-success":"apHRFn06nKXkcvRPfUqc","colorSuccess":"apHRFn06nKXkcvRPfUqc","color-darkYellow":"Y7tkmX5rwSdeTgwwSDHm","colorDarkYellow":"Y7tkmX5rwSdeTgwwSDHm","size-small":"nPKhnTrtE_WLjCVliANF","sizeSmall":"nPKhnTrtE_WLjCVliANF","size-medium":"_eyo_oWbGtpZObZGP5Ta","sizeMedium":"_eyo_oWbGtpZObZGP5Ta","size-large":"MczzJfDlJVJyq0raYWRu","sizeLarge":"MczzJfDlJVJyq0raYWRu","fixed":"diSWnVw5Wz1KUtOsI_zF","primary":"sNDeEGGVJblH1Kq9tngH","arrowBox":"ht23q0mf9fKomXdcEVdb","arrow":"nktQYcS9cvRpI3hQaIbz","secondary":"eLWZd2Vzy67y2XLdmBop","typography":"BmF1fXfxaKGqsAYIEkOi","container":"SSNORTSMiSG7X5d1T4xQ"});

/***/ }),

/***/ 42009:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"MjSSEO3qcZ6Yb3Q47gXQ","clearInlineWhitespaceWrapper":"MjSSEO3qcZ6Yb3Q47gXQ","anchor":"Ij3JS6rqqWK7x8bPp6gg","color-primary":"vukXh4tM7m_Z20hn5JF8","colorPrimary":"vukXh4tM7m_Z20hn5JF8","color-darkGreen":"j5d5WKOAUkVTWSdove_Y","colorDarkGreen":"j5d5WKOAUkVTWSdove_Y","color-tertiary":"CdOSIoN6ALeIpJSF5Qxn","colorTertiary":"CdOSIoN6ALeIpJSF5Qxn","color-secondary":"x5VQ3pAm6lCRXzDyNU8x","colorSecondary":"x5VQ3pAm6lCRXzDyNU8x","color-tertiaryLight":"_qndvlFPjJC_EnkBK75Q","colorTertiaryLight":"_qndvlFPjJC_EnkBK75Q","color-ghost":"pdrNbFmPJ6_Oh2g6bOjJ","colorGhost":"pdrNbFmPJ6_Oh2g6bOjJ","color-lime":"RMbxD37n7TXS9Pp0YstQ","colorLime":"RMbxD37n7TXS9Pp0YstQ","color-black":"fbkBNaEUzMRieT6ob19j","colorBlack":"fbkBNaEUzMRieT6ob19j","color-destructive":"nWMVVSHlvYlagJpnW82Q","colorDestructive":"nWMVVSHlvYlagJpnW82Q","color-success":"ZC6ZDBwSlLBRLFvGyGbO","colorSuccess":"ZC6ZDBwSlLBRLFvGyGbO","color-darkYellow":"jmYpcGyXye9is9hwitbw","colorDarkYellow":"jmYpcGyXye9is9hwitbw","size-small":"WRBioxn_SW10Fxikz1ba","sizeSmall":"WRBioxn_SW10Fxikz1ba","size-medium":"cgyZWzdBsyYux6trSkWk","sizeMedium":"cgyZWzdBsyYux6trSkWk","size-large":"WPtaaA3x1GyA69yCq5Og","sizeLarge":"WPtaaA3x1GyA69yCq5Og","fixed":"NTeRfPrr5VKyWiYXwuh6","sub-label":"e2vMgaWXm0GwmK6US9Gg","subLabel":"e2vMgaWXm0GwmK6US9Gg"});

/***/ }),

/***/ 51844:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"JAnPSZNTphUhctUW_anP","clearInlineWhitespaceWrapper":"JAnPSZNTphUhctUW_anP","container":"QQIeAPafIYLZdcS07ZzS","inner-container":"grHQwrCaS_Cp82q_NnOL","innerContainer":"grHQwrCaS_Cp82q_NnOL","bubble":"cBijf3y_QsF3BjuT1lYz","bubble-user":"ynzph7h6ZdVhTe_o9F_5","bubbleUser":"ynzph7h6ZdVhTe_o9F_5","bubble-other":"ZTEaig8WndUyb69BYMu1","bubbleOther":"ZTEaig8WndUyb69BYMu1","text":"y1CECBUp9ouGbBDEICKk","avatar":"dfVSKfC_X9EDS7z9Dm3t","spinner-container":"Fcv8I0HeqeOizB3_95Od","spinnerContainer":"Fcv8I0HeqeOizB3_95Od","timestamp":"IMwOTZJoyFh8TC_NwLlp","align-right":"r4jqnB22JSYYGo8TdHVl","alignRight":"r4jqnB22JSYYGo8TdHVl"});

/***/ }),

/***/ 1448:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"uFFCZ8llSCMIr_TbwOkA","clearInlineWhitespaceWrapper":"uFFCZ8llSCMIr_TbwOkA","list":"V5oKRHIkDzbhOm_uTXNN","list-item":"QMSfPsSf3_pIBfEJfswJ","listItem":"QMSfPsSf3_pIBfEJfswJ","list-item-with-sub-item":"crPBUTdMLpT3SRuZGd2D","listItemWithSubItem":"crPBUTdMLpT3SRuZGd2D","list-sub-items":"JIE2240GZOTAwop98GZh","listSubItems":"JIE2240GZOTAwop98GZh","list-item-secondary":"M59Uvij6xefNnGJh3xCr","listItemSecondary":"M59Uvij6xefNnGJh3xCr","secondary":"Jphd1tvzgQ0QebwWEyO8","iconWrapper":"BftnMex4fdILGzvSlA9b","horizontal":"vxl2zYOFQJcaRBBqIl6D"});

/***/ }),

/***/ 55580:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"fC00C5VbUZ_jl4i2HL6_","clearInlineWhitespaceWrapper":"fC00C5VbUZ_jl4i2HL6_","progress-outline":"vIfbmZ6wyeK2clnFXJ2y","progressOutline":"vIfbmZ6wyeK2clnFXJ2y","progress-bar":"Jj6lFUCcUhxK3cS_qyqK","progressBar":"Jj6lFUCcUhxK3cS_qyqK"});

/***/ }),

/***/ 90231:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"Pl2aE6afGbW3j1wg7eMQ","clearInlineWhitespaceWrapper":"Pl2aE6afGbW3j1wg7eMQ","collapsible-content":"N7SvEAJ4UBuoYsvKRVN4","collapsibleContent":"N7SvEAJ4UBuoYsvKRVN4","spacer":"C8DK5J124jmlsNfw1JBo"});

/***/ }),

/***/ 61313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"AbRfB0TlJl1JtxH6Vsep","clearInlineWhitespaceWrapper":"AbRfB0TlJl1JtxH6Vsep","medium":"zx207jdaslQpFv9L1zFY","large":"popVnKapp9e3yElGdfpn"});

/***/ }),

/***/ 86365:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"GmUlixRUaIEq0pkyjbNO","clearInlineWhitespaceWrapper":"GmUlixRUaIEq0pkyjbNO","content-loader":"LFawXJm4OXA53BW3J0Or","contentLoader":"LFawXJm4OXA53BW3J0Or","loading":"VdZ9Upjpaj4tpLvxSK1t"});

/***/ }),

/***/ 33648:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"DowxVZAS2nbH3QVxddae","clearInlineWhitespaceWrapper":"DowxVZAS2nbH3QVxddae"});

/***/ }),

/***/ 2683:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"kXH3UGJBWe_J9Bi899ig","clearInlineWhitespaceWrapper":"kXH3UGJBWe_J9Bi899ig","ctaCard":"ItFy6h3QNXwIyt0CCnNB","text-container":"xA5_2W3CF1RrOtAwNReY","textContainer":"xA5_2W3CF1RrOtAwNReY","heading":"DDQ3bPzuXswcdUTrjyYi","description":"uu3bXHPwSYNiJoymFagg","ctaText":"yvel4DkP3ucY7i9r2E0q"});

/***/ }),

/***/ 50540:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"IIKtQUzp_gbs9GogUDAv","clearInlineWhitespaceWrapper":"IIKtQUzp_gbs9GogUDAv","overlay":"qbl9nM_bCHny1rEWslwh","modal":"T3Vqfl7_7e3rBeA0m9LK","page-container":"qX6AQpBmbyJ_AiYME1CF","pageContainer":"qX6AQpBmbyJ_AiYME1CF","x-large":"HnhY2FVjTEcnshNddG_I","xLarge":"HnhY2FVjTEcnshNddG_I","close-button":"hgiklW5goauHnGXPfi8h","closeButton":"hgiklW5goauHnGXPfi8h","fade-in-keyframes":"A7qXsm1JITbj42CuVWRT","fadeInKeyframes":"A7qXsm1JITbj42CuVWRT"});

/***/ }),

/***/ 83661:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"MyLVNmxT90Xc0Y5nX5F5","clearInlineWhitespaceWrapper":"MyLVNmxT90Xc0Y5nX5F5","page":"mWWX5dX0UugmGOGFuh8n","header-and-body":"LyM0mGXLuy5jM_j98ce8","headerAndBody":"LyM0mGXLuy5jM_j98ce8","top-icon-container":"DoUKp8kOSn3I95m69KMS","topIconContainer":"DoUKp8kOSn3I95m69KMS","title":"Ocp0az9MGgcP2IgpKOCA","body":"CeZZJLXaVV1MtkVQ2FWq","body-without-top-icon":"Qt5W5sWd5g6EKQJOjqXz","bodyWithoutTopIcon":"Qt5W5sWd5g6EKQJOjqXz","header-and-body-showing-image":"txCArwNQvpFnenK3X_Tp","headerAndBodyShowingImage":"txCArwNQvpFnenK3X_Tp","footer":"YoUj5KeGce6Cugn8A9hy","buttons-container":"b_trmX8Mbkwb4Lwj_dqd","buttonsContainer":"b_trmX8Mbkwb4Lwj_dqd","separator":"GE3X_cSJuy3Mnr78pLQw","left-image":"H9mEjsN4psnt_HenDtF9","leftImage":"H9mEjsN4psnt_HenDtF9"});

/***/ }),

/***/ 61172:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"kbwwIsFtBunLswS3sNfd","clearInlineWhitespaceWrapper":"kbwwIsFtBunLswS3sNfd","guidesCard":"tFSQt7pOG43Pj8vcS6gQ","guidesCardTitle":"kXFJ26iU6doLfel4f5xj","guidesCardText":"hChAA6713aO2CBy6Nltj","orange":"tus5GoJkRa61kuuOdDrF","guidesCardHeader":"gWx5ig6UWPCkCwdPvrPj","green":"Je95MQKe94QzVdPS46q8","purple":"PdO5VQhrfPZn7Dpm8aY9"});

/***/ }),

/***/ 64122:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ZS2MwGmJJRrk4pxs4H4C","clearInlineWhitespaceWrapper":"ZS2MwGmJJRrk4pxs4H4C","animation-wrapper":"FVM5wZB5ipU_0ok65OIE","animationWrapper":"FVM5wZB5ipU_0ok65OIE","animation":"tUIIymv4TgEIXPcGJEfs","title":"j2OQPVVEWjAVEolXf7mL","loading-wrapper":"QzBrHD3xufIa42BQWDCv","loadingWrapper":"QzBrHD3xufIa42BQWDCv","first-loading":"Mzp8YQlGOcCelUpJK_Ym","firstLoading":"Mzp8YQlGOcCelUpJK_Ym","second-loading":"kBrItgBWaC39nQLWeD3m","secondLoading":"kBrItgBWaC39nQLWeD3m","third-loading":"mX4tP2kfO8VTKv8kzLcf","thirdLoading":"mX4tP2kfO8VTKv8kzLcf","fourth-loading":"j_jfBjblnyrdjqcneeU5","fourthLoading":"j_jfBjblnyrdjqcneeU5","children-wrapper":"kAehLxjMTjg_FoNlRnk8","childrenWrapper":"kAehLxjMTjg_FoNlRnk8"});

/***/ }),

/***/ 21598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"v9ylntZ78pG3zq6cu_zQ","clearInlineWhitespaceWrapper":"v9ylntZ78pG3zq6cu_zQ","item-wrapper":"g3wB6_eShSxIJPzaAFEw","itemWrapper":"g3wB6_eShSxIJPzaAFEw","icon-wrapper":"QIGc24np8rmMuMCwmRJB","iconWrapper":"QIGc24np8rmMuMCwmRJB","vertical-line-wrapper":"ahLY2ethUuJiuEC5uQQC","verticalLineWrapper":"ahLY2ethUuJiuEC5uQQC","vertical-line":"LOxzMW3HJvC0EynGl5ym","verticalLine":"LOxzMW3HJvC0EynGl5ym"});

/***/ }),

/***/ 34762:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"DthDcrs6omgHmA12svp7","clearInlineWhitespaceWrapper":"DthDcrs6omgHmA12svp7","loadingIndicator":"sIT6yCphxDbZaGIskJI0","loadingIndicatorText":"r2sRSlWDb09_HB6qK0Yc","spinner":"OnP7C713raDriS5MecMM","backgroundArc":"wny2f7ShApfZRjhJwFuN","rotatingArc":"vHwRrjsDAcx6TooLCY4Q"});

/***/ }),

/***/ 5424:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"wtqymdO2qmvCtdNjJfpH","clearInlineWhitespaceWrapper":"wtqymdO2qmvCtdNjJfpH","container":"qloz6IFZUI8Im2DU3xQ5","chart":"FhPvVxpcXJLbmDYWFyEA","padlock-container":"_3SzGZzrQJXjqTQYgtLC","padlockContainer":"_3SzGZzrQJXjqTQYgtLC","text":"UJI1zB_wKxA2UFiklNNH"});

/***/ }),

/***/ 29418:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"TmfgrQuQIMEXf1etck5R","clearInlineWhitespaceWrapper":"TmfgrQuQIMEXf1etck5R","button":"HOOYCYkWH1Cs49Lt98QZ","color-primary":"a9oCz3FPY6dL2XkZqtXx","colorPrimary":"a9oCz3FPY6dL2XkZqtXx","color-darkGreen":"zLA0ihntOO52wprwU2EZ","colorDarkGreen":"zLA0ihntOO52wprwU2EZ","color-tertiary":"nJ8DgYPbXhijPSaWpdFf","colorTertiary":"nJ8DgYPbXhijPSaWpdFf","color-secondary":"jWq2RbnK72n9tsWV3KTv","colorSecondary":"jWq2RbnK72n9tsWV3KTv","color-tertiaryLight":"wmrr7e_dfYEtb7J3FOMU","colorTertiaryLight":"wmrr7e_dfYEtb7J3FOMU","color-ghost":"UichhhcEPjD6M7yD7_Xq","colorGhost":"UichhhcEPjD6M7yD7_Xq","color-lime":"OiaIvk8CjxUxOAyEuVpU","colorLime":"OiaIvk8CjxUxOAyEuVpU","color-black":"OUU6PfjWDMDH0sxXinQ8","colorBlack":"OUU6PfjWDMDH0sxXinQ8","color-destructive":"pLFxEGjUkfcNQFfloi7G","colorDestructive":"pLFxEGjUkfcNQFfloi7G","color-success":"IdNfNCMkmXMEnZUwwXvV","colorSuccess":"IdNfNCMkmXMEnZUwwXvV","color-darkYellow":"YAJG_UX9G6bDDFACiu9g","colorDarkYellow":"YAJG_UX9G6bDDFACiu9g","size-small":"LtXi5Atcqf5GCY1sEe1q","sizeSmall":"LtXi5Atcqf5GCY1sEe1q","size-medium":"D_6lqUhxzFAnN7ZF50g5","sizeMedium":"D_6lqUhxzFAnN7ZF50g5","size-large":"OYlW8etNhl2TY_Dwz1kc","sizeLarge":"OYlW8etNhl2TY_Dwz1kc","fixed":"M3Sxm2x1zJ7FOver1WRA","arrowBox":"q4pitpFJYSUb3jWKDB4d","typography":"YwsPfaUhkHKdQEjfGmZt","container":"cGb5XFZ6Zfhs9stNjC0b","arrow":"haS88HqewwkZQBq4qX2h","primary":"Ovz5sJ9FBvTFUtE5gkKC","secondary":"du6E3wibKEJ8pdExRNnb"});

/***/ }),

/***/ 46132:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"tGue_qPkcOJaxB_7RBqj","clearInlineWhitespaceWrapper":"tGue_qPkcOJaxB_7RBqj","menu":"NXdmu0z4FfFG3TXdpBxz","name":"mvOCrzkHtMj0D5eh80pQ","menu-open":"b0gJamCqhODSYN3eiIdD","menuOpen":"b0gJamCqhODSYN3eiIdD","default-link":"AWYGxbNrbna1_sPkEnqs","defaultLink":"AWYGxbNrbna1_sPkEnqs","open":"kJJfJ1yPLpDBzpJQxf46","closed":"E8pexjVG6v9wQArGYatJ","menu-item-button":"HLkX0KL9cp_06k93gaOV","menuItemButton":"HLkX0KL9cp_06k93gaOV","menu-options-wrapper":"VdWBtFr86Axi5JkkvBEh","menuOptionsWrapper":"VdWBtFr86Axi5JkkvBEh","menu-children":"XXbXcaTEr8Mpu3bvOH1X","menuChildren":"XXbXcaTEr8Mpu3bvOH1X","menu-options":"N7bphCDrBPP0h1JvypJ9","menuOptions":"N7bphCDrBPP0h1JvypJ9"});

/***/ }),

/***/ 30931:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"tWIdqa1vMkATSTYusw3r","clearInlineWhitespaceWrapper":"tWIdqa1vMkATSTYusw3r","message":"Bo3OACa3Q8nDXoUbXohY","icon":"QIWmCfzhgLJiLhRq45SK","error":"_ciyuFVaU57xoySZTvK5","warning":"SHETUbW2xcmSyhXH7iOj","success":"o5HEtFPeAMxv8VucXIft","information":"RXPMTaMlZWznm3BLSLVl","pending":"bfS0L0OA6qUp3PA0e1hk"});

/***/ }),

/***/ 13288:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"m9IaVwu2xUQQsUWtOER_","clearInlineWhitespaceWrapper":"m9IaVwu2xUQQsUWtOER_","overlay":"dTBZXDB03p1K3wYDWp8I","modal":"HFAUOi6MhivWWE7qNbCf","close-button":"CwmBZkolravA6ciMTgoL","closeButton":"CwmBZkolravA6ciMTgoL","fade-in-keyframes":"aOFZNmJTZVPOpGDrDlam","fadeInKeyframes":"aOFZNmJTZVPOpGDrDlam"});

/***/ }),

/***/ 59990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"jD4B_PkkF6v59aywdNq6","clearInlineWhitespaceWrapper":"jD4B_PkkF6v59aywdNq6","title":"mhqm2a_HgGd4TsLCdlf0","subtitle":"CFeiqTxLuenkRS1Ca3xB","desc":"TRFIzfL0Epjf8DxSM6nA"});

/***/ }),

/***/ 21984:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"owXD31h6yrL1SwztURnn","clearInlineWhitespaceWrapper":"owXD31h6yrL1SwztURnn","content":"npKSHHBpY28tSlKeLrfT","shadow":"Q0X091R2QGHgEiiBtrLD","outer-container":"MnjSegAZIsB0ykY6BSu3","outerContainer":"MnjSegAZIsB0ykY6BSu3"});

/***/ }),

/***/ 37081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"VhUkWyIavkqgYyWAOouG","clearInlineWhitespaceWrapper":"VhUkWyIavkqgYyWAOouG","container":"P0xRRw2i7Ra9MHKkYct6","previousButton":"VZPaO7LPiCx5N8w49Pov","nextButton":"rZC3g1ppN69UAnGNj9tw","hidden":"QWETo8WuR45lSF9BcxPh","buttonText":"UeYWMAzrDvYMUcCu4wB7","currentPage":"us1ORPcwynzmZVJC_Rqs","betterV2":"VZMoiTIUQo47OKsVAf4a"});

/***/ }),

/***/ 23302:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"QhhbRB1xsVWfYxDATYvV","clearInlineWhitespaceWrapper":"QhhbRB1xsVWfYxDATYvV","pill":"rJRQemVHqG9Nf7T1lZuA","primary":"m9BPZQQXY4GXFfw_1n70","secondary":"BgiDObKGiGIS9pqVMOuP","informative":"Gyu27IEXzgEX2Hbpd7ha","disabled":"iYzVvlSkQubh6yOZ0at2","warning":"iK1h4lTvR1lg82UUDUty"});

/***/ }),

/***/ 48226:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"pIojZ7mXpHjTEGX4AebK","clearInlineWhitespaceWrapper":"pIojZ7mXpHjTEGX4AebK","name":"yljVWDtsdjnuIvUnC_Qt","profile-menu":"UlbFhnyiKqdqFzRxLVHe","profileMenu":"UlbFhnyiKqdqFzRxLVHe","chevron":"b4aV9TmG_fC2EH9QD3p7","illustration-icon":"Ab2TpAfgWWICBDNZ_S8b","illustrationIcon":"Ab2TpAfgWWICBDNZ_S8b","desktop":"phgD112njPl5OymwH2oy","mobile":"fkAfHYLYAtn69D7_r7xY"});

/***/ }),

/***/ 85949:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"w54obtbwdLak8Wc_QfUD","clearInlineWhitespaceWrapper":"w54obtbwdLak8Wc_QfUD","progress":"qsuZTWS2QKknIxhpwUfH"});

/***/ }),

/***/ 50578:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"u3nrI2qpkOYBs41NsQgI","clearInlineWhitespaceWrapper":"u3nrI2qpkOYBs41NsQgI","card":"CEyg9rHqlrlab7_rXF02","author-line-container":"Qw4YeBwzjQI3eG_jn4bG","authorLineContainer":"Qw4YeBwzjQI3eG_jn4bG","title":"b8UQk4J5a4Nl8gZ5MebJ","icon-container":"v8N5MK0F0NfSE9sVRegQ","iconContainer":"v8N5MK0F0NfSE9sVRegQ","text":"qNL5YKqrdY9U4jihafSv"});

/***/ }),

/***/ 10945:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"RMVc8rWUBSfkNRJlhNuJ","clearInlineWhitespaceWrapper":"RMVc8rWUBSfkNRJlhNuJ","simpleText":"Pb1Eve0adDEZb9hKDkQC","heading":"MXn4kdwltjCBR5SUmBLT","body":"DC0lGDQJ6_ICycf39p1I","footer":"wUvPLhggRjF_6uouYaZw"});

/***/ }),

/***/ 19272:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"P9I_TpELSe_Ew50Y_Kly","clearInlineWhitespaceWrapper":"P9I_TpELSe_Ew50Y_Kly","wrapper":"cmDZFYZbBjKQ1CyeKHxJ","slideout":"rIq25Xs0q8tgIKTCI_g6","secondary":"xFDVEJ4WtZV9USB9w0W4","slideoutContent":"DouwTJfIWGIroTRCcaZJ","header":"nClX20t2BGpIBp6Xigp2","secondaryHeader":"BAbXhy_dLkXdOXrKsYZn","closeButton":"IWK9l5zf2I_14kCRBb_E","hidden":"kgP5kOJN5jUDkcRMpcN2","modalOpen":"plx_30HRBfkQt6DgNK_5"});

/***/ }),

/***/ 74777:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"mt2":"JR64qNS46bwjHzowUtTf","mt4":"PH6esGIV_O9YMMjkS5J1","mt8":"yLz6c0WyHZrHWyEcue9J","mt12":"LcCiiI7S0GaRLmKVtK90","mt16":"vJ_v9szVVStEzBcK7G4e","mt24":"DqljqtjYN8WG1FuWiLLo","mt32":"WthKbKoFIemgNu6Vadmz","mt48":"VODsJhKFyILXkrAd_gkT","mt56":"eOhcvhbyRGVOXpWkpp8h","mt64":"GulMrU6xxbT8Vd1byRuc","mr2":"aqOX7etztVsDIPlw8YkG","mr4":"XKjvxVZumaOuzbxhoYIv","mr8":"FSNMa1WuG1Ie38vN3U98","mr12":"ukN2CcyuVa8JY7ElRuIB","mr16":"BFr7kZ2ur9FauTyfdrvn","mr24":"yLbb6MZoZGQOm8xWIJJU","mr32":"h1cEwQ_dnt63jIVSwIws","mr48":"WggXL0RuSfzvylHCTsDs","mr56":"NGBQIeFjeslMSexGzmMg","mr64":"SRZJoS6u3feCnSPv6D52","mb2":"I9vzHP6lYZHr91xi4rGs","mb4":"_J9AMA1yxzsrR3IYUN0N","mb8":"ulLcaoHiSgq53ZXFM2WC","mb12":"vX9jMsDOkeaIPPNuRgin","mb16":"IpQZDc92CeF6o2jKCVEb","mb24":"GJaveY7GEdzprex7nEdt","mb32":"ZYmkfIt7mX65NF3TuO_l","mb48":"UrDbY8lrbEObXI6EzmIF","mb56":"vuXYW14Y8Mk8QfLFnn0Z","mb64":"jfCbPAcZqW6YXsaUtqUW","ml2":"yMW6KVRdb3HW4S60LSJg","ml4":"dOqAs9HV6Bq4zLnG9Aml","ml8":"uHv1HshGt2vGn0X57bwA","ml12":"lbp2SIqiolBgYK6fBiZP","ml16":"NDUkbuYvB0R9RB0Dhfdz","ml24":"H68VukO5o6A69BJdSpAF","ml32":"SYyox5T2QvvAMlVOGVvO","ml48":"MCtFSqNGqbFiG1KASjZC","ml56":"Exz5ASEZO4UHtXaUekbA","ml64":"b0hhTyxmExAKNlrHtS04"});

/***/ }),

/***/ 7662:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ToCWN_rkB6BBbib7tHzO","clearInlineWhitespaceWrapper":"ToCWN_rkB6BBbib7tHzO","background-arc":"pPr5vIjhATz_Qh3LtHap","backgroundArc":"pPr5vIjhATz_Qh3LtHap","rotating-arc":"JHBXLCsRENLYdaHMzQUb","rotatingArc":"JHBXLCsRENLYdaHMzQUb","arc--animation":"IcryfJsFh7WAYIezAO6g","arcAnimation":"IcryfJsFh7WAYIezAO6g"});

/***/ }),

/***/ 67715:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"zd7O5xMRb9mrb1HrTXyQ","clearInlineWhitespaceWrapper":"zd7O5xMRb9mrb1HrTXyQ","has-visibility-hidden":"XItGhHOJp4xSeqAEdOqa","hasVisibilityHidden":"XItGhHOJp4xSeqAEdOqa","has-display-none":"tJN03NupPitn0rZr4QN8","hasDisplayNone":"tJN03NupPitn0rZr4QN8","spinner-wrapper":"KPUP0CpllzbztOzUNWt9","spinnerWrapper":"KPUP0CpllzbztOzUNWt9","spinner":"zGAaQbuDepKPRNn0AeMj"});

/***/ }),

/***/ 32866:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"iytuZpNvfZWfZaNfACnh","clearInlineWhitespaceWrapper":"iytuZpNvfZWfZaNfACnh","staticFooter":"xxVigBPLW5rJPStqpEKE"});

/***/ }),

/***/ 66172:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"qP9VmtB8aBjkZ9aZywda","clearInlineWhitespaceWrapper":"qP9VmtB8aBjkZ9aZywda","subtitle":"Ye7cB_Sncvb2QA9DqMOQ","align-left":"C13b9Lmnsw8guYNoMhLE","alignLeft":"C13b9Lmnsw8guYNoMhLE","align-center":"aUTwfMtJm_TTMEadiw86","alignCenter":"aUTwfMtJm_TTMEadiw86","font-weight-regular":"v_9KSJxMvzgCJPSPxBfE","fontWeightRegular":"v_9KSJxMvzgCJPSPxBfE","font-weight-semi-bold":"rtmpc3WT8SwJW_lEdsrJ","fontWeightSemiBold":"rtmpc3WT8SwJW_lEdsrJ","font-weight-bold":"nuCU7u6CsPlM6ssgJO7o","fontWeightBold":"nuCU7u6CsPlM6ssgJO7o"});

/***/ }),

/***/ 4295:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"krcBOWRXhjjn5utBT5mS","clearInlineWhitespaceWrapper":"krcBOWRXhjjn5utBT5mS","container":"kWHnSXuaLEOkHm9e9mhA","tab":"pdfaHyNwxh48NqkqJkKo","betterV2":"QHXMD6QwEEjXJRlcQLt8","tab-active":"LbjOy9dYTxlq4IDrrthr","tabActive":"LbjOy9dYTxlq4IDrrthr"});

/***/ }),

/***/ 62481:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"p3vmoIFNbfI3ODPWHDpw","clearInlineWhitespaceWrapper":"p3vmoIFNbfI3ODPWHDpw","text-link":"zPzEBNl97O_M0GgQQbw9","textLink":"zPzEBNl97O_M0GgQQbw9","text":"X0iuVbh4feMG0qd_jaZG","icon":"anbrnR_iPTXsCuuaVKyp","underlined":"vBkf92mkGmB0kaUOOik0","light":"odemZI1HGBscTmb1hosA","light-disabled":"sMBaOb9A0yzJosv0L62L","lightDisabled":"sMBaOb9A0yzJosv0L62L","dark":"PikdimoDPbrw60AvJ6B9","dark-disabled":"_EKp2ImO5S_c1_tUomia","darkDisabled":"_EKp2ImO5S_c1_tUomia","secondary":"yGylbdcY53dctkUwYInu","secondary-dark":"TmivR74nyG4zUeOG4YRz","secondaryDark":"TmivR74nyG4zUeOG4YRz"});

/***/ }),

/***/ 49604:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"e3ubStIufX4xDctYVvHI","clearInlineWhitespaceWrapper":"e3ubStIufX4xDctYVvHI","timer":"cSHhaMGTDNJn6j1lM2QV","timerText":"COhIL_8OKephZBtcfjEN","time":"wnBdhBbFOv31AVLuewsR"});

/***/ }),

/***/ 12928:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"TWAJSt8SZkMuhCAzw95l","clearInlineWhitespaceWrapper":"TWAJSt8SZkMuhCAzw95l","title":"eJrX5ewe4jxHmjzoabKM","align-left":"UHw8SCNZJt_zYHQdgyaD","alignLeft":"UHw8SCNZJt_zYHQdgyaD","align-center":"ghmq96cKCZuTmxJM06TJ","alignCenter":"ghmq96cKCZuTmxJM06TJ","font-weight-regular":"uMkA9TOMmtm6Gbl8ldI3","fontWeightRegular":"uMkA9TOMmtm6Gbl8ldI3","font-weight-semi-bold":"_kYmXqWZ3kMwp7jTD1l8","fontWeightSemiBold":"_kYmXqWZ3kMwp7jTD1l8","font-weight-bold":"zV5RYglcNin6nTqIQ9UW","fontWeightBold":"zV5RYglcNin6nTqIQ9UW"});

/***/ }),

/***/ 91554:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"w2j8I294forfojVvDtTl","clearInlineWhitespaceWrapper":"w2j8I294forfojVvDtTl","tracker-dot":"oceuIK_Vp79VhY5jMi7f","trackerDot":"oceuIK_Vp79VhY5jMi7f","active":"xZQE0ALBGg7zWHBf3iaO","fixed":"V568UNwLKc6bi_92RvRy","inactive":"e6lOoGDaQRpJIQEfh3Wz"});

/***/ }),

/***/ 9311:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"eWiupFOajC05vxKSthAo","clearInlineWhitespaceWrapper":"eWiupFOajC05vxKSthAo","button":"sCbhGtwCvqVpXk1gKs0r","icon":"NRNaZvutL2rmRP31ncYA","left-btn":"EU3S09l3ptmoqcl3OPCg","leftBtn":"EU3S09l3ptmoqcl3OPCg","right-btn":"Wfb1nRu6iFA8Jr73OgH0","rightBtn":"Wfb1nRu6iFA8Jr73OgH0","icon-add":"M8sIiMc5Wx1r2FcLGDqE","iconAdd":"M8sIiMc5Wx1r2FcLGDqE","icon-remove":"lovSBNTsPW2PnH15Yzym","iconRemove":"lovSBNTsPW2PnH15Yzym","icon-left-arrow":"Pvh0eNqWSso0fIwKuNHS","iconLeftArrow":"Pvh0eNqWSso0fIwKuNHS","icon-right-arrow":"GKasxP5MckGppj4P2jmq","iconRightArrow":"GKasxP5MckGppj4P2jmq"});

/***/ }),

/***/ 69598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"l7lUlf4HKAjwGKu8MjLz","clearInlineWhitespaceWrapper":"l7lUlf4HKAjwGKu8MjLz","animationWrapper":"zUpH7nWcU3eo3jV_zHr3","first-arrow":"CBLKq2ouwaobroOEckc1","firstArrow":"CBLKq2ouwaobroOEckc1","second-arrow":"JZizJf0wXuUFbI0mR6vJ","secondArrow":"JZizJf0wXuUFbI0mR6vJ","third-arrow":"hJYoleYaevq6KGKHO7cj","thirdArrow":"hJYoleYaevq6KGKHO7cj","size-small":"KIVANK6CjyYK8g5YOAHA","sizeSmall":"KIVANK6CjyYK8g5YOAHA","size-medium":"cTT1BgN75YTxqPuHAzIq","sizeMedium":"cTT1BgN75YTxqPuHAzIq","size-large":"G0ZaiVH_DU7EqXFuHpyc","sizeLarge":"G0ZaiVH_DU7EqXFuHpyc"});

/***/ }),

/***/ 28272:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"lkHEWf14eAwZVoqKkQqt","clearInlineWhitespaceWrapper":"lkHEWf14eAwZVoqKkQqt","back-link":"mrb8DXN9xvyoikE3RsYz","backLink":"mrb8DXN9xvyoikE3RsYz","icon":"ombjwGU6uK0ot4obZLhs","left-btn":"MiihHbKHv7ZQRra9Udkd","leftBtn":"MiihHbKHv7ZQRra9Udkd","right-btn":"Ny5K7TVC6BlmIA4BpIpG","rightBtn":"Ny5K7TVC6BlmIA4BpIpG","icon-add":"r6jgLmjzGgmbv2T2Fy2V","iconAdd":"r6jgLmjzGgmbv2T2Fy2V","icon-remove":"FzuAkHbrEDTrsHJMycvc","iconRemove":"FzuAkHbrEDTrsHJMycvc","icon-left-arrow":"sfnY1EesVigplCmHK_AZ","iconLeftArrow":"sfnY1EesVigplCmHK_AZ","icon-right-arrow":"SkFYFz7WaGqZxw5_GYaW","iconRightArrow":"SkFYFz7WaGqZxw5_GYaW"});

/***/ }),

/***/ 52841:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"I8vQBCIHS3TBlXdQdJ_d","clearInlineWhitespaceWrapper":"I8vQBCIHS3TBlXdQdJ_d","button":"Zet3uhkugZO39L7brvKL","color-primary":"kAO817E30Id_2_xaM61y","colorPrimary":"kAO817E30Id_2_xaM61y","color-darkGreen":"LG5KiLG7KpPs3HZojjbI","colorDarkGreen":"LG5KiLG7KpPs3HZojjbI","color-tertiary":"LQP2I7oFjyZYgc3a2JhI","colorTertiary":"LQP2I7oFjyZYgc3a2JhI","color-secondary":"Kb90JoaAVJYYi_wPnpc4","colorSecondary":"Kb90JoaAVJYYi_wPnpc4","color-tertiaryLight":"B5OUf4Y6YXE5YudaQqnV","colorTertiaryLight":"B5OUf4Y6YXE5YudaQqnV","color-ghost":"uhNzduZK0aFem5nEnikq","colorGhost":"uhNzduZK0aFem5nEnikq","color-lime":"ZsLayznVCI6fDMknTFOQ","colorLime":"ZsLayznVCI6fDMknTFOQ","color-black":"KQYZGiUiYOpNG1cIW1rG","colorBlack":"KQYZGiUiYOpNG1cIW1rG","color-destructive":"BeeKO5rjql9YyUVw55up","colorDestructive":"BeeKO5rjql9YyUVw55up","color-success":"fsi7pnWbcvT_8B_6Oz_c","colorSuccess":"fsi7pnWbcvT_8B_6Oz_c","color-darkYellow":"T0VI7T0O8PzPyacPEOwF","colorDarkYellow":"T0VI7T0O8PzPyacPEOwF","size-small":"tLoxDUxavjm9u5U2sC2m","sizeSmall":"tLoxDUxavjm9u5U2sC2m","size-medium":"GYQ5nXSC7SGd8NF8s3eQ","sizeMedium":"GYQ5nXSC7SGd8NF8s3eQ","size-large":"P0QKMUkTzxbjSKOfmOJz","sizeLarge":"P0QKMUkTzxbjSKOfmOJz","fixed":"XAETXU0_W8d3hmS9LXA9","size-icon":"fCGp0ihnJ0uXb5SZmgLl","sizeIcon":"fCGp0ihnJ0uXb5SZmgLl"});

/***/ }),

/***/ 47366:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"gjfNSY2etgjWse7MlDhs","clearInlineWhitespaceWrapper":"gjfNSY2etgjWse7MlDhs","light-label-v3":"CyzHnynsvK8L6yuGwtKy","lightLabelV3":"CyzHnynsvK8L6yuGwtKy","green-label":"gRXZzzBwZ1ELbE6Ai0SX","greenLabel":"gRXZzzBwZ1ELbE6Ai0SX","low-contact-label":"ktp3ZSxPbSWmAvleqtK3","lowContactLabel":"ktp3ZSxPbSWmAvleqtK3","light-label":"tGAJc7LC2xGqisbcF1_w","lightLabel":"tGAJc7LC2xGqisbcF1_w","default-label":"cioO9z67Fcjv1pahYBAZ","defaultLabel":"cioO9z67Fcjv1pahYBAZ","container":"kIqJTKavCgZP0fvzIHQ5","input":"JjcxEW6v69FWkPsT14gO","box-wrapper":"Jt_SyLKx9u4GcmiJuMkv","boxWrapper":"Jt_SyLKx9u4GcmiJuMkv","box":"zgCH6hmfdh10m1C9qBtg","box-checked":"LQKNS4PGnXuUt8nfMf2Q","boxChecked":"LQKNS4PGnXuUt8nfMf2Q","disabled-box":"akkbXiuYBUNCcY5o0244","disabledBox":"akkbXiuYBUNCcY5o0244","box-wrapper-checked":"EGwuu0Jd6wmOj6d1iyQg","boxWrapperChecked":"EGwuu0Jd6wmOj6d1iyQg","label-checked":"WAl8udGc8zwrgLOJlde8","labelChecked":"WAl8udGc8zwrgLOJlde8","error":"M1qAU6IIiH4cwcxrqYLR","disabled":"BQq6n3CGS_bKGFfcS83r","tooltip-wrapper":"bDDKabnrWmyMPaw_woXw","tooltipWrapper":"bDDKabnrWmyMPaw_woXw","tooltip-outer-container-default":"LoicvdhB_hTnerMoFTEV","tooltipOuterContainerDefault":"LoicvdhB_hTnerMoFTEV","tooltip-inner-container-default":"EJSHKV9Ovuo0g3DhYM78","tooltipInnerContainerDefault":"EJSHKV9Ovuo0g3DhYM78","tooltip-inner-container-light":"ocZeN3eYjanO9coOuhaE","tooltipInnerContainerLight":"ocZeN3eYjanO9coOuhaE","tooltip-outer-container-light":"tJTA7ml0L78ljJ7KXgiT","tooltipOuterContainerLight":"tJTA7ml0L78ljJ7KXgiT","small-label":"sRaDVCIDgUr5wicQMY8Q","smallLabel":"sRaDVCIDgUr5wicQMY8Q","small-box":"gsuw8NpemGS3tZEiQnVf","smallBox":"gsuw8NpemGS3tZEiQnVf","small-box-v3":"I47NIM_VrB9FpSX6_cyC","smallBoxV3":"I47NIM_VrB9FpSX6_cyC","small-box-green":"HKtshEJ04jRj7DmKWpPf","smallBoxGreen":"HKtshEJ04jRj7DmKWpPf"});

/***/ }),

/***/ 88680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"nWZgurK7om5WIBI66u_n","clearInlineWhitespaceWrapper":"nWZgurK7om5WIBI66u_n","container":"xMVH_Y6W0PC1mHrjnWxe","icon":"AjQK75Y56NYi40oEE6Uq","input":"C5Mm7O8SuG9V_ENSd8x1","input-invalid":"Bq0p2ht3N2EI13KYKVxm","inputInvalid":"Bq0p2ht3N2EI13KYKVxm"});

/***/ }),

/***/ 44332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"UVtSXrfGZIYMHLM89MmV","clearInlineWhitespaceWrapper":"UVtSXrfGZIYMHLM89MmV","input":"hTODmLz_UjXSQOYI_8gd","input-error":"HhqgOiZk263nEudPq4OV","inputError":"HhqgOiZk263nEudPq4OV"});

/***/ }),

/***/ 39004:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ejhdQVi0kbAzvDNn4D26","clearInlineWhitespaceWrapper":"ejhdQVi0kbAzvDNn4D26","container":"TSG0UWsShMN0fq1evENl","select":"xx7dAJUesjMzY9cYMbW8","secondary":"kxETFYrtEoAF4RZdzqQy","label":"xiVdw9UPo56J_Jr2GCUf","error":"kgoJnuCdtwggujwV60GK"});

/***/ }),

/***/ 73772:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"mbQ9SnPUEjsuJRzs4DHp","clearInlineWhitespaceWrapper":"mbQ9SnPUEjsuJRzs4DHp","expand-button":"_4Fow0EWl757QX1XkHWA","expandButton":"_4Fow0EWl757QX1XkHWA"});

/***/ }),

/***/ 99091:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"c8_yBUz6a0fnrk0Nrtkk","clearInlineWhitespaceWrapper":"c8_yBUz6a0fnrk0Nrtkk","error":"j8r1lxEWnyX0rv9May_y"});

/***/ }),

/***/ 81726:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"S4T83HQ64SWyoWhUxZ9o","clearInlineWhitespaceWrapper":"S4T83HQ64SWyoWhUxZ9o","fieldset":"b4lx3D9KRaCKrUHliehB","legend":"gaP6QhOizdgHaVEjnkIE","hide-legend":"wVJ0PVoneSy2SuiBAax1","hideLegend":"wVJ0PVoneSy2SuiBAax1","with-tooltip":"d4ZgnfxpwRdoDZGtgOT7","withTooltip":"d4ZgnfxpwRdoDZGtgOT7"});

/***/ }),

/***/ 37473:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"L1KjKSJJQExlsG9PXDwD","clearInlineWhitespaceWrapper":"L1KjKSJJQExlsG9PXDwD","flatTile":"fNVfNUelmhfSSDJjVfwx","iconContainer":"m54udvelBLYR3qgzx_QE"});

/***/ }),

/***/ 48621:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"SdsHswv1Yy8FKUvG_FYQ","clearInlineWhitespaceWrapper":"SdsHswv1Yy8FKUvG_FYQ","button":"__iZ2tYNB1wt0S2kkD8E","size-small":"uqb7Fdi4rXcfDpZAjUSu","sizeSmall":"uqb7Fdi4rXcfDpZAjUSu","size-medium":"V29vj6GnuOHNqtGzyxef","sizeMedium":"V29vj6GnuOHNqtGzyxef","size-large":"aemKtuj5XSdhd5QbwV2t","sizeLarge":"aemKtuj5XSdhd5QbwV2t","fixed":"tvlPYx6g2d72hurHZaJL"});

/***/ }),

/***/ 79745:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"Wu7bd3EnryH5tDA4ysvw","clearInlineWhitespaceWrapper":"Wu7bd3EnryH5tDA4ysvw","container":"lbO3vywFGDJHi9LInwXE","select-container":"AyBizX0u6eRYxcSp4Iop","selectContainer":"AyBizX0u6eRYxcSp4Iop","select":"so4IPoyquP21nDTOk7HS","label":"kD92u4pEnDS0lNSJqKNp","label-margin-left":"x2sCG7gJTh31s7IRzWwP","labelMarginLeft":"x2sCG7gJTh31s7IRzWwP","label-margin-right":"qVhNJA4xShnr0Hbu_Oly","labelMarginRight":"qVhNJA4xShnr0Hbu_Oly","icon":"lqylWeY8dXoXpYqAhDtf","betterV2":"aWXrEPIiDXGHeDpNe9iE","input-container":"HJpm7lZYNwZLnVRidVYi","inputContainer":"HJpm7lZYNwZLnVRidVYi","yearInput":"V99DdHeemuki1AZ31EOi","input-container-colour-primary":"zVteZ81Pp96HKBkeypow","inputContainerColourPrimary":"zVteZ81Pp96HKBkeypow","input-container-colour-secondary":"Ua8BbcvjaYSPD4hoJ42v","inputContainerColourSecondary":"Ua8BbcvjaYSPD4hoJ42v","reverse":"OC7Lur0m67YWP5R6c1m3","input":"a3oGmXgbHR2GqohpUw9v","additionalTextContainer":"j3yIR5RlBDilA_6lI88H","icon-x":"DsqE0fsXrEe80qU77Jmn","iconX":"DsqE0fsXrEe80qU77Jmn","errorMsg":"_5qw1X0SIRF_xdqTV8SJ","helperText":"AZDVihGyMLWN4yX8mA_u","disabled":"krzlI7ft_pjUG0kGBsJx","error":"EDDLhBQWvz_KFuOuPfrr","hide-label":"NFAgY2B07DgVPdqd2HkA","hideLabel":"NFAgY2B07DgVPdqd2HkA","size-small":"w4deynQ6kJ0nWGKAXeHI","sizeSmall":"w4deynQ6kJ0nWGKAXeHI","size-large":"W7JQUY6yosMNZbIMtvE7","sizeLarge":"W7JQUY6yosMNZbIMtvE7","size-x-large":"u22fRN5h01XMDiB0jYHu","sizeXLarge":"u22fRN5h01XMDiB0jYHu","align-left":"ZsNRBojj0wMK_Aj_0W1_","alignLeft":"ZsNRBojj0wMK_Aj_0W1_","align-right":"HvzSB_cJO57im0hSb6K2","alignRight":"HvzSB_cJO57im0hSb6K2","focused":"Su6U3cr2_tTdnqjIZLJg","label-initially-moved-up":"iFYQWMrxpgrCGztU26NV","labelInitiallyMovedUp":"iFYQWMrxpgrCGztU26NV","label-align-left":"wNmkPEFaigoQEoqB27VH","labelAlignLeft":"wNmkPEFaigoQEoqB27VH","label-align-right":"KlUK2CRQ3X7jKBKCMG0O","labelAlignRight":"KlUK2CRQ3X7jKBKCMG0O","focused-icon-margin":"fE0kAj637tcsAgHhxLYq","focusedIconMargin":"fE0kAj637tcsAgHhxLYq","label-initially-moved-up-icon-margin":"XzQAnSw6lVKKXMBmI28Q","labelInitiallyMovedUpIconMargin":"XzQAnSw6lVKKXMBmI28Q","extra-padding":"f7CSa9ssU77rysEA2wcY","extraPadding":"f7CSa9ssU77rysEA2wcY","yearInputIcon":"HwUVurKklGmwML_Vz7dJ","yearInputDivider":"GPBjs_6_u2RbJlN3kz25","closeButton":"S8JY53TvTjHEFiIvdGB0","yearCloseButton":"CV7kADqEN41gXRTlhJ1B","closeButtonIconRightAligned":"t48Gor5zHZi53tw5jZhh","closeButtonRightAligned":"WOZbqY18tvOic47Q0Zxs"});

/***/ }),

/***/ 55477:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"vQKdca8Bqk01LEa_CNYc","clearInlineWhitespaceWrapper":"vQKdca8Bqk01LEa_CNYc","label":"ziaFZgjOVCLuD45JwhnB","withTooltip":"eWpmGCWlmMPLv4nGek1K"});

/***/ }),

/***/ 87707:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"sF6TfrtSXD1BTKkWvwv0","clearInlineWhitespaceWrapper":"sF6TfrtSXD1BTKkWvwv0","button":"LFywCC45ij4dMqf98xWH","icon":"IS6BSAoLL1xuGBWDDM6k","left-btn":"MQPFeCcQV68cCfewBdMc","leftBtn":"MQPFeCcQV68cCfewBdMc","right-btn":"aXOvuf2OrzVHl_KE68MW","rightBtn":"aXOvuf2OrzVHl_KE68MW","icon-add":"oAE6isQY30k6MvtPRkoQ","iconAdd":"oAE6isQY30k6MvtPRkoQ","icon-remove":"EBsnJTO6eaBytRmlFK6i","iconRemove":"EBsnJTO6eaBytRmlFK6i","icon-left-arrow":"WL4z6cgkeC_SHcs09WsG","iconLeftArrow":"WL4z6cgkeC_SHcs09WsG","icon-right-arrow":"PHE9yB8JXaL18nnpW6BF","iconRightArrow":"PHE9yB8JXaL18nnpW6BF","size-small":"JnJ6tmhECS2e5Ife0Bma","sizeSmall":"JnJ6tmhECS2e5Ife0Bma","size-medium":"LFcKS_ugeGXU7IO_UqGL","sizeMedium":"LFcKS_ugeGXU7IO_UqGL"});

/***/ }),

/***/ 59856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ZpKsKZUhSoFJojRFJdh2","clearInlineWhitespaceWrapper":"ZpKsKZUhSoFJojRFJdh2","container":"V6HPxvlx1LUg8I6IVZpU","icon":"SkB813ltZ18sytvcZwB2","input":"v9tHwcRPxS6SNAjRDItT","input-invalid":"Punr9xygyUFhokn5aibO","inputInvalid":"Punr9xygyUFhokn5aibO"});

/***/ }),

/***/ 4547:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"uqJpNynS5oKlfVpN6xaD","clearInlineWhitespaceWrapper":"uqJpNynS5oKlfVpN6xaD","question-button":"nHMk8R3s6uEE5Vs0Mbrl","questionButton":"nHMk8R3s6uEE5Vs0Mbrl"});

/***/ }),

/***/ 183:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ryrunXNRADQdDAoSJHts","clearInlineWhitespaceWrapper":"ryrunXNRADQdDAoSJHts","button":"I54dfeuhnkektmk1KIT5"});

/***/ }),

/***/ 33696:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"zjylXBVJM5f9JAZnw1rE","clearInlineWhitespaceWrapper":"zjylXBVJM5f9JAZnw1rE","input-wrapper":"Yv40CftC5oQ2p73SmRJ0","inputWrapper":"Yv40CftC5oQ2p73SmRJ0","inline":"wWs5uFPoOJJOSc5r5Y9z","input":"uIttjGGLt8F5d69seka3","label":"lVi5ZclcAOkcDpoBCF_i","radio":"GB1uFVYP36qwp33qT82q","radio-checked":"cnjQbELKdNVQmqnEVjX3","radioChecked":"cnjQbELKdNVQmqnEVjX3","disabled":"MCHMU2znhlE1_vQYCzxG","disabled-radio":"VRpdPTipU0CoH1rSm46N","disabledRadio":"VRpdPTipU0CoH1rSm46N","tooltip-outer-container":"vPOvgL3VvnZa0tcWVl_Y","tooltipOuterContainer":"vPOvgL3VvnZa0tcWVl_Y","tooltip-inner-container":"VqDsnUwvmBZh2TbA6TXs","tooltipInnerContainer":"VqDsnUwvmBZh2TbA6TXs","error":"nAfeVnH1hpwFatTklH5J","label-v2":"_vCgY4tuCrgHRekvh79Z","labelV2":"_vCgY4tuCrgHRekvh79Z","radio-v2":"L7k5zFvFV1W8Rts3QHYJ","radioV2":"L7k5zFvFV1W8Rts3QHYJ","disabled-radio-v2":"ru72SfsbTZ3ojlXJ63_n","disabledRadioV2":"ru72SfsbTZ3ojlXJ63_n","label-checked-v2":"vqY3tuBcxfdduep1fWC0","labelCheckedV2":"vqY3tuBcxfdduep1fWC0","radio-checked-v2":"pvzHfjHLZhLOBgwqYHwx","radioCheckedV2":"pvzHfjHLZhLOBgwqYHwx","radioPoint":"rTEY0BZYELLTeioyvQSK","disabled-v2":"Cpg7jgBIIN0DuyHQzzuI","disabledV2":"Cpg7jgBIIN0DuyHQzzuI"});

/***/ }),

/***/ 76357:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"C59VUAqQPsLku2GvMmkx","clearInlineWhitespaceWrapper":"C59VUAqQPsLku2GvMmkx","input":"jTSoaVpw3LwTU58SzIr8","container-disabled":"MZoEb1EhORvsHV9Oo5ES","containerDisabled":"MZoEb1EhORvsHV9Oo5ES","input-disabled":"lNabTTtiCXqI2DLVHlqw","inputDisabled":"lNabTTtiCXqI2DLVHlqw","bubble-container":"iutLHjL7CzONOee4Th1T","bubbleContainer":"iutLHjL7CzONOee4Th1T","bubble":"qLldtSxnoCsDuxFZyHws","notches-container":"jPsnoIaY7YUYhF5flf0N","notchesContainer":"jPsnoIaY7YUYhF5flf0N","notches":"tHhQDbTO5rrjIPTCeUKE"});

/***/ }),

/***/ 18062:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"n5fX8uVPNPp7ZGwSoOpz","clearInlineWhitespaceWrapper":"n5fX8uVPNPp7ZGwSoOpz","container":"inDv6GekTMwj1zJnqXMM","icon":"fZXyNAQFzOInCilhbdhM","input":"NByio6jH22mvxvu8mF2Q","input-container":"kPc2K8Np9_vRXAQYFjvT","inputContainer":"kPc2K8Np9_vRXAQYFjvT","size-small":"hHVNpq62u7W9BzYVpz7E","sizeSmall":"hHVNpq62u7W9BzYVpz7E","cancelButton":"NNnzrkxW5LuxXgEgwaWv","loader":"rq8qgOIQDRTwA33wmlJN","size-large":"cwtHum2NByJln_EJGJr1","sizeLarge":"cwtHum2NByJln_EJGJr1","label":"OUxtQTpp1bZ_giP91tw8","spinner":"a7q_7SZ_Y7g2IPt7KOR2","hideCancelSearchButton":"YBN6seM7u7qYpAC35V06","hide-spinner":"GhVBuIfpotqjJWmONj6I","hideSpinner":"GhVBuIfpotqjJWmONj6I","betterV2":"cvyw99rfWlXAXDpeLqQc"});

/***/ }),

/***/ 16358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"CNTLj8rDUaN3kjhgKM_h","clearInlineWhitespaceWrapper":"CNTLj8rDUaN3kjhgKM_h","subtle-button":"tF3m23dxkY6C0gACM2v3","subtleButton":"tF3m23dxkY6C0gACM2v3"});

/***/ }),

/***/ 82287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"mP1izIaoonLMrC0Py9U4","clearInlineWhitespaceWrapper":"mP1izIaoonLMrC0Py9U4","subtle-button-with-icon":"i1u2GNBfDdLA2xYRv0gy","subtleButtonWithIcon":"i1u2GNBfDdLA2xYRv0gy"});

/***/ }),

/***/ 78601:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"NJKMDWOIgsOkDqi67Y7w","clearInlineWhitespaceWrapper":"NJKMDWOIgsOkDqi67Y7w","button":"UHFD2uvH2_atriHurViu","text":"DrDeJ3CQ_hFraF_fu9qN","icon":"D8MRVnobRfNMgdywA8rw"});

/***/ }),

/***/ 50765:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"JJl_3gTK8Snz31FAZ6uV","clearInlineWhitespaceWrapper":"JJl_3gTK8Snz31FAZ6uV","container":"Kk8upTDTEKMuKYZ8nnIl","input":"m2Heh9gvOaQj4esH9bHg","input-invalid":"ozTEfUqezy01IvfDwLSW","inputInvalid":"ozTEfUqezy01IvfDwLSW","suffix-text":"D9SQUP69LT1PEz9bJ6G0","suffixText":"D9SQUP69LT1PEz9bJ6G0"});

/***/ }),

/***/ 86559:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"TTWSVGbadXaNn9N5eevK","clearInlineWhitespaceWrapper":"TTWSVGbadXaNn9N5eevK","textarea":"C4QTh5GstxxuWJOhZeZC","textarea-invalid":"dkbNQAzgnRMuYSRjvl6J","textareaInvalid":"dkbNQAzgnRMuYSRjvl6J"});

/***/ }),

/***/ 25831:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ca7JZHR0Bk81Yj3BAd_W","clearInlineWhitespaceWrapper":"ca7JZHR0Bk81Yj3BAd_W","tile-group":"stzatLNAQqdJyU5gdghT","tileGroup":"stzatLNAQqdJyU5gdghT","tile":"GajaxhfgvP7C5vOpjpK3","input":"t_xYDx007Hfoy2mQYS0K","label":"Ra1Z1YpYzMurZp31KNmX","error":"Q6RrdS3pyrT6Gbqr5QEN","icon-wrapper":"zARcyjHJanXGzeiVp4tE","iconWrapper":"zARcyjHJanXGzeiVp4tE","icon":"WuLALuBL0RZCyuf8Ebnt","description-wrapper":"SOGzkmeOLflcC09pgQvM","descriptionWrapper":"SOGzkmeOLflcC09pgQvM","description":"HGrH_R6VgDjQVDLkLDzj","selected-container":"svtkXMLVKE7o2ZCX3A9w","selectedContainer":"svtkXMLVKE7o2ZCX3A9w","checked-container":"QFA6jjuLn5t2TbrdhGb2","checkedContainer":"QFA6jjuLn5t2TbrdhGb2","checked-label":"CzTWLtnXmKDV4Xyn01fM","checkedLabel":"CzTWLtnXmKDV4Xyn01fM"});

/***/ }),

/***/ 44409:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"zqy3hTO4L4fiItJ__BGF","clearInlineWhitespaceWrapper":"zqy3hTO4L4fiItJ__BGF","container-v4":"qa3jJQkZSx2ofZ9P5ND8","containerV4":"qa3jJQkZSx2ofZ9P5ND8","button":"pdCaOwG2C8xi4567GgWJ","button-dark":"C2f6_zki4G_FqJZSbSGv","buttonDark":"C2f6_zki4G_FqJZSbSGv","button-normal":"Qw_ODsaWPD_T72RiGG4x","buttonNormal":"Qw_ODsaWPD_T72RiGG4x","button-small":"PmoFyiBWBCdXp4plH7WG","buttonSmall":"PmoFyiBWBCdXp4plH7WG","button-with-validation":"GsEuhbAysHwHSrcs639l","buttonWithValidation":"GsEuhbAysHwHSrcs639l","tip-outer-container":"JVt2luiREH8hGf_xT54A","tipOuterContainer":"JVt2luiREH8hGf_xT54A","button-grey":"yjeDtc09apUnCclFX57v","buttonGrey":"yjeDtc09apUnCclFX57v","tip-inner-container":"lLcvUyZ9GQp7hPalqvUh","tipInnerContainer":"lLcvUyZ9GQp7hPalqvUh","outer-container-open":"w4_1hB8CcW1dmKEPuOFJ","outerContainerOpen":"w4_1hB8CcW1dmKEPuOFJ","tip-open":"FoQM6xZJZpNNlpCqC2II","tipOpen":"FoQM6xZJZpNNlpCqC2II","tip-small":"jknA44q34y149NAi2XgJ","tipSmall":"jknA44q34y149NAi2XgJ","tip-with-validation":"wBdDYisiYhbY6_PjmMrB","tipWithValidation":"wBdDYisiYhbY6_PjmMrB","text-container":"mrdLftQSyJ7qQDlSVO88","textContainer":"mrdLftQSyJ7qQDlSVO88","alwaysOpenDown":"JMU4D_T59PB2EB2aXksZ","text-container-v3":"PgUrntl51pD8RadgN07Q","textContainerV3":"PgUrntl51pD8RadgN07Q","button-v3":"sidUehabk0z1NfP_ZDhm","buttonV3":"sidUehabk0z1NfP_ZDhm","tip-open-v3":"OAFtFbyoKDke_qKQTqBk","tipOpenV3":"OAFtFbyoKDke_qKQTqBk","tip-grey-small":"NwjRj2fu6Dg8T5hpNLaS","tipGreySmall":"NwjRj2fu6Dg8T5hpNLaS","body":"XRqezLJANkmINXWeAJiX","position-top":"nHoC8pkM68gCLHvFEFaK","positionTop":"nHoC8pkM68gCLHvFEFaK","position-bottom":"ZIkzUKFsXspgRCNaejrw","positionBottom":"ZIkzUKFsXspgRCNaejrw","position-left":"KY1NQkha7nEWPvCOkSxb","positionLeft":"KY1NQkha7nEWPvCOkSxb","position-right":"EkoMiqsPv2Xuhx92OvTg","positionRight":"EkoMiqsPv2Xuhx92OvTg","show":"wCSmUitf1W_WfxUAA3iL"});

/***/ }),

/***/ 344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"NDrF6GPAKRk0TgZclbQW","clearInlineWhitespaceWrapper":"NDrF6GPAKRk0TgZclbQW","container":"t4_ashVbPhZKVakzBnrB","input":"JSadcNgTLvXfL9gXj3Zx","input-invalid":"rlHQADhUAtas1QYQckQZ","inputInvalid":"rlHQADhUAtas1QYQckQZ","results":"z3lCp0Jww0jB7dt8VoNm","option":"jIbl093P5Ljw7320XhbQ","option-selected":"XTScIc_f478vjhNAmXoq","optionSelected":"XTScIc_f478vjhNAmXoq"});

/***/ }),

/***/ 36930:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"icon-container":"f4mUAAE8FWXAkvh8BNi1","iconContainer":"f4mUAAE8FWXAkvh8BNi1","icon":"TQm2UoFHvCX4uGONANe2"});

/***/ }),

/***/ 54278:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"inner-container":"AIf59qF8A39VdX7qxul_","innerContainer":"AIf59qF8A39VdX7qxul_","component-container":"VQZr_iB8MIGOkw2qWz6U","componentContainer":"VQZr_iB8MIGOkw2qWz6U","error-container":"cGwh1fm2NboxwXS6_SNX","errorContainer":"cGwh1fm2NboxwXS6_SNX","untouched":"vv4SO8WIpUvTgVUOWTxL"});

/***/ }),

/***/ 26021:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"sD1qZZI3Lx_s7t1Y0d4t","clearInlineWhitespaceWrapper":"sD1qZZI3Lx_s7t1Y0d4t","trustpilot":"CrT7KrEtfnigHgEdVerQ","trustpilotWap":"AZsNzGsAbGvZf8V7h_u7","trustpilot-logo":"Dc8IBBJuht17oUB1bMpg","trustpilotLogo":"Dc8IBBJuht17oUB1bMpg","trustpilot-stars":"seShbbIDo20CL2jVvkWw","trustpilotStars":"seShbbIDo20CL2jVvkWw","trustpilot-score":"fxwzo6P6wMmeU6S8TU0o","trustpilotScore":"fxwzo6P6wMmeU6S8TU0o"});

/***/ }),

/***/ 2241:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"Zm59XmFnuiLOBQUErpNE","clearInlineWhitespaceWrapper":"Zm59XmFnuiLOBQUErpNE","button":"ziokffeqJOrGw6_rqMAX","text":"YCzQHLowe93HkGuXaMA2","arrow":"L4QEuYHMxHbNOb2jnXcf","arrow-clicked":"gnjXz990hCYT9b7pLqBZ","arrowClicked":"gnjXz990hCYT9b7pLqBZ","arrowDefault":"RdruG0rDqVbcV4iHq_RH","arrowDesktop":"jo_sQGNzsC6nlSq56yWg","arrowMobile":"SscKCmS2q2hLYW_UMaOE"});

/***/ }),

/***/ 35138:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"me7Rtg9iWvqfX_LOeJP6","clearInlineWhitespaceWrapper":"me7Rtg9iWvqfX_LOeJP6","application-card":"L44Lty95iO9WHwDnsY9V","applicationCard":"L44Lty95iO9WHwDnsY9V","filled":"S_4kMQtpjgz0Jvl7moQ4","collapsibleContentDivider":"uEkGF_YPqQvgeNWrjA7e","header":"Z13L_pDUIWHkDbCymZsY","title":"IesccbzPTDKQGDXyYw3m","textLink":"o5plK5203u57d_P0Y2FF","open":"hhU8UIZWDirR3MBilBUg","collapsed":"mK0E4GikZSJbe2WiGCj4","applicationCard__line":"LYx1vkZeznvd68ZxC7in","applicationCardLine":"LYx1vkZeznvd68ZxC7in","applicationCard__line__title":"oPOK3kPFK_Za1unrAPJc","applicationCardLineTitle":"oPOK3kPFK_Za1unrAPJc","applicationCard__line__info":"tp4bdW0bUGCYxrORxSjR","applicationCardLineInfo":"tp4bdW0bUGCYxrORxSjR","edit":"enbz0Wj_aTInBGLmXT4r","showMoreButton":"BAeyPnxIT7lCorlq4gQw","applicationCardBottom":"YufEx5vY16rwAp4b5Gi1","applicationCard__textLink":"bswLASu8CcYhGbQsDvh7","applicationCardTextLink":"bswLASu8CcYhGbQsDvh7"});

/***/ }),

/***/ 15410:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"SBo9SuWsTPGKgBfZqZzI","clearInlineWhitespaceWrapper":"SBo9SuWsTPGKgBfZqZzI","adviser-assigned-wrapper":"s2E3cTjDCKJkxbAK4du0","adviserAssignedWrapper":"s2E3cTjDCKJkxbAK4du0","adviser-assigned-wrapper-light":"Gh3Q5XQ719a349VPGUFu","adviserAssignedWrapperLight":"Gh3Q5XQ719a349VPGUFu","adviser-assigned":"zHJAyzCvky9tsKw_2xZ5","adviserAssigned":"zHJAyzCvky9tsKw_2xZ5","adviser-assigned-early-breakpoint":"D7eaAp1Xz7S7FKl1CFHH","adviserAssignedEarlyBreakpoint":"D7eaAp1Xz7S7FKl1CFHH","adviser-wrapper":"OCQHU_1eoPFjFJmDZ0CQ","adviserWrapper":"OCQHU_1eoPFjFJmDZ0CQ","icon":"CX67B84MDGzVWaKXfE1U","iconContainer":"pk3wXnNs80cpzMuUuugi","details":"CYfrV6uX4KdyQx9yD1Tz","title":"kQ1HDIIIN1xxBmPCGu1A","cta":"C8yBWtjgralTMnqCrmI1","phone-number":"HzVVq8iWuAPorVxbypyp","phoneNumber":"HzVVq8iWuAPorVxbypyp","external-email":"l6ROdq4SPS29Vcogs_XM","externalEmail":"l6ROdq4SPS29Vcogs_XM","sub-title":"Vwr08fkc6VFfiqEUpVQU","subTitle":"Vwr08fkc6VFfiqEUpVQU","buttons-container":"vBVMWntGEF0vtTOmwU4r","buttonsContainer":"vBVMWntGEF0vtTOmwU4r","quoteLayout":"Q84uAv5cV_IvDnV2kmV6","adviserDetailsContainer":"akI3mN698XFhyxNkklkB","quoteContainer":"WNVk_r4mkayDq1NAZHWY","quoteInnerContainer":"gFPPRbNwDD7iA8FqmePq","quoteTextContainer":"MsRpyLuUt1_T7yBLeFIS","quoteIconContainer":"C2MeJoib6b6fphtVolYL","hr":"eG4IOEYNehOeIzr3Uy1l"});

/***/ }),

/***/ 32489:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"tayqH40iIonor8WBZh7g","clearInlineWhitespaceWrapper":"tayqH40iIonor8WBZh7g","no-adviser-assigned-container":"rwtbJbRjfhuYQjuQfRsf","noAdviserAssignedContainer":"rwtbJbRjfhuYQjuQfRsf","no-adviser-assigned-card":"Ih_O76yv58N9MBdWV_j5","noAdviserAssignedCard":"Ih_O76yv58N9MBdWV_j5","no-adviser-title":"vLqDIc3PJOEHPJ4qrJf4","noAdviserTitle":"vLqDIc3PJOEHPJ4qrJf4","no-adviser-ordered-list":"sBuHRZwObsboREaN6czl","noAdviserOrderedList":"sBuHRZwObsboREaN6czl","no-adviser-list-item":"pZKP9AtRmsChjPGGKEua","noAdviserListItem":"pZKP9AtRmsChjPGGKEua","spinnerWrapper":"rG9ySfGBX5yIKiwkKrV5","backgroundArc":"pJJbgdjvOImhrS6gvWew","rotatingArc":"L2CTyYCBxAiC0W_g_vxQ","spinnerWrapperLight":"vtSRwFlqciQM5UwSneyw"});

/***/ }),

/***/ 15771:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"vKQI98OFpBzo7uUPOylQ","clearInlineWhitespaceWrapper":"vKQI98OFpBzo7uUPOylQ","application-card":"OXBXozXOQ_EpZ6I2sSPw","applicationCard":"OXBXozXOQ_EpZ6I2sSPw","header":"LFpA2TVimOJ0VjW8n6N9","title":"XgAh_NWXLCOZjy5uVFQR","names":"YC4sfczA28cFJ9ZKCLzY","address":"K2sibw1jwI86F8Wt0sNk","financials":"xQ8ePH9yBW8vOQl7gbA2","cta":"VEL7NYXxuP4dZdXDVEaU"});

/***/ }),

/***/ 9262:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"XO5fuRCD2o59nktBAVcj","clearInlineWhitespaceWrapper":"XO5fuRCD2o59nktBAVcj","service-offering":"pzsVkFrpvO5e9SB_zhwR","serviceOffering":"pzsVkFrpvO5e9SB_zhwR","offeringLogos":"NpVn3CFpmLHyVIDznHmQ","figure":"lghj9K0O_teutNCfdFMQ","figureDescription":"AMwYRJFpAhSPEsvshXLu","list":"hxCRHdRiDTv2C5Iawz5J","informationBlock":"gNvMQDQy8Shcb1QO917u","informationTitle":"bAVq9NBvgeeFwdch5Hr0","informationDescription":"kCtNl8LGIYCq8InrpCQA"});

/***/ }),

/***/ 54313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"SYHdyP3wKuh6TZfZekN6","clearInlineWhitespaceWrapper":"SYHdyP3wKuh6TZfZekN6","card-container":"KLFSfjeKugHVNzCBEaTI","cardContainer":"KLFSfjeKugHVNzCBEaTI","title":"jBzVZB6mpdfbLzGrv5G0","list-container":"bw22vnpbNVIbY2jhBs8A","listContainer":"bw22vnpbNVIbY2jhBs8A","card-container-full-width":"ZVYm97r9pN5C0lyCjvyR","cardContainerFullWidth":"ZVYm97r9pN5C0lyCjvyR","col":"cTDyC_w1DYiRnUAB1LRH","col-content":"GzQXVtrnNyoafFo7USTy","colContent":"GzQXVtrnNyoafFo7USTy","card":"bfkjMDUcWqLX6Of5rdiA","background":"rfJQ1rlXIC77BeJPD1ZS","illustration":"q9tKTuvfuv5L_woRCqW7","card-with-illustration":"nBfwEu49zw3JjzG4KyEf","cardWithIllustration":"nBfwEu49zw3JjzG4KyEf","card-full-width":"LnqWU_zSh2tBAQFZ2N9F","cardFullWidth":"LnqWU_zSh2tBAQFZ2N9F","card-with-background":"Ah0a2IqJsjFARByeSvT2","cardWithBackground":"Ah0a2IqJsjFARByeSvT2","card-with-link":"oVVHWpjuhkHoGDjY2NlA","cardWithLink":"oVVHWpjuhkHoGDjY2NlA","link":"zVRZaf8eVEOX6jXD_658","card-with-cta":"Vo_wbGUN7mcbrMzEpjwj","cardWithCta":"Vo_wbGUN7mcbrMzEpjwj","cta":"ytTjtpmV6AjHjtGMo6r8","cta-illustration":"bJ3Z8OYkUsKRZ5ornXKO","ctaIllustration":"bJ3Z8OYkUsKRZ5ornXKO","text":"f1ws4Ohb5Gabf30_aPwL","text-inner-wrap":"Keg3zhEqQ3kwjPEaFbig","textInnerWrap":"Keg3zhEqQ3kwjPEaFbig","button":"EfL8V7saXo5hPAVs29o5","card-with-cta-and-illustration":"VcAgo_tOL1lrIrOxmN11","cardWithCtaAndIllustration":"VcAgo_tOL1lrIrOxmN11","card-list-of-links":"R6GbjE5pJReAF0IVD6IW","cardListOfLinks":"R6GbjE5pJReAF0IVD6IW","list":"BpPW3odeziSJfhQz98Sg","hero-content":"my6eEJkpnbzGNrEXmzq2","heroContent":"my6eEJkpnbzGNrEXmzq2","hero":"NTJxzPT1fYNZLEG6Sagh","links":"hEUoouXNQYV_v4c4__zC","no-border":"BEPXxrQ_R4JDWqA89bnY","noBorder":"BEPXxrQ_R4JDWqA89bnY"});

/***/ }),

/***/ 97170:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"zFgeJyyeNdSAn_LOWQ25","clearInlineWhitespaceWrapper":"zFgeJyyeNdSAn_LOWQ25","card-carousel":"CyevziVMEczRHoSCqnv0","cardCarousel":"CyevziVMEczRHoSCqnv0","card-wrapper":"L2KPR5UJlI0h9jh15Nyz","cardWrapper":"L2KPR5UJlI0h9jh15Nyz","card-navigation-bar":"FqXAgKzitgrnTiFVEIhr","cardNavigationBar":"FqXAgKzitgrnTiFVEIhr","page-tracker":"uX2wXW2N_jp3usQTX_wD","pageTracker":"uX2wXW2N_jp3usQTX_wD","navigation-buttons":"ehZ_eKLSi31so58w4QeN","navigationButtons":"ehZ_eKLSi31so58w4QeN","navigation-button":"QINQwjdYX8pTqngE3qkC","navigationButton":"QINQwjdYX8pTqngE3qkC"});

/***/ }),

/***/ 21679:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"uKZ8sXi519x40jbSkPKZ","clearInlineWhitespaceWrapper":"uKZ8sXi519x40jbSkPKZ","container-wrapper":"Livf1DHALyzGfXDTgbGv","containerWrapper":"Livf1DHALyzGfXDTgbGv","carousel-container":"HhsRZqEdrZeAjKHHwPh7","carouselContainer":"HhsRZqEdrZeAjKHHwPh7","carousel-container--narrow":"sINqdoJ2P0wwQZ6aJQg_","carouselContainerNarrow":"sINqdoJ2P0wwQZ6aJQg_","carousel-wrapper":"boFHAFUpDZKEVWhOl2JS","carouselWrapper":"boFHAFUpDZKEVWhOl2JS","carousel-content":"zi8PdFLmbIBRKfQkxjIp","carouselContent":"zi8PdFLmbIBRKfQkxjIp","carousel-item":"YP71GJJUiSrqNXgYm8h8","carouselItem":"YP71GJJUiSrqNXgYm8h8","carousel-buttons":"C4fFVAza57bxlui3yfZR","carouselButtons":"C4fFVAza57bxlui3yfZR"});

/***/ }),

/***/ 1111:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"B9QNIK_LJ6wLgIlpcuWy","clearInlineWhitespaceWrapper":"B9QNIK_LJ6wLgIlpcuWy","show":"XaofH7rldWWl94yzsrLw","hide":"dhWY2FQnudO8tho4Bqge","child":"_P4soWwSpBS6o8swshf1","children-container":"utKGHNXxc0lqtZWIq69A","childrenContainer":"utKGHNXxc0lqtZWIq69A","tracker-dots":"Ao4TaASC_emKd4cTV_bg","trackerDots":"Ao4TaASC_emKd4cTV_bg","arrow-left":"VvkNwkUWRoH7AhX9iM5a","arrowLeft":"VvkNwkUWRoH7AhX9iM5a","arrow-right":"F8aDBPTZ_JJBPNtgy4Sy","arrowRight":"F8aDBPTZ_JJBPNtgy4Sy","carousel":"lnRcRpPXRqfE09o_Xjrp","placeHolder":"XW3Vjuno5BT3Gx1l0DC2","titles":"X_eq99mmEHF5dN81MfZ1","showNavigation":"nUwtcFrHoDDNajemI7QD","firstVisibleElement":"kl_fUx4p5SQ1zWI8Qgox","lastVisibleElement":"Mw35z1HMpg7G6v52Glm_","renderNavigationOutsideContainer":"w9KdVAbAbJtIAW9jrUyN","fixedTitle":"iTBVtrTHQa3wIsng33Nl"});

/***/ }),

/***/ 39837:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"hQqLIIbsqEs_yHt9Mfdk","clearInlineWhitespaceWrapper":"hQqLIIbsqEs_yHt9Mfdk","page-header":"aqrsnHgZnmzwFL0jSzUg","pageHeader":"aqrsnHgZnmzwFL0jSzUg","panel-header":"Q2FNBHzRf6Bs9Jl8C9Vv","panelHeader":"Q2FNBHzRf6Bs9Jl8C9Vv","bot-info-container":"yWk0otQEnGcbsZ258Cr_","botInfoContainer":"yWk0otQEnGcbsZ258Cr_","bot-info":"PDTMFNPqj2fIdjWSF5Bn","botInfo":"PDTMFNPqj2fIdjWSF5Bn","bot-info-with-logo":"WgJVkxuj2csjSLozJZxw","botInfoWithLogo":"WgJVkxuj2csjSLozJZxw","bot-name":"BtfkfY3SJeOvG8TVncJ4","botName":"BtfkfY3SJeOvG8TVncJ4","bot-subtitle":"XZV9cOWUVCuti0r77I_K","botSubtitle":"XZV9cOWUVCuti0r77I_K","by-text":"KBPhIvpyogGZ9cfEFD6W","byText":"KBPhIvpyogGZ9cfEFD6W","logo":"SVIZGRQ1oUerYukj9tXu","back-button-container":"JUtmGR3amDXO0AjRb_RA","backButtonContainer":"JUtmGR3amDXO0AjRb_RA","hide":"JvbbbAfdWH8HZYfXYmi6","back-button":"DbVA8QzD_zK3wUc960mT","backButton":"DbVA8QzD_zK3wUc960mT"});

/***/ }),

/***/ 1536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"MStijC_93NUhozd33eEF","clearInlineWhitespaceWrapper":"MStijC_93NUhozd33eEF","complex-button":"ZE9dGhNiUp378h8ysYtF","complexButton":"ZE9dGhNiUp378h8ysYtF","fully-disabled":"duNxape5yiwIiOa4k5mE","fullyDisabled":"duNxape5yiwIiOa4k5mE","horizontal-container":"BY91ON7JTckB5if9Pnwf","horizontalContainer":"BY91ON7JTckB5if9Pnwf","left-container":"thHy4Xi1jJGAWOWJP9xQ","leftContainer":"thHy4Xi1jJGAWOWJP9xQ","middle-container":"EXM4WX5ZlvuByBTMNyKz","middleContainer":"EXM4WX5ZlvuByBTMNyKz","right-container":"IDe4NBbEmhOipkNJ2qxK","rightContainer":"IDe4NBbEmhOipkNJ2qxK","spinner-container":"qwdxBdgDY6EbNEMio8LD","spinnerContainer":"qwdxBdgDY6EbNEMio8LD","top-row":"EATuP4BZkEngv_w6qDw3","topRow":"EATuP4BZkEngv_w6qDw3","partially-disabled":"z1Lepw2wZGjqLOtfec4L","partiallyDisabled":"z1Lepw2wZGjqLOtfec4L","body":"gusATyQhNYmU9voq_QdJ","title":"pkrrDcohlimBJncLc9_e","pill":"qNQhCez0fZUB97GEXVzE","spinner-background-arc":"pT5MASuwC85OTgwaTjYv","spinnerBackgroundArc":"pT5MASuwC85OTgwaTjYv","spinner-foreground-arc":"dtT27GvQK7ylDg7kR_Vr","spinnerForegroundArc":"dtT27GvQK7ylDg7kR_Vr"});

/***/ }),

/***/ 23531:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"MmAQsu9Pont6gst8_TtQ","clearInlineWhitespaceWrapper":"MmAQsu9Pont6gst8_TtQ","contact-adviser":"NQIW84nVNk5laFP3vmci","contactAdviser":"NQIW84nVNk5laFP3vmci","message-template-container":"UuwPIbd2OC0aJvwi3rfF","messageTemplateContainer":"UuwPIbd2OC0aJvwi3rfF","mortgage-product-container":"swcOUaFCcvrEoxZ3G1Yx","mortgageProductContainer":"swcOUaFCcvrEoxZ3G1Yx","message-text-area-container":"nSTPgutlE_JKi0T4_bLz","messageTextAreaContainer":"nSTPgutlE_JKi0T4_bLz","message-text-area":"epXUocmln5ozTVL29A5t","messageTextArea":"epXUocmln5ozTVL29A5t","message-text-area-invalid":"E5zkOv_ljqvgOoCYvBXe","messageTextAreaInvalid":"E5zkOv_ljqvgOoCYvBXe","success-message":"mIxL2acdz_18fqiXQqCZ","successMessage":"mIxL2acdz_18fqiXQqCZ","button-container":"hFS0BnjqKwuVxUxerely","buttonContainer":"hFS0BnjqKwuVxUxerely","cta":"XvTREy8lFxgDtqbsFMY_"});

/***/ }),

/***/ 12901:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"NRjzLtleIG6A_F0eQw5q","clearInlineWhitespaceWrapper":"NRjzLtleIG6A_F0eQw5q","contact-card-wrapper":"Yoo0HKLoJm7Z4aZKCCCc","contactCardWrapper":"Yoo0HKLoJm7Z4aZKCCCc","contact-card":"MQHzIKkCLRXz9alpkUF6","contactCard":"MQHzIKkCLRXz9alpkUF6","column":"UvzQAadMnu02lTfLYodt","icon":"rEjaHnug2xcSgoz9jgQf","iconContainer":"G9U1XHFOcSQ9LQQS3o7r","details":"brUtbIwAHNHkLQp0KCcn","children":"AaW5DCvMtN6wa7qwbeN5","cta":"DqjM61Pa9FirLXI0IudH","contact-card-field":"NwU6OczYWzD2ytQeShnD","contactCardField":"NwU6OczYWzD2ytQeShnD","title":"Cr4do2WAg2ZCi2VnHVf4","show-more-button":"G5QkekOX_UKJrq548baQ","showMoreButton":"G5QkekOX_UKJrq548baQ","truncated-content":"PRLb_apvQKHfLU1OwSK_","truncatedContent":"PRLb_apvQKHfLU1OwSK_","fixed":"uTkJSYMIRu9MpOmrc1ke"});

/***/ }),

/***/ 11178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"PRXOIQ72aRqS5rPqx9E4","clearInlineWhitespaceWrapper":"PRXOIQ72aRqS5rPqx9E4","drawer-container":"K6M1if5BDdz9hkLllroQ","drawerContainer":"K6M1if5BDdz9hkLllroQ","right":"tu_WX96XRq4x5QuY39L8","drawer":"_LuVNx_PMq1gELJVBfy2","active":"GKndzzmeuv1O6f_BTBLe","left":"nWDivwsUMw6NP3_mbmp8","drawer-header":"FzV42A43toAIf8nlfs9c","drawerHeader":"FzV42A43toAIf8nlfs9c","drawer-header-text":"VK9Mc61cdBsiS5mdxSzw","drawerHeaderText":"VK9Mc61cdBsiS5mdxSzw","close":"rZXaw_mXQ8WXWus0z2y2"});

/***/ }),

/***/ 20303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"C4CwCCO7_L3QfLjC3d1L","clearInlineWhitespaceWrapper":"C4CwCCO7_L3QfLjC3d1L","button":"jzB3Mofc0edbIXswqycW","underline-animation":"_XOYf2ORKX0pY3Tb3OOQ","underlineAnimation":"_XOYf2ORKX0pY3Tb3OOQ","arrow-right":"mA0eZ2nrcds5j1SSv7F6","arrowRight":"mA0eZ2nrcds5j1SSv7F6","light":"tB9X8lRvoHgddwlzn35u","partner-image":"nVYME8v2kWSuMzEwEa2a","partnerImage":"nVYME8v2kWSuMzEwEa2a","dark":"j0cQTIdiOQUEnhCfp00g","header3":"SEPyzruDnB_xdwDEBYIi"});

/***/ }),

/***/ 23093:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"AuwRCXOof8mUTAtFMYwL","clearInlineWhitespaceWrapper":"AuwRCXOof8mUTAtFMYwL","button":"qCiA5Klkz3RGCt1eM6to","underline-animation":"AbtqGYlEL1rEWIpfabE9","underlineAnimation":"AbtqGYlEL1rEWIpfabE9","arrow-right":"W7Jm7kthNkXO5z4WXlYA","arrowRight":"W7Jm7kthNkXO5z4WXlYA","header3":"dl_Ah1VGEn6SveB2jdGn","light":"MYbh5JVb9XWMSP85QY6e","header-logo-text":"YLllyCLIEGrfKGUcM9D9","headerLogoText":"YLllyCLIEGrfKGUcM9D9","hamburger":"bqMN_KvOk79sZRB1N6gH","hamburger-partner":"xtO48hkoSR_0HAyZSC75","hamburgerPartner":"xtO48hkoSR_0HAyZSC75","home-link-holder":"cync6d_U1sYKwt5rCKR1","homeLinkHolder":"cync6d_U1sYKwt5rCKR1","header-login":"KFhrHkPfbIoDBxZdAbI2","headerLogin":"KFhrHkPfbIoDBxZdAbI2","header-logo":"tv2Cti6TKQRVZamm4xHd","headerLogo":"tv2Cti6TKQRVZamm4xHd","logo-white":"fQuVoLjsHiLKXIVj7URe","logoWhite":"fQuVoLjsHiLKXIVj7URe","logo-green":"WiZ1z7NNCFXYClEGCaWg","logoGreen":"WiZ1z7NNCFXYClEGCaWg","header-logo-partner":"zptmbVwdmxmvafOCBXsb","headerLogoPartner":"zptmbVwdmxmvafOCBXsb","menu-items":"GNcxjvrPHq1tynHSFuMf","menuItems":"GNcxjvrPHq1tynHSFuMf","menu-items-partner":"Q5zxttCBKKtW3VZNP_ex","menuItemsPartner":"Q5zxttCBKKtW3VZNP_ex","header-inner":"qcLqFYYwHkSv3ZjTwgmw","headerInner":"qcLqFYYwHkSv3ZjTwgmw","header-inner-partner":"KQWyWunurUTfNdhr666Q","headerInnerPartner":"KQWyWunurUTfNdhr666Q","header-inner-left":"_51bmQEjwA7oSU9L6Nj6o","headerInnerLeft":"_51bmQEjwA7oSU9L6Nj6o","header-inner-left-partner":"MqBeMbTpDt_UZP2AKGlU","headerInnerLeftPartner":"MqBeMbTpDt_UZP2AKGlU","header-inner-right":"XkR6PL1BIf_smLQg_Mnq","headerInnerRight":"XkR6PL1BIf_smLQg_Mnq","header-inner-right-partner":"bkSlheoqTv15y89cuLze","headerInnerRightPartner":"bkSlheoqTv15y89cuLze","partner-container":"AQYjF0qzuQu3R2shENyy","partnerContainer":"AQYjF0qzuQu3R2shENyy","partner-container-partner":"SSzbVzVqBAl5svC_Q2iy","partnerContainerPartner":"SSzbVzVqBAl5svC_Q2iy","line-break":"MfX0jzEonP7AE2J5MAiE","lineBreak":"MfX0jzEonP7AE2J5MAiE","line-break-partner":"yf5hGk9BVChLmgZuTFqo","lineBreakPartner":"yf5hGk9BVChLmgZuTFqo"});

/***/ }),

/***/ 14493:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"EIMQ5eBRbxjEBjl9wp7w","clearInlineWhitespaceWrapper":"EIMQ5eBRbxjEBjl9wp7w","button":"h1Px2n5moPMt_1MblREu","underline-animation":"fAgJdy2UNdl4QzruwdHB","underlineAnimation":"fAgJdy2UNdl4QzruwdHB","arrow-right":"FW5Dedu3xWtpyw5bveql","arrowRight":"FW5Dedu3xWtpyw5bveql","close-button":"VTdb6XRiohGwh8jPYHvB","closeButton":"VTdb6XRiohGwh8jPYHvB","menu-item-submenu-link":"xMm6BvA7r5dBP_VWFQWT","menuItemSubmenuLink":"xMm6BvA7r5dBP_VWFQWT","hamburger":"NmwNeVKEf_Kzs7ZspR00","logo-container":"yHyAebDgTM0zTYUgvS1w","logoContainer":"yHyAebDgTM0zTYUgvS1w","sidenav":"YPXrUXmv5KaIXbgrt6t7","collapsed":"UvodZSrg0z5w8elT3oUM","sidenav-open":"MRhZP0kTW9aldztVm_0K","sidenavOpen":"MRhZP0kTW9aldztVm_0K","menu-items-container":"uPAHwgUgTGuLg16OJJgx","menuItemsContainer":"uPAHwgUgTGuLg16OJJgx","social-buttons":"XjvPaaVXqHhi7AGsmcx8","socialButtons":"XjvPaaVXqHhi7AGsmcx8"});

/***/ }),

/***/ 42873:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"R9pm0aDqnvUotVgVTeQ0","clearInlineWhitespaceWrapper":"R9pm0aDqnvUotVgVTeQ0","button":"thyse2sI9mKGw5bE4wJZ","underline-animation":"DSP_osIhilUKwENHINAw","underlineAnimation":"DSP_osIhilUKwENHINAw","arrow-right":"IzRFsy9SGScQBLpSQd8i","arrowRight":"IzRFsy9SGScQBLpSQd8i","menu-item":"kWKgXd2OzI0LhfUH7fXd","menuItem":"kWKgXd2OzI0LhfUH7fXd","menu-item-button":"kJYhh5Kme2j0C6a1dZbC","menuItemButton":"kJYhh5Kme2j0C6a1dZbC","menu-button-text":"IjY7yNDwNnzUPtdgGoyQ","menuButtonText":"IjY7yNDwNnzUPtdgGoyQ","menu-button-arrow":"MuuwVs7sTBbnog_sS7zA","menuButtonArrow":"MuuwVs7sTBbnog_sS7zA","collapsed":"RTP38Z_n4k9CnJVMEu1u","menu-item-link":"SgrHVEhsyisqOQiFKRug","menuItemLink":"SgrHVEhsyisqOQiFKRug","menu-item-link-light":"MlGF3CwyAcIKzQiSwODa","menuItemLinkLight":"MlGF3CwyAcIKzQiSwODa","menu-item-submenu":"PKSeKqy0VIJCNTrK8eXh","menuItemSubmenu":"PKSeKqy0VIJCNTrK8eXh","menu-item-submenu-link":"jLsBTgup5HtQWO67a7VZ","menuItemSubmenuLink":"jLsBTgup5HtQWO67a7VZ","partner":"EDIekJNo0hvizNdR3p9S","menu-item-submenu-link-wrapper":"x6WxRQvKuxU3WYPYMHIz","menuItemSubmenuLinkWrapper":"x6WxRQvKuxU3WYPYMHIz","has-visibility-hidden":"bZaoSzZ4uLqGy1FvzgmW","hasVisibilityHidden":"bZaoSzZ4uLqGy1FvzgmW","options-list":"MoVhZ2PW9_iObnm7gOz9","optionsList":"MoVhZ2PW9_iObnm7gOz9","options-list-link":"pCSjMCzIt7idj_EbOiMx","optionsListLink":"pCSjMCzIt7idj_EbOiMx","options-list-visible":"Sn3QKoURogXff9hC5DPp","optionsListVisible":"Sn3QKoURogXff9hC5DPp","with-children":"RGiwGfbCVhaQN0t7XMD1","withChildren":"RGiwGfbCVhaQN0t7XMD1","children-wrapper":"JT3doGnh8rhcZe4JVAMO","childrenWrapper":"JT3doGnh8rhcZe4JVAMO","logoContainer":"XxIq6H2bFpf8RoMJ_Ppq"});

/***/ }),

/***/ 83962:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"lOy9nrkzWseMZ9PEDi4G","clearInlineWhitespaceWrapper":"lOy9nrkzWseMZ9PEDi4G","button":"uUyENRR0DKZ7YaGWlQn7","underline-animation":"MAKWJ7VRMEXZ6xt4FJSw","underlineAnimation":"MAKWJ7VRMEXZ6xt4FJSw","arrow-right":"IWYowJnn9OW4ukji6_jw","arrowRight":"IWYowJnn9OW4ukji6_jw","header4":"jSntWqv9gNkEpAP6hsDw","header-logo":"xjJSXES2nLceedG1BbXe","headerLogo":"xjJSXES2nLceedG1BbXe","menu-items":"FYqLh7f7B2PMwQ9PSC_Q","menuItems":"FYqLh7f7B2PMwQ9PSC_Q","profile-button":"y4PIHKUrb71wPRvw7jGu","profileButton":"y4PIHKUrb71wPRvw7jGu","hamburger-menu":"fs2s6bjLLPcN2K1XoFZq","hamburgerMenu":"fs2s6bjLLPcN2K1XoFZq","loading-button":"F0awoQRxAwDWzm4zrcS0","loadingButton":"F0awoQRxAwDWzm4zrcS0","loading-button-spinner":"jd78giSl2xG6A98W_JMD","loadingButtonSpinner":"jd78giSl2xG6A98W_JMD","profile-button-text":"JB_ijYZh5pFROXu2zqm2","profileButtonText":"JB_ijYZh5pFROXu2zqm2"});

/***/ }),

/***/ 81138:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"t8uRhtcsu9iVsGhB0tEO","clearInlineWhitespaceWrapper":"t8uRhtcsu9iVsGhB0tEO","header-container":"grBOAGGTuBejYV0Cd8WA","headerContainer":"grBOAGGTuBejYV0Cd8WA","header-container-v3":"cdC6fYzmmHaXChhozBbE","headerContainerV3":"cdC6fYzmmHaXChhozBbE","header-inner-container":"XZcUcLNEO8zaHlYD1xtr","headerInnerContainer":"XZcUcLNEO8zaHlYD1xtr","profile-menu":"ONGY8zf4s03XBVnEZiIL","profileMenu":"ONGY8zf4s03XBVnEZiIL","logo-better":"F8eFHAom3LVQ9cJ7jXTT","logoBetter":"F8eFHAom3LVQ9cJ7jXTT","icon-user":"a06IzXTZ0smTEktfD5OV","iconUser":"a06IzXTZ0smTEktfD5OV","name-style":"MdOe7StrNPfdHTg8MyZa","nameStyle":"MdOe7StrNPfdHTg8MyZa","chevron":"a0qZXG1jbv8T5GvWPuKH","menu-button":"kVivcVgphhk4qsFJZ9hm","menuButton":"kVivcVgphhk4qsFJZ9hm","loading":"i_AcTmcyOqiFYvizyCfm"});

/***/ }),

/***/ 93077:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"SGiEEgxMpaac10TxJbxN","clearInlineWhitespaceWrapper":"SGiEEgxMpaac10TxJbxN","button":"EGd1uGAG8Q4_WyKTGIPm","underline-animation":"JyV4h2NiRqUJKFXqGGaA","underlineAnimation":"JyV4h2NiRqUJKFXqGGaA","arrow-right":"eF5gJFC04J4TvoNWwMcD","arrowRight":"eF5gJFC04J4TvoNWwMcD","menu-item":"W0C57ghIBbKBEjMInfG8","menuItem":"W0C57ghIBbKBEjMInfG8","menu-item-button":"ooanFuGHkYJPoe6HuBHu","menuItemButton":"ooanFuGHkYJPoe6HuBHu","menu-item-button-light":"R8Nca4v2Mjc7FXehQ0kG","menuItemButtonLight":"R8Nca4v2Mjc7FXehQ0kG","menu-button-text":"mPYGTI3H0VNG0c_AGqRh","menuButtonText":"mPYGTI3H0VNG0c_AGqRh","menu-button-arrow":"zHADxPE0LX71dtHCKlCM","menuButtonArrow":"zHADxPE0LX71dtHCKlCM","collapsed":"dtdjbnQ4F1TzFopICAK5","expanded":"PZtethJZFVVJY5BLqS67","expanded-light":"AKei2FvmiYlvxbrSA_kB","expandedLight":"AKei2FvmiYlvxbrSA_kB","menu-item-link":"P82PimVyN9o26_5Y4J6n","menuItemLink":"P82PimVyN9o26_5Y4J6n","menu-item-link-light":"xk61t6BguH6vBGsj7lUy","menuItemLinkLight":"xk61t6BguH6vBGsj7lUy","menu-item-submenu":"AIcuhGD1YxrjRVZwTadJ","menuItemSubmenu":"AIcuhGD1YxrjRVZwTadJ","menu-item-submenu-link":"aGncGJ81C0o329VcBPPT","menuItemSubmenuLink":"aGncGJ81C0o329VcBPPT","partner":"mD9IUb4kylbXdq3qA_n8","menu-item-submenu-link-wrapper":"hJ2lM0VGpbYuPZY5QFmE","menuItemSubmenuLinkWrapper":"hJ2lM0VGpbYuPZY5QFmE","has-visibility-hidden":"rxpo2hNQfd49RWUfy7J3","hasVisibilityHidden":"rxpo2hNQfd49RWUfy7J3","options-list":"R_8Gcfvn9BvAB0Gsreut","optionsList":"R_8Gcfvn9BvAB0Gsreut","options-list-link":"MqJ2M6UJ0SOLZyg_s1cV","optionsListLink":"MqJ2M6UJ0SOLZyg_s1cV","options-list-hidden":"slxvhH84yxNuBsaABQCh","optionsListHidden":"slxvhH84yxNuBsaABQCh","options-list-visible":"hjSE0AsOxBkKdAgmZFdA","optionsListVisible":"hjSE0AsOxBkKdAgmZFdA","with-children":"hUpv1SU79KLehcGbKUaX","withChildren":"hUpv1SU79KLehcGbKUaX","children-wrapper":"OfsWASCGEXtYh1gc8Zy2","childrenWrapper":"OfsWASCGEXtYh1gc8Zy2","sidenav":"YRsEDeHpStMaGpz3Gwi8","close-button":"XP2IWE6NlGVzQ1oopHpw","closeButton":"XP2IWE6NlGVzQ1oopHpw","hamburger":"h4nCS9rx8vZs1O7creNz","logo-container":"QFzpJKB3kRcWgdGfYxhg","logoContainer":"A6i5qojNQmpRJeBA3Cnc","get-started-button":"MZ4R9b788_4TKGL16zDV","getStartedButton":"MZ4R9b788_4TKGL16zDV","nav-bar-v3":"FoSXvKPkfRVMOgvU5puy","navBarV3":"FoSXvKPkfRVMOgvU5puy","sidenav-open":"aRL7kbeS5oi7kdNzFbkT","sidenavOpen":"aRL7kbeS5oi7kdNzFbkT","close-icon":"hurIEs4GmmyOR4uaxsdT","closeIcon":"hurIEs4GmmyOR4uaxsdT","menu-items-container":"JkMt_c1_Jc9vN2rZi9_V","menuItemsContainer":"JkMt_c1_Jc9vN2rZi9_V","light":"_sSbNKVTpbTx93tVAj_6","dark":"p3DeECMLJMm6l0Ymt4cC"});

/***/ }),

/***/ 41644:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"eJolCGx5Apyny_xxJXeu","clearInlineWhitespaceWrapper":"eJolCGx5Apyny_xxJXeu","outer-container":"fnjpIyo3kpAWPmCZytrO","outerContainer":"fnjpIyo3kpAWPmCZytrO","image-wrapper":"b2ZRDj8qXSEj4z4G8Li1","imageWrapper":"b2ZRDj8qXSEj4z4G8Li1","title":"lfWBWHAVLHkHeVL33d5F","message":"WUZD03Nsdqfvr0zxgRPO","cta":"KvqLCnnU3DBjTHjPB9IT","top":"T7cU8z23EI5HWKebQ1SO"});

/***/ }),

/***/ 281:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"iwo4trKHMcYhKMsz7uD9","clearInlineWhitespaceWrapper":"iwo4trKHMcYhKMsz7uD9","hook":"eBP4dFaI5XPaOxcLmVNb","title":"IIVU0sdWBCw1ARkOuBE6","ball":"ugXjDWNellD29OqbNJlA","tooltip":"ejICBVG8NkbsxAKHNbuz","tooltip-body-text":"g8Pe6GaZRtZEL_NUcUBv","tooltipBodyText":"g8Pe6GaZRtZEL_NUcUBv","description":"d2q8Hzva9JfrugPUL2pm","description-item":"Fm15WQBJ1IAXbJzhLREu","descriptionItem":"Fm15WQBJ1IAXbJzhLREu","score":"DmNn9os7kOtgTDpvELy6","button":"kJ7OPj5JvZd6Ai5tkVDI","disclaimer":"DQDommSGnYsXJQrZfiJ_","block":"B_vQ8gP34T1w_Nc_pykC","block-1":"uYd1zCiNQe0oKnEKEnVW","block1":"uYd1zCiNQe0oKnEKEnVW","block-2":"uMlYkOZ66OvJp_JUsSXl","block2":"uMlYkOZ66OvJp_JUsSXl","block-3":"ejptWn9vpRA7pZmFEcxo","block3":"ejptWn9vpRA7pZmFEcxo","block-4":"z4LTtemAJVD3l8Uy1UYz","block4":"z4LTtemAJVD3l8Uy1UYz","block-5":"QglQyliAPnZ4B6n7uvEy","block5":"QglQyliAPnZ4B6n7uvEy","block-6":"uyas04cg7uu4nBUg90OS","block6":"uyas04cg7uu4nBUg90OS","block-7":"PpoOiGeIXcgmOZ3IyjuP","block7":"PpoOiGeIXcgmOZ3IyjuP","block-8":"MYclIgB7nHo4i2ONxWCt","block8":"MYclIgB7nHo4i2ONxWCt","block-9":"o82RMcnE14eEHiGJVCD5","block9":"o82RMcnE14eEHiGJVCD5","block-10":"yWbusE6o6TN20psnRfr8","block10":"yWbusE6o6TN20psnRfr8"});

/***/ }),

/***/ 33185:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ieXqKifoUHk1k9XkglWm","clearInlineWhitespaceWrapper":"ieXqKifoUHk1k9XkglWm","grey":"M75CPKV_aDzvIqU6VidE","colouredInfo":"gIy_KxN32g5rvG30mccg","red":"EMOmxUzhr7B5aMHruNfA","green":"LTL1ZE0ZrL4hRViZqugq","wrapper":"EtrOnhat_0FCOt0lLUTn","content":"y1XinugJL_SxBj_QlwIW","title":"eUZ2BFAjPhx77eFN8HRZ","top":"YN5aRVUialtnLkvZju9L","info":"sLQ0RM2ikLEmc0ye48Ae","image":"Ugrc3m9cql5KxHfyFCjZ"});

/***/ }),

/***/ 47352:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"nYLTgd_TpspN24jiLuAF","clearInlineWhitespaceWrapper":"nYLTgd_TpspN24jiLuAF","low-contact-product-card-wrapper":"XvXNyMYOfWe9pAsLD0ee","lowContactProductCardWrapper":"XvXNyMYOfWe9pAsLD0ee","initial-data":"pVpFivJRGXJVs7pkepow","initialData":"pVpFivJRGXJVs7pkepow","exclusive":"Y_4C7I7ypHumXbIVYZbZ","dot":"JmTWVQa1LQYzbyVbl1dm","lender-logo-wrapper":"OddNe3ERNgKA6wZh49lA","lenderLogoWrapper":"OddNe3ERNgKA6wZh49lA","product-terms":"T0GWh8kP54u_4TGSurTy","productTerms":"T0GWh8kP54u_4TGSurTy","product-terms-with-description":"GSb8Y5IuJpcHxshxzUGK","productTermsWithDescription":"GSb8Y5IuJpcHxshxzUGK","product-terms-item":"VlRGR65DkYiMyxdbFzU7","productTermsItem":"VlRGR65DkYiMyxdbFzU7","product-terms-item-title":"gVVHZqg6qoWa1XyJL2Py","productTermsItemTitle":"gVVHZqg6qoWa1XyJL2Py","product-terms-item-value":"dDbN8DiTT9exY8KVLzCy","productTermsItemValue":"dDbN8DiTT9exY8KVLzCy","actions":"IL4ppKlFgE3IyHn6SbM9","view-more-button":"NUx2XI8y9FD_0SYw3gqT","viewMoreButton":"NUx2XI8y9FD_0SYw3gqT","description":"FWWZcBjQHFcVP2Nts8bq","show-description":"wM86ETFClH0WBQIOfJ58","showDescription":"wM86ETFClH0WBQIOfJ58","tooltip-wrapper":"_iQU8K_vQKAki8ufoS8w","tooltipWrapper":"_iQU8K_vQKAki8ufoS8w","tooltipText":"RrwujjyRRI9F6RkoWquX","tooltipIcon":"JRtsmJIoX7OG3DUW_to1","initialTermCostTooltip":"Tg_FLvxGRvv39Pk9tE8w","initialDataText":"haoWDJnW2ye05F270VVO","product-name":"fKEeDYHvHDkw4GNlx08u","productName":"fKEeDYHvHDkw4GNlx08u","lowContactProductCardWrapperV2":"P9WvEYebSdHLpo5wv4y7","spinnerTransparent":"Fihi1Y9HD1u_fmfsDuM0","spinnerGrey":"DxTCFTruMmhfJicUNeON"});

/***/ }),

/***/ 53942:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"XXkaMyREwmmrcDFASjbG","clearInlineWhitespaceWrapper":"XXkaMyREwmmrcDFASjbG","mip-explained":"gJbcL3UrrNE9zJsGkTWs","mipExplained":"gJbcL3UrrNE9zJsGkTWs","card":"Ml4dC88_4m29XciEK00F","title":"JOuF_qS_Q3chglw8mtPy","top":"KUfYcS4g0a3zD90SzUNy","subtitle":"boURi56OiwfBJyNTzeWD","description":"bKUe9QMsUau2c0iUZlpg","top-card":"I7A6jugLxcK8Q8m9Rte9","topCard":"I7A6jugLxcK8Q8m9Rte9","link":"iaefTiOI4vgxXDImTU_t","bottom":"KpAQZY0CgI2gUU2VR0O4","logo":"QUjFFlEK2mf_Yo24pzoQ","logos":"KUE2MlLEbM7tQ9nUluri"});

/***/ }),

/***/ 81160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"AwgF2lxZHYGjAtvNTfMq","clearInlineWhitespaceWrapper":"AwgF2lxZHYGjAtvNTfMq","container":"bfsNGoRsvBZTxRB7UWoe","trustpilotContainer":"LHd5rceKTOwPb2dfVBdV"});

/***/ }),

/***/ 1961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"nu14AjmUm9CG6vwavj7v","clearInlineWhitespaceWrapper":"nu14AjmUm9CG6vwavj7v","modal-overlay":"xt0j2LvwFIm29jz7kCaK","modalOverlay":"xt0j2LvwFIm29jz7kCaK","modal-content":"ZVgy4yhIDW8l6HYnMDH4","modalContent":"ZVgy4yhIDW8l6HYnMDH4","modal-close":"yLLQByrnQGjeAQ1hF9Qs","modalClose":"yLLQByrnQGjeAQ1hF9Qs"});

/***/ }),

/***/ 77186:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"content":"JeqNGyJ7Q2Ux08GX6BRD"});

/***/ }),

/***/ 50544:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"EJjEfNXndWAmf9QMro_k","clearInlineWhitespaceWrapper":"EJjEfNXndWAmf9QMro_k","timelineContainer":"hkY3anwPiSro9LjLMfxI","timeline":"lTMDyGALyxwdQYphRLRX","step-outer-container":"PQmEYJO8XyQcQRoA7jT5","stepOuterContainer":"PQmEYJO8XyQcQRoA7jT5","step-inner-container":"JDv21sp6BADkGXjMUpjI","stepInnerContainer":"JDv21sp6BADkGXjMUpjI","step-icon":"L4JxpULTuqXiDH31cMA4","stepIcon":"L4JxpULTuqXiDH31cMA4","step-description":"_qAjA19jbQJBu2hkvtm4","stepDescription":"_qAjA19jbQJBu2hkvtm4","circle":"uahsWlDAgCODqS6zC_Ce","line":"As7KIBaNSlnrMCJY0d4s","label":"c00gMeHmE30k810ReQ3Z"});

/***/ }),

/***/ 35942:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"Q1jfg9dyK4pqR2vzWGiw","clearInlineWhitespaceWrapper":"Q1jfg9dyK4pqR2vzWGiw","timeline":"spcOjbwhxFa0Lkx1GSGh","stepContainer":"a13LUThkQ6jlLnzuuCD9","stepNumberContainer":"Wq0hsMq5Hx5faXRbI3Dk","stepIconNumber":"d0VAPxhOqr3XYRn_Gy8S"});

/***/ }),

/***/ 45945:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"UJSyWARRkVp1uReRtPnm","clearInlineWhitespaceWrapper":"UJSyWARRkVp1uReRtPnm","card":"b8xBm3mTsfBu5t9k7a2b","background":"lhYgRWenrJRiVOXm3Hit","content":"I6ge7Tx8G2yGstonlH4H","title":"qn9PcZ5uhGZrHOs9dXrV","subtitle":"KNlGfikOlYCAAYLgkiUD","linkText":"wm2tCuH250Ry8NkLWJhw","customerExclusiveBanner":"y1hf5ZfmIBPzDXc19drW","monzoLogo":"MejOnZrsPr7IhSzFEqOu","customerExclusiveText":"rjCnQCjSkEiZwgECw_tj"});

/***/ }),

/***/ 8038:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ifVivEwARmfIGt9E1aDH","clearInlineWhitespaceWrapper":"ifVivEwARmfIGt9E1aDH","header":"x2VoZn1MyX7FCXdA6keA","title":"wdAo4gbU5rBYyrtxEWUQ","subtitle":"r78Hp0SjMZHbbvwC1jFk","images":"oiiXF07bo0lWvQjUPcqR","line":"ej2JAKhGsRr75aX7AZDq","preCtaContent":"do2uqC6k5_bQnNze6XWB","start-button":"FlKDUrv6wljUPD0nS7Yk","startButton":"FlKDUrv6wljUPD0nS7Yk","service-offering":"drNdJIwSkQpzvvljORkj","serviceOffering":"drNdJIwSkQpzvvljORkj","figure":"g15GOD4TedOYKzmBrpvr","offeringLogos":"CnM2mkRrTnAaCH_bptUt","figureDescription":"k9DFBo7hn6t4MHQ03Ciu","list":"fbzEqUyLn_Oy5QM0h1Kf","informationTitle":"YTMaF55z4hCQuiVfW1NO","informationDescription":"mE7LioEGR3_CsHBMdZu2","informationBlock":"K2yjfMIuhkzB9T92m9Mq","buttonsContainer":"GA5787pZUuhFcOQ6qDcp","buttonsDivider":"jlY_wEohyfMikBP2AioT"});

/***/ }),

/***/ 64545:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"LQrZicE6IOU7Qdr9ytJb","clearInlineWhitespaceWrapper":"LQrZicE6IOU7Qdr9ytJb","flex-container":"zmOOxXg5DNcWpGvLisQZ","flexContainer":"zmOOxXg5DNcWpGvLisQZ","flex-item":"miR4sMBMoiwyhNuFDESh","flexItem":"miR4sMBMoiwyhNuFDESh","text-align-left":"xtdPAsuLoI28QRHK0oqA","textAlignLeft":"xtdPAsuLoI28QRHK0oqA","text-align-right":"zK4tekVVPhspzpxwHTLk","textAlignRight":"zK4tekVVPhspzpxwHTLk","text-align-center":"KrPcZhmnJNM03mmSKu9Y","textAlignCenter":"KrPcZhmnJNM03mmSKu9Y","card-wrapper":"T_ztNbJfXxEAYPCccaC4","cardWrapper":"T_ztNbJfXxEAYPCccaC4","card-wrapper-primary":"cyY608y9TPyEvYXkNMOx","cardWrapperPrimary":"cyY608y9TPyEvYXkNMOx","card-wrapper-secondary":"Ll5xDcmSuFkTmMJbUiOh","cardWrapperSecondary":"Ll5xDcmSuFkTmMJbUiOh","card-preamble":"Z4BdZ1wNJ_fznfkv5qXg","cardPreamble":"Z4BdZ1wNJ_fznfkv5qXg","card-preamble-text":"cj5D7_KBtiMobUsEH7EN","cardPreambleText":"cj5D7_KBtiMobUsEH7EN","card":"TMvPuDkOyWdXKMsbcioP","logo-container":"xGHt4s5Ab9MzkXfbT4C9","logoContainer":"xGHt4s5Ab9MzkXfbT4C9","logo-image-container":"dLleztOy3kmhIQRPYkAW","logoImageContainer":"dLleztOy3kmhIQRPYkAW","product-initial-duration":"DnVds2loIK1rq5M0Ek8l","productInitialDuration":"DnVds2loIK1rq5M0Ek8l","main-info-container":"HvBU8kzlH_2rOmWTQDtG","mainInfoContainer":"HvBU8kzlH_2rOmWTQDtG","main-info-line":"k_qSnjyGgOsh9JLai7rR","mainInfoLine":"k_qSnjyGgOsh9JLai7rR","text-pair-label":"S78xJdzN9JMQT_vEFHde","textPairLabel":"S78xJdzN9JMQT_vEFHde","text-pair-value":"cfmOuTW9_1SviTn_j0uQ","textPairValue":"cfmOuTW9_1SviTn_j0uQ","text-pair-value-prefix":"cVp4uwMwmby6PTNQW1B4","textPairValuePrefix":"cVp4uwMwmby6PTNQW1B4","calculations-container":"MscwX3BUWVhxzZ642G1v","calculationsContainer":"MscwX3BUWVhxzZ642G1v","calculations-line":"DDb6J77i9iI8ap65d1Fc","calculationsLine":"DDb6J77i9iI8ap65d1Fc","glossary-container":"MdUzBDd1xBwzrx4Lxqxi","glossaryContainer":"MdUzBDd1xBwzrx4Lxqxi","terms-explained-button":"X2bwfuOZyXoUvqk6s8jR","termsExplainedButton":"X2bwfuOZyXoUvqk6s8jR","separator":"jHfyRUS1Ommsc6aAPhou","actions-container":"iEPCzcrDpDaKpLX9w3jJ","actionsContainer":"iEPCzcrDpDaKpLX9w3jJ","details-container":"TUql4XW0hn5DYhkncEj0","detailsContainer":"TUql4XW0hn5DYhkncEj0","details-title":"s8NoBEMwzfbNcbDI6jiE","detailsTitle":"s8NoBEMwzfbNcbDI6jiE","details-list":"SarnA87VSfLGbX6oyo5o","detailsList":"SarnA87VSfLGbX6oyo5o","details-pair-label":"Gptw5md7qD10wIvhVLom","detailsPairLabel":"Gptw5md7qD10wIvhVLom","details-pair-value":"csl2_mXIm7_zPEh3WoLp","detailsPairValue":"csl2_mXIm7_zPEh3WoLp","details-pair-value-bold":"hsjiC8gaN3ky3UXC7139","detailsPairValueBold":"hsjiC8gaN3ky3UXC7139","footer-container":"rGHiugClFV4q7OtV45pV","footerContainer":"rGHiugClFV4q7OtV45pV","cardPlaceholder":"qFFvcitO_J0Q6LfBwU4u","mortgage-product-card":"qpudyQzDUF2vRGZ51sL_","mortgageProductCard":"qpudyQzDUF2vRGZ51sL_","mortgage-product-card-primary":"t5gr_DRrhWsBOQhqFryY","mortgageProductCardPrimary":"t5gr_DRrhWsBOQhqFryY","mortgage-product-card-secondary":"ko3EugMOSSM1jnTNgOWs","mortgageProductCardSecondary":"ko3EugMOSSM1jnTNgOWs","mortgage-product-card-informative":"uJV4f6Srz5o_vCecr0XH","mortgageProductCardInformative":"uJV4f6Srz5o_vCecr0XH","mortgage-product-card-disabled":"z7U7p88ikjnVEp_Mm9Qb","mortgageProductCardDisabled":"z7U7p88ikjnVEp_Mm9Qb","mortgage-product-card-accepted":"f3xhvI4biz4Td4N94f9g","mortgageProductCardAccepted":"f3xhvI4biz4Td4N94f9g","card-header":"WYMvMWbPIkfASfQKbbHG","cardHeader":"WYMvMWbPIkfASfQKbbHG","radio-input":"gJt7_aNlcLmhzGr5z3tw","radioInput":"gJt7_aNlcLmhzGr5z3tw","radio":"DvdhrzVXOkP5P1Hg5N8m","radio-checked":"Uo1qujfKmtTz_joaXxGZ","radioChecked":"Uo1qujfKmtTz_joaXxGZ","radio-disabled":"gIeds0G9DL3kU_gOYzwQ","radioDisabled":"gIeds0G9DL3kU_gOYzwQ","logo":"TrE9akN2a0z7hfkXXNUY","quote-card":"IeXl9lgz_HGgbYcvkWuR","quoteCard":"IeXl9lgz_HGgbYcvkWuR","quote-card-title":"PmUSPAu5Ui02z_K1F_m7","quoteCardTitle":"PmUSPAu5Ui02z_K1F_m7","quote-card-text":"ORqcA2__nRMb1XRYVqwL","quoteCardText":"ORqcA2__nRMb1XRYVqwL","card-items":"ZRhE9u7XcYV1f_9OsQah","cardItems":"ZRhE9u7XcYV1f_9OsQah","card-item":"ZC2wR9gyyEwliTxh7cnl","cardItem":"ZC2wR9gyyEwliTxh7cnl","no-pointer-events":"YHMy05Th6TsJ4PfGpZkK","noPointerEvents":"YHMy05Th6TsJ4PfGpZkK","card-button":"LqWD7IE7tjk40HZD6zzj","cardButton":"LqWD7IE7tjk40HZD6zzj","contactAdviser":"JLrlXI5N7ZVtCWldN_BN"});

/***/ }),

/***/ 79270:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"QQqpJ9IBdezPMNF2eSj3","clearInlineWhitespaceWrapper":"QQqpJ9IBdezPMNF2eSj3","details":"n_EVfiRJtoDNcahzZNsh","quote-card":"IKTIwIYPHDT4QJHInHkM","quoteCard":"IKTIwIYPHDT4QJHInHkM","subtitle":"tQQqm_glfhK7Z9B3we2g","leftColumn":"aQkmAQeDGy6Idu8Iw4QD","rightColumn":"U6WfMeLZoGvzgdr_M1aS","label":"zKewGm1qyRTGAGKKXLvg","value":"AgQSOUKkErJu7HeIhvL6","modal-item":"eNm8MA4oZIz0Q0A_nOqR","modalItem":"eNm8MA4oZIz0Q0A_nOqR","tooltip":"fHZyYwgIRqFjbTWOfM2D","tooltip-btn":"AEmnz0rmuJQIfyJvSypZ","tooltipBtn":"AEmnz0rmuJQIfyJvSypZ","tooltip-text":"o8GZY0ccKXej8UpiPxjo","tooltipText":"o8GZY0ccKXej8UpiPxjo","tooltip-active":"X5u1likh9B6m2ItJiWDS","tooltipActive":"X5u1likh9B6m2ItJiWDS","incentives":"JMQT_Ghd882ewoiBXhpL","incentives-items":"axtALs6HagOv7QgWJfQL","incentivesItems":"axtALs6HagOv7QgWJfQL","incentive":"Y3MPTcvbzJmUDqvEauu4","fees":"S1OIqk3YCD_PM0tDPvGz","additional":"K1ySgnZqHavHNBBNkONW","representative-example-wrapper":"mdCITP9WBRrMI0lOtSuw","representativeExampleWrapper":"mdCITP9WBRrMI0lOtSuw","representative-example":"lxPxshkq5XwOxJ1un_gr","representativeExample":"lxPxshkq5XwOxJ1un_gr","container-under-review":"I8hhSCwcIJx58KiIghUh","containerUnderReview":"I8hhSCwcIJx58KiIghUh","container-low-contact":"QD2U9wYsrQ0dWQX1onnG","containerLowContact":"QD2U9wYsrQ0dWQX1onnG","product-description":"A_eLRtab35_DudF0Epnp","productDescription":"A_eLRtab35_DudF0Epnp"});

/***/ }),

/***/ 99435:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"ZXIXRJWzKecdtF9ksbWO","clearInlineWhitespaceWrapper":"ZXIXRJWzKecdtF9ksbWO","modal":"pifQ1oWetV9du3_8khmw","page":"xEf3eIYxhGZqn0nf9nYL","headerAndBody":"roLK4AMiprEdyuP1rUXF","headerAndBodyLowContact":"xssydh4KjwBUrrX8l9ag","body":"dYi5drNIaiS1S1E93ddI","bodyLowContact":"kG7qqOwH9sErSyAJnHvC","footer":"TcCn9UebjVSc0OkhYc0G","buttonsContainer":"yRc6gIssPweEdfVYwFDO"});

/***/ }),

/***/ 9541:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"N0dmEXDzhQtl2UjfYYVs","clearInlineWhitespaceWrapper":"N0dmEXDzhQtl2UjfYYVs","container":"mwPKdUBgsnqwidwXI5HW","logo":"NidhzToh9IT9GI04FbWG","logo--align-left":"I42k4zme4VfkpmxIIu9I","logoAlignLeft":"I42k4zme4VfkpmxIIu9I","logo--align-center":"hCLThSGyxszrCK2eKO6r","logoAlignCenter":"hCLThSGyxszrCK2eKO6r","logo--align-right":"Wnz9SxNkBV2Eyq6bp3ou","logoAlignRight":"Wnz9SxNkBV2Eyq6bp3ou","progress":"xIutt_QH_wTkSYVwWbnN","labels":"c35OQ2wTfYwraKxDSWjp","label":"YB8Y3jTll00P5Mk1wxty","label--active":"KQ2HkQa3Q5uikNLKJVcc","labelActive":"KQ2HkQa3Q5uikNLKJVcc","label--show":"RIvq8ypM57tcJE7Xcg2M","labelShow":"RIvq8ypM57tcJE7Xcg2M"});

/***/ }),

/***/ 91273:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"yDCC7U8Zkeb1zJ3Tjfs2","clearInlineWhitespaceWrapper":"yDCC7U8Zkeb1zJ3Tjfs2","footer":"fDjged23PA2kzxTl5Gg0","privacyPolicy":"usCkHe8Gxu70C0sLXRFJ"});

/***/ }),

/***/ 6574:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"oQgFYgf5f9mOCkluDGcN","clearInlineWhitespaceWrapper":"oQgFYgf5f9mOCkluDGcN","linksCtr":"X5Da9uX17lbvqhqsfJjg","linksRowWrapper":"PhOxMJlgRFHb3mvjwEKw","linkRow":"Cz8b5U1K3Kn5H0cN5nAt","columnHeader":"mogWf8kme7CiNsB3Cv3p","textLink":"mWfjxGbSQRJ8cXxqGX7C","linksContainer":"nZ8TigH9SmvTlAWUaAvW","linksColumn":"ApVSZ9p2XgYogqqTR48K","logo":"XNujJOfKh8JZibqJqyIa","legalText":"stajuKEl6EBDyOwZYRW_","footerText":"FAYqDhssBjL6ObsyW06k","legalTextSmallFooter":"q3y2Jkt8cOlX3qbzrwot","terms":"ZllopJJHWNUqvm1giJIT","dark":"PkZbZsrOwETJ5jaYzoUz","firstFooterContainer":"RS6PlaaGr9vbcxyqlBpN","secondFooterContainer":"IHmkX49om9y2dmuk3wMM","firstFooterTextSecondColumn":"ZveHKD2XeNfIr8Y69lm2"});

/***/ }),

/***/ 15165:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"qGIYbXlbnsF2vMjj6yIx","clearInlineWhitespaceWrapper":"qGIYbXlbnsF2vMjj6yIx","wrapper":"BQiUhnN8VxWpveMt_JWK","textWrapper":"XEdcgwArJdma1GPuhDSy","textWrapper-mobile":"DHIaMg8ohN86n4cBAFbK","textWrapperMobile":"DHIaMg8ohN86n4cBAFbK","amountWrapper":"vx8LEJJH3UaiSaZIp1jE","amountWrapper-mobile":"PA7zxmYZWhxGbUh8gQqn","amountWrapperMobile":"PA7zxmYZWhxGbUh8gQqn","tagLineWrapper-mobile":"iDd6TaLiq0lRHLHel2nu","tagLineWrapperMobile":"iDd6TaLiq0lRHLHel2nu","moneyUmbrella":"eji52q7u_CJjAkLB_aB2","moneyUmbrella-mobile":"BLiCgDlI_GqrBnwI3wps","moneyUmbrellaMobile":"BLiCgDlI_GqrBnwI3wps"});

/***/ }),

/***/ 34244:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"g6vS749pB60IzcE3rWZP","clearInlineWhitespaceWrapper":"g6vS749pB60IzcE3rWZP","timeline":"BPhPu5JVDL949fbVe3kL","section":"Jk_BZU5p5rG64TixkBSg","section__first":"yO0ETs4k78LBIRZGSqxO","sectionFirst":"yO0ETs4k78LBIRZGSqxO","section__second":"KpcfIHfH8d3d4NgASCnw","sectionSecond":"KpcfIHfH8d3d4NgASCnw","section__third":"FIH8Kw59SjPvU0u0FrIE","sectionThird":"FIH8Kw59SjPvU0u0FrIE","section__accent":"rhrShueeJROE0TRBv1rM","sectionAccent":"rhrShueeJROE0TRBv1rM","current":"ZAfyBFzKvuRa_o8bR8Zy","section__active":"BNqdMJ93SSPHKpNvK_D5","sectionActive":"BNqdMJ93SSPHKpNvK_D5","cardContainer":"CZq2mC7oifG7MRwhv1Ot","lineSection":"p8nbc4pxT5wCyZSJ9iNI","labels":"bnfyaeMxbmI8lXtx8yDg","labelContainer":"z0Fk5878MpJYMX1dtink","tooltipContainer":"Rmp42GQQYpQ8tD6Fdkt0"});

/***/ }),

/***/ 1553:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"MUQBgUkeMYzoErv5CDAf","clearInlineWhitespaceWrapper":"MUQBgUkeMYzoErv5CDAf","outer-container":"n_ldH5hay4SopiFcF2Gg","outerContainer":"n_ldH5hay4SopiFcF2Gg","card":"eVLwIIrO25VZDR4ouT_8","cardText":"fSVsaaaV7xZTnS0sMTZk","textInnerWrap":"w2CxXmFqHAtMfu9OP5B7","inputs":"ItG19HQKuOxwFLowrJMs","input":"TLgRHS1RpoXeW6M2IA8C","title":"kwKr3AxPhpCFMM3hOGJ8","results":"MBa1TWyEt0LUD6fKFvlP","header":"vlIWy6Y1y7zN7DsOGkrC","description":"PiOKyPlnysdEMONzKRIl","result":"YMveCnCLvRmoDA7rcHBJ","amount":"sirWYLsUvubeSNlkXFPQ","information":"fZ6qUKJh0TCG4Q6adEU4","loadingLong":"KS4Cjf35dWtAYCsNfGa7","loadingShort":"kIGqEmo7ANQrqfWJwcBJ","spinner":"f8Pa_w9vvtUNUFJxLuXn","disclaimer":"ebQ4YaJk4eN4eim5zqzR","result-top":"y0MxbcTkM5bp1GZosnS1","resultTop":"y0MxbcTkM5bp1GZosnS1","tooltip-open":"a_Bqk5CbDwg2u0Q1wA50","tooltipOpen":"a_Bqk5CbDwg2u0Q1wA50","tooltip-paragraph":"MsV3IQxCT6NzzSQwikh3","tooltipParagraph":"MsV3IQxCT6NzzSQwikh3","tooltip-button":"VO6eBzPZOxkBZFoFpor0","tooltipButton":"VO6eBzPZOxkBZFoFpor0"});

/***/ }),

/***/ 49360:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"oR_NHCDWegOa9FLOL4vU","clearInlineWhitespaceWrapper":"oR_NHCDWegOa9FLOL4vU","sectionCard":"HlOmF8cyPZUt6h5exy9v","partially-disabled":"aCPEEVhUlIJ3Uaq_HX2j","partiallyDisabled":"aCPEEVhUlIJ3Uaq_HX2j","buttonTooltip":"Eb2E4RgpW25QHnvqb0Ss","icon":"ogDdYoGCsq4sGJwCDIIz","button":"dj1zHWCRiv8FFo8iRRfP","titleContainer":"gFrJlmDHP5ZKV3BC6WFC","numberContainer":"lC1Cj8hPCk6UKWGMXBGB","hairlineContainer":"RrpD6jXHcedvWcJ1BAM5","removeApplicantButton":"kvrZq_7WitUtUFIF_GGx","textContainer":"YRr5G38NVN3h5IVeppmq","textContainerDocuments":"rbnu529g2SvVqJRmO6bB","percentageContainer":"VwynkLM3lnLQm9KWXXFj","documentsPill":"fjxn1fX0Be7a1bvgascK","arrowIcon":"FPIow_Qb3dAKeGPw71Jt","percentageText":"TKo5pjX0gVukp9O7EOm_","title":"w12o3bqXps9apKaVph5Y","description":"NjVzamYQxN0PhTAK70wP","descriptionText":"o2bOwHDutsXucOY3zT_9","defaultSection":"kwJ2vQBZ8SFdiiCBP4Zg","documentsSection":"Dej92RvE9k3ai0MTxxBF","addSecondSection":"dljlIADu90TSIGX5gpqe","addSecondSectionRemove":"KHlfcHH14GB3JSUqfra0","tipOuterContainer":"Y2pmk4JnV5Y0MQuZYYDR","tipInnerContainer":"jAM5skuKNr21312RwCyu","tooltipTextContainer":"iXVQZHqwSLaxvPmsKLyH","completedSection":"Str0lLqTLrRYq9YXFIcw"});

/***/ }),

/***/ 40023:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"JiXKXIPHzvCH0ohju6g_","clearInlineWhitespaceWrapper":"JiXKXIPHzvCH0ohju6g_","container":"TNFwAojYLssrA3n1F3Ok","mainOptionsButton":"QL3qgxyBC1XDn1W3DMqg","optionsContainer":"KQMGNUiG_wwNIEQpAU18","option":"bE83XSJ4cBk3hNCneG8Z","triangle":"bQCeCdZkLSzbjljeneMp","open":"hee4mmx8QDbDxWw8PKx4","profileText":"lVfQz7LsrK6pYj4SrpGZ","unknownProfileIcon":"tGinuzjXhBmv0kgFslvb"});

/***/ }),

/***/ 45346:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"R6wRxg3krBwH0ktaa7AR","clearInlineWhitespaceWrapper":"R6wRxg3krBwH0ktaa7AR","loading":"CZZx3hLSZjXZJu4PVCZw","spinner":"zH74MPi5PQnx2Bh4AHfQ","spin":"DqC4utNRvmtgMhp_cwjS","button":"ITYWAWOkViAn7OTIEYM5","loadingText":"AO3DCzAQWKYCFGl2fKtG","buttonText":"CY1K6fYQSzOHsBy__Yc1","button-content":"UdD9i1MZ3zz9UVxiNeGC","buttonContent":"UdD9i1MZ3zz9UVxiNeGC"});

/***/ }),

/***/ 24637:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"O3n_axiJAfvx2ClFRAc8","clearInlineWhitespaceWrapper":"O3n_axiJAfvx2ClFRAc8","article":"NxlQRDSrgCtmvRxPQz6g","secondary-heading":"Iv4SMt7Dkivc0xtV8wBP","secondaryHeading":"Iv4SMt7Dkivc0xtV8wBP","link":"GNphqErTe4tY_X9Hhc6S","button-link":"rbIJ2JzONLsLbDFmZkMx","buttonLink":"rbIJ2JzONLsLbDFmZkMx"});

/***/ }),

/***/ 58540:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"list":"bnR9B8wa_rPsPc5DKFDQ","item":"PwEAMNKmRyqsWYRbGPmf","text":"Pq_qiyCbhosTMS4TWZha","title":"ytguqqb5a5dqDJrvGQVA","description":"ylDuQ4TFiVZ0SrJUBQQC"});

/***/ }),

/***/ 63287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"M4JFCANf93m6yHj7VpVX","clearInlineWhitespaceWrapper":"M4JFCANf93m6yHj7VpVX","social":"H7RFh1CZPDwD57Qg8ZgA","link":"toEZsEa9EmwzfpAlWKgK","dark":"FDnepsy9MrRct6fxBE89"});

/***/ }),

/***/ 9376:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"FEJsR8iHizK6rlR2CLPe","clearInlineWhitespaceWrapper":"FEJsR8iHizK6rlR2CLPe","review-container":"yuDp2Q4nTaJaTzlKuezI","reviewContainer":"yuDp2Q4nTaJaTzlKuezI","review-container--green":"DjFzzKbmDNgEM_h6yVTY","reviewContainerGreen":"DjFzzKbmDNgEM_h6yVTY","review-container--orange":"aeKrZ92DSCTTd2uYiTDA","reviewContainerOrange":"aeKrZ92DSCTTd2uYiTDA","review-container--purple":"x0Bd7FDTlx1y7tmz858b","reviewContainerPurple":"x0Bd7FDTlx1y7tmz858b","star-rating":"hvFH6itnZP9SOc894kbl","starRating":"hvFH6itnZP9SOc894kbl","text":"rEV4Nk33QAj3nCCSV7H2","meta-wrapper":"Wb6urS00QSrDCSlOlBFS","metaWrapper":"Wb6urS00QSrDCSlOlBFS","meta":"HJ4TM7CxX2sgWSGYikI5","small":"cz33U2A8Q8foWCJ1k64q","link":"AVVIG1r1_LBnzk4UEz2D"});

/***/ }),

/***/ 34001:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"mTdWkWHGhP3g0tmq94K0","clearInlineWhitespaceWrapper":"mTdWkWHGhP3g0tmq94K0","container":"fftalwgNHdNA3cDcTasi","reviewsContainer":"vQ7NkOvZeC9P0vmHMYiy","trustpilot":"dcaZIYhBEfAqzfRzKM6t","title":"PEAtuuboBPzR7BZirmlC","text":"I7yKWklX1hfwfa61lGtM","link":"ezwBfUo7u3SiYBLj4F7g","linkContent":"xGVMZYaJMTmDAzmVdJmc","arrow":"AXCOo4OgmEU7LaIKDtvJ"});

/***/ }),

/***/ 5536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"H48bvvkP5HxRHdgui4Ud","clearInlineWhitespaceWrapper":"H48bvvkP5HxRHdgui4Ud","outer-container":"DW4zx39R6TyIWRYlE2xf","outerContainer":"DW4zx39R6TyIWRYlE2xf","text-wrapper":"jcCpmLkyn2HaMPW6tgTv","textWrapper":"jcCpmLkyn2HaMPW6tgTv","option":"Lj2Gq4U6zyJk5rJPkX7Z","enabled":"srD43TMo5jxZHEJ75FVc","disabled":"syed1Sax7hMSpLEPO1TZ","tick":"TFuhYnWa8G7FswBB015Z","title":"GFbzTWrQbBfpZM3y7hHw","text":"jvtfVZ_bWVfdHOofP8Qw","left":"cLgK7nC1pXi3zq3HC0pa","line":"gMa5fY_3rip6KmbRrzGU"});

/***/ }),

/***/ 76508:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"nAIXaZSD6YqAqAtxrxoc","clearInlineWhitespaceWrapper":"nAIXaZSD6YqAqAtxrxoc","outer-container":"bQYyxOZahqujGvePPxAE","outerContainer":"bQYyxOZahqujGvePPxAE","main-title":"wgJnCTP2bGxiGiZhzg3A","mainTitle":"wgJnCTP2bGxiGiZhzg3A","line":"lEUYKLmUdEM0oyoTnbAe","wrapper":"LMiOaxbRs07OLWhmegJQ","text-wrapper":"qoDUCLLS47bE6oEQaeyN","textWrapper":"qoDUCLLS47bE6oEQaeyN","ellipse":"gQhQgupuJEdC8t4Q2Zfx","title":"CNPWMjCIGDsVLLsEsUhw","paragraph":"QOMmHonzpwQ5257G3EwD","list":"SknUoTo3Y4THeAej5ysG"});

/***/ }),

/***/ 49299:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"fI6jwhdXGKyVxSuNd9CQ","clearInlineWhitespaceWrapper":"fI6jwhdXGKyVxSuNd9CQ","tooltipCardContainer":"QCZiAugzp2NOxlS_M46R","caret":"ffpZ7rdrVyXcYaaWyqOl","align-left":"rRuLZgyTOzhXlpdHrffv","alignLeft":"rRuLZgyTOzhXlpdHrffv","align-center":"GevKs6SSCTRFvXdiZDtS","alignCenter":"GevKs6SSCTRFvXdiZDtS","align-right":"t9uO2F_xlcGxp1fQZvMC","alignRight":"t9uO2F_xlcGxp1fQZvMC","tooltipCardHeader":"VtdbC7jksWT7HqN6LbPq","subtitle":"O3Fq6fxGYByCcKzo_wPo","pill":"lBwqKNrmIdQJXFIwXfJd","tooltipCardFooter":"RNuvqRYve0oEQ9CAAUjA","month":"ydQMOUSp5z1eeoZY9bnd","primary":"dmlfmGVRqr84ZJzm4vAg","warning":"pc2EhF2boKpqFHttM73u","informative":"CWhCKeNoIQeKVO1vKnna"});

/***/ }),

/***/ 25265:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"Ij9VGrFvyE0rr67Kbqhw","clearInlineWhitespaceWrapper":"Ij9VGrFvyE0rr67Kbqhw","trustpilot-card-container":"y3vAGXe3op9glPHZQMPK","trustpilotCardContainer":"y3vAGXe3op9glPHZQMPK","trustpilot-card":"yAMnWy9mWwBS9R8MqMDd","trustpilotCard":"yAMnWy9mWwBS9R8MqMDd","star-wrapper":"mzpYqzJ_iTQsEU5EoL__","starWrapper":"mzpYqzJ_iTQsEU5EoL__","slide-in":"BM8oSbdKmyAGwgVlefYr","slideIn":"BM8oSbdKmyAGwgVlefYr","bouncy-star":"V8YUqfXFvz7pKeWja6ez","bouncyStar":"V8YUqfXFvz7pKeWja6ez","mover":"Pw5PYZaCm1rK7KHGGKNx","bouncy-star-infinite":"QeUB_aKNb06ccwmXgGQs","bouncyStarInfinite":"QeUB_aKNb06ccwmXgGQs","review-card-container":"yDVWDZp1u97p4X3Paosk","reviewCardContainer":"yDVWDZp1u97p4X3Paosk","slide-left":"ZttwQMbAZg6EnaeeCk2R","slideLeft":"ZttwQMbAZg6EnaeeCk2R","review-card-container-slide-right":"cvrp9xR8dlP8Ky6YYiJw","reviewCardContainerSlideRight":"cvrp9xR8dlP8Ky6YYiJw","header-wrapper":"lf_5NRyimOizsdyJJXnt","headerWrapper":"lf_5NRyimOizsdyJJXnt","review-wrapper":"cuYQ_jNszbc0VHqtY6JY","reviewWrapper":"cuYQ_jNszbc0VHqtY6JY","review-card":"ckZdLYz2ItgpfComPwiJ","reviewCard":"ckZdLYz2ItgpfComPwiJ","review-card-text":"oeJY5IijmWD65h857txC","reviewCardText":"oeJY5IijmWD65h857txC","trust-pilot-logo":"xlYwufYOZBnSr32aeUed","trustPilotLogo":"xlYwufYOZBnSr32aeUed","title":"nXRkARCQacHTX9MeocDk","name":"lUqoKKAua7RII0gU4isM","reviewer-wrapper":"YWIHF69zKAAAk3VFOp6B","reviewerWrapper":"YWIHF69zKAAAk3VFOp6B","reviewer-wrapper-slide-right":"oIQNgB5yDb6R86Z9yGAA","reviewerWrapperSlideRight":"oIQNgB5yDb6R86Z9yGAA"});

/***/ }),

/***/ 51889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"t5iW7qfTeLf_hbTL59y9","clearInlineWhitespaceWrapper":"t5iW7qfTeLf_hbTL59y9","button":"sq9fwoWGReVMkUlI9s6L","dark":"iKLXOZCyD3kMDM_Rjljy","title":"JOuHz_jUG_xCR2AYeKbX","smart-buyer-badge":"XzKVGy7ASd8HK1VGn65R","smartBuyerBadge":"XzKVGy7ASd8HK1VGn65R","body":"DhUAkXngzoHQl9NjrdJZ","icon":"qBNC2EL8TRMXdOSzpMEp"});

/***/ }),

/***/ 646:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"YoVn9vraJkVEbFq0NyJ4","clearInlineWhitespaceWrapper":"YoVn9vraJkVEbFq0NyJ4","button":"Wfqa5MfUfOqy1wc7c30W","content":"HRK93k9kPiv4lcedDmQS"});

/***/ }),

/***/ 24925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"hPf_eCknfQvoGlOTTFG0","clearInlineWhitespaceWrapper":"hPf_eCknfQvoGlOTTFG0","container":"c4vLN4tGivAxeG_hJ8R4","title":"Zz_atfJ1jAzTpWDLFIdi","text":"lRER1q7aCGmtDHvwNg8D"});

/***/ }),

/***/ 69436:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"Tfjg8bOzdco0vNK2uYAH","clearInlineWhitespaceWrapper":"Tfjg8bOzdco0vNK2uYAH","wrapper":"L96McW7AJSJrJUe76sZ3","default-wrapper":"BtHP17dJB0luZnVC1tAc","defaultWrapper":"BtHP17dJB0luZnVC1tAc","zoopla-wrapper":"Knl4ErBSZzVnKiHHY8od","zooplaWrapper":"Knl4ErBSZzVnKiHHY8od"});

/***/ }),

/***/ 87947:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"green-green_500":"#00875a","greenGreen500":"#00875a","green-green_400":"#2ace93","greenGreen400":"#2ace93","green-green_300":"#74e0a1","greenGreen300":"#74e0a1","green-green_200":"#b0efbc","greenGreen200":"#b0efbc","green-green_100":"#c8fad1","greenGreen100":"#c8fad1","green-green_75":"#deffe4","greenGreen75":"#deffe4","green-green_50":"#f1fff3","greenGreen50":"#f1fff3","yellow-yellow_500":"#e79500","yellowYellow500":"#e79500","yellow-yellow_400":"#f69f00","yellowYellow400":"#f69f00","yellow-yellow_300":"#ffb61a","yellowYellow300":"#ffb61a","yellow-yellow_200":"#ffc159","yellowYellow200":"#ffc159","yellow-yellow_100":"#ffd081","yellowYellow100":"#ffd081","yellow-yellow_75":"#ffe0ad","yellowYellow75":"#ffe0ad","yellow-yellow_50":"#fffbf5","yellowYellow50":"#fffbf5","red-red_500":"#cc3229","redRed500":"#cc3229","red-red_400":"#f33c31","redRed400":"#f33c31","red-red_300":"#f56358","redRed300":"#f56358","red-red_200":"#ff9187","redRed200":"#ff9187","red-red_100":"#ffb2ab","redRed100":"#ffb2ab","red-red_75":"#ffd2ce","redRed75":"#ffd2ce","red-red_50":"#fff4f3","redRed50":"#fff4f3","neutral-neutral_500":"#0b0e2d","neutralNeutral500":"#0b0e2d","neutral-neutral_400":"#45556f","neutralNeutral400":"#45556f","neutral-neutral_300":"#8992a1","neutralNeutral300":"#8992a1","neutral-neutral_200":"#acb5c2","neutralNeutral200":"#acb5c2","neutral-neutral_100":"#c2cbd7","neutralNeutral100":"#c2cbd7","neutral-neutral_75":"#d8dfe9","neutralNeutral75":"#d8dfe9","neutral-neutral_50":"#f1f2f8","neutralNeutral50":"#f1f2f8","neutral-neutral_25":"#fafaff","neutralNeutral25":"#fafaff","neutral-neutral_0":"#fff","neutralNeutral0":"#fff","coal-coal_500":"#15151b","coalCoal500":"#15151b","coal-coal_400":"#292a33","coalCoal400":"#292a33","coal-coal_300":"#3b3c45","coalCoal300":"#3b3c45","primary-purple_500":"#6a148e","primaryPurple500":"#6a148e","secondary-green-300":"#74e0a1","secondaryGreen300":"#74e0a1","clear-inline-whitespace-wrapper":"CGbSUrNfkaSUVaiUXgJn","clearInlineWhitespaceWrapper":"CGbSUrNfkaSUVaiUXgJn","display1Variant":"ENue4Um_SO174OXhPXrM","display2Variant":"T6RiJTUC4hqZ5ryInSOw","display3Variant":"hcD14m3natoHqTHy8IjT","h1Variant":"gsQWK06R8_lNeuTaDa5m","h2Variant":"VgOd9n2lxuDfBL2jL6es","h3Variant":"TOMyyfMAqIZEmVXfO6Mg","h4Variant":"GsaJ0RrWzg7sAjRhV0p6","h5Variant":"Le34JplwR3gbQSj7iSJE","h6Variant":"KVfdtOywKjHfDQeMvJoL","h7Variant":"TGfkpp1rvjOb5yaXG5ou","body1Variant":"J1xeyitVPtok70kDJv_b","body2Variant":"quTfNW3vnMqL6Cug59AO","body3Variant":"p8ziiJYBir3wnU0ob42D","left":"SeoXzcWhAZzdsbjCSBld","right":"U2PV_9VR_U7eSSYzJFWt","center":"YGi44523rqTFuHazelRs","inherit":"wW1oIzpyMBkS6Ny0NVVd","justify":"RHuBfINggi9tpuz0DO_i","gutterBottom":"WrwqVZuC2gNyoKpbyefl"});

/***/ }),

/***/ 36085:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var callToActionLink_1 = __importDefault(__webpack_require__(62950));
var style_scss_1 = __importDefault(__webpack_require__(80458));
var componentName = "Error404Page";
var elementIdentifiers = (0, shared_1.tuple)("container", "background", "content", "header", "explainer", "spacer");
var defaultMessage = (react_1.default.createElement(react_1.default.Fragment, null,
    "Looks like you may have",
    react_1.default.createElement("br", null),
    "the wrong address"));
var Error404Page = function (_a) {
    var homeHref = _a.homeHref, _b = _a.message, message = _b === void 0 ? defaultMessage : _b, returnHomeMessage = _a.returnHomeMessage, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, className = _a.className, props = __rest(_a, ["homeHref", "message", "returnHomeMessage", "classOverrides", "testIds", "refs", "className"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({ id: "error" }, ovr.container, { className: (0, classnames_1.default)(ovr.container, className) }, props),
        react_1.default.createElement("div", __assign({}, ovr.background),
            react_1.default.createElement("div", __assign({}, ovr.content),
                react_1.default.createElement("h1", __assign({ id: "error-title" }, ovr.header), message),
                react_1.default.createElement("div", __assign({}, ovr.spacer)),
                react_1.default.createElement("p", __assign({}, ovr.explainer),
                    react_1.default.createElement(callToActionLink_1.default, { id: "take-me-home", href: homeHref }, returnHomeMessage))))));
};
Error404Page.displayName = componentName;
exports["default"] = Error404Page;


/***/ }),

/***/ 71101:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(15634));
var shared_1 = __webpack_require__(89574);
var classnames_1 = __importDefault(__webpack_require__(57485));
var componentName = "Accordion";
var elementIdentifiers = (0, shared_1.tuple)("accordion", "accordionItem", "accordionItemHeader", "accordionButton", "accordionItemTitle", "accordionIcon", "accordionContent");
var Accordion = function (_a) {
    var items = _a.items, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["items", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _b = (0, react_1.useState)([]), openIndexes = _b[0], setOpenIndexes = _b[1];
    var toggleIndex = function (index) {
        setOpenIndexes(function (prevIndexes) {
            return prevIndexes.includes(index)
                ? prevIndexes.filter(function (i) { return i !== index; })
                : __spreadArray(__spreadArray([], prevIndexes, true), [index], false);
        });
    };
    return (react_1.default.createElement("div", __assign({}, ovr.accordion), items.map(function (item, index) {
        var _a;
        return (react_1.default.createElement("div", __assign({ key: index }, ovr.accordionItem),
            react_1.default.createElement("div", __assign({}, ovr.accordionItemHeader),
                react_1.default.createElement("button", __assign({}, ovr.accordionButton, { onClick: function () { return toggleIndex(index); } }),
                    react_1.default.createElement("h3", __assign({}, ovr.accordionItemTitle), item.title)),
                openIndexes.includes(index) ? (react_1.default.createElement("button", __assign({ "aria-label": "close panel", onClick: function () { return toggleIndex(index); } }, ovr.accordionIcon),
                    react_1.default.createElement(shared_1.Icon, { name: "RemoveDark" }))) : (react_1.default.createElement("button", __assign({ "aria-label": "open panel", onClick: function () { return toggleIndex(index); } }, ovr.accordionIcon),
                    react_1.default.createElement(shared_1.Icon, { name: "AddDark" })))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.accordionContent, ovr.accordionContent.className, (_a = {},
                    _a[style_scss_1.default["accordion-content-show"]] = openIndexes.includes(index),
                    _a)) }, item.content)));
    })));
};
Accordion.displayName = componentName;
exports["default"] = Accordion;


/***/ }),

/***/ 44260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ArrowDirections = exports.componentName = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var chevron_right_react_svg_1 = __importDefault(__webpack_require__(14720));
var chevron_left_react_svg_1 = __importDefault(__webpack_require__(5074));
var style_scss_1 = __importDefault(__webpack_require__(93161));
exports.componentName = "Arrow";
var elementIdentifiers = (0, shared_1.tuple)("arrow");
var ArrowDirections;
(function (ArrowDirections) {
    ArrowDirections["Left"] = "left";
    ArrowDirections["Right"] = "right";
})(ArrowDirections = exports.ArrowDirections || (exports.ArrowDirections = {}));
var Arrow = function (_a) {
    var _b, _c;
    var direction = _a.direction, onClick = _a.onClick, _d = _a.disabled, disabled = _d === void 0 ? false : _d, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["direction", "onClick", "disabled", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: exports.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var attributes = __assign(__assign(__assign({}, ovr.arrow), props), { className: (0, classnames_1.default)((_b = {},
            _b[style_scss_1.default.disabled] = disabled,
            _b[style_scss_1.default.enabled] = !disabled,
            _b), ovr.arrow.className, className) });
    var chevronSelection = (_c = {},
        _c[ArrowDirections.Left] = chevron_left_react_svg_1.default,
        _c[ArrowDirections.Right] = chevron_right_react_svg_1.default,
        _c);
    var Chevron = chevronSelection[direction];
    return (react_1.default.createElement("span", __assign({}, attributes, { onClick: disabled ? undefined : onClick, onKeyDown: disabled ? undefined : onClick }),
        react_1.default.createElement(Chevron, { "aria-label": direction })));
};
Arrow.displayName = exports.componentName;
exports["default"] = Arrow;


/***/ }),

/***/ 88426:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(67874));
var componentName = "Avatars";
var elementIdentifiers = (0, shared_1.tuple)("avatars", "avatar");
var Avatars = function (_a) {
    var images = _a.images, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["images", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var attributes = __assign(__assign(__assign({}, props), ovr.avatars), { className: (0, classnames_1.default)(ovr.avatars.className, className) });
    var reversedImages = (0, react_1.useMemo)(function () { return images.reverse(); }, [images]);
    return (react_1.default.createElement("div", __assign({}, attributes), reversedImages.map(function (image, index) { return (react_1.default.createElement("div", __assign({}, ovr.avatar, { key: index, style: { backgroundImage: "url(".concat(image, ")") } }))); })));
};
Avatars.displayName = componentName;
exports["default"] = Avatars;


/***/ }),

/***/ 11409:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BoxButton = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(43404));
var classnames_1 = __importDefault(__webpack_require__(57485));
var typography_1 = __webpack_require__(34237);
var shared_1 = __webpack_require__(89574);
var componentName = "BoxButton";
var elementIdentifiers = (0, shared_1.tuple)("button", "container", "typography", "arrowBox", "arrow");
exports.BoxButton = react_1.default.forwardRef(function (_a, ref) {
    var text = _a.text, label = _a.label, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["text", "label", "variant", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, ovr.button, { ref: ref, className: (0, classnames_1.default)(style_scss_1.default.button, ovr.button.className, variant === "primary" ? style_scss_1.default.primary : style_scss_1.default.secondary) }, props, { type: "button" }),
        react_1.default.createElement("div", __assign({}, ovr.container),
            react_1.default.createElement("div", null,
                label && (react_1.default.createElement(typography_1.Typography, { variant: "h6", classes: (0, classnames_1.default)(style_scss_1.default.typography, ovr.typography.className) }, label)),
                react_1.default.createElement(typography_1.Typography, __assign({ variant: "h4", classes: (0, classnames_1.default)(style_scss_1.default.typography, ovr.typography.className) }, ovr.typography), text)),
            react_1.default.createElement("div", __assign({}, ovr.arrowBox),
                react_1.default.createElement("div", __assign({}, ovr.arrow))))));
});
exports.BoxButton.displayName = componentName;


/***/ }),

/***/ 93158:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(11409), exports);


/***/ }),

/***/ 62950:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(42009));
var componentName = "CallToActionLink";
var elementIdentifiers = (0, shared_1.tuple)("anchor", "subLabel");
var CallToActionLink = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.size, size = _d === void 0 ? shared_1.ButtonSize.Large : _d, _e = _a.colour, colour = _e === void 0 ? shared_1.ButtonColour.Primary : _e, subLabel = _a.subLabel, _f = _a.preventDefault, preventDefault = _f === void 0 ? false : _f, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "size", "colour", "subLabel", "preventDefault", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var updatedProps = preventDefault ? __assign(__assign({}, props), { href: undefined }) : props;
    return (react_1.default.createElement("a", __assign({}, ovr.anchor, updatedProps, { "aria-label": "Link", className: (0, classnames_1.default)((_b = {}, _b["".concat(style_scss_1.default["size-".concat(size)])] = size, _b), (_c = {}, _c["".concat(style_scss_1.default["color-".concat(colour)])] = colour, _c), ovr.anchor.className, className) }),
        children,
        subLabel && react_1.default.createElement("div", __assign({}, ovr.subLabel), subLabel)));
};
CallToActionLink.displayName = componentName;
exports["default"] = CallToActionLink;


/***/ }),

/***/ 81845:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var React = __importStar(__webpack_require__(99497));
var styles_scss_1 = __importDefault(__webpack_require__(51844));
var shared_1 = __webpack_require__(89574);
var classnames_1 = __importDefault(__webpack_require__(57485));
var monty_bot_png_1 = __importDefault(__webpack_require__(40699));
var Spinner_1 = __importDefault(__webpack_require__(88774));
var react_linkify_1 = __importDefault(__webpack_require__(36887));
var componentName = "ChatBubble";
var elementIdentifiers = (0, shared_1.tuple)("container", "innerContainer", "spinnerContainer", "bubbleUser", "bubbleOther", "text", "avatar", "timestamp");
var ChatBubble = function (_a) {
    var _b;
    var variant = _a.variant, text = _a.text, timestamp = _a.timestamp, _c = _a.avatarImageSrc, avatarImageSrc = _c === void 0 ? monty_bot_png_1.default : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["variant", "text", "timestamp", "avatarImageSrc", "isLoading", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    var isUser = variant === "user";
    var bubbleOvr = isUser ? ovr.bubbleUser : ovr.bubbleOther;
    var showAvatar = !isUser;
    var content = isLoading && !text ? (React.createElement("div", __assign({}, ovr.spinnerContainer),
        React.createElement(Spinner_1.default, null))) : (React.createElement("div", __assign({}, ovr.innerContainer),
        React.createElement("div", __assign({}, bubbleOvr, { className: (0, classnames_1.default)(styles_scss_1.default.bubble, bubbleOvr.className) }),
            React.createElement("div", __assign({}, ovr.text),
                React.createElement(react_linkify_1.default, null, text))),
        React.createElement("div", __assign({}, ovr.timestamp), timestamp)));
    return (React.createElement("div", __assign({}, ovr.container, { className: (0, classnames_1.default)(ovr.container.className, (_b = {}, _b[styles_scss_1.default["align-right"]] = isUser, _b)) }),
        showAvatar ? (React.createElement("img", __assign({}, ovr.avatar, { src: avatarImageSrc, alt: "robot avatar" }))) : null,
        content));
};
exports["default"] = ChatBubble;


/***/ }),

/***/ 58487:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var styles_scss_1 = __importDefault(__webpack_require__(1448));
var shared_1 = __webpack_require__(89574);
var check_circle_outline_24px_react_svg_1 = __importDefault(__webpack_require__(48636));
var tick_reskin_react_svg_1 = __importDefault(__webpack_require__(54277));
var classnames_1 = __importDefault(__webpack_require__(57485));
var componentName = "Checklist";
var elementIdentifiers = (0, shared_1.tuple)("list", "listItem", "listSubItems", "listItemWithSubItem", "listItemSecondary");
var Checklist = function (_a) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? "default" : _c, items = _a.items, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["type", "items", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    var listGap = type === "subItems" ? "24px" : "12px";
    var listItemStyles = type === "subItems"
        ? ovr.listItemWithSubItem
        : type === "secondary"
            ? ovr.listItemSecondary
            : ovr.listItem;
    return (react_1.default.createElement("ul", __assign({}, ovr.list, { className: (0, classnames_1.default)(ovr.list.className, (_b = {},
            _b[styles_scss_1.default.horizontal] = type === "horizontal",
            _b[styles_scss_1.default.secondary] = type === "secondary",
            _b)), style: { gap: listGap } }), items.map(function (el) { return (react_1.default.createElement("li", __assign({ key: "".concat(type, "-").concat(el.item || el) }, listItemStyles),
        react_1.default.createElement("div", { className: styles_scss_1.default.iconWrapper },
            type === "secondary" ? react_1.default.createElement(tick_reskin_react_svg_1.default, null) : react_1.default.createElement(check_circle_outline_24px_react_svg_1.default, null),
            " "),
        react_1.default.createElement("span", null,
            el.item || el,
            type === "subItems" && react_1.default.createElement("p", __assign({}, ovr.listSubItems), el === null || el === void 0 ? void 0 : el.subItem)))); })));
};
Checklist.displayName = componentName;
exports["default"] = Checklist;


/***/ }),

/***/ 79581:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CircularProgressBarSize = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var formatMoney_1 = __webpack_require__(71367);
var styles_scss_1 = __importDefault(__webpack_require__(55580));
var shared_1 = __webpack_require__(89574);
var SIZE_SMALL = 48;
var SIZE_DEFAULT = 160;
var STROKE_WIDTH_SMALL = 6;
var STROKE_WIDTH_DEFAULT = 20;
var FONT_SIZE_SMALL = 10;
var FONT_SIZE_DEFAULT = 16;
var MAX_PROGRESS_DEFAULT = 100;
var MONEY_ABBREVIATE_AMOUNT_SMALL = 1000;
var MONEY_ABBREVIATE_AMOUNT_DEFAULT = 10000;
var CircularProgressBarSize;
(function (CircularProgressBarSize) {
    CircularProgressBarSize[CircularProgressBarSize["Small"] = SIZE_SMALL] = "Small";
    CircularProgressBarSize[CircularProgressBarSize["Default"] = SIZE_DEFAULT] = "Default";
})(CircularProgressBarSize = exports.CircularProgressBarSize || (exports.CircularProgressBarSize = {}));
var componentName = "CircularProgressBar";
var elementIdentifiers = (0, shared_1.tuple)("container", "progressOutline", "progressBar", "text");
var CircularProgressBar = function (_a) {
    var progress = _a.progress, _b = _a.type, type = _b === void 0 ? "percent" : _b, _c = _a.max, max = _c === void 0 ? MAX_PROGRESS_DEFAULT : _c, _d = _a.size, size = _d === void 0 ? CircularProgressBarSize.Small : _d, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["progress", "type", "max", "size", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    var strokeWidth = size === CircularProgressBarSize.Small
        ? STROKE_WIDTH_SMALL
        : STROKE_WIDTH_DEFAULT;
    var radius = (size - strokeWidth) / 2;
    var circumference = radius * 2 * Math.PI;
    var offset = circumference - (progress / max) * circumference;
    var fontSize = size === CircularProgressBarSize.Small
        ? FONT_SIZE_SMALL
        : FONT_SIZE_DEFAULT;
    var progressText;
    var title;
    var abbreviateFromAmount = size === CircularProgressBarSize.Small
        ? MONEY_ABBREVIATE_AMOUNT_SMALL
        : MONEY_ABBREVIATE_AMOUNT_DEFAULT;
    var formattedAmount = (0, formatMoney_1.formatMoney)(progress, abbreviateFromAmount);
    switch (type) {
        case "money":
            progressText = "\u00A3".concat(formattedAmount);
            title = "Progress \u00A3".concat(formattedAmount, " (").concat(((progress / max) * 100).toFixed(1), "%)");
            break;
        case "steps":
            progressText = "".concat(progress, "/").concat(max);
            title = "Progress ".concat(progress, "/").concat(max, " steps (").concat(((progress / max) *
                100).toFixed(1), "%)");
            break;
        case "percent":
        default:
            progressText = "".concat(progress, "%");
            title = "Progress ".concat(((progress / max) * 100).toFixed(1), "%");
            break;
    }
    return (react_1.default.createElement("svg", __assign({ "aria-label": title, role: "progressbar", width: size, height: size }, ovr.container),
        react_1.default.createElement("circle", __assign({ cx: size / 2, cy: size / 2, r: radius, fill: "transparent", strokeWidth: strokeWidth }, ovr.progressOutline)),
        react_1.default.createElement("circle", __assign({ cx: size / 2, cy: size / 2, r: radius, fill: "transparent", strokeWidth: strokeWidth, strokeDasharray: "".concat(circumference, " ").concat(circumference), strokeDashoffset: offset, strokeLinecap: "round", transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")") }, ovr.progressBar)),
        react_1.default.createElement("text", __assign({ x: "50%", y: "50%", textAnchor: "middle", dominantBaseline: "middle", fontSize: fontSize, fill: "#000000", fontWeight: "bold" }, ovr.text), progressText)));
};
CircularProgressBar.displayName = componentName;
exports["default"] = CircularProgressBar;


/***/ }),

/***/ 24082:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var icon_1 = __webpack_require__(55074);
var keycodes_1 = __webpack_require__(52394);
var style_scss_1 = __importDefault(__webpack_require__(90231));
exports.componentName = "CollapsibleContent";
exports.elementIdentifiers = (0, shared_1.tuple)("collapsibleContent");
var CollapsibleContent = function (_a) {
    var children = _a.children, title = _a.title, openByDefault = _a.openByDefault, isCollapsible = _a.isCollapsible, onClickHandler = _a.onClickHandler, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "title", "openByDefault", "isCollapsible", "onClickHandler", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: exports.elementIdentifiers,
        componentName: exports.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _b = (0, react_1.useState)(openByDefault), isExpanded = _b[0], setIsExpanded = _b[1];
    var onExpandableTitleClick = function () {
        setIsExpanded(!isExpanded);
        if (onClickHandler) {
            onClickHandler();
        }
    };
    var onKeyDownHandler = function (event) {
        if ([keycodes_1.SPACE, keycodes_1.ENTER].includes(event.keyCode)) {
            onExpandableTitleClick();
            event.preventDefault(); // prevent default page scrolling when using spacebar
        }
    };
    if (!isCollapsible) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({}, props, ovr.collapsibleContent, { onClick: onExpandableTitleClick, onKeyDown: onKeyDownHandler, role: "button", tabIndex: 0, "aria-expanded": isExpanded, className: (0, classnames_1.default)(ovr.collapsibleContent.className, className, isExpanded && style_scss_1.default.spacer) }),
            title,
            isExpanded ? (react_1.default.createElement(icon_1.Icon, { name: icon_1.IconName.UpArrow })) : (react_1.default.createElement(icon_1.Icon, { name: icon_1.IconName.DownArrow }))),
        isExpanded ? react_1.default.createElement(react_1.default.Fragment, null, children) : null));
};
CollapsibleContent.displayName = exports.componentName;
exports["default"] = CollapsibleContent;


/***/ }),

/***/ 56466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Container = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(61313));
var componentName = "Container";
var elementIdentifiers = (0, shared_1.tuple)("div");
var Container = function (_a) {
    var children = _a.children, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, _b = _a.size, size = _b === void 0 ? "medium" : _b, props = __rest(_a, ["children", "classOverrides", "testIds", "refs", "size"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.div, props, { className: style_scss_1.default[size] }), children));
};
exports.Container = Container;


/***/ }),

/***/ 178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(86365));
var componentName = "content-loader";
var elementIdentifiers = (0, shared_1.tuple)("contentLoader");
var ContentLoader = function (_a) {
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.contentLoader, props, { className: (0, classnames_1.default)(ovr.contentLoader.className, className) }), "\u00A0"));
};
ContentLoader.displayName = componentName;
exports["default"] = ContentLoader;


/***/ }),

/***/ 35913:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
__webpack_require__(33648);
var initCookieBanner = function (themeClassName, onStatusChange) { return __awaiter(void 0, void 0, void 0, function () {
    var initOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(__webpack_require__(88296)); })];
            case 1:
                _a.sent();
                initOptions = {
                    cookie: {
                        domain: ".better.co.uk"
                    },
                    content: {
                        message: 'By using the website you agree to our <a href="https://better.co.uk/cookies" title="Cookie Policy" class="cc-policy-link"> cookie policy</a>',
                        dismiss: "Okay, got it"
                    },
                    dismissOnTimeout: 30000,
                    position: "bottom",
                    showLink: false,
                    theme: "better.co.uk",
                    window: "<div role=\"dialog\" aria-live=\"polite\" aria-label=\"cookieconsent\" aria-describedby=\"cookieconsent:desc\" class=\"".concat(themeClassName, " cc-window {{classes}}\"><div class=\"cc-content\">{{children}}</div></div>")
                };
                if (onStatusChange) {
                    // Setting this to undefined creates an error in the cookieconsent library
                    initOptions.onStatusChange = onStatusChange;
                }
                window.cookieconsent.initialise(initOptions);
                return [2 /*return*/];
        }
    });
}); };
var CookieBanner = function (_a) {
    var themeClassName = _a.themeClassName, onStatusChange = _a.onStatusChange;
    // check if cookie banner has already been initialised, should only load once even if argument changes
    var _b = react_1.default.useState(false), cookieBannerInit = _b[0], setCookieBannerInit = _b[1];
    (0, react_1.useEffect)(function () {
        var checkCookieBannerInit = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!cookieBannerInit) return [3 /*break*/, 2];
                        return [4 /*yield*/, initCookieBanner(themeClassName, onStatusChange)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, setCookieBannerInit(true)];
                    case 2: return [2 /*return*/, null];
                }
            });
        }); };
        checkCookieBannerInit();
    }, []);
    return null;
};
exports["default"] = CookieBanner;


/***/ }),

/***/ 1689:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "CtaCard";
exports.elementIdentifiers = (0, shared_1.tuple)("heading", "description", "ctaText");


/***/ }),

/***/ 86808:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var callToActionLink_1 = __importDefault(__webpack_require__(62950));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(1689);
var style_scss_1 = __importDefault(__webpack_require__(2683));
var CtaCard = function (_a) {
    var heading = _a.heading, description = _a.description, link = _a.link, ctaText = _a.ctaText, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["heading", "description", "link", "ctaText", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.ctaCard, className) },
        react_1.default.createElement("div", { className: style_scss_1.default.textContainer },
            heading && react_1.default.createElement("p", __assign({}, ovr.heading), heading),
            description && react_1.default.createElement("p", __assign({}, ovr.description), description)),
        link && ctaText && (react_1.default.createElement(callToActionLink_1.default, __assign({ size: shared_1.ButtonSize.Medium, href: link }, ovr.ctaText), ctaText))));
};
CtaCard.displayName = constants_1.componentName;
exports["default"] = CtaCard;


/***/ }),

/***/ 84628:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "FlexibleModal";
exports.elementIdentifiers = (0, shared_1.tuple)("overlay", "modal", "closeButton", "pageContainer");


/***/ }),

/***/ 27767:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var keycodes_1 = __webpack_require__(52394);
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(50540));
var close_cross_react_svg_1 = __importDefault(__webpack_require__(98502));
var subtleButton_1 = __importDefault(__webpack_require__(74500));
var flexibleModalPage_1 = __importDefault(__webpack_require__(47282));
var FlexibleModalPageIdsContext_1 = __webpack_require__(7412);
var constants_1 = __webpack_require__(84628);
var allowOverflow = function () {
    document.body.style.overflow = "auto";
};
/**
 * Renders a modal with one or more pages.
 * Should be used alongside {@link FlexibleModalPage} and {@link FlexibleModalButton}.
 */
var FlexibleModal = function (_a) {
    var _b;
    var id = _a.id, className = _a.className, onClose = _a.onClose, isOpen = _a.isOpen, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, pages = _a.pages, _c = _a.size, size = _c === void 0 ? "medium" : _c;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    // Modal state helpers
    var _d = (0, react_1.useState)(0), currentPageIndex = _d[0], setCurrentPageIndex = _d[1];
    var lastPageIndexRef = (0, react_1.useRef)(0);
    var goToPreviousPage = (0, react_1.useCallback)(function () {
        if (currentPageIndex > 0) {
            setCurrentPageIndex(currentPageIndex - 1);
        }
    }, [currentPageIndex]);
    var goToNextPage = (0, react_1.useCallback)(function () {
        if (currentPageIndex < lastPageIndexRef.current) {
            setCurrentPageIndex(currentPageIndex + 1);
        }
    }, [currentPageIndex, lastPageIndexRef.current]);
    var goToPage = (0, react_1.useCallback)(function (newPageIndex) {
        if (newPageIndex >= 0 && newPageIndex <= lastPageIndexRef.current) {
            setCurrentPageIndex(newPageIndex);
        }
    }, [lastPageIndexRef.current]);
    var close = function () {
        onClose();
        goToPage(0);
    };
    // Focus on close button when opening and navigating between pages
    var closeButtonRef = (0, react_1.useMemo)(function () { return (refs && refs.closeButton ? refs.closeButton : (0, react_1.createRef)()); }, [refs]);
    (0, react_1.useEffect)(function () {
        if (isOpen && closeButtonRef.current) {
            closeButtonRef.current.focus();
        }
        if (isOpen) {
            document.body.style.overflow = "hidden";
        }
        else {
            allowOverflow();
        }
        return function () { return allowOverflow(); };
    }, [isOpen, currentPageIndex, closeButtonRef.current]);
    // Close when pressing Escape
    var onKeyUp = function (_a) {
        var keyCode = _a.keyCode;
        if (keyCode === keycodes_1.ESCAPE) {
            close();
        }
    };
    // Prepare pages
    var pagesResult = pages({
        close: close,
        goToNextPage: goToNextPage,
        goToPreviousPage: goToPreviousPage,
        goToPage: goToPage
    });
    if (pagesResult.length === 0) {
        throw new Error("".concat(constants_1.componentName, ": pages can't return an empty list."));
    }
    lastPageIndexRef.current = pagesResult.length - 1;
    // Prepare ids
    var prefix = id || constants_1.componentName;
    var titleId = "".concat(prefix, "-title");
    var bodyId = "".concat(prefix, "-body");
    var pageIds = {
        titleId: titleId,
        bodyId: bodyId
    };
    if (!isOpen) {
        return null;
    }
    var stopPropagatingEvent = function (event) {
        event.stopPropagation();
    };
    return (react_1.default.createElement("div", __assign({}, ovr.overlay, { onClick: close, onKeyUp: onKeyUp, role: "dialog", "aria-label": "Overlay dialog" }),
        react_1.default.createElement("div", __assign({}, ovr.modal, { id: id, role: "dialog", "aria-label": "Dialog", "aria-labelledby": titleId, "aria-describedby": bodyId, className: (0, classnames_1.default)(ovr.modal.className, className, (_b = {},
                _b[style_scss_1.default.xLarge] = size === "x-large",
                _b)), onClick: stopPropagatingEvent, onKeyUp: onKeyUp }),
            react_1.default.createElement(subtleButton_1.default, __assign({}, ovr.closeButton, { "aria-label": "close", refs: { subtleButton: closeButtonRef }, onClick: close }),
                react_1.default.createElement(close_cross_react_svg_1.default, null)),
            pagesResult.map(function (pageElementOrProps, pageIndex) {
                var isForCurrentPage = currentPageIndex === pageIndex;
                var pageElement;
                // Render using function
                if ((0, shared_1.isRenderable)(pageElementOrProps)) {
                    pageElement = pageElementOrProps;
                }
                // Render using properties
                else {
                    pageElement = (react_1.default.createElement(flexibleModalPage_1.default, __assign({}, pageElementOrProps)));
                }
                return (react_1.default.createElement("div", __assign({}, ovr.pageContainer, { key: pageIndex, hidden: !isForCurrentPage }),
                    react_1.default.createElement(FlexibleModalPageIdsContext_1.FlexibleModalPageIdsContext.Provider, { value: isForCurrentPage ? pageIds : undefined }, pageElement)));
            }))));
};
FlexibleModal.displayName = constants_1.componentName;
exports["default"] = FlexibleModal;


/***/ }),

/***/ 70793:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var react_1 = __importDefault(__webpack_require__(99497));
var form_1 = __webpack_require__(13174);
var shared_1 = __webpack_require__(89574);
var componentName = "FlexibleModalButton";
/**
 * Renders a button, meant to be used in modal footers.
 * Should be used alongside {@link FlexibleModal} and {@link FlexibleModalPage}.
 *
 * It's based on a regular button with slightly more constrained attributes.
 */
var FlexibleModalButton = function (props) {
    var newProps = __assign(__assign({}, props), { size: shared_1.ButtonSize.Large, fixed: true });
    return react_1.default.createElement(form_1.Button, __assign({}, newProps));
};
FlexibleModalButton.displayName = componentName;
exports["default"] = FlexibleModalButton;


/***/ }),

/***/ 7412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FlexibleModalPageIdsContext = void 0;
var React = __importStar(__webpack_require__(99497));
exports.FlexibleModalPageIdsContext = React.createContext(undefined);


/***/ }),

/***/ 46718:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "FlexibleModalPage";
exports.elementIdentifiers = (0, shared_1.tuple)("page", "headerAndBody", "topIconContainer", "title", "body", "footer", "buttonsContainer", "leftImage");


/***/ }),

/***/ 47282:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(83661));
var flexibleModalButton_1 = __importDefault(__webpack_require__(70793));
var FlexibleModalPageIdsContext_1 = __webpack_require__(7412);
var classnames_1 = __importDefault(__webpack_require__(57485));
var constants_1 = __webpack_require__(46718);
var isImageComponent_1 = __importDefault(__webpack_require__(39294));
/**
 * Renders a page of a modal. Should always be used alongside {@link FlexibleModal} and {@link FlexibleModalButton}.
 */
var FlexibleModalPage = function (_a) {
    var id = _a.id, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, topIcon = _a.topIcon, title = _a.title, body = _a.body, leftImage = _a.leftImage, footer = _a.footer;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var footerElement;
    // Render footer using provided element
    if ((0, shared_1.isRenderable)(footer)) {
        footerElement = footer;
    }
    // Render footer using provided button parameters
    else {
        footerElement = (react_1.default.createElement(react_1.default.Fragment, null, footer.map(function (buttonProps, index) {
            var children = buttonProps.children;
            if (!children) {
                children = buttonProps.label;
            }
            return (react_1.default.createElement(flexibleModalButton_1.default, __assign({}, buttonProps, { children: children, key: index })));
        })));
    }
    return (react_1.default.createElement("div", __assign({}, ovr.page, { id: id, className: (0, classnames_1.default)(className, ovr.page.className) }),
        react_1.default.createElement(FlexibleModalPageIdsContext_1.FlexibleModalPageIdsContext.Consumer, null, function (pageIds) {
            var _a, _b;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", __assign({}, ovr.headerAndBody, { className: (0, classnames_1.default)(ovr.headerAndBody.className, (_a = {},
                        _a[style_scss_1.default.headerAndBodyShowingImage] = Boolean(leftImage),
                        _a)) }),
                    topIcon ? react_1.default.createElement("div", __assign({}, ovr.topIconContainer), topIcon) : null,
                    title && (react_1.default.createElement("h2", __assign({}, ovr.title, { id: pageIds && pageIds.titleId }), title)),
                    body ? (react_1.default.createElement("div", __assign({}, ovr.body, { id: pageIds && pageIds.bodyId, className: (0, classnames_1.default)(ovr.body.className, (_b = {},
                            _b[style_scss_1.default.bodyWithoutTopIcon] = !topIcon,
                            _b)) }), body)) : null),
                leftImage &&
                    ((0, isImageComponent_1.default)(leftImage) ? (leftImage) : (react_1.default.createElement("picture", __assign({}, ovr.leftImage),
                        react_1.default.createElement("source", { media: "(min-width:1200px)", srcSet: leftImage.src }),
                        react_1.default.createElement("source", { media: "(max-width:1199px)", srcSet: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==", sizes: "100%" }),
                        react_1.default.createElement("img", { src: leftImage.src, alt: leftImage.altText || "modal image" })))),
                footer && (react_1.default.createElement("div", __assign({}, ovr.footer),
                    react_1.default.createElement("div", __assign({}, ovr.buttonsContainer), footerElement)))));
        })));
};
FlexibleModalPage.displayName = constants_1.componentName;
exports["default"] = FlexibleModalPage;


/***/ }),

/***/ 38936:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var getImage_1 = __importDefault(__webpack_require__(1308));
var style_scss_1 = __importDefault(__webpack_require__(61172));
var classnames_1 = __importDefault(__webpack_require__(57485));
var componentName = "GuidesCard";
var elementIdentifiers = (0, shared_1.tuple)("guidesCard", "guidesCardTitle", "guidesCardSubTitle", "guidesCardText", "guidesCardHeader");
var GuidesCard = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "orange" : _b, title = _a.title, subtitle = _a.subtitle, text = _a.text, icon = _a.icon, link = _a.link, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["variant", "title", "subtitle", "text", "icon", "link", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("a", { href: link, style: { textDecoration: "none" }, rel: "noopener noreferrer" },
        react_1.default.createElement("div", __assign({}, ovr.guidesCard, { className: (0, classnames_1.default)(ovr.guidesCard.className, 
            // eslint-disable-next-line no-nested-ternary
            variant === "orange"
                ? style_scss_1.default.orange
                : variant === "green"
                    ? style_scss_1.default.green
                    : style_scss_1.default.purple) }),
            react_1.default.createElement("div", __assign({}, ovr.guidesCardHeader),
                (0, getImage_1.default)(icon, "Guide card", "lazy"),
                react_1.default.createElement("p", __assign({}, ovr.guidesCardSubTitle), subtitle)),
            react_1.default.createElement("p", __assign({}, ovr.guidesCardTitle), title),
            react_1.default.createElement("p", __assign({}, ovr.guidesCardText), text))));
};
GuidesCard.displayName = componentName;
exports["default"] = GuidesCard;


/***/ }),

/***/ 49429:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* istanbul ignore file */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Modal = exports.GuidesCard = exports.LoadingIndicator = exports.ChatBubble = exports.LockedGraph = exports.StaticFooter = exports.Timer = exports.Checklist = exports.QuoteCard = exports.CircularProgressBar = exports.Accordion = exports.SimpleText = exports.Slideout = exports.Pagination = exports.Tabs = exports.CtaCard = exports.TextLink = exports.TrackerDots = exports.MortgageBlock = exports.Arrow = exports.Pill = exports.SpinnerWrapper = exports.Spinner = exports.FlexibleModalButton = exports.FlexibleModalPage = exports.FlexibleModal = exports.LoadingChecklist = exports.Loading = exports.Output = exports.ContentLoader = exports.CookieBanner = exports.CallToActionLink = exports.Error404Page = exports.Message = exports.Progress = exports.Avatars = exports.Menu = exports.ProfileMenu = exports.Title = exports.SubTitle = exports.Spacing = void 0;
var spacing_1 = __webpack_require__(15582);
Object.defineProperty(exports, "Spacing", ({ enumerable: true, get: function () { return __importDefault(spacing_1).default; } }));
__exportStar(__webpack_require__(15582), exports);
var subTitle_1 = __webpack_require__(4317);
Object.defineProperty(exports, "SubTitle", ({ enumerable: true, get: function () { return __importDefault(subTitle_1).default; } }));
__exportStar(__webpack_require__(4317), exports);
var title_1 = __webpack_require__(19938);
Object.defineProperty(exports, "Title", ({ enumerable: true, get: function () { return __importDefault(title_1).default; } }));
__exportStar(__webpack_require__(19938), exports);
var profileMenu_1 = __webpack_require__(83723);
Object.defineProperty(exports, "ProfileMenu", ({ enumerable: true, get: function () { return __importDefault(profileMenu_1).default; } }));
__exportStar(__webpack_require__(83723), exports);
var menu_1 = __webpack_require__(27930);
Object.defineProperty(exports, "Menu", ({ enumerable: true, get: function () { return __importDefault(menu_1).default; } }));
__exportStar(__webpack_require__(27930), exports);
var avatars_1 = __webpack_require__(88426);
Object.defineProperty(exports, "Avatars", ({ enumerable: true, get: function () { return __importDefault(avatars_1).default; } }));
__exportStar(__webpack_require__(88426), exports);
var progress_1 = __webpack_require__(23987);
Object.defineProperty(exports, "Progress", ({ enumerable: true, get: function () { return __importDefault(progress_1).default; } }));
__exportStar(__webpack_require__(23987), exports);
var message_1 = __webpack_require__(14552);
Object.defineProperty(exports, "Message", ({ enumerable: true, get: function () { return __importDefault(message_1).default; } }));
__exportStar(__webpack_require__(14552), exports);
var _404Page_1 = __webpack_require__(36085);
Object.defineProperty(exports, "Error404Page", ({ enumerable: true, get: function () { return __importDefault(_404Page_1).default; } }));
__exportStar(__webpack_require__(36085), exports);
var callToActionLink_1 = __webpack_require__(62950);
Object.defineProperty(exports, "CallToActionLink", ({ enumerable: true, get: function () { return __importDefault(callToActionLink_1).default; } }));
__exportStar(__webpack_require__(62950), exports);
var cookieBanner_1 = __webpack_require__(35913);
Object.defineProperty(exports, "CookieBanner", ({ enumerable: true, get: function () { return __importDefault(cookieBanner_1).default; } }));
var contentLoader_1 = __webpack_require__(178);
Object.defineProperty(exports, "ContentLoader", ({ enumerable: true, get: function () { return __importDefault(contentLoader_1).default; } }));
__exportStar(__webpack_require__(178), exports);
var output_1 = __webpack_require__(67942);
Object.defineProperty(exports, "Output", ({ enumerable: true, get: function () { return __importDefault(output_1).default; } }));
__exportStar(__webpack_require__(67942), exports);
var loading_1 = __webpack_require__(48993);
Object.defineProperty(exports, "Loading", ({ enumerable: true, get: function () { return __importDefault(loading_1).default; } }));
__exportStar(__webpack_require__(48993), exports);
var loadingChecklist_1 = __webpack_require__(35977);
Object.defineProperty(exports, "LoadingChecklist", ({ enumerable: true, get: function () { return __importDefault(loadingChecklist_1).default; } }));
__exportStar(__webpack_require__(35977), exports);
var flexibleModal_1 = __webpack_require__(27767);
Object.defineProperty(exports, "FlexibleModal", ({ enumerable: true, get: function () { return __importDefault(flexibleModal_1).default; } }));
__exportStar(__webpack_require__(27767), exports);
var flexibleModalPage_1 = __webpack_require__(47282);
Object.defineProperty(exports, "FlexibleModalPage", ({ enumerable: true, get: function () { return __importDefault(flexibleModalPage_1).default; } }));
__exportStar(__webpack_require__(47282), exports);
var flexibleModalButton_1 = __webpack_require__(70793);
Object.defineProperty(exports, "FlexibleModalButton", ({ enumerable: true, get: function () { return __importDefault(flexibleModalButton_1).default; } }));
__exportStar(__webpack_require__(70793), exports);
var Spinner_1 = __webpack_require__(88774);
Object.defineProperty(exports, "Spinner", ({ enumerable: true, get: function () { return __importDefault(Spinner_1).default; } }));
__exportStar(__webpack_require__(88774), exports);
var spinnerWrapper_1 = __webpack_require__(42907);
Object.defineProperty(exports, "SpinnerWrapper", ({ enumerable: true, get: function () { return __importDefault(spinnerWrapper_1).default; } }));
__exportStar(__webpack_require__(42907), exports);
var pill_1 = __webpack_require__(74747);
Object.defineProperty(exports, "Pill", ({ enumerable: true, get: function () { return __importDefault(pill_1).default; } }));
__exportStar(__webpack_require__(74747), exports);
var arrow_1 = __webpack_require__(44260);
Object.defineProperty(exports, "Arrow", ({ enumerable: true, get: function () { return __importDefault(arrow_1).default; } }));
__exportStar(__webpack_require__(44260), exports);
var mortgageBlock_1 = __webpack_require__(85106);
Object.defineProperty(exports, "MortgageBlock", ({ enumerable: true, get: function () { return mortgageBlock_1.MortgageBlock; } }));
var trackerDots_1 = __webpack_require__(47485);
Object.defineProperty(exports, "TrackerDots", ({ enumerable: true, get: function () { return __importDefault(trackerDots_1).default; } }));
__exportStar(__webpack_require__(47485), exports);
__exportStar(__webpack_require__(547), exports);
__exportStar(__webpack_require__(93158), exports);
__exportStar(__webpack_require__(56466), exports);
var textLink_1 = __webpack_require__(21773);
Object.defineProperty(exports, "TextLink", ({ enumerable: true, get: function () { return __importDefault(textLink_1).default; } }));
__exportStar(__webpack_require__(21773), exports);
var ctaCard_1 = __webpack_require__(86808);
Object.defineProperty(exports, "CtaCard", ({ enumerable: true, get: function () { return __importDefault(ctaCard_1).default; } }));
__exportStar(__webpack_require__(86808), exports);
var tabs_1 = __webpack_require__(65779);
Object.defineProperty(exports, "Tabs", ({ enumerable: true, get: function () { return __importDefault(tabs_1).default; } }));
__exportStar(__webpack_require__(65779), exports);
var pagination_1 = __webpack_require__(76657);
Object.defineProperty(exports, "Pagination", ({ enumerable: true, get: function () { return __importDefault(pagination_1).default; } }));
__exportStar(__webpack_require__(76657), exports);
var slideOut_1 = __webpack_require__(32564);
Object.defineProperty(exports, "Slideout", ({ enumerable: true, get: function () { return __importDefault(slideOut_1).default; } }));
var simpleText_1 = __webpack_require__(99277);
Object.defineProperty(exports, "SimpleText", ({ enumerable: true, get: function () { return __importDefault(simpleText_1).default; } }));
__exportStar(__webpack_require__(99277), exports);
var accordion_1 = __webpack_require__(71101);
Object.defineProperty(exports, "Accordion", ({ enumerable: true, get: function () { return __importDefault(accordion_1).default; } }));
__exportStar(__webpack_require__(71101), exports);
var circularProgressBar_1 = __webpack_require__(79581);
Object.defineProperty(exports, "CircularProgressBar", ({ enumerable: true, get: function () { return __importDefault(circularProgressBar_1).default; } }));
__exportStar(__webpack_require__(79581), exports);
var quoteCard_1 = __webpack_require__(71993);
Object.defineProperty(exports, "QuoteCard", ({ enumerable: true, get: function () { return __importDefault(quoteCard_1).default; } }));
__exportStar(__webpack_require__(71993), exports);
var checklist_1 = __webpack_require__(58487);
Object.defineProperty(exports, "Checklist", ({ enumerable: true, get: function () { return __importDefault(checklist_1).default; } }));
__exportStar(__webpack_require__(58487), exports);
var timer_1 = __webpack_require__(58656);
Object.defineProperty(exports, "Timer", ({ enumerable: true, get: function () { return __importDefault(timer_1).default; } }));
__exportStar(__webpack_require__(58656), exports);
var staticFooter_1 = __webpack_require__(77682);
Object.defineProperty(exports, "StaticFooter", ({ enumerable: true, get: function () { return __importDefault(staticFooter_1).default; } }));
__exportStar(__webpack_require__(77682), exports);
var lockedGraph_1 = __webpack_require__(45141);
Object.defineProperty(exports, "LockedGraph", ({ enumerable: true, get: function () { return __importDefault(lockedGraph_1).default; } }));
__exportStar(__webpack_require__(45141), exports);
var chatBubble_1 = __webpack_require__(81845);
Object.defineProperty(exports, "ChatBubble", ({ enumerable: true, get: function () { return __importDefault(chatBubble_1).default; } }));
__exportStar(__webpack_require__(81845), exports);
var loadingIndicator_1 = __webpack_require__(19801);
Object.defineProperty(exports, "LoadingIndicator", ({ enumerable: true, get: function () { return __importDefault(loadingIndicator_1).default; } }));
__exportStar(__webpack_require__(19801), exports);
var guidesCard_1 = __webpack_require__(38936);
Object.defineProperty(exports, "GuidesCard", ({ enumerable: true, get: function () { return __importDefault(guidesCard_1).default; } }));
__exportStar(__webpack_require__(38936), exports);
var modal_1 = __webpack_require__(47172);
Object.defineProperty(exports, "Modal", ({ enumerable: true, get: function () { return __importDefault(modal_1).default; } }));
__exportStar(__webpack_require__(47172), exports);


/***/ }),

/***/ 91248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Animation = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var isClientSideRendering_1 = __webpack_require__(11250);
var constants_1 = __webpack_require__(17825);
// Uploaded to our on S3 bucket to prevent someone changing the content of this library without our review
var LOTTIE_URL = "https://".concat(constants_1.CDN_DOMAIN, "/external-libraries/lottie/5.9.6/lottie.min.js");
var Animation = function (_a) {
    var prefix = _a.prefix, ovr = _a.ovr, animation = _a.animation;
    var animationRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(window.lottie !== undefined), scriptLoaded = _b[0], setScriptLoaded = _b[1];
    (0, react_1.useEffect)(function () {
        if (scriptLoaded) {
            if (animationRef.current) {
                window.lottie.loadAnimation({
                    container: animationRef.current,
                    renderer: "svg",
                    loop: true,
                    autoplay: true,
                    name: "".concat(prefix, "-loading-animation"),
                    path: animation
                });
            }
            // Prevent build errors on the server as we only need it on the front-end
        }
        else if ((0, isClientSideRendering_1.isClientSideRendering)()) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
            var scriptjs = __webpack_require__(26893);
            scriptjs.get(LOTTIE_URL, function () {
                setScriptLoaded(true);
            }); // This library is big - 68.4kb! So we want to lazy load it
        }
        return function () {
            if (scriptLoaded) {
                window.lottie.destroy("".concat(prefix, "-loading-animation"));
            }
        };
    }, [animationRef.current, scriptLoaded]);
    return (react_1.default.createElement("div", __assign({}, ovr.animationWrapper),
        react_1.default.createElement("div", __assign({}, ovr.animation, { ref: animationRef }))));
};
exports.Animation = Animation;


/***/ }),

/***/ 42361:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "Loading";
exports.elementIdentifiers = (0, shared_1.tuple)("outerContainer", "title", "animationWrapper", "animation", "firstLoading", "secondLoading", "thirdLoading", "fourthLoading", "loadingWrapper", "childrenWrapper");


/***/ }),

/***/ 48993:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(64122));
var __1 = __webpack_require__(49429);
var contentLoader_1 = __importDefault(__webpack_require__(178));
var Animation_1 = __webpack_require__(91248);
var constants_1 = __webpack_require__(42361);
var Loading = function (_a) {
    var children = _a.children, title = _a.title, animation = _a.animation, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "title", "animation", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var prefix = props.id || constants_1.componentName;
    return (react_1.default.createElement("div", __assign({}, ovr.outerContainer, props, { className: (0, classnames_1.default)(ovr.outerContainer.className, className), role: "region", "aria-labelledby": "".concat(prefix, "-title"), "aria-describedby": "".concat(prefix, "-message") }),
        title ? (react_1.default.createElement(__1.Title, __assign({ align: "center" }, ovr.title), title)) : null,
        animation ? (react_1.default.createElement(Animation_1.Animation, { ovr: ovr, prefix: prefix, animation: animation })) : null,
        children ? (react_1.default.createElement("div", __assign({}, ovr.childrenWrapper), children)) : (react_1.default.createElement("div", __assign({}, ovr.loadingWrapper),
            react_1.default.createElement(contentLoader_1.default, __assign({}, ovr.firstLoading)),
            react_1.default.createElement(contentLoader_1.default, __assign({}, ovr.secondLoading)),
            react_1.default.createElement(contentLoader_1.default, __assign({}, ovr.thirdLoading)),
            react_1.default.createElement(contentLoader_1.default, __assign({}, ovr.fourthLoading))))));
};
Loading.displayName = constants_1.componentName;
exports["default"] = Loading;


/***/ }),

/***/ 35977:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiersLoadingChecklist = exports.componentNameLoadingChecklist = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(21598));
var item_complete_react_svg_1 = __importDefault(__webpack_require__(23081));
var item_disabled_react_svg_1 = __importDefault(__webpack_require__(98164));
var classnames_1 = __importDefault(__webpack_require__(57485));
exports.componentNameLoadingChecklist = "LoadingChecklist";
exports.elementIdentifiersLoadingChecklist = (0, shared_1.tuple)("loadingChecklist", "iconWrapper", "verticalLineWrapper", "verticalLine", "itemWrapper");
var Item = function (_a) {
    var ovr = _a.ovr, _b = _a.delay, delay = _b === void 0 ? 0 : _b, text = _a.text, last = _a.last;
    var _c = (0, react_1.useState)(delay === 0), completed = _c[0], setCompleted = _c[1];
    setTimeout(function () {
        setCompleted(true);
    }, delay);
    return (react_1.default.createElement("div", __assign({}, ovr.itemWrapper),
        react_1.default.createElement("div", __assign({}, ovr.iconWrapper), completed ? react_1.default.createElement(item_complete_react_svg_1.default, null) : react_1.default.createElement(item_disabled_react_svg_1.default, null)),
        react_1.default.createElement("p", null, text),
        !last && (react_1.default.createElement("div", __assign({}, ovr.verticalLineWrapper),
            react_1.default.createElement("span", __assign({}, ovr.verticalLine))))));
};
var LoadingChecklist = function (_a) {
    var items = _a.items, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["items", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: exports.elementIdentifiersLoadingChecklist,
        componentName: exports.componentNameLoadingChecklist,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.loadingChecklist, props, { role: "region", className: (0, classnames_1.default)(ovr.loadingChecklist.className, className) }), items.map(function (item, i) { return (react_1.default.createElement(Item, __assign({ key: i, ovr: ovr, last: items.length - 1 === i }, item))); })));
};
LoadingChecklist.displayName = exports.componentNameLoadingChecklist;
exports["default"] = LoadingChecklist;


/***/ }),

/***/ 19801:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(34762));
var Spinner_1 = __importDefault(__webpack_require__(88774));
var componentName = "LoadingIndicator";
var elementIdentifiers = (0, shared_1.tuple)("loadingIndicator", "loadingIndicatorText");
var LoadingIndicator = function (_a) {
    var text = _a.text, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["text", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.loadingIndicator, props),
        react_1.default.createElement(Spinner_1.default, { size: 24, backgroundArcClassname: style_scss_1.default.backgroundArc, rotatingArcClassname: style_scss_1.default.rotatingArc }),
        react_1.default.createElement("span", __assign({}, ovr.loadingIndicatorText), text)));
};
LoadingIndicator.displayName = componentName;
exports["default"] = LoadingIndicator;


/***/ }),

/***/ 45141:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var styles_scss_1 = __importDefault(__webpack_require__(5424));
var padlock_react_svg_1 = __importDefault(__webpack_require__(30344));
var rates_chart_png_1 = __importDefault(__webpack_require__(70113));
var componentName = "LockedGraph";
var elementIdentifiers = (0, shared_1.tuple)("container", "chart", "padlockContainer", "text");
var LockedGraph = function (_a) {
    var _b = _a.text, text = _b === void 0 ? "Fill-in the input fields to see the result" : _b, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.container),
        react_1.default.createElement("img", __assign({}, ovr.chart, { loading: "lazy", src: rates_chart_png_1.default, alt: "Rates chart" })),
        react_1.default.createElement("div", __assign({}, ovr.padlockContainer),
            react_1.default.createElement(padlock_react_svg_1.default, null),
            react_1.default.createElement("p", __assign({}, ovr.text), text))));
};
LockedGraph.displayName = componentName;
exports["default"] = LockedGraph;


/***/ }),

/***/ 38218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MegaButton = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(29418));
var classnames_1 = __importDefault(__webpack_require__(57485));
var typography_1 = __webpack_require__(34237);
var shared_1 = __webpack_require__(89574);
var componentName = "MegaButton";
var elementIdentifiers = (0, shared_1.tuple)("button", "container", "typography", "arrowBox", "arrow");
exports.MegaButton = react_1.default.forwardRef(function (_a, ref) {
    var text = _a.text, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["text", "variant", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, ovr.button, { ref: ref, className: (0, classnames_1.default)(style_scss_1.default.button, variant === "primary" ? style_scss_1.default.primary : style_scss_1.default.secondary, ovr.button.className) }, props, { type: "button" }),
        react_1.default.createElement("div", __assign({}, ovr.container),
            react_1.default.createElement(typography_1.Typography, __assign({ variant: "h2", classes: (0, classnames_1.default)(style_scss_1.default.typography, ovr.typography.className) }, ovr.typography), text),
            react_1.default.createElement("div", __assign({}, ovr.arrowBox),
                react_1.default.createElement("div", __assign({}, ovr.arrow))))));
});
exports.MegaButton.displayName = componentName;


/***/ }),

/***/ 547:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(38218), exports);


/***/ }),

/***/ 27930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var use_onclickoutside_1 = __importDefault(__webpack_require__(37251));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(46132));
var componentName = "Menu";
var elementIdentifiers = (0, shared_1.tuple)("menu", "menuOptions", "menuItemButton", "menuButton");
var DefaultLink = function (_a) {
    var children = _a.children, href = _a.href;
    return (react_1.default.createElement("a", { href: href, className: style_scss_1.default.defaultLink }, children || null));
};
var Menu = function (_a) {
    var _b, _c;
    var LinkComponent = _a.LinkComponent, links = _a.links, onOpenToggle = _a.onOpenToggle, button = _a.button, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["LinkComponent", "links", "onOpenToggle", "button", "className", "classOverrides", "testIds", "refs"]);
    var menuRef = (0, react_1.useRef)();
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: __assign({ menu: menuRef }, refs),
        stylesheet: style_scss_1.default
    });
    var _d = (0, react_1.useState)(false), isOpen = _d[0], setIsOpen = _d[1];
    var Link = LinkComponent || DefaultLink;
    // Should always be true
    if (ovr.menu.ref) {
        (0, use_onclickoutside_1.default)(ovr.menu.ref, function () {
            if (isOpen) {
                setIsOpen(false);
                if (onOpenToggle) {
                    onOpenToggle(false);
                }
            }
        });
    }
    var toggle = function () {
        setIsOpen(!isOpen);
        if (onOpenToggle) {
            onOpenToggle(!isOpen);
        }
    };
    return (react_1.default.createElement("div", __assign({}, ovr.menu, props, { "aria-haspopup": "true", "aria-label": "Menu", className: (0, classnames_1.default)(ovr.menu.className, className, (_b = {}, _b[style_scss_1.default.menuOpen] = isOpen, _b)) }),
        react_1.default.createElement("div", { className: style_scss_1.default.menuChildren }, button({
            isMenuOpen: isOpen,
            buttonProps: __assign({ "aria-expanded": isOpen, onClick: toggle }, ovr.menuButton)
        })),
        react_1.default.createElement("div", { className: style_scss_1.default.menuOptionsWrapper },
            react_1.default.createElement("div", __assign({}, ovr.menuOptions, { role: "group", "aria-label": "Menu Options", className: (0, classnames_1.default)((_c = {},
                    _c[style_scss_1.default.open] = isOpen,
                    _c[style_scss_1.default.closed] = !isOpen,
                    _c), ovr.menuOptions.className) }), links.map(function (_a, idx) {
                var description = _a.description, href = _a.href, onClick = _a.onClick, testId = _a.testId;
                var suffix = testId || idx;
                var onMenuItemClick = function (e) {
                    toggle();
                    if (onClick) {
                        onClick(e);
                    }
                };
                return (react_1.default.createElement(Link, { href: href, key: description },
                    react_1.default.createElement("button", __assign({}, ovr.menuItemButton, { type: "button", onClick: onMenuItemClick, "data-testid": "".concat(ovr.menuOptions["data-testid"], "-").concat(suffix) }), description)));
            })))));
};
Menu.displayName = componentName;
exports["default"] = Menu;


/***/ }),

/***/ 50986:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "Message";
exports.elementIdentifiers = (0, shared_1.tuple)("message", "icon");


/***/ }),

/***/ 14552:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(30931));
var circle_cross_react_svg_1 = __importDefault(__webpack_require__(67297));
var triangle_exclamation_react_svg_1 = __importDefault(__webpack_require__(14332));
var circle_tick_react_svg_1 = __importDefault(__webpack_require__(57876));
var circle_exclamation_react_svg_1 = __importDefault(__webpack_require__(9168));
var checkmark_react_svg_1 = __importDefault(__webpack_require__(55065));
var constants_1 = __webpack_require__(50986);
var messageTypeToIcon = (_a = {},
    _a[shared_1.MessageType.ERROR] = circle_cross_react_svg_1.default,
    _a[shared_1.MessageType.WARNING] = triangle_exclamation_react_svg_1.default,
    _a[shared_1.MessageType.SUCCESS] = circle_tick_react_svg_1.default,
    _a[shared_1.MessageType.INFORMATION] = circle_exclamation_react_svg_1.default,
    _a[shared_1.MessageType.PENDING] = checkmark_react_svg_1.default,
    _a);
var Message = function (_a) {
    var _b;
    var children = _a.children, _c = _a.type, type = _c === void 0 ? shared_1.MessageType.ERROR : _c, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "type", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var Icon = messageTypeToIcon[type];
    return (react_1.default.createElement("div", __assign({}, ovr.message, props, { className: (0, classnames_1.default)((_b = {},
            _b[style_scss_1.default.error] = type === shared_1.MessageType.ERROR,
            _b[style_scss_1.default.warning] = type === shared_1.MessageType.WARNING,
            _b[style_scss_1.default.success] = type === shared_1.MessageType.SUCCESS,
            _b[style_scss_1.default.information] = type === shared_1.MessageType.INFORMATION,
            _b[style_scss_1.default.pending] = type === shared_1.MessageType.PENDING,
            _b), ovr.message.className, className) }),
        react_1.default.createElement("div", __assign({}, ovr.icon),
            react_1.default.createElement(Icon, null)),
        children));
};
Message.displayName = constants_1.componentName;
exports["default"] = Message;


/***/ }),

/***/ 34737:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "FlexibleModal";
exports.elementIdentifiers = (0, shared_1.tuple)("overlay", "modal", "closeButton", "pageContainer");


/***/ }),

/***/ 47172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var keycodes_1 = __webpack_require__(52394);
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(13288));
var constants_1 = __webpack_require__(34737);
var subtleButton_1 = __importDefault(__webpack_require__(74500));
var close_cross_react_svg_1 = __importDefault(__webpack_require__(98502));
var allowOverflow = function () {
    document.body.style.overflow = "auto";
};
var Modal = function (_a) {
    var id = _a.id, className = _a.className, children = _a.children, onClose = _a.onClose, isOpen = _a.isOpen, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, _b = _a.showCloseButton, showCloseButton = _b === void 0 ? true : _b;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var close = function () {
        onClose();
    };
    var closeButtonRef = (0, react_1.useMemo)(function () { return (refs && refs.closeButton ? refs.closeButton : (0, react_1.createRef)()); }, [refs]);
    (0, react_1.useEffect)(function () {
        if (isOpen && closeButtonRef.current) {
            closeButtonRef.current.focus();
        }
        if (isOpen) {
            document.body.style.overflow = "hidden";
        }
        else {
            allowOverflow();
        }
        return function () { return allowOverflow(); };
    }, [isOpen, closeButtonRef.current]);
    // Close when pressing Escape
    var onKeyUp = function (_a) {
        var keyCode = _a.keyCode;
        if (keyCode === keycodes_1.ESCAPE) {
            close();
        }
    };
    if (!isOpen) {
        return null;
    }
    var stopPropagatingEvent = function (event) {
        event.stopPropagation();
    };
    return (react_1.default.createElement("div", __assign({}, ovr.overlay, { onClick: close, onKeyUp: onKeyUp, role: "dialog", "aria-label": "Overlay dialog" }),
        react_1.default.createElement("div", __assign({}, ovr.modal, { id: id, role: "dialog", "aria-label": "Dialog", className: (0, classnames_1.default)(ovr.modal.className, className), onClick: stopPropagatingEvent, onKeyUp: onKeyUp }),
            showCloseButton && (react_1.default.createElement(subtleButton_1.default, __assign({}, ovr.closeButton, { "aria-label": "close", refs: { subtleButton: closeButtonRef }, onClick: close }),
                react_1.default.createElement(close_cross_react_svg_1.default, null))),
            children)));
};
Modal.displayName = constants_1.componentName;
exports["default"] = Modal;


/***/ }),

/***/ 85106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MortgageBlock = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var button_1 = __importDefault(__webpack_require__(47426));
var types_1 = __webpack_require__(6343);
var typography_1 = __webpack_require__(34237);
var tuple_1 = __webpack_require__(40697);
var useOverrides_1 = __webpack_require__(62465);
var styles_scss_1 = __importDefault(__webpack_require__(59990));
var getImage_1 = __importDefault(__webpack_require__(1308));
var elementIdentifiers = (0, tuple_1.tuple)("title", "subtitle", "description", "button", "outerContainer");
var MortgageBlock = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, description = _a.description, image = _a.image, cta = _a.cta, testIds = _a.testIds, classOverrides = _a.classOverrides, refs = _a.refs, props = __rest(_a, ["title", "subtitle", "description", "image", "cta", "testIds", "classOverrides", "refs"]);
    var ovr = (0, useOverrides_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: "MortgageBlock",
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.outerContainer),
        react_1.default.createElement(typography_1.Typography, { variant: "h2", classes: (0, classnames_1.default)(styles_scss_1.default.title, ovr.title.className), testId: "mortgageBlock-title".concat(ovr.title["data-test-id"] ? "-".concat(ovr.title["data-test-id"]) : "") }, title),
        subtitle && (react_1.default.createElement(typography_1.Typography, { variant: "h3", classes: (0, classnames_1.default)(styles_scss_1.default.subtitle, ovr.subtitle.className), testId: "mortgageBlock-subtitle".concat(ovr.subtitle["data-test-id"]
                ? "-".concat(ovr.subtitle["data-test-id"])
                : "") }, subtitle)),
        react_1.default.createElement(typography_1.Typography, { variant: "h6", component: "div", classes: (0, classnames_1.default)(styles_scss_1.default.desc, ovr.description.className), testId: "mortgageBlock-description".concat(ovr.description["data-test-id"]
                ? "-".concat(ovr.description["data-test-id"])
                : "") }, description),
        (0, getImage_1.default)(image, "Mortgage block", "lazy"),
        cta && (react_1.default.createElement(button_1.default, { type: "button", colour: cta.colour || types_1.ButtonColour.Primary, size: types_1.ButtonSize.Medium, onClick: cta.onClick, classOverrides: { button: ovr.button.className } }, cta.text))));
};
exports.MortgageBlock = MortgageBlock;


/***/ }),

/***/ 90050:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "Output";
exports.elementIdentifiers = (0, shared_1.tuple)("outerContainer", "content", "shadow");


/***/ }),

/***/ 67942:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(21984));
var constants_1 = __webpack_require__(90050);
var Output = function (_a) {
    var children = _a.children, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.outerContainer, props, { className: (0, classnames_1.default)(ovr.outerContainer.className, className) }),
        react_1.default.createElement("div", __assign({}, ovr.content), children),
        react_1.default.createElement("div", __assign({}, ovr.shadow))));
};
Output.displayName = constants_1.componentName;
exports["default"] = Output;


/***/ }),

/***/ 76657:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(37081));
var form_1 = __webpack_require__(13174);
var arrow_left_24px_react_svg_1 = __importDefault(__webpack_require__(55982));
var arrow_right_24px_react_svg_1 = __importDefault(__webpack_require__(48854));
var componentName = "Pagination";
var elementIdentifiers = (0, shared_1.tuple)("container", "previousButton", "nextButton");
var Pagination = function (_a) {
    var _b, _c, _d;
    var id = _a.id, currentPage = _a.currentPage, numberOfPages = _a.numberOfPages, onPreviousClick = _a.onPreviousClick, onNextClick = _a.onNextClick, betterV2 = _a.betterV2, classOverrides = _a.classOverrides, className = _a.className, testIds = _a.testIds, refs = _a.refs, rest = __rest(_a, ["id", "currentPage", "numberOfPages", "onPreviousClick", "onNextClick", "betterV2", "classOverrides", "className", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.container, rest, { className: (0, classnames_1.default)(ovr.container.className, className) }),
        react_1.default.createElement(form_1.Button, __assign({}, ovr.previousButton, { fixed: false, size: shared_1.ButtonSize.Small, colour: shared_1.ButtonColour.Ghost, className: (0, classnames_1.default)(ovr.previousButton.className, (_b = {},
                _b[style_scss_1.default.hidden] = currentPage <= 1,
                _b)), onClick: onPreviousClick }),
            react_1.default.createElement(arrow_left_24px_react_svg_1.default, null),
            react_1.default.createElement("span", { className: style_scss_1.default.buttonText }, "Previous")),
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: (0, classnames_1.default)(style_scss_1.default.currentPage, (_c = {}, _c[style_scss_1.default.betterV2] = betterV2, _c)) }, currentPage),
            "\u00A0 of \u00A0",
            react_1.default.createElement("span", null, numberOfPages)),
        react_1.default.createElement(form_1.Button, __assign({}, ovr.nextButton, { fixed: false, size: shared_1.ButtonSize.Small, colour: shared_1.ButtonColour.Ghost, className: (0, classnames_1.default)(ovr.nextButton.className, (_d = {},
                _d[style_scss_1.default.hidden] = currentPage >= numberOfPages,
                _d)), onClick: onNextClick }),
            react_1.default.createElement("span", { className: style_scss_1.default.buttonText }, "Next"),
            react_1.default.createElement(arrow_right_24px_react_svg_1.default, null))));
};
Pagination.displayName = componentName;
exports["default"] = Pagination;


/***/ }),

/***/ 74747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PillColours = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var overrides_1 = __webpack_require__(46235);
var warning_react_svg_1 = __importDefault(__webpack_require__(89091));
var style_scss_1 = __importDefault(__webpack_require__(23302));
var componentName = "Pill";
var elementIdentifiers = (0, overrides_1.tuple)("pill");
var PillColours;
(function (PillColours) {
    PillColours["Primary"] = "primary";
    PillColours["Secondary"] = "secondary";
    PillColours["Disabled"] = "disabled";
    PillColours["Informative"] = "informative";
    PillColours["Warning"] = "warning";
})(PillColours = exports.PillColours || (exports.PillColours = {}));
var Pill = function (_a) {
    var _b;
    var children = _a.children, _c = _a.colour, colour = _c === void 0 ? PillColours.Primary : _c, _d = _a.inline, inline = _d === void 0 ? true : _d, _e = _a.ignoreIcon, ignoreIcon = _e === void 0 ? false : _e, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "colour", "inline", "ignoreIcon", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, overrides_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var attributes = __assign(__assign(__assign({}, ovr.pill), props), { className: (0, classnames_1.default)((_b = {},
            _b[style_scss_1.default.primary] = colour === PillColours.Primary,
            _b[style_scss_1.default.secondary] = colour === PillColours.Secondary,
            _b[style_scss_1.default.informative] = colour === PillColours.Informative,
            _b[style_scss_1.default.disabled] = colour === PillColours.Disabled,
            _b[style_scss_1.default.warning] = colour === PillColours.Warning,
            _b), ovr.pill.className, className) });
    var inlinedPill = (react_1.default.createElement("span", __assign({}, attributes),
        colour === PillColours.Warning && react_1.default.createElement(warning_react_svg_1.default, null),
        children));
    return inline ? (react_1.default.createElement("span", __assign({}, attributes),
        colour === PillColours.Warning && !ignoreIcon && react_1.default.createElement(warning_react_svg_1.default, null),
        children)) : (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.clearInlineWhitespaceWrapper) }, inlinedPill));
};
Pill.displayName = componentName;
exports["default"] = Pill;


/***/ }),

/***/ 83723:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var menu_1 = __importDefault(__webpack_require__(27930));
var style_scss_1 = __importDefault(__webpack_require__(48226));
var avatar_react_svg_1 = __importDefault(__webpack_require__(63327));
var avatar_x2_png_1 = __importDefault(__webpack_require__(64356));
var avatar_png_1 = __importDefault(__webpack_require__(6016));
var unknownProfile_react_svg_1 = __importDefault(__webpack_require__(20099));
var chevron_down_react_svg_1 = __importDefault(__webpack_require__(42582));
var chevron_up_react_svg_1 = __importDefault(__webpack_require__(34565));
var classnames_1 = __importDefault(__webpack_require__(57485));
var theme_1 = __webpack_require__(79090);
var componentName = "ProfileMenu";
var elementIdentifiers = (0, shared_1.tuple)("menu", "menuOptions", "menuButton", "illustrationIcon", "unknownProfileIcon", "name", "chevron");
var ProfileMenu = function (_a) {
    var LinkComponent = _a.LinkComponent, name = _a.name, customGreetingText = _a.customGreetingText, links = _a.links, icon = _a.icon, onOpenToggle = _a.onOpenToggle, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["LinkComponent", "name", "customGreetingText", "links", "icon", "onOpenToggle", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var theme = (0, theme_1.useTheme)();
    return (react_1.default.createElement(menu_1.default, { LinkComponent: LinkComponent, links: links, onOpenToggle: onOpenToggle, className: className, classOverrides: classOverrides, testIds: testIds, refs: refs, button: function (_a) {
            var isMenuOpen = _a.isMenuOpen, buttonProps = _a.buttonProps;
            return (react_1.default.createElement("button", __assign({}, buttonProps, { className: (0, classnames_1.default)(style_scss_1.default.profileMenu, buttonProps.className) }),
                icon === "illustration" ? (react_1.default.createElement("span", __assign({}, ovr.illustrationIcon), theme === theme_1.Themes.TRUSSLE_V3 ? (react_1.default.createElement("picture", null,
                    react_1.default.createElement("source", { media: "(max-width:640px)", srcSet: avatar_png_1.default }),
                    react_1.default.createElement("img", { src: avatar_x2_png_1.default, alt: "avatar" }))) : (react_1.default.createElement(avatar_react_svg_1.default, null)))) : (react_1.default.createElement("span", __assign({}, ovr.unknownProfileIcon),
                    react_1.default.createElement(unknownProfile_react_svg_1.default, null))),
                react_1.default.createElement("span", __assign({}, ovr.name), customGreetingText ? (customGreetingText) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: style_scss_1.default.desktop }, "Hello"),
                    react_1.default.createElement("span", { className: style_scss_1.default.mobile }, "Hi"),
                    " ",
                    name))),
                react_1.default.createElement("span", __assign({}, ovr.chevron), isMenuOpen ? react_1.default.createElement(chevron_up_react_svg_1.default, null) : react_1.default.createElement(chevron_down_react_svg_1.default, null))));
        } }));
};
ProfileMenu.displayName = componentName;
exports["default"] = ProfileMenu;


/***/ }),

/***/ 23987:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(85949));
var componentName = "Progress";
var elementIdentifiers = (0, shared_1.tuple)("progress");
var DEFAULT_MAX = 100;
var Progress = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? DEFAULT_MAX : _c, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["value", "max", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("progress", __assign({}, ovr.progress, props, { className: (0, classnames_1.default)(ovr.progress.className, className), max: max, value: value })));
};
Progress.displayName = componentName;
exports["default"] = Progress;


/***/ }),

/***/ 71993:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(50578));
var quote_react_svg_1 = __importDefault(__webpack_require__(75216));
var componentName = "QuoteCard";
var elementIdentifiers = (0, shared_1.tuple)("card", "authorLineContainer", "title", "iconContainer", "text");
var QuoteCard = function (_a) {
    var title = _a.title, text = _a.text, image = _a.image, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["title", "text", "image", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, props, ovr.card),
        react_1.default.createElement("div", __assign({}, ovr.authorLineContainer),
            image,
            react_1.default.createElement("div", __assign({}, ovr.title), title),
            react_1.default.createElement("div", __assign({}, ovr.iconContainer),
                react_1.default.createElement(quote_react_svg_1.default, null))),
        react_1.default.createElement("p", __assign({}, ovr.text), text)));
};
QuoteCard.displayName = componentName;
exports["default"] = QuoteCard;


/***/ }),

/***/ 99277:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(10945));
var componentName = "SimpleText";
var elementIdentifiers = (0, shared_1.tuple)("simpleText", "heading", "body", "footer");
var SimpleText = function (_a) {
    var classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, headingLevel = _a.headingLevel, heading = _a.heading, body = _a.body, footer = _a.footer, props = __rest(_a, ["classOverrides", "testIds", "refs", "headingLevel", "heading", "body", "footer"]);
    var Heading = headingLevel;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, props, ovr.simpleText),
        react_1.default.createElement(Heading, __assign({}, ovr.heading), heading),
        react_1.default.createElement("p", __assign({}, ovr.body), body),
        footer ? (react_1.default.createElement("div", __assign({}, ovr.footer),
            react_1.default.createElement("span", null, footer.left),
            react_1.default.createElement("span", null, footer ? footer.right : null))) : null));
};
exports["default"] = SimpleText;


/***/ }),

/***/ 32564:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(19272));
var shared_1 = __webpack_require__(89574);
var classnames_1 = __importDefault(__webpack_require__(57485));
var keyboard_arrow_down_24px_react_svg_1 = __importDefault(__webpack_require__(30692));
var filter_list_react_svg_1 = __importDefault(__webpack_require__(9526));
var close_small_react_svg_1 = __importDefault(__webpack_require__(61148));
var componentName = "SlideOut";
exports.elementIdentifiers = (0, shared_1.tuple)("slideout", "header", "wrapper");
var SlideOut = function (_a) {
    var _b, _c;
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, title = _a.title, _d = _a.variant, variant = _d === void 0 ? "primary" : _d, icon = _a.icon, refs = _a.refs, children = _a.children, onToggle = _a.onToggle, childrenWithToggle = _a.childrenWithToggle, props = __rest(_a, ["className", "classOverrides", "testIds", "title", "variant", "icon", "refs", "children", "onToggle", "childrenWithToggle"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: exports.elementIdentifiers,
        componentName: componentName,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _e = (0, react_1.useState)(true), hidden = _e[0], setHidden = _e[1];
    var wrapperRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!hidden) {
            document.body.classList.add(style_scss_1.default.modalOpen);
        }
        else {
            document.body.classList.remove(style_scss_1.default.modalOpen);
        }
    }, [hidden]);
    var handleHideSlideOut = function () {
        var newHidden = !hidden;
        if (onToggle) {
            onToggle(newHidden);
        }
        setHidden(newHidden);
        if (wrapperRef.current) {
            wrapperRef.current.scrollTop = 0;
        }
    };
    // eslint-disable-next-line no-nested-ternary
    var Icon = icon ? icon : variant === "primary" ? keyboard_arrow_down_24px_react_svg_1.default : filter_list_react_svg_1.default;
    return (react_1.default.createElement("div", __assign({}, ovr.wrapper, { ref: wrapperRef, className: (0, classnames_1.default)(hidden ? style_scss_1.default.hidden : "", ovr.wrapper.className) }),
        react_1.default.createElement("div", __assign({}, ovr.slideout, props, { className: (0, classnames_1.default)(ovr.slideout.className, className, (_b = {},
                _b[style_scss_1.default.secondary] = variant === "secondary",
                _b)) }),
            react_1.default.createElement("button", __assign({}, ovr.header, { className: (0, classnames_1.default)(ovr.header.className, (_c = {},
                    _c[style_scss_1.default.secondaryHeader] = variant === "secondary",
                    _c)), onClick: handleHideSlideOut }),
                variant === "secondary" && (react_1.default.createElement("div", { className: style_scss_1.default.closeButton },
                    react_1.default.createElement(close_small_react_svg_1.default, null))),
                react_1.default.createElement("h1", null, title),
                react_1.default.createElement(Icon, null)),
            react_1.default.createElement("div", { className: style_scss_1.default.slideoutContent },
                children && children,
                childrenWithToggle && childrenWithToggle(handleHideSlideOut)))));
};
exports["default"] = SlideOut;


/***/ }),

/***/ 15582:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(74777));
var componentName = "Spacing";
var elementIdentifiers = (0, shared_1.tuple)("spacing");
var Spacing = function (_a) {
    var _b;
    var marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["marginTop", "marginRight", "marginBottom", "marginLeft", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.spacing, { role: "presentation" }, props, { className: (0, classnames_1.default)((_b = {},
            _b[style_scss_1.default["mt".concat(marginTop)]] = Boolean(marginTop),
            _b[style_scss_1.default["mr".concat(marginRight)]] = Boolean(marginRight),
            _b[style_scss_1.default["mb".concat(marginBottom)]] = Boolean(marginBottom),
            _b[style_scss_1.default["ml".concat(marginLeft)]] = Boolean(marginLeft),
            _b), ovr.spacing.className, className) })));
};
Spacing.displayName = componentName;
exports["default"] = Spacing;


/***/ }),

/***/ 88774:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-use-before-define */
var react_1 = __importDefault(__webpack_require__(99497));
var Spinner_scss_1 = __importDefault(__webpack_require__(7662));
var classnames_1 = __importDefault(__webpack_require__(57485));
var strokeWidth = 6;
var R = 50;
var SAR = R - strokeWidth; // Stroke adjusted radius
var circumference = (Math.PI * 2 * SAR).toFixed(2);
var DEFAULT_SIZE = 30;
var Spinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? DEFAULT_SIZE : _b, backgroundArcClassname = _a.backgroundArcClassname, rotatingArcClassname = _a.rotatingArcClassname, props = __rest(_a, ["size", "backgroundArcClassname", "rotatingArcClassname"]);
    return (react_1.default.createElement("svg", __assign({ width: size, height: size, strokeWidth: strokeWidth.toFixed(2), viewBox: "-".concat(R, " -").concat(R, " ").concat(R * 2, " ").concat(R * 2), fill: "none", "aria-label": "Loading icon" }, props),
        react_1.default.createElement("circle", { cx: "0", cy: "0", r: SAR, fill: "none", className: (0, classnames_1.default)(Spinner_scss_1.default.backgroundArc, backgroundArcClassname) }),
        react_1.default.createElement("circle", { strokeDasharray: circumference, strokeDashoffset: 75, className: (0, classnames_1.default)(Spinner_scss_1.default.rotatingArc, rotatingArcClassname), cx: "0", cy: "0", r: SAR })));
};
exports["default"] = Spinner;


/***/ }),

/***/ 42907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var Spinner_1 = __importDefault(__webpack_require__(88774));
var classnames_1 = __importDefault(__webpack_require__(57485));
var index_scss_1 = __importDefault(__webpack_require__(67715));
var Index = function (_a) {
    var _b, _c;
    var children = _a.children, showSpinner = _a.showSpinner, props = __rest(_a, ["children", "showSpinner"]);
    return (react_1.default.createElement("div", { className: index_scss_1.default.spinnerWrapper },
        react_1.default.createElement(Spinner_1.default, __assign({}, props, { className: (0, classnames_1.default)(props.className, index_scss_1.default.spinner, (_b = {},
                _b[index_scss_1.default.hasDisplayNone] = !showSpinner,
                _b)) })),
        react_1.default.createElement("div", { className: (0, classnames_1.default)((_c = {}, _c[index_scss_1.default.hasVisibilityHidden] = showSpinner, _c)) }, children)));
};
exports["default"] = Index;


/***/ }),

/***/ 77682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(32866));
var classnames_1 = __importDefault(__webpack_require__(57485));
var button_1 = __importDefault(__webpack_require__(47426));
var componentName = "StaticFooter";
var elementIdentifiers = (0, shared_1.tuple)("staticFooter", "button");
var StaticFooter = function (_a) {
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, buttonTitle = _a.buttonTitle, clickHandler = _a.clickHandler, refs = _a.refs, props = __rest(_a, ["className", "classOverrides", "testIds", "buttonTitle", "clickHandler", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.staticFooter, props, { className: (0, classnames_1.default)(ovr.staticFooter.className, className) }),
        react_1.default.createElement(button_1.default, __assign({}, ovr.button, { size: shared_1.ButtonSize.Small, onClick: clickHandler }), buttonTitle)));
};
exports["default"] = StaticFooter;


/***/ }),

/***/ 4317:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(66172));
var componentName = "SubTitle";
var elementIdentifiers = (0, shared_1.tuple)("subtitle");
var SubTitle = function (_a) {
    var _b;
    var children = _a.children, _c = _a.align, align = _c === void 0 ? shared_1.Alignment.LEFT : _c, _d = _a.weight, weight = _d === void 0 ? shared_1.FontWeight.BOLD : _d, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "align", "weight", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("h2", __assign({}, ovr.subtitle, props, { className: (0, classnames_1.default)((_b = {},
            _b[style_scss_1.default.alignLeft] = align === shared_1.Alignment.LEFT,
            _b[style_scss_1.default.alignCenter] = align === shared_1.Alignment.CENTER,
            _b[style_scss_1.default.fontWeightRegular] = weight === shared_1.FontWeight.REGULAR,
            _b[style_scss_1.default.fontWeightSemiBold] = weight === shared_1.FontWeight.SEMI_BOLD,
            _b[style_scss_1.default.fontWeightBold] = weight === shared_1.FontWeight.BOLD,
            _b), ovr.subtitle.className, className) }), children));
};
SubTitle.displayName = componentName;
exports["default"] = SubTitle;


/***/ }),

/***/ 65779:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var classnames_1 = __importDefault(__webpack_require__(57485));
var style_scss_1 = __importDefault(__webpack_require__(4295));
var componentName = "Tabs";
var elementIdentifiers = (0, shared_1.tuple)("container", "tab");
var Tabs = function (_a) {
    var id = _a.id, tabs = _a.tabs, onTabClick = _a.onTabClick, _b = _a.betterV2, betterV2 = _b === void 0 ? false : _b, classOverrides = _a.classOverrides, className = _a.className, testIds = _a.testIds, refs = _a.refs, rest = __rest(_a, ["id", "tabs", "onTabClick", "betterV2", "classOverrides", "className", "testIds", "refs"]);
    var _c = (0, react_1.useState)(tabs[0]), activeTab = _c[0], setIsActiveTab = _c[1];
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var onTabClickHandler = function (tabName) {
        return function () {
            setIsActiveTab(tabName);
            onTabClick(tabName);
        };
    };
    return (react_1.default.createElement("div", __assign({}, ovr.container, rest, { className: (0, classnames_1.default)(ovr.container.className, className) }), tabs.map(function (tabName) {
        var _a;
        return (react_1.default.createElement("button", __assign({}, ovr.tab, { key: tabName, onClick: onTabClickHandler(tabName), className: (0, classnames_1.default)(ovr.tab.className, (_a = {},
                _a[style_scss_1.default.tabActive] = activeTab === tabName,
                _a[style_scss_1.default.betterV2] = betterV2,
                _a)) }), tabName));
    })));
};
Tabs.displayName = componentName;
exports["default"] = Tabs;


/***/ }),

/***/ 20017:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "TextLink";
exports.elementIdentifiers = (0, shared_1.tuple)("anchor", "icon", "text");


/***/ }),

/***/ 21773:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextLinkTheme = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var classnames_1 = __importDefault(__webpack_require__(57485));
var style_scss_1 = __importDefault(__webpack_require__(62481));
var constants_1 = __webpack_require__(20017);
var TextLinkTheme;
(function (TextLinkTheme) {
    TextLinkTheme["LIGHT"] = "light";
    TextLinkTheme["DARK"] = "dark";
    TextLinkTheme["SECONDARY"] = "secondary";
    TextLinkTheme["SECONDARY_DARK"] = "secondary-dark";
})(TextLinkTheme = exports.TextLinkTheme || (exports.TextLinkTheme = {}));
var TextLink = function (_a) {
    var _b, _c;
    var _d = _a.theme, theme = _d === void 0 ? TextLinkTheme.DARK : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.underlined, underlined = _f === void 0 ? false : _f, Icon = _a.icon, children = _a.children, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["theme", "disabled", "underlined", "icon", "children", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("a", __assign({}, ovr.anchor, props, { className: (0, classnames_1.default)(style_scss_1.default.textLink, style_scss_1.default["".concat(theme)], (_b = {}, _b[style_scss_1.default["".concat(theme, "-disabled")]] = disabled, _b), className) }),
        react_1.default.createElement("span", __assign({}, ovr.text, { className: (0, classnames_1.default)(style_scss_1.default.text, (_c = {}, _c[style_scss_1.default.underlined] = underlined, _c)) }), children),
        Icon && react_1.default.createElement(Icon, __assign({}, ovr.icon, { className: style_scss_1.default.icon }))));
};
TextLink.displayName = constants_1.componentName;
exports["default"] = TextLink;


/***/ }),

/***/ 58656:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(49604));
var clock_react_svg_1 = __importDefault(__webpack_require__(27497));
var componentName = "Timer";
var elementIdentifiers = (0, shared_1.tuple)("timer", "timerText", "time");
var Timer = function (_a) {
    var time = _a.time, onReset = _a.onReset, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["time", "onReset", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _b = (0, react_1.useState)(0), hours = _b[0], setHours = _b[1];
    var _c = (0, react_1.useState)(0), minutes = _c[0], setMinutes = _c[1];
    var _d = (0, react_1.useState)(0), seconds = _d[0], setSeconds = _d[1];
    var getTime = function (deadline) {
        var total = Date.parse(deadline) - Date.now();
        if (total < 0) {
            if (onReset) {
                onReset();
            }
        }
        else {
            setHours(Math.floor(total / (1000 * 60 * 60)));
            setMinutes(Math.floor((total / 1000 / 60) % 60));
            setSeconds(Math.floor((total / 1000) % 60));
        }
    };
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () { return getTime(time); }, 1000);
        return function () { return clearInterval(interval); };
    }, []);
    return (react_1.default.createElement("div", __assign({}, ovr.timer, props),
        react_1.default.createElement("div", { className: "timer__icon" },
            react_1.default.createElement(clock_react_svg_1.default, null)),
        react_1.default.createElement("div", { className: "timer__timeContainer" },
            react_1.default.createElement("p", __assign({}, ovr.timerText), "Will be recalculated automatically in"),
            react_1.default.createElement("time", __assign({}, ovr.time),
                hours < 10 ? "0".concat(hours) : hours,
                ":",
                minutes < 10 ? "0".concat(minutes) : minutes,
                ":",
                seconds < 10 ? "0".concat(seconds) : seconds))));
};
Timer.displayName = componentName;
exports["default"] = Timer;


/***/ }),

/***/ 19938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(12928));
var componentName = "Title";
var elementIdentifiers = (0, shared_1.tuple)("title");
var Title = function (_a) {
    var _b;
    var children = _a.children, _c = _a.align, align = _c === void 0 ? shared_1.Alignment.LEFT : _c, _d = _a.weight, weight = _d === void 0 ? shared_1.FontWeight.BOLD : _d, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "align", "weight", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("h1", __assign({}, ovr.title, props, { className: (0, classnames_1.default)((_b = {},
            _b[style_scss_1.default.alignLeft] = align === shared_1.Alignment.LEFT,
            _b[style_scss_1.default.alignCenter] = align === shared_1.Alignment.CENTER,
            _b[style_scss_1.default.fontWeightRegular] = weight === shared_1.FontWeight.REGULAR,
            _b[style_scss_1.default.fontWeightSemiBold] = weight === shared_1.FontWeight.SEMI_BOLD,
            _b[style_scss_1.default.fontWeightBold] = weight === shared_1.FontWeight.BOLD,
            _b), ovr.title.className, className) }), children));
};
Title.displayName = componentName;
exports["default"] = Title;


/***/ }),

/***/ 47485:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StatusIndicators = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(91554));
var dot_react_svg_1 = __importDefault(__webpack_require__(9785));
var componentName = "TrackerDots";
var elementIdentifiers = (0, shared_1.tuple)("trackerDots", "trackerDot");
var StatusIndicators;
(function (StatusIndicators) {
    StatusIndicators["Active"] = "active";
    StatusIndicators["Inactive"] = "inactive";
    StatusIndicators["Fixed"] = "fixed";
})(StatusIndicators = exports.StatusIndicators || (exports.StatusIndicators = {}));
var TrackerDots = function (_a) {
    var statusIndicators = _a.statusIndicators, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["statusIndicators", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, props, ovr.trackerDots, { className: (0, classnames_1.default)(ovr.trackerDots.className, className) }), statusIndicators.map(function (statusIndicator, index) {
        var attributes = __assign(__assign({}, ovr.trackerDot), { className: (0, classnames_1.default)(ovr.trackerDot.className, style_scss_1.default[statusIndicator]) });
        return (react_1.default.createElement("span", __assign({}, attributes, { "data-testid": "".concat(ovr.trackerDot["data-testid"], "-").concat(index), key: "".concat(ovr.trackerDot.className, "-").concat(index) }),
            react_1.default.createElement(dot_react_svg_1.default, { "aria-label": "".concat(statusIndicator, " tracker dot") })));
    })));
};
TrackerDots.displayName = componentName;
exports["default"] = TrackerDots;


/***/ }),

/***/ 34391:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(9311));
var index_1 = __webpack_require__(55074);
var componentName = "AddRemoveButton";
var elementIdentifiers = (0, shared_1.tuple)("button", "icon");
var AddRemoveButton = function (_a) {
    var _b, _c;
    var title = _a.title, onClick = _a.onClick, _d = _a.icon, icon = _d === void 0 ? index_1.IconName.Add : _d, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["title", "onClick", "icon", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, ovr.button, props, { className: (0, classnames_1.default)(ovr.button.className, className), onClick: onClick }),
        react_1.default.createElement("span", __assign({}, ovr.icon, { className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.iconRemove] = icon === index_1.IconName.Remove, _b), (_c = {}, _c[style_scss_1.default.iconAdd] = icon === index_1.IconName.Add, _c), ovr.icon.className) }),
            react_1.default.createElement(index_1.Icon, { name: icon })),
        title));
};
AddRemoveButton.displayName = componentName;
exports["default"] = AddRemoveButton;


/***/ }),

/***/ 96326:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "AnimatedAnchor";
exports.elementIdentifiers = (0, shared_1.tuple)("animationWrapper", "animation");


/***/ }),

/***/ 72689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(69598));
var arrow_react_svg_1 = __importDefault(__webpack_require__(11070));
var constants_1 = __webpack_require__(96326);
var AnimatedAnchor = function (_a) {
    var _b = _a.size, size = _b === void 0 ? shared_1.ButtonSize.Medium : _b, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["size", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("a", __assign({}, props, ovr.animationWrapper, { className: (0, classnames_1.default)(ovr.animationWrapper.className, style_scss_1.default["size-".concat(size)], className) }),
        react_1.default.createElement(arrow_react_svg_1.default, null)));
};
AnimatedAnchor.displayName = constants_1.componentName;
exports["default"] = AnimatedAnchor;


/***/ }),

/***/ 82107:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var icon_1 = __webpack_require__(55074);
var style_scss_1 = __importDefault(__webpack_require__(28272));
var componentName = "BackLink";
var elementIdentifiers = (0, shared_1.tuple)("backLink", "icon");
var BackLink = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.children, children = _f === void 0 ? "Back" : _f, _g = _a.icon, icon = _g === void 0 ? icon_1.IconName.LeftArrow : _g, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "icon", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("a", __assign({}, ovr.backLink, props, { 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0, className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.leftBtn] = icon === icon_1.IconName.LeftArrow, _b), (_c = {}, _c[style_scss_1.default.rightBtn] = icon === icon_1.IconName.RightArrow, _c), ovr.backLink.className, className) }),
        react_1.default.createElement("span", __assign({}, ovr.icon, { className: (0, classnames_1.default)((_d = {}, _d[style_scss_1.default.iconLeftArrow] = icon === icon_1.IconName.LeftArrow, _d), (_e = {}, _e[style_scss_1.default.iconRightArrow] = icon === icon_1.IconName.RightArrow, _e), ovr.icon.className, className) }),
            react_1.default.createElement(icon_1.Icon, { name: icon })),
        children));
};
BackLink.displayName = componentName;
exports["default"] = BackLink;


/***/ }),

/***/ 47426:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(52841));
var componentName = "Button";
var elementIdentifiers = (0, shared_1.tuple)("button");
var Button = function (_a) {
    var _b, _c, _d;
    var children = _a.children, _e = _a.size, size = _e === void 0 ? shared_1.ButtonSize.Medium : _e, _f = _a.colour, colour = _f === void 0 ? shared_1.ButtonColour.Primary : _f, _g = _a.fixed, fixed = _g === void 0 ? true : _g, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "size", "colour", "fixed", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, ovr.button, props, { className: (0, classnames_1.default)((_b = {}, _b["".concat(style_scss_1.default["size-".concat(size)])] = size, _b), (_c = {}, _c["".concat(style_scss_1.default["color-".concat(colour)])] = colour, _c), (_d = {}, _d[style_scss_1.default.fixed] = fixed, _d), ovr.button.className, className) }), children));
};
Button.displayName = componentName;
exports["default"] = Button;


/***/ }),

/***/ 96578:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CheckboxSize = exports.CheckboxModes = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var tooltip_1 = __importDefault(__webpack_require__(62636));
var tick_react_svg_1 = __importDefault(__webpack_require__(62851));
var tick_reskin_react_svg_1 = __importDefault(__webpack_require__(54277));
var tick_green_react_svg_1 = __importDefault(__webpack_require__(33937));
var tick_low_contact_react_svg_1 = __importDefault(__webpack_require__(93301));
var style_scss_1 = __importDefault(__webpack_require__(47366));
var componentName = "Checkbox";
var elementIdentifiers = (0, shared_1.tuple)("container", "input", "box", "label", "boxWrapper");
var CheckboxModes;
(function (CheckboxModes) {
    CheckboxModes["Default"] = "default";
    CheckboxModes["Light"] = "light";
    CheckboxModes["LightV3"] = "lightV3";
    CheckboxModes["LightV4"] = "lightV4";
    CheckboxModes["Green"] = "green";
})(CheckboxModes = exports.CheckboxModes || (exports.CheckboxModes = {}));
var CheckboxSize;
(function (CheckboxSize) {
    CheckboxSize["Default"] = "default";
    CheckboxSize["Small"] = "Small";
})(CheckboxSize = exports.CheckboxSize || (exports.CheckboxSize = {}));
var Checkbox = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var id = _a.id, label = _a.label, _s = _a.checked, checked = _s === void 0 ? false : _s, _t = _a.mode, mode = _t === void 0 ? CheckboxModes.Default : _t, _u = _a.sizeBox, sizeBox = _u === void 0 ? CheckboxSize.Default : _u, _v = _a.isValid, isValid = _v === void 0 ? true : _v, _w = _a.tooltip, tooltip = _w === void 0 ? null : _w, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["id", "label", "checked", "mode", "sizeBox", "isValid", "tooltip", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var TickImage = undefined;
    if (checked) {
        switch (mode) {
            case CheckboxModes.LightV3: {
                TickImage = tick_reskin_react_svg_1.default;
                break;
            }
            case CheckboxModes.Green: {
                TickImage = tick_green_react_svg_1.default;
                break;
            }
            case CheckboxModes.LightV4: {
                TickImage = tick_low_contact_react_svg_1.default;
                break;
            }
            default: {
                TickImage = tick_react_svg_1.default;
                break;
            }
        }
    }
    return (react_1.default.createElement("div", __assign({}, ovr.container),
        react_1.default.createElement("input", __assign({ id: id }, ovr.input, { className: (0, classnames_1.default)(ovr.input.className, className) }, props, { type: "checkbox", checked: checked })),
        react_1.default.createElement("label", __assign({}, ovr.label, { htmlFor: id, className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.error] = !isValid, _b), (_c = {}, _c[style_scss_1.default.lightLabel] = mode === CheckboxModes.Light, _c), (_d = {}, _d[style_scss_1.default.lightLabelV3] = mode === CheckboxModes.LightV3, _d), (_e = {}, _e[style_scss_1.default.defaultLabel] = mode === CheckboxModes.Default, _e), (_f = {}, _f[style_scss_1.default.greenLabel] = mode === CheckboxModes.Green, _f), (_g = {}, _g[style_scss_1.default.lowContactLabel] = mode === CheckboxModes.LightV4, _g), (_h = {}, _h[style_scss_1.default.labelChecked] = checked, _h), (_j = {}, _j[style_scss_1.default.disabled] = props.disabled, _j), (_k = {}, _k[style_scss_1.default.smallLabel] = sizeBox === CheckboxSize.Small, _k), ovr.label.className) }),
            react_1.default.createElement("div", __assign({}, ovr.boxWrapper, { className: (0, classnames_1.default)((_l = {}, _l[style_scss_1.default.boxWrapperChecked] = checked, _l), ovr.boxWrapper.className) }),
                react_1.default.createElement("div", __assign({}, ovr.box, { className: (0, classnames_1.default)((_m = {}, _m[style_scss_1.default.boxChecked] = checked, _m), (_o = {}, _o[style_scss_1.default.disabledBox] = props.disabled, _o), (_p = {}, _p[style_scss_1.default.smallBox] = sizeBox === CheckboxSize.Small, _p), (_q = {},
                        _q[style_scss_1.default.smallBoxV3] = sizeBox === CheckboxSize.Small &&
                            mode === CheckboxModes.LightV3,
                        _q), (_r = {},
                        _r[style_scss_1.default.smallBoxGreen] = sizeBox === CheckboxSize.Small && mode === CheckboxModes.Green,
                        _r), ovr.box.className) }), TickImage && react_1.default.createElement(TickImage, null))),
            react_1.default.createElement(react_1.default.Fragment, null, label)),
        tooltip ? (react_1.default.createElement("div", { className: style_scss_1.default.tooltipWrapper },
            react_1.default.createElement(tooltip_1.default, { classOverrides: {
                    button: style_scss_1.default.tooltipButton,
                    tipOuterContainer: mode === CheckboxModes.Light ||
                        CheckboxModes.LightV3 ||
                        CheckboxModes.Green
                        ? style_scss_1.default.tooltipOuterContainerLight
                        : style_scss_1.default.tooltipOuterContainerDefault,
                    tipInnerContainer: mode === CheckboxModes.Light ||
                        CheckboxModes.LightV3 ||
                        CheckboxModes.Green
                        ? style_scss_1.default.tooltipInnerContainerLight
                        : style_scss_1.default.tooltipInnerContainerDefault
                } }, tooltip.props.children))) : null));
};
Checkbox.displayName = componentName;
exports["default"] = Checkbox;


/***/ }),

/***/ 22555:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isDigitWithTwoDecimalsRegex = exports.isFormattedCurrencyRegexPatternAttribute = exports.isFormattedCurrencyRegex = exports.deformatCurrency = exports.formatCurrencyWithSymbol = exports.formatCurrency = void 0;
var EMPTY_STRING = "";
// Test if valid formatted currency
// See example https://regex101.com/r/b0Vs3j/2
var isFormattedCurrencyRegex = /^(\d{1,3})(,\d{3})*(\.\d{1,2})?$/;
exports.isFormattedCurrencyRegex = isFormattedCurrencyRegex;
var isFormattedCurrencyRegexPatternAttribute = String(isFormattedCurrencyRegex).slice(1, -1);
exports.isFormattedCurrencyRegexPatternAttribute = isFormattedCurrencyRegexPatternAttribute;
// Test if valid digit allowing up to 2 decimal places
// See example https://regex101.com/r/EtqoRb/3
var isDigitWithTwoDecimalsRegex = /^\d+(\.?\d{0,2})?$/;
exports.isDigitWithTwoDecimalsRegex = isDigitWithTwoDecimalsRegex;
var formatCurrency = function (currentValue) {
    if (currentValue === void 0) { currentValue = ""; }
    var newAmount = "".concat(currentValue).replace(/[,\s]/g, EMPTY_STRING);
    var lastCharacter = newAmount[newAmount.length - 1];
    var formatter = new Intl.NumberFormat("en-GB", {
        maximumFractionDigits: 2
    });
    if (newAmount === EMPTY_STRING) {
        return EMPTY_STRING;
    }
    // Test if valid digital allowing up to 2 decimal places
    if (isDigitWithTwoDecimalsRegex.test(newAmount)) {
        var newAmountAsNumber = Number(newAmount);
        var formattedAmount = formatter.format(newAmountAsNumber);
        // If a user enters '1234.' we want to display '1,234.'
        return lastCharacter === "." ? "".concat(formattedAmount, ".") : formattedAmount;
    }
    return null;
};
exports.formatCurrency = formatCurrency;
// This is a slight variation on formatCurrency as it returns 2 decimal places as well
// as the currency symbol. I've additionally removed the check on the number having 2 decimal
// places on the input as this was casuing issues with values like 495.0000005.
// eslint-disable-next-line no-warning-comments
// TODO: Make this one method (formatCurrency) with optional param for symbol after assessing impact.
var formatCurrencyWithSymbol = function (currentValue) {
    if (currentValue === void 0) { currentValue = ""; }
    var newAmount = "".concat(currentValue).replace(/[,\s]/g, EMPTY_STRING);
    if (newAmount === EMPTY_STRING) {
        return EMPTY_STRING;
    }
    var formatter = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP"
    });
    var asNumber = Number(newAmount);
    if (isNaN(asNumber))
        return null;
    return formatter.format(asNumber);
};
exports.formatCurrencyWithSymbol = formatCurrencyWithSymbol;
var deformatCurrency = function (currentValue) {
    if (currentValue === void 0) { currentValue = ""; }
    return currentValue.replace(/,/g, "").replace(/£/g, "");
};
exports.deformatCurrency = deformatCurrency;


/***/ }),

/***/ 93606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCurrency = exports.isDigitWithTwoDecimalsRegex = exports.isFormattedCurrencyRegex = exports.deformatCurrency = exports.formatCurrencyWithSymbol = exports.formatCurrency = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var formatCurrency_1 = __webpack_require__(22555);
Object.defineProperty(exports, "deformatCurrency", ({ enumerable: true, get: function () { return formatCurrency_1.deformatCurrency; } }));
Object.defineProperty(exports, "formatCurrency", ({ enumerable: true, get: function () { return formatCurrency_1.formatCurrency; } }));
Object.defineProperty(exports, "formatCurrencyWithSymbol", ({ enumerable: true, get: function () { return formatCurrency_1.formatCurrencyWithSymbol; } }));
Object.defineProperty(exports, "isDigitWithTwoDecimalsRegex", ({ enumerable: true, get: function () { return formatCurrency_1.isDigitWithTwoDecimalsRegex; } }));
Object.defineProperty(exports, "isFormattedCurrencyRegex", ({ enumerable: true, get: function () { return formatCurrency_1.isFormattedCurrencyRegex; } }));
var style_scss_1 = __importDefault(__webpack_require__(88680));
var useCurrency_1 = __webpack_require__(60780);
Object.defineProperty(exports, "useCurrency", ({ enumerable: true, get: function () { return useCurrency_1.useCurrency; } }));
var componentName = "CurrencyInput";
var elementIdentifiers = (0, shared_1.tuple)("container", "input", "icon");
var CurrencyInput = function (_a) {
    var _b;
    var value = _a.value, _c = _a.isValid, isValid = _c === void 0 ? true : _c, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["value", "isValid", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var params = (0, useCurrency_1.useCurrency)({
        onChange: props.onChange,
        value: value
    });
    return (react_1.default.createElement("div", __assign({}, ovr.container),
        react_1.default.createElement("div", __assign({}, ovr.icon, { role: "presentation" }), "\u00A3"),
        react_1.default.createElement("input", __assign({}, ovr.input, props, { className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.inputInvalid] = !isValid, _b), ovr.input.className, className), "aria-label": "Currency input", type: "text" }, params))));
};
CurrencyInput.displayName = componentName;
// Component
exports["default"] = CurrencyInput;


/***/ }),

/***/ 60780:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCurrency = void 0;
var react_1 = __webpack_require__(99497);
var formatCurrency_1 = __webpack_require__(22555);
var useCurrency = function (_a) {
    var onChange = _a.onChange, value = _a.value;
    var _b = (0, react_1.useState)(value), updatedValue = _b[0], setValue = _b[1];
    (0, react_1.useEffect)(function () {
        setValue(value);
    }, [value]);
    var handleOnChange = function (event) {
        var formattedValue = (0, formatCurrency_1.formatCurrency)(event.target.value);
        if (formattedValue === null) {
            return false;
        }
        setValue(formattedValue);
        if (onChange && formattedValue !== null) {
            event.target.value = formattedValue;
            onChange(event);
        }
    };
    return {
        inputMode: "numeric",
        pattern: formatCurrency_1.isFormattedCurrencyRegexPatternAttribute,
        value: (0, formatCurrency_1.formatCurrency)(updatedValue) || "",
        onChange: handleOnChange
    };
};
exports.useCurrency = useCurrency;


/***/ }),

/***/ 86810:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DateInputModes = void 0;
var DateInputModes;
(function (DateInputModes) {
    DateInputModes["FullDate"] = "DD/MM/YYYY";
    DateInputModes["MonthYear"] = "MM/YYYY";
})(DateInputModes = exports.DateInputModes || (exports.DateInputModes = {}));


/***/ }),

/***/ 33673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DateInputModes = exports.isISODate = exports.isDDMMYYYY = exports.isMMYYYY = exports.ISORegex = exports.DDMMYYYYRegex = exports.MMYYYYRegex = exports.convertISOToDDMMYYYY = exports.convertISOToMMYYYY = exports.convertDDMMYYYYToISO = exports.convertMMYYYYToISO = exports.DDMMYYYYDateString = exports.MMYYYYDateString = exports.ISODateString = exports.monthYearMaskPattern = exports.fullDateMaskPattern = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var dayjs_1 = __importDefault(__webpack_require__(16060));
__webpack_require__(67850);
var customParseFormat_1 = __importDefault(__webpack_require__(476));
var react_1 = __importDefault(__webpack_require__(99497));
var react_text_mask_1 = __importDefault(__webpack_require__(64139));
var createAutoCorrectedDatePipe_1 = __importDefault(__webpack_require__(39873));
var shared_1 = __webpack_require__(89574);
var DateInputModes_1 = __webpack_require__(86810);
var utilities_1 = __webpack_require__(53365);
var style_scss_1 = __importDefault(__webpack_require__(44332));
dayjs_1.default.locale("en-gb");
dayjs_1.default.extend(customParseFormat_1.default);
var componentName = "DateInput";
var elementIdentifiers = (0, shared_1.tuple)("input");
exports.fullDateMaskPattern = [
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    "/",
    /[1-2]/,
    /[0|1|9]/,
    /\d/,
    /\d/
];
exports.monthYearMaskPattern = [
    /\d/,
    /\d/,
    "/",
    /[1-2]/,
    /[0|1|9]/,
    /\d/,
    /\d/
];
var DateInput = function (_a) {
    var _b;
    var id = _a.id, value = _a.value, _c = _a.isValid, isValid = _c === void 0 ? true : _c, onValidDate = _a.onValidDate, _d = _a.mode, mode = _d === void 0 ? DateInputModes_1.DateInputModes.FullDate : _d, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["id", "value", "isValid", "onValidDate", "mode", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var autoCorrectedDatePipe = (0, createAutoCorrectedDatePipe_1.default)(mode.toLowerCase());
    var maskPattern = mode === DateInputModes_1.DateInputModes.FullDate
        ? exports.fullDateMaskPattern
        : exports.monthYearMaskPattern;
    return (react_1.default.createElement(react_text_mask_1.default, __assign({}, ovr.input, props, { id: id, className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.inputError] = !isValid, _b), ovr.input.className, className), "aria-label": "Date input", keepCharPositions: true, mask: maskPattern, pipe: autoCorrectedDatePipe, placeholderChar: "\u2000", placeholder: mode, inputMode: "numeric", value: value, type: "text", guide: false, onChange: function (e) {
            var date = e.target.value;
            if (onValidDate && date && ((0, utilities_1.isMMYYYY)(date) || (0, utilities_1.isDDMMYYYY)(date))) {
                onValidDate(mode === DateInputModes_1.DateInputModes.MonthYear
                    ? (0, utilities_1.convertMMYYYYToISO)(date)
                    : (0, utilities_1.convertDDMMYYYYToISO)(date));
            }
            if (props.onChange) {
                props.onChange(e);
            }
        } })));
};
DateInput.displayName = componentName;
// Utils
var utilities_2 = __webpack_require__(53365);
// types
Object.defineProperty(exports, "ISODateString", ({ enumerable: true, get: function () { return utilities_2.ISODateString; } }));
Object.defineProperty(exports, "MMYYYYDateString", ({ enumerable: true, get: function () { return utilities_2.MMYYYYDateString; } }));
Object.defineProperty(exports, "DDMMYYYYDateString", ({ enumerable: true, get: function () { return utilities_2.DDMMYYYYDateString; } }));
// converters
Object.defineProperty(exports, "convertMMYYYYToISO", ({ enumerable: true, get: function () { return utilities_2.convertMMYYYYToISO; } }));
Object.defineProperty(exports, "convertDDMMYYYYToISO", ({ enumerable: true, get: function () { return utilities_2.convertDDMMYYYYToISO; } }));
Object.defineProperty(exports, "convertISOToMMYYYY", ({ enumerable: true, get: function () { return utilities_2.convertISOToMMYYYY; } }));
Object.defineProperty(exports, "convertISOToDDMMYYYY", ({ enumerable: true, get: function () { return utilities_2.convertISOToDDMMYYYY; } }));
// regex
Object.defineProperty(exports, "MMYYYYRegex", ({ enumerable: true, get: function () { return utilities_2.MMYYYYRegex; } }));
Object.defineProperty(exports, "DDMMYYYYRegex", ({ enumerable: true, get: function () { return utilities_2.DDMMYYYYRegex; } }));
Object.defineProperty(exports, "ISORegex", ({ enumerable: true, get: function () { return utilities_2.ISORegex; } }));
// validators
Object.defineProperty(exports, "isMMYYYY", ({ enumerable: true, get: function () { return utilities_2.isMMYYYY; } }));
Object.defineProperty(exports, "isDDMMYYYY", ({ enumerable: true, get: function () { return utilities_2.isDDMMYYYY; } }));
Object.defineProperty(exports, "isISODate", ({ enumerable: true, get: function () { return utilities_2.isISODate; } }));
var DateInputModes_2 = __webpack_require__(86810);
Object.defineProperty(exports, "DateInputModes", ({ enumerable: true, get: function () { return DateInputModes_2.DateInputModes; } }));
exports["default"] = DateInput;


/***/ }),

/***/ 53365:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.convertISOToDDMMYYYY = exports.convertISOToMMYYYY = exports.convertDDMMYYYYToISO = exports.convertMMYYYYToISO = exports.isISODate = exports.isDDMMYYYY = exports.isMMYYYY = exports.ISORegex = exports.DDMMYYYYRegex = exports.MMYYYYRegex = void 0;
var dayjs_1 = __importDefault(__webpack_require__(16060));
__webpack_require__(67850);
var customParseFormat_1 = __importDefault(__webpack_require__(476));
var utc_1 = __importDefault(__webpack_require__(54468));
var DateInputModes_1 = __webpack_require__(86810);
dayjs_1.default.locale("en-gb");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
// https://www.debuggex.com/r/6UyaIhyy8Dp_wcQi
exports.MMYYYYRegex = /^((0\d)|(1[0-2]))\/((19|20|21)\d{2})$/;
// https://www.debuggex.com/r/JAlFuArxAuqbcuUy
exports.DDMMYYYYRegex = /^(?:(?:31(\/)(?:0[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0[13-9]|1[0-2])\2))(?:(?:19|20|21)\d{2})$|^(?:29(\/)02\3(?:(?:(?:19|20|21)(?:0[48]|[2468][048]|[13579][26]))))$|^(?:0[1-9]|1\d|2[0-8])(\/)(?:(?:0[1-9])|(?:1[0-2]))\4(?:(?:19|20|21)\d{2})$/;
// https://www.debuggex.com/r/_zsOL6ltnYaYNItc / https://stackoverflow.com/a/3143231/1046561
exports.ISORegex = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
var isMMYYYY = function (value) { return exports.MMYYYYRegex.test(value); };
exports.isMMYYYY = isMMYYYY;
var isDDMMYYYY = function (value) { return exports.DDMMYYYYRegex.test(value); };
exports.isDDMMYYYY = isDDMMYYYY;
var isISODate = function (value) { return exports.ISORegex.test(value); };
exports.isISODate = isISODate;
var convertMMYYYYToISO = function (mmyyyy) {
    if (!(0, exports.isMMYYYY)(mmyyyy)) {
        throw Error("Format must be ".concat(DateInputModes_1.DateInputModes.MonthYear));
    }
    // Tack on first day of month to beginning before converting to ISO
    // else day will be set to today
    return dayjs_1.default.utc("01/".concat(mmyyyy), DateInputModes_1.DateInputModes.FullDate).toISOString();
};
exports.convertMMYYYYToISO = convertMMYYYYToISO;
var convertDDMMYYYYToISO = function (ddmmyyyy) {
    if (!(0, exports.isDDMMYYYY)(ddmmyyyy)) {
        throw Error("Format must be ".concat(DateInputModes_1.DateInputModes.FullDate));
    }
    return dayjs_1.default.utc(ddmmyyyy, DateInputModes_1.DateInputModes.FullDate).toISOString();
};
exports.convertDDMMYYYYToISO = convertDDMMYYYYToISO;
var convertISOToMMYYYY = function (iso) {
    if (!(0, exports.isISODate)(iso)) {
        throw Error("Format must be ISO date");
    }
    return (0, dayjs_1.default)(iso).format(DateInputModes_1.DateInputModes.MonthYear);
};
exports.convertISOToMMYYYY = convertISOToMMYYYY;
var convertISOToDDMMYYYY = function (iso) {
    if (!exports.ISORegex.test(iso)) {
        throw Error("Format must be ISO date");
    }
    return (0, dayjs_1.default)(iso).format(DateInputModes_1.DateInputModes.FullDate);
};
exports.convertISOToDDMMYYYY = convertISOToDDMMYYYY;


/***/ }),

/***/ 81394:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var chevron_react_svg_1 = __importDefault(__webpack_require__(47582));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(39004));
var componentName = "Dropdown";
var elementIdentifiers = (0, shared_1.tuple)("container", "label", "select");
var optionsMapper = function (options) {
    return options.map(function (opt) {
        return opt.children ? (react_1.default.createElement("optgroup", { label: opt.description }, optionsMapper(opt.children))) : (react_1.default.createElement("option", { key: opt.code, value: opt.code }, opt.description));
    });
};
var placeholderOption = function (placeholder) {
    if (!placeholder) {
        return null;
    }
    return (react_1.default.createElement("option", { key: "", value: "", disabled: true }, placeholder));
};
var Dropdown = function (_a) {
    var _b, _c;
    var value = _a.value, disabled = _a.disabled, options = _a.options, placeholder = _a.placeholder, _d = _a.isValid, isValid = _d === void 0 ? true : _d, _e = _a.variant, variant = _e === void 0 ? "primary" : _e, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["value", "disabled", "options", "placeholder", "isValid", "variant", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.container),
        react_1.default.createElement("label", __assign({ htmlFor: props.id }, ovr.label, { className: (0, classnames_1.default)(ovr.label.className, className) }),
            react_1.default.createElement(chevron_react_svg_1.default, null),
            react_1.default.createElement("select", __assign({}, ovr.select, props, { "aria-label": "Dropdown", className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.error] = !isValid, _b), (_c = {}, _c[style_scss_1.default.secondary] = variant === "secondary", _c), ovr.select.className, className), disabled: disabled, value: value || "" }),
                placeholderOption(placeholder),
                optionsMapper(options)))));
};
Dropdown.displayName = componentName;
exports["default"] = Dropdown;


/***/ }),

/***/ 94540:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var chevron_up_react_svg_1 = __importDefault(__webpack_require__(34565));
var chevron_down_react_svg_1 = __importDefault(__webpack_require__(42582));
var subtleButtonWithIcon_1 = __importDefault(__webpack_require__(82099));
var style_scss_1 = __importDefault(__webpack_require__(73772));
var componentName = "ExpandButton";
var elementIdentifiers = (0, shared_1.tuple)("expandButton");
var ExpandButton = function (_a) {
    var children = _a.children, isExpanded = _a.isExpanded, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "isExpanded", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement(subtleButtonWithIcon_1.default, __assign({}, ovr.expandButton, props, { icon: isExpanded ? react_1.default.createElement(chevron_up_react_svg_1.default, null) : react_1.default.createElement(chevron_down_react_svg_1.default, null), className: (0, classnames_1.default)(ovr.expandButton.className, className) }), children));
};
ExpandButton.displayName = componentName;
exports["default"] = ExpandButton;


/***/ }),

/***/ 12223:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(99091));
var componentName = "FieldError";
var elementIdentifiers = (0, shared_1.tuple)("error");
var FieldError = function (_a) {
    var message = _a.message, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["message", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return message ? (react_1.default.createElement("div", __assign({}, ovr.error, props, { className: (0, classnames_1.default)(ovr.error.className, className) }), message)) : null;
};
FieldError.displayName = componentName;
exports["default"] = FieldError;


/***/ }),

/***/ 7726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(81726));
var componentName = "Fieldset";
var elementIdentifiers = (0, shared_1.tuple)("fieldset", "legend");
var FieldSet = function (_a) {
    var _b;
    var legend = _a.legend, hideLegend = _a.hideLegend, _c = _a.tooltip, tooltip = _c === void 0 ? null : _c, children = _a.children, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["legend", "hideLegend", "tooltip", "children", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("fieldset", __assign({}, ovr.fieldset, props, { className: (0, classnames_1.default)(ovr.fieldset.className, className) }),
        legend && (react_1.default.createElement("legend", __assign({}, ovr.legend, { className: (0, classnames_1.default)((_b = {},
                _b[style_scss_1.default.hideLegend] = hideLegend,
                _b[style_scss_1.default.withTooltip] = tooltip,
                _b), ovr.legend.className) }),
            legend,
            tooltip)),
        children));
};
FieldSet.displayName = componentName;
exports["default"] = FieldSet;


/***/ }),

/***/ 9325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultTileIcons = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var document_react_svg_1 = __importDefault(__webpack_require__(29303));
var home_react_svg_1 = __importDefault(__webpack_require__(59189));
var phone_green_react_svg_1 = __importDefault(__webpack_require__(35615));
var search_react_svg_1 = __importDefault(__webpack_require__(80244));
var borrowing_react_svg_1 = __importDefault(__webpack_require__(23488));
var writing_react_svg_1 = __importDefault(__webpack_require__(48875));
var style_scss_1 = __importDefault(__webpack_require__(37473));
var componentName = "FlatTile";
var elementIdentifiers = (0, shared_1.tuple)("flatTileTitle", "flatTile", "iconContainer");
var DefaultTileIcons;
(function (DefaultTileIcons) {
    DefaultTileIcons["PHONE"] = "Phone";
    DefaultTileIcons["WRITING"] = "Writing";
    DefaultTileIcons["DOCUMENT"] = "Document";
    DefaultTileIcons["HOME"] = "Home";
    DefaultTileIcons["SEARCH"] = "Search";
    DefaultTileIcons["BORROWING"] = "Borrowing";
})(DefaultTileIcons = exports.DefaultTileIcons || (exports.DefaultTileIcons = {}));
var FlatTile = function (_a) {
    var title = _a.title, icon = _a.icon, onClick = _a.onClick, defaultIcon = _a.defaultIcon, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["title", "icon", "onClick", "defaultIcon", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var FlatDefaultIcon = function () {
        switch (defaultIcon) {
            case DefaultTileIcons.HOME:
                return react_1.default.createElement(home_react_svg_1.default, null);
            case DefaultTileIcons.PHONE:
                return react_1.default.createElement(phone_green_react_svg_1.default, null);
            case DefaultTileIcons.DOCUMENT:
                return react_1.default.createElement(document_react_svg_1.default, null);
            case DefaultTileIcons.SEARCH:
                return react_1.default.createElement(search_react_svg_1.default, null);
            case DefaultTileIcons.BORROWING:
                return react_1.default.createElement(borrowing_react_svg_1.default, null);
            default:
                return react_1.default.createElement(writing_react_svg_1.default, null);
        }
    };
    return (react_1.default.createElement("button", __assign({}, ovr.flatTile, props, { onClick: onClick }),
        react_1.default.createElement("div", __assign({}, ovr.iconContainer), icon ? icon : react_1.default.createElement(FlatDefaultIcon, null)),
        react_1.default.createElement("span", __assign({}, ovr.flatTileTitle), title)));
};
FlatTile.displayName = componentName;
exports["default"] = FlatTile;


/***/ }),

/***/ 63111:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(48621));
var componentName = "GhostButton";
var elementIdentifiers = (0, shared_1.tuple)("button");
var GhostButton = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.size, size = _d === void 0 ? shared_1.ButtonSize.Medium : _d, _e = _a.fixed, fixed = _e === void 0 ? true : _e, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "size", "fixed", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, ovr.button, props, { className: (0, classnames_1.default)((_b = {}, _b["".concat(style_scss_1.default["size-".concat(size)])] = size, _b), (_c = {}, _c[style_scss_1.default.fixed] = fixed, _c), ovr.button.className, className) }), children));
};
GhostButton.displayName = componentName;
exports["default"] = GhostButton;


/***/ }),

/***/ 13174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AnimatedAnchor = exports.QuestionIconButton = exports.DateInput = exports.TypeAhead = exports.Checkbox = exports.Tooltip = exports.Label = exports.FlatTile = exports.Tile = exports.Fieldset = exports.FieldError = exports.withValidation = exports.Textarea = exports.RangeInput = exports.ICurrencyInputProps = exports.CurrencyInput = exports.PercentageInput = exports.TextInput = exports.ValidationIcon = exports.Dropdown = exports.GhostButton = exports.AddRemoveButton = exports.BackLink = exports.TextButton = exports.LightButton = exports.Button = exports.Radio = void 0;
var radio_1 = __webpack_require__(68257);
Object.defineProperty(exports, "Radio", ({ enumerable: true, get: function () { return __importDefault(radio_1).default; } }));
__exportStar(__webpack_require__(68257), exports);
var button_1 = __webpack_require__(47426);
Object.defineProperty(exports, "Button", ({ enumerable: true, get: function () { return __importDefault(button_1).default; } }));
__exportStar(__webpack_require__(47426), exports);
var lightButton_1 = __webpack_require__(80985);
Object.defineProperty(exports, "LightButton", ({ enumerable: true, get: function () { return __importDefault(lightButton_1).default; } }));
__exportStar(__webpack_require__(80985), exports);
var textButton_1 = __webpack_require__(80271);
Object.defineProperty(exports, "TextButton", ({ enumerable: true, get: function () { return __importDefault(textButton_1).default; } }));
__exportStar(__webpack_require__(80271), exports);
var backLink_1 = __webpack_require__(82107);
Object.defineProperty(exports, "BackLink", ({ enumerable: true, get: function () { return __importDefault(backLink_1).default; } }));
__exportStar(__webpack_require__(82107), exports);
var addRemoveButton_1 = __webpack_require__(34391);
Object.defineProperty(exports, "AddRemoveButton", ({ enumerable: true, get: function () { return __importDefault(addRemoveButton_1).default; } }));
__exportStar(__webpack_require__(34391), exports);
var ghostButton_1 = __webpack_require__(63111);
Object.defineProperty(exports, "GhostButton", ({ enumerable: true, get: function () { return __importDefault(ghostButton_1).default; } }));
__exportStar(__webpack_require__(63111), exports);
var dropdown_1 = __webpack_require__(81394);
Object.defineProperty(exports, "Dropdown", ({ enumerable: true, get: function () { return __importDefault(dropdown_1).default; } }));
__exportStar(__webpack_require__(81394), exports);
var validationIcon_1 = __webpack_require__(27309);
Object.defineProperty(exports, "ValidationIcon", ({ enumerable: true, get: function () { return __importDefault(validationIcon_1).default; } }));
__exportStar(__webpack_require__(27309), exports);
var textInput_1 = __webpack_require__(49077);
Object.defineProperty(exports, "TextInput", ({ enumerable: true, get: function () { return __importDefault(textInput_1).default; } }));
__exportStar(__webpack_require__(49077), exports);
var percentageInput_1 = __webpack_require__(17833);
Object.defineProperty(exports, "PercentageInput", ({ enumerable: true, get: function () { return __importDefault(percentageInput_1).default; } }));
__exportStar(__webpack_require__(17833), exports);
var currencyInput_1 = __webpack_require__(93606);
Object.defineProperty(exports, "CurrencyInput", ({ enumerable: true, get: function () { return __importDefault(currencyInput_1).default; } }));
Object.defineProperty(exports, "ICurrencyInputProps", ({ enumerable: true, get: function () { return currencyInput_1.ICurrencyInputProps; } }));
__exportStar(__webpack_require__(93606), exports);
var rangeInput_1 = __webpack_require__(68795);
Object.defineProperty(exports, "RangeInput", ({ enumerable: true, get: function () { return __importDefault(rangeInput_1).default; } }));
__exportStar(__webpack_require__(68795), exports);
var textarea_1 = __webpack_require__(27584);
Object.defineProperty(exports, "Textarea", ({ enumerable: true, get: function () { return __importDefault(textarea_1).default; } }));
__exportStar(__webpack_require__(27584), exports);
var withValidation_1 = __webpack_require__(68443);
Object.defineProperty(exports, "withValidation", ({ enumerable: true, get: function () { return __importDefault(withValidation_1).default; } }));
__exportStar(__webpack_require__(68443), exports);
var fieldError_1 = __webpack_require__(12223);
Object.defineProperty(exports, "FieldError", ({ enumerable: true, get: function () { return __importDefault(fieldError_1).default; } }));
__exportStar(__webpack_require__(12223), exports);
var fieldset_1 = __webpack_require__(7726);
Object.defineProperty(exports, "Fieldset", ({ enumerable: true, get: function () { return __importDefault(fieldset_1).default; } }));
__exportStar(__webpack_require__(7726), exports);
var tile_1 = __webpack_require__(14009);
Object.defineProperty(exports, "Tile", ({ enumerable: true, get: function () { return __importDefault(tile_1).default; } }));
__exportStar(__webpack_require__(14009), exports);
var flatTile_1 = __webpack_require__(9325);
Object.defineProperty(exports, "FlatTile", ({ enumerable: true, get: function () { return __importDefault(flatTile_1).default; } }));
__exportStar(__webpack_require__(9325), exports);
var label_1 = __webpack_require__(46178);
Object.defineProperty(exports, "Label", ({ enumerable: true, get: function () { return __importDefault(label_1).default; } }));
__exportStar(__webpack_require__(46178), exports);
var tooltip_1 = __webpack_require__(62636);
Object.defineProperty(exports, "Tooltip", ({ enumerable: true, get: function () { return __importDefault(tooltip_1).default; } }));
__exportStar(__webpack_require__(62636), exports);
var checkbox_1 = __webpack_require__(96578);
Object.defineProperty(exports, "Checkbox", ({ enumerable: true, get: function () { return __importDefault(checkbox_1).default; } }));
__exportStar(__webpack_require__(96578), exports);
var typeahead_1 = __webpack_require__(8240);
Object.defineProperty(exports, "TypeAhead", ({ enumerable: true, get: function () { return __importDefault(typeahead_1).default; } }));
__exportStar(__webpack_require__(8240), exports);
var dateInput_1 = __webpack_require__(33673);
Object.defineProperty(exports, "DateInput", ({ enumerable: true, get: function () { return __importDefault(dateInput_1).default; } }));
__exportStar(__webpack_require__(33673), exports);
var questionIconButton_1 = __webpack_require__(95590);
Object.defineProperty(exports, "QuestionIconButton", ({ enumerable: true, get: function () { return __importDefault(questionIconButton_1).default; } }));
__exportStar(__webpack_require__(95590), exports);
var animatedAnchor_1 = __webpack_require__(72689);
Object.defineProperty(exports, "AnimatedAnchor", ({ enumerable: true, get: function () { return __importDefault(animatedAnchor_1).default; } }));
__exportStar(__webpack_require__(72689), exports);
__exportStar(__webpack_require__(74625), exports);
__exportStar(__webpack_require__(2144), exports);


/***/ }),

/***/ 74625:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Input = exports.isMonthSupported = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(79745));
var shared_1 = __webpack_require__(89574);
var mail_24px_react_svg_1 = __importDefault(__webpack_require__(93791));
var currency_react_svg_1 = __importDefault(__webpack_require__(11891));
var currencyInput_1 = __webpack_require__(93606);
var percentage_sign_react_svg_1 = __importDefault(__webpack_require__(73991));
var month_react_svg_1 = __importDefault(__webpack_require__(83414));
var close_icon_24px_react_svg_1 = __importDefault(__webpack_require__(56368));
var pound_24px_react_svg_1 = __importDefault(__webpack_require__(99519));
var perc_24px_react_svg_1 = __importDefault(__webpack_require__(42822));
var mail_24px_react_svg_2 = __importDefault(__webpack_require__(77044));
var calendar_24px_react_svg_1 = __importDefault(__webpack_require__(8553));
var utils_1 = __webpack_require__(48277);
var utils_2 = __webpack_require__(48277);
Object.defineProperty(exports, "isMonthSupported", ({ enumerable: true, get: function () { return utils_2.isMonthSupported; } }));
var chevron_react_svg_1 = __importDefault(__webpack_require__(47582));
var componentName = "Input";
var elementIdentifiers = (0, shared_1.tuple)("container", "inputContainer", "icon", "input", "label", "additionalTextContainer", "iconX", "errorMsg", "helperText", "closeButton");
exports.Input = react_1.default.forwardRef(function (_a, ref) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var name = _a.name, label = _a.label, _m = _a.align, align = _m === void 0 ? "left" : _m, _o = _a.disabled, disabled = _o === void 0 ? false : _o, _p = _a.error, error = _p === void 0 ? false : _p, _q = _a.errorMsg, errorMsg = _q === void 0 ? "Invalid input" : _q, _r = _a.colour, colour = _r === void 0 ? "primary" : _r, _s = _a.inputSize, inputSize = _s === void 0 ? "large" : _s, helperText = _a.helperText, _t = _a.variant, variant = _t === void 0 ? "normal" : _t, _u = _a.showIcon, showIcon = _u === void 0 ? true : _u, _v = _a.monthSupported, monthSupported = _v === void 0 ? false : _v, _w = _a.betterV2, betterV2 = _w === void 0 ? false : _w, options = _a.options, id = _a.id, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, rest = __rest(_a, ["name", "label", "align", "disabled", "error", "errorMsg", "colour", "inputSize", "helperText", "variant", "showIcon", "monthSupported", "betterV2", "options", "id", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _x = (0, react_1.useState)(rest.value || rest.defaultValue), inputValue = _x[0], setInputValue = _x[1];
    var handleChange = function (event) {
        if (rest.onChange) {
            rest.onChange(event);
        }
        if (betterV2 && variant !== "month") {
            setInputValue(event.target.value);
        }
    };
    var clearInput = function () {
        setInputValue("");
    };
    var _y = react_1.default.useState(rest.value !== undefined && rest.value !== null && rest.value !== ""), isFocused = _y[0], setIsFocused = _y[1];
    var onFocus = function (e) {
        setIsFocused(true);
        if (rest.onFocus) {
            rest.onFocus(e);
        }
    };
    var onBlur = function (e) {
        setIsFocused(e.target.value.length > 0);
        if (rest.onBlur) {
            rest.onBlur(e);
        }
    };
    var isAndroid = typeof window !== "undefined" && navigator.userAgent.match(/android/i);
    var isIOS = typeof window !== "undefined" &&
        navigator.userAgent.match(/(iPad|iPhone|iPod)/i);
    var isMobile = isAndroid || isIOS;
    var labelInitiallyMovedUp = (variant === "month" && monthSupported && !isMobile) ||
        (rest.defaultValue !== undefined &&
            rest.defaultValue !== null &&
            rest.defaultValue !== "");
    var refMonthly = (0, utils_1.useMonthlyPatter)(rest.min ? new Date(rest.min) : undefined).ref;
    var extraInputProps = {};
    var getIcon = function (iconType) {
        switch (iconType) {
            case "currency":
                return {
                    icon: betterV2 ? react_1.default.createElement(pound_24px_react_svg_1.default, null) : react_1.default.createElement(currency_react_svg_1.default, null),
                    width: inputSize === "x-large" ? "32px" : betterV2 ? "24px" : "9px"
                };
            case "email":
                return {
                    icon: betterV2 ? react_1.default.createElement(mail_24px_react_svg_2.default, null) : react_1.default.createElement(mail_24px_react_svg_1.default, null),
                    width: inputSize === "x-large" ? "32px" : "24px"
                };
            case "month":
                return {
                    icon: betterV2 ? react_1.default.createElement(calendar_24px_react_svg_1.default, null) : react_1.default.createElement(month_react_svg_1.default, null),
                    width: inputSize === "x-large" ? "32px" : "16px"
                };
            case "percentage":
                return {
                    icon: betterV2 ? react_1.default.createElement(perc_24px_react_svg_1.default, null) : react_1.default.createElement(percentage_sign_react_svg_1.default, null),
                    width: inputSize === "x-large" ? "32px" : betterV2 ? "24px" : "12px"
                };
            case "year":
                return {
                    icon: react_1.default.createElement("div", { className: style_scss_1.default.yearInputIcon }, "years"),
                    width: ""
                };
            default:
                return null;
        }
    };
    var currentIcon = null;
    var iconPosition = "left";
    switch (variant) {
        case "normal": {
            extraInputProps.value = betterV2 ? inputValue : rest.value;
            break;
        }
        case "email": {
            extraInputProps.type = "email";
            extraInputProps.inputMode = "email";
            currentIcon = getIcon("email");
            break;
        }
        case "currency": {
            var currencyParams = (0, currencyInput_1.useCurrency)({
                value: betterV2 ? inputValue : rest.value,
                onChange: betterV2 ? function (e) { return handleChange(e); } : rest.onChange
            });
            extraInputProps.value = currencyParams.value;
            extraInputProps.onChange = currencyParams.onChange;
            extraInputProps.inputMode = "numeric";
            currentIcon = getIcon("currency");
            break;
        }
        case "percentage": {
            extraInputProps.type = "number";
            extraInputProps.inputMode = "numeric";
            currentIcon = getIcon("percentage");
            iconPosition = "right";
            break;
        }
        case "month": {
            extraInputProps.inputMode = "numeric";
            if (monthSupported) {
                extraInputProps.type = "month";
                extraInputProps.onFocus = function (event) {
                    if (event.currentTarget.showPicker) {
                        event.currentTarget.showPicker();
                    }
                    onFocus(event);
                };
            }
            else {
                extraInputProps.type = "text";
            }
            if (!monthSupported || isIOS) {
                currentIcon = getIcon("month");
                iconPosition = "right";
            }
            break;
        }
        case "year": {
            extraInputProps.type = "number";
            extraInputProps.inputMode = "numeric";
            currentIcon = getIcon("year");
            iconPosition = "right";
            break;
        }
        default:
            break;
    }
    var elementToRender;
    switch (variant) {
        case "month":
            elementToRender = (react_1.default.createElement("input", __assign({}, rest, ovr.input, { ref: monthSupported ? ref : refMonthly, id: id || name, name: name, className: (0, classnames_1.default)(ovr.input.className, className, (_b = {},
                    _b[style_scss_1.default.betterV2] = betterV2,
                    _b)), onFocus: onFocus, onBlur: onBlur, disabled: disabled, "aria-label": label, placeholder: isFocused ? rest.placeholder : "" }, extraInputProps)));
            break;
        case "select":
            elementToRender = (react_1.default.createElement("div", { className: style_scss_1.default.selectContainer },
                react_1.default.createElement(chevron_react_svg_1.default, null),
                react_1.default.createElement("select", __assign({}, rest, ovr.input, { ref: ref, value: inputValue, onChange: function (e) { return handleChange(e); }, id: id || name, name: name, className: (0, classnames_1.default)(ovr.input.className, style_scss_1.default.select, className, (_c = {},
                        _c[style_scss_1.default.betterV2] = betterV2,
                        _c)), onFocus: onFocus, onBlur: onBlur, disabled: disabled, "aria-label": label, placeholder: isFocused ? rest.placeholder : "" }, extraInputProps), options === null || options === void 0 ? void 0 : options.map(function (_a) {
                    var value = _a.value, label = _a.label, rest = __rest(_a, ["value", "label"]);
                    return (react_1.default.createElement("option", __assign({ key: label, value: value }, rest), label));
                }))));
            break;
        default:
            elementToRender = (react_1.default.createElement("input", __assign({}, rest, ovr.input, { ref: monthSupported ||
                    variant === "email" ||
                    variant === "currency" ||
                    variant === "normal" ||
                    variant === "percentage" ||
                    variant === "year"
                    ? ref
                    : refMonthly, value: inputValue, onChange: function (e) { return handleChange(e); }, id: id || name, name: name, className: (0, classnames_1.default)(ovr.input.className, className, (_d = {},
                    _d[style_scss_1.default.betterV2] = betterV2,
                    _d)), onFocus: onFocus, onBlur: onBlur, disabled: disabled, "aria-label": label, placeholder: isFocused ? rest.placeholder : "" }, extraInputProps)));
            break;
    }
    var displayIcon = Boolean(showIcon && currentIcon);
    return (react_1.default.createElement("div", __assign({}, ovr.container, { className: (0, classnames_1.default)(ovr.container.className, style_scss_1.default["size-".concat(inputSize)], style_scss_1.default["align-".concat(align)], (_e = {},
            _e[style_scss_1.default.error] = error,
            _e[style_scss_1.default.disabled] = disabled,
            _e[style_scss_1.default.focused] = isFocused,
            _e[style_scss_1.default.hideLabel] = (isFocused && inputSize === "small") ||
                (isFocused && inputSize === "x-large"),
            _e[style_scss_1.default.focusedIconMargin] = isFocused && inputSize === "large",
            _e[style_scss_1.default.iconVisible] = displayIcon,
            _e[style_scss_1.default.labelInitiallyMovedUp] = labelInitiallyMovedUp,
            _e[style_scss_1.default.extraPadding] = variant === "month" && monthSupported && isMobile,
            _e[style_scss_1.default.betterV2] = betterV2,
            _e)) }),
        react_1.default.createElement("div", __assign({}, ovr.inputContainer, { className: (0, classnames_1.default)(ovr.inputContainer.className, style_scss_1.default["input-container-colour-".concat(colour)], (_f = {}, _f[style_scss_1.default.reverse] = iconPosition === "right", _f[style_scss_1.default.betterV2] = betterV2, _f)) }),
            react_1.default.createElement("label", __assign({}, ovr.label, { className: (0, classnames_1.default)(ovr.label.className, style_scss_1.default["label-align-".concat(align)], (_g = {},
                    _g[style_scss_1.default["label-margin-".concat(iconPosition)]] = displayIcon,
                    _g[style_scss_1.default.betterV2] = betterV2,
                    _g)), htmlFor: id || name }), label),
            displayIcon && (react_1.default.createElement("div", __assign({}, ovr.icon, { className: (0, classnames_1.default)(ovr.icon.className, (_h = {},
                    _h[style_scss_1.default.yearInputDivider] = variant === "year",
                    _h[style_scss_1.default.betterV2] = betterV2,
                    _h)), style: { width: currentIcon.width } }), currentIcon.icon)),
            elementToRender,
            betterV2 && inputValue && variant !== "month" && (react_1.default.createElement("button", { className: (0, classnames_1.default)(ovr.closeButton.className, (_j = {},
                    _j[style_scss_1.default.yearCloseButton] = variant === "year",
                    _j[style_scss_1.default.closeButtonIconRightAligned] = iconPosition === "right" && variant !== "year",
                    _j[style_scss_1.default.closeButtonRightAligned] = align === "right",
                    _j)), onClick: clearInput },
                react_1.default.createElement(close_icon_24px_react_svg_1.default, null)))),
        react_1.default.createElement("div", __assign({}, ovr.additionalTextContainer),
            react_1.default.createElement("span", __assign({}, ovr.iconX, { className: (0, classnames_1.default)(ovr.iconX.className, (_k = {}, _k[style_scss_1.default.betterV2] = betterV2, _k)) })),
            react_1.default.createElement("span", __assign({}, ovr.errorMsg, { className: (0, classnames_1.default)(ovr.errorMsg.className, (_l = {}, _l[style_scss_1.default.betterV2] = betterV2, _l)) }), errorMsg),
            helperText && !error ? (react_1.default.createElement("span", __assign({}, ovr.helperText), helperText)) : null)));
});


/***/ }),

/***/ 48277:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMonthSupported = exports.useMonthlyPatter = void 0;
var react_imask_1 = __webpack_require__(58719);
var useMonthlyPatter = function (min) {
    return (0, react_imask_1.useIMask)({
        mask: Date,
        pattern: "m/`Y",
        format: function (date) {
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            if (month < 10)
                month = "0".concat(month);
            return [month, year].join("/");
        },
        parse: function (str) {
            var yearMonthDay = str.split("/");
            return new Date(parseInt(yearMonthDay[1]), parseInt(yearMonthDay[0]) - 1);
        },
        autofix: true,
        lazy: true,
        overwrite: true,
        min: min
    });
};
exports.useMonthlyPatter = useMonthlyPatter;
var isMonthSupported = function () {
    var input = document.createElement("input");
    var value = "a";
    input.setAttribute("type", "month");
    input.setAttribute("value", value);
    return input.value !== value;
};
exports.isMonthSupported = isMonthSupported;


/***/ }),

/***/ 46178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(55477));
var componentName = "Label";
var elementIdentifiers = (0, shared_1.tuple)("label");
var Label = function (_a) {
    var _b;
    var title = _a.title, _c = _a.tooltip, tooltip = _c === void 0 ? null : _c, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["title", "tooltip", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("label", __assign({}, ovr.label, { className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.withTooltip] = tooltip, _b), ovr.label.className, className) }, props),
        title,
        tooltip));
};
Label.displayName = componentName;
exports["default"] = Label;


/***/ }),

/***/ 80985:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(87707));
var componentName = "LightButton";
var elementIdentifiers = (0, shared_1.tuple)("button", "icon");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isPropString = function (prop) { return typeof prop === "string"; };
var LightButton = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var children = _a.children, icon = _a.icon, _l = _a.disabled, disabled = _l === void 0 ? false : _l, _m = _a.size, size = _m === void 0 ? shared_1.ButtonSize.Medium : _m, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "icon", "disabled", "size", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, ovr.button, props, { className: (0, classnames_1.default)((_b = {}, _b["".concat(style_scss_1.default["size-".concat(size)])] = size, _b), (_c = {}, _c[style_scss_1.default.leftBtn] = icon && icon.alignment === shared_1.IconAlignment.Left, _c), (_d = {}, _d[style_scss_1.default.rightBtn] = icon && icon.alignment === shared_1.IconAlignment.Right, _d), ovr.button.className, className), disabled: disabled }),
        children,
        icon &&
            (isPropString(icon.image) ? (react_1.default.createElement("span", __assign({}, ovr.icon, { className: (0, classnames_1.default)((_e = {}, _e[style_scss_1.default.iconAdd] = icon.image === shared_1.IconName.Add, _e), (_f = {}, _f[style_scss_1.default.iconRemove] = icon.image === shared_1.IconName.Remove, _f), (_g = {}, _g[style_scss_1.default.iconLeftArrow] = icon.image === shared_1.IconName.LeftArrow, _g), (_h = {}, _h[style_scss_1.default.iconRightArrow] = icon.image === shared_1.IconName.RightArrow, _h), ovr.icon.className) }),
                react_1.default.createElement(shared_1.Icon, { name: icon.image }))) : (react_1.default.createElement("span", { className: (0, classnames_1.default)((_j = {}, _j[style_scss_1.default.iconLeft] = icon.alignment === shared_1.IconAlignment.Left, _j), (_k = {}, _k[style_scss_1.default.iconRight] = icon.alignment === shared_1.IconAlignment.Right, _k), ovr.icon.className) }, icon.image)))));
};
LightButton.displayName = componentName;
exports["default"] = LightButton;


/***/ }),

/***/ 72202:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "PercentageInput";
exports.elementIdentifiers = (0, shared_1.tuple)("container", "input", "icon");


/***/ }),

/***/ 17833:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var lodash_isnumber_1 = __importDefault(__webpack_require__(76506));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(72202);
var style_scss_1 = __importDefault(__webpack_require__(59856));
var PercentageInput = function (_a) {
    var _b;
    var value = _a.value, _c = _a.isValid, isValid = _c === void 0 ? true : _c, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["value", "isValid", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.container),
        react_1.default.createElement("div", __assign({}, ovr.icon, { role: "presentation" }), "%"),
        react_1.default.createElement("input", __assign({}, ovr.input, { inputMode: "numeric" }, props, { type: "number", "aria-label": "Percentage input", value: (0, lodash_isnumber_1.default)(value) ? value : undefined, className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.inputInvalid] = !isValid, _b), ovr.input.className, className) }))));
};
PercentageInput.displayName = constants_1.componentName;
exports["default"] = PercentageInput;


/***/ }),

/***/ 81347:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var tooltip_react_svg_1 = __importDefault(__webpack_require__(41071));
var subtleButtonWithIcon_1 = __importDefault(__webpack_require__(82099));
var style_scss_1 = __importDefault(__webpack_require__(4547));
var componentName = "QuestionButton";
var elementIdentifiers = (0, shared_1.tuple)("questionButton");
var QuestionButton = function (_a) {
    var children = _a.children, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement(subtleButtonWithIcon_1.default, __assign({}, ovr.questionButton, props, { icon: react_1.default.createElement(tooltip_react_svg_1.default, null), className: (0, classnames_1.default)(ovr.questionButton.className, className) }), children));
};
QuestionButton.displayName = componentName;
exports["default"] = QuestionButton;


/***/ }),

/***/ 85804:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "QuestionIconButton";
exports.elementIdentifiers = (0, shared_1.tuple)("button");


/***/ }),

/***/ 95590:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var constants_1 = __webpack_require__(85804);
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(183));
var QuestionIconButton = function (_a) {
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, ovr.button, props, { className: (0, classnames_1.default)(ovr.button.className, className), "aria-label": "Question button" }),
        react_1.default.createElement(shared_1.Icon, { name: shared_1.IconName.Info })));
};
QuestionIconButton.displayName = constants_1.componentName;
exports["default"] = QuestionIconButton;


/***/ }),

/***/ 20963:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "Radio";
exports.elementIdentifiers = (0, shared_1.tuple)("radioGroup", "input", "radio", "label");


/***/ }),

/***/ 68257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var radio_react_svg_1 = __importDefault(__webpack_require__(33407));
var style_scss_1 = __importDefault(__webpack_require__(33696));
var tooltip_1 = __importDefault(__webpack_require__(62636));
var constants_1 = __webpack_require__(20963);
var Radio = function (_a) {
    var _b;
    var value = _a.value, options = _a.options, _c = _a.variant, variant = _c === void 0 ? "default" : _c, _d = _a.inline, inline = _d === void 0 ? false : _d, _e = _a.isValid, isValid = _e === void 0 ? true : _e, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["value", "options", "variant", "inline", "isValid", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var isV2 = variant === "v2";
    var optionElements = options.map(function (opt) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var prefix = props.id || constants_1.componentName;
        var suffix = opt.code.toLowerCase();
        var optionId = "".concat(prefix, "-").concat(suffix);
        return (react_1.default.createElement("div", { key: optionId, className: style_scss_1.default.inputWrapper },
            react_1.default.createElement("input", __assign({}, ovr.input, props, { id: optionId, type: "radio", value: opt.code, checked: opt.code === value, disabled: props.disabled || opt.disabled, className: (0, classnames_1.default)(ovr.input.className, className), "data-testid": "".concat(ovr.input["data-testid"], "-").concat(suffix) })),
            react_1.default.createElement("label", __assign({}, ovr.label, { htmlFor: optionId, className: (0, classnames_1.default)((_a = {}, _a[style_scss_1.default.labelChecked] = opt.code === value, _a), (_b = {}, _b[style_scss_1.default.labelCheckedV2] = opt.code === value, _b), (_c = {}, _c[style_scss_1.default.error] = !isValid, _c), (_d = {}, _d[style_scss_1.default.disabled] = props.disabled || opt.disabled, _d), (_e = {}, _e[style_scss_1.default.disabledV2] = (props.disabled || opt.disabled) && isV2, _e), (_f = {}, _f[style_scss_1.default.labelV2] = isV2, _f), ovr.label.className), "data-testid": "".concat(ovr.label["data-testid"], "-").concat(suffix) }),
                react_1.default.createElement("div", { className: (0, classnames_1.default)((_g = {}, _g[style_scss_1.default.radioChecked] = opt.code === value, _g), (_h = {}, _h[style_scss_1.default.radioCheckedV2] = opt.code === value && isV2, _h), (_j = {}, _j[style_scss_1.default.disabledRadio] = props.disabled || opt.disabled, _j), (_k = {}, _k[style_scss_1.default.disabledRadioV2] = (props.disabled || opt.disabled) && isV2, _k), (_l = {}, _l[style_scss_1.default.radioV2] = isV2, _l), ovr.radio.className) },
                    opt.code === value && isV2 && react_1.default.createElement("div", { className: style_scss_1.default.radioPoint }),
                    opt.code === value && variant === "default" && react_1.default.createElement(radio_react_svg_1.default, null)),
                opt.description),
            !inline && opt.tooltip ? (react_1.default.createElement("div", { className: style_scss_1.default.tooltipWrapper },
                react_1.default.createElement(tooltip_1.default, { classOverrides: {
                        tipOuterContainer: style_scss_1.default.tooltipOuterContainer,
                        tipInnerContainer: style_scss_1.default.tooltipInnerContainer
                    } }, opt.tooltip.props.children))) : null));
    });
    return (react_1.default.createElement("div", __assign({}, ovr.radioGroup, { className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.inline] = inline, _b), ovr.radioGroup.className) }), optionElements));
};
Radio.displayName = constants_1.componentName;
exports["default"] = Radio;


/***/ }),

/***/ 18893:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Bubble = void 0;
/* eslint-disable no-magic-numbers */
var lodash_get_1 = __importDefault(__webpack_require__(81805));
var react_1 = __importStar(__webpack_require__(99497));
var helpers_1 = __webpack_require__(22409);
var useBubbleLeftOffset = function (leftOffset, bubbleWidth, containerWidth) {
    return (0, react_1.useMemo)(function () {
        var bubbleLeftOffset = leftOffset - bubbleWidth / 2;
        return bubbleLeftOffset;
    }, [leftOffset, bubbleWidth, containerWidth]);
};
var Bubble = function (_a) {
    var value = _a.value, valueChanged = _a.valueChanged, bubbleProp = _a.bubbleProp, containerWidth = _a.containerWidth, snapValueToPercentageMapping = _a.snapValueToPercentageMapping, disabled = _a.disabled, ovr = _a.ovr;
    var _b = (0, helpers_1.useBubbleWidth)(valueChanged, ovr.bubble.ref, disabled), bubbleWidth = _b.bubbleWidth, bubbleRef = _b.bubbleRef;
    var snapPercentage = snapValueToPercentageMapping[value];
    var leftOffset = (0, helpers_1.useLeftOffset)(snapPercentage !== undefined ? snapPercentage : 0, containerWidth);
    var bubbleLeftOffset = useBubbleLeftOffset(leftOffset, bubbleWidth, containerWidth);
    var prefix = (0, lodash_get_1.default)(bubbleProp, "prefix", "");
    var suffix = (0, lodash_get_1.default)(bubbleProp, "suffix", "");
    return (react_1.default.createElement("div", __assign({}, ovr.bubbleContainer, { style: { left: "".concat(bubbleLeftOffset, "px") } }),
        react_1.default.createElement("output", __assign({}, ovr.bubble, { ref: bubbleRef }),
            react_1.default.createElement("span", null, disabled ? "?" : "".concat(prefix, " ").concat(value, " ").concat(suffix)))));
};
exports.Bubble = Bubble;


/***/ }),

/***/ 47197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Notches = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var helpers_1 = __webpack_require__(22409);
var notch_react_svg_1 = __importDefault(__webpack_require__(17665));
var style_scss_1 = __importDefault(__webpack_require__(76357));
var Notches = function (_a) {
    var value = _a.value, containerWidth = _a.containerWidth, snapValueToPercentageMapping = _a.snapValueToPercentageMapping, ovr = _a.ovr;
    return (react_1.default.createElement("div", { className: style_scss_1.default.notchesContainer }, Object.entries(snapValueToPercentageMapping).map(function (_a) {
        var snapValue = _a[0], snapPercentage = _a[1];
        var leftOffset = (0, helpers_1.useLeftOffset)(snapPercentage, containerWidth);
        return (react_1.default.createElement("span", __assign({ key: snapValue }, ovr.notches, { style: {
                left: "".concat(leftOffset, "px"),
                display: Number(snapValue) === value ? "none" : undefined // hide notch if thumb over it
            } }),
            react_1.default.createElement(notch_react_svg_1.default, null)));
    })));
};
exports.Notches = Notches;


/***/ }),

/***/ 17042:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RIGHT_ARROW_KEYCODE = exports.LEFT_ARROW_KEYCODE = exports.RANGE_DEFAULTS = exports.TO_PERCENT = void 0;
exports.TO_PERCENT = 100;
exports.RANGE_DEFAULTS = {
    MIN: 0,
    MAX: 100,
    STEP: 1
};
exports.LEFT_ARROW_KEYCODE = 37;
exports.RIGHT_ARROW_KEYCODE = 39;


/***/ }),

/***/ 22409:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLeftOffset = exports.useBubbleWidth = exports.useContainerWidth = exports.useSnapValueToPercentageMapping = exports.findHigherSnap = exports.findLowerSnap = exports.findClosestSnap = exports.useSortedSnaps = void 0;
var react_1 = __webpack_require__(99497);
var constants_1 = __webpack_require__(17042);
var useSortedSnaps = function (snaps) {
    return (0, react_1.useMemo)(function () { return snaps && snaps.values.sort(function (a, b) { return a - b; }); }, [snaps]);
};
exports.useSortedSnaps = useSortedSnaps;
var findClosestSnap = function (snaps, value) {
    var result = snaps.reduce(function (_a, snap) {
        var closestSnap = _a[0], lowestAbs = _a[1];
        var abs = Math.abs(snap - value);
        if (abs < lowestAbs) {
            return [snap, abs];
        }
        return [closestSnap, lowestAbs];
    }, [Infinity, Infinity])[0];
    return result;
};
exports.findClosestSnap = findClosestSnap;
var findLowerSnap = function (snapValues, value) {
    var snapsLessThanValue = __spreadArray([], snapValues, true).filter(function (snapValue) { return snapValue < value; });
    var closestSnap = (0, exports.findClosestSnap)(snapsLessThanValue, value);
    return closestSnap === Infinity ? snapValues[0] : closestSnap;
};
exports.findLowerSnap = findLowerSnap;
var findHigherSnap = function (snapValues, value) {
    var snapsGreaterThanValue = __spreadArray([], snapValues, true).filter(function (snapValue) { return snapValue > value; });
    var closestSnap = (0, exports.findClosestSnap)(snapsGreaterThanValue, value);
    return closestSnap === Infinity
        ? snapValues[snapValues.length - 1]
        : closestSnap;
};
exports.findHigherSnap = findHigherSnap;
var useSnapValueToPercentageMapping = function (snaps, min, max, step) {
    var sortedSnaps = (0, exports.useSortedSnaps)(snaps);
    return (0, react_1.useMemo)(function () {
        if (snaps) {
            var lowestSnap = sortedSnaps[0];
            var highestSnap = sortedSnaps[sortedSnaps.length - 1];
            var rangeMin_1;
            var rangeMax_1;
            if (max === undefined) {
                rangeMax_1 = highestSnap;
            }
            else {
                rangeMax_1 = highestSnap > Number(max) ? highestSnap : Number(max);
            }
            if (min === undefined) {
                rangeMin_1 = lowestSnap;
            }
            else {
                rangeMin_1 = lowestSnap < Number(min) ? lowestSnap : Number(min);
            }
            // tslint:disable-next-line: no-shadowed-variable
            var snapValueToPercentageMapping_1 = sortedSnaps.reduce(function (acc, snapValue) {
                var _a;
                var snapPercentage = ((snapValue - rangeMin_1) / (rangeMax_1 - rangeMin_1)) * constants_1.TO_PERCENT;
                return __assign(__assign({}, acc), (_a = {}, _a[Number(snapValue)] = snapPercentage, _a));
            }, {});
            return snapValueToPercentageMapping_1;
        }
        var snapValueToPercentageMapping = {};
        var xmin = Number(min) || constants_1.RANGE_DEFAULTS.MIN;
        var xmax = Number(max) || constants_1.RANGE_DEFAULTS.MAX;
        var xstep = Number(step) || constants_1.RANGE_DEFAULTS.STEP;
        for (var val = xmin; val <= xmax; val += xstep) {
            var snapValue = val;
            var snapPercentage = (val / (xmax - xmin)) * constants_1.TO_PERCENT;
            snapValueToPercentageMapping[Number(snapValue)] = snapPercentage;
        }
        return snapValueToPercentageMapping;
    }, [snaps, min, max, step]);
};
exports.useSnapValueToPercentageMapping = useSnapValueToPercentageMapping;
var useContainerWidth = function (ref) {
    var DEFAULT_CONTAINER_WIDTH = 480;
    var _a = (0, react_1.useState)(DEFAULT_CONTAINER_WIDTH), containerWidth = _a[0], setContainerWidth = _a[1];
    var containerRef = ref || (0, react_1.useRef)(null);
    var updateContainerWidth = function () {
        return setContainerWidth(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerRef.current.offsetWidth || DEFAULT_CONTAINER_WIDTH);
    };
    (0, react_1.useEffect)(function () {
        updateContainerWidth();
    }, []);
    (0, react_1.useEffect)(function () {
        addEventListener("resize", function () {
            updateContainerWidth();
        });
    }, [window.outerWidth]);
    return { containerWidth: containerWidth, containerRef: containerRef };
};
exports.useContainerWidth = useContainerWidth;
var useBubbleWidth = function (valueChanged, ref, disabled) {
    var DEFAULT_BUBBLE_WIDTH = 26;
    var _a = (0, react_1.useState)(DEFAULT_BUBBLE_WIDTH), bubbleWidth = _a[0], setBubbleWidth = _a[1];
    var bubbleRef = ref || (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        setBubbleWidth(bubbleRef.current.offsetWidth || DEFAULT_BUBBLE_WIDTH);
    }, [valueChanged, disabled]);
    return { bubbleWidth: bubbleWidth, bubbleRef: bubbleRef };
};
exports.useBubbleWidth = useBubbleWidth;
var useLeftOffset = function (snapPercentage, bubbleContainerWidth) {
    return (0, react_1.useMemo)(function () {
        var NOTCH_WIDTH = 20;
        var HALF_NOTCH_WIDTH = NOTCH_WIDTH / 2;
        // notch is inset by half a thumb width on left and right of range
        var usableRange = bubbleContainerWidth - HALF_NOTCH_WIDTH * 2;
        var offset = (snapPercentage / constants_1.TO_PERCENT) * usableRange;
        return HALF_NOTCH_WIDTH + offset;
    }, [snapPercentage, bubbleContainerWidth]);
};
exports.useLeftOffset = useLeftOffset;


/***/ }),

/***/ 68795:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var Bubble_1 = __webpack_require__(18893);
var constants_1 = __webpack_require__(17042);
var helpers_1 = __webpack_require__(22409);
var Notch_1 = __webpack_require__(47197);
var style_scss_1 = __importDefault(__webpack_require__(76357));
var componentName = "RangeInput";
var elementIdentifiers = (0, shared_1.tuple)("input", "container", "bubbleContainer", "bubble", "notches");
var RangeInput = function (_a) {
    var _b, _c;
    var snaps = _a.snaps, bubble = _a.bubble, onValue = _a.onValue, 
    // Take isValid off so that using this with withValidation does not show console error
    // May design an invalid state for this input later on
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isValid = _a.isValid, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["snaps", "bubble", "onValue", "isValid", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _d = (0, react_1.useState)(Number(props.value) || 0), value = _d[0], setValue = _d[1];
    var _e = (0, react_1.useState)(0), valueChanged = _e[0], setValueChanged = _e[1];
    (0, react_1.useEffect)(function () {
        if (onValue) {
            onValue(value);
        }
    }, [valueChanged]);
    var _f = (0, helpers_1.useContainerWidth)(ovr.container.ref), containerWidth = _f.containerWidth, containerRef = _f.containerRef;
    var onChange = function (e) {
        e.persist();
        if (snaps) {
            var newValue = (0, helpers_1.findClosestSnap)(snaps.values, Number(e.target.value));
            if (newValue !== value) {
                setValue(newValue);
                setValueChanged(valueChanged + 1);
            }
        }
        else {
            setValue(Number(e.target.value));
            setValueChanged(valueChanged + 1);
        }
        if (props.onChange) {
            props.onChange(e);
        }
    };
    var onMouseUp = function (e) {
        e.persist();
        if (snaps) {
            // Firefox fires onChange after onMouseUp, need this to sequence properly
            setTimeout(function () {
                var snapValue = (0, helpers_1.findClosestSnap)(snaps.values, value);
                if (snapValue !== value) {
                    setValue(snapValue);
                    setValueChanged(valueChanged + 1);
                }
            }, 0);
        }
        setTimeout(function () {
            if (props.onMouseUp) {
                props.onMouseUp(e);
            }
        }, 0);
    };
    var onKeyDown = function (e) {
        e.persist();
        if (snaps) {
            var snapValue_1;
            if (e.keyCode === constants_1.LEFT_ARROW_KEYCODE) {
                snapValue_1 = (0, helpers_1.findLowerSnap)(snaps.values, value);
            }
            else if (e.keyCode === constants_1.RIGHT_ARROW_KEYCODE) {
                snapValue_1 = (0, helpers_1.findHigherSnap)(snaps.values, value);
            }
            else {
                return;
            }
            if (snapValue_1 !== value) {
                // Firefox fires onChange after onKeyDown, need this to sequence properly
                setTimeout(function () {
                    setValue(snapValue_1);
                    setValueChanged(valueChanged + 1);
                }, 0);
            }
        }
        setTimeout(function () {
            if (props.onKeyDown) {
                props.onKeyDown(e);
            }
        }, 0);
    };
    var sortedSnaps = (0, helpers_1.useSortedSnaps)(snaps);
    var snapValueToPercentageMapping = (0, helpers_1.useSnapValueToPercentageMapping)(snaps, props.min, props.max, props.step);
    return (react_1.default.createElement("div", __assign({}, ovr.container, { className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.containerDisabled] = props.disabled, _b), ovr.container.className), ref: containerRef }),
        bubble && bubble.hide ? null : (react_1.default.createElement(Bubble_1.Bubble, { value: value, valueChanged: valueChanged, bubbleProp: bubble, containerWidth: containerWidth, snapValueToPercentageMapping: snapValueToPercentageMapping, disabled: props.disabled, ovr: ovr })),
        react_1.default.createElement("input", __assign({}, ovr.input, { min: sortedSnaps ? sortedSnaps[0] : constants_1.RANGE_DEFAULTS.MIN, max: sortedSnaps ? sortedSnaps[sortedSnaps.length - 1] : constants_1.RANGE_DEFAULTS.MAX, step: constants_1.RANGE_DEFAULTS.STEP }, props, { type: "range", "aria-label": "Range input", onChange: onChange, onMouseUp: onMouseUp, onKeyDown: onKeyDown, value: value, className: (0, classnames_1.default)((_c = {}, _c[style_scss_1.default.inputDisabled] = props.disabled, _c), ovr.input.className, className) })),
        snaps && !snaps.hide && (react_1.default.createElement(Notch_1.Notches, { value: value, containerWidth: containerWidth, snapValueToPercentageMapping: snapValueToPercentageMapping, ovr: ovr }))));
};
RangeInput.displayName = componentName;
exports["default"] = RangeInput;


/***/ }),

/***/ 2144:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SearchInput = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var classnames_1 = __importDefault(__webpack_require__(57485));
var lodash_debounce_1 = __importDefault(__webpack_require__(89192));
var style_scss_1 = __importDefault(__webpack_require__(18062));
var search_icon_21px_react_svg_1 = __importDefault(__webpack_require__(83862));
var search_betterv2_react_svg_1 = __importDefault(__webpack_require__(36209));
var cancel_react_svg_1 = __importDefault(__webpack_require__(25784));
var close_betterv2_react_svg_1 = __importDefault(__webpack_require__(10377));
var componentName = "SearchInput";
var elementIdentifiers = (0, shared_1.tuple)("container", "inputContainer", "icon", "input", "cancelButton", "loader");
var SearchInput = function (_a) {
    var _b;
    var name = _a.name, placeholder = _a.placeholder, id = _a.id, isLoading = _a.isLoading, classOverrides = _a.classOverrides, testIds = _a.testIds, _c = _a.inputSize, inputSize = _c === void 0 ? "large" : _c, _d = _a.theme, theme = _d === void 0 ? "default" : _d, refs = _a.refs, searchCallback = _a.searchCallback, _e = _a.debounceDelay, debounceDelay = _e === void 0 ? 400 : _e, searchEmptiedCallback = _a.searchEmptiedCallback, rest = __rest(_a, ["name", "placeholder", "id", "isLoading", "classOverrides", "testIds", "inputSize", "theme", "refs", "searchCallback", "debounceDelay", "searchEmptiedCallback"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var searchCallbackDebounced = (0, react_1.useMemo)(function () { return (0, lodash_debounce_1.default)(searchCallback, debounceDelay); }, []);
    var _f = (0, react_1.useState)(""), value = _f[0], setValue = _f[1];
    var onChange = function (e) {
        e.persist();
        setValue(e.target.value);
        searchCallbackDebounced(e);
    };
    var onCancleSearchButtonClick = function () {
        setValue("");
        if (searchEmptiedCallback) {
            searchEmptiedCallback();
        }
    };
    return (react_1.default.createElement("div", __assign({}, ovr.container, { className: (0, classnames_1.default)(ovr.container.className, style_scss_1.default["size-".concat(inputSize)], isLoading ? "" : style_scss_1.default.hideSpinner, isLoading ? style_scss_1.default.hideCancelSearchButton : "", value === "" ? style_scss_1.default.hideCancelSearchButton : "", (_b = {},
            _b[style_scss_1.default.betterV2] = "betterV2" === theme,
            _b)) }),
        react_1.default.createElement("div", __assign({}, ovr.inputContainer),
            react_1.default.createElement("div", __assign({}, ovr.icon), "betterV2" === theme ? react_1.default.createElement(search_betterv2_react_svg_1.default, null) : react_1.default.createElement(search_icon_21px_react_svg_1.default, null)),
            react_1.default.createElement("input", __assign({ placeholder: placeholder }, rest, ovr.input, { value: value, onChange: onChange, className: (0, classnames_1.default)(ovr.input.className), id: id || name, "aria-label": placeholder || "Search" }))),
        react_1.default.createElement("button", __assign({}, ovr.cancelButton, { onClick: onCancleSearchButtonClick, title: "Clear search" }), "betterV2" === theme ? react_1.default.createElement(close_betterv2_react_svg_1.default, null) : react_1.default.createElement(cancel_react_svg_1.default, null)),
        react_1.default.createElement("div", __assign({}, ovr.loader))));
};
exports.SearchInput = SearchInput;


/***/ }),

/***/ 74500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var overrides_1 = __webpack_require__(46235);
var style_scss_1 = __importDefault(__webpack_require__(16358));
var componentName = "SubtleButton";
var elementIdentifiers = (0, overrides_1.tuple)("subtleButton");
var SubtleButton = function (_a) {
    var children = _a.children, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, overrides_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, ovr.subtleButton, props, { className: (0, classnames_1.default)(ovr.subtleButton.className, className) }), children));
};
SubtleButton.displayName = componentName;
exports["default"] = SubtleButton;


/***/ }),

/***/ 82099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var overrides_1 = __webpack_require__(46235);
var style_scss_1 = __importDefault(__webpack_require__(82287));
var subtleButton_1 = __importDefault(__webpack_require__(74500));
var componentName = "SubtleButtonWithIcon";
var elementIdentifiers = (0, overrides_1.tuple)("subtleButtonWithIcon");
var SubtleButtonWithIcon = function (_a) {
    var children = _a.children, icon = _a.icon, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["children", "icon", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, overrides_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement(subtleButton_1.default, __assign({}, ovr.subtleButtonWithIcon, props, { className: (0, classnames_1.default)(ovr.subtleButtonWithIcon.className, className) }),
        children,
        icon));
};
SubtleButtonWithIcon.displayName = componentName;
exports["default"] = SubtleButtonWithIcon;


/***/ }),

/***/ 91637:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "TextButton";
exports.elementIdentifiers = (0, shared_1.tuple)("button", "icon", "text");


/***/ }),

/***/ 80271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(91637);
var style_scss_1 = __importDefault(__webpack_require__(78601));
var TextButton = function (_a) {
    var value = _a.value, icon = _a.icon, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["value", "icon", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var Icon = icon;
    return (react_1.default.createElement("button", __assign({}, ovr.button, props, { className: (0, classnames_1.default)(ovr.button.className, className) }),
        Icon && (react_1.default.createElement("span", __assign({}, ovr.icon),
            react_1.default.createElement(Icon, null))),
        react_1.default.createElement("span", __assign({}, ovr.text), value)));
};
TextButton.displayName = constants_1.componentName;
exports["default"] = TextButton;


/***/ }),

/***/ 49077:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable jsx-a11y/label-has-associated-control */
// We're associating the label the other way around using aria-labelledby on the input so don't need to declare an associated control
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(50765));
var componentName = "TextInput";
var elementIdentifiers = (0, shared_1.tuple)("container", "input", "suffixText");
var TextInput = function (_a) {
    var _b;
    var value = _a.value, _c = _a.isValid, isValid = _c === void 0 ? true : _c, type = _a.type, suffix = _a.suffix, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["value", "isValid", "type", "suffix", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var suffixTextId = "".concat(props.id || componentName, "-suffixText");
    var labeledBy = function () {
        if (suffix) {
            return "".concat(suffix.labelId, " ").concat(suffixTextId);
        }
        return undefined;
    };
    var input = (react_1.default.createElement("input", __assign({}, ovr.input, { type: type, value: value === undefined ? "" : value, "aria-label": "Text input", "aria-labelledby": labeledBy(), className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.inputInvalid] = !isValid, _b), ovr.input.className, className) }, props)));
    return suffix ? (react_1.default.createElement("div", __assign({}, ovr.container),
        input,
        react_1.default.createElement("label", __assign({}, ovr.suffixText, { id: suffixTextId }), suffix.text))) : (input);
};
TextInput.displayName = componentName;
exports["default"] = TextInput;


/***/ }),

/***/ 27584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(86559));
var componentName = "Textarea";
var elementIdentifiers = (0, shared_1.tuple)("textarea");
var Textarea = function (_a) {
    var _b;
    var id = _a.id, _c = _a.isValid, isValid = _c === void 0 ? true : _c, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["id", "isValid", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    // expands size of text area while typing
    var handleOnInput = function (e) {
        var elementTarget = e.target;
        elementTarget.style.height = "56px";
        elementTarget.style.height = "".concat(elementTarget.scrollHeight, "px");
        if (props.onInput) {
            props.onInput(e);
        }
    };
    return (react_1.default.createElement("textarea", __assign({}, ovr.textarea, props, { "aria-label": "Text area", onInput: function (e) { return handleOnInput(e); }, className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.textareaInvalid] = !isValid, _b), ovr.textarea.className, props.className) }), props.value));
};
Textarea.displayName = componentName;
exports["default"] = Textarea;


/***/ }),

/***/ 14009:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(25831));
var componentName = "Tile";
var elementIdentifiers = (0, shared_1.tuple)("tileGroup", "tile", "input", "label", "selectedContainer", "iconWrapper", "icon", "descriptionWrapper", "description");
var Tile = function (_a) {
    var value = _a.value, options = _a.options, _b = _a.isValid, isValid = _b === void 0 ? true : _b, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["value", "options", "isValid", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var optionElements = options.map(function (opt) {
        var _a, _b, _c;
        var prefix = props.id || componentName;
        var suffix = opt.code.toLowerCase();
        var optionId = "".concat(prefix, "-").concat(suffix);
        var TileIcon = opt.icon;
        return (react_1.default.createElement(react_1.default.Fragment, { key: optionId },
            react_1.default.createElement("div", __assign({}, ovr.tile),
                react_1.default.createElement("input", __assign({}, ovr.input, props, { id: optionId, type: "radio", value: opt.code, checked: opt.code === value, className: (0, classnames_1.default)(ovr.input.className, className), "data-testid": "".concat(ovr.input["data-testid"], "-").concat(suffix) })),
                react_1.default.createElement("label", __assign({}, ovr.label, { className: (0, classnames_1.default)((_a = {}, _a[style_scss_1.default.checkedLabel] = opt.code === value, _a), (_b = {}, _b[style_scss_1.default.error] = !isValid, _b), ovr.label.className), htmlFor: optionId, "data-testid": "".concat(ovr.label["data-testid"], "-").concat(suffix) }),
                    react_1.default.createElement("div", { className: (0, classnames_1.default)((_c = {}, _c[style_scss_1.default.checkedContainer] = opt.code === value, _c), ovr.selectedContainer.className), "data-testid": "".concat(ovr.selectedContainer["data-testid"], "-").concat(suffix) },
                        react_1.default.createElement("div", __assign({}, ovr.iconWrapper, { "data-testid": "".concat(ovr.iconWrapper["data-testid"], "-").concat(suffix) }),
                            react_1.default.createElement(TileIcon, __assign({}, ovr.icon, { "data-testid": "".concat(ovr.icon["data-testid"], "-").concat(suffix) }))),
                        react_1.default.createElement("div", __assign({}, ovr.descriptionWrapper, { "data-testid": "".concat(ovr.descriptionWrapper["data-testid"], "-").concat(suffix) }),
                            react_1.default.createElement("div", __assign({}, ovr.description, { "data-testid": "".concat(ovr.description["data-testid"], "-").concat(suffix) }), opt.description)))))));
    });
    return react_1.default.createElement("div", __assign({}, ovr.tileGroup), optionElements);
};
Tile.displayName = componentName;
exports["default"] = Tile;


/***/ }),

/***/ 62636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ToolTipSize = exports.ToolTipTheme = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var use_onclickoutside_1 = __importDefault(__webpack_require__(37251));
var keycodes_1 = __webpack_require__(52394);
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(44409));
var componentName = "Tooltip";
var elementIdentifiers = (0, shared_1.tuple)("containerV4", "button", "tipOuterContainer", "tipInnerContainer", "textContainer", "body");
var ToolTipTheme;
(function (ToolTipTheme) {
    ToolTipTheme["Light"] = "light";
    ToolTipTheme["Grey"] = "grey";
    ToolTipTheme["Dark"] = "dark";
    ToolTipTheme["V3"] = "v3";
    ToolTipTheme["V4"] = "v4";
})(ToolTipTheme = exports.ToolTipTheme || (exports.ToolTipTheme = {}));
var ToolTipSize;
(function (ToolTipSize) {
    ToolTipSize["Normal"] = "normal";
    ToolTipSize["Small"] = "small";
})(ToolTipSize = exports.ToolTipSize || (exports.ToolTipSize = {}));
var States;
(function (States) {
    States[States["Open"] = 0] = "Open";
    States[States["Closed"] = 1] = "Closed";
})(States || (States = {}));
var getTooltipIcon = (_a = {},
    _a[States.Closed] = (_b = {},
        _b[ToolTipTheme.Light] = (_c = {},
            _c[ToolTipSize.Normal] = shared_1.IconName.Info,
            _c[ToolTipSize.Small] = shared_1.IconName.InfoSmall,
            _c),
        _b[ToolTipTheme.Dark] = (_d = {},
            _d[ToolTipSize.Normal] = shared_1.IconName.InfoDark,
            _d[ToolTipSize.Small] = shared_1.IconName.InfoDarkSmall,
            _d),
        _b[ToolTipTheme.V3] = (_e = {},
            _e[ToolTipSize.Normal] = shared_1.IconName.InfoV3,
            _e[ToolTipSize.Small] = shared_1.IconName.InfoV3Small,
            _e),
        _b[ToolTipTheme.Grey] = (_f = {},
            _f[ToolTipSize.Normal] = shared_1.IconName.InfoGreyIcon,
            _f[ToolTipSize.Small] = shared_1.IconName.InfoGreyIcon,
            _f),
        _b),
    _a[States.Open] = (_g = {},
        _g[ToolTipTheme.Light] = (_h = {},
            _h[ToolTipSize.Normal] = shared_1.IconName.Close,
            _h[ToolTipSize.Small] = shared_1.IconName.CloseSmall,
            _h),
        _g[ToolTipTheme.Dark] = (_j = {},
            _j[ToolTipSize.Normal] = shared_1.IconName.CloseDark,
            _j[ToolTipSize.Small] = shared_1.IconName.CloseDarkSmall,
            _j),
        _g[ToolTipTheme.V3] = (_k = {},
            _k[ToolTipSize.Normal] = shared_1.IconName.CloseV3,
            _k[ToolTipSize.Small] = shared_1.IconName.CloseV3Small,
            _k),
        _g[ToolTipTheme.Grey] = (_l = {},
            _l[ToolTipSize.Normal] = shared_1.IconName.InfoFilledIcon,
            _l[ToolTipSize.Small] = shared_1.IconName.InfoFilledIcon,
            _l),
        _g),
    _a);
var toggleOpenCloseState = function (state) {
    return state === States.Open ? States.Closed : States.Open;
};
var Tooltip = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var openEvent = _a.openEvent, closeEvent = _a.closeEvent, children = _a.children, _h = _a.withValidation, withValidation = _h === void 0 ? false : _h, _j = _a.alwaysOpenDown, alwaysOpenDown = _j === void 0 ? false : _j, _k = _a.theme, theme = _k === void 0 ? ToolTipTheme.Light : _k, _l = _a.size, size = _l === void 0 ? ToolTipSize.Normal : _l, isOpened = _a.isOpened, _m = _a.position, position = _m === void 0 ? "top" : _m, body = _a.body, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["openEvent", "closeEvent", "children", "withValidation", "alwaysOpenDown", "theme", "size", "isOpened", "position", "body", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _o = (0, react_1.useState)(States.Closed), openCloseState = _o[0], setOpenCloseState = _o[1];
    var ref = ovr.containerV4.ref || (refs === null || refs === void 0 ? void 0 : refs.container) || react_1.default.useRef(null);
    (0, use_onclickoutside_1.default)(ref, function () {
        setOpenCloseState(States.Closed);
    });
    var openCloseEvents = function (event) {
        if (openEvent && openCloseState === States.Closed) {
            openEvent(event);
        }
        if (closeEvent && openCloseState === States.Open) {
            closeEvent(event);
        }
    };
    var clickHandler = function (event) {
        openCloseEvents(event);
        setOpenCloseState(toggleOpenCloseState(openCloseState));
        event.preventDefault(); // Prevent default label functionality which put focus on the field
    };
    var keyDownHandler = function (event) {
        if ([keycodes_1.SPACE, keycodes_1.ENTER].includes(event.keyCode)) {
            openCloseEvents(event);
            setOpenCloseState(toggleOpenCloseState(openCloseState));
            event.preventDefault(); // prevent default page scrolling when using spacebar
        }
    };
    var iconName = theme !== ToolTipTheme.V4 && getTooltipIcon[openCloseState][theme][size];
    if (theme === ToolTipTheme.V4) {
        return (react_1.default.createElement("div", __assign({}, ovr.containerV4, { className: (0, classnames_1.default)(ovr.containerV4.className, className), onMouseEnter: function () {
                return isOpened === undefined && setOpenCloseState(States.Open);
            }, onMouseLeave: function () {
                return isOpened === undefined && setOpenCloseState(States.Closed);
            }, "aria-expanded": openCloseState === States.Open || Boolean(isOpened), "aria-haspopup": "true" }, props),
            react_1.default.createElement("div", __assign({}, ovr.body, { className: (0, classnames_1.default)(ovr.body.className, style_scss_1.default["position-".concat(position)], (_b = {},
                    _b[style_scss_1.default.show] = openCloseState === States.Open || Boolean(isOpened),
                    _b)) }), body),
            children));
    }
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)((_c = {},
            _c[style_scss_1.default.alwaysOpenDown] = alwaysOpenDown,
            _c)) },
        react_1.default.createElement("div", __assign({}, ovr.button, props, { role: "button", className: (0, classnames_1.default)(openCloseState === States.Open ? style_scss_1.default.buttonOpen : style_scss_1.default.buttonClosed, (_d = {}, _d[style_scss_1.default.buttonDark] = theme === ToolTipTheme.Dark, _d), (_e = {}, _e[style_scss_1.default.buttonGrey] = theme === ToolTipTheme.Grey, _e), size === ToolTipSize.Normal ? style_scss_1.default.buttonNormal : style_scss_1.default.buttonSmall, withValidation && style_scss_1.default.buttonWithValidation, theme === ToolTipTheme.V3 && style_scss_1.default.buttonV3, ovr.button.className, className), onClick: clickHandler, onKeyDown: keyDownHandler, "aria-label": "Tooltip button", "aria-expanded": openCloseState === States.Open, tabIndex: 0 }),
            react_1.default.createElement(shared_1.Icon, { name: iconName })),
        react_1.default.createElement("div", __assign({}, ovr.tipOuterContainer, { className: (0, classnames_1.default)((_f = {}, _f[style_scss_1.default.outerContainerOpen] = openCloseState === States.Open, _f), ovr.tipOuterContainer.className), hidden: openCloseState !== States.Open }),
            react_1.default.createElement("div", __assign({}, ovr.tipInnerContainer, { className: (0, classnames_1.default)(openCloseState === States.Open && style_scss_1.default.tipOpen, (_g = {},
                    _g[style_scss_1.default.tipWithValidation] = withValidation && openCloseState === States.Open,
                    _g[style_scss_1.default.tipSmall] = size === ToolTipSize.Small,
                    _g[style_scss_1.default.tipOpenV3] = theme === ToolTipTheme.V3,
                    _g[style_scss_1.default.tipGreySmall] = theme === ToolTipTheme.Grey,
                    _g), ovr.tipInnerContainer.className) }),
                react_1.default.createElement("div", __assign({}, ovr.textContainer, { className: (0, classnames_1.default)(theme === ToolTipTheme.V3 && style_scss_1.default.textContainerV3, ovr.textContainer.className) }), children)))));
};
Tooltip.displayName = componentName;
exports["default"] = Tooltip;


/***/ }),

/***/ 970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ensureHighlightedItemIsVisible = exports.formatOption = exports.select = exports.filterOptions = exports.keyboardInteraction = void 0;
var keycodes_1 = __webpack_require__(52394);
var keyboardInteraction = function (_a) {
    var keyCode = _a.keyCode, count = _a.count, state = _a.state, setState = _a.setState, callback = _a.callback;
    switch (keyCode) {
        case keycodes_1.UP:
            if (state.currentOption !== null) {
                var currentOption = state.currentOption > 0
                    ? state.currentOption - 1
                    : state.currentOption;
                setState(__assign(__assign({}, state), { currentOption: currentOption }));
            }
            break;
        case keycodes_1.DOWN:
            if (state.currentOption !== null) {
                var currentOption = state.currentOption < count - 1
                    ? state.currentOption + 1
                    : state.currentOption;
                setState(__assign(__assign({}, state), { currentOption: currentOption }));
            }
            else {
                setState(__assign(__assign({}, state), { currentOption: 0 }));
            }
            break;
        case keycodes_1.ENTER:
            if (state.currentOption !== null) {
                callback();
            }
            break;
        default:
            break;
    }
};
exports.keyboardInteraction = keyboardInteraction;
var filterOptions = function (maxResults, options, term) {
    var count = 0;
    var filteredOptions = [];
    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
        var option = options_1[_i];
        if (count >= maxResults) {
            break;
        }
        if (option.description.toLowerCase().indexOf(term.toLowerCase().trim()) > -1) {
            filteredOptions.push(option);
            count++;
        }
    }
    return filteredOptions;
};
exports.filterOptions = filterOptions;
var select = function (option, state, setState, onValue, onSelect) {
    onValue(option.code);
    onSelect(option.code);
    setState(__assign(__assign({}, state), { filteredOptions: [], term: option.description, currentOption: null, shouldShowOptions: false }));
};
exports.select = select;
var formatOption = function (option, untrimmedTerm, shouldNotHighlightResults) {
    if (shouldNotHighlightResults) {
        return option;
    }
    var term = untrimmedTerm.trim();
    var index = option.toLowerCase().indexOf(term.toLowerCase());
    var matched = option.substr(index, term.length);
    var formatted = "<strong>".concat(matched, "</strong>");
    return option.replace(matched, formatted);
};
exports.formatOption = formatOption;
// https://github.com/moroshko/react-autosuggest/blob/804d85b762f5fe769bb14df6bb8d317da3802c13/src/Autowhatever.js#L334
var ensureHighlightedItemIsVisible = function (highlightedItem, itemsContainer) {
    if (!highlightedItem || !itemsContainer) {
        return;
    }
    var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer
        ? highlightedItem.offsetTop
        : highlightedItem.offsetTop - itemsContainer.offsetTop;
    var scrollTop = itemsContainer.scrollTop; // Top of the visible area
    if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
    }
    else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight >
        scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop =
            itemOffsetRelativeToContainer +
                highlightedItem.offsetHeight -
                itemsContainer.offsetHeight;
    }
    if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
    }
};
exports.ensureHighlightedItemIsVisible = ensureHighlightedItemIsVisible;


/***/ }),

/***/ 8240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var use_onclickoutside_1 = __importDefault(__webpack_require__(37251));
var shared_1 = __webpack_require__(89574);
var textInput_1 = __importDefault(__webpack_require__(49077));
var helpers_1 = __webpack_require__(970);
var style_scss_1 = __importDefault(__webpack_require__(344));
var componentName = "Typeahead";
var elementIdentifiers = (0, shared_1.tuple)("container", "inputContainer", "input", "results", "option");
var DEFAULT_MAX_RESULTS = 5;
var TypeAhead = function (_a) {
    var _b;
    var onChange = _a.onChange, onKeyDown = _a.onKeyDown, _c = _a.onValue, onValue = _c === void 0 ? function () { return null; } : _c, _d = _a.onSelectOption, onSelectOption = _d === void 0 ? function () { return null; } : _d, options = _a.options, _e = _a.maxResults, maxResults = _e === void 0 ? DEFAULT_MAX_RESULTS : _e, value = _a.value, _f = _a.isValid, isValid = _f === void 0 ? true : _f, _g = _a.placeholder, placeholder = _g === void 0 ? "" : _g, _h = _a.shouldNotFilterOptions, shouldNotFilterOptions = _h === void 0 ? false : _h, _j = _a.shouldNotHighlightResults, shouldNotHighlightResults = _j === void 0 ? false : _j, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["onChange", "onKeyDown", "onValue", "onSelectOption", "options", "maxResults", "value", "isValid", "placeholder", "shouldNotFilterOptions", "shouldNotHighlightResults", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var rehydrateValue = options.find(function (op) { return op.code === value; });
    var initialValue = rehydrateValue ? rehydrateValue.description : value;
    var _k = (0, react_1.useState)({
        filteredOptions: [],
        term: initialValue || "",
        value: value || "",
        currentOption: null,
        shouldShowOptions: true
    }), state = _k[0], setState = _k[1];
    var ref = (0, react_1.useRef)(null);
    var itemsContainer = (0, react_1.useRef)(null);
    var highlightedItem = (0, react_1.useRef)(null);
    var highlightedOption = (0, react_1.useRef)(null);
    (0, use_onclickoutside_1.default)(ref, function () {
        setState(__assign(__assign({}, state), { filteredOptions: [], shouldShowOptions: false }));
    });
    var onKeyDownHandler = function (e) {
        (0, helpers_1.keyboardInteraction)({
            keyCode: e.keyCode,
            count: options.length,
            state: state,
            setState: setState,
            callback: function () {
                if (highlightedOption.current) {
                    (0, helpers_1.select)(highlightedOption.current, state, setState, onValue, onSelectOption);
                }
            }
        });
        if (onKeyDown) {
            onKeyDown(e);
        }
    };
    var onChangeHandler = function (e) {
        var filteredOptions = (0, helpers_1.filterOptions)(maxResults, options, e.target.value);
        setState(__assign(__assign({}, state), { term: e.target.value, filteredOptions: filteredOptions, currentOption: null, shouldShowOptions: true }));
        onValue(e.target.value);
        if (onChange) {
            onChange(e);
        }
    };
    var optionsToShow = shouldNotFilterOptions
        ? options
        : state.filteredOptions;
    (0, react_1.useEffect)(function () {
        (0, helpers_1.ensureHighlightedItemIsVisible)(highlightedItem.current, itemsContainer.current);
    });
    return (react_1.default.createElement("div", __assign({}, ovr.container, { ref: ovr.container.ref || ref }),
        react_1.default.createElement(textInput_1.default, __assign({}, props, { type: "text", placeholder: placeholder, autoComplete: "off", value: state.term, isValid: isValid, onKeyDown: onKeyDownHandler, onChange: onChangeHandler, className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.inputInvalid] = !isValid, _b), ovr.input.className, className), testIds: {
                input: testIds && testIds.input ? testIds.input : undefined
            }, refs: { input: ovr.input.ref } })),
        state.shouldShowOptions && optionsToShow.length > 0 ? (react_1.default.createElement("ul", __assign({}, ovr.results, { ref: itemsContainer }), optionsToShow.map(function (option, index) {
            var _a;
            var prefix = props.id || componentName;
            var suffix = option.code.trim().toLowerCase();
            var optionId = "".concat(prefix, "-").concat(suffix);
            var currentOptionHighlighted = index === state.currentOption;
            if (currentOptionHighlighted) {
                highlightedOption.current = option;
            }
            return (react_1.default.createElement("li", { key: index, className: style_scss_1.default.item },
                react_1.default.createElement("button", __assign({}, ovr.option, { id: optionId, onClick: function () {
                        return (0, helpers_1.select)(option, state, setState, onValue, onSelectOption);
                    }, dangerouslySetInnerHTML: {
                        __html: (0, helpers_1.formatOption)(option.description, state.term, shouldNotHighlightResults)
                    }, className: (0, classnames_1.default)((_a = {}, _a[style_scss_1.default.optionSelected] = currentOptionHighlighted, _a), ovr.option.className), ref: currentOptionHighlighted ? highlightedItem : undefined, "data-testid": "".concat(ovr.option["data-testid"], "-").concat(suffix) }))));
        }))) : null));
};
TypeAhead.displayName = componentName;
exports["default"] = TypeAhead;


/***/ }),

/***/ 27309:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var index_1 = __webpack_require__(55074);
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(36930));
var componentName = "ValidationIcon";
var elementIdentifiers = (0, shared_1.tuple)("iconContainer", "icon");
var ValidationIcon = function (_a) {
    var _b, _c;
    var _d = _a.isValid, isValid = _d === void 0 ? false : _d, _e = _a.isTouched, isTouched = _e === void 0 ? false : _e, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["isValid", "isTouched", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return isTouched ? (react_1.default.createElement("div", __assign({}, ovr.iconContainer, props, { className: (0, classnames_1.default)(ovr.iconContainer.className, className) }),
        react_1.default.createElement("span", __assign({}, ovr.icon, { className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.iconValid] = Boolean(isValid), _b), (_c = {}, _c[style_scss_1.default.iconInvalid] = Boolean(!isValid), _c), ovr.icon.className) }),
            react_1.default.createElement(index_1.Icon, { name: isValid ? index_1.IconName.Valid : index_1.IconName.Invalid })))) : null;
};
ValidationIcon.displayName = componentName;
exports["default"] = ValidationIcon;


/***/ }),

/***/ 68443:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var lodash_omit_1 = __importDefault(__webpack_require__(34590));
var lodash_pick_1 = __importDefault(__webpack_require__(47049));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var fieldError_1 = __importDefault(__webpack_require__(12223));
var validationIcon_1 = __importDefault(__webpack_require__(27309));
var style_scss_1 = __importDefault(__webpack_require__(54278));
var elementIdentifiers = (0, shared_1.tuple)("componentContainer", "errorContainer", "innerContainer", "validationContainer", "icon", "error");
var withValidation = function (WrappedComponent) {
    var componentName = "WithValidation(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    var WithValidation = function (props) {
        var _a;
        var isTouched = props.isTouched, isValid = props.isValid, _b = props.validationIconEnabled, validationIconEnabled = _b === void 0 ? true : _b, error = props.error, classOverrides = props.classOverrides, testIds = props.testIds, refs = props.refs, componentProps = __rest(props, ["isTouched", "isValid", "validationIconEnabled", "error", "classOverrides", "testIds", "refs"]);
        var ovr = (0, shared_1.useOverrides)({
            elementIdentifiers: elementIdentifiers,
            componentName: componentName,
            id: props.id,
            classOverrides: classOverrides,
            testIds: testIds,
            refs: refs,
            stylesheet: style_scss_1.default
        });
        // From all possible overrides select only ones for passing down to an element
        var filterOverrides = function (strategy, ovrSelection) {
            return Object.entries({ classOverrides: classOverrides, testIds: testIds, refs: refs }).reduce(function (overrides, _a) {
                var _b;
                var overrideKey = _a[0], overrideValues = _a[1];
                var filterMethod = strategy === "pick" ? lodash_pick_1.default : lodash_omit_1.default;
                var filteredOverrideValues = filterMethod(overrideValues, ovrSelection);
                return __assign(__assign({}, overrides), (_b = {}, _b[overrideKey] = Object.entries(filteredOverrideValues).length
                    ? filteredOverrideValues
                    : undefined, _b));
            }, {});
        };
        var componentOverrides = filterOverrides("omit", elementIdentifiers);
        var validationIconOverrides = filterOverrides("pick", ["icon"]);
        var errorOverrides = filterOverrides("pick", ["error"]);
        return (react_1.default.createElement("div", __assign({}, ovr.validationContainer, { className: (0, classnames_1.default)((_a = {}, _a[style_scss_1.default.untouched] = validationIconEnabled && !isTouched, _a), ovr.validationContainer.className) }),
            react_1.default.createElement("div", __assign({}, ovr.innerContainer),
                react_1.default.createElement("div", __assign({}, ovr.componentContainer),
                    react_1.default.createElement(WrappedComponent, __assign({}, componentProps, componentOverrides, { isValid: isValid }))),
                validationIconEnabled && (react_1.default.createElement(validationIcon_1.default, __assign({}, validationIconOverrides, { isValid: isValid, isTouched: isTouched })))),
            error ? (react_1.default.createElement("div", __assign({}, ovr.errorContainer),
                react_1.default.createElement(fieldError_1.default, __assign({}, errorOverrides, { message: error })))) : null));
    };
    WithValidation.displayName = componentName;
    return WithValidation;
};
exports["default"] = withValidation;


/***/ }),

/***/ 57397:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatHelper = void 0;
var ChatHelper_1 = __webpack_require__(75592);
Object.defineProperty(exports, "ChatHelper", ({ enumerable: true, get: function () { return ChatHelper_1.ChatHelper; } }));


/***/ }),

/***/ 75592:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatHelper = void 0;
var globals_1 = __webpack_require__(74495);
var load = function (initialWidgetId) {
    return new Promise(function (resolve) {
        // Based on https://developer.snapengage.com/#api-placement-and-availability
        var hasLoaded = false;
        function afterLoading() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (!hasLoaded &&
                        (!this.readyState ||
                            this.readyState === "loaded" ||
                            this.readyState === "complete")) {
                        hasLoaded = true;
                        resolve();
                    }
                    return [2 /*return*/];
                });
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var snapEngageScriptElement = (0, globals_1.getDocument)().createElement("script");
        snapEngageScriptElement.type = "text/javascript";
        snapEngageScriptElement.async = true;
        snapEngageScriptElement.src = "//storage.googleapis.com/code.snapengage.com/js/".concat(initialWidgetId, ".js");
        snapEngageScriptElement.onload = afterLoading;
        snapEngageScriptElement.onreadystatechange = afterLoading;
        var firstScriptInDocument = (0, globals_1.getDocument)().getElementsByTagName("script")[0];
        if (firstScriptInDocument && firstScriptInDocument.parentNode) {
            firstScriptInDocument.parentNode.insertBefore(snapEngageScriptElement, firstScriptInDocument);
        }
    });
};
var isLoaded = function () { return (0, globals_1.getSnapEngage)() !== undefined; };
var open = function () {
    var snapEngage = (0, globals_1.getSnapEngage)();
    if (snapEngage) {
        snapEngage.startLink();
    }
};
var areAgentsAvailable = function () {
    return new Promise(function (resolve) {
        var snapEngage = (0, globals_1.getSnapEngage)();
        if (snapEngage) {
            snapEngage.getAgentStatusAsync(function (online) { return resolve(online); });
        }
        else {
            resolve(false);
        }
    });
};
var openProactively = function (_a) {
    var message = _a.message, _b = _a.doForce, doForce = _b === void 0 ? false : _b, _c = _a.doWhenAgentsOffline, doWhenAgentsOffline = _c === void 0 ? false : _c;
    var snapEngage = (0, globals_1.getSnapEngage)();
    if (snapEngage) {
        snapEngage.openProactiveChat(doForce, doWhenAgentsOffline, message);
    }
};
var setNoProactiveChatDelay = function (delayInMinutes) {
    var snapEngage = (0, globals_1.getSnapEngage)();
    if (snapEngage) {
        snapEngage.setNoProactiveChatDelay(delayInMinutes);
    }
};
var switchChatAgentChannel = function (widgetId) {
    return new Promise(function (resolve) {
        var snapEngage = (0, globals_1.getSnapEngage)();
        if (snapEngage) {
            snapEngage.switchWidget(widgetId, function () {
                resolve();
            });
        }
        else {
            resolve();
        }
    });
};
var setUserName = function (name) {
    var snapEngage = (0, globals_1.getSnapEngage)();
    if (snapEngage) {
        snapEngage.setUserName(name);
    }
};
var setUserEmailAddress = function (emailAddress, doPreventChanging) {
    if (doPreventChanging === void 0) { doPreventChanging = false; }
    var snapEngage = (0, globals_1.getSnapEngage)();
    if (snapEngage) {
        snapEngage.setUserEmail(emailAddress, doPreventChanging);
    }
};
var enableSound = function () {
    var snapEngage = (0, globals_1.getSnapEngage)();
    if (snapEngage) {
        snapEngage.allowChatSound(true);
    }
};
var disableSound = function () {
    var snapEngage = (0, globals_1.getSnapEngage)();
    if (snapEngage) {
        snapEngage.allowChatSound(false);
    }
};
exports.ChatHelper = {
    load: load,
    isLoaded: isLoaded,
    open: open,
    areAgentsAvailable: areAgentsAvailable,
    openProactively: openProactively,
    setNoProactiveChatDelay: setNoProactiveChatDelay,
    switchChatAgentChannel: switchChatAgentChannel,
    setUserName: setUserName,
    setUserEmailAddress: setUserEmailAddress,
    enableSound: enableSound,
    disableSound: disableSound
};


/***/ }),

/***/ 74495:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSnapEngage = exports.getDocument = void 0;
var getDocument = function () { return document; };
exports.getDocument = getDocument;
var getSnapEngage = function () { return window.SnapEngage; };
exports.getSnapEngage = getSnapEngage;


/***/ }),

/***/ 92457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(55454), exports);


/***/ }),

/***/ 55454:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useWindowSize = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
function useWindowSize() {
    var _a = react_1.default.useState({
        width: null,
        height: null
    }), size = _a[0], setSize = _a[1];
    react_1.default.useLayoutEffect(function () {
        var handleResize = function () {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return size;
}
exports.useWindowSize = useWindowSize;


/***/ }),

/***/ 80341:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* istanbul ignore file */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validators = void 0;
__exportStar(__webpack_require__(49429), exports);
__exportStar(__webpack_require__(58261), exports);
__exportStar(__webpack_require__(13174), exports);
__exportStar(__webpack_require__(89574), exports);
__exportStar(__webpack_require__(92457), exports);
__exportStar(__webpack_require__(57397), exports);
__exportStar(__webpack_require__(79090), exports);
__exportStar(__webpack_require__(34237), exports);
var validators = __importStar(__webpack_require__(98260));
exports.validators = validators;


/***/ }),

/***/ 69332:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(6343), exports);


/***/ }),

/***/ 6343:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonColour = exports.ButtonSize = void 0;
var ButtonSize;
(function (ButtonSize) {
    /** @deprecated */
    ButtonSize["XSmall"] = "x-small";
    ButtonSize["Small"] = "small";
    ButtonSize["Medium"] = "medium";
    ButtonSize["Large"] = "large";
    ButtonSize["Icon"] = "icon";
})(ButtonSize = exports.ButtonSize || (exports.ButtonSize = {}));
var ButtonColour;
(function (ButtonColour) {
    ButtonColour["Primary"] = "primary";
    ButtonColour["Secondary"] = "secondary";
    ButtonColour["Tertiary"] = "tertiary";
    ButtonColour["TertiaryLight"] = "tertiaryLight";
    ButtonColour["Ghost"] = "ghost";
    ButtonColour["Destructive"] = "destructive";
    ButtonColour["Success"] = "success";
    ButtonColour["Lime"] = "lime";
    ButtonColour["Black"] = "black";
    ButtonColour["DarkGreen"] = "darkGreen";
    ButtonColour["DarkYellow"] = "darkYellow";
})(ButtonColour = exports.ButtonColour || (exports.ButtonColour = {}));


/***/ }),

/***/ 7933:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var add_react_svg_1 = __importDefault(__webpack_require__(50434));
var alert_react_svg_1 = __importDefault(__webpack_require__(70070));
var add_dark_react_svg_1 = __importDefault(__webpack_require__(77454));
var remove_react_svg_1 = __importDefault(__webpack_require__(85909));
var remove_dark_react_svg_1 = __importDefault(__webpack_require__(35833));
var left_react_svg_1 = __importDefault(__webpack_require__(51244));
var right_react_svg_1 = __importDefault(__webpack_require__(22906));
var up_reskin_react_svg_1 = __importDefault(__webpack_require__(63434));
var done_react_svg_1 = __importDefault(__webpack_require__(21352));
var down_reskin_react_svg_1 = __importDefault(__webpack_require__(47877));
var delete_bucket_react_svg_1 = __importDefault(__webpack_require__(25014));
var invalid_react_svg_1 = __importDefault(__webpack_require__(55433));
var valid_react_svg_1 = __importDefault(__webpack_require__(43144));
var info_react_svg_1 = __importDefault(__webpack_require__(40935));
var info_small_react_svg_1 = __importDefault(__webpack_require__(74053));
var info_v3_react_svg_1 = __importDefault(__webpack_require__(74953));
var info_v3_small_react_svg_1 = __importDefault(__webpack_require__(76904));
var close_react_svg_1 = __importDefault(__webpack_require__(60251));
var close_small_react_svg_1 = __importDefault(__webpack_require__(61148));
var close_v3_react_svg_1 = __importDefault(__webpack_require__(79984));
var close_v3_small_react_svg_1 = __importDefault(__webpack_require__(71302));
var close_dark_react_svg_1 = __importDefault(__webpack_require__(13238));
var close_dark_small_react_svg_1 = __importDefault(__webpack_require__(77205));
var info_dark_react_svg_1 = __importDefault(__webpack_require__(57791));
var info_dark_small_react_svg_1 = __importDefault(__webpack_require__(80904));
var phone_react_svg_1 = __importDefault(__webpack_require__(32577));
var calendar_react_svg_1 = __importDefault(__webpack_require__(65849));
var download_react_svg_1 = __importDefault(__webpack_require__(31343));
var send_react_svg_1 = __importDefault(__webpack_require__(48228));
var info_filled_react_svg_1 = __importDefault(__webpack_require__(94130));
var info_grey_react_svg_1 = __importDefault(__webpack_require__(39060));
var check_new_react_svg_1 = __importDefault(__webpack_require__(46764));
var close_new_react_svg_1 = __importDefault(__webpack_require__(91948));
var componentName = "Icon";
var iconComponentTypes = {
    Add: add_react_svg_1.default,
    Alert: alert_react_svg_1.default,
    AddDark: add_dark_react_svg_1.default,
    Remove: remove_react_svg_1.default,
    RemoveDark: remove_dark_react_svg_1.default,
    LeftArrow: left_react_svg_1.default,
    RightArrow: right_react_svg_1.default,
    UpArrow: up_reskin_react_svg_1.default,
    Done: done_react_svg_1.default,
    DownArrow: down_reskin_react_svg_1.default,
    DeleteBucket: delete_bucket_react_svg_1.default,
    Valid: valid_react_svg_1.default,
    Invalid: invalid_react_svg_1.default,
    Info: info_react_svg_1.default,
    InfoV3: info_v3_react_svg_1.default,
    InfoSmall: info_small_react_svg_1.default,
    InfoV3Small: info_v3_small_react_svg_1.default,
    InfoGreyIcon: info_grey_react_svg_1.default,
    InfoFilledIcon: info_filled_react_svg_1.default,
    Close: close_react_svg_1.default,
    CloseV3: close_v3_react_svg_1.default,
    CloseSmall: close_small_react_svg_1.default,
    CloseV3Small: close_v3_small_react_svg_1.default,
    InfoDark: info_dark_react_svg_1.default,
    InfoDarkSmall: info_dark_small_react_svg_1.default,
    CloseDark: close_dark_react_svg_1.default,
    CloseDarkSmall: close_dark_small_react_svg_1.default,
    Phone: phone_react_svg_1.default,
    Calendar: calendar_react_svg_1.default,
    Download: download_react_svg_1.default,
    Send: send_react_svg_1.default,
    CheckNew: check_new_react_svg_1.default,
    CloseNew: close_new_react_svg_1.default
};
var Icon = function (_a) {
    var name = _a.name;
    var IconComponent = iconComponentTypes[name];
    return (react_1.default.createElement(IconComponent, { className: "".concat(name, "-svg"), "aria-label": "".concat(name, " icon") }));
};
Icon.displayName = componentName;
exports["default"] = Icon;


/***/ }),

/***/ 55074:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Icon = void 0;
__exportStar(__webpack_require__(56737), exports);
var Icon_1 = __webpack_require__(7933);
Object.defineProperty(exports, "Icon", ({ enumerable: true, get: function () { return __importDefault(Icon_1).default; } }));


/***/ }),

/***/ 56737:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IconName = exports.IconAlignment = void 0;
var IconAlignment;
(function (IconAlignment) {
    IconAlignment["Left"] = "Left";
    IconAlignment["Right"] = "Right";
})(IconAlignment = exports.IconAlignment || (exports.IconAlignment = {}));
var IconName;
(function (IconName) {
    IconName["Alert"] = "Alert";
    IconName["InfoGreyIcon"] = "InfoGreyIcon";
    IconName["InfoFilledIcon"] = "InfoFilledIcon";
    IconName["LeftArrow"] = "LeftArrow";
    IconName["RightArrow"] = "RightArrow";
    IconName["UpArrow"] = "UpArrow";
    IconName["Done"] = "Done";
    IconName["DownArrow"] = "DownArrow";
    IconName["DeleteBucket"] = "DeleteBucket";
    IconName["Add"] = "Add";
    IconName["Remove"] = "Remove";
    IconName["Valid"] = "Valid";
    IconName["Invalid"] = "Invalid";
    IconName["Info"] = "Info";
    IconName["InfoSmall"] = "InfoSmall";
    IconName["InfoV3"] = "InfoV3";
    IconName["InfoV3Small"] = "InfoV3Small";
    IconName["Close"] = "Close";
    IconName["CloseSmall"] = "CloseSmall";
    IconName["CloseV3"] = "CloseV3";
    IconName["CloseV3Small"] = "CloseV3Small";
    IconName["InfoDark"] = "InfoDark";
    IconName["InfoDarkSmall"] = "InfoDarkSmall";
    IconName["CloseDark"] = "CloseDark";
    IconName["CloseDarkSmall"] = "CloseDarkSmall";
    IconName["Phone"] = "Phone";
    IconName["Calender"] = "Calendar";
    IconName["Download"] = "Download";
    IconName["Send"] = "Send";
    IconName["CheckNew"] = "CheckNew";
    IconName["CloseNew"] = "CloseNew";
})(IconName = exports.IconName || (exports.IconName = {}));


/***/ }),

/***/ 89574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(69332), exports);
__exportStar(__webpack_require__(55074), exports);
__exportStar(__webpack_require__(46235), exports);
__exportStar(__webpack_require__(86006), exports);
__exportStar(__webpack_require__(97346), exports);


/***/ }),

/***/ 52394:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DOWN = exports.RIGHT = exports.UP = exports.LEFT = exports.TAB = exports.SPACE = exports.ESCAPE = exports.ENTER = void 0;
exports.ENTER = 13;
exports.ESCAPE = 27;
exports.SPACE = 32;
exports.TAB = 9;
exports.LEFT = 37;
exports.UP = 38;
exports.RIGHT = 39;
exports.DOWN = 40;


/***/ }),

/***/ 87382:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 61040:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generateClassName = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var generateClassName = function (_a) {
    var classOverrides = _a.classOverrides, elementIdentifier = _a.elementIdentifier, stylesheet = _a.stylesheet;
    return (0, classnames_1.default)(stylesheet && stylesheet[elementIdentifier], classOverrides && classOverrides[elementIdentifier]);
};
exports.generateClassName = generateClassName;


/***/ }),

/***/ 55932:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generateDataTestid = void 0;
var generateDataTestid = function (_a) {
    var testIds = _a.testIds, elementIdentifier = _a.elementIdentifier, componentName = _a.componentName, id = _a.id;
    var prefix = id || componentName;
    var tidSuffix = (testIds && testIds[elementIdentifier]) || elementIdentifier;
    return "".concat(prefix, "-").concat(tidSuffix);
};
exports.generateDataTestid = generateDataTestid;


/***/ }),

/***/ 39354:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generateOverrides = void 0;
var generateClassName_1 = __webpack_require__(61040);
var generateDataTestid_1 = __webpack_require__(55932);
var generateRef_1 = __webpack_require__(41259);
var generateOverrides = function (_a) {
    var classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, elementIdentifiers = _a.elementIdentifiers, componentName = _a.componentName, id = _a.id, stylesheet = _a.stylesheet;
    var type = elementIdentifiers.reduce(function (accumulator, elementIdentifier) {
        accumulator.type[elementIdentifier] = {
            className: (0, generateClassName_1.generateClassName)({
                classOverrides: classOverrides,
                elementIdentifier: elementIdentifier,
                stylesheet: stylesheet
            }),
            "data-testid": (0, generateDataTestid_1.generateDataTestid)({
                testIds: testIds,
                elementIdentifier: elementIdentifier,
                componentName: componentName,
                id: id
            }),
            ref: (0, generateRef_1.generateRef)({ refs: refs, elementIdentifier: elementIdentifier })
        };
        return accumulator;
    }, { type: {} }).type;
    return type;
};
exports.generateOverrides = generateOverrides;


/***/ }),

/***/ 41259:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generateRef = void 0;
var generateRef = function (_a) {
    var refs = _a.refs, elementIdentifier = _a.elementIdentifier;
    return (refs && refs[elementIdentifier]) || undefined;
};
exports.generateRef = generateRef;


/***/ }),

/***/ 46235:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useOverrides = exports.tuple = exports.IOverrideProps = void 0;
__exportStar(__webpack_require__(87382), exports);
var generateOverrides_1 = __webpack_require__(39354);
Object.defineProperty(exports, "IOverrideProps", ({ enumerable: true, get: function () { return generateOverrides_1.IOverrideProps; } }));
var tuple_1 = __webpack_require__(40697);
Object.defineProperty(exports, "tuple", ({ enumerable: true, get: function () { return tuple_1.tuple; } }));
var useOverrides_1 = __webpack_require__(62465);
Object.defineProperty(exports, "useOverrides", ({ enumerable: true, get: function () { return useOverrides_1.useOverrides; } }));


/***/ }),

/***/ 40697:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.tuple = void 0;
/*
Turns arguments "A", "B", "C" into tuple ["A", "B", "C"],
which then turns in to type "A" | "B" | "C"
when run through this: (typeof tuple)[number];
*/
var tuple = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args;
};
exports.tuple = tuple;


/***/ }),

/***/ 62465:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useOverrides = void 0;
var react_1 = __webpack_require__(99497);
var generateOverrides_1 = __webpack_require__(39354);
/*
The useOverrides calls generateOverrides in the component. It should only call generateOverrides once
as the dependencies to it (elementIdentifiers, classOverrides, id, etc.) should never change.
If we did not use this function and used generateOverrides instead that function would get called
and overrides would get generated on every render.
*/
var useOverrides = function (params) {
    return (0, react_1.useMemo)(function () { return (0, generateOverrides_1.generateOverrides)(params); }, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        params.id,
        params.componentName
    ], params.elementIdentifiers, true), Object.values(params.classOverrides || {}), true), Object.values(params.testIds || {}), true), Object.values(params.refs || {}), true), Object.values(params.stylesheet || {}), true));
};
exports.useOverrides = useOverrides;


/***/ }),

/***/ 86006:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Direction = exports.MessageType = exports.FontWeight = exports.Alignment = void 0;
var Alignment;
(function (Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
var FontWeight;
(function (FontWeight) {
    FontWeight["REGULAR"] = "regular";
    FontWeight["SEMI_BOLD"] = "semi-bold";
    FontWeight["BOLD"] = "bold";
})(FontWeight = exports.FontWeight || (exports.FontWeight = {}));
var MessageType;
(function (MessageType) {
    MessageType["ERROR"] = "error";
    MessageType["WARNING"] = "warning";
    MessageType["SUCCESS"] = "success";
    MessageType["INFORMATION"] = "information";
    MessageType["PENDING"] = "pending";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var Direction;
(function (Direction) {
    Direction["LEFT"] = "left";
    Direction["RIGHT"] = "right";
})(Direction = exports.Direction || (exports.Direction = {}));


/***/ }),

/***/ 17825:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DOMAIN = exports.CDN_DOMAIN = void 0;
exports.CDN_DOMAIN = "02.cdn.better.co.uk";
exports.DOMAIN = "better.co.uk";


/***/ }),

/***/ 71367:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatMoney = void 0;
var ABBREVIATE_FROM_AMOUNT = 10000;
function formatMoney(number, abbreviateFromAmount) {
    if (abbreviateFromAmount === void 0) { abbreviateFromAmount = ABBREVIATE_FROM_AMOUNT; }
    var decimals = 2;
    if (number < abbreviateFromAmount) {
        return number.toFixed(decimals);
    }
    var abbreviations = ["k", "M", "B", "T"];
    var base = Math.floor(Math.log10(number) / 3);
    var abbreviation = abbreviations[base - 1];
    return (number / Math.pow(10, base * 3)).toFixed(decimals - 1) + abbreviation;
}
exports.formatMoney = formatMoney;


/***/ }),

/***/ 1308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var isImageComponent_1 = __importDefault(__webpack_require__(39294));
var getImage = function (image, altText, loading, className) {
    if (!image) {
        return null;
    }
    if ((0, isImageComponent_1.default)(image)) {
        return image;
    }
    if (typeof image === "function") {
        var ImageComponent = image;
        return react_1.default.createElement(ImageComponent, null);
    }
    if (typeof image === "string") {
        return (react_1.default.createElement("img", { src: image, alt: altText, className: className, loading: loading }));
    }
    return (react_1.default.createElement("img", { src: image.src, alt: image.alt || altText, loading: loading }));
};
exports["default"] = getImage;


/***/ }),

/***/ 97346:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(7895), exports);


/***/ }),

/***/ 11250:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isClientSideRendering = void 0;
var isClientSideRendering = function () { return typeof window !== "undefined"; };
exports.isClientSideRendering = isClientSideRendering;


/***/ }),

/***/ 39294:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(99497);
var allowedComponents = ["GatsbyImage", "StaticImage"];
var isImageComponent = function (image) {
    var _a, _b;
    return ((0, react_1.isValidElement)(image) &&
        // eslint-disable-next-line prettier/prettier
        allowedComponents.includes(((_a = image.type) === null || _a === void 0 ? void 0 : _a.displayName) || ((_b = image.type) === null || _b === void 0 ? void 0 : _b.name)));
};
exports["default"] = isImageComponent;


/***/ }),

/***/ 7895:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isRenderable = void 0;
var react_is_1 = __webpack_require__(1953);
var isRenderable = function (param) {
    return Boolean(!param ||
        typeof param === "number" ||
        (0, react_is_1.isValidElementType)(param) ||
        (0, react_is_1.typeOf)(param));
};
exports.isRenderable = isRenderable;


/***/ }),

/***/ 75975:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TrustpilotScore = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var styles_scss_1 = __importDefault(__webpack_require__(26021));
var fallback_trustpilot_score_svg_1 = __importDefault(__webpack_require__(84420));
var classnames_1 = __importDefault(__webpack_require__(57485));
var MS_LOADING_FALLBACK = 3000;
var TrustpilotScore = function (_a) {
    var _b;
    var _c = _a.href, href = _c === void 0 ? "https://uk.trustpilot.com/review/better.co.uk" : _c, _d = _a.shouldWapDirection, shouldWapDirection = _d === void 0 ? true : _d;
    var _e = (0, react_1.useState)(false), hasError = _e[0], setHasError = _e[1];
    var logoRef = (0, react_1.useRef)(null);
    var starRef = (0, react_1.useRef)(null);
    var scoreRef = (0, react_1.useRef)(null);
    var checkLoadingImages = function () {
        var _a, _b, _c;
        var currentStatusOfLoadingImages = {
            logo: !((_a = logoRef.current) === null || _a === void 0 ? void 0 : _a.complete),
            stars: !((_b = starRef.current) === null || _b === void 0 ? void 0 : _b.complete),
            score: !((_c = scoreRef.current) === null || _c === void 0 ? void 0 : _c.complete)
        };
        if (Object.values(currentStatusOfLoadingImages).includes(true)) {
            setHasError(true);
        }
    };
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () {
            checkLoadingImages();
        }, MS_LOADING_FALLBACK);
        return function () {
            clearTimeout(timer);
        };
    }, []);
    var handleError = function () {
        setHasError(true);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_scss_1.default.trustpilot, (_b = {},
            _b[styles_scss_1.default.trustpilotWap] = shouldWapDirection,
            _b)) }, hasError ? (react_1.default.createElement("img", { src: fallback_trustpilot_score_svg_1.default, alt: "Trustpilot Score placeholder" })) : (react_1.default.createElement("a", { href: href, target: "_blank" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { ref: logoRef, src: "https://emailsignature.trustpilot.com/brand/n/2/logo.png", height: "24", alt: "Trustpilot Logo", className: "trustpilot-logo", onError: function () { return handleError(); } })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { ref: starRef, src: "https://emailsignature.trustpilot.com/newsletter/en-US/2/6392287740b116458553ed83/stars.png", height: "24", alt: "Trustpilot Stars", className: "trustpilot-stars", onError: function () { return handleError(); } })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { ref: scoreRef, src: "https://emailsignature.trustpilot.com/newsletter/en-US/1/6392287740b116458553ed83/text2@2x.png", height: "14", alt: "Trustpilot Score", className: "trustpilot-score", onError: function () { return handleError(); } }))))));
};
exports.TrustpilotScore = TrustpilotScore;


/***/ }),

/***/ 40191:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "ViewMoreButton";
exports.elementIdentifiers = (0, shared_1.tuple)("button", "text", "arrow");


/***/ }),

/***/ 39581:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(40191);
var style_scss_1 = __importDefault(__webpack_require__(2241));
var classnames_1 = __importDefault(__webpack_require__(57485));
var arrow_down_react_svg_1 = __importDefault(__webpack_require__(8133));
var chevron_down_react_svg_1 = __importDefault(__webpack_require__(66999));
var ViewMoreButton = function (_a) {
    var _b, _c;
    var showIcon = _a.showIcon, hideIcon = _a.hideIcon, _d = _a.showLabel, showLabel = _d === void 0 ? "View more" : _d, _e = _a.hideLabel, hideLabel = _e === void 0 ? "View less" : _e, onClick = _a.onClick, id = _a.id, classOverrides = _a.classOverrides, className = _a.className, testIds = _a.testIds, refs = _a.refs;
    var _f = (0, react_1.useState)(false), isOpened = _f[0], setIsOpened = _f[1];
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var toggleButton = function (e) {
        setIsOpened(function (prevState) { return !prevState; });
        if (onClick)
            onClick(e);
    };
    return (react_1.default.createElement("button", __assign({}, ovr.button, { className: (0, classnames_1.default)(ovr.button.className, className), onClick: toggleButton }),
        react_1.default.createElement("p", __assign({}, ovr.text), isOpened ? hideLabel : showLabel),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.arrow, style_scss_1.default.arrowDesktop, (_b = {},
                _b[style_scss_1.default.arrowClicked] = isOpened,
                _b[style_scss_1.default.arrowDefault] = !showIcon && !hideIcon,
                _b)) }, showIcon || react_1.default.createElement(arrow_down_react_svg_1.default, null)),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.arrow, style_scss_1.default.arrowMobile, (_c = {},
                _c[style_scss_1.default.arrowClicked] = isOpened,
                _c[style_scss_1.default.arrowDefault] = !showIcon && !hideIcon,
                _c)) }, hideIcon || react_1.default.createElement(chevron_down_react_svg_1.default, null))));
};
ViewMoreButton.displayName = constants_1.componentName;
exports["default"] = ViewMoreButton;


/***/ }),

/***/ 17680:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardLine = exports.ExpandSectionButton = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(35138));
var content_1 = __webpack_require__(49429);
var ViewMoreButton_1 = __importDefault(__webpack_require__(39581));
var ExpandSectionButton = function (_a) {
    var onClick = _a.onClick;
    return react_1.default.createElement(ViewMoreButton_1.default, { onClick: onClick });
};
exports.ExpandSectionButton = ExpandSectionButton;
var CardLine = function (_a) {
    var title = _a.title, value = _a.value, onClick = _a.onClick, props = __rest(_a, ["title", "value", "onClick"]);
    return (react_1.default.createElement("div", __assign({}, props, { className: style_scss_1.default.applicationCard__line }),
        react_1.default.createElement("p", { className: style_scss_1.default.applicationCard__line__title }, title),
        react_1.default.createElement("button", { className: style_scss_1.default.applicationCard__line__info, onClick: onClick, onKeyDown: onClick }, !value ? (react_1.default.createElement(content_1.TextLink, { theme: content_1.TextLinkTheme.SECONDARY }, "Fill in")) : (react_1.default.createElement("span", null, value))),
        react_1.default.createElement(content_1.TextLink, { theme: content_1.TextLinkTheme.SECONDARY, onClick: onClick, className: style_scss_1.default.edit }, value ? "Edit" : null)));
};
exports.CardLine = CardLine;


/***/ }),

/***/ 37880:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "AccessApplicationCard";
exports.elementIdentifiers = (0, shared_1.tuple)("header", "title", "applicationCard", "collapsibleContentDivider", "applicationCardBottom", "applicationCard__textLink");


/***/ }),

/***/ 60690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(35138));
var content_1 = __webpack_require__(49429);
var constants_1 = __webpack_require__(37880);
var auxiliary_1 = __webpack_require__(17680);
var AccessSectionCard = function (_a) {
    var className = _a.className, fields = _a.fields, cardTitle = _a.cardTitle, onContinue = _a.onContinue, onStartFilling = _a.onStartFilling, progress = _a.progress, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["className", "fields", "cardTitle", "onContinue", "onStartFilling", "progress", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _b = (0, react_1.useState)(false), isContentOpen = _b[0], setIsContentOpen = _b[1];
    var handleCardClick = function () {
        if (fields.length === 0) {
            onStartFilling();
        }
    };
    var handleKeyDown = function (e) {
        if (fields.length === 0 && e.target.key("Enter")) {
            onStartFilling();
        }
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    react_1.default.createElement("div", __assign({}, props, ovr.applicationCard, { className: (0, classnames_1.default)(className, progress === 100 ? style_scss_1.default.filled : "", ovr.applicationCard.className), onClick: handleCardClick, onKeyDown: handleKeyDown }),
        react_1.default.createElement("section", __assign({}, ovr.header),
            react_1.default.createElement("h3", __assign({}, ovr.title),
                cardTitle,
                fields.length === 0 ? react_1.default.createElement("span", null, "(1 minute to complete)") : null),
            react_1.default.createElement(content_1.CircularProgressBar, { progress: progress, max: 100, type: "percent" })),
        fields.length !== 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(auxiliary_1.CardLine, { title: fields[0].title, value: fields[0].description, onClick: fields[0].onClick }),
            react_1.default.createElement(auxiliary_1.CardLine, { title: fields[1].title, value: fields[1].description, onClick: fields[1].onClick }))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.collapsibleContent, isContentOpen ? style_scss_1.default.open : style_scss_1.default.collapsed) }, fields.slice(2).map(function (field) { return (react_1.default.createElement(auxiliary_1.CardLine, { title: field.title, value: field.description, onClick: field.onClick, key: field.title })); })),
        react_1.default.createElement("div", __assign({}, ovr.collapsibleContentDivider)),
        react_1.default.createElement("div", __assign({}, ovr.applicationCardBottom),
            fields.length !== 0 ? (react_1.default.createElement(auxiliary_1.ExpandSectionButton, { onClick: function () { return setIsContentOpen(!isContentOpen); }, isExpanded: isContentOpen })) : null,
            react_1.default.createElement("div", __assign({}, ovr.applicationCard__textLink), fields.length === 0 ? (react_1.default.createElement(content_1.TextLink, { className: style_scss_1.default.textLink, theme: content_1.TextLinkTheme.SECONDARY, onClick: onStartFilling }, "Start filling in")) : (react_1.default.createElement(content_1.TextLink, { theme: content_1.TextLinkTheme.SECONDARY, className: style_scss_1.default.textLink, onClick: onContinue }, "Continue"))))));
};
AccessSectionCard.displayName = constants_1.componentName;
exports["default"] = AccessSectionCard;


/***/ }),

/***/ 19217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var isImageComponent_1 = __importDefault(__webpack_require__(39294));
var form_1 = __webpack_require__(13174);
var favicon_react_svg_1 = __importDefault(__webpack_require__(43519));
var style_scss_1 = __importDefault(__webpack_require__(15410));
var adviserPanel_1 = __webpack_require__(97127);
var loadingIndicator_1 = __importDefault(__webpack_require__(19801));
var whatsappButton_1 = __importDefault(__webpack_require__(21716));
var workingHoursInfo_1 = __importDefault(__webpack_require__(32871));
var quote_react_svg_1 = __importDefault(__webpack_require__(75216));
var hooks_1 = __webpack_require__(92457);
var tokens_breakpoints_1 = __webpack_require__(26963);
var componentName = "AdviserAssigned";
var elementIdentifiers = (0, shared_1.tuple)("adviserAssignedWrapperLight", "adviserAssigned", "adviserAssignedWrapper", "cta", "adviserWrapper", "iconContainer", "details", "subTitle", "title", "phoneNumber", "externalEmail");
var AdviserAssigned = function (_a) {
    var _b, _c;
    var icon = _a.icon, contact = _a.contact, cta = _a.cta, state = _a.state, _d = _a.variant, variant = _d === void 0 ? adviserPanel_1.AdviserPanelVariant.DEFAULT : _d, editApplication = _a.editApplication, _e = _a.showWhatsAppButton, showWhatsAppButton = _e === void 0 ? false : _e, quote = _a.quote, _f = _a.showWorkingHours, showWorkingHours = _f === void 0 ? true : _f, workingHours = _a.workingHours, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, className = _a.className, props = __rest(_a, ["icon", "contact", "cta", "state", "variant", "editApplication", "showWhatsAppButton", "quote", "showWorkingHours", "workingHours", "classOverrides", "testIds", "refs", "className"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _g = (0, react_1.useState)(false), iconFailed = _g[0], setIconFailed = _g[1];
    var iconFailedToLoad = function () {
        setIconFailed(true);
    };
    var width = (0, hooks_1.useWindowSize)().width;
    var totalButtons = Number(!!cta) + Number(!!editApplication) + Number(showWhatsAppButton);
    var isMoreThanOneButton = totalButtons > 1;
    var buttonsContainerStyle = "".concat(style_scss_1.default.buttonsContainer, " ").concat(isMoreThanOneButton ? style_scss_1.default.moreThanOneButton : style_scss_1.default.moreThanOneButton);
    if (state === adviserPanel_1.AdviserState.SEARCH) {
        return react_1.default.createElement(loadingIndicator_1.default, { text: "Finding you an adviser..." });
    }
    var iconContainer = (react_1.default.createElement("div", __assign({}, ovr.iconContainer), iconFailed ? (react_1.default.createElement(favicon_react_svg_1.default, null)) : (((0, isImageComponent_1.default)(icon) && (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.icon) }, icon))) || (react_1.default.createElement("img", { src: icon.src, alt: icon.alt, className: (0, classnames_1.default)(style_scss_1.default.icon), onError: iconFailedToLoad })))));
    var buttons = (react_1.default.createElement("div", { className: buttonsContainerStyle },
        editApplication && (react_1.default.createElement(form_1.Button, { size: shared_1.ButtonSize.Small, colour: shared_1.ButtonColour.Ghost, id: "".concat(shared_1.ButtonColour.Ghost, "-small"), fixed: false, onClick: editApplication.onClick }, editApplication.text)),
        showWhatsAppButton && react_1.default.createElement(whatsappButton_1.default, null),
        cta && (react_1.default.createElement(form_1.Button, __assign({}, ovr.cta, { size: shared_1.ButtonSize.Small, colour: variant === adviserPanel_1.AdviserPanelVariant.LIGHT
                ? shared_1.ButtonColour.TertiaryLight
                : shared_1.ButtonColour.Primary, onClick: cta.onClick, id: "".concat(variant === adviserPanel_1.AdviserPanelVariant.LIGHT
                ? shared_1.ButtonColour.TertiaryLight
                : shared_1.ButtonColour.Primary, "-small"), fixed: false }),
            cta.icon && cta.icon === "calendar" && (react_1.default.createElement(shared_1.Icon, { name: shared_1.IconName.Calender })),
            cta.icon && cta.icon === "phone" && react_1.default.createElement(shared_1.Icon, { name: shared_1.IconName.Phone }),
            cta.text))));
    var adviserDetails = (react_1.default.createElement("div", __assign({}, ovr.details),
        !editApplication && (react_1.default.createElement("div", __assign({}, ovr.subTitle), variant === adviserPanel_1.AdviserPanelVariant.LIGHT
            ? "Your dedicated adviser:"
            : "Your personal Adviser:")),
        react_1.default.createElement("div", __assign({}, ovr.title),
            contact.name,
            contact.qualification ? ", ".concat(contact.qualification) : null),
        contact.telephoneNumber && (react_1.default.createElement("a", __assign({}, ovr.phoneNumber, { href: "tel:".concat(contact.telephoneNumber) }),
            "T: ",
            contact.telephoneNumber)),
        contact.externalEmail && (react_1.default.createElement("a", __assign({}, ovr.externalEmail, { href: "mailto:".concat(contact.externalEmail) }),
            "E: ",
            contact.externalEmail))));
    var adviserDetailsWithIcon = (react_1.default.createElement("div", __assign({}, ovr.adviserWrapper),
        iconContainer,
        adviserDetails));
    var standardLayout = (react_1.default.createElement("div", __assign({}, ovr.adviserAssigned, { className: (0, classnames_1.default)(ovr.adviserAssigned.className, (_b = {},
            _b[style_scss_1.default.adviserAssignedEarlyBreakpoint] = totalButtons > 2,
            _b)) }),
        adviserDetailsWithIcon,
        buttons));
    var isNarrowViewport = width && width < tokens_breakpoints_1.MQ_MEDIUM_LARGE;
    var quoteLayout = (react_1.default.createElement("div", { className: style_scss_1.default.quoteLayout },
        react_1.default.createElement("div", { className: style_scss_1.default.adviserDetailsContainer },
            isNarrowViewport ? adviserDetailsWithIcon : adviserDetails,
            !isNarrowViewport &&
                (showWorkingHours ? (react_1.default.createElement(workingHoursInfo_1.default, { workingHours: workingHours })) : (buttons))),
        react_1.default.createElement("div", { className: style_scss_1.default.quoteContainer },
            !isNarrowViewport && iconContainer,
            react_1.default.createElement("div", { className: style_scss_1.default.quoteInnerContainer },
                react_1.default.createElement("div", { className: style_scss_1.default.quoteTextContainer },
                    react_1.default.createElement("p", null, quote),
                    react_1.default.createElement("span", { className: style_scss_1.default.quoteIconContainer },
                        react_1.default.createElement(quote_react_svg_1.default, null))))),
        isNarrowViewport && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("hr", { className: style_scss_1.default.hr }),
            showWorkingHours ? react_1.default.createElement(workingHoursInfo_1.default, null) : buttons))));
    return (react_1.default.createElement("div", __assign({}, props, ovr.adviserAssignedWrapper, { className: (0, classnames_1.default)(ovr.adviserAssignedWrapper.className, (_c = {},
            _c[ovr.adviserAssignedWrapperLight.className] = variant === adviserPanel_1.AdviserPanelVariant.LIGHT,
            _c), className) }), quote ? quoteLayout : standardLayout));
};
AdviserAssigned.displayName = componentName;
exports["default"] = AdviserAssigned;


/***/ }),

/***/ 97127:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AdviserPanelVariant = exports.CtaIcon = exports.AdviserState = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var trustPilotCard_1 = __importDefault(__webpack_require__(26924));
var adviserAssigned_1 = __importDefault(__webpack_require__(19217));
var noAdviserAssigned_1 = __importDefault(__webpack_require__(50607));
var loadingIndicator_1 = __importDefault(__webpack_require__(19801));
var componentName = "AdviserPanel";
var AdviserState;
(function (AdviserState) {
    AdviserState["ASSIGNED"] = "assigned";
    AdviserState["LOADING"] = "loading";
    AdviserState["SEARCH"] = "search";
    AdviserState["NONE_ASSIGNED"] = "noneAssigned";
})(AdviserState = exports.AdviserState || (exports.AdviserState = {}));
var CtaIcon;
(function (CtaIcon) {
    CtaIcon["PHONE"] = "phone";
    CtaIcon["CALENDAR"] = "calendar";
})(CtaIcon = exports.CtaIcon || (exports.CtaIcon = {}));
var AdviserPanelVariant;
(function (AdviserPanelVariant) {
    AdviserPanelVariant["DEFAULT"] = "default";
    AdviserPanelVariant["LIGHT"] = "light";
})(AdviserPanelVariant = exports.AdviserPanelVariant || (exports.AdviserPanelVariant = {}));
var AdviserPanel = function (_a) {
    var icon = _a.icon, contact = _a.contact, cta = _a.cta, state = _a.state, variant = _a.variant, reviews = _a.reviews, loadingTitle = _a.loadingTitle, reviewDirection = _a.reviewDirection, customerNameDirection = _a.customerNameDirection, bounceOnEveryReview = _a.bounceOnEveryReview, noAdviserAssignedTitle = _a.noAdviserAssignedTitle, points = _a.points, editApplication = _a.editApplication, _b = _a.showWhatsAppButton, showWhatsAppButton = _b === void 0 ? false : _b, _c = _a.showWorkingHours, showWorkingHours = _c === void 0 ? true : _c, workingHours = _a.workingHours, quote = _a.quote;
    switch (state) {
        case AdviserState.ASSIGNED:
            return (react_1.default.createElement(adviserAssigned_1.default, { icon: icon, contact: contact, cta: cta, variant: variant, editApplication: editApplication, showWhatsAppButton: showWhatsAppButton, quote: quote, showWorkingHours: showWorkingHours, workingHours: workingHours }));
        case AdviserState.NONE_ASSIGNED:
            return (react_1.default.createElement(noAdviserAssigned_1.default, { title: noAdviserAssignedTitle, points: points }));
        case AdviserState.SEARCH:
            return react_1.default.createElement(loadingIndicator_1.default, { text: "Finding you an adviser..." });
        default:
            return (react_1.default.createElement(trustPilotCard_1.default, { title: loadingTitle, reviews: reviews, reviewDirection: reviewDirection, customerNameDirection: customerNameDirection, bounceOnEveryReview: bounceOnEveryReview }));
    }
};
AdviserPanel.displayName = componentName;
exports["default"] = AdviserPanel;


/***/ }),

/***/ 50607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(32489));
var card_1 = __importDefault(__webpack_require__(82972));
var componentName = "Trustpilot Card";
exports.elementIdentifiers = (0, shared_1.tuple)("noAdviserAssignedContainer", "noAdviserAssignedCard", "noAdviserAssignedCardText", "noAdviserTitle", "noAdviserOrderedList", "noAdviserListItem");
var NoAdviserAssigned = function (_a) {
    var classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, title = _a.title, points = _a.points, props = __rest(_a, ["classOverrides", "testIds", "refs", "title", "points"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: exports.elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement(card_1.default, { classOverrides: {
            cardContainer: ovr.noAdviserAssignedContainer.className,
            card: ovr.noAdviserAssignedCard.className,
            text: ovr.noAdviserAssignedCardText.className
        } },
        react_1.default.createElement("h3", __assign({}, ovr.noAdviserTitle), title),
        react_1.default.createElement("ol", __assign({}, ovr.noAdviserOrderedList), points.map(function (point) { return (react_1.default.createElement("li", __assign({}, ovr.noAdviserListItem),
            " ",
            point)); }))));
};
NoAdviserAssigned.displayName = componentName;
exports["default"] = NoAdviserAssigned;


/***/ }),

/***/ 89517:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "ApplicationCard";
exports.elementIdentifiers = (0, shared_1.tuple)("header", "financials", "title", "address", "names", "applicationCard", "cta");


/***/ }),

/***/ 68421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(15771));
var form_1 = __webpack_require__(13174);
var icon_1 = __webpack_require__(55074);
var constants_1 = __webpack_require__(89517);
var collapsibleContent_1 = __importDefault(__webpack_require__(24082));
var ApplicationCard = function (_a) {
    var children = _a.children, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, application = _a.application, _b = _a.openByDefault, openByDefault = _b === void 0 ? true : _b, _c = _a.isCollapsible, isCollapsible = _c === void 0 ? false : _c, cta = _a.cta, props = __rest(_a, ["children", "className", "classOverrides", "testIds", "refs", "application", "openByDefault", "isCollapsible", "cta"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var toLocale = function (number) {
        return number.toLocaleString("en-GB", {
            style: "currency",
            currency: "GBP"
        });
    };
    return (react_1.default.createElement("div", __assign({}, props, ovr.applicationCard, { className: (0, classnames_1.default)(className, ovr.applicationCard.className) }),
        react_1.default.createElement(collapsibleContent_1.default, { title: "Borrowing Requirements", isCollapsible: isCollapsible, openByDefault: openByDefault },
            react_1.default.createElement("section", __assign({}, ovr.header),
                react_1.default.createElement("h3", __assign({}, ovr.title), "Your application"),
                cta && (react_1.default.createElement(form_1.BackLink, __assign({}, ovr.cta, { id: "view-application-backlink", onClick: cta.onClick, icon: icon_1.IconName.RightArrow }), cta.text))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", __assign({}, ovr.names), application.names),
                react_1.default.createElement("address", __assign({}, ovr.address),
                    react_1.default.createElement("p", null, [
                        application.addressLine1,
                        application.addressLine2,
                        application.postcode
                    ]
                        .filter(function (addressLine) { return addressLine; })
                        .map(function (line, i) {
                        return (react_1.default.createElement(react_1.default.Fragment, { key: "line_".concat(i) },
                            line,
                            react_1.default.createElement("br", null)));
                    })))),
            application.propertyPrice && application.borrowingAmount && (react_1.default.createElement("div", __assign({}, ovr.financials),
                react_1.default.createElement("dl", null,
                    react_1.default.createElement("dt", null, "Property price"),
                    react_1.default.createElement("dd", null, toLocale(application.propertyPrice))),
                react_1.default.createElement("dl", null,
                    react_1.default.createElement("dt", null, "Borrowing amount"),
                    react_1.default.createElement("dd", null, toLocale(application.borrowingAmount))))),
            children && react_1.default.createElement("div", null, children))));
};
ApplicationCard.displayName = constants_1.componentName;
exports["default"] = ApplicationCard;


/***/ }),

/***/ 59994:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultInformationBlocks = exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "MonzoGetStarted";
exports.elementIdentifiers = (0, shared_1.tuple)("serviceOffering", "figure", "informationBlock", "informationTitle", "title", "line", "offeringLogos", "figureDescription", "list", "informationDescription");
exports.defaultInformationBlocks = [
    {
        title: "Create an application",
        description: "No one likes form-filling, but it’s necessary. Mortgages are complex!"
    },
    {
        title: "RateWatch",
        description: "Reserve a rate up to 6 months before your current deal ends. If a more suitable deal becomes available to you, our RateWatch service will offer to swap you onto it."
    },
    {
        title: "Switch",
        description: "When the time is right, we’ll switch you over to your new rate."
    }
];


/***/ }),

/***/ 80940:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var logo_better_2024_no_size_react_svg_1 = __importDefault(__webpack_require__(70868));
var shared_1 = __webpack_require__(89574);
var TrustpilotScore_1 = __webpack_require__(75975);
var typography_1 = __webpack_require__(34237);
var style_scss_1 = __importDefault(__webpack_require__(9262));
var constants_1 = __webpack_require__(59994);
var BetterAndTrustpilotChecklist = function (_a) {
    var _b = _a.informationBlocks, informationBlocks = _b === void 0 ? constants_1.defaultInformationBlocks : _b, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["informationBlocks", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.serviceOffering),
        react_1.default.createElement("div", __assign({}, ovr.offeringLogos),
            react_1.default.createElement("figure", __assign({}, ovr.figure),
                react_1.default.createElement(logo_better_2024_no_size_react_svg_1.default, null),
                react_1.default.createElement("figcaption", __assign({}, ovr.figureDescription),
                    "Your ",
                    react_1.default.createElement("strong", null, "free online"),
                    " Mortgage\u00A0Broker")),
            react_1.default.createElement(TrustpilotScore_1.TrustpilotScore, { shouldWapDirection: false })),
        react_1.default.createElement("ol", __assign({}, ovr.list), informationBlocks.map(function (_a, index) {
            var title = _a.title, description = _a.description;
            return (react_1.default.createElement("li", __assign({}, ovr.informationBlock, { key: index }),
                react_1.default.createElement(typography_1.Typography, __assign({ variant: "h4", component: "p" }, ovr.informationTitle, { classes: ovr.informationTitle.className, id: "informationBlock-title-".concat(index) }), title),
                react_1.default.createElement(typography_1.Typography, __assign({ variant: "body2", component: "p" }, ovr.informationDescription, { classes: ovr.informationDescription.className, id: "informationBlock-description-".concat(index) }), description)));
        }))));
};
exports["default"] = BetterAndTrustpilotChecklist;


/***/ }),

/***/ 82972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = void 0;
/* eslint-disable no-nested-ternary */
var react_1 = __importDefault(__webpack_require__(99497));
var react_is_1 = __webpack_require__(1953);
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(54313));
var arrow_react_svg_1 = __importDefault(__webpack_require__(25184));
var form_1 = __webpack_require__(13174);
var isImageComponent_1 = __importDefault(__webpack_require__(39294));
var componentName = "Card";
exports.elementIdentifiers = (0, shared_1.tuple)("anchor", "card", "cta", "cardContainer", "text", "textInnerWrap", "col", "colContent", "colText", "colIllustration", "background", "backgroundLeft", "backgroundRight", "illustration", "illustrationLeft", "illustrationRight", "title", "ctaIllustration", "list", "links", "hero", "heroContent", "link");
var Card = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var children = _a.children, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, title = _a.title, cta = _a.cta, illustration = _a.illustration, background = _a.background, transparent = _a.transparent, link = _a.link, linkIcon = _a.linkIcon, _j = _a.fullWidth, fullWidth = _j === void 0 ? false : _j, left = _a.left, right = _a.right, _k = _a.colConfig, colConfig = _k === void 0 ? { left: {}, right: {} } : _k, hero = _a.hero, links = _a.links, props = __rest(_a, ["children", "classOverrides", "testIds", "refs", "title", "cta", "illustration", "background", "transparent", "link", "linkIcon", "fullWidth", "left", "right", "colConfig", "hero", "links"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: exports.elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var ctaWithoutText = __assign(__assign({}, cta), { text: undefined });
    var colConfigLeftIllustration = colConfig.left.illustration;
    var colConfigLeftBackground = colConfig.left.background;
    var colConfigRightIllustration = colConfig.right.illustration;
    var colConfigRightBackground = colConfig.right.background;
    return (react_1.default.createElement("div", __assign({ role: "region" }, ovr.cardContainer, props, { className: (0, classnames_1.default)(style_scss_1.default.cardContainer, (_b = {},
            _b[style_scss_1.default.cardContainerFullWidth] = cta || fullWidth,
            _b[style_scss_1.default.listContainer] = hero && links,
            _b), ovr.cardContainer.className) }),
        title &&
            ((0, react_is_1.isElement)(title) ? react_1.default.createElement(react_1.default.Fragment, null, title) : react_1.default.createElement("h3", __assign({}, ovr.title), title)),
        react_1.default.createElement("div", __assign({}, ovr.card, { className: (0, classnames_1.default)((_c = {},
                _c[style_scss_1.default.cardWithIllustration] = illustration,
                _c[style_scss_1.default.cardWithBackground] = background,
                _c[style_scss_1.default.cardWithLink] = link,
                _c[style_scss_1.default.cardWithCta] = cta,
                _c[style_scss_1.default.cardWithCtaAndIllustration] = cta && illustration,
                _c[style_scss_1.default.cardFullWidth] = fullWidth,
                _c[style_scss_1.default.cardListOfLinks] = hero && links,
                _c[style_scss_1.default.noBorder] = transparent,
                _c), style_scss_1.default.card, ovr.card.className) }),
            react_1.default.createElement("div", __assign({}, ovr.text, { className: (0, classnames_1.default)((_d = {}, _d[style_scss_1.default.textNoIllustration] = !illustration, _d), style_scss_1.default.text, ovr.text.className) }),
                cta &&
                    illustration &&
                    ((0, isImageComponent_1.default)(illustration) ? (react_1.default.createElement("div", __assign({}, ovr.ctaIllustration), illustration)) : (react_1.default.createElement("img", __assign({}, ovr.ctaIllustration, { src: illustration.src, alt: illustration.alt })))),
                react_1.default.createElement("div", __assign({}, ovr.textInnerWrap), !fullWidth && children),
                fullWidth && left && right ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", __assign({}, ovr.col, { className: (0, classnames_1.default)((_e = {}, _e[style_scss_1.default.colWithIllustration] = illustration, _e), (_f = {}, _f[style_scss_1.default.colWithBackground] = background, _f), style_scss_1.default.col, ovr.col.className) }),
                        react_1.default.createElement("div", __assign({}, ovr.colContent),
                            react_1.default.createElement("div", __assign({}, ovr.colText), left),
                            react_1.default.createElement("div", __assign({}, ovr.colIllustration), colConfigLeftIllustration &&
                                ((0, isImageComponent_1.default)(colConfigLeftIllustration) ? (react_1.default.createElement("div", __assign({}, ovr.illustrationLeft, { className: (0, classnames_1.default)(style_scss_1.default.illustration, ovr.illustrationLeft.className) }), colConfigLeftIllustration)) : (react_1.default.createElement("img", __assign({}, ovr.illustrationLeft, { className: (0, classnames_1.default)(style_scss_1.default.illustration, ovr.illustrationLeft.className), src: colConfigLeftIllustration.src, alt: colConfigLeftIllustration.alt })))))),
                        colConfigLeftBackground &&
                            ((0, isImageComponent_1.default)(colConfigLeftBackground) ? (react_1.default.createElement("div", __assign({}, ovr.backgroundLeft, { className: (0, classnames_1.default)(style_scss_1.default.background, ovr.backgroundLeft.className) }), colConfigLeftBackground)) : (react_1.default.createElement("img", __assign({}, ovr.backgroundLeft, { className: (0, classnames_1.default)(style_scss_1.default.background, ovr.backgroundLeft.className), src: colConfigLeftBackground.src, alt: colConfigLeftBackground.alt }))))),
                    react_1.default.createElement("div", __assign({}, ovr.col, { className: (0, classnames_1.default)((_g = {}, _g[style_scss_1.default.colWithIllustration] = illustration, _g), (_h = {}, _h[style_scss_1.default.colWithBackground] = background, _h), style_scss_1.default.col, ovr.col.className) }),
                        react_1.default.createElement("div", __assign({}, ovr.colContent), right),
                        colConfigRightIllustration &&
                            ((0, isImageComponent_1.default)(colConfigRightIllustration) ? (react_1.default.createElement("div", __assign({}, ovr.illustrationRight, { className: (0, classnames_1.default)(style_scss_1.default.illustration, ovr.illustrationRight.className) }), colConfigRightIllustration)) : (react_1.default.createElement("img", __assign({}, ovr.illustrationRight, { className: (0, classnames_1.default)(style_scss_1.default.illustration, ovr.illustrationRight.className), src: colConfigRightIllustration.src, alt: colConfigRightIllustration.alt })))),
                        colConfigRightBackground &&
                            ((0, isImageComponent_1.default)(colConfigRightBackground) ? (react_1.default.createElement("div", __assign({}, ovr.backgroundRight, { className: (0, classnames_1.default)(style_scss_1.default.background, ovr.backgroundRight.className) }), colConfigRightBackground)) : (react_1.default.createElement("img", __assign({}, ovr.backgroundRight, { className: (0, classnames_1.default)(style_scss_1.default.background, ovr.backgroundRight.className), src: colConfigRightBackground.src, alt: colConfigRightBackground.alt }))))))) : null),
            illustration &&
                !cta &&
                ((0, isImageComponent_1.default)(illustration) ? (react_1.default.createElement("div", __assign({}, ovr.illustration, { style: {
                        marginTop: illustration.verticalOffset
                            ? illustration.verticalOffset
                            : 0
                    } }), illustration)) : (react_1.default.createElement("img", __assign({}, ovr.illustration, { src: illustration.src, alt: illustration.alt, style: {
                        marginTop: illustration.verticalOffset
                            ? illustration.verticalOffset
                            : 0
                    } })))),
            cta && (react_1.default.createElement(form_1.Button, __assign({}, ovr.cta, { colour: shared_1.ButtonColour.Primary, fixed: false }, ctaWithoutText), cta.text)),
            background &&
                ((0, isImageComponent_1.default)(background) ? (react_1.default.createElement("div", __assign({}, ovr.background), background)) : (react_1.default.createElement("img", __assign({}, ovr.background, { src: background.src, alt: background.alt }))))),
        link && (react_1.default.createElement("div", __assign({}, ovr.link),
            link,
            linkIcon ? linkIcon : react_1.default.createElement(arrow_react_svg_1.default, null))),
        hero && links && (react_1.default.createElement("div", __assign({}, ovr.list),
            react_1.default.createElement("div", __assign({}, ovr.heroContent), (0, isImageComponent_1.default)(hero) ? (react_1.default.createElement("div", __assign({}, ovr.hero), hero)) : (react_1.default.createElement("img", __assign({}, ovr.hero, { src: hero.src, alt: hero.alt })))),
            react_1.default.createElement("ul", __assign({}, ovr.links), links.map(function (li, i) { return (react_1.default.createElement("li", __assign({}, ovr.list, { "data-testid": "".concat(ovr.list["data-testid"], "-").concat(i) }),
                react_1.default.createElement("a", __assign({}, ovr.anchor, { href: li.href, target: li.target || "_blank" }), li.text),
                li.icon ? (li.icon) : (react_1.default.createElement(arrow_react_svg_1.default, { "data-testid": "Card-link-".concat(i, "-arrow") })))); }))))));
};
Card.displayName = componentName;
exports["default"] = Card;


/***/ }),

/***/ 25640:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* istanbul ignore file */
var react_1 = __importStar(__webpack_require__(99497));
var styles_scss_1 = __importDefault(__webpack_require__(97170));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var chevron_left_black_react_svg_1 = __importDefault(__webpack_require__(17838));
var chevron_right_black_react_svg_1 = __importDefault(__webpack_require__(51809));
var lodash_throttle_1 = __importDefault(__webpack_require__(39523));
var componentName = "CardCarousel";
var elementIdentifiers = (0, shared_1.tuple)("cardCarousel", "cardWrapper");
var SCROLL_CB_THROTTLE_MS = 100;
var CardCarousel = function (_a) {
    var cards = _a.cards, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["cards", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    var carouselRef = (0, react_1.useRef)(null);
    var cardRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), isDragging = _b[0], setIsDragging = _b[1];
    var _c = (0, react_1.useState)(0), dragStartX = _c[0], setDragStartX = _c[1];
    var _d = (0, react_1.useState)(0), currentIndex = _d[0], setCurrentIndex = _d[1];
    var handleScroll = (0, lodash_throttle_1.default)(function () {
        if (carouselRef.current && cardRef.current) {
            var cardWidth = cardRef.current.offsetWidth;
            var scrollLeft = carouselRef.current.scrollLeft;
            var newIndex = Math.round(scrollLeft / cardWidth);
            setCurrentIndex(newIndex);
        }
    }, SCROLL_CB_THROTTLE_MS);
    var getClientX = function (event) {
        return "touches" in event ? event.touches[0].clientX : event.clientX;
    };
    var handleDragStart = function (event) {
        setDragStartX(getClientX(event));
        setIsDragging(true);
    };
    var handleDragMove = function (event) {
        if (isDragging) {
            event.preventDefault();
            var clientX = getClientX(event);
            var deltaX = clientX - dragStartX;
            if (carouselRef.current) {
                carouselRef.current.scrollLeft -= deltaX;
            }
        }
    };
    var handleDragEnd = function () {
        setIsDragging(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)(styles_scss_1.default.cardCarousel, ovr.cardCarousel.className), "data-testid": ovr.cardCarousel["data-testid"], ref: carouselRef, onMouseDown: handleDragStart, onMouseMove: handleDragMove, onMouseUp: handleDragEnd, onTouchStart: handleDragStart, onTouchEnd: handleDragEnd, onScroll: handleScroll, tabIndex: 0 }, props, { "aria-label": "Carousel", role: "listbox" }), cards.map(function (card, index) { return (react_1.default.createElement("div", __assign({ key: index }, ovr.cardWrapper, { ref: cardRef }), card)); })),
        react_1.default.createElement("div", { className: styles_scss_1.default.cardNavigationBar },
            react_1.default.createElement("div", { className: styles_scss_1.default.pageTracker },
                currentIndex + 1,
                " of ",
                cards.length),
            react_1.default.createElement("div", { className: styles_scss_1.default.navigationButtons },
                react_1.default.createElement("button", { "aria-label": "Previous card", className: styles_scss_1.default.navigationButton, onClick: function () {
                        if (carouselRef.current && cardRef.current) {
                            carouselRef.current.scrollLeft -= cardRef.current.offsetWidth;
                        }
                    } },
                    react_1.default.createElement(chevron_left_black_react_svg_1.default, null)),
                react_1.default.createElement("button", { "aria-label": "Next card", className: styles_scss_1.default.navigationButton, onClick: function () {
                        if (carouselRef.current && cardRef.current) {
                            carouselRef.current.scrollLeft += cardRef.current.offsetWidth;
                        }
                    } },
                    react_1.default.createElement(chevron_right_black_react_svg_1.default, null))))));
};
CardCarousel.displayName = componentName;
exports["default"] = CardCarousel;


/***/ }),

/***/ 69857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
var styles_scss_1 = __importDefault(__webpack_require__(21679));
var chevron_left_black_react_svg_1 = __importDefault(__webpack_require__(17838));
var chevron_right_black_react_svg_1 = __importDefault(__webpack_require__(51809));
var react_use_draggable_scroll_1 = __webpack_require__(54973);
var tokens_breakpoints_1 = __webpack_require__(26963);
var useWindowSize_1 = __webpack_require__(55454);
var Carousel = function (_a) {
    var children = _a.children, _b = _a.childWidth, childWidth = _b === void 0 ? 495 : _b;
    var containerRef = (0, react_1.useRef)();
    var carouselRef = (0, react_1.useRef)(null);
    var events = (0, react_use_draggable_scroll_1.useDraggable)(containerRef).events;
    var _c = (0, react_1.useState)(0), currentIndex = _c[0], setCurrentIndex = _c[1];
    var width = (0, useWindowSize_1.useWindowSize)().width;
    var _d = (0, react_1.useState)(width && width > tokens_breakpoints_1.MQ_WIDE), isWide = _d[0], setIsWide = _d[1];
    var childrenCount = react_1.default.Children.count(children);
    var outOfViewComponents = width
        ? Math.ceil(((childrenCount + 1) * childWidth - width) / childWidth)
        : 0;
    (0, react_1.useEffect)(function () {
        if (width)
            setIsWide(width > tokens_breakpoints_1.MQ_WIDE);
    }, [width]);
    var goLeft = function () {
        setCurrentIndex(function (prevIndex) {
            return prevIndex > 0 ? prevIndex - 1 : outOfViewComponents;
        });
    };
    var goRight = function () {
        setCurrentIndex(function (prevIndex) {
            return prevIndex < outOfViewComponents ? prevIndex + 1 : 0;
        });
    };
    return (react_1.default.createElement("div", { className: styles_scss_1.default.containerWrapper },
        react_1.default.createElement("div", __assign({}, events, { ref: containerRef, className: isWide ? styles_scss_1.default.carouselContainer : styles_scss_1.default.carouselContainerNarrow }),
            react_1.default.createElement("div", { className: styles_scss_1.default.carouselWrapper, ref: carouselRef },
                react_1.default.createElement("div", { className: styles_scss_1.default.carouselContent, style: { transform: "translateX(-".concat(currentIndex * childWidth, "px)") } }, react_1.default.Children.map(children, function (child, index) { return (react_1.default.createElement("div", { className: styles_scss_1.default.carouselItem, key: index }, child)); })))),
        react_1.default.createElement("div", { className: styles_scss_1.default.carouselButtons },
            react_1.default.createElement("button", { "aria-label": "left", onClick: goLeft },
                react_1.default.createElement(chevron_left_black_react_svg_1.default, null)),
            react_1.default.createElement("button", { "aria-label": "right", onClick: goRight },
                react_1.default.createElement(chevron_right_black_react_svg_1.default, null)))));
};
exports["default"] = Carousel;


/***/ }),

/***/ 36218:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.N_CHILDREN_IN_VIEW = exports.FIXED_INDEX = exports.MIN_CHILDREN_TO_SHOW_NAVIGATION = void 0;
exports.MIN_CHILDREN_TO_SHOW_NAVIGATION = 3;
exports.FIXED_INDEX = 0;
exports.N_CHILDREN_IN_VIEW = 3;


/***/ }),

/***/ 71429:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(1111));
var trackerDots_1 = __importStar(__webpack_require__(47485));
var arrow_1 = __importStar(__webpack_require__(44260));
var constants_1 = __webpack_require__(36218);
exports.componentName = "Carousel";
exports.elementIdentifiers = (0, shared_1.tuple)("carousel", "childrenContainer", "child", "trackerDots", "arrowLeft", "arrowRight", "titles", "fixedTitle", "title");
var Carousel = function (_a) {
    var _b;
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: exports.elementIdentifiers,
        componentName: exports.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var children = props.children, placeholderComponent = props.placeholderComponent, fixedTitle = props.fixedTitle, title = props.title;
    var returnNPlaceholders = function (n) {
        return Array(n)
            .fill(null)
            .map(function () { return placeholderComponent; });
    };
    var childrenAsArray = react_1.default.Children.toArray(children);
    var placeholders = placeholderComponent && childrenAsArray.length < constants_1.N_CHILDREN_IN_VIEW
        ? returnNPlaceholders(constants_1.N_CHILDREN_IN_VIEW - childrenAsArray.length)
        : [];
    var renderableChildren = __spreadArray(__spreadArray([], childrenAsArray, true), placeholders, true);
    var childCount = renderableChildren.length;
    var _c = (0, react_1.useState)([]), trackerDots = _c[0], setTrackerDots = _c[1];
    var _d = (0, react_1.useState)([1, 2]), activeIndexes = _d[0], setActiveIndexes = _d[1];
    var updateTrackerDots = function (shiftActiveIdxsBy) {
        var copyOfTrackerDots = __spreadArray([], trackerDots, true);
        activeIndexes.forEach(function (idx) { return (copyOfTrackerDots[idx] = trackerDots_1.StatusIndicators.Inactive); });
        activeIndexes.forEach(function (idx) {
            return (copyOfTrackerDots[idx + shiftActiveIdxsBy] = trackerDots_1.StatusIndicators.Active);
        });
        setTrackerDots(copyOfTrackerDots);
    };
    var handleOnClickLeft = function () {
        updateTrackerDots(-1);
        setActiveIndexes(activeIndexes.map(function (idx) { return idx - 1; }));
    };
    var handleOnClickRight = function () {
        updateTrackerDots(1);
        setActiveIndexes(activeIndexes.map(function (idx) { return idx + 1; }));
    };
    var renderChildren = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, renderableChildren.map(function (child, idx) {
            var showChild = idx === constants_1.FIXED_INDEX || activeIndexes.includes(idx);
            var lastVisibleElement = idx === activeIndexes[1];
            var firstVisibleElement = idx === 0;
            var isPlaceholder = idx >= childrenAsArray.length;
            return (react_1.default.createElement("div", __assign({}, ovr.child, { key: "child-".concat(idx), className: (0, classnames_1.default)(ovr.child.className, showChild ? style_scss_1.default.show : style_scss_1.default.hide, lastVisibleElement ? style_scss_1.default.lastVisibleElement : "", firstVisibleElement ? style_scss_1.default.firstVisibleElement : "", isPlaceholder ? style_scss_1.default.placeHolder : "") }), child));
        })));
    };
    (0, react_1.useEffect)(function () {
        if (childCount > constants_1.N_CHILDREN_IN_VIEW) {
            var inactiveTrackerDots = new Array(childCount - constants_1.MIN_CHILDREN_TO_SHOW_NAVIGATION).fill(trackerDots_1.StatusIndicators.Inactive);
            setTrackerDots(__spreadArray([
                fixedTitle ? trackerDots_1.StatusIndicators.Fixed : trackerDots_1.StatusIndicators.Active,
                trackerDots_1.StatusIndicators.Active,
                trackerDots_1.StatusIndicators.Active
            ], inactiveTrackerDots, true));
        }
    }, []);
    var showNavigation = childCount > constants_1.MIN_CHILDREN_TO_SHOW_NAVIGATION;
    var tracker = showNavigation && (react_1.default.createElement(trackerDots_1.default, __assign({}, ovr.trackerDots, { statusIndicators: trackerDots })));
    var arrows = showNavigation && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(arrow_1.default, __assign({}, ovr.arrowLeft, { direction: arrow_1.ArrowDirections.Left, onClick: handleOnClickLeft, disabled: activeIndexes[0] - 2 < 0 })),
        react_1.default.createElement(arrow_1.default, __assign({}, ovr.arrowRight, { direction: arrow_1.ArrowDirections.Right, onClick: handleOnClickRight, disabled: activeIndexes[1] + 2 > childCount }))));
    return (react_1.default.createElement("div", __assign({}, props, ovr.carousel, { className: (0, classnames_1.default)(ovr.carousel.className, className, (_b = {},
            _b[style_scss_1.default.showNavigation] = showNavigation,
            _b[style_scss_1.default.renderNavigationOutsideContainer] = props.renderNavigationOutsideContainer,
            _b)) }),
        react_1.default.createElement("div", __assign({}, ovr.titles),
            fixedTitle && react_1.default.createElement("div", __assign({}, ovr.fixedTitle), fixedTitle),
            title && react_1.default.createElement("div", __assign({}, ovr.title), title)),
        react_1.default.createElement("div", __assign({}, ovr.childrenContainer), renderChildren()),
        tracker,
        arrows));
};
Carousel.displayName = exports.componentName;
exports["default"] = Carousel;


/***/ }),

/***/ 49249:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "ChatPageHeader";
exports.elementIdentifiers = (0, shared_1.tuple)("header", "botInfoContainer", "botInfo", "botInfoWithLogo", "logo", "botName", "botSubtitle", "byText");


/***/ }),

/***/ 32751:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(39837));
var constants_1 = __webpack_require__(49249);
var monty_bot_png_1 = __importDefault(__webpack_require__(40699));
var arrow_left_24px_react_svg_1 = __importDefault(__webpack_require__(55982));
var logo_better_2024_no_size_react_svg_1 = __importDefault(__webpack_require__(70868));
var form_1 = __webpack_require__(13174);
var classnames_1 = __importDefault(__webpack_require__(57485));
var ChatHeader = function (_a) {
    var _b, _c;
    var type = _a.type, _d = _a.botName, botName = _d === void 0 ? "Monty" : _d, _e = _a.subtitle, subtitle = _e === void 0 ? "Here to help" : _e, _f = _a.byText, byText = _f === void 0 ? "Powered by" : _f, _g = _a.buttonColour, buttonColour = _g === void 0 ? shared_1.ButtonColour.Secondary : _g, onBackButtonClick = _a.onBackButtonClick, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["type", "botName", "subtitle", "byText", "buttonColour", "onBackButtonClick", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.header, { className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.panelHeader] = type === "panel", _b), (_c = {}, _c[style_scss_1.default.pageHeader] = type === "page", _c), ovr.header.className) }, props),
        react_1.default.createElement("div", __assign({}, ovr.botInfoContainer),
            type === "page" && (react_1.default.createElement(form_1.Button, { colour: buttonColour, size: shared_1.ButtonSize.Icon, onClick: onBackButtonClick, fixed: false, id: "".concat(buttonColour, "-icon"), className: style_scss_1.default.backButtonContainer, "aria-label": "Go back" },
                react_1.default.createElement("div", { className: style_scss_1.default.backButton },
                    react_1.default.createElement(arrow_left_24px_react_svg_1.default, null)))),
            react_1.default.createElement("img", { loading: "lazy", src: monty_bot_png_1.default, width: "48", alt: "Better AI Bot avatar" }),
            react_1.default.createElement("div", __assign({}, ovr.botInfo),
                react_1.default.createElement("span", __assign({}, ovr.botName), botName),
                react_1.default.createElement("span", __assign({}, ovr.botSubtitle), subtitle))),
        type === "panel" && (react_1.default.createElement("div", __assign({}, ovr.botInfoWithLogo),
            react_1.default.createElement("span", __assign({}, ovr.byText), byText),
            react_1.default.createElement("div", __assign({}, ovr.logo),
                react_1.default.createElement(logo_better_2024_no_size_react_svg_1.default, null))))));
};
ChatHeader.displayName = constants_1.componentName;
exports["default"] = ChatHeader;


/***/ }),

/***/ 63633:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "ComplexButton";
exports.elementIdentifiers = (0, shared_1.tuple)("complexButton", "horizontalContainer", "leftContainer", "middleContainer", "topRow", "title", "pill", "body");


/***/ }),

/***/ 88824:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var pill_1 = __importStar(__webpack_require__(74747));
var right_react_svg_1 = __importDefault(__webpack_require__(22906));
var style_scss_1 = __importDefault(__webpack_require__(1536));
var constants_1 = __webpack_require__(63633);
var content_1 = __webpack_require__(49429);
/**
 * A big button with a few inner elements.
 *
 * Will not render a pill if `isLoading`=true (even if `pillBody` is defined), and will show a spinner instead.
 * `isPartiallyDisabled` will disable the button but it will not appear fully disabled.
 * `disabled` will take precedence over `isPartiallyDisabled`,
 * and it will make the button be disabled and look fully disabled.
 */
var ComplexButton = function (_a) {
    var _b, _c;
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, icon = _a.icon, title = _a.title, pillBody = _a.pillBody, body = _a.body, isPartiallyDisabled = _a.isPartiallyDisabled, isLoading = _a.isLoading, disabled = _a.disabled, props = __rest(_a, ["className", "classOverrides", "testIds", "refs", "icon", "title", "pillBody", "body", "isPartiallyDisabled", "isLoading", "disabled"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, props, ovr.complexButton, { className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.partiallyDisabled] = disabled || isPartiallyDisabled, _b), (_c = {}, _c[style_scss_1.default.fullyDisabled] = disabled, _c), ovr.complexButton.className, className), disabled: disabled || isPartiallyDisabled }),
        react_1.default.createElement("div", __assign({}, ovr.horizontalContainer),
            react_1.default.createElement("div", __assign({}, ovr.leftContainer), icon),
            react_1.default.createElement("div", __assign({}, ovr.middleContainer),
                react_1.default.createElement("div", __assign({}, ovr.topRow),
                    react_1.default.createElement("span", __assign({}, ovr.title), title),
                    react_1.default.createElement(right_react_svg_1.default, null),
                    pillBody && !isLoading ? (react_1.default.createElement(pill_1.default, __assign({ colour: disabled ? pill_1.PillColours.Disabled : pill_1.PillColours.Primary, inline: false }, ovr.pill), pillBody)) : null),
                react_1.default.createElement("div", __assign({}, ovr.body), body)),
            isLoading ? (react_1.default.createElement("div", { className: style_scss_1.default.rightContainer },
                react_1.default.createElement("div", { className: style_scss_1.default.spinnerContainer },
                    react_1.default.createElement(content_1.Spinner, { size: 24, backgroundArcClassname: style_scss_1.default.spinnerBackgroundArc, rotatingArcClassname: style_scss_1.default.spinnerForegroundArc })))) : null)));
};
ComplexButton.displayName = constants_1.componentName;
exports["default"] = ComplexButton;


/***/ }),

/***/ 22075:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var getImage_1 = __importDefault(__webpack_require__(1308));
var form_1 = __webpack_require__(13174);
var style_scss_1 = __importDefault(__webpack_require__(23531));
var content_1 = __webpack_require__(49429);
var contactCard_1 = __importDefault(__webpack_require__(77074));
var auxiliary_1 = __webpack_require__(84334);
var componentName = "ContactAdviser";
var elementIdentifiers = (0, shared_1.tuple)("contactAdviser", "cta", "title", "messageTextArea", "closeButton");
var ContactAdviser = function (_a) {
    var _b;
    var _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.isValid, isValid = _d === void 0 ? true : _d, value = _a.value, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, icon = _a.icon, contact = _a.contact, cta = _a.cta, sent = _a.sent, onClose = _a.onClose, errorMessage = _a.errorMessage, mortgageProduct = _a.mortgageProduct, messageIntro = _a.messageIntro, greeting = _a.greeting, props = __rest(_a, ["disabled", "isValid", "value", "className", "classOverrides", "testIds", "refs", "icon", "contact", "cta", "sent", "onClose", "errorMessage", "mortgageProduct", "messageIntro", "greeting"]);
    var _e = (0, react_1.useState)(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var handleOnClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, cta.onClick(e)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var lenderLogoSmallImageURL = mortgageProduct === null || mortgageProduct === void 0 ? void 0 : mortgageProduct.lenderLogoSmallImageURL;
    return (react_1.default.createElement("div", __assign({}, ovr.contactAdviser, props, { className: (0, classnames_1.default)(className, ovr.contactAdviser.className) }),
        react_1.default.createElement(contactCard_1.default, { contact: contact, icon: icon }),
        sent ? (react_1.default.createElement("div", { className: style_scss_1.default.successMessage },
            react_1.default.createElement("p", null, props.successMessage))) : (react_1.default.createElement(react_1.default.Fragment, null,
            mortgageProduct && (react_1.default.createElement("div", { className: style_scss_1.default.messageTemplateContainer },
                greeting,
                react_1.default.createElement("br", null),
                messageIntro,
                react_1.default.createElement("div", { className: style_scss_1.default.mortgageProductContainer },
                    react_1.default.createElement(auxiliary_1.LogoContainer, null,
                        react_1.default.createElement(auxiliary_1.LogoImageContainer, null, (0, getImage_1.default)(lenderLogoSmallImageURL, mortgageProduct.lenderName)),
                        react_1.default.createElement(auxiliary_1.ProductInitialDuration, null, mortgageProduct.title)),
                    react_1.default.createElement(auxiliary_1.MainInfoContainer, null,
                        react_1.default.createElement(auxiliary_1.MainInfoLine, null,
                            react_1.default.createElement(auxiliary_1.TextPair, { label: "Monthly payment", value: mortgageProduct.monthlyPayment }),
                            react_1.default.createElement(auxiliary_1.TextPair, { label: "Initial Rate", value: mortgageProduct.initialRate, textAlignment: auxiliary_1.TextPairAlignment.RIGHT })),
                        react_1.default.createElement(auxiliary_1.MainInfoLine, null,
                            react_1.default.createElement(auxiliary_1.TextPair, { label: "Total fees", value: mortgageProduct.totalFees }),
                            react_1.default.createElement(auxiliary_1.TextPair, { label: "Cashback", value: mortgageProduct.cashback, textAlignment: auxiliary_1.TextPairAlignment.CENTER }),
                            react_1.default.createElement(auxiliary_1.TextPair, { label: "APRC", value: mortgageProduct.lenderAprc, textAlignment: auxiliary_1.TextPairAlignment.RIGHT })))))),
            react_1.default.createElement("div", { className: style_scss_1.default.messageTextAreaContainer },
                react_1.default.createElement("textarea", { disabled: isSubmitting, "aria-label": "Text area", className: (0, classnames_1.default)((_b = {}, _b[style_scss_1.default.messageTextAreaInvalid] = !isValid, _b), style_scss_1.default.messageTextArea), value: value, placeholder: props.placeholder, maxLength: props.maxLength }),
                errorMessage && react_1.default.createElement(form_1.FieldError, { message: errorMessage })))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.buttonContainer) },
            react_1.default.createElement(form_1.Button, { testIds: { button: ovr.closeButton["data-testid"] }, size: shared_1.ButtonSize.Small, colour: shared_1.ButtonColour.Secondary, onClick: onClose, fixed: false, id: "".concat(shared_1.ButtonColour.Secondary, "-small"), disabled: isSubmitting }, "Close"),
            !sent && (react_1.default.createElement(form_1.Button, __assign({}, ovr.cta, { disabled: disabled || isSubmitting, size: shared_1.ButtonSize.Small, colour: shared_1.ButtonColour.Success, onClick: handleOnClick, fixed: false, id: "".concat(shared_1.ButtonColour.Primary, "-small") }), isSubmitting ? react_1.default.createElement(content_1.Spinner, { size: 20 }) : cta.text)))));
};
ContactAdviser.displayName = componentName;
exports["default"] = ContactAdviser;


/***/ }),

/***/ 20781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShowMoreButton = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var expandButton_1 = __importDefault(__webpack_require__(94540));
var style_scss_1 = __importDefault(__webpack_require__(12901));
var ShowMoreButton = function (_a) {
    var props = __rest(_a, []);
    return (react_1.default.createElement(expandButton_1.default, __assign({}, props, { className: (0, classnames_1.default)(style_scss_1.default.flexItem, style_scss_1.default.showMoreButton) }), "Show more"));
};
exports.ShowMoreButton = ShowMoreButton;


/***/ }),

/***/ 77074:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var form_1 = __webpack_require__(13174);
var avatar_react_svg_1 = __importDefault(__webpack_require__(63327));
var style_scss_1 = __importDefault(__webpack_require__(12901));
var collapsibleContent_1 = __importDefault(__webpack_require__(24082));
var auxiliary_1 = __webpack_require__(20781);
var isImageComponent_1 = __importDefault(__webpack_require__(39294));
var componentName = "ContactCard";
var elementIdentifiers = (0, shared_1.tuple)("contactCard", "detailsButton", "contactCardWrapper", "cta");
var ContactCard = function (_a) {
    var _b, _c;
    var children = _a.children, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, _d = _a.fixed, fixed = _d === void 0 ? false : _d, icon = _a.icon, contact = _a.contact, _e = _a.openByDefault, openByDefault = _e === void 0 ? true : _e, _f = _a.isCollapsible, isCollapsible = _f === void 0 ? false : _f, cta = _a.cta, props = __rest(_a, ["children", "className", "classOverrides", "testIds", "refs", "fixed", "icon", "contact", "openByDefault", "isCollapsible", "cta"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _g = (0, react_1.useState)(false), isContentOpen = _g[0], setIsContentOpen = _g[1];
    var _h = (0, react_1.useState)(false), iconFailed = _h[0], setIconFailed = _h[1];
    var iconFailedToLoad = function () {
        setIconFailed(true);
    };
    return (react_1.default.createElement("div", __assign({}, ovr.contactCard, props, { className: (0, classnames_1.default)(className, (_b = {}, _b[style_scss_1.default.fixed] = fixed, _b), ovr.contactCardWrapper.className) }),
        react_1.default.createElement(collapsibleContent_1.default, { title: "Adviser Details", isCollapsible: isCollapsible, openByDefault: openByDefault },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(className, (_c = {}, _c[style_scss_1.default.fixed] = fixed, _c), ovr.contactCard.className) },
                react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.column, style_scss_1.default.iconContainer) }, iconFailed ? (react_1.default.createElement(avatar_react_svg_1.default, null)) : (((0, isImageComponent_1.default)(icon) && (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.icon) }, icon))) || (react_1.default.createElement("img", { src: icon.src, alt: icon.alt, className: (0, classnames_1.default)(style_scss_1.default.icon), onError: iconFailedToLoad })))),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.column, style_scss_1.default.details) },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.contactCardField, style_scss_1.default.title) }, contact.name),
                    contact.jobTitle && (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.contactCardField, style_scss_1.default.subTitle) }, contact.jobTitle)),
                    contact.telephoneNumber && (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.contactCardField, style_scss_1.default.phoneNumber) },
                        "T:",
                        " ",
                        react_1.default.createElement("a", { href: "tel:".concat(contact.telephoneNumber) },
                            contact.telephoneNumber,
                            " "))),
                    contact.emailAddress && (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.contactCardField, style_scss_1.default.emailAddress) },
                        "E:",
                        " ",
                        react_1.default.createElement("a", { href: "mailto:".concat(contact.emailAddress) }, contact.emailAddress.length > 30
                            ? "".concat(contact.emailAddress.substr(0, 27), "...")
                            : contact.emailAddress))),
                    cta && (react_1.default.createElement(form_1.Button, __assign({}, ovr.cta, { size: shared_1.ButtonSize.Small, colour: shared_1.ButtonColour.Secondary, onClick: cta.onClick, fixed: false, id: "".concat(shared_1.ButtonColour.Secondary, "-small") }), cta.text))),
                children && (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.column, style_scss_1.default.children) },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(!isContentOpen && style_scss_1.default.truncatedContent) }, children),
                    react_1.default.createElement(auxiliary_1.ShowMoreButton, __assign({}, ovr.detailsButton, { isExpanded: isContentOpen, onClick: function () { return setIsContentOpen(!isContentOpen); } }))))))));
};
ContactCard.displayName = componentName;
exports["default"] = ContactCard;


/***/ }),

/***/ 71564:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ESCAPE_KEY_CODE = exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "Drawer";
exports.elementIdentifiers = (0, shared_1.tuple)("drawer", "drawerContainer", "drawerHeader", "close", "drawerHeaderText");
exports.ESCAPE_KEY_CODE = 27;


/***/ }),

/***/ 50668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(11178));
var constants_1 = __webpack_require__(71564);
var Drawer = function (_a) {
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var handleKeyPress = function (e) {
        // eslint-disable-next-line no-magic-numbers
        if (e.keyCode === constants_1.ESCAPE_KEY_CODE) {
            props.toggleFunction();
        }
    };
    return (react_1.default.createElement("aside", __assign({}, ovr.drawerContainer, { onKeyPress: handleKeyPress, onClick: props.toggleFunction, className: (0, classnames_1.default)(ovr.drawerContainer.className, className, props.active ? style_scss_1.default.active : "", props.position ? style_scss_1.default[props.position] : style_scss_1.default.right), role: "presentation" }),
        react_1.default.createElement("div", __assign({}, ovr.drawer, { className: (0, classnames_1.default)(ovr.drawer.className), role: "none", onKeyPress: handleKeyPress, onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
            } }),
            react_1.default.createElement("div", __assign({}, ovr.drawerHeader, { className: (0, classnames_1.default)(ovr.drawerHeader.className) }),
                react_1.default.createElement("div", __assign({}, ovr.close, { role: "button", onClick: props.toggleFunction, onKeyPress: handleKeyPress, className: (0, classnames_1.default)(ovr.close.className), tabIndex: 0, dangerouslySetInnerHTML: { __html: "&#x2715" } })),
                react_1.default.createElement("div", __assign({}, ovr.drawerHeaderText, { className: (0, classnames_1.default)(ovr.drawerHeaderText.className) }), props.headerText)),
            props.children)));
};
Drawer.displayName = constants_1.componentName;
exports["default"] = Drawer;


/***/ }),

/***/ 17954:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Header3 = exports.LogoColour = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var React = __importStar(__webpack_require__(99497));
var form_1 = __webpack_require__(13174);
var shared_1 = __webpack_require__(89574);
var Menu_1 = __webpack_require__(1830);
var PartnerLogo_1 = __webpack_require__(59696);
var logo_better_2024_no_size_react_svg_1 = __importDefault(__webpack_require__(70868));
var style_scss_1 = __importDefault(__webpack_require__(23093));
var MenuItem_1 = __webpack_require__(9536);
var constants_1 = __webpack_require__(17825);
var signInProfileButton_1 = __webpack_require__(54526);
var componentName = "Header3";
var elementIdentifiers = (0, shared_1.tuple)("header3", "headerInner", "headerInnerLeft", "hamburger", "homeLinkHolder", "headerLogo", "menuItems", "lineBreak", "partnerContainer", "headerLogoText", "headerLogoPartner", "headerInnerRight", "headerLogin");
var LogoColour;
(function (LogoColour) {
    LogoColour["White"] = "white";
    LogoColour["Black"] = "black";
    LogoColour["Green"] = "green";
})(LogoColour = exports.LogoColour || (exports.LogoColour = {}));
var Header3 = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var partner = _a.partner, homeUrl = _a.homeUrl, onLogInButtonClick = _a.onLogInButtonClick, onGetStartedButtonClick = _a.onGetStartedButtonClick, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, navigationMenu = _a.navigationMenu, _m = _a.theme, theme = _m === void 0 ? "dark" : _m, _o = _a.showMenu, showMenu = _o === void 0 ? true : _o, _p = _a.centerLogo, centerLogo = _p === void 0 ? false : _p, _q = _a.showLogin, showLogin = _q === void 0 ? true : _q, signInButtonOptions = _a.signInButtonOptions, _r = _a.isLoggedIn, isLoggedIn = _r === void 0 ? false : _r, _s = _a.isLoading, isLoading = _s === void 0 ? false : _s, _t = _a.logoColour, logoColour = _t === void 0 ? LogoColour.Black : _t, loadingButtonProps = _a.loadingButtonProps, buttonWithOptionsProps = _a.buttonWithOptionsProps, props = __rest(_a, ["partner", "homeUrl", "onLogInButtonClick", "onGetStartedButtonClick", "classOverrides", "testIds", "refs", "navigationMenu", "theme", "showMenu", "centerLogo", "showLogin", "signInButtonOptions", "isLoggedIn", "isLoading", "logoColour", "loadingButtonProps", "buttonWithOptionsProps"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var Logo = logo_better_2024_no_size_react_svg_1.default;
    var logoStyle = centerLogo ? { margin: "auto" } : {};
    return (React.createElement("header", __assign({}, ovr.header3, { className: (0, classnames_1.default)(ovr.header3.className, (_b = {},
            _b[style_scss_1.default.light] = theme === "light",
            _b)) }),
        React.createElement("div", __assign({}, ovr.headerInner, { className: (0, classnames_1.default)(ovr.headerInner.className, (_c = {},
                _c[style_scss_1.default.headerInnerPartner] = partner,
                _c)) }),
            React.createElement("div", __assign({}, ovr.headerInnerLeft, { className: (0, classnames_1.default)(ovr.headerInnerLeft.className, (_d = {},
                    _d[style_scss_1.default.headerInnerLeftPartner] = partner,
                    _d)), style: logoStyle }),
                showMenu ? (React.createElement("div", __assign({}, ovr.hamburger, { className: (0, classnames_1.default)(ovr.hamburger.className, (_e = {},
                        _e[style_scss_1.default.hamburgerPartner] = partner,
                        _e[style_scss_1.default["logo-".concat(logoColour)]] = logoColour === "white" || logoColour === "green",
                        _e[style_scss_1.default.logoWhite] = theme === "dark",
                        _e)) }),
                    React.createElement(Menu_1.Menu, { partner: partner, showLogin: showLogin, Logo: Logo, useVersion3: true, menuItems: navigationMenu, onGetStartedButtonClick: onGetStartedButtonClick, onSignInButtonClick: onLogInButtonClick, theme: theme === "light" ? "light" : "dark" }))) : null,
                React.createElement("div", __assign({}, ovr.homeLinkHolder), partner ? (React.createElement(PartnerLogo_1.PartnerLogo, { partner: partner, theme: theme })) : (React.createElement("a", __assign({}, ovr.headerLogo, { href: homeUrl, tabIndex: 0, "aria-label": constants_1.DOMAIN, className: (0, classnames_1.default)(ovr.headerLogo.className, (_f = {},
                        _f[style_scss_1.default["logo-".concat(logoColour)]] = logoColour === "white" || logoColour === "green",
                        _f[style_scss_1.default.logoWhite] = theme === "dark",
                        _f)) }),
                    React.createElement(Logo, null)))),
                showMenu ? (React.createElement("div", __assign({}, ovr.menuItems, { className: (0, classnames_1.default)(ovr.menuItems.className, (_g = {},
                        _g[style_scss_1.default.menuItemsPartner] = partner,
                        _g)) }), navigationMenu &&
                    navigationMenu.map(function (menuItem) { return (React.createElement(MenuItem_1.MenuItem, { key: menuItem.text, useVersion3: true, theme: theme, menuItem: menuItem })); }))) : null),
            React.createElement("div", __assign({}, ovr.lineBreak, { className: (0, classnames_1.default)(ovr.lineBreak.className, (_h = {},
                    _h[style_scss_1.default.lineBreakPartner] = partner,
                    _h)) })),
            partner && (React.createElement("div", __assign({}, ovr.partnerContainer, { className: (0, classnames_1.default)(ovr.partnerContainer.className, (_j = {},
                    _j[style_scss_1.default.partnerContainerPartner] = partner,
                    _j)) }),
                React.createElement("div", __assign({}, ovr.headerLogoText), "provided by"),
                React.createElement("a", __assign({}, ovr.headerLogoPartner, { href: homeUrl, tabIndex: 0, "aria-label": constants_1.DOMAIN, className: (0, classnames_1.default)(ovr.headerLogoPartner.className, (_k = {},
                        _k[style_scss_1.default["logo-".concat(logoColour)]] = logoColour === "white" || logoColour === "green",
                        _k[style_scss_1.default.logoWhite] = theme === "dark",
                        _k)) }),
                    React.createElement(logo_better_2024_no_size_react_svg_1.default, null)))),
            showLogin && (React.createElement("div", __assign({}, ovr.headerInnerRight, { className: (0, classnames_1.default)(ovr.headerInnerRight.className, (_l = {},
                    _l[style_scss_1.default.headerInnerRightPartner] = partner,
                    _l)) }), signInButtonOptions ? (React.createElement(signInProfileButton_1.SignInProfileButton, { isLoggedIn: isLoggedIn, isLoading: isLoading, onClick: onLogInButtonClick, loadingButtonProps: loadingButtonProps, buttonWithOptionsProps: buttonWithOptionsProps, options: signInButtonOptions })) : (React.createElement(form_1.Button, __assign({}, ovr.headerLogin, { onClick: onLogInButtonClick, tabIndex: 0, size: shared_1.ButtonSize.Small, colour: theme === "light"
                    ? shared_1.ButtonColour.TertiaryLight
                    : shared_1.ButtonColour.Tertiary, fixed: false }), "Sign in")))))));
};
exports.Header3 = Header3;


/***/ }),

/***/ 65826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


// eslint-disable-file camelcase
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PartnerLogo = exports.logos = void 0;
var emma_react_svg_1 = __importDefault(__webpack_require__(33280));
var eveningstandard_react_svg_1 = __importDefault(__webpack_require__(34958));
var forbes_react_svg_1 = __importDefault(__webpack_require__(50353));
var moveiq_react_svg_1 = __importDefault(__webpack_require__(14745));
var React = __importStar(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(20303));
var classnames_1 = __importDefault(__webpack_require__(57485));
/*
  Documentation for adding Partner logos to all apps:
  https://teamtrussle.atlassian.net/wiki/spaces/ENG/pages/670171213/Adding+a+Partner+logo
*/
exports.logos = {
    emma: { src: emma_react_svg_1.default, alt: "Emma Logo" },
    eveningstandard: { src: eveningstandard_react_svg_1.default, alt: "Evening Standard Logo" },
    evening_standard: { src: eveningstandard_react_svg_1.default, alt: "Evening Standard Logo" },
    forbes: { src: forbes_react_svg_1.default, alt: "Forbes Logo" },
    moveiq: { src: moveiq_react_svg_1.default, alt: "Move iQ Logo" }
};
var PartnerLogo = function (_a) {
    var _b;
    var partner = _a.partner, theme = _a.theme;
    var partnerLogo = exports.logos[partner];
    if (!partnerLogo) {
        return null;
    }
    var logoClass = style_scss_1.default[partner.toLowerCase()] || "";
    return (React.createElement("div", { className: (0, classnames_1.default)("".concat(logoClass, " ").concat(style_scss_1.default.partnerImage, " ").concat(style_scss_1.default.header3), (_b = {},
            _b[style_scss_1.default.light] = theme === "light",
            _b[style_scss_1.default.dark] = theme === "dark",
            _b)) },
        React.createElement(partnerLogo.src, null)));
};
exports.PartnerLogo = PartnerLogo;


/***/ }),

/***/ 59696:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.logos = exports.PartnerLogo = void 0;
var PartnerLogo_1 = __webpack_require__(65826);
Object.defineProperty(exports, "PartnerLogo", ({ enumerable: true, get: function () { return PartnerLogo_1.PartnerLogo; } }));
Object.defineProperty(exports, "logos", ({ enumerable: true, get: function () { return PartnerLogo_1.logos; } }));


/***/ }),

/***/ 13165:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LogoColour = exports.IHeader3Props = exports.Header3 = void 0;
var Header3_1 = __webpack_require__(17954);
Object.defineProperty(exports, "Header3", ({ enumerable: true, get: function () { return Header3_1.Header3; } }));
Object.defineProperty(exports, "IHeader3Props", ({ enumerable: true, get: function () { return Header3_1.IHeader3Props; } }));
Object.defineProperty(exports, "LogoColour", ({ enumerable: true, get: function () { return Header3_1.LogoColour; } }));


/***/ }),

/***/ 55334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Menu = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var React = __importStar(__webpack_require__(99497));
var MenuItem_1 = __webpack_require__(12802);
var burger_react_svg_1 = __importDefault(__webpack_require__(37682));
var close_react_svg_1 = __importDefault(__webpack_require__(47724));
var style_scss_1 = __importDefault(__webpack_require__(14493));
var use_onclickoutside_1 = __importDefault(__webpack_require__(37251));
var instagram_2024_react_svg_1 = __importDefault(__webpack_require__(1247));
var tiktok_2024_react_svg_1 = __importDefault(__webpack_require__(22082));
var facebook_2024_react_svg_1 = __importDefault(__webpack_require__(47699));
var linkedin_2024_react_svg_1 = __importDefault(__webpack_require__(80022));
var Menu = function (_a) {
    var _b;
    var Logo = _a.Logo, menuItems = _a.menuItems, partner = _a.partner, _c = _a.socialLinks, socialLinks = _c === void 0 ? {} : _c;
    var _d = React.useState(true), isCollapsed = _d[0], setIsCollapsed = _d[1];
    var ref = React.useRef(null);
    function toggleMenu() {
        setIsCollapsed(!isCollapsed);
    }
    var handleKeyDownOpen = React.useCallback(function (event) {
        if (event.key === " " ||
            event.key === "Enter" ||
            event.key === "Spacebar") {
            event.preventDefault();
            toggleMenu();
        }
    }, []);
    var handleKeyDownClose = React.useCallback(function (event) {
        if (event.key === "Escape") {
            event.preventDefault();
            toggleMenu();
        }
    }, []);
    (0, use_onclickoutside_1.default)(ref, function () {
        setIsCollapsed(true);
    });
    return (React.createElement("nav", { ref: ref },
        React.createElement("div", { className: style_scss_1.default.hamburger },
            React.createElement("button", { onClick: toggleMenu, className: style_scss_1.default.button, "aria-label": "Open navigation", "aria-expanded": !isCollapsed, "aria-haspopup": "true", onKeyDown: handleKeyDownOpen },
                React.createElement(burger_react_svg_1.default, { fill: "black" })),
            React.createElement("div", { id: "sidebar-headers", className: (0, classnames_1.default)(style_scss_1.default.sidenav, (_b = {},
                    _b[style_scss_1.default.collapsed] = isCollapsed,
                    _b[style_scss_1.default.sidenavOpen] = !isCollapsed,
                    _b)) },
                React.createElement("div", { className: style_scss_1.default.logoContainer },
                    React.createElement("a", { href: "/" }, Logo && React.createElement(Logo, null)),
                    React.createElement("button", { className: (0, classnames_1.default)(style_scss_1.default.button, style_scss_1.default.closeButton), onClick: toggleMenu, onKeyDown: handleKeyDownClose, "aria-label": "Close navigation" },
                        React.createElement(close_react_svg_1.default, { stroke: "black" }))),
                React.createElement("div", { className: style_scss_1.default.menuItemsContainer },
                    menuItems &&
                        menuItems.map(function (menuItem) { return (React.createElement(MenuItem_1.MenuItem, { partner: partner, mobileView: true, menuItem: menuItem, key: menuItem.text })); }),
                    React.createElement("div", { className: style_scss_1.default.socialButtons },
                        socialLinks.tiktok && (React.createElement("a", { href: socialLinks.tiktok, target: "_blank", rel: "noreferrer noopener" },
                            React.createElement(tiktok_2024_react_svg_1.default, null))),
                        socialLinks.linkedin && (React.createElement("a", { href: socialLinks.linkedin, target: "_blank", rel: "noreferrer noopener" },
                            React.createElement(linkedin_2024_react_svg_1.default, null))),
                        socialLinks.facebook && (React.createElement("a", { href: socialLinks.facebook, target: "_blank", rel: "noreferrer noopener" },
                            React.createElement(facebook_2024_react_svg_1.default, null))),
                        socialLinks.instagram && (React.createElement("a", { href: socialLinks.instagram, target: "_blank", rel: "noreferrer noopener" },
                            React.createElement(instagram_2024_react_svg_1.default, null)))))))));
};
exports.Menu = Menu;


/***/ }),

/***/ 91316:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Menu = void 0;
var Menu_1 = __webpack_require__(55334);
Object.defineProperty(exports, "Menu", ({ enumerable: true, get: function () { return Menu_1.Menu; } }));


/***/ }),

/***/ 6:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 10177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuItem = exports.OptionsCard = exports.ListItem = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var React = __importStar(__webpack_require__(99497));
var use_onclickoutside_1 = __importDefault(__webpack_require__(37251));
var arrowV3_black_react_svg_1 = __importDefault(__webpack_require__(70825));
var style_scss_1 = __importDefault(__webpack_require__(42873));
var ListItem = function (_a) {
    var _b;
    var subMenuItem = _a.subMenuItem, partner = _a.partner;
    return (React.createElement("li", { key: subMenuItem.text, className: style_scss_1.default.menuItemSubmenuLinkWrapper },
        React.createElement("a", { className: (0, classnames_1.default)(style_scss_1.default.menuItemSubmenuLink, (_b = {},
                _b[style_scss_1.default.partner] = partner,
                _b)), href: subMenuItem.url },
            React.createElement("span", null, subMenuItem.text))));
};
exports.ListItem = ListItem;
var OptionsCard = function (_a) {
    var _b, _c;
    var children = _a.children, isCollapsed = _a.isCollapsed, subMenuItems = _a.subMenuItems, partner = _a.partner;
    return (React.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.menuItemSubmenu, (_b = {},
            _b[style_scss_1.default.hasVisibilityHidden] = isCollapsed,
            _b)) },
        React.createElement("div", { className: (0, classnames_1.default)((_c = {}, _c[style_scss_1.default.withChildren] = Boolean(children), _c)) },
            React.createElement("ul", null, subMenuItems.map(function (subMenuItem) { return (React.createElement(exports.ListItem, { key: subMenuItem.text, subMenuItem: subMenuItem, partner: partner })); })),
            React.createElement("div", { className: style_scss_1.default.childrenWrapper }, children))));
};
exports.OptionsCard = OptionsCard;
var OptionsList = function (_a) {
    var _b;
    var isCollapsed = _a.isCollapsed, subMenuItems = _a.subMenuItems, partner = _a.partner;
    return (React.createElement("ul", { className: (0, classnames_1.default)(style_scss_1.default.optionsList, (_b = {},
            _b[style_scss_1.default.optionsListVisible] = !isCollapsed,
            _b)) }, subMenuItems &&
        subMenuItems.map(function (menuItem) { return (React.createElement(exports.ListItem, { subMenuItem: menuItem, partner: partner })); })));
};
var MenuItem = function (_a) {
    var _b, _c;
    var _d = _a.menuItem, subMenuItems = _d.subMenuItems, text = _d.text, url = _d.url, children = _d.children, _e = _a.mobileView, mobileView = _e === void 0 ? false : _e, partner = _a.partner;
    var _f = React.useState(true), isCollapsed = _f[0], setIsCollapsed = _f[1];
    function toggleMenu() {
        setIsCollapsed(!isCollapsed);
    }
    var ref = React.useRef(null);
    (0, use_onclickoutside_1.default)(ref, function () {
        if (!mobileView)
            setIsCollapsed(true);
    });
    var MenuOptions = null;
    if (mobileView) {
        MenuOptions = (React.createElement(OptionsList, { isCollapsed: isCollapsed, subMenuItems: subMenuItems, partner: partner }));
    }
    else if (subMenuItems && subMenuItems.length > 0) {
        MenuOptions = (React.createElement(exports.OptionsCard, { isCollapsed: isCollapsed, subMenuItems: subMenuItems, partner: partner }, children));
    }
    return (React.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.menuItem, (_b = {},
            _b[style_scss_1.default.collapsed] = isCollapsed,
            _b)), ref: ref },
        url ? (React.createElement("a", { className: (0, classnames_1.default)(style_scss_1.default.menuItemLink, style_scss_1.default.menuItemLinkLight, style_scss_1.default.arrowRight), href: url },
            React.createElement("span", { className: style_scss_1.default.underlineAnimation }, text))) : (React.createElement("button", { className: (0, classnames_1.default)(style_scss_1.default.button, style_scss_1.default.menuItemButton), onClick: toggleMenu, "aria-expanded": !isCollapsed, "aria-haspopup": "true" },
            React.createElement("p", { className: (0, classnames_1.default)(style_scss_1.default.menuButtonText, style_scss_1.default.underlineAnimation) }, text),
            React.createElement("span", { className: (0, classnames_1.default)(style_scss_1.default.menuButtonArrow, (_c = {},
                    _c[style_scss_1.default.partner] = partner,
                    _c[style_scss_1.default.collapsed] = isCollapsed,
                    _c)), style: { height: "24", width: "24" } },
                React.createElement(arrowV3_black_react_svg_1.default, null)))),
        MenuOptions));
};
exports.MenuItem = MenuItem;


/***/ }),

/***/ 12802:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IMenuItem = exports.MenuItem = void 0;
var MenuItem_1 = __webpack_require__(10177);
Object.defineProperty(exports, "MenuItem", ({ enumerable: true, get: function () { return MenuItem_1.MenuItem; } }));
var IMenuItem_1 = __webpack_require__(6);
Object.defineProperty(exports, "IMenuItem", ({ enumerable: true, get: function () { return IMenuItem_1.IMenuItem; } }));


/***/ }),

/***/ 57739:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IMenuItem = exports.Menu = void 0;
var Menu_1 = __webpack_require__(91316);
Object.defineProperty(exports, "Menu", ({ enumerable: true, get: function () { return Menu_1.Menu; } }));
var MenuItem_1 = __webpack_require__(12802);
Object.defineProperty(exports, "IMenuItem", ({ enumerable: true, get: function () { return MenuItem_1.IMenuItem; } }));


/***/ }),

/***/ 83616:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Header4 = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var logo_better_2024_no_size_react_svg_1 = __importDefault(__webpack_require__(70868));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(83962));
var Menu_1 = __webpack_require__(57739);
var signInProfileButton_1 = __webpack_require__(54526);
var MenuItem_1 = __webpack_require__(12802);
var PartnerLogo_1 = __webpack_require__(59696);
var constants_1 = __webpack_require__(17825);
var classnames_1 = __importDefault(__webpack_require__(57485));
var componentName = "Header4";
var elementIdentifiers = (0, shared_1.tuple)("header4", "headerLogo", "menuItems", "hamburgerMenu", "profileButton");
var Header4 = function (_a) {
    var classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, partner = _a.partner, homeUrl = _a.homeUrl, onLogInButtonClick = _a.onLogInButtonClick, navigationMenuItems = _a.navigationMenuItems, signInButtonOptions = _a.signInButtonOptions, _b = _a.isLoggedIn, isLoggedIn = _b === void 0 ? false : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, loadingButtonProps = _a.loadingButtonProps, buttonWithOptionsProps = _a.buttonWithOptionsProps, socialLinks = _a.socialLinks;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.header4),
        react_1.default.createElement("div", __assign({}, ovr.hamburgerMenu),
            react_1.default.createElement(Menu_1.Menu, { menuItems: navigationMenuItems, Logo: logo_better_2024_no_size_react_svg_1.default, socialLinks: socialLinks })),
        react_1.default.createElement("div", null, partner ? (react_1.default.createElement(PartnerLogo_1.PartnerLogo, { partner: partner, theme: "light" })) : (react_1.default.createElement("a", __assign({}, ovr.headerLogo, { href: homeUrl, tabIndex: 0, "aria-label": constants_1.DOMAIN }),
            react_1.default.createElement(logo_better_2024_no_size_react_svg_1.default, null)))),
        react_1.default.createElement("div", __assign({}, ovr.menuItems), navigationMenuItems &&
            navigationMenuItems.map(function (menuItem) { return (react_1.default.createElement(MenuItem_1.MenuItem, { key: menuItem.text, menuItem: menuItem })); })),
        react_1.default.createElement("div", __assign({}, ovr.profileButton),
            react_1.default.createElement(signInProfileButton_1.SignInProfileButton, { isLoggedIn: isLoggedIn, isLoading: isLoading, onClick: onLogInButtonClick, loadingButtonProps: loadingButtonProps, loadingButtonClassOverrides: {
                    button: style_scss_1.default.loadingButton,
                    buttonContentWrapper: style_scss_1.default.underlineAnimation,
                    buttonText: style_scss_1.default.arrowRight,
                    spinner: style_scss_1.default.loadingButtonSpinner
                }, buttonWithOptionsProps: __assign({ displayProfileIcon: false }, buttonWithOptionsProps), options: signInButtonOptions, buttonWithOptionsClassOverrides: {
                    profileText: (0, classnames_1.default)(style_scss_1.default.profileButtonText, style_scss_1.default.underlineAnimation),
                    mainOptionsButton: style_scss_1.default.profileButton
                } }))));
};
exports.Header4 = Header4;


/***/ }),

/***/ 61940:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderLoggedIn = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var logo_better_2024_react_svg_1 = __importDefault(__webpack_require__(99865));
var style_scss_1 = __importDefault(__webpack_require__(81138));
var profileMenu_1 = __importDefault(__webpack_require__(83723));
var contentLoader_1 = __importDefault(__webpack_require__(178));
var constants_1 = __webpack_require__(17825);
var HeaderLoggedIn = function (_a) {
    var name = _a.name, customGreetingText = _a.customGreetingText, hrefBetterLogo = _a.hrefBetterLogo, hrefLogOut = _a.hrefLogOut, onClickBetterLogo = _a.onClickBetterLogo, onClickLogOut = _a.onClickLogOut, onClickToggleMenu = _a.onClickToggleMenu, _b = _a.useVersion3, useVersion3 = _b === void 0 ? false : _b;
    var suffix = useVersion3 ? "-v3" : "";
    return (react_1.default.createElement("header", { className: style_scss_1.default["header-container".concat(suffix)] },
        react_1.default.createElement("div", { className: "tsl-container ".concat(style_scss_1.default["header-inner-container"]) },
            react_1.default.createElement("a", { href: hrefBetterLogo, onClick: onClickBetterLogo, "data-testid": "logo-link", "aria-label": constants_1.DOMAIN },
                react_1.default.createElement("div", { className: style_scss_1.default.logoBetter, "data-testId": "HeaderLoggedIn-betterLogo-".concat(useVersion3 ? "logoV3" : "logo") },
                    react_1.default.createElement(logo_better_2024_react_svg_1.default, null))),
            name ? (react_1.default.createElement(profileMenu_1.default, { icon: "illustration", className: style_scss_1.default["profile-menu"], name: name, customGreetingText: customGreetingText, onOpenToggle: onClickToggleMenu, classOverrides: {
                    illustrationIcon: style_scss_1.default.iconUser,
                    name: useVersion3 ? style_scss_1.default.nameStyle : undefined,
                    chevron: useVersion3 ? style_scss_1.default.chevron : undefined,
                    menuButton: useVersion3 ? style_scss_1.default.menuButton : undefined
                }, links: [
                    {
                        testId: "logout",
                        description: "Logout",
                        href: hrefLogOut,
                        onClick: onClickLogOut
                    }
                ] })) : (react_1.default.createElement(contentLoader_1.default, { classOverrides: { contentLoader: style_scss_1.default.loading } })))));
};
exports.HeaderLoggedIn = HeaderLoggedIn;


/***/ }),

/***/ 45876:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderTransparentNotLoggedIn = void 0;
var React = __importStar(__webpack_require__(99497));
var Header3_1 = __webpack_require__(13165);
var HeaderTransparentNotLoggedIn = function (props) { return React.createElement(Header3_1.Header3, __assign({ theme: "light", showMenu: false, centerLogo: true }, props)); };
exports.HeaderTransparentNotLoggedIn = HeaderTransparentNotLoggedIn;


/***/ }),

/***/ 84667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Menu = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var React = __importStar(__webpack_require__(99497));
var MenuItem_1 = __webpack_require__(9536);
var burger_react_svg_1 = __importDefault(__webpack_require__(6437));
var close_react_svg_1 = __importDefault(__webpack_require__(11372));
var style_scss_1 = __importDefault(__webpack_require__(93077));
var form_1 = __webpack_require__(13174);
var shared_1 = __webpack_require__(89574);
var use_onclickoutside_1 = __importDefault(__webpack_require__(37251));
var Menu = function (_a) {
    var _b, _c;
    var Logo = _a.Logo, menuItems = _a.menuItems, onGetStartedButtonClick = _a.onGetStartedButtonClick, onSignInButtonClick = _a.onSignInButtonClick, _d = _a.useVersion3, useVersion3 = _d === void 0 ? false : _d, _e = _a.theme, theme = _e === void 0 ? "dark" : _e, _f = _a.showLogin, showLogin = _f === void 0 ? true : _f, partner = _a.partner;
    var _g = React.useState(true), isCollapsed = _g[0], setIsCollapsed = _g[1];
    var ref = React.useRef(null);
    function toggleMenu() {
        setIsCollapsed(!isCollapsed);
    }
    var handleKeyDownOpen = React.useCallback(function (event) {
        if (event.key === " " ||
            event.key === "Enter" ||
            event.key === "Spacebar") {
            event.preventDefault();
            toggleMenu();
        }
    }, []);
    var handleKeyDownClose = React.useCallback(function (event) {
        if (event.key === "Escape") {
            event.preventDefault();
            toggleMenu();
        }
    }, []);
    (0, use_onclickoutside_1.default)(ref, function () {
        setIsCollapsed(true);
    });
    var themeColor = theme === "dark" ? "white" : "black";
    return (React.createElement("nav", { ref: ref, className: (0, classnames_1.default)((_b = {},
            _b[style_scss_1.default.dark] = theme === "dark",
            _b[style_scss_1.default.light] = theme === "light",
            _b[style_scss_1.default.navBarV3] = useVersion3,
            _b)) },
        React.createElement("div", { className: style_scss_1.default.hamburger, onKeyDown: handleKeyDownClose },
            React.createElement("button", { onClick: toggleMenu, className: style_scss_1.default.button, "aria-label": "Open navigation", "aria-expanded": !isCollapsed, "aria-haspopup": "true", onKeyDown: handleKeyDownOpen },
                React.createElement(burger_react_svg_1.default, { fill: themeColor })),
            React.createElement("div", { id: "sidebar-headers", className: (0, classnames_1.default)(style_scss_1.default.sidenav, (_c = {},
                    _c[style_scss_1.default.collapsed] = isCollapsed,
                    _c[style_scss_1.default.sidenavOpen] = !isCollapsed,
                    _c)) },
                React.createElement("div", { className: style_scss_1.default.logoContainer },
                    React.createElement("a", { href: "/" }, Logo && React.createElement(Logo, null)),
                    React.createElement("button", { className: (0, classnames_1.default)(style_scss_1.default.button, style_scss_1.default.closeButton), onClick: toggleMenu, onKeyDown: handleKeyDownClose, "aria-label": "Close navigation" },
                        React.createElement(close_react_svg_1.default, { stroke: themeColor }))),
                React.createElement("div", { className: style_scss_1.default.menuItemsContainer },
                    menuItems &&
                        menuItems.map(function (menuItem) { return (React.createElement(MenuItem_1.MenuItem, { partner: partner, useVersion3: useVersion3, mobileView: true, menuItem: menuItem, key: menuItem.text, theme: theme })); }),
                    showLogin && (React.createElement(form_1.Button, { colour: theme === "light"
                            ? shared_1.ButtonColour.TertiaryLight
                            : shared_1.ButtonColour.Tertiary, size: shared_1.ButtonSize.Medium, fixed: false, className: style_scss_1.default.getStartedButton, onClick: onSignInButtonClick }, "Sign in")),
                    React.createElement(form_1.Button, { colour: theme === "light"
                            ? shared_1.ButtonColour.TertiaryLight
                            : shared_1.ButtonColour.Tertiary, size: shared_1.ButtonSize.Medium, fixed: false, className: style_scss_1.default.getStartedButton, onClick: onGetStartedButtonClick }, "Get started"))))));
};
exports.Menu = Menu;


/***/ }),

/***/ 82105:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Menu = void 0;
var Menu_1 = __webpack_require__(84667);
Object.defineProperty(exports, "Menu", ({ enumerable: true, get: function () { return Menu_1.Menu; } }));


/***/ }),

/***/ 36271:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 29802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuItem = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var React = __importStar(__webpack_require__(99497));
var use_onclickoutside_1 = __importDefault(__webpack_require__(37251));
var arrow_react_svg_1 = __importDefault(__webpack_require__(81034));
var arrowV3_react_svg_1 = __importDefault(__webpack_require__(46685));
var arrowV3_black_react_svg_1 = __importDefault(__webpack_require__(13166));
var style_scss_1 = __importDefault(__webpack_require__(93077));
var ListItem = function (_a) {
    var _b;
    var subMenuItem = _a.subMenuItem, partner = _a.partner;
    return (React.createElement("li", { key: subMenuItem.text, className: style_scss_1.default.menuItemSubmenuLinkWrapper },
        React.createElement("a", { className: (0, classnames_1.default)(style_scss_1.default.menuItemSubmenuLink, (_b = {},
                _b[style_scss_1.default.partner] = partner,
                _b)), href: subMenuItem.url }, subMenuItem.text)));
};
var OptionsCard = function (_a) {
    var _b, _c;
    var children = _a.children, isCollapsed = _a.isCollapsed, subMenuItems = _a.subMenuItems, partner = _a.partner;
    return (React.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.menuItemSubmenu, (_b = {},
            _b[style_scss_1.default.hasVisibilityHidden] = isCollapsed,
            _b)) },
        React.createElement("div", { className: (0, classnames_1.default)((_c = {}, _c[style_scss_1.default.withChildren] = Boolean(children), _c)) },
            React.createElement("ul", null, subMenuItems.map(function (subMenuItem) { return (React.createElement(ListItem, { key: subMenuItem.text, subMenuItem: subMenuItem, partner: partner })); })),
            React.createElement("div", { className: style_scss_1.default.childrenWrapper }, children))));
};
var OptionsList = function (_a) {
    var isCollapsed = _a.isCollapsed, subMenuItems = _a.subMenuItems, partner = _a.partner;
    return (React.createElement("ul", { className: (0, classnames_1.default)(style_scss_1.default.optionsList, isCollapsed ? style_scss_1.default.optionsListHidden : style_scss_1.default.optionsListVisible) }, subMenuItems &&
        subMenuItems.map(function (menuItem) { return (React.createElement(ListItem, { subMenuItem: menuItem, partner: partner })); })));
};
var MenuItem = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.menuItem, subMenuItems = _f.subMenuItems, text = _f.text, url = _f.url, children = _f.children, useVersion3 = _a.useVersion3, _g = _a.mobileView, mobileView = _g === void 0 ? false : _g, _h = _a.theme, theme = _h === void 0 ? "dark" : _h, partner = _a.partner;
    var _j = React.useState(true), isCollapsed = _j[0], setIsCollapsed = _j[1];
    function toggleMenu() {
        setIsCollapsed(!isCollapsed);
    }
    var ref = React.useRef(null);
    (0, use_onclickoutside_1.default)(ref, function () {
        if (!mobileView)
            setIsCollapsed(true);
    });
    var MenuOptions = null;
    if (mobileView) {
        MenuOptions = (React.createElement(OptionsList, { isCollapsed: isCollapsed, subMenuItems: subMenuItems, partner: partner }));
    }
    else if (subMenuItems && subMenuItems.length > 0) {
        MenuOptions = (React.createElement(OptionsCard, { isCollapsed: isCollapsed, subMenuItems: subMenuItems, partner: partner }, children));
    }
    var ArrowImgComponent = arrow_react_svg_1.default;
    if (useVersion3) {
        ArrowImgComponent = theme === "light" ? arrowV3_black_react_svg_1.default : arrowV3_react_svg_1.default;
    }
    return (React.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.menuItem, (_b = {},
            _b[style_scss_1.default.collapsed] = isCollapsed,
            _b)), ref: ref },
        url ? (React.createElement("a", { className: (0, classnames_1.default)(style_scss_1.default.menuItemLink, (_c = {},
                _c[style_scss_1.default.menuItemLinkLight] = theme === "light",
                _c)), href: url }, text)) : (React.createElement("button", { className: (0, classnames_1.default)(style_scss_1.default.button, style_scss_1.default.menuItemButton, (_d = {},
                _d[style_scss_1.default.expanded] = !isCollapsed,
                _d[style_scss_1.default.menuItemButtonLight] = theme === "light",
                _d[style_scss_1.default.expandedLight] = !isCollapsed && theme === "light",
                _d)), onClick: toggleMenu, "aria-expanded": !isCollapsed, "aria-haspopup": "true" },
            React.createElement("p", { className: style_scss_1.default.menuButtonText }, text),
            React.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.menuButtonArrow, (_e = {},
                    _e[style_scss_1.default.partner] = partner,
                    _e[style_scss_1.default.collapsed] = isCollapsed,
                    _e)), style: {
                    height: useVersion3 ? "24" : "6",
                    width: useVersion3 ? "24" : "10"
                } },
                React.createElement(ArrowImgComponent, null)))),
        MenuOptions));
};
exports.MenuItem = MenuItem;


/***/ }),

/***/ 9536:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IMenuItem = exports.MenuItem = void 0;
var MenuItem_1 = __webpack_require__(29802);
Object.defineProperty(exports, "MenuItem", ({ enumerable: true, get: function () { return MenuItem_1.MenuItem; } }));
var IMenuItem_1 = __webpack_require__(36271);
Object.defineProperty(exports, "IMenuItem", ({ enumerable: true, get: function () { return IMenuItem_1.IMenuItem; } }));


/***/ }),

/***/ 1830:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IMenuItem = exports.Menu = void 0;
var Menu_1 = __webpack_require__(82105);
Object.defineProperty(exports, "Menu", ({ enumerable: true, get: function () { return Menu_1.Menu; } }));
var MenuItem_1 = __webpack_require__(9536);
Object.defineProperty(exports, "IMenuItem", ({ enumerable: true, get: function () { return MenuItem_1.IMenuItem; } }));


/***/ }),

/***/ 70192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* istanbul ignore file */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.logos = exports.IMenuItem = exports.HeaderTransparentNotLoggedIn = exports.HeaderLoggedIn = exports.LogoColour = exports.IHeader3Props = exports.Header3 = void 0;
var Header3_1 = __webpack_require__(13165);
Object.defineProperty(exports, "Header3", ({ enumerable: true, get: function () { return Header3_1.Header3; } }));
Object.defineProperty(exports, "IHeader3Props", ({ enumerable: true, get: function () { return Header3_1.IHeader3Props; } }));
Object.defineProperty(exports, "LogoColour", ({ enumerable: true, get: function () { return Header3_1.LogoColour; } }));
__exportStar(__webpack_require__(83616), exports);
var HeaderLoggedIn_1 = __webpack_require__(61940);
Object.defineProperty(exports, "HeaderLoggedIn", ({ enumerable: true, get: function () { return HeaderLoggedIn_1.HeaderLoggedIn; } }));
var HeaderTransparentNotLoggedIn_1 = __webpack_require__(45876);
Object.defineProperty(exports, "HeaderTransparentNotLoggedIn", ({ enumerable: true, get: function () { return HeaderTransparentNotLoggedIn_1.HeaderTransparentNotLoggedIn; } }));
var MenuItem_1 = __webpack_require__(9536);
Object.defineProperty(exports, "IMenuItem", ({ enumerable: true, get: function () { return MenuItem_1.IMenuItem; } }));
var PartnerLogo_1 = __webpack_require__(59696);
Object.defineProperty(exports, "logos", ({ enumerable: true, get: function () { return PartnerLogo_1.logos; } }));


/***/ }),

/***/ 57938:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "Hero";
exports.elementIdentifiers = (0, shared_1.tuple)("outerContainer", "image", "title", "message", "cta", "imageWrapper", "textWrapper", "top");


/***/ }),

/***/ 99869:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(57938);
var style_scss_1 = __importDefault(__webpack_require__(41644));
var form_1 = __webpack_require__(13174);
var content_1 = __webpack_require__(49429);
var Hero = function (_a) {
    var image = _a.image, title = _a.title, message = _a.message, cta = _a.cta, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["image", "title", "message", "cta", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var prefix = props.id || constants_1.componentName;
    var Image = image;
    return (react_1.default.createElement("div", __assign({}, ovr.outerContainer, props, { className: (0, classnames_1.default)(ovr.outerContainer.className, className), role: "region", "aria-label": "".concat(prefix, "-label") }),
        react_1.default.createElement("div", __assign({}, ovr.top),
            react_1.default.createElement("div", __assign({}, ovr.textWrapper),
                react_1.default.createElement(content_1.Title, __assign({}, ovr.title, { align: "center", id: "".concat(prefix, "-title") }), title),
                message ? (react_1.default.createElement("p", __assign({}, ovr.message, { id: "".concat(prefix, "-message") }), message)) : null),
            Image ? (react_1.default.createElement("div", __assign({}, ovr.imageWrapper),
                react_1.default.createElement(Image, __assign({}, ovr.image)))) : null),
        cta && (react_1.default.createElement(form_1.Button, __assign({}, ovr.cta, { className: (0, classnames_1.default)(style_scss_1.default.cta, ovr.cta.className), size: shared_1.ButtonSize.Small, colour: shared_1.ButtonColour.Primary, onClick: cta.onClick, fixed: true, id: "".concat(shared_1.ButtonColour.Primary, "-small") }), cta.text))));
};
Hero.displayName = constants_1.componentName;
exports["default"] = Hero;


/***/ }),

/***/ 68896:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var button_1 = __importDefault(__webpack_require__(47426));
var tooltip_1 = __importStar(__webpack_require__(62636));
var style_scss_1 = __importDefault(__webpack_require__(281));
var componentName = "Hook";
var alphabetSet = ["A", "B", "C", "D", "E", "F"];
var Ball = function () {
    return react_1.default.createElement("div", { className: style_scss_1.default.ball });
};
var Hook = function (_a) {
    var hdScore = _a.hdScore, onButtonClick = _a.onButtonClick;
    var tooltipWithBall = function () {
        if (hdScore > 0 && hdScore < alphabetSet.length) {
            return (react_1.default.createElement(tooltip_1.default, { theme: tooltip_1.ToolTipTheme.V4, className: style_scss_1.default.tooltip, body: react_1.default.createElement("p", { className: style_scss_1.default.tooltipBodyText },
                    alphabetSet[hdScore - 1],
                    "\u00A0-\u00A0",
                    alphabetSet[hdScore]), isOpened: true },
                react_1.default.createElement(Ball, null)));
        }
    };
    var colourfulList = Array.from({ length: 10 }, function (_, i) { return i + 1; });
    return (react_1.default.createElement("div", { className: style_scss_1.default.hook },
        react_1.default.createElement("p", { className: style_scss_1.default.title }, "We've checked your Experian mortgage eligibility profile, you are most likely between bands:"),
        react_1.default.createElement("div", { className: style_scss_1.default.score }, colourfulList.map(function (element) { return (react_1.default.createElement("div", { key: element, className: (0, classnames_1.default)(style_scss_1.default.block, style_scss_1.default["block-".concat(element)]) }, hdScore === colourfulList.length - element && tooltipWithBall())); })),
        react_1.default.createElement("div", { className: style_scss_1.default.description },
            react_1.default.createElement("p", { className: style_scss_1.default.descriptionItem },
                react_1.default.createElement("span", null, "A"),
                "\u00A0-\u00A0Eligible with 100% of the lender market"),
            react_1.default.createElement("p", { className: style_scss_1.default.descriptionItem },
                react_1.default.createElement("span", null, "B"),
                "\u00A0-\u00A0Eligible with majority of lender market"),
            react_1.default.createElement("p", { className: style_scss_1.default.descriptionItem },
                react_1.default.createElement("span", null, "C"),
                "\u00A0-\u00A0Wide range of possibilities"),
            react_1.default.createElement("p", { className: style_scss_1.default.descriptionItem },
                react_1.default.createElement("span", null, "D"),
                "\u00A0-\u00A0Good chance with specialist lenders"),
            react_1.default.createElement("p", { className: style_scss_1.default.descriptionItem },
                react_1.default.createElement("span", null, "E"),
                "\u00A0-\u00A0Requires specialist support"),
            react_1.default.createElement("p", { className: style_scss_1.default.descriptionItem },
                react_1.default.createElement("span", null, "F"),
                "\u00A0-\u00A0May struggle to get a mortgage")),
        react_1.default.createElement(button_1.default, { size: shared_1.ButtonSize.Small, onClick: onButtonClick, fixed: false, className: style_scss_1.default.button }, "Unlock your band*"),
        react_1.default.createElement("p", { className: style_scss_1.default.disclaimer }, "*Your adviser will need to check a few details to confirm your exact eligibility")));
};
Hook.displayName = componentName;
exports["default"] = Hook;


/***/ }),

/***/ 58261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* istanbul ignore file */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MonzoCashIncentive = exports.WorkingHoursInfo = exports.BetterAndTrustpilotChecklist = exports.modalWithTimeline = exports.RateWatchCard = exports.WhatsappButton = exports.MonzoGetStarted = exports.SmartBuyerBenefits = exports.TestimonialCarousel = exports.TestimonialCard = exports.ChatHeader = exports.RemortgageTimeline = exports.InfoCard = exports.NavbarWithProgress = exports.MortgageProductDetails = exports.MortgageProductDetailsModal = exports.CardCarousel = exports.socialMedia = exports.Hook = exports.SlideoutArticles = exports.trustPilotCard = exports.AdviserAssigned = exports.AdviserPanel = exports.ViewMoreButton = exports.ContactAdviser = exports.Drawer = exports.Carousel = exports.PostSignupFooter = exports.PreSignupFooter = exports.SectionCard = exports.MipExplained = exports.RepaymentsCalculator = exports.TujButton = exports.Card = exports.ComplexButton = exports.TimelinePlainWithTitle = exports.Timeline = exports.Hero = exports.TooltipCard = exports.LowContactProductCard = exports.MortgageProductCard = exports.AccessSectionCard = exports.ApplicationCard = exports.ContactCard = void 0;
var contactCard_1 = __webpack_require__(77074);
Object.defineProperty(exports, "ContactCard", ({ enumerable: true, get: function () { return __importDefault(contactCard_1).default; } }));
__exportStar(__webpack_require__(77074), exports);
var applicationCard_1 = __webpack_require__(68421);
Object.defineProperty(exports, "ApplicationCard", ({ enumerable: true, get: function () { return __importDefault(applicationCard_1).default; } }));
__exportStar(__webpack_require__(68421), exports);
var accessSectionCard_1 = __webpack_require__(60690);
Object.defineProperty(exports, "AccessSectionCard", ({ enumerable: true, get: function () { return __importDefault(accessSectionCard_1).default; } }));
__exportStar(__webpack_require__(60690), exports);
var mortgageProductCard_1 = __webpack_require__(76286);
Object.defineProperty(exports, "MortgageProductCard", ({ enumerable: true, get: function () { return __importDefault(mortgageProductCard_1).default; } }));
__exportStar(__webpack_require__(76286), exports);
var lowContactProductCard_1 = __webpack_require__(37914);
Object.defineProperty(exports, "LowContactProductCard", ({ enumerable: true, get: function () { return __importDefault(lowContactProductCard_1).default; } }));
__exportStar(__webpack_require__(37914), exports);
var tooltipCard_1 = __webpack_require__(60533);
Object.defineProperty(exports, "TooltipCard", ({ enumerable: true, get: function () { return __importDefault(tooltipCard_1).default; } }));
__exportStar(__webpack_require__(60533), exports);
var hero_1 = __webpack_require__(99869);
Object.defineProperty(exports, "Hero", ({ enumerable: true, get: function () { return __importDefault(hero_1).default; } }));
__exportStar(__webpack_require__(99869), exports);
var timeline_1 = __webpack_require__(54790);
Object.defineProperty(exports, "Timeline", ({ enumerable: true, get: function () { return __importDefault(timeline_1).default; } }));
__exportStar(__webpack_require__(54790), exports);
var timelinePlainWithTitle_1 = __webpack_require__(57852);
Object.defineProperty(exports, "TimelinePlainWithTitle", ({ enumerable: true, get: function () { return __importDefault(timelinePlainWithTitle_1).default; } }));
__exportStar(__webpack_require__(57852), exports);
var complexButton_1 = __webpack_require__(88824);
Object.defineProperty(exports, "ComplexButton", ({ enumerable: true, get: function () { return __importDefault(complexButton_1).default; } }));
__exportStar(__webpack_require__(88824), exports);
var card_1 = __webpack_require__(82972);
Object.defineProperty(exports, "Card", ({ enumerable: true, get: function () { return __importDefault(card_1).default; } }));
__exportStar(__webpack_require__(82972), exports);
var tujButton_1 = __webpack_require__(61382);
Object.defineProperty(exports, "TujButton", ({ enumerable: true, get: function () { return __importDefault(tujButton_1).default; } }));
__exportStar(__webpack_require__(61382), exports);
var repaymentsCalculator_1 = __webpack_require__(62553);
Object.defineProperty(exports, "RepaymentsCalculator", ({ enumerable: true, get: function () { return __importDefault(repaymentsCalculator_1).default; } }));
__exportStar(__webpack_require__(62553), exports);
var mipExplained_1 = __webpack_require__(23293);
Object.defineProperty(exports, "MipExplained", ({ enumerable: true, get: function () { return __importDefault(mipExplained_1).default; } }));
__exportStar(__webpack_require__(23293), exports);
var sectionCard_1 = __webpack_require__(94925);
Object.defineProperty(exports, "SectionCard", ({ enumerable: true, get: function () { return __importDefault(sectionCard_1).default; } }));
__exportStar(__webpack_require__(94925), exports);
__exportStar(__webpack_require__(94815), exports);
var preSignupFooter_1 = __webpack_require__(94815);
Object.defineProperty(exports, "PreSignupFooter", ({ enumerable: true, get: function () { return __importDefault(preSignupFooter_1).default; } }));
__exportStar(__webpack_require__(54084), exports);
var postSignupFooter_1 = __webpack_require__(54084);
Object.defineProperty(exports, "PostSignupFooter", ({ enumerable: true, get: function () { return __importDefault(postSignupFooter_1).default; } }));
var carousel_1 = __webpack_require__(71429);
Object.defineProperty(exports, "Carousel", ({ enumerable: true, get: function () { return __importDefault(carousel_1).default; } }));
__exportStar(__webpack_require__(50668), exports);
var drawer_1 = __webpack_require__(50668);
Object.defineProperty(exports, "Drawer", ({ enumerable: true, get: function () { return __importDefault(drawer_1).default; } }));
__exportStar(__webpack_require__(22075), exports);
var contactAdviser_1 = __webpack_require__(22075);
Object.defineProperty(exports, "ContactAdviser", ({ enumerable: true, get: function () { return __importDefault(contactAdviser_1).default; } }));
__exportStar(__webpack_require__(70192), exports);
var ViewMoreButton_1 = __webpack_require__(39581);
Object.defineProperty(exports, "ViewMoreButton", ({ enumerable: true, get: function () { return __importDefault(ViewMoreButton_1).default; } }));
__exportStar(__webpack_require__(39581), exports);
__exportStar(__webpack_require__(54526), exports);
__exportStar(__webpack_require__(97127), exports);
var adviserPanel_1 = __webpack_require__(97127);
Object.defineProperty(exports, "AdviserPanel", ({ enumerable: true, get: function () { return __importDefault(adviserPanel_1).default; } }));
__exportStar(__webpack_require__(19217), exports);
var adviserAssigned_1 = __webpack_require__(19217);
Object.defineProperty(exports, "AdviserAssigned", ({ enumerable: true, get: function () { return __importDefault(adviserAssigned_1).default; } }));
var trustPilotCard_1 = __webpack_require__(26924);
Object.defineProperty(exports, "trustPilotCard", ({ enumerable: true, get: function () { return __importDefault(trustPilotCard_1).default; } }));
__exportStar(__webpack_require__(61382), exports);
var slideOutArticles_1 = __webpack_require__(30426);
Object.defineProperty(exports, "SlideoutArticles", ({ enumerable: true, get: function () { return __importDefault(slideOutArticles_1).default; } }));
var hook_1 = __webpack_require__(68896);
Object.defineProperty(exports, "Hook", ({ enumerable: true, get: function () { return __importDefault(hook_1).default; } }));
__exportStar(__webpack_require__(68896), exports);
__exportStar(__webpack_require__(234), exports);
var socialMedia_1 = __webpack_require__(234);
Object.defineProperty(exports, "socialMedia", ({ enumerable: true, get: function () { return __importDefault(socialMedia_1).default; } }));
__exportStar(__webpack_require__(25640), exports);
var cardCarousel_1 = __webpack_require__(25640);
Object.defineProperty(exports, "CardCarousel", ({ enumerable: true, get: function () { return __importDefault(cardCarousel_1).default; } }));
__exportStar(__webpack_require__(56042), exports);
var mortgageProductDetailsModal_1 = __webpack_require__(56042);
Object.defineProperty(exports, "MortgageProductDetailsModal", ({ enumerable: true, get: function () { return __importDefault(mortgageProductDetailsModal_1).default; } }));
__exportStar(__webpack_require__(54213), exports);
var mortgageProductDetails_1 = __webpack_require__(54213);
Object.defineProperty(exports, "MortgageProductDetails", ({ enumerable: true, get: function () { return __importDefault(mortgageProductDetails_1).default; } }));
__exportStar(__webpack_require__(91630), exports);
var navbarWithProgress_1 = __webpack_require__(91630);
Object.defineProperty(exports, "NavbarWithProgress", ({ enumerable: true, get: function () { return __importDefault(navbarWithProgress_1).default; } }));
__exportStar(__webpack_require__(25297), exports);
var infoCard_1 = __webpack_require__(25297);
Object.defineProperty(exports, "InfoCard", ({ enumerable: true, get: function () { return __importDefault(infoCard_1).default; } }));
__exportStar(__webpack_require__(11267), exports);
var remortgageTimeline_1 = __webpack_require__(11267);
Object.defineProperty(exports, "RemortgageTimeline", ({ enumerable: true, get: function () { return __importDefault(remortgageTimeline_1).default; } }));
__exportStar(__webpack_require__(32751), exports);
var chatHeader_1 = __webpack_require__(32751);
Object.defineProperty(exports, "ChatHeader", ({ enumerable: true, get: function () { return __importDefault(chatHeader_1).default; } }));
__exportStar(__webpack_require__(63198), exports);
var testimonialCard_1 = __webpack_require__(63198);
Object.defineProperty(exports, "TestimonialCard", ({ enumerable: true, get: function () { return __importDefault(testimonialCard_1).default; } }));
__exportStar(__webpack_require__(79540), exports);
var testimonialCarousel_1 = __webpack_require__(79540);
Object.defineProperty(exports, "TestimonialCarousel", ({ enumerable: true, get: function () { return __importDefault(testimonialCarousel_1).default; } }));
__exportStar(__webpack_require__(25936), exports);
var smartBuyerBenefits_1 = __webpack_require__(25936);
Object.defineProperty(exports, "SmartBuyerBenefits", ({ enumerable: true, get: function () { return __importDefault(smartBuyerBenefits_1).default; } }));
__exportStar(__webpack_require__(35392), exports);
var monzoGetStarted_1 = __webpack_require__(35392);
Object.defineProperty(exports, "MonzoGetStarted", ({ enumerable: true, get: function () { return __importDefault(monzoGetStarted_1).default; } }));
__exportStar(__webpack_require__(21716), exports);
var whatsappButton_1 = __webpack_require__(21716);
Object.defineProperty(exports, "WhatsappButton", ({ enumerable: true, get: function () { return __importDefault(whatsappButton_1).default; } }));
__exportStar(__webpack_require__(72054), exports);
var rateWatchCard_1 = __webpack_require__(72054);
Object.defineProperty(exports, "RateWatchCard", ({ enumerable: true, get: function () { return __importDefault(rateWatchCard_1).default; } }));
__exportStar(__webpack_require__(15257), exports);
var modalWithTimeline_1 = __webpack_require__(15257);
Object.defineProperty(exports, "modalWithTimeline", ({ enumerable: true, get: function () { return __importDefault(modalWithTimeline_1).default; } }));
__exportStar(__webpack_require__(80940), exports);
var betterAndTrustpilotChecklist_1 = __webpack_require__(80940);
Object.defineProperty(exports, "BetterAndTrustpilotChecklist", ({ enumerable: true, get: function () { return __importDefault(betterAndTrustpilotChecklist_1).default; } }));
__exportStar(__webpack_require__(32871), exports);
var workingHoursInfo_1 = __webpack_require__(32871);
Object.defineProperty(exports, "WorkingHoursInfo", ({ enumerable: true, get: function () { return __importDefault(workingHoursInfo_1).default; } }));
__exportStar(__webpack_require__(83873), exports);
var monzoCashIncentive_1 = __webpack_require__(83873);
Object.defineProperty(exports, "MonzoCashIncentive", ({ enumerable: true, get: function () { return __importDefault(monzoCashIncentive_1).default; } }));


/***/ }),

/***/ 15250:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "InfoCard";
exports.elementIdentifiers = (0, shared_1.tuple)("wrapper", "top", "info", "colouredInfo", "title", "content", "image");


/***/ }),

/***/ 25297:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(15250);
var style_scss_1 = __importDefault(__webpack_require__(33185));
var classnames_1 = __importDefault(__webpack_require__(57485));
var typography_1 = __webpack_require__(34237);
var InfoCard = function (_a) {
    var _b;
    var id = _a.id, _c = _a.colour, colour = _c === void 0 ? "grey" : _c, image = _a.image, title = _a.title, content = _a.content, info = _a.info, colouredInfo = _a.colouredInfo, classOverrides = _a.classOverrides, className = _a.className, testIds = _a.testIds, refs = _a.refs;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.wrapper, { className: (0, classnames_1.default)(ovr.wrapper.className, className, (_b = {},
            _b[style_scss_1.default.grey] = colour === "grey",
            _b[style_scss_1.default.red] = colour === "red",
            _b[style_scss_1.default.green] = colour === "green",
            _b)) }),
        react_1.default.createElement("div", __assign({}, ovr.top),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", __assign({}, ovr.info), info),
                react_1.default.createElement(typography_1.Typography, __assign({ variant: "h7", component: "span" }, ovr.colouredInfo, { classes: ovr.colouredInfo.className, id: null }), colouredInfo)),
            image && react_1.default.createElement("div", __assign({}, ovr.image), image)),
        title && (react_1.default.createElement(typography_1.Typography, __assign({ variant: "h6", component: "span" }, ovr.title, { classes: ovr.title.className, id: null }), title)),
        react_1.default.createElement("span", __assign({}, ovr.content), content)));
};
InfoCard.displayName = constants_1.componentName;
exports["default"] = InfoCard;


/***/ }),

/***/ 15764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProductTermItem = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var useWindowSize_1 = __webpack_require__(55454);
var shared_1 = __webpack_require__(89574);
var form_1 = __webpack_require__(13174);
var styles_scss_1 = __importDefault(__webpack_require__(47352));
var lodash_isboolean_1 = __importDefault(__webpack_require__(88073));
var classnames_1 = __importDefault(__webpack_require__(57485));
var statusIcon = function (status) {
    return status ? (react_1.default.createElement(shared_1.Icon, { name: shared_1.IconName.CheckNew })) : (react_1.default.createElement(shared_1.Icon, { name: shared_1.IconName.CloseNew }));
};
var ProductTermItem = function (_a) {
    var label = _a.label, value = _a.value, showTooltip = _a.showTooltip, tooltipText = _a.tooltipText, extraClassName = _a.extraClassName;
    var width = (0, useWindowSize_1.useWindowSize)().width;
    return (react_1.default.createElement("div", { className: styles_scss_1.default.productTermsItem },
        react_1.default.createElement("p", { className: styles_scss_1.default.productTermsItemTitle }, label),
        showTooltip && (react_1.default.createElement("div", { className: styles_scss_1.default.tooltipWrapper },
            react_1.default.createElement(form_1.Tooltip, { theme: form_1.ToolTipTheme.V4, size: form_1.ToolTipSize.Small, position: width && width < 528 ? "bottom" : "right", className: (0, classnames_1.default)(styles_scss_1.default.tooltipIcon, extraClassName), body: react_1.default.createElement("p", { className: styles_scss_1.default.tooltipText }, tooltipText) },
                react_1.default.createElement(shared_1.Icon, { name: shared_1.IconName.InfoGreyIcon })))),
        react_1.default.createElement("p", { className: styles_scss_1.default.productTermsItemValue }, (0, lodash_isboolean_1.default)(value) ? statusIcon(value) : value)));
};
exports.ProductTermItem = ProductTermItem;


/***/ }),

/***/ 37914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var chevron_down_react_svg_1 = __importDefault(__webpack_require__(42582));
var styles_scss_1 = __importDefault(__webpack_require__(47352));
var Spinner_1 = __importDefault(__webpack_require__(88774));
var getImage_1 = __importDefault(__webpack_require__(1308));
var ViewMoreButton_1 = __importDefault(__webpack_require__(39581));
var form_1 = __webpack_require__(13174);
var auxiliary_1 = __webpack_require__(15764);
var info_exclusive_react_svg_1 = __importDefault(__webpack_require__(89732));
var componentName = "LowContactProductCard";
var elementIdentifiers = (0, shared_1.tuple)("dot", "actions", "description", "initialData", "initialDataText", "productTerms", "viewMoreButton", "lenderLogoWrapper", "lowContactProductCardWrapper", "lowContactProductCardWrapperV2", "exclusive", "productName", "initialTermCostTooltip");
var LowContactProductCard = function (_a) {
    var _b, _c;
    var cost = _a.cost, aprc = _a.aprc, cashback = _a.cashback, isLoading = _a.isLoading, lenderName = _a.lenderName, lenderLogo = _a.lenderLogo, initialRate = _a.initialRate, yearTracker = _a.yearTracker, upfrontFees = _a.upfrontFees, freeLegalFees = _a.freeLegalFees, initialMonthlyPayment = _a.initialMonthlyPayment, mortgageClass = _a.mortgageClass, productName = _a.productName, onClick = _a.onClick, _d = _a.variant, variant = _d === void 0 ? "default" : _d, onViewDetailsClick = _a.onViewDetailsClick, exclusive = _a.exclusive, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["cost", "aprc", "cashback", "isLoading", "lenderName", "lenderLogo", "initialRate", "yearTracker", "upfrontFees", "freeLegalFees", "initialMonthlyPayment", "mortgageClass", "productName", "onClick", "variant", "onViewDetailsClick", "exclusive", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    var _e = (0, react_1.useState)(variant === "v2"), isContentOpen = _e[0], setIsContentOpen = _e[1];
    var onSubmitData = function () {
        onClick();
    };
    var onShowDetails = function () {
        onViewDetailsClick === null || onViewDetailsClick === void 0 ? void 0 : onViewDetailsClick();
    };
    return (react_1.default.createElement("div", __assign({}, props, ovr.lowContactProductCardWrapper, { className: (0, classnames_1.default)(ovr.lowContactProductCardWrapper.className, className, (_b = {},
            _b[ovr.lowContactProductCardWrapperV2.className] = variant === "v2",
            _b)) }),
        react_1.default.createElement("div", __assign({}, ovr.initialData),
            variant === "default" ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null,
                    initialRate.toFixed(2),
                    " %"),
                react_1.default.createElement("p", __assign({}, ovr.dot)),
                react_1.default.createElement("p", null,
                    yearTracker,
                    " ",
                    yearTracker > 1 ? "Years" : "Year",
                    " ",
                    mortgageClass),
                react_1.default.createElement("div", __assign({}, ovr.lenderLogoWrapper),
                    react_1.default.createElement("span", null, "by"),
                    (0, getImage_1.default)(lenderLogo) || react_1.default.createElement("p", null, lenderName)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", __assign({}, ovr.lenderLogoWrapper), (0, getImage_1.default)(lenderLogo) || react_1.default.createElement("p", null, lenderName)),
                react_1.default.createElement("div", __assign({}, ovr.initialDataText),
                    react_1.default.createElement("p", null,
                        initialRate.toFixed(2),
                        " %"),
                    react_1.default.createElement("p", __assign({}, ovr.dot)),
                    react_1.default.createElement("p", null,
                        mortgageClass,
                        " ",
                        react_1.default.createElement("span", null, "for"),
                        " ",
                        yearTracker,
                        " ",
                        yearTracker > 1 ? "Years" : "Year")))),
            exclusive && (react_1.default.createElement("span", __assign({}, ovr.exclusive),
                exclusive,
                react_1.default.createElement(info_exclusive_react_svg_1.default, null)))),
        react_1.default.createElement("p", __assign({}, ovr.productName), productName),
        react_1.default.createElement("div", __assign({}, ovr.productTerms, { className: (0, classnames_1.default)(ovr.productTerms.className, (_c = {},
                _c[styles_scss_1.default.productTermsWithDescription] = isContentOpen,
                _c)) }),
            react_1.default.createElement(auxiliary_1.ProductTermItem, { label: "Init. Monthly Payments", value: "\u00A3".concat(initialMonthlyPayment.toFixed(2)) }),
            react_1.default.createElement(auxiliary_1.ProductTermItem, { label: "Initial term cost", value: "\u00A3".concat(cost.toFixed(2)), showTooltip: true, extraClassName: ovr.initialTermCostTooltip.className, tooltipText: "This is the total amount you'll pay, including interest, over the introductory period." }),
            react_1.default.createElement(auxiliary_1.ProductTermItem, { label: "Upfront Fees", value: "\u00A3".concat(upfrontFees.toFixed(2)) }),
            react_1.default.createElement(auxiliary_1.ProductTermItem, { showTooltip: true, label: "APRC", value: "".concat(aprc.toFixed(2), "%"), tooltipText: "Annual Percentage Rate of Charge(APRC) is the total yearly cost of a\n            mortgage as a percentage. It's calculated with the mortgage interest\n            rate and the mortgage term, plus any fees." }),
            react_1.default.createElement(auxiliary_1.ProductTermItem, { label: "Free legal Fees", value: freeLegalFees }),
            react_1.default.createElement(auxiliary_1.ProductTermItem, { label: "Cashback", value: cashback })),
        react_1.default.createElement("div", __assign({}, ovr.actions),
            variant === "default" ? (react_1.default.createElement(ViewMoreButton_1.default, { showLabel: "Show more", hideLabel: "Show less", showIcon: react_1.default.createElement(chevron_down_react_svg_1.default, null), hideIcon: react_1.default.createElement(chevron_down_react_svg_1.default, null), onClick: function () { return setIsContentOpen(!isContentOpen); }, classOverrides: {
                    button: styles_scss_1.default.viewMoreButton
                } })) : (react_1.default.createElement(form_1.Button, { colour: shared_1.ButtonColour.TertiaryLight, onClick: onShowDetails, disabled: isLoading, className: styles_scss_1.default.disabledButton }, isLoading ? (react_1.default.createElement(Spinner_1.default, { key: "spinner-".concat(isLoading), size: 15, fill: "transparent", id: styles_scss_1.default.spinnerTransparent })) : ("View details"))),
            react_1.default.createElement(form_1.Button, { colour: variant === "default"
                    ? shared_1.ButtonColour.DarkGreen
                    : shared_1.ButtonColour.Primary, disabled: isLoading, onClick: onSubmitData, className: styles_scss_1.default.disabledButton }, isLoading ? (react_1.default.createElement(Spinner_1.default, { key: "spinner-".concat(isLoading), size: 15, fill: "transparent", id: styles_scss_1.default.spinnerGrey })) : ("Reserve for me")))));
};
LowContactProductCard.displayName = componentName;
exports["default"] = LowContactProductCard;


/***/ }),

/***/ 63318:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "MipExplained";
exports.elementIdentifiers = (0, shared_1.tuple)("mipExplained", "title", "top", "subtitle", "description", "topCard", "card", "link", "bottom", "logos", "logo");


/***/ }),

/***/ 23293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(53942));
var constants_1 = __webpack_require__(63318);
var card_1 = __importDefault(__webpack_require__(82972));
var halifax_react_svg_1 = __importDefault(__webpack_require__(9396));
var coventry_react_svg_1 = __importDefault(__webpack_require__(50730));
var leeds_building_society_react_svg_1 = __importDefault(__webpack_require__(17434));
var hsbc_react_svg_1 = __importDefault(__webpack_require__(6682));
var precise_mortgages_react_svg_1 = __importDefault(__webpack_require__(3038));
var tsb_react_svg_1 = __importDefault(__webpack_require__(44924));
var together_react_svg_1 = __importDefault(__webpack_require__(67414));
var santander_react_svg_1 = __importDefault(__webpack_require__(71718));
var accord_mortgages_react_svg_1 = __importDefault(__webpack_require__(61478));
var aldermore_react_svg_1 = __importDefault(__webpack_require__(82698));
var MipExplained = function (_a) {
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, hrefExplanation = _a.hrefExplanation, logos = _a.logos, onClickHref = _a.onClickHref, props = __rest(_a, ["className", "classOverrides", "testIds", "refs", "hrefExplanation", "logos", "onClickHref"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var logosList = logos || [
        react_1.default.createElement(halifax_react_svg_1.default, null),
        react_1.default.createElement(coventry_react_svg_1.default, null),
        react_1.default.createElement(leeds_building_society_react_svg_1.default, null),
        react_1.default.createElement(hsbc_react_svg_1.default, null),
        react_1.default.createElement(precise_mortgages_react_svg_1.default, null),
        react_1.default.createElement(tsb_react_svg_1.default, null),
        react_1.default.createElement(together_react_svg_1.default, null),
        react_1.default.createElement(santander_react_svg_1.default, null),
        react_1.default.createElement(accord_mortgages_react_svg_1.default, null),
        react_1.default.createElement(aldermore_react_svg_1.default, null)
    ];
    return (react_1.default.createElement("div", __assign({}, ovr.mipExplained, { className: (0, classnames_1.default)(ovr.mipExplained.className, className), role: "region", "aria-label": "Your Mortgage in Principle explained" }),
        react_1.default.createElement("h2", __assign({}, ovr.title), "Your Mortgage in Principle explained"),
        react_1.default.createElement(card_1.default, { classOverrides: {
                cardContainer: ovr.card.className,
                card: ovr.card.className,
                text: ovr.card.className
            } },
            react_1.default.createElement("div", __assign({}, ovr.top),
                react_1.default.createElement("div", __assign({}, ovr.topCard),
                    react_1.default.createElement("h3", __assign({}, ovr.subtitle), "Powered by Experian"),
                    react_1.default.createElement("p", __assign({}, ovr.description), "Our MIP gives you an accurate maximum mortgage amount, based on your income, credit history and the criteria from 18 major mortgage lenders.")),
                react_1.default.createElement("div", __assign({}, ovr.topCard),
                    react_1.default.createElement("h3", __assign({}, ovr.subtitle), "Personalised"),
                    react_1.default.createElement("p", __assign({}, ovr.description), "Your dedicated mortgage expert will talk you through your chances of being approved for a mortgage, so you can househunt with more certainty."))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", __assign({}, ovr.logos), logosList.map(function (logo, index) { return (react_1.default.createElement("div", __assign({}, ovr.logo, { key: index }), logo)); })),
                react_1.default.createElement("p", __assign({}, ovr.bottom),
                    "These are some of the lenders we checked your details against.",
                    " ",
                    react_1.default.createElement("a", __assign({ href: hrefExplanation }, ovr.link, { onClick: onClickHref }), "Learn more about these calculations"))))));
};
MipExplained.displayName = constants_1.componentName;
exports["default"] = MipExplained;


/***/ }),

/***/ 15257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var styles_scss_1 = __importDefault(__webpack_require__(77186));
var timelineDesktop_1 = __webpack_require__(57015);
var innerContentContainer_1 = __webpack_require__(5410);
var modal_1 = __webpack_require__(12704);
var typography_1 = __webpack_require__(34237);
var form_1 = __webpack_require__(13174);
var hooks_1 = __webpack_require__(92457);
var timelineMobile_1 = __webpack_require__(76461);
var tokens_breakpoints_1 = __webpack_require__(26963);
var componentName = "ModalWithTimeline";
var elementIdentifiers = (0, shared_1.tuple)("content", "ctaButton");
var defaultSteps = [
    "Select a deal that works for you",
    "A qualified adviser will check the market and review your choice",
    "If we can find a better deal, we’ll be in touch",
    "We’ll handle the mortgage submission for you! Fee-free"
];
var ModalWithTimeline = function (_a) {
    var isOpen = _a.isOpen, onCtaClick = _a.onCtaClick, onClose = _a.onClose, _b = _a.title, title = _b === void 0 ? "Browse all* remortgage deals currently on the market" : _b, _c = _a.steps, steps = _c === void 0 ? defaultSteps : _c, _d = _a.disclosureText, disclosureText = _d === void 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        "*We do not show deals from Lloyds, First Direct, and Yorkshire Building Society, as they do not work with ",
        react_1.default.createElement("u", null, "any"),
        " brokers.")) : _d, _e = _a.ctaText, ctaText = _e === void 0 ? "Browse all deals" : _e, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["isOpen", "onCtaClick", "onClose", "title", "steps", "disclosureText", "ctaText", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    var width = (0, hooks_1.useWindowSize)().width;
    var isMobile = Boolean(width && width <= tokens_breakpoints_1.MQ_WIDE);
    var listItems = [
        "Once you lock in a rate, we automatically monitor the market for changes",
        "If rates drop, we’ll offer to switch you 📉"
    ];
    return (react_1.default.createElement(modal_1.Modal, { isOpen: isOpen, onClose: onClose },
        react_1.default.createElement("div", __assign({}, ovr.content),
            react_1.default.createElement(typography_1.Typography, { variant: "h3" }, title),
            isMobile ? (react_1.default.createElement(timelineMobile_1.TimelineMobile, { steps: steps })) : (react_1.default.createElement(timelineDesktop_1.TimelineDesktop, { steps: steps })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(innerContentContainer_1.InnerContentContainer, { listItems: listItems }),
                react_1.default.createElement("br", null),
                react_1.default.createElement(typography_1.Typography, { variant: "body2" }, disclosureText)),
            react_1.default.createElement(form_1.Button, __assign({ size: shared_1.ButtonSize.Large, style: { maxWidth: 300, marginLeft: "auto" }, onClick: onCtaClick }, ovr.ctaButton), ctaText))));
};
ModalWithTimeline.displayName = componentName;
exports["default"] = ModalWithTimeline;


/***/ }),

/***/ 5410:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InnerContentContainer = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var styles_scss_1 = __importDefault(__webpack_require__(81160));
var trustpilot_react_svg_1 = __importDefault(__webpack_require__(83856));
var InnerContentContainer = function (_a) {
    var listItems = _a.listItems;
    return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement("b", null, "Protected by RateWatch \uD83D\uDD12"),
            react_1.default.createElement("ol", null, listItems.map(function (item, index) { return (react_1.default.createElement("li", { key: index }, item)); }))),
        react_1.default.createElement("span", { className: styles_scss_1.default.trustpilotContainer },
            react_1.default.createElement(trustpilot_react_svg_1.default, null))));
};
exports.InnerContentContainer = InnerContentContainer;


/***/ }),

/***/ 12704:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* eslint-disable */
// eslint complains about the use of handlers on the divs, but the solution
// (marking it as a button) is not a good one, as it would make the divs
// focusable, which is not the desired behavior. This interactivity is needed for good UX
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Modal = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var react_dom_1 = __importDefault(__webpack_require__(27137));
var styles_scss_1 = __importDefault(__webpack_require__(1961));
var theme_1 = __webpack_require__(79090);
var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children;
    if (!isOpen)
        return null;
    var firstElementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (isOpen && firstElementRef.current) {
            firstElementRef.current.focus();
        }
    }, [isOpen]);
    var handleKeyDown = function (e) {
        if (e.key === "Escape") {
            onClose();
        }
    };
    return react_dom_1.default.createPortal(react_1.default.createElement(theme_1.ThemeWrapper, null,
        react_1.default.createElement("div", { className: styles_scss_1.default.modalOverlay, onClick: onClose, onKeyDown: handleKeyDown, tabIndex: 0 },
            react_1.default.createElement("div", { ref: firstElementRef, className: styles_scss_1.default.modalContent, onClick: function (e) { return e.stopPropagation(); } },
                react_1.default.createElement("button", { className: styles_scss_1.default.modalClose, onClick: onClose }, "X"),
                children))), document.body);
};
exports.Modal = Modal;


/***/ }),

/***/ 57015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimelineDesktop = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var styles_scss_1 = __importDefault(__webpack_require__(50544));
var icon_keyboard_tap_react_svg_1 = __importDefault(__webpack_require__(30214));
var icon_analysis_react_svg_1 = __importDefault(__webpack_require__(46472));
var icon_contact_react_svg_1 = __importDefault(__webpack_require__(61527));
var icon_percentage_react_svg_1 = __importDefault(__webpack_require__(8855));
var stepIcons = [
    react_1.default.createElement(icon_keyboard_tap_react_svg_1.default, null),
    react_1.default.createElement(icon_analysis_react_svg_1.default, null),
    react_1.default.createElement(icon_contact_react_svg_1.default, null),
    react_1.default.createElement(icon_percentage_react_svg_1.default, null)
];
var TimelineDesktop = function (_a) {
    var steps = _a.steps;
    return (react_1.default.createElement("div", { className: styles_scss_1.default.timelineContainer },
        react_1.default.createElement("div", { className: styles_scss_1.default.timeline }, steps.map(function (_, index) { return (react_1.default.createElement("div", { key: index, className: styles_scss_1.default.stepOuterContainer },
            react_1.default.createElement("span", { className: styles_scss_1.default.stepInnerContainer },
                react_1.default.createElement("div", { className: styles_scss_1.default.circle }, index + 1),
                react_1.default.createElement("div", { className: styles_scss_1.default.line })))); })),
        react_1.default.createElement("div", { className: styles_scss_1.default.timeline }, steps.map(function (step, index) { return (react_1.default.createElement("span", { className: styles_scss_1.default.stepDescription, key: index },
            react_1.default.createElement("span", { className: styles_scss_1.default.stepIcon }, stepIcons[index % stepIcons.length]),
            step)); }))));
};
exports.TimelineDesktop = TimelineDesktop;


/***/ }),

/***/ 76461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimelineMobile = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var styles_scss_1 = __importDefault(__webpack_require__(35942));
var icon_keyboard_tap_react_svg_1 = __importDefault(__webpack_require__(30214));
var icon_analysis_react_svg_1 = __importDefault(__webpack_require__(46472));
var icon_contact_react_svg_1 = __importDefault(__webpack_require__(61527));
var icon_percentage_react_svg_1 = __importDefault(__webpack_require__(8855));
var stepIcons = [
    react_1.default.createElement(icon_keyboard_tap_react_svg_1.default, null),
    react_1.default.createElement(icon_analysis_react_svg_1.default, null),
    react_1.default.createElement(icon_contact_react_svg_1.default, null),
    react_1.default.createElement(icon_percentage_react_svg_1.default, null)
];
var TimelineMobile = function (_a) {
    var steps = _a.steps;
    return (react_1.default.createElement("div", { className: styles_scss_1.default.timeline }, steps.map(function (step, index) { return (react_1.default.createElement("div", { className: styles_scss_1.default.stepContainer, key: index },
        react_1.default.createElement("span", { className: styles_scss_1.default.stepNumberContainer },
            react_1.default.createElement("p", { className: styles_scss_1.default.stepIconNumber }, "0".concat(index + 1)),
            stepIcons[index % stepIcons.length]),
        react_1.default.createElement("div", null, step))); })));
};
exports.TimelineMobile = TimelineMobile;


/***/ }),

/***/ 83873:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var monzoKey_png_1 = __importDefault(__webpack_require__(64600));
var monzoLogo_png_1 = __importDefault(__webpack_require__(79939));
var style_scss_1 = __importDefault(__webpack_require__(45945));
var content_1 = __webpack_require__(49429);
var typography_1 = __webpack_require__(34237);
var componentName = "MonzoCashIncentive";
var elementIdentifiers = (0, shared_1.tuple)("card", "title", "subtitle", "linkText", "background", "content", "customerExclusiveBanner", "customerExclusiveText", "monzoLogo");
var MonzoCashIncentive = function (_a) {
    var _b = _a.title, title = _b === void 0 ? "Earn £100 if you complete with us" : _b, _c = _a.subtitle, subtitle = _c === void 0 ? "Once your new mortgage deal is locked in, you’ll get £100 to celebrate the smart move." : _c, _d = _a.linkText, linkText = _d === void 0 ? "See if you’re eligible." : _d, _e = _a.linkURL, linkURL = _e === void 0 ? "https://better.co.uk/monzo-exclusive-terms-and-conditions" : _e, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["title", "subtitle", "linkText", "linkURL", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.card),
        react_1.default.createElement("img", __assign({}, ovr.background, { src: monzoKey_png_1.default, alt: "Monzo" })),
        react_1.default.createElement("div", __assign({}, ovr.content),
            react_1.default.createElement(typography_1.Typography, { variant: "h2", classes: ovr.title.className }, title),
            react_1.default.createElement(typography_1.Typography, { variant: "body1", classes: ovr.subtitle.className }, subtitle),
            react_1.default.createElement(content_1.TextLink, { target: "_blank", className: ovr.linkText.className, href: linkURL, underlined: true, theme: content_1.TextLinkTheme.LIGHT }, linkText),
            react_1.default.createElement("div", __assign({}, ovr.customerExclusiveBanner),
                react_1.default.createElement("img", __assign({}, ovr.monzoLogo, { src: monzoLogo_png_1.default, alt: "Monzo" })),
                react_1.default.createElement(typography_1.Typography, { variant: "body1", classes: ovr.customerExclusiveText.className }, "Monzo Customer exclusive")))));
};
exports["default"] = MonzoCashIncentive;


/***/ }),

/***/ 87279:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultInformationBlocks = exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "MonzoGetStarted";
exports.elementIdentifiers = (0, shared_1.tuple)("startButton", "header", "images", "preCtaContent", "link", "serviceOffering", "figure", "informationBlock", "informationTitle", "title", "subtitle", "line", "offeringLogos", "figureDescription", "list", "informationDescription", "buttonsContainer", "buttonsDivider");
exports.defaultInformationBlocks = [
    {
        title: "Add some extra details",
        description: "Finish telling us about you and we'll match you with an expert to help you find the right deal for you"
    },
    {
        title: "RateWatch",
        description: "Reserve a rate up to 6 months before your current deal ends. If a more suitable deal becomes available to you, our RateWatch service will offer to swap you onto it."
    },
    {
        title: "Switch",
        description: "When the time is right, we'll switch you over to your new rate."
    }
];


/***/ }),

/***/ 35392:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var monzo_react_svg_1 = __importDefault(__webpack_require__(34261));
var logo_better_2024_no_size_react_svg_1 = __importDefault(__webpack_require__(70868));
var shared_1 = __webpack_require__(89574);
var form_1 = __webpack_require__(13174);
var TrustpilotScore_1 = __webpack_require__(75975);
var typography_1 = __webpack_require__(34237);
var content_1 = __webpack_require__(49429);
var style_scss_1 = __importDefault(__webpack_require__(8038));
var constants_1 = __webpack_require__(87279);
var MonzoGetStarted = function (_a) {
    var onClick = _a.onClick, onSecondCtaClick = _a.onSecondCtaClick, _b = _a.informationBlocks, informationBlocks = _b === void 0 ? constants_1.defaultInformationBlocks : _b, _c = _a.title, title = _c === void 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        "Welcome, ",
        react_1.default.createElement("br", null),
        " we're Better.co.uk \uD83D\uDC4B")) : _c, _d = _a.subtitle, subtitle = _d === void 0 ? "We've got your info from Monzo and we're almost ready to get going on finding your new deal." : _d, _e = _a.preCtaContent, preCtaContent = _e === void 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        "By clicking 'Get started', you confirm you have read and accepted our",
        " ",
        react_1.default.createElement(content_1.TextLink, { href: "https://better.co.uk/privacy", underlined: true, theme: content_1.TextLinkTheme.DARK }, "Privacy Policy"),
        " ",
        "and",
        " ",
        react_1.default.createElement(content_1.TextLink, { href: "https://better.co.uk/terms", underlined: true, theme: content_1.TextLinkTheme.DARK }, "Terms of Business"),
        ".")) : _e, _f = _a.ctaText, ctaText = _f === void 0 ? "Get started" : _f, secondCtaText = _a.secondCtaText, _g = _a.hideCheckList, hideCheckList = _g === void 0 ? false : _g, _h = _a.ctaDisabled, ctaDisabled = _h === void 0 ? false : _h, _j = _a.secondCtaTextDisabled, secondCtaTextDisabled = _j === void 0 ? false : _j, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["onClick", "onSecondCtaClick", "informationBlocks", "title", "subtitle", "preCtaContent", "ctaText", "secondCtaText", "hideCheckList", "ctaDisabled", "secondCtaTextDisabled", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, props, { className: className }),
        react_1.default.createElement("div", __assign({}, ovr.header),
            react_1.default.createElement(typography_1.Typography, __assign({ variant: "h1" }, ovr.title, { classes: ovr.title.className }), title),
            react_1.default.createElement("div", __assign({}, ovr.subtitle), subtitle)),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", __assign({}, ovr.images),
                react_1.default.createElement(monzo_react_svg_1.default, null)),
            !hideCheckList && (react_1.default.createElement("div", __assign({}, ovr.serviceOffering),
                react_1.default.createElement("div", __assign({}, ovr.offeringLogos),
                    react_1.default.createElement("figure", __assign({}, ovr.figure),
                        react_1.default.createElement(logo_better_2024_no_size_react_svg_1.default, null),
                        react_1.default.createElement("figcaption", __assign({}, ovr.figureDescription),
                            "Your ",
                            react_1.default.createElement("strong", null, "free online"),
                            " Mortgage\u00A0Broker")),
                    react_1.default.createElement(TrustpilotScore_1.TrustpilotScore, { shouldWapDirection: false })),
                react_1.default.createElement("ol", __assign({}, ovr.list), informationBlocks.map(function (_a, index) {
                    var title = _a.title, description = _a.description;
                    return (react_1.default.createElement("li", __assign({}, ovr.informationBlock, { key: index }),
                        react_1.default.createElement(typography_1.Typography, __assign({ variant: "h4", component: "p" }, ovr.informationTitle, { classes: ovr.informationTitle.className, id: "informationBlock-title-".concat(index) }), title),
                        react_1.default.createElement(typography_1.Typography, __assign({ variant: "body2", component: "p" }, ovr.informationDescription, { classes: ovr.informationDescription.className, id: "informationBlock-description-".concat(index) }), description)));
                })))),
            react_1.default.createElement("div", __assign({}, ovr.preCtaContent), preCtaContent),
            react_1.default.createElement("div", __assign({}, ovr.buttonsContainer),
                react_1.default.createElement(form_1.Button, __assign({}, ovr.startButton, { onClick: onClick, fixed: false, size: shared_1.ButtonSize.Large, disabled: ctaDisabled }), ctaText),
                secondCtaText && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", __assign({}, ovr.buttonsDivider), "or"),
                    react_1.default.createElement(form_1.Button, __assign({}, ovr.startButton, { onClick: onSecondCtaClick, fixed: false, size: shared_1.ButtonSize.Large, disabled: secondCtaTextDisabled }), secondCtaText)))))));
};
exports["default"] = MonzoGetStarted;


/***/ }),

/***/ 84334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FooterContainer = exports.DetailsPair = exports.DetailsList = exports.DetailsTitle = exports.DetailsContainer = exports.CtaButton = exports.DetailsButton = exports.ActionsContainer = exports.Separator = exports.TermsExplainedButton = exports.GlossaryContainer = exports.CalculationsLine = exports.CalculationsContainer = exports.TextPair = exports.TextPairAlignment = exports.MainInfoLine = exports.MainInfoContainer = exports.ProductInitialDuration = exports.LogoImageContainer = exports.LogoContainer = exports.Card = exports.CardPreambleText = exports.ProductTypePill = exports.CardPreamble = exports.CardWrapper = exports.elementIdentifiers = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(64545));
var pill_1 = __importStar(__webpack_require__(74747));
var button_1 = __importDefault(__webpack_require__(47426));
var index_1 = __webpack_require__(69332);
var questionButton_1 = __importDefault(__webpack_require__(81347));
var expandButton_1 = __importDefault(__webpack_require__(94540));
exports.elementIdentifiers = (0, shared_1.tuple)("className", "mortgageProductCard");
var CardWrapper = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, isPrimary = _a.isPrimary, props = __rest(_a, ["className", "children", "isPrimary"]);
    return (react_1.default.createElement("div", __assign({}, props, { className: (0, classnames_1.default)(style_scss_1.default.cardWrapper, (_b = {},
            _b[style_scss_1.default.cardWrapperPrimary] = isPrimary === true,
            _b[style_scss_1.default.cardWrapperSecondary] = isPrimary === false,
            _b), className) }), children));
};
exports.CardWrapper = CardWrapper;
var CardPreamble = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement("div", __assign({}, props, { className: style_scss_1.default.cardPreamble }), children));
};
exports.CardPreamble = CardPreamble;
var ProductTypePill = function (_a) {
    var children = _a.children, isPrimary = _a.isPrimary;
    return (react_1.default.createElement(pill_1.default, { colour: isPrimary ? pill_1.PillColours.Primary : pill_1.PillColours.Secondary, inline: false, classOverrides: {
            pill: style_scss_1.default.pill
        } }, children));
};
exports.ProductTypePill = ProductTypePill;
var CardPreambleText = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: style_scss_1.default.cardPreambleText }, children));
};
exports.CardPreambleText = CardPreambleText;
var Card = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.card) }, children));
};
exports.Card = Card;
var LogoContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.logoContainer, style_scss_1.default.paddingHorizontal, style_scss_1.default.flexContainer) }, children));
};
exports.LogoContainer = LogoContainer;
var LogoImageContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.logoImageContainer, style_scss_1.default.flexItem) }, children));
};
exports.LogoImageContainer = LogoImageContainer;
var ProductInitialDuration = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.productInitialDuration, style_scss_1.default.flexItem) }, children));
};
exports.ProductInitialDuration = ProductInitialDuration;
var MainInfoContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.mainInfoContainer, style_scss_1.default.paddingHorizontal) }, children));
};
exports.MainInfoContainer = MainInfoContainer;
var MainInfoLine = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.flexContainer, style_scss_1.default.mainInfoLine) }, children));
};
exports.MainInfoLine = MainInfoLine;
var TextPairAlignment;
(function (TextPairAlignment) {
    TextPairAlignment[TextPairAlignment["LEFT"] = 0] = "LEFT";
    TextPairAlignment[TextPairAlignment["RIGHT"] = 1] = "RIGHT";
    TextPairAlignment[TextPairAlignment["CENTER"] = 2] = "CENTER";
})(TextPairAlignment = exports.TextPairAlignment || (exports.TextPairAlignment = {}));
var TextPairLabel = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: style_scss_1.default.textPairLabel }, children));
};
var TextPairValue = function (_a) {
    var children = _a.children, textPrefix = _a.textPrefix;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.textPairValue) },
        !textPrefix ? null : (react_1.default.createElement("span", { className: style_scss_1.default.textPairValuePrefix }, textPrefix)),
        react_1.default.createElement("span", { className: style_scss_1.default.textPairValue }, children)));
};
var TextPair = function (_a) {
    var _b;
    var label = _a.label, value = _a.value, _c = _a.textAlignment, textAlignment = _c === void 0 ? TextPairAlignment.LEFT : _c, textPrefix = _a.textPrefix;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.flexItem, (_b = {},
            _b[style_scss_1.default.textAlignLeft] = textAlignment === TextPairAlignment.LEFT,
            _b[style_scss_1.default.textAlignRight] = textAlignment === TextPairAlignment.RIGHT,
            _b[style_scss_1.default.textAlignCenter] = textAlignment === TextPairAlignment.CENTER,
            _b)) },
        react_1.default.createElement(TextPairLabel, null, label),
        react_1.default.createElement(TextPairValue, { textPrefix: textPrefix }, value)));
};
exports.TextPair = TextPair;
var CalculationsContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.calculationsContainer, style_scss_1.default.paddingHorizontal) }, children));
};
exports.CalculationsContainer = CalculationsContainer;
var CalculationsLine = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.calculationsLine) }, children));
};
exports.CalculationsLine = CalculationsLine;
var GlossaryContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.glossaryContainer, style_scss_1.default.paddingHorizontal) }, children));
};
exports.GlossaryContainer = GlossaryContainer;
var TermsExplainedButton = function (_a) {
    var props = __rest(_a, []);
    return (react_1.default.createElement(questionButton_1.default, __assign({}, props, { className: style_scss_1.default.termsExplainedButton }), "Terms explained"));
};
exports.TermsExplainedButton = TermsExplainedButton;
var Separator = function () { return react_1.default.createElement("hr", { className: style_scss_1.default.separator }); };
exports.Separator = Separator;
var ActionsContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.actionsContainer, style_scss_1.default.paddingHorizontal, style_scss_1.default.flexContainer) }, children));
};
exports.ActionsContainer = ActionsContainer;
var DetailsButton = function (_a) {
    var props = __rest(_a, []);
    return (react_1.default.createElement(expandButton_1.default, __assign({}, props, { className: style_scss_1.default.flexItem }), "Details"));
};
exports.DetailsButton = DetailsButton;
var CtaButton = function (_a) {
    var isPrimary = _a.isPrimary, props = __rest(_a, ["isPrimary"]);
    return (react_1.default.createElement(button_1.default, __assign({}, props, { colour: isPrimary ? index_1.ButtonColour.Success : index_1.ButtonColour.Secondary, fixed: false, size: index_1.ButtonSize.Small, className: style_scss_1.default.flexItem }), isPrimary ? "Accept" : "Ask about this"));
};
exports.CtaButton = CtaButton;
var DetailsContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.detailsContainer, style_scss_1.default.paddingHorizontal) }, children));
};
exports.DetailsContainer = DetailsContainer;
var DetailsTitle = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: style_scss_1.default.detailsTitle }, children));
};
exports.DetailsTitle = DetailsTitle;
var DetailsList = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("dl", { className: style_scss_1.default.detailsList }, children));
};
exports.DetailsList = DetailsList;
var DetailsPair = function (_a) {
    var _b;
    var label = _a.label, value = _a.value, isBold = _a.isBold;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("dt", { className: style_scss_1.default.detailsPairLabel }, label),
        react_1.default.createElement("dd", { className: (0, classnames_1.default)(style_scss_1.default.detailsPairValue, (_b = {}, _b[style_scss_1.default.detailsPairValueBold] = isBold, _b)) }, value)));
};
exports.DetailsPair = DetailsPair;
var FooterContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.footerContainer, style_scss_1.default.paddingHorizontal) }, children));
};
exports.FooterContainer = FooterContainer;


/***/ }),

/***/ 76286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MortgageProductCardBlank = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var tray_react_svg_1 = __importDefault(__webpack_require__(56110));
var auxiliary_1 = __webpack_require__(84334);
var form_1 = __webpack_require__(13174);
var content_1 = __webpack_require__(49429);
var radio_react_svg_1 = __importDefault(__webpack_require__(33407));
var isImageComponent_1 = __importDefault(__webpack_require__(39294));
var style_scss_1 = __importDefault(__webpack_require__(64545));
var getImage_1 = __importDefault(__webpack_require__(1308));
var componentName = "MortgageProductCard";
var elementIdentifiers = (0, shared_1.tuple)("mortgageProductCard", "badge", "radio", "termsExplainedButton", "detailsButton", "ctaButton", "cardPreamble");
var DESCRIPTION_MAX_CHARS_TO_SHOW = 92;
var MortgageProductCard = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var id = _a.id, hidePreamble = _a.hidePreamble, isPrimary = _a.isPrimary, isAccepted = _a.isAccepted, _k = _a.isExpanded, isExpanded = _k === void 0 ? false : _k, onTermsExplainedButtonClick = _a.onTermsExplainedButtonClick, onDetailsButtonClick = _a.onDetailsButtonClick, onCtaButtonClick = _a.onCtaButtonClick, data = _a.data, _l = _a.disabled, disabled = _l === void 0 ? false : _l, _m = _a.v2, v2 = _m === void 0 ? false : _m, adviserFirstName = _a.adviserFirstName, adviserProfilePhoto = _a.adviserProfilePhoto, _o = _a.isInformative, isInformative = _o === void 0 ? false : _o, testIds = _a.testIds, refs = _a.refs, _p = _a.hideViewDetails, hideViewDetails = _p === void 0 ? false : _p, props = __rest(_a, ["id", "hidePreamble", "isPrimary", "isAccepted", "isExpanded", "onTermsExplainedButtonClick", "onDetailsButtonClick", "onCtaButtonClick", "data", "disabled", "v2", "adviserFirstName", "adviserProfilePhoto", "isInformative", "testIds", "refs", "hideViewDetails"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var lenderLogoSmallImageURL = data.lenderLogoSmallImageURL;
    if (v2) {
        return (react_1.default.createElement("label", __assign({}, ovr.mortgageProductCard, { className: (0, classnames_1.default)(ovr.mortgageProductCard.className, (_b = {}, _b[style_scss_1.default.mortgageProductCardPrimary] = isPrimary, _b), (_c = {}, _c[style_scss_1.default.mortgageProductCardSecondary] = !isPrimary && !isInformative, _c), (_d = {}, _d[style_scss_1.default.mortgageProductCardInformative] = isInformative, _d), (_e = {}, _e[style_scss_1.default.mortgageProductCardDisabled] = !isAccepted && disabled, _e), (_f = {}, _f[style_scss_1.default.mortgageProductCardAccepted] = !isInformative && isAccepted, _f), (_g = {}, _g[style_scss_1.default.noPointerEvents] = disabled, _g)), htmlFor: "product-card-radio-".concat(id || data.lenderName) }),
            react_1.default.createElement("input", { id: "product-card-radio-".concat(id || data.lenderName), type: "radio", className: style_scss_1.default.radioInput, onChange: props.onChange, value: id, checked: isAccepted }),
            react_1.default.createElement("div", { className: style_scss_1.default.cardHeader },
                react_1.default.createElement(content_1.Pill, __assign({}, ovr.badge, { colour: 
                    // eslint-disable-next-line no-nested-ternary
                    isPrimary
                        ? content_1.PillColours.Primary
                        : isInformative
                            ? content_1.PillColours.Informative
                            : content_1.PillColours.Secondary }), data.productLabel),
                !isInformative && (react_1.default.createElement("div", __assign({}, ovr.radio, { className: (0, classnames_1.default)((_h = {}, _h[style_scss_1.default.radioChecked] = isAccepted, _h), (_j = {}, _j[style_scss_1.default.radioDisabled] = disabled, _j), ovr.radio.className) }), isAccepted && react_1.default.createElement(radio_react_svg_1.default, null)))),
            (0, isImageComponent_1.default)(lenderLogoSmallImageURL) && (react_1.default.createElement("div", { className: style_scss_1.default.logo }, lenderLogoSmallImageURL)),
            typeof lenderLogoSmallImageURL === "string" && (react_1.default.createElement("img", { className: style_scss_1.default.logo, src: lenderLogoSmallImageURL, alt: data.lenderName })),
            adviserFirstName && adviserProfilePhoto && (react_1.default.createElement(content_1.QuoteCard, { classOverrides: {
                    card: style_scss_1.default.quoteCard,
                    title: style_scss_1.default.quoteCardTitle,
                    text: style_scss_1.default.quoteCardText
                }, text: "".concat(data.productDescription.length > DESCRIPTION_MAX_CHARS_TO_SHOW
                    ? data.productDescription.slice(0, DESCRIPTION_MAX_CHARS_TO_SHOW)
                    : data.productDescription, "..."), title: "".concat(adviserFirstName, "'s explanation"), image: adviserProfilePhoto, onClick: function (e) {
                    e.stopPropagation();
                    onDetailsButtonClick();
                } })),
            react_1.default.createElement("div", { className: style_scss_1.default.cardItems },
                react_1.default.createElement("div", { className: style_scss_1.default.cardItem },
                    react_1.default.createElement("span", null, "Rate type"),
                    react_1.default.createElement("span", null, data.rateType)),
                react_1.default.createElement("div", { className: style_scss_1.default.cardItem },
                    react_1.default.createElement("span", null, "Fees"),
                    react_1.default.createElement("span", null, data.totalFees)),
                react_1.default.createElement("div", { className: style_scss_1.default.cardItem },
                    react_1.default.createElement("span", null, "Total cost"),
                    react_1.default.createElement("span", null, data.whatYouPayPlusRemainingBalance)),
                react_1.default.createElement("div", { className: style_scss_1.default.cardItem },
                    react_1.default.createElement("span", null, "Initial rate"),
                    react_1.default.createElement("span", null, data.initialRate)),
                react_1.default.createElement("div", { className: style_scss_1.default.cardItem },
                    react_1.default.createElement("span", null, "Monthly payment"),
                    react_1.default.createElement("span", null, data.monthlyPayment))),
            !hideViewDetails ? (react_1.default.createElement(form_1.Button, { className: style_scss_1.default.cardButton, colour: shared_1.ButtonColour.TertiaryLight, fixed: false, size: shared_1.ButtonSize.Small, onClick: function (e) {
                    e.stopPropagation();
                    onDetailsButtonClick();
                } }, "View details")) : (react_1.default.createElement("p", { className: style_scss_1.default.contactAdviser }, "Contact adviser to discuss."))));
    }
    return (react_1.default.createElement(auxiliary_1.CardWrapper, __assign({ isPrimary: isPrimary }, ovr.mortgageProductCard, props),
        hidePreamble ? null : (react_1.default.createElement(auxiliary_1.CardPreamble, __assign({}, ovr.cardPreamble),
            react_1.default.createElement(auxiliary_1.ProductTypePill, { isPrimary: isPrimary }, data.productLabel),
            react_1.default.createElement(auxiliary_1.CardPreambleText, null, data.productDescription))),
        react_1.default.createElement(auxiliary_1.Card, null,
            react_1.default.createElement(auxiliary_1.LogoContainer, null,
                react_1.default.createElement(auxiliary_1.LogoImageContainer, null, (0, getImage_1.default)(lenderLogoSmallImageURL, data.lenderName)),
                react_1.default.createElement(auxiliary_1.ProductInitialDuration, null, data.title)),
            react_1.default.createElement(auxiliary_1.MainInfoContainer, null,
                react_1.default.createElement(auxiliary_1.MainInfoLine, null,
                    react_1.default.createElement(auxiliary_1.TextPair, { label: "Monthly payment", value: data.monthlyPayment }),
                    react_1.default.createElement(auxiliary_1.TextPair, { label: "Initial Rate", value: data.initialRate, textAlignment: auxiliary_1.TextPairAlignment.RIGHT })),
                react_1.default.createElement(auxiliary_1.MainInfoLine, null,
                    react_1.default.createElement(auxiliary_1.TextPair, { label: "Total fees", value: data.totalFees }),
                    react_1.default.createElement(auxiliary_1.TextPair, { label: "Cashback", value: data.cashback, textAlignment: auxiliary_1.TextPairAlignment.CENTER }),
                    react_1.default.createElement(auxiliary_1.TextPair, { label: "APRC", value: data.lenderAprc, textAlignment: auxiliary_1.TextPairAlignment.RIGHT }))),
            react_1.default.createElement(auxiliary_1.CalculationsContainer, null,
                react_1.default.createElement(auxiliary_1.CalculationsLine, null,
                    react_1.default.createElement(auxiliary_1.TextPair, { label: "What you pay over ".concat(data.initialPeriodInYears, " years"), value: data.whatYouPayOverInitialPeriod, textAlignment: auxiliary_1.TextPairAlignment.CENTER })),
                react_1.default.createElement(auxiliary_1.CalculationsLine, null,
                    react_1.default.createElement(auxiliary_1.TextPair, { label: "Your balance after ".concat(data.initialPeriodInYears, " years"), value: data.yourBalanceAfterInitialPeriod, textAlignment: auxiliary_1.TextPairAlignment.CENTER, textPrefix: "+" })),
                react_1.default.createElement(auxiliary_1.CalculationsLine, null,
                    react_1.default.createElement(auxiliary_1.TextPair, { label: "What you pay plus remaining balance", value: data.whatYouPayPlusRemainingBalance, textAlignment: auxiliary_1.TextPairAlignment.CENTER, textPrefix: "=" }))),
            onTermsExplainedButtonClick && (react_1.default.createElement(auxiliary_1.GlossaryContainer, null,
                react_1.default.createElement(auxiliary_1.TermsExplainedButton, __assign({}, ovr.termsExplainedButton, { onClick: onTermsExplainedButtonClick })))),
            react_1.default.createElement(auxiliary_1.Separator, null),
            react_1.default.createElement(auxiliary_1.ActionsContainer, null,
                react_1.default.createElement(auxiliary_1.DetailsButton, __assign({}, ovr.detailsButton, { isExpanded: isExpanded, onClick: onDetailsButtonClick })),
                !isAccepted && onCtaButtonClick && (react_1.default.createElement(auxiliary_1.CtaButton, __assign({}, ovr.ctaButton, { isPrimary: isPrimary, onClick: onCtaButtonClick, disabled: disabled })))),
            isExpanded ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(auxiliary_1.Separator, null),
                react_1.default.createElement(auxiliary_1.DetailsContainer, null,
                    react_1.default.createElement(auxiliary_1.DetailsTitle, null, "Key details"),
                    react_1.default.createElement(auxiliary_1.DetailsList, null,
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Property value", value: data.propertyValue }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Mortgage value", value: data.mortgageValue }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "LTV", value: data.ltv }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Term", value: data.term }))),
                react_1.default.createElement(auxiliary_1.Separator, null),
                react_1.default.createElement(auxiliary_1.DetailsContainer, null,
                    react_1.default.createElement(auxiliary_1.DetailsTitle, null, "Rates and cost"),
                    react_1.default.createElement(auxiliary_1.DetailsList, null,
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Product type", value: data.productType }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Rate type", value: data.rateType }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Initial period", value: data.initialPeriodInMonths }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Fixed until", value: data.fixedUntil }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Initial rate", value: data.initialRate }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Initial monthly payments", value: data.initialMonthlyPayments }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "SVR", value: data.svr }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "SVR monthly payment", value: data.svrMonthlyPayment }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Months on SVR", value: data.monthsOnSVR }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Lender APRC", value: data.lenderAprc }))),
                react_1.default.createElement(auxiliary_1.Separator, null),
                react_1.default.createElement(auxiliary_1.DetailsContainer, null,
                    react_1.default.createElement(auxiliary_1.DetailsTitle, null, "Fees"),
                    react_1.default.createElement(auxiliary_1.DetailsList, null,
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Booking fee", value: data.bookingFee }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Valuation fee", value: data.valuationFee }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Arrangement fee", value: data.arrangementFee }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Discharge fee", value: data.dischargeFee }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Deeds release fee", value: data.deedsReleaseFee }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Transfer fee", value: data.transferFee }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Total fees", value: data.totalFees, isBold: true }))),
                react_1.default.createElement(auxiliary_1.Separator, null),
                react_1.default.createElement(auxiliary_1.DetailsContainer, null,
                    react_1.default.createElement(auxiliary_1.DetailsTitle, null, "Incentives"),
                    react_1.default.createElement(auxiliary_1.DetailsList, null,
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Cashback", value: data.cashback }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Free legals", value: data.freeLegals }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Free valuation", value: data.freeValuation }))),
                react_1.default.createElement(auxiliary_1.Separator, null),
                react_1.default.createElement(auxiliary_1.DetailsContainer, null,
                    react_1.default.createElement(auxiliary_1.DetailsTitle, null, "Additional details"),
                    react_1.default.createElement(auxiliary_1.DetailsList, null,
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Overpayments", value: data.overpayments }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Portable", value: data.portable }),
                        react_1.default.createElement(auxiliary_1.DetailsPair, { label: "Offset", value: data.offset }))),
                react_1.default.createElement(auxiliary_1.Separator, null),
                react_1.default.createElement(auxiliary_1.FooterContainer, null,
                    react_1.default.createElement("p", null,
                        "When your initial period ends you\u2019ll start paying",
                        " ",
                        data.lenderName,
                        "\u2019s ",
                        react_1.default.createElement("strong", null, "standard variable rate"),
                        " ",
                        "(SVR) if you do not remortgage. It\u2019s currently",
                        " ",
                        react_1.default.createElement("strong", null, data.lenderAprc),
                        " and you\u2019ll pay",
                        " ",
                        react_1.default.createElement("strong", null,
                            data.monthlyPaymentPostInitialPeriod,
                            " a month for",
                            " ",
                            data.durationInMonthsPostInitialPeriod,
                            " months"),
                        "."),
                    react_1.default.createElement("p", null, data.earlyExitText)))) : null)));
};
MortgageProductCard.displayName = componentName;
exports["default"] = MortgageProductCard;
var MortgageProductCardBlank = function (_a) {
    var props = __rest(_a, []);
    return (react_1.default.createElement(auxiliary_1.CardWrapper, __assign({}, props, { className: (0, classnames_1.default)(style_scss_1.default.cardPlaceholder, props.className) }),
        react_1.default.createElement(tray_react_svg_1.default, { "aria-label": "tray icon" })));
};
exports.MortgageProductCardBlank = MortgageProductCardBlank;
exports.MortgageProductCardBlank.displayName = "MortgageProductCardBlank";


/***/ }),

/***/ 54213:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var pill_1 = __importStar(__webpack_require__(74747));
var quoteCard_1 = __importDefault(__webpack_require__(71993));
var cross_react_svg_1 = __importDefault(__webpack_require__(2989));
var tick_react_svg_1 = __importDefault(__webpack_require__(42121));
var getImage_1 = __importDefault(__webpack_require__(1308));
var style_scss_1 = __importDefault(__webpack_require__(79270));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var menuItemWithTooltip_1 = __webpack_require__(83556);
var componentName = "MortgageProductDetails";
var mapAnswerToIcon = {
    Yes: react_1.default.createElement(tick_react_svg_1.default, null),
    No: react_1.default.createElement(cross_react_svg_1.default, null)
};
var matchZeroRegeEx = /£0(\.00)?/;
var elementIdentifiers = (0, shared_1.tuple)("containerUnderReview", "productDescription", "underReview", "quoteCard", "details", "leftColumn", "modalItem", "label", "value", "tooltip", "tooltipBtn", "tooltipText", "fees", "subtitle", "rightColumn", "incentives", "incentivesItems", "incentive", "additional", "representativeExampleWrapper", "representativeExample", "containerLowContact");
var MortgageProductDetails = function (_a) {
    var _b;
    var data = _a.data, isPrimary = _a.isPrimary, isInformative = _a.isInformative, adviserFirstName = _a.adviserFirstName, adviserProfilePhoto = _a.adviserProfilePhoto, representativeExample = _a.representativeExample, _c = _a.variant, variant = _c === void 0 ? "default" : _c, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["data", "isPrimary", "isInformative", "adviserFirstName", "adviserProfilePhoto", "representativeExample", "variant", "className", "classOverrides", "testIds", "refs"]);
    var lenderLogoSmallImageURL = data.lenderLogoSmallImageURL;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, (_b = {},
            _b[ovr.containerUnderReview.className] = variant === "underReview",
            _b[ovr.containerLowContact.className] = variant === "lowContact",
            _b)) },
        variant !== "default" && (react_1.default.createElement("p", __assign({}, ovr.productDescription),
            react_1.default.createElement("span", null, data.productDescription),
            variant === "underReview" && (react_1.default.createElement(pill_1.default, __assign({ colour: pill_1.PillColours.Secondary }, ovr.underReview), "Under review")))),
        variant === "default" && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(pill_1.default, { colour: 
                // eslint-disable-next-line no-nested-ternary
                isPrimary
                    ? pill_1.PillColours.Primary
                    : isInformative
                        ? pill_1.PillColours.Informative
                        : pill_1.PillColours.Secondary }, data.productLabel),
            adviserFirstName && adviserProfilePhoto && (react_1.default.createElement(quoteCard_1.default, { classOverrides: { card: ovr.quoteCard.className }, text: data.productDescription, title: adviserFirstName, image: adviserProfilePhoto })))),
        react_1.default.createElement("div", __assign({}, ovr.details),
            react_1.default.createElement("div", __assign({}, ovr.leftColumn),
                react_1.default.createElement("div", __assign({}, ovr.modalItem),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Lender"),
                    (0, getImage_1.default)(lenderLogoSmallImageURL, data.lenderName)),
                react_1.default.createElement("div", __assign({}, ovr.modalItem),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Rate type"),
                    react_1.default.createElement("span", __assign({}, ovr.value), data.rateType)),
                react_1.default.createElement("div", __assign({}, ovr.modalItem),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Initial rate"),
                    react_1.default.createElement("span", __assign({}, ovr.value), data.initialRate)),
                variant !== "default" && (react_1.default.createElement("div", __assign({}, ovr.modalItem),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Term"),
                    react_1.default.createElement("span", __assign({}, ovr.value), data.term))),
                react_1.default.createElement("div", __assign({}, ovr.modalItem),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Monthly payment"),
                    react_1.default.createElement("span", __assign({}, ovr.value), data.monthlyPayment)),
                variant !== "default" && (react_1.default.createElement(menuItemWithTooltip_1.MenuItemWithTooltip, { label: "Initial term cost", value: data.whatYouPayOverInitialPeriod, tooltip: "This is the total amount you'll pay, including interest, over the introductory period.", ovr: ovr })),
                react_1.default.createElement(menuItemWithTooltip_1.MenuItemWithTooltip, { label: "APRC", value: data.lenderAprc, tooltip: "Annual Percentage Rate of Charge(APRC) is the total yearly cost of a\n  mortgage as a percentage. It's calculated with the mortgage interest\n  rate and the mortgage term, plus any fees.", ovr: ovr }),
                react_1.default.createElement("div", __assign({}, ovr.modalItem),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Mortgage amount"),
                    react_1.default.createElement("span", __assign({}, ovr.value), data.mortgageValue)),
                react_1.default.createElement("div", __assign({}, ovr.modalItem),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Property value"),
                    react_1.default.createElement("span", __assign({}, ovr.value), data.propertyValue)),
                react_1.default.createElement("div", __assign({}, ovr.modalItem),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Loan to value"),
                    react_1.default.createElement("span", __assign({}, ovr.value), data.ltv)),
                react_1.default.createElement("div", __assign({}, ovr.fees),
                    react_1.default.createElement("h4", __assign({}, ovr.subtitle), "Fees"),
                    react_1.default.createElement("div", __assign({}, ovr.modalItem),
                        react_1.default.createElement("span", __assign({}, ovr.label), "Total fees"),
                        react_1.default.createElement("span", __assign({}, ovr.value), data.totalFees)))),
            react_1.default.createElement("div", __assign({}, ovr.rightColumn),
                react_1.default.createElement("div", __assign({}, ovr.incentives),
                    react_1.default.createElement("h4", __assign({}, ovr.subtitle), "Incentives"),
                    react_1.default.createElement("div", __assign({}, ovr.incentivesItems),
                        react_1.default.createElement("div", __assign({}, ovr.incentive),
                            react_1.default.createElement("span", __assign({}, ovr.label), "Cashback"),
                            data.cashback.match(matchZeroRegeEx) ? (react_1.default.createElement(cross_react_svg_1.default, null)) : (react_1.default.createElement("span", null, data.cashback))),
                        react_1.default.createElement("div", __assign({}, ovr.incentive),
                            react_1.default.createElement("span", __assign({}, ovr.label), "Free legals"),
                            mapAnswerToIcon[data.freeLegals] || react_1.default.createElement(cross_react_svg_1.default, null)),
                        react_1.default.createElement("div", __assign({}, ovr.incentive),
                            react_1.default.createElement("span", __assign({}, ovr.label), "Free valuation"),
                            mapAnswerToIcon[data.freeValuation] || react_1.default.createElement(cross_react_svg_1.default, null)))),
                react_1.default.createElement("div", __assign({}, ovr.additional),
                    react_1.default.createElement("h4", __assign({}, ovr.subtitle), "Additional details"),
                    react_1.default.createElement("span", __assign({}, ovr.label), "Early payment charge"),
                    react_1.default.createElement("p", null, data.earlyExitText),
                    react_1.default.createElement("p", null,
                        "When your initial period ends you\u2019ll start paying\u00A0",
                        data.lenderName,
                        "\u2019s standard variable rate (SVR) if you do not remortgage. It\u2019s currently ",
                        data.lenderAprc,
                        " and you\u2019ll pay\u00A0",
                        data.monthlyPaymentPostInitialPeriod,
                        " a month for\u00A0",
                        data.durationInMonthsPostInitialPeriod,
                        " months.")))),
        representativeExample && (react_1.default.createElement("div", __assign({}, ovr.representativeExampleWrapper),
            react_1.default.createElement("p", __assign({}, ovr.subtitle), "Representative example:"),
            react_1.default.createElement("p", __assign({}, ovr.representativeExample), representativeExample)))));
};
MortgageProductDetails.displayName = componentName;
exports["default"] = MortgageProductDetails;


/***/ }),

/***/ 83556:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuItemWithTooltip = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var info_react_svg_1 = __importDefault(__webpack_require__(8159));
var info_filled_react_svg_1 = __importDefault(__webpack_require__(647));
var MenuItemWithTooltip = function (_a) {
    var label = _a.label, value = _a.value, tooltip = _a.tooltip, ovr = _a.ovr;
    var _b = (0, react_1.useState)(false), isTooltipShowed = _b[0], setIsTooltipshowed = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({}, ovr.modalItem),
            react_1.default.createElement("div", __assign({}, ovr.tooltip),
                react_1.default.createElement("span", __assign({}, ovr.label), label),
                react_1.default.createElement("button", __assign({}, ovr.tooltipBtn, { "aria-label": "Info-".concat(label), onClick: function () { return setIsTooltipshowed(function (prevState) { return !prevState; }); } }), isTooltipShowed ? react_1.default.createElement(info_filled_react_svg_1.default, null) : react_1.default.createElement(info_react_svg_1.default, null))),
            react_1.default.createElement("span", __assign({}, ovr.value), value)),
        isTooltipShowed && (react_1.default.createElement("p", __assign({}, ovr.tooltipText, { "data-testid": "tooltip-text" }), tooltip))));
};
exports.MenuItemWithTooltip = MenuItemWithTooltip;


/***/ }),

/***/ 56042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
var flexibleModal_1 = __importDefault(__webpack_require__(27767));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(99435));
var mortgageProductDetails_1 = __importDefault(__webpack_require__(54213));
var componentName = "MortgageProductDetailsModal";
var MortgageProductDetailsModal = function (_a) {
    var data = _a.data, isOpened = _a.isOpened, onClose = _a.onClose, isPrimary = _a.isPrimary, isInformative = _a.isInformative, isDisabled = _a.isDisabled, adviserFirstName = _a.adviserFirstName, adviserProfilePhoto = _a.adviserProfilePhoto, onSelectProductClick = _a.onSelectProductClick, _b = _a.variant, variant = _b === void 0 ? "default" : _b, representativeExample = _a.representativeExample;
    var _c = (0, react_1.useState)(false), submitting = _c[0], setSubmitting = _c[1];
    var body = (react_1.default.createElement(mortgageProductDetails_1.default, { data: data, isInformative: isInformative, isPrimary: isPrimary, adviserFirstName: adviserFirstName, adviserProfilePhoto: adviserProfilePhoto, representativeExample: representativeExample, variant: variant }));
    var onSendLowContactProduct = function () {
        setSubmitting(true);
        onSelectProductClick();
    };
    var isDefault = variant === "default";
    var defaultFooter = isInformative || isDisabled
        ? []
        : [
            {
                label: "Select product",
                colour: shared_1.ButtonColour.TertiaryLight,
                onClick: onSelectProductClick
            }
        ];
    var lowContactFooter = [
        {
            label: "Choose a different product",
            colour: shared_1.ButtonColour.TertiaryLight,
            disabled: submitting,
            onClick: onClose
        },
        {
            label: "Reserve for me",
            colour: shared_1.ButtonColour.Primary,
            disabled: submitting,
            onClick: onSendLowContactProduct
        }
    ];
    var footer = isDefault ? defaultFooter : lowContactFooter;
    return (react_1.default.createElement(flexibleModal_1.default, { isOpen: isOpened, size: "x-large", classOverrides: { pageContainer: style_scss_1.default.pageContainer, modal: style_scss_1.default.modal }, pages: function () { return [
            {
                body: body,
                footer: footer,
                classOverrides: {
                    page: style_scss_1.default.page,
                    headerAndBody: isDefault
                        ? style_scss_1.default.headerAndBody
                        : style_scss_1.default.headerAndBodyLowContact,
                    body: isDefault ? style_scss_1.default.body : style_scss_1.default.bodyLowContact,
                    footer: style_scss_1.default.footer,
                    buttonsContainer: style_scss_1.default.buttonsContainer
                }
            }
        ]; }, onClose: onClose }));
};
MortgageProductDetailsModal.displayName = componentName;
exports["default"] = MortgageProductDetailsModal;


/***/ }),

/***/ 91630:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(9541));
var web_1 = __webpack_require__(93815);
var logo_better_2024_react_svg_1 = __importDefault(__webpack_require__(99865));
var componentName = "NavbarWithProgress";
var elementIdentifiers = (0, shared_1.tuple)("container", "logo", "progress", "labels", "label");
var NavbarWithProgress = function (_a) {
    var progress = _a.progress, previousProgress = _a.previousProgress, _b = _a.max, max = _b === void 0 ? 100 : _b, _c = _a.logoAlignment, logoAlignment = _c === void 0 ? "left" : _c, _d = _a.springConfig, springConfig = _d === void 0 ? "default" : _d, _e = _a.showLogo, showLogo = _e === void 0 ? true : _e, _f = _a.labels, labels = _f === void 0 ? [] : _f, _g = _a.currentLabel, currentLabel = _g === void 0 ? "" : _g, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["progress", "previousProgress", "max", "logoAlignment", "springConfig", "showLogo", "labels", "currentLabel", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var progressAnimation = (0, web_1.useSpring)({
        value: progress,
        from: { value: previousProgress !== null && previousProgress !== void 0 ? previousProgress : progress },
        config: web_1.config[springConfig]
    });
    return (react_1.default.createElement("div", __assign({}, ovr.container),
        showLogo ? (react_1.default.createElement("div", { className: (0, classnames_1.default)(ovr.logo.className, style_scss_1.default["logo--align-".concat(logoAlignment)]), "data-testid": ovr.logo["data-testid"] },
            react_1.default.createElement(logo_better_2024_react_svg_1.default, null))) : null,
        react_1.default.createElement(web_1.animated.progress, { className: (0, classnames_1.default)(ovr.progress.className, className), value: progressAnimation.value, max: max }),
        react_1.default.createElement("div", __assign({}, ovr.labels), labels.map(function (label, index) {
            var _a;
            var isActive = label === currentLabel;
            var show = labels.indexOf(currentLabel) === labels.length - 1 && index === 0;
            return (react_1.default.createElement("p", __assign({}, ovr.label, { className: (0, classnames_1.default)(ovr.label.className, style_scss_1.default["_".concat(index.toString())], (_a = {},
                    _a[style_scss_1.default["label--active"]] = isActive,
                    _a[style_scss_1.default["label--show"]] = show,
                    _a)) }), label));
        }))));
};
NavbarWithProgress.displayName = componentName;
exports["default"] = NavbarWithProgress;


/***/ }),

/***/ 20222:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "PostSignupFooter";
exports.elementIdentifiers = (0, shared_1.tuple)("footer", "privacyPolicy");


/***/ }),

/***/ 54084:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var textLink_1 = __importDefault(__webpack_require__(21773));
var constants_1 = __webpack_require__(20222);
var logo_better_2024_react_svg_1 = __importDefault(__webpack_require__(99865));
var trustpilot_react_svg_1 = __importDefault(__webpack_require__(70546));
var style_scss_1 = __importDefault(__webpack_require__(91273));
var PostSignupFooter = function (_a) {
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("footer", __assign({}, ovr.footer, props, { className: (0, classnames_1.default)(ovr.footer.className, className) }),
        react_1.default.createElement(logo_better_2024_react_svg_1.default, null),
        react_1.default.createElement("br", null),
        react_1.default.createElement("br", null),
        react_1.default.createElement(trustpilot_react_svg_1.default, null),
        react_1.default.createElement("p", null, "1st Floor, Wellington House, Wellington Street, Cardiff, Wales. Registered in England and Wales: 09459339."),
        react_1.default.createElement("p", null, "Better.co.uk is a trading name of Trussle Lab Ltd, which is authorised and regulated by the Financial Conduct Authority under firm reference number 924229."),
        react_1.default.createElement("p", null, "You may have to pay an early repayment charge to your existing lender if you remortgage. Your home may be repossessed if you do not keep up repayments on your mortgage."),
        react_1.default.createElement("p", null,
            react_1.default.createElement(textLink_1.default, __assign({ href: "https://better.co.uk/privacy", underlined: true }, ovr.privacyPolicy), "Privacy policy"))));
};
PostSignupFooter.displayName = constants_1.componentName;
exports["default"] = PostSignupFooter;


/***/ }),

/***/ 68412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var textLink_1 = __importStar(__webpack_require__(21773));
var Link = function (_a) {
    var data = _a.data, _b = _a.variant, variant = _b === void 0 ? textLink_1.TextLinkTheme.SECONDARY : _b, rest = __rest(_a, ["data", "variant"]);
    return (react_1.default.createElement("div", __assign({}, rest.textLink),
        react_1.default.createElement(textLink_1.default, { href: data.href, theme: variant, type: data.type, className: data.class, id: data.id }, data.label)));
};
exports["default"] = Link;


/***/ }),

/***/ 22740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var Link_1 = __importDefault(__webpack_require__(68412));
var typography_1 = __webpack_require__(34237);
var LinksColumn = function (_a) {
    var data = _a.data, rest = __rest(_a, ["data"]);
    return (react_1.default.createElement("div", __assign({}, rest.linksColumn),
        react_1.default.createElement(typography_1.Typography, { variant: "h3", classes: rest.columnHeader.className, id: data.columnHeader }, data.columnHeader),
        react_1.default.createElement("div", __assign({}, rest.linksCtr), data.links.map(function (link, idx) { return (react_1.default.createElement(Link_1.default, __assign({ key: idx, data: link }, rest))); }))));
};
exports["default"] = LinksColumn;


/***/ }),

/***/ 43534:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var Link_1 = __importDefault(__webpack_require__(68412));
var LinksRow = function (_a) {
    var data = _a.data, rest = __rest(_a, ["data"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", __assign({}, rest.linksRowWrapper), data.map(function (link, idx) {
            return (react_1.default.createElement("div", __assign({}, rest.linkRow),
                react_1.default.createElement(Link_1.default, __assign({ key: idx, data: link }, rest))));
        }))));
};
exports["default"] = LinksRow;


/***/ }),

/***/ 15190:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "PreSignupFooter";
exports.elementIdentifiers = (0, shared_1.tuple)("footer", "footerContent", "linksContainer", "footerText", "textLink", "linksColumn", "linksCtr", "columnHeader", "linksRowWrapper", "linkRow", "logo", "legalText", "terms", "legalTextSmallFooter", "dark", "firstFooterContainer", "secondFooterContainer");


/***/ }),

/***/ 94815:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var textLink_1 = __importStar(__webpack_require__(21773));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(15190);
var better_logo_react_svg_1 = __importDefault(__webpack_require__(96225));
var better_logo_v2_react_svg_1 = __importDefault(__webpack_require__(77977));
var style_scss_1 = __importDefault(__webpack_require__(6574));
var socialMedia_1 = __importDefault(__webpack_require__(234));
var LinksColumn_1 = __importDefault(__webpack_require__(22740));
var LinksRow_1 = __importDefault(__webpack_require__(43534));
var PreSignupFooter = function (_a) {
    var _b;
    var navigationMenu = _a.navigationMenu, socialLinks = _a.socialLinks, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, showSmallFooter = _a.showSmallFooter, _c = _a.variant, variant = _c === void 0 ? "default" : _c, props = __rest(_a, ["navigationMenu", "socialLinks", "className", "classOverrides", "testIds", "refs", "showSmallFooter", "variant"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var legalTextFooter = showSmallFooter
        ? ovr.legalTextSmallFooter
        : ovr.legalText;
    var isDefault = variant === "default";
    return (react_1.default.createElement("footer", __assign({}, ovr.footer, props, { className: (0, classnames_1.default)(ovr.footer.className, className, (_b = {},
            _b[ovr.dark.className] = variant === "dark",
            _b)) }),
        react_1.default.createElement("div", __assign({}, ovr.footerContent),
            !showSmallFooter && (react_1.default.createElement("div", __assign({}, ovr.logo), isDefault ? react_1.default.createElement(better_logo_react_svg_1.default, null) : react_1.default.createElement(better_logo_v2_react_svg_1.default, null))),
            showSmallFooter ? (react_1.default.createElement("div", null, navigationMenu && (react_1.default.createElement(LinksRow_1.default, __assign({ data: navigationMenu[0].links }, ovr))))) : (react_1.default.createElement("div", __assign({}, ovr.linksContainer), navigationMenu &&
                navigationMenu.map(function (data) { return (react_1.default.createElement(LinksColumn_1.default, __assign({ key: data.columnHeader, data: data }, ovr, { variant: isDefault
                        ? textLink_1.TextLinkTheme.SECONDARY
                        : textLink_1.TextLinkTheme.SECONDARY_DARK }))); }))),
            !showSmallFooter && (react_1.default.createElement(socialMedia_1.default, { links: socialLinks, variant: variant })),
            react_1.default.createElement("div", __assign({}, legalTextFooter),
                react_1.default.createElement("div", __assign({}, ovr.firstFooterContainer),
                    react_1.default.createElement("div", __assign({}, ovr.footerText),
                        react_1.default.createElement("span", null, "We're a fee-free mortgage broker for most customers \u2013 dependent on your circumstances and credit history.\u2002"),
                        react_1.default.createElement(textLink_1.default, { href: "https://better.co.uk/terms", target: "_blank", underlined: true, className: ovr.terms.className, theme: isDefault ? textLink_1.TextLinkTheme.DARK : textLink_1.TextLinkTheme.LIGHT }, "Learn more here.")),
                    react_1.default.createElement("p", __assign({}, ovr.footerText), "For insurance business we offer products from a choice of insurers."),
                    react_1.default.createElement("p", __assign({}, ovr.footerText), "You may have to pay an early repayment charge to your existing lender if you remortgage. Your savings will depend on personal circumstances.")),
                react_1.default.createElement("div", __assign({}, ovr.secondFooterContainer),
                    react_1.default.createElement("p", __assign({}, ovr.footerText, { className: (0, classnames_1.default)(ovr.footerText.className, style_scss_1.default.firstFooterTextSecondColumn) }), "Your home may be repossessed if you do not keep up repayments on your mortgage."),
                    react_1.default.createElement("p", __assign({}, ovr.footerText), "There is no guarantee that it will be possible to arrange continuous letting of the property, nor that rental income will be sufficient to meet the cost of the mortgage."),
                    react_1.default.createElement("p", __assign({}, ovr.footerText), "Better.co.uk is a trading name of Trussle Lab Ltd, which is authorised and regulated by the Financial Conduct Authority under firm reference number 924229. You can check this on the Financial Services Register by visiting the FCA website."),
                    react_1.default.createElement("p", __assign({}, ovr.footerText), "1st Floor, Wellington House, Wellington Street, Cardiff, Wales. Registered in England and Wales: 09459339."))))));
};
PreSignupFooter.displayName = constants_1.componentName;
exports["default"] = PreSignupFooter;


/***/ }),

/***/ 43422:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "Ratewatch Card";
exports.elementIdentifiers = (0, shared_1.tuple)("wrapper", "amountWrapper", "textWrapper", "description", "tagLine", "moneyUmbrella", "tagLineWrapper");


/***/ }),

/***/ 72054:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(43422);
var style_scss_1 = __importDefault(__webpack_require__(15165));
var typography_1 = __webpack_require__(34237);
var moneyUmbrella_png_1 = __importDefault(__webpack_require__(15755));
var useWindowSize_1 = __webpack_require__(55454);
var classnames_1 = __importDefault(__webpack_require__(57485));
var tokens_breakpoints_1 = __webpack_require__(26963);
var RateWatchCard = function (_a) {
    var _b, _c, _d, _e;
    var savingsAmount = _a.savingsAmount, savingsDescription = _a.savingsDescription, rateWatchTagline = _a.rateWatchTagline, rateWatchTaglineMobile = _a.rateWatchTaglineMobile, _f = _a.mobileBreakPoint, mobileBreakPoint = _f === void 0 ? tokens_breakpoints_1.MQ_WIDE : _f;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        stylesheet: style_scss_1.default
    });
    var width = (0, useWindowSize_1.useWindowSize)().width;
    var isMobile = Boolean(width && width <= mobileBreakPoint);
    return (react_1.default.createElement("div", __assign({}, ovr.wrapper),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.textWrapper, ovr.textWrapper.className, (_b = {},
                _b[style_scss_1.default["textWrapper-mobile"]] = isMobile,
                _b)) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.amountWrapper, ovr.amountWrapper.className, (_c = {},
                    _c[style_scss_1.default["amountWrapper-mobile"]] = isMobile,
                    _c)) },
                react_1.default.createElement(typography_1.Typography, { variant: isMobile ? "h2" : "display1" }, savingsAmount),
                react_1.default.createElement(typography_1.Typography, { variant: isMobile ? "body2" : "h7" }, savingsDescription)),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.tagLineWrapper, ovr.tagLineWrapper.className, (_d = {},
                    _d[style_scss_1.default["tagLineWrapper-mobile"]] = isMobile,
                    _d)) },
                react_1.default.createElement(typography_1.Typography, { variant: isMobile ? "h5" : "h4", gutterBottom: true }, isMobile ? rateWatchTaglineMobile : rateWatchTagline))),
        react_1.default.createElement("img", { className: (0, classnames_1.default)(style_scss_1.default.moneyUmbrella, ovr.moneyUmbrella.className, (_e = {},
                _e[style_scss_1.default["moneyUmbrella-mobile"]] = isMobile,
                _e)), src: moneyUmbrella_png_1.default, alt: "MoneyUmbrella" })));
};
RateWatchCard.displayName = constants_1.componentName;
exports["default"] = RateWatchCard;


/***/ }),

/***/ 87768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InfoCardNeutral = exports.InfoCardWarning = exports.InfoCardGood = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var infoCard_1 = __importDefault(__webpack_require__(25297));
var better_logo_react_svg_1 = __importDefault(__webpack_require__(96225));
exports.InfoCardGood = (react_1.default.createElement(infoCard_1.default, { title: "A Better.co.uk advisor will be in touch", content: "You can lock in a new rate as soon as you're six months away from your current deal ending.", info: "Before your deal runs out:", colouredInfo: "3-6 months", colour: "green", image: react_1.default.createElement(better_logo_react_svg_1.default, null) }));
exports.InfoCardWarning = (react_1.default.createElement(infoCard_1.default, { content: "Your current rate will end and you could be forced onto a much higher SVR (Standard Variable Rate).", info: "Before your deal runs out:", colouredInfo: "Less than 3 months", colour: "red" }));
exports.InfoCardNeutral = (react_1.default.createElement(infoCard_1.default, { content: "Keep track of rates and prepare for your upcoming remortgage.", info: "Before your deal runs out:", colouredInfo: "6 months or more", colour: "grey" }));


/***/ }),

/***/ 84347:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RemortgageTimeline = void 0;
var React = __importStar(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(34244));
var useWindowSize_1 = __webpack_require__(55454);
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(24693);
var TimelineSection_1 = __webpack_require__(30968);
var getCardsForTimeline_1 = __webpack_require__(79589);
var calculateDates_1 = __webpack_require__(48785);
var tokens_breakpoints_1 = __webpack_require__(26963);
var RemortgageTimeline = function (_a) {
    var classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, remortgageDate = _a.remortgageDate, onClick = _a.onClick, _b = _a.isPreview, isPreview = _b === void 0 ? false : _b, children = _a.children, props = __rest(_a, ["classOverrides", "testIds", "refs", "remortgageDate", "onClick", "isPreview", "children"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var width = (0, useWindowSize_1.useWindowSize)().width;
    var isMobile = Boolean(width && width <= tokens_breakpoints_1.MQ_WIDE);
    var _c = (0, calculateDates_1.calculateRemortgageTimelineVariantAndMonths)(remortgageDate, isPreview), variant = _c.variant, monthsUntilRemo = _c.monthsUntilRemo;
    var _d = (0, getCardsForTimeline_1.getCardsForTimeline)(variant, onClick, monthsUntilRemo, children), firstCard = _d.firstCard, secondCard = _d.secondCard, thirdCard = _d.thirdCard;
    var _e = (0, calculateDates_1.calculateDates)(remortgageDate), range0 = _e.range0, range1 = _e.range1, range2 = _e.range2;
    var previewLabels = [
        [{ text: "6 + months", isCurrent: false }],
        [{ text: "3-6 months", isCurrent: false }],
        [
            { text: "Less than 3 months", isCurrent: false },
            { text: "Product end date", isCurrent: false }
        ]
    ];
    return (React.createElement("div", __assign({}, ovr.timeline, props),
        React.createElement(TimelineSection_1.TimelineSection, { range: range0, section: "first", variant: variant, isMobile: isMobile, ovr: ovr, labelsOvr: isPreview ? previewLabels[0] : undefined }, firstCard),
        React.createElement(TimelineSection_1.TimelineSection, { range: range1, section: "second", variant: variant, isMobile: isMobile, ovr: ovr, labelsOvr: isPreview ? previewLabels[1] : undefined }, secondCard),
        React.createElement(TimelineSection_1.TimelineSection, { range: range2, section: "third", variant: variant, isMobile: isMobile, ovr: ovr, labelsOvr: isPreview ? previewLabels[2] : undefined }, thirdCard)));
};
exports.RemortgageTimeline = RemortgageTimeline;
exports.RemortgageTimeline.displayName = constants_1.componentName;
exports["default"] = exports.RemortgageTimeline;


/***/ }),

/***/ 30968:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimelineSection = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var enums_1 = __webpack_require__(92231);
var style_scss_1 = __importDefault(__webpack_require__(34244));
var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var formatDate = function (date, short) {
    var month = months[date.getMonth()];
    return "".concat(short ? month.substring(0, 3) : month, " ").concat(date.getFullYear());
};
function makeLabels(range, active, isMobile) {
    var monthsBetween = [];
    if (range) {
        var date = new Date(range[0]);
        while (date <= range[1]) {
            monthsBetween.push(new Date(date));
            date.setMonth(date.getMonth() + 1);
        }
    }
    var endOfRange = range[1];
    var current = new Date();
    var isCurrentDateMoreInThePastThanEndOfRange = current.getTime() - endOfRange.getTime() > 0;
    var currentUpToEnd = active && isCurrentDateMoreInThePastThanEndOfRange ? endOfRange : current;
    var labels = monthsBetween.map(function (date) { return ({
        text: formatDate(date, isMobile),
        isCurrent: date.getFullYear() === currentUpToEnd.getFullYear() &&
            date.getMonth() === currentUpToEnd.getMonth()
    }); });
    return labels;
}
var TimelineSection = function (_a) {
    var _b;
    var range = _a.range, variant = _a.variant, section = _a.section, isMobile = _a.isMobile, ovr = _a.ovr, labelsOvr = _a.labelsOvr, children = _a.children;
    var accent = ((variant === enums_1.TimelineVariant.Early ||
        variant === enums_1.TimelineVariant.OnTime) &&
        section === "second") ||
        (variant === enums_1.TimelineVariant.Preview && section === "second");
    var active = (variant === enums_1.TimelineVariant.Early && section === "first") ||
        (variant === enums_1.TimelineVariant.OnTime && section === "second") ||
        (variant === enums_1.TimelineVariant.Late && section === "third");
    var labels = labelsOvr !== null && labelsOvr !== void 0 ? labelsOvr : makeLabels(range, active, isMobile);
    return (react_1.default.createElement("div", __assign({}, ovr.section, { className: (0, classnames_1.default)(ovr.section.className, style_scss_1.default["section__".concat(section)], (_b = {},
            _b[style_scss_1.default.section__accent] = accent,
            _b[style_scss_1.default.section__active] = active,
            _b)) }),
        react_1.default.createElement("div", __assign({}, ovr.cardContainer), children),
        react_1.default.createElement("span", __assign({}, ovr.lineSection)),
        react_1.default.createElement("div", __assign({}, ovr.labels), labels.map(function (label) {
            var _a;
            return (react_1.default.createElement("span", __assign({}, ovr.labelContainer, { key: label.text, className: (0, classnames_1.default)(ovr.labelContainer.className, (_a = {},
                    _a[style_scss_1.default.current] = label.isCurrent,
                    _a)) }),
                react_1.default.createElement("span", __assign({}, ovr.label, { key: label.text }), label.text)));
        }))));
};
exports.TimelineSection = TimelineSection;


/***/ }),

/***/ 32031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TooltipCardContactUs = exports.TooltipCardActNow = exports.TooltipCardNoAction = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var tooltipCard_1 = __importDefault(__webpack_require__(60533));
var typography_1 = __webpack_require__(34237);
var style_scss_1 = __importDefault(__webpack_require__(34244));
var TooltipCardNoAction = function (monthsRemaining, onClick, firstCardBottomSection) { return (react_1.default.createElement(tooltipCard_1.default, { buttonText: "Send me updates", onButtonClick: onClick, monthsRemaining: monthsRemaining, pillText: "Sign up now", subtitle: "Before your deal runs out:", stateColour: "informative", showForm: firstCardBottomSection },
    react_1.default.createElement(typography_1.Typography, { variant: "body2" }, "Rates can move up or down weekly, sign up to our Mortgage RateWatch email and receive updates straight to your inbox."),
    react_1.default.createElement("br", null),
    react_1.default.createElement(typography_1.Typography, { variant: "body2" }, "Get ready to lock in a new deal as soon as you're six months away from your current mortgage running out."),
    react_1.default.createElement("br", null))); };
exports.TooltipCardNoAction = TooltipCardNoAction;
var TooltipCardActNow = function (monthsRemaining, onClick) { return (react_1.default.createElement("div", { className: style_scss_1.default.tooltipContainer },
    react_1.default.createElement(tooltipCard_1.default, { buttonText: "Remortgage now", onButtonClick: onClick, monthsRemaining: monthsRemaining, pillText: "Act now", subtitle: "Before your deal runs out:", stateColour: "primary" },
        react_1.default.createElement(typography_1.Typography, { variant: "body2" },
            "Secure your rate today.",
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            "We'll continue to monitor and be in touch if a more suitable rate becomes available."),
        react_1.default.createElement("br", null)))); };
exports.TooltipCardActNow = TooltipCardActNow;
var TooltipCardContactUs = function (monthsRemaining, monthsUntilRemo, onClick) { return (react_1.default.createElement(tooltipCard_1.default, { buttonText: "Remortgage now", onButtonClick: onClick, monthsRemaining: monthsRemaining, pillText: "Contact us", subtitle: "Before your deal runs out:", stateColour: "warning" },
    react_1.default.createElement("br", null),
    react_1.default.createElement(typography_1.Typography, { variant: "body2" }, monthsUntilRemo >= 0
        ? "Your current rate will end and you could be forced onto a much higher SVR (Standard Variable Rate)."
        : "Your current rate has ended and you might have been forced onto a much higher SVR (Standard Variable Rate)."),
    react_1.default.createElement("br", null))); };
exports.TooltipCardContactUs = TooltipCardContactUs;


/***/ }),

/***/ 48785:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


// Calculates the dates for the remortgage timeline
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.calculateRemortgageTimelineVariantAndMonths = exports.calculateDates = void 0;
var dayjs_1 = __importDefault(__webpack_require__(16060));
var enums_1 = __webpack_require__(92231);
var calculateDates = function (remortgageDate) {
    var startDate;
    var today = new Date();
    var nineMonthsBeforeRemo = new Date(remortgageDate);
    nineMonthsBeforeRemo.setMonth(remortgageDate.getMonth() - 9);
    // check if current date is more than 9 months before remortgage date
    if (today < nineMonthsBeforeRemo) {
        startDate = new Date(today);
        startDate.setMonth(today.getMonth() - 1);
    }
    else {
        startDate = new Date(remortgageDate);
        startDate.setMonth(remortgageDate.getMonth() - 9);
    }
    var sevenMonthsBeforeRemo = new Date(remortgageDate);
    sevenMonthsBeforeRemo.setMonth(remortgageDate.getMonth() - 6);
    var sixMonthsBeforeRemo = new Date(remortgageDate);
    sixMonthsBeforeRemo.setMonth(remortgageDate.getMonth() - 5);
    var threeMonthsBeforeRemo = new Date(remortgageDate);
    threeMonthsBeforeRemo.setMonth(remortgageDate.getMonth() - 3);
    var twoMonthsBeforeRemo = new Date(remortgageDate);
    twoMonthsBeforeRemo.setMonth(remortgageDate.getMonth() - 2);
    var range0 = [startDate, sevenMonthsBeforeRemo];
    var range1 = [sixMonthsBeforeRemo, threeMonthsBeforeRemo];
    var range2 = [twoMonthsBeforeRemo, remortgageDate];
    return { range0: range0, range1: range1, range2: range2 };
};
exports.calculateDates = calculateDates;
var calculateRemortgageTimelineVariantAndMonths = function (remortgageDate, isPreview) {
    if (isPreview) {
        return { variant: enums_1.TimelineVariant.Preview, monthsUntilRemo: 0 };
    }
    // calculate months remaining to remortgage date
    var monthsUntilRemo = Math.ceil((0, dayjs_1.default)(remortgageDate).diff((0, dayjs_1.default)(), "month", true));
    if (monthsUntilRemo < 3) {
        return { variant: enums_1.TimelineVariant.Late, monthsUntilRemo: monthsUntilRemo };
    }
    else if (monthsUntilRemo < 6) {
        return { variant: enums_1.TimelineVariant.OnTime, monthsUntilRemo: monthsUntilRemo };
    }
    return { variant: enums_1.TimelineVariant.Early, monthsUntilRemo: monthsUntilRemo };
};
exports.calculateRemortgageTimelineVariantAndMonths = calculateRemortgageTimelineVariantAndMonths;


/***/ }),

/***/ 24693:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "RemortgageTimeline";
exports.elementIdentifiers = (0, shared_1.tuple)("timeline", "section", "cardContainer", "lineSection", "labels", "labelContainer", "label");


/***/ }),

/***/ 92231:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimelineVariant = void 0;
var TimelineVariant;
(function (TimelineVariant) {
    TimelineVariant["Early"] = "early";
    TimelineVariant["OnTime"] = "on-time";
    TimelineVariant["Late"] = "late";
    TimelineVariant["Preview"] = "preview";
})(TimelineVariant = exports.TimelineVariant || (exports.TimelineVariant = {}));


/***/ }),

/***/ 79589:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getCardsForTimeline = void 0;
var InfoCards_1 = __webpack_require__(87768);
var TooltipCards_1 = __webpack_require__(32031);
var enums_1 = __webpack_require__(92231);
var getCardsForTimeline = function (variant, onClick, monthsUntilRemo, firstCardBottomSection) {
    var monthAlwaysInPositive = Math.max(monthsUntilRemo, 0);
    var monthsRemainingCopy = "".concat(monthAlwaysInPositive, " month").concat(monthAlwaysInPositive === 1 ? "" : "s");
    switch (variant) {
        case enums_1.TimelineVariant.Preview:
            return {
                firstCard: InfoCards_1.InfoCardNeutral,
                secondCard: InfoCards_1.InfoCardGood,
                thirdCard: InfoCards_1.InfoCardWarning
            };
        case enums_1.TimelineVariant.Early:
            return {
                firstCard: (0, TooltipCards_1.TooltipCardNoAction)(monthsRemainingCopy, onClick, firstCardBottomSection),
                secondCard: InfoCards_1.InfoCardGood,
                thirdCard: InfoCards_1.InfoCardWarning
            };
        case enums_1.TimelineVariant.OnTime:
            return {
                firstCard: InfoCards_1.InfoCardNeutral,
                secondCard: (0, TooltipCards_1.TooltipCardActNow)(monthsRemainingCopy, onClick),
                thirdCard: InfoCards_1.InfoCardWarning
            };
        case enums_1.TimelineVariant.Late:
        default:
            return {
                firstCard: InfoCards_1.InfoCardNeutral,
                secondCard: InfoCards_1.InfoCardGood,
                thirdCard: (0, TooltipCards_1.TooltipCardContactUs)(monthsRemainingCopy, monthsUntilRemo, onClick)
            };
    }
};
exports.getCardsForTimeline = getCardsForTimeline;


/***/ }),

/***/ 11267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* istanbul ignore file */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.calculateRemortgageTimelineVariantAndMonths = exports["default"] = void 0;
var RemortgageTimeline_1 = __webpack_require__(84347);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return RemortgageTimeline_1.RemortgageTimeline; } }));
__exportStar(__webpack_require__(84347), exports);
__exportStar(__webpack_require__(92231), exports);
var calculateDates_1 = __webpack_require__(48785);
Object.defineProperty(exports, "calculateRemortgageTimelineVariantAndMonths", ({ enumerable: true, get: function () { return calculateDates_1.calculateRemortgageTimelineVariantAndMonths; } }));


/***/ }),

/***/ 39703:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DEBOUNCE_DELAY = exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "RepaymentsCalculator";
exports.elementIdentifiers = (0, shared_1.tuple)("outerContainer", "inputs", "textInnerWrap", "input", "title", "results", "header", "information", "amount", "result", "description", "card", "loadingLong", "loadingShort", "cardText", "spinner", "tooltipParagraph", "tooltipButton", "tooltipOpen", "disclaimer", "resultTop");
exports.DEBOUNCE_DELAY = 1000;


/***/ }),

/***/ 90803:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initialTerms = exports.InitialTerm = exports.productTypes = exports.ProductTypes = void 0;
var ProductTypes;
(function (ProductTypes) {
    ProductTypes["FIXED"] = "FIXED";
    ProductTypes["TRACKER"] = "TRACKER";
    ProductTypes["DISCOUNT"] = "DISCOUNT";
    ProductTypes["VARIABLE"] = "VARIABLE";
})(ProductTypes = exports.ProductTypes || (exports.ProductTypes = {}));
exports.productTypes = [
    {
        code: ProductTypes.FIXED,
        description: "Fixed"
    },
    {
        code: ProductTypes.VARIABLE,
        description: "Variable"
    },
    {
        code: ProductTypes.DISCOUNT,
        description: "Discount"
    },
    {
        code: ProductTypes.TRACKER,
        description: "Tracker"
    }
];
var InitialTerm;
(function (InitialTerm) {
    InitialTerm["ONE_YEAR"] = "ONE_YEAR";
    InitialTerm["TWO_YEAR"] = "TWO_YEAR";
    InitialTerm["THREE_YEAR"] = "THREE_YEAR";
    InitialTerm["FOUR_YEAR"] = "FOUR_YEAR";
    InitialTerm["FIVE_YEAR"] = "FIVE_YEAR";
    InitialTerm["TEN_YEAR"] = "TEN_YEAR";
})(InitialTerm = exports.InitialTerm || (exports.InitialTerm = {}));
exports.initialTerms = [
    {
        code: InitialTerm.ONE_YEAR,
        description: "1"
    },
    {
        code: InitialTerm.TWO_YEAR,
        description: "2"
    },
    {
        code: InitialTerm.THREE_YEAR,
        description: "3"
    },
    {
        code: InitialTerm.FOUR_YEAR,
        description: "4"
    },
    {
        code: InitialTerm.FIVE_YEAR,
        description: "5"
    },
    {
        code: InitialTerm.TEN_YEAR,
        description: "10"
    }
];


/***/ }),

/***/ 62553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InitialTerm = exports.ProductTypes = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(1553));
var content_1 = __webpack_require__(49429);
var card_1 = __importDefault(__webpack_require__(82972));
var form_1 = __webpack_require__(13174);
var dropdownOptions_1 = __webpack_require__(90803);
var constants_1 = __webpack_require__(39703);
var lodash_debounce_1 = __importDefault(__webpack_require__(89192));
var dropdownOptions_2 = __webpack_require__(90803);
Object.defineProperty(exports, "ProductTypes", ({ enumerable: true, get: function () { return dropdownOptions_2.ProductTypes; } }));
Object.defineProperty(exports, "InitialTerm", ({ enumerable: true, get: function () { return dropdownOptions_2.InitialTerm; } }));
var MAX_REPAYMENT_PERIOD = 100;
var RepaymentsCalculator = function (_a) {
    var initialBorrowingAmount = _a.initialBorrowingAmount, onChangeParams = _a.onChangeParams, resultDescriptions = _a.resultDescriptions, hrefTooltip = _a.hrefTooltip, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["initialBorrowingAmount", "onChangeParams", "resultDescriptions", "hrefTooltip", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var prefix = props.id || constants_1.componentName;
    var _b = (0, react_1.useState)(initialBorrowingAmount), borrowingAmount = _b[0], setBorrowingAmount = _b[1];
    var _c = (0, react_1.useState)("25"), repaymentPeriod = _c[0], setRepaymentPeriod = _c[1];
    var _d = (0, react_1.useState)(dropdownOptions_1.InitialTerm.TWO_YEAR), initialPeriod = _d[0], setInitialPeriod = _d[1];
    var _e = (0, react_1.useState)(dropdownOptions_1.ProductTypes.FIXED), rateType = _e[0], setRateType = _e[1];
    var onChangeParamsDebounced = (0, react_1.useMemo)(function () { return (0, lodash_debounce_1.default)(onChangeParams, constants_1.DEBOUNCE_DELAY); }, [onChangeParams]);
    var changeBorrowingAmount = function (e) {
        var value = e.target.value;
        setBorrowingAmount(value);
        onChangeParamsDebounced({
            borrowingAmount: value,
            repaymentPeriod: repaymentPeriod,
            rateType: rateType,
            initialPeriod: initialPeriod
        });
    };
    var changeRepaymentPeriod = function (e) {
        var value = e.target.value;
        var valueInRange = Math.min(MAX_REPAYMENT_PERIOD, Math.max(0, Number(value))).toString();
        setRepaymentPeriod(valueInRange);
        onChangeParamsDebounced({
            borrowingAmount: borrowingAmount,
            repaymentPeriod: valueInRange,
            rateType: rateType,
            initialPeriod: initialPeriod
        });
    };
    var changeInitialPeriod = function (e) {
        var value = e.target.value;
        setInitialPeriod(value);
        onChangeParams({
            borrowingAmount: borrowingAmount,
            repaymentPeriod: repaymentPeriod,
            rateType: rateType,
            initialPeriod: value
        });
    };
    var changeRateType = function (e) {
        var value = e.target.value;
        setRateType(value);
        onChangeParams({
            borrowingAmount: borrowingAmount,
            repaymentPeriod: repaymentPeriod,
            rateType: value,
            initialPeriod: initialPeriod
        });
    };
    (0, react_1.useEffect)(function () {
        onChangeParams({
            borrowingAmount: borrowingAmount,
            repaymentPeriod: repaymentPeriod,
            rateType: rateType,
            initialPeriod: initialPeriod
        });
    }, []);
    return (react_1.default.createElement("div", { role: "region", "aria-label": "Repayment calculator", className: className },
        react_1.default.createElement(card_1.default, __assign({}, ovr.outerContainer, props, { role: "region", "aria-label": "".concat(prefix, "-label"), classOverrides: {
                textInnerWrap: ovr.textInnerWrap.className,
                text: ovr.cardText.className,
                cardContainer: ovr.outerContainer.className,
                card: ovr.card.className
            } }),
            react_1.default.createElement("div", __assign({}, ovr.inputs),
                react_1.default.createElement("div", __assign({}, ovr.input),
                    react_1.default.createElement("h3", __assign({}, ovr.title), "I want to borrow"),
                    react_1.default.createElement(form_1.CurrencyInput, { id: "".concat(prefix, "-borrowing"), isValid: true, value: borrowingAmount, onChange: changeBorrowingAmount })),
                react_1.default.createElement("div", __assign({}, ovr.input),
                    react_1.default.createElement("h3", __assign({}, ovr.title), "Pay back mortgage over"),
                    react_1.default.createElement(form_1.TextInput, { onChange: changeRepaymentPeriod, type: "number", isValid: true, id: "".concat(prefix, "-repayment"), value: repaymentPeriod, suffix: {
                            text: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("span", null, "years"))),
                            labelId: "".concat(prefix, "-repayment-label")
                        } })),
                react_1.default.createElement("div", __assign({}, ovr.input),
                    react_1.default.createElement("h3", __assign({}, ovr.title), "Initial period"),
                    react_1.default.createElement(form_1.Dropdown, { id: "".concat(prefix, "-initial-period"), isValid: true, options: dropdownOptions_1.initialTerms, value: initialPeriod, onChange: changeInitialPeriod })),
                react_1.default.createElement("div", __assign({}, ovr.input),
                    react_1.default.createElement("h3", __assign({}, ovr.title), "Rate type"),
                    react_1.default.createElement(form_1.Dropdown, { id: "".concat(prefix, "-rate-type"), isValid: true, options: dropdownOptions_1.productTypes, value: rateType, onChange: changeRateType }))),
            react_1.default.createElement("div", __assign({}, ovr.results),
                react_1.default.createElement("div", __assign({}, ovr.resultTop),
                    react_1.default.createElement("h3", __assign({}, ovr.header), "How much will you pay? "),
                    react_1.default.createElement(form_1.Tooltip, { classOverrides: {
                            tipOuterContainer: ovr.tooltipOpen.className,
                            textContainer: ovr.tooltipParagraph.className
                        }, alwaysOpenDown: true },
                        "We have calculated an example market leading interest rate based on your deposit and the details shown here.",
                        " ",
                        react_1.default.createElement("a", __assign({}, ovr.tooltipButton, { href: hrefTooltip }), "Learn more about how this calculator works"))),
                resultDescriptions ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", __assign({}, ovr.description), resultDescriptions.description),
                    react_1.default.createElement("div", __assign({}, ovr.result),
                        react_1.default.createElement("h3", __assign({}, ovr.amount), resultDescriptions.amount),
                        react_1.default.createElement("p", __assign({}, ovr.information), resultDescriptions.information)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", __assign({}, ovr.description),
                        react_1.default.createElement(content_1.ContentLoader, { classOverrides: {
                                contentLoader: ovr.loadingLong.className
                            } }),
                        react_1.default.createElement(content_1.ContentLoader, { classOverrides: {
                                contentLoader: ovr.loadingShort.className
                            } })),
                    react_1.default.createElement("div", __assign({}, ovr.result),
                        react_1.default.createElement(content_1.Spinner, { size: 24, className: ovr.spinner.className })))))),
        react_1.default.createElement("p", __assign({}, ovr.disclaimer), "This is an estimate of your monthly repayments. Talk to a mortgage broker or lender to get an exact figure.")));
};
RepaymentsCalculator.displayName = constants_1.componentName;
exports["default"] = RepaymentsCalculator;


/***/ }),

/***/ 88001:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "SectionCard";
exports.elementIdentifiers = (0, shared_1.tuple)("icon", "title", "description", "sectionCard", "textContainer", "percentageContainer", "percentageText", "titleContainer", "removeApplicantButton", "button", "hairlineContainer", "descriptionText");


/***/ }),

/***/ 94925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(49360));
var arrow_react_svg_1 = __importDefault(__webpack_require__(74725));
var cross_react_svg_1 = __importDefault(__webpack_require__(75679));
var pill_1 = __importStar(__webpack_require__(74747));
var classnames_1 = __importDefault(__webpack_require__(57485));
var textButton_1 = __importDefault(__webpack_require__(80271));
var constants_1 = __webpack_require__(88001);
var tooltip_1 = __importStar(__webpack_require__(62636));
var SectionCard = function (_a) {
    var _b, _c;
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, icon = _a.icon, title = _a.title, description = _a.description, completed = _a.completed, percentage = _a.percentage, isSecondApplicant = _a.isSecondApplicant, tooltip = _a.tooltip, removeApplicantHandler = _a.removeApplicantHandler, onClick = _a.onClick, _d = _a.variant, variant = _d === void 0 ? "default" : _d, props = __rest(_a, ["className", "classOverrides", "testIds", "refs", "icon", "title", "description", "completed", "percentage", "isSecondApplicant", "tooltip", "removeApplicantHandler", "onClick", "variant"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var tooltipRef = (0, react_1.useRef)(null);
    var Icon = icon;
    var removeApplicantHandlerButton = removeApplicantHandler && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", __assign({}, ovr.hairlineContainer),
            react_1.default.createElement("hr", null)),
        react_1.default.createElement(textButton_1.default, __assign({}, ovr.removeApplicantButton, { onClick: removeApplicantHandler, icon: cross_react_svg_1.default, value: "Remove applicant" }))));
    var percentageWithArrowDefault = (percentage || completed) &&
        variant === "default" && (react_1.default.createElement("span", __assign({}, ovr.percentageContainer),
        !completed ? (percentage &&
            parseInt(percentage.replace(/\D/g, "")) !== 0 && (react_1.default.createElement("p", __assign({}, ovr.percentageText), percentage))) : (react_1.default.createElement(pill_1.default, null, "Completed")),
        react_1.default.createElement(arrow_react_svg_1.default, null)));
    var isDocuments = variant === "documents";
    var completedDocuments = isDocuments && (react_1.default.createElement("span", __assign({}, ovr.percentageContainer),
        react_1.default.createElement(pill_1.default, { colour: completed ? pill_1.PillColours.Primary : pill_1.PillColours.Warning, ignoreIcon: true, className: style_scss_1.default.documentsPill }, completed ? "UPLOADED" : "DOCUMENTS REQUIRED")));
    var arrowDocuments = isDocuments && (react_1.default.createElement("span", __assign({}, ovr.percentageContainer),
        react_1.default.createElement(arrow_react_svg_1.default, null)));
    var addSecondApplicantPlusOne = isSecondApplicant &&
        !removeApplicantHandler && react_1.default.createElement("span", { className: style_scss_1.default.numberContainer }, "+1");
    return (react_1.default.createElement("div", __assign({}, ovr.sectionCard, { className: (0, classnames_1.default)(ovr.sectionCard.className, className, isSecondApplicant && style_scss_1.default.addSecondSection, removeApplicantHandler && style_scss_1.default.addSecondSectionRemove, completed && style_scss_1.default.completedSection, (_b = {},
            _b[style_scss_1.default.documentsSection] = isDocuments,
            _b[style_scss_1.default.defaultSection] = variant === "default",
            _b)) }),
        react_1.default.createElement("button", __assign({}, ovr.button, props, { onClick: function (event) {
                if (onClick &&
                    (tooltipRef.current
                        ? !tooltipRef.current.contains(event.target)
                        : true)) {
                    onClick(event);
                }
            } }),
            Icon && (react_1.default.createElement("span", __assign({}, ovr.icon),
                react_1.default.createElement(Icon, null))),
            react_1.default.createElement("span", __assign({}, ovr.textContainer, { className: (0, classnames_1.default)(ovr.textContainer.className, (_c = {},
                    _c[style_scss_1.default.textContainerDocuments] = isDocuments,
                    _c)) }),
                react_1.default.createElement("span", __assign({}, ovr.titleContainer),
                    react_1.default.createElement("h1", __assign({}, ovr.title), title),
                    completedDocuments),
                description && (react_1.default.createElement("p", __assign({}, ovr.description),
                    react_1.default.createElement("span", __assign({}, ovr.descriptionText), description),
                    arrowDocuments)),
                tooltip && (react_1.default.createElement(tooltip_1.default, { refs: { container: tooltipRef }, classOverrides: {
                        button: style_scss_1.default.buttonTooltip,
                        textContainer: style_scss_1.default.tooltipTextContainer,
                        tipInnerContainer: style_scss_1.default.tipInnerContainer,
                        tipOuterContainer: style_scss_1.default.tipOuterContainer
                    }, theme: tooltip_1.ToolTipTheme.V3, size: tooltip_1.ToolTipSize.Small, alwaysOpenDown: true }, tooltip))),
            percentageWithArrowDefault,
            addSecondApplicantPlusOne),
        removeApplicantHandlerButton));
};
SectionCard.displayName = constants_1.componentName;
exports["default"] = SectionCard;


/***/ }),

/***/ 8616:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonWithOptions = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var ButtonWithOptions_styles_scss_1 = __importDefault(__webpack_require__(40023));
var classnames_1 = __importDefault(__webpack_require__(57485));
var use_onclickoutside_1 = __importDefault(__webpack_require__(37251));
var shared_1 = __webpack_require__(89574);
var unknownProfile_react_svg_1 = __importDefault(__webpack_require__(20099));
var componentName = "ProfileDropdown";
var elementIdentifiers = (0, shared_1.tuple)("container", "mainOptionsButton", "triangle", "optionsContainer", "option", "unknownProfileIcon", "profileText");
var ButtonWithOptions = function (_a) {
    var _b;
    var options = _a.options, _c = _a.displayProfileIcon, displayProfileIcon = _c === void 0 ? true : _c, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["options", "displayProfileIcon", "classOverrides", "testIds", "refs"]);
    var _d = (0, react_1.useState)(false), dropdownOpen = _d[0], setDropdownOpen = _d[1];
    var ref = react_1.default.useRef(null);
    (0, use_onclickoutside_1.default)(ref, function () {
        setDropdownOpen(false);
    });
    var toggleDropdown = function () {
        setDropdownOpen(!dropdownOpen);
    };
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: ButtonWithOptions_styles_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.container, { ref: ref }),
        react_1.default.createElement("button", __assign({}, ovr.mainOptionsButton, props, { onClick: toggleDropdown }),
            displayProfileIcon && (react_1.default.createElement("span", __assign({}, ovr.unknownProfileIcon),
                react_1.default.createElement(unknownProfile_react_svg_1.default, null))),
            react_1.default.createElement("span", __assign({}, ovr.profileText), "My Profile "),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(ButtonWithOptions_styles_scss_1.default.triangle, (_b = {}, _b[ButtonWithOptions_styles_scss_1.default.open] = dropdownOpen, _b), __assign({}, ovr.triangle)) })),
        dropdownOpen && (react_1.default.createElement("div", __assign({}, ovr.optionsContainer), options &&
            options.map(function (option) { return (react_1.default.createElement("button", __assign({}, ovr.option, { key: option.label, onClick: option.onClick }), option.label)); })))));
};
exports.ButtonWithOptions = ButtonWithOptions;


/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LoadingButton = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var LoadingButton_styles_scss_1 = __importDefault(__webpack_require__(45346));
var classnames_1 = __importDefault(__webpack_require__(57485));
var form_1 = __webpack_require__(13174);
var shared_1 = __webpack_require__(89574);
var componentName = "LoadingButton";
var elementIdentifiers = (0, shared_1.tuple)("button", "spinner", "buttonContentWrapper", "buttonContent", "loadingText", "buttonText");
var LoadingButton = function (_a) {
    var _b;
    var onClick = _a.onClick, loading = _a.loading, _c = _a.colour, colour = _c === void 0 ? shared_1.ButtonColour.TertiaryLight : _c, text = _a.text, _d = _a.loadingText, loadingText = _d === void 0 ? "Loading" : _d, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["onClick", "loading", "colour", "text", "loadingText", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: LoadingButton_styles_scss_1.default
    });
    return (react_1.default.createElement(form_1.Button, __assign({}, ovr.button, props, { onClick: onClick, disabled: loading, className: (0, classnames_1.default)((_b = {}, _b[LoadingButton_styles_scss_1.default.loading] = loading, _b), ovr.button.className, className), fixed: false, colour: colour }),
        react_1.default.createElement("div", __assign({}, ovr.buttonContentWrapper),
            react_1.default.createElement("div", __assign({}, ovr.buttonContent),
                loading && (react_1.default.createElement("div", __assign({}, ovr.spinner, { "aria-busy": "true", "aria-live": "polite" }))),
                loading ? (react_1.default.createElement("span", __assign({}, ovr.loadingText), loadingText)) : (react_1.default.createElement("span", __assign({}, ovr.buttonText), text))))));
};
exports.LoadingButton = LoadingButton;


/***/ }),

/***/ 44812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SignInProfileButton = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var LoadingButton_1 = __webpack_require__(6240);
var ButtonWithOptions_1 = __webpack_require__(8616);
var SignInProfileButton = function (_a) {
    var isLoggedIn = _a.isLoggedIn, onClick = _a.onClick, isLoading = _a.isLoading, options = _a.options, buttonWithOptionsProps = _a.buttonWithOptionsProps, buttonWithOptionsClassOverrides = _a.buttonWithOptionsClassOverrides, loadingButtonProps = _a.loadingButtonProps, loadingButtonClassOverrides = _a.loadingButtonClassOverrides;
    return isLoggedIn ? (react_1.default.createElement(ButtonWithOptions_1.ButtonWithOptions, __assign({}, buttonWithOptionsProps, { options: options, classOverrides: buttonWithOptionsClassOverrides }))) : (react_1.default.createElement(LoadingButton_1.LoadingButton, __assign({ loading: isLoading, onClick: onClick, text: "Sign in" }, loadingButtonProps, { classOverrides: loadingButtonClassOverrides })));
};
exports.SignInProfileButton = SignInProfileButton;


/***/ }),

/***/ 54526:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(44812), exports);


/***/ }),

/***/ 30426:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var slideOut_1 = __importDefault(__webpack_require__(32564));
var shared_1 = __webpack_require__(89574);
var react_1 = __importDefault(__webpack_require__(99497));
var style_scss_1 = __importDefault(__webpack_require__(24637));
var tujButton_1 = __importDefault(__webpack_require__(61382));
exports.componentName = "SlideOutArticles";
exports.elementIdentifiers = (0, shared_1.tuple)("secondaryHeading", "article", "link", "buttonLink");
var SlideOutArticles = function (_a) {
    var classOverrides = _a.classOverrides, className = _a.className, testIds = _a.testIds, title = _a.title, articles = _a.articles, slideoutButtons = _a.slideoutButtons, _b = _a.openArticleInNewCard, openArticleInNewCard = _b === void 0 ? false : _b, _c = _a.openTopButtonLinkInNewCard, openTopButtonLinkInNewCard = _c === void 0 ? false : _c, secondaryHeading = _a.secondaryHeading, refs = _a.refs, props = __rest(_a, ["classOverrides", "className", "testIds", "title", "articles", "slideoutButtons", "openArticleInNewCard", "openTopButtonLinkInNewCard", "secondaryHeading", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: exports.elementIdentifiers,
        componentName: exports.componentName,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var options = openArticleInNewCard
        ? { rel: "noopener noreferrer", target: "_blank" }
        : null;
    var topButtonLinkOptions = openTopButtonLinkInNewCard
        ? { rel: "noopener noreferrer", target: "_blank" }
        : null;
    return (react_1.default.createElement(slideOut_1.default, __assign({ title: title }, props, { className: className }), slideoutButtons === null || slideoutButtons === void 0 ? void 0 :
        slideoutButtons.map(function (data, key) { return (react_1.default.createElement("a", __assign({ href: data.link }, topButtonLinkOptions, ovr.buttonLink, { key: key }),
            react_1.default.createElement(tujButton_1.default, { variant: "dark", smartBuyerBadge: data.smartBuyerBadge, title: data.title, body: data.body }))); }),
        react_1.default.createElement("h2", __assign({}, ovr.secondaryHeading), secondaryHeading),
        react_1.default.createElement("div", null, articles.map(function (article, i) { return (react_1.default.createElement("a", __assign({ href: article.link }, options, ovr.link, { key: "".concat(article.link, "_").concat(i) }),
            react_1.default.createElement("div", __assign({}, ovr.article),
                react_1.default.createElement("img", { src: article.src, alt: article.alt }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h3", null, article.header),
                    react_1.default.createElement("p", null, article.text),
                    react_1.default.createElement("div", null, "Read more"))))); }))));
};
exports["default"] = SlideOutArticles;


/***/ }),

/***/ 25936:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(58540));
var suitcase_react_svg_1 = __importDefault(__webpack_require__(7837));
var rocket_react_svg_1 = __importDefault(__webpack_require__(60626));
var thumbs_up_react_svg_1 = __importDefault(__webpack_require__(35356));
var shield_react_svg_1 = __importDefault(__webpack_require__(13740));
var componentName = "SmartBuyerBenefits";
var elementIdentifiers = (0, shared_1.tuple)("list", "item", "icon", "text", "title", "description");
var defaultItems = [
    {
        title: "Convenient",
        description: "Everything goes through us, keeping all the bits in one place",
        icon: "suitcase"
    },
    {
        title: "Fast",
        description: "Average time to complete is just six weeks",
        icon: "rocket"
    },
    {
        title: "Affordable",
        description: "Prices start from £2000",
        icon: "thumbs-up"
    },
    {
        title: "Protected",
        description: "If you don't exchange, you won't pay any legal fees",
        icon: "shield"
    }
];
var SmartBuyerBenefits = function (_a) {
    var id = _a.id, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, _b = _a.items, items = _b === void 0 ? defaultItems : _b;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("ul", __assign({}, ovr.list), items.map(function (item, index) { return (react_1.default.createElement("li", __assign({ key: index }, ovr.item),
        react_1.default.createElement("div", __assign({}, ovr.icon),
            item.icon === "suitcase" && react_1.default.createElement(suitcase_react_svg_1.default, null),
            item.icon === "rocket" && react_1.default.createElement(rocket_react_svg_1.default, null),
            item.icon === "thumbs-up" && react_1.default.createElement(thumbs_up_react_svg_1.default, null),
            item.icon === "shield" && react_1.default.createElement(shield_react_svg_1.default, null)),
        react_1.default.createElement("div", __assign({}, ovr.text),
            react_1.default.createElement("p", __assign({}, ovr.title), item.title),
            react_1.default.createElement("p", __assign({}, ovr.description), item.description)))); })));
};
SmartBuyerBenefits.displayName = componentName;
exports["default"] = SmartBuyerBenefits;


/***/ }),

/***/ 11121:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "SocialMedia";
exports.elementIdentifiers = (0, shared_1.tuple)("social", "link", "dark");


/***/ }),

/***/ 234:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var constants_1 = __webpack_require__(11121);
var style_scss_1 = __importDefault(__webpack_require__(63287));
var classnames_1 = __importDefault(__webpack_require__(57485));
var twitter_react_svg_1 = __importDefault(__webpack_require__(94221));
var facebook_react_svg_1 = __importDefault(__webpack_require__(90260));
var instagram_react_svg_1 = __importDefault(__webpack_require__(83580));
var linkedin_react_svg_1 = __importDefault(__webpack_require__(45103));
var tiktok_react_svg_1 = __importDefault(__webpack_require__(5569));
var SocialMedia = function (_a) {
    var _b;
    var id = _a.id, _c = _a.links, twitter = _c.twitter, linkedin = _c.linkedin, facebook = _c.facebook, instagram = _c.instagram, tiktok = _c.tiktok, classOverrides = _a.classOverrides, className = _a.className, testIds = _a.testIds, refs = _a.refs, _d = _a.variant, variant = _d === void 0 ? "default" : _d;
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.social, { className: (0, classnames_1.default)(ovr.social.className, className, (_b = {},
            _b[ovr.dark.className] = variant === "dark",
            _b)) }),
        tiktok && (react_1.default.createElement("a", __assign({ href: tiktok, "aria-label": "tiktok" }, ovr.link),
            react_1.default.createElement(tiktok_react_svg_1.default, { "aria-label": "tiktok" }))),
        twitter && (react_1.default.createElement("a", __assign({ href: twitter, "aria-label": "twitter" }, ovr.link),
            react_1.default.createElement(twitter_react_svg_1.default, { "aria-label": "twitter" }))),
        variant === "default" && (react_1.default.createElement(react_1.default.Fragment, null,
            linkedin && (react_1.default.createElement("a", __assign({ href: linkedin, "aria-label": "linkedin" }, ovr.link),
                react_1.default.createElement(linkedin_react_svg_1.default, { "aria-label": "linkedin" }))),
            facebook && (react_1.default.createElement("a", __assign({ href: facebook, "aria-label": "facebook" }, ovr.link),
                react_1.default.createElement(facebook_react_svg_1.default, { "aria-label": "facebook" }))))),
        variant === "dark" && (react_1.default.createElement(react_1.default.Fragment, null,
            facebook && (react_1.default.createElement("a", __assign({ href: facebook, "aria-label": "facebook" }, ovr.link),
                react_1.default.createElement(facebook_react_svg_1.default, { "aria-label": "facebook" }))),
            linkedin && (react_1.default.createElement("a", __assign({ href: linkedin, "aria-label": "linkedin" }, ovr.link),
                react_1.default.createElement(linkedin_react_svg_1.default, { "aria-label": "linkedin" }))))),
        instagram && (react_1.default.createElement("a", __assign({ href: instagram, "aria-label": "instagram" }, ovr.link),
            react_1.default.createElement(instagram_react_svg_1.default, { "aria-label": "instagram" })))));
};
SocialMedia.displayName = constants_1.componentName;
exports["default"] = SocialMedia;


/***/ }),

/***/ 99161:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MaybeLink = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
function MaybeLink(_a) {
    var url = _a.url, children = _a.children, classname = _a.classname;
    if (url) {
        return (react_1.default.createElement("a", { className: classname, href: url, target: "_blank", rel: "noopener noreferrer" }, children));
    }
    return react_1.default.createElement("div", { className: classname }, children);
}
exports.MaybeLink = MaybeLink;


/***/ }),

/***/ 63198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var styles_scss_1 = __importDefault(__webpack_require__(9376));
var starContainer_1 = __webpack_require__(63129);
var Trustpilot_react_svg_1 = __importDefault(__webpack_require__(70772));
var MaybeLink_1 = __webpack_require__(99161);
var componentName = "TestimonialCard";
var elementIdentifiers = (0, shared_1.tuple)("reviewContainer", "text", "meta");
var TestimonialCard = function (_a) {
    var productType = _a.productType, author = _a.author, text = _a.text, rating = _a.rating, _b = _a.variant, variant = _b === void 0 ? "green" : _b, _c = _a.size, size = _c === void 0 ? "large" : _c, link = _a.link, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["productType", "author", "text", "rating", "variant", "size", "link", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    var list = size === "small" ? (react_1.default.createElement("div", { className: styles_scss_1.default.metaWrapper },
        react_1.default.createElement(Trustpilot_react_svg_1.default, null),
        react_1.default.createElement("ul", __assign({}, ovr.meta),
            react_1.default.createElement("li", null, author),
            react_1.default.createElement("li", null, productType)))) : (react_1.default.createElement("div", { className: styles_scss_1.default.metaWrapper },
        react_1.default.createElement("ul", __assign({}, ovr.meta),
            react_1.default.createElement("li", null,
                react_1.default.createElement(Trustpilot_react_svg_1.default, null)),
            react_1.default.createElement("li", null, author),
            react_1.default.createElement("li", null, productType))));
    return (react_1.default.createElement(MaybeLink_1.MaybeLink, { url: link, classname: styles_scss_1.default.link },
        react_1.default.createElement("div", __assign({}, ovr.reviewContainer, { className: (0, classnames_1.default)(ovr.reviewContainer.className, styles_scss_1.default["review-container--".concat(variant)], styles_scss_1.default[size]) }),
            react_1.default.createElement(starContainer_1.Rating, { rating: rating }),
            react_1.default.createElement("p", __assign({}, ovr.text), text),
            list)));
};
TestimonialCard.displayName = componentName;
exports["default"] = TestimonialCard;


/***/ }),

/***/ 5305:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Star = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var Star = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "full" : _b;
    if (variant === "full") {
        return (react_1.default.createElement("svg", { width: "24", height: "23", viewBox: "0 0 24 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M11.7131 1.16382C11.8218 0.912438 12.1782 0.912437 12.2869 1.16382L15.3137 8.16819C15.359 8.27293 15.4577 8.34468 15.5713 8.35536L23.1682 9.0696C23.4409 9.09523 23.551 9.43424 23.3455 9.61524L17.6193 14.6584C17.5337 14.7338 17.496 14.8499 17.5209 14.9613L19.1892 22.4071C19.2491 22.6743 18.9607 22.8838 18.7251 22.7443L12.1592 18.8568C12.061 18.7986 11.939 18.7986 11.8408 18.8568L5.27494 22.7443C5.0393 22.8838 4.75092 22.6743 4.81079 22.4071L6.47908 14.9613C6.50403 14.8499 6.46631 14.7338 6.38069 14.6584L0.654479 9.61524C0.448969 9.43424 0.55912 9.09523 0.831768 9.0696L8.42867 8.35536C8.54227 8.34468 8.64102 8.27293 8.68628 8.16819L11.7131 1.16382Z", fill: "#fffdfa", stroke: "#fffdfa" })));
    }
    else if (variant === "half") {
        var clipPathId = "clip0_".concat(Math.floor(Math.random() * 1000));
        return (react_1.default.createElement("svg", { width: "24", height: "23", viewBox: "0 0 24 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M11.7131 1.16382C11.8218 0.912438 12.1782 0.912437 12.2869 1.16382L15.3137 8.16819C15.359 8.27293 15.4577 8.34468 15.5713 8.35536L23.1682 9.0696C23.4409 9.09523 23.551 9.43424 23.3455 9.61524L17.6193 14.6584C17.5337 14.7338 17.496 14.8499 17.5209 14.9613L19.1892 22.4071C19.2491 22.6743 18.9607 22.8838 18.7251 22.7443L12.1592 18.8568C12.061 18.7986 11.939 18.7986 11.8408 18.8568L5.27494 22.7443C5.0393 22.8838 4.75092 22.6743 4.81079 22.4071L6.47908 14.9613C6.50403 14.8499 6.46631 14.7338 6.38069 14.6584L0.654479 9.61524C0.448969 9.43424 0.55912 9.09523 0.831768 9.0696L8.42867 8.35536C8.54227 8.34468 8.64102 8.27293 8.68628 8.16819L11.7131 1.16382Z", fill: "none", stroke: "#fffdfa" }),
            react_1.default.createElement("g", { "clip-path": "url(#".concat(clipPathId, ")") },
                react_1.default.createElement("path", { d: "M11.7131 1.16382C11.8218 0.912438 12.1782 0.912437 12.2869 1.16382L15.3137 8.16819C15.359 8.27293 15.4577 8.34468 15.5713 8.35536L23.1682 9.0696C23.4409 9.09523 23.551 9.43424 23.3455 9.61524L17.6193 14.6584C17.5337 14.7338 17.496 14.8499 17.5209 14.9613L19.1892 22.4071C19.2491 22.6743 18.9607 22.8838 18.7251 22.7443L12.1592 18.8568C12.061 18.7986 11.939 18.7986 11.8408 18.8568L5.27494 22.7443C5.0393 22.8838 4.75092 22.6743 4.81079 22.4071L6.47908 14.9613C6.50403 14.8499 6.46631 14.7338 6.38069 14.6584L0.654479 9.61524C0.448969 9.43424 0.55912 9.09523 0.831768 9.0696L8.42867 8.35536C8.54227 8.34468 8.64102 8.27293 8.68628 8.16819L11.7131 1.16382Z", fill: "#fffdfa", stroke: "#fffdfa" })),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("clipPath", { id: clipPathId },
                    react_1.default.createElement("rect", { width: "12", height: "23", fill: "white", transform: "translate(0.5)" })))));
    }
    else {
        return (react_1.default.createElement("svg", { width: "24", height: "23", viewBox: "0 0 24 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M11.7131 1.16382C11.8218 0.912438 12.1782 0.912437 12.2869 1.16382L15.3137 8.16819C15.359 8.27293 15.4577 8.34468 15.5713 8.35536L23.1682 9.0696C23.4409 9.09523 23.551 9.43424 23.3455 9.61524L17.6193 14.6584C17.5337 14.7338 17.496 14.8499 17.5209 14.9613L19.1892 22.4071C19.2491 22.6743 18.9607 22.8838 18.7251 22.7443L12.1592 18.8568C12.061 18.7986 11.939 18.7986 11.8408 18.8568L5.27494 22.7443C5.0393 22.8838 4.75092 22.6743 4.81079 22.4071L6.47908 14.9613C6.50403 14.8499 6.46631 14.7338 6.38069 14.6584L0.654479 9.61524C0.448969 9.43424 0.55912 9.09523 0.831768 9.0696L8.42867 8.35536C8.54227 8.34468 8.64102 8.27293 8.68628 8.16819L11.7131 1.16382Z", fill: "none", stroke: "#fffdfa" })));
    }
};
exports.Star = Star;


/***/ }),

/***/ 63129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Rating = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var star_1 = __webpack_require__(5305);
var styles_scss_1 = __importDefault(__webpack_require__(9376));
var Rating = function (_a) {
    var rating = _a.rating;
    // convert a numerical rating into an array of "full", "half" and "empty" stars
    var starArray = Array.from(Array(5).keys()).map(function (i) {
        if (rating >= i + 1) {
            return "full";
        }
        else if (rating >= i + 0.5) {
            return "half";
        }
        else {
            return "empty";
        }
    });
    return (react_1.default.createElement("div", { className: styles_scss_1.default["star-rating"], title: "".concat(rating.toString(), " rating") }, starArray.map(function (star, i) { return (react_1.default.createElement(star_1.Star, { variant: star, key: i })); })));
};
exports.Rating = Rating;


/***/ }),

/***/ 79540:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var testimonialCard_1 = __importDefault(__webpack_require__(63198));
var styles_scss_1 = __importDefault(__webpack_require__(34001));
var useWindowSize_1 = __webpack_require__(55454);
var carousel_v2_1 = __importDefault(__webpack_require__(69857));
var tokens_breakpoints_1 = __webpack_require__(26963);
var arrow_forward_react_svg_1 = __importDefault(__webpack_require__(69554));
var TrustpilotScore_1 = __webpack_require__(75975);
var componentName = "TestimonialCarousel";
var elementIdentifiers = (0, shared_1.tuple)("container", "carousel", "reviewsContainer", "link", "linkContent", "arrow");
var TestimonialCarousel = function (_a) {
    var cards = _a.cards, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["cards", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: styles_scss_1.default
    });
    var width = (0, useWindowSize_1.useWindowSize)().width;
    var isMobile = width && width <= tokens_breakpoints_1.MQ_WIDE;
    var cardComponents = __spreadArray([], cards.map(function (card) { return (react_1.default.createElement(testimonialCard_1.default, __assign({ classOverrides: { reviewContainer: styles_scss_1.default.container }, size: isMobile ? "small" : "large" }, card))); }), true);
    var card = (react_1.default.createElement("div", { className: styles_scss_1.default.trustpilot },
        react_1.default.createElement("h2", { className: styles_scss_1.default.title }, "Reviews"),
        react_1.default.createElement("p", { className: styles_scss_1.default.text }, "Join thousands of homeowners who got a mortgage with Better.co.uk"),
        react_1.default.createElement(TrustpilotScore_1.TrustpilotScore, null)));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isMobile && card,
        react_1.default.createElement("div", __assign({}, ovr.reviewsContainer),
            !isMobile && card,
            react_1.default.createElement(carousel_v2_1.default, null,
                cardComponents,
                react_1.default.createElement("div", __assign({}, ovr.link),
                    react_1.default.createElement("a", __assign({}, ovr.linkContent, { href: "https://uk.trustpilot.com/review/better.co.uk", target: "_blank" }),
                        react_1.default.createElement("span", null, "Read more customer stories"),
                        react_1.default.createElement("div", __assign({}, ovr.arrow),
                            react_1.default.createElement(arrow_forward_react_svg_1.default, null))))))));
};
TestimonialCarousel.displayName = componentName;
exports["default"] = TestimonialCarousel;


/***/ }),

/***/ 54790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var timeline_tick_react_svg_1 = __importDefault(__webpack_require__(10993));
var style_scss_1 = __importDefault(__webpack_require__(5536));
var componentName = "Timeline";
var elementIdentifiers = (0, shared_1.tuple)("outerContainer", "option", "enabled", "disabled", "text", "left", "line", "title", "textWrapper");
var Timeline = function (_a) {
    var options = _a.options, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["options", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var prefix = props.id || componentName;
    var sizeOptions = options.length;
    return (react_1.default.createElement("div", __assign({}, ovr.outerContainer, props, { className: (0, classnames_1.default)(ovr.outerContainer.className, className), "aria-labelledby": "".concat(prefix, "-title"), "aria-describedby": "".concat(prefix, "-message"), role: "region" }), options.map(function (_a, index) {
        var text = _a.text, enabled = _a.enabled, title = _a.title;
        return (react_1.default.createElement("div", __assign({ key: title }, ovr.option),
            react_1.default.createElement("div", __assign({}, ovr.left),
                enabled ? (react_1.default.createElement("div", __assign({}, ovr.enabled),
                    react_1.default.createElement(timeline_tick_react_svg_1.default, null))) : (react_1.default.createElement("div", __assign({}, ovr.disabled))),
                sizeOptions !== index + 1 && react_1.default.createElement("div", __assign({}, ovr.line))),
            react_1.default.createElement("div", __assign({}, ovr.textWrapper),
                title && react_1.default.createElement("div", __assign({}, ovr.title), title),
                react_1.default.createElement("div", __assign({}, ovr.text), text))));
    })));
};
Timeline.displayName = componentName;
exports["default"] = Timeline;


/***/ }),

/***/ 57852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.componentTimelinePlainWithTitleName = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var timeline_1 = __importDefault(__webpack_require__(54790));
var typography_1 = __webpack_require__(34237);
var style_scss_1 = __importDefault(__webpack_require__(76508));
exports.componentTimelinePlainWithTitleName = "TimelinePlainWithTitle";
var elementIdentifiers = (0, shared_1.tuple)("outerContainer", "line", "title", "textWrapper", "ellipse", "wrapper", "mainTitle");
var TimelinePlainWithTitle = function (_a) {
    var options = _a.options, title = _a.title, className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["options", "title", "className", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: exports.componentTimelinePlainWithTitleName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("div", __assign({}, ovr.outerContainer, props, { className: (0, classnames_1.default)(ovr.outerContainer.className, className) }),
        react_1.default.createElement(typography_1.Typography, { variant: "h3", component: "h2", classes: ovr.mainTitle.className, testId: ovr.mainTitle["data-testid"], ref: ovr.mainTitle.ref }, title),
        react_1.default.createElement(timeline_1.default, { options: options, classOverrides: {
                line: ovr.line.className,
                disabled: ovr.ellipse.className,
                textWrapper: ovr.textWrapper.className,
                title: ovr.title.className
            }, className: ovr.wrapper.className })));
};
TimelinePlainWithTitle.displayName = exports.componentTimelinePlainWithTitleName;
exports["default"] = TimelinePlainWithTitle;


/***/ }),

/***/ 21000:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "Tooltip Card";
exports.elementIdentifiers = (0, shared_1.tuple)("tooltipCard", "tooltipCardContainer", "tooltipCardHeader", "tooltipCardFooter", "pill", "subtitle", "caret");


/***/ }),

/***/ 60533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(49299));
var button_1 = __importDefault(__webpack_require__(47426));
var pill_1 = __importStar(__webpack_require__(74747));
var constants_1 = __webpack_require__(21000);
var classnames_1 = __importDefault(__webpack_require__(57485));
var TooltipCard = function (_a) {
    var classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, buttonText = _a.buttonText, onButtonClick = _a.onButtonClick, monthsRemaining = _a.monthsRemaining, pillText = _a.pillText, subtitle = _a.subtitle, stateColour = _a.stateColour, caretPosition = _a.caretPosition, children = _a.children, showForm = _a.showForm, props = __rest(_a, ["classOverrides", "testIds", "refs", "buttonText", "onButtonClick", "monthsRemaining", "pillText", "subtitle", "stateColour", "caretPosition", "children", "showForm"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var buttonColour = stateColour === "informative"
        ? shared_1.ButtonColour.Secondary
        : shared_1.ButtonColour.Primary;
    return (react_1.default.createElement("div", __assign({ "aria-label": "tooltip card" }, ovr.tooltipCardContainer, props, { className: ovr.tooltipCardContainer.className }),
        react_1.default.createElement("div", __assign({}, ovr.tooltipCard),
            react_1.default.createElement("div", __assign({}, ovr.tooltipCardHeader),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", __assign({}, ovr.subtitle), subtitle),
                    react_1.default.createElement("p", { className: (0, classnames_1.default)(style_scss_1.default["".concat(stateColour)], style_scss_1.default.month) }, monthsRemaining)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(pill_1.default, { classOverrides: { pill: style_scss_1.default.pill }, colour: 
                        // eslint-disable-next-line no-nested-ternary
                        stateColour === "primary"
                            ? pill_1.PillColours.Primary
                            : stateColour === "informative"
                                ? pill_1.PillColours.Disabled
                                : pill_1.PillColours.Warning }, pillText))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", null, children))),
            react_1.default.createElement("div", __assign({}, ovr.tooltipCardFooter),
                showForm || null,
                !showForm && (react_1.default.createElement(button_1.default, { fixed: false, colour: buttonColour, onClick: onButtonClick }, buttonText)))),
        caretPosition && (react_1.default.createElement("div", __assign({}, ovr.caret, { className: (0, classnames_1.default)(ovr.caret.className, style_scss_1.default["align-".concat(caretPosition)]) })))));
};
TooltipCard.displayName = constants_1.componentName;
exports["default"] = TooltipCard;


/***/ }),

/***/ 26924:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = void 0;
var react_1 = __importStar(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(25265));
var star_png_1 = __importDefault(__webpack_require__(9554));
var trustpilot_react_svg_1 = __importDefault(__webpack_require__(70975));
var card_1 = __importDefault(__webpack_require__(82972));
var componentName = "Trustpilot Card";
exports.elementIdentifiers = (0, shared_1.tuple)("trustpilotCard", "trustpilotCardContainer", "title", "trustPilotLogo", "name", "starWrapper", "bouncyStar", "reviewCardContainer", "reviewerWrapper", "headerWrapper", "reviewWrapper");
var REVIEW_DURATION = 5000;
var TRUST_PILOT_STAR_COUNT = 5;
var TrustpilotCard = function (_a) {
    var _b, _c, _d;
    var classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, title = _a.title, props = __rest(_a, ["classOverrides", "testIds", "refs", "title"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: exports.elementIdentifiers,
        componentName: componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var _e = (0, react_1.useState)(0), currentIndex = _e[0], setCurrentIndex = _e[1];
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () {
            setTimeout(function () {
                // eslint-disable-next-line max-nested-callbacks
                setCurrentIndex(function (prevIndex) { return (prevIndex + 1) % props.reviews.length; });
            }, 0);
        }, REVIEW_DURATION);
        return function () { return clearInterval(interval); };
    }, [props.reviews.length, REVIEW_DURATION]);
    return (react_1.default.createElement("div", __assign({ role: "region", "aria-label": "Trustpilot card" }, ovr.trustpilotCardContainer, props, { className: ovr.trustpilotCardContainer.className }),
        react_1.default.createElement("div", __assign({}, ovr.trustpilotCard),
            react_1.default.createElement("div", __assign({}, ovr.headerWrapper),
                react_1.default.createElement("h3", __assign({}, ovr.title), title),
                react_1.default.createElement("div", { className: ovr.starWrapper.className }, Array(TRUST_PILOT_STAR_COUNT).fill(react_1.default.createElement("div", { className: (0, classnames_1.default)(ovr.bouncyStar.className, (_b = {},
                        _b[style_scss_1.default.bouncyStarInfinite] = props.bounceOnEveryReview,
                        _b)) },
                    react_1.default.createElement("img", { src: star_png_1.default, alt: "Star" }))))),
            react_1.default.createElement("div", __assign({}, ovr.reviewWrapper),
                react_1.default.createElement(card_1.default, { classOverrides: {
                        cardContainer: (0, classnames_1.default)(ovr.reviewCardContainer.className, (_c = {},
                            _c[style_scss_1.default.reviewCardContainerSlideLeft] = props.reviewDirection === shared_1.Direction.LEFT,
                            _c[style_scss_1.default.reviewCardContainerSlideRight] = props.reviewDirection === shared_1.Direction.RIGHT,
                            _c)),
                        card: style_scss_1.default.reviewCard,
                        text: style_scss_1.default.reviewCardText
                    } }, props.reviews[currentIndex].review),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(ovr.reviewerWrapper.className, (_d = {},
                            _d[style_scss_1.default.reviewerWrapperSlideLeft] = props.customerNameDirection === shared_1.Direction.LEFT,
                            _d[style_scss_1.default.reviewerWrapperSlideRight] = props.customerNameDirection === shared_1.Direction.RIGHT,
                            _d)) },
                        react_1.default.createElement("p", __assign({}, ovr.name),
                            props.reviews[currentIndex].name,
                            ",\u00A0"),
                        react_1.default.createElement("p", null, "Better.co.uk customer")))),
            react_1.default.createElement("span", __assign({}, ovr.trustPilotLogo),
                react_1.default.createElement(trustpilot_react_svg_1.default, { "aria-label": "Trustpilot logo" })))));
};
TrustpilotCard.displayName = componentName;
exports["default"] = TrustpilotCard;


/***/ }),

/***/ 89004:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementIdentifiers = exports.componentName = void 0;
var shared_1 = __webpack_require__(89574);
exports.componentName = "TujButton";
exports.elementIdentifiers = (0, shared_1.tuple)("button", "body", "title", "icon", "smartBuyerBadge");


/***/ }),

/***/ 61382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var classnames_1 = __importDefault(__webpack_require__(57485));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(51889));
var constants_1 = __webpack_require__(89004);
var right_react_svg_1 = __importDefault(__webpack_require__(22906));
var right_reskin_react_svg_1 = __importDefault(__webpack_require__(98267));
var TujButton = function (_a) {
    var className = _a.className, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, _b = _a.arrowVersion, arrowVersion = _b === void 0 ? "v2" : _b, _c = _a.smartBuyerBadge, smartBuyerBadge = _c === void 0 ? false : _c, title = _a.title, body = _a.body, _d = _a.variant, variant = _d === void 0 ? "default" : _d, props = __rest(_a, ["className", "classOverrides", "testIds", "refs", "arrowVersion", "smartBuyerBadge", "title", "body", "variant"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: constants_1.elementIdentifiers,
        componentName: constants_1.componentName,
        id: props.id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    return (react_1.default.createElement("button", __assign({}, props, ovr.button, { className: (0, classnames_1.default)(ovr.button.className, className, variant === "dark" ? style_scss_1.default.dark : "") }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("h2", __assign({}, ovr.title),
                title,
                smartBuyerBadge === true ? (react_1.default.createElement("div", __assign({}, ovr.smartBuyerBadge, { className: ovr.smartBuyerBadge.className }), "SmartBuyer")) : null),
            body && react_1.default.createElement("div", __assign({}, ovr.body), body)),
        react_1.default.createElement("div", __assign({}, ovr.icon), arrowVersion === "v3" ? react_1.default.createElement(right_reskin_react_svg_1.default, null) : react_1.default.createElement(right_react_svg_1.default, null))));
};
TujButton.displayName = constants_1.componentName;
exports["default"] = TujButton;


/***/ }),

/***/ 21716:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(646));
var classnames_1 = __importDefault(__webpack_require__(57485));
var form_1 = __webpack_require__(13174);
var whatsapp_react_svg_1 = __importDefault(__webpack_require__(18050));
var componentName = "WhatsAppButton";
var elementIdentifiers = (0, shared_1.tuple)("button", "content");
var WhatsAppButton = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "Chat on WhatsApp" : _b, _c = _a.size, size = _c === void 0 ? shared_1.ButtonSize.Small : _c, onClick = _a.onClick, id = _a.id, classOverrides = _a.classOverrides, className = _a.className, testIds = _a.testIds, refs = _a.refs, props = __rest(_a, ["label", "size", "onClick", "id", "classOverrides", "className", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var handleClick = function () {
        window.open("https://wa.me/442039237999", "_blank");
    };
    return (react_1.default.createElement(form_1.Button, __assign({}, ovr.button, props, { className: (0, classnames_1.default)(ovr.button.className, className), classOverrides: { button: style_scss_1.default.button }, fixed: false, size: size, onClick: onClick !== null && onClick !== void 0 ? onClick : handleClick }),
        react_1.default.createElement("span", __assign({}, ovr.content),
            react_1.default.createElement(whatsapp_react_svg_1.default, null),
            label)));
};
WhatsAppButton.displayName = componentName;
exports["default"] = WhatsAppButton;


/***/ }),

/***/ 32871:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(99497));
var shared_1 = __webpack_require__(89574);
var style_scss_1 = __importDefault(__webpack_require__(24925));
var workingHours_1 = __webpack_require__(62224);
var componentName = "WorkingHoursInfo";
var elementIdentifiers = (0, shared_1.tuple)("container", "title", "text");
var WorkingHoursInfo = function (_a) {
    var _b = _a.title, title = _b === void 0 ? "Working hours" : _b, _c = _a.workingHours, workingHours = _c === void 0 ? {
        mon: [9, 20],
        tue: [9, 20],
        wed: [9, 20],
        thu: [9, 20],
        fri: [9, 20],
        sat: [9, 17]
    } : _c, id = _a.id, classOverrides = _a.classOverrides, testIds = _a.testIds, refs = _a.refs, rest = __rest(_a, ["title", "workingHours", "id", "classOverrides", "testIds", "refs"]);
    var ovr = (0, shared_1.useOverrides)({
        elementIdentifiers: elementIdentifiers,
        componentName: componentName,
        id: id,
        classOverrides: classOverrides,
        testIds: testIds,
        refs: refs,
        stylesheet: style_scss_1.default
    });
    var consolidatedHours = (0, workingHours_1.getConsolidatedHours)(workingHours);
    return (react_1.default.createElement("div", __assign({}, rest, ovr.container),
        react_1.default.createElement("p", __assign({}, ovr.title), title),
        react_1.default.createElement("p", __assign({}, ovr.text), consolidatedHours.map(function (hours) { return (react_1.default.createElement("span", { key: hours },
            hours,
            react_1.default.createElement("br", null))); }))));
};
WorkingHoursInfo.displayName = componentName;
exports["default"] = WorkingHoursInfo;


/***/ }),

/***/ 62224:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getConsolidatedHours = void 0;
function formatTime(hour, minute) {
    var period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return "".concat(hour).concat(minute === 0 ? "" : ":".concat(minute)).concat(period);
}
function formatWorkingHours(hours) {
    var result = {};
    for (var day in hours) {
        var _a = hours[day], startHour = _a[0], endHour = _a[1];
        // Normalize start hour
        var normalizedStartHour = startHour >= 100 ? Math.floor(startHour / 100) : startHour;
        var startMinutes = startHour >= 100 ? startHour % 100 : 0;
        // Normalize end hour
        var normalizedEndHour = endHour >= 100 ? Math.floor(endHour / 100) : endHour;
        var endMinutes = endHour >= 100 ? endHour % 100 : 0;
        var startTime = formatTime(normalizedStartHour, startMinutes);
        var endTime = formatTime(normalizedEndHour, endMinutes);
        result[day] = "".concat(startTime, " - ").concat(endTime);
    }
    return result;
}
function consolidateHours(hours) {
    // Define day order for checking consecutive days
    var dayOrder = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
    var result = [];
    var currentRange = [];
    var currentHours = "";
    // Process days in order
    for (var i = 0; i < dayOrder.length; i++) {
        var day = dayOrder[i];
        if (hours[day]) {
            if (currentRange.length === 0) {
                // Start new range
                currentRange.push(day);
                currentHours = hours[day];
            }
            else if (hours[day] === currentHours &&
                dayOrder.indexOf(currentRange[currentRange.length - 1]) === i - 1) {
                // Add to current range if hours match and day is consecutive
                currentRange.push(day);
            }
            else {
                // End current range and start new one
                result.push(formatRange(currentRange, currentHours));
                currentRange = [day];
                currentHours = hours[day];
            }
        }
    }
    // Add final range
    if (currentRange.length > 0) {
        result.push(formatRange(currentRange, currentHours));
    }
    return result;
}
function formatRange(days, hours) {
    var formattedDays = days.map(function (day) { return day.charAt(0).toUpperCase() + day.slice(1, 3); });
    return days.length === 1
        ? "".concat(formattedDays[0], ": ").concat(hours)
        : "".concat(formattedDays[0], "-").concat(formattedDays[formattedDays.length - 1], ": ").concat(hours);
}
function getConsolidatedHours(workingHours) {
    var formattedHours = formatWorkingHours(workingHours);
    return consolidateHours(formattedHours);
}
exports.getConsolidatedHours = getConsolidatedHours;


/***/ }),

/***/ 79090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeWrapper = void 0;
var wrapper_1 = __webpack_require__(45436);
Object.defineProperty(exports, "ThemeWrapper", ({ enumerable: true, get: function () { return __importDefault(wrapper_1).default; } }));
__exportStar(__webpack_require__(45436), exports);
__exportStar(__webpack_require__(58853), exports);


/***/ }),

/***/ 96759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(26963), exports);


/***/ }),

/***/ 26963:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MQ_EXTRA_WIDE_V2_ABOVE_LIMIT = exports.MQ_EXTRA_WIDE_V2 = exports.MQ_EXTRA_WIDE_ABOVE_LIMIT = exports.MQ_EXTRA_WIDE = exports.MQ_WIDE_ABOVE_LIMIT = exports.MQ_WIDE = exports.MQ_MEDIUM_LARGE_ABOVE_LARGE = exports.MQ_MEDIUM_LARGE = exports.MQ_MEDIUM_ABOVE_LIMIT = exports.MQ_MEDIUM = exports.MQ_MEDIUM_SMALL_ABOVE_LIMIT = exports.MQ_MEDIUM_SMALL = exports.MQ_SMALL_ABOVE_LIMIT = exports.MQ_SMALL = exports.MQ_SMALL_VERTICAL_ABOVE_LIMIT = exports.MQ_SMALL_VERTICAL = exports.MQ_EXTRA_SMALL_ABOVE_LIMIT = exports.MQ_EXTRA_SMALL = void 0;
exports.MQ_EXTRA_SMALL = 320;
exports.MQ_EXTRA_SMALL_ABOVE_LIMIT = 321;
exports.MQ_SMALL_VERTICAL = 375;
exports.MQ_SMALL_VERTICAL_ABOVE_LIMIT = 376;
exports.MQ_SMALL = 480;
exports.MQ_SMALL_ABOVE_LIMIT = 481;
exports.MQ_MEDIUM_SMALL = 520;
exports.MQ_MEDIUM_SMALL_ABOVE_LIMIT = 521;
exports.MQ_MEDIUM = 640;
exports.MQ_MEDIUM_ABOVE_LIMIT = 641;
exports.MQ_MEDIUM_LARGE = 720;
exports.MQ_MEDIUM_LARGE_ABOVE_LARGE = 721;
exports.MQ_WIDE = 960;
exports.MQ_WIDE_ABOVE_LIMIT = 961;
exports.MQ_EXTRA_WIDE = 1200;
exports.MQ_EXTRA_WIDE_ABOVE_LIMIT = 1201;
exports.MQ_EXTRA_WIDE_V2 = 1360;
exports.MQ_EXTRA_WIDE_V2_ABOVE_LIMIT = 1361;


/***/ }),

/***/ 58853:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(96759), exports);


/***/ }),

/***/ 45436:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTheme = exports.Themes = void 0;
var classnames_1 = __importDefault(__webpack_require__(57485));
var style_scss_1 = __importDefault(__webpack_require__(69436));
var react_1 = __importStar(__webpack_require__(99497));
var componentName = "ThemeWrapper";
var Themes;
(function (Themes) {
    Themes["TRUSSLE_V3"] = "DEFAULT";
    Themes["ZOOPLA"] = "ZOOPLA";
})(Themes = exports.Themes || (exports.Themes = {}));
var ThemeContext = (0, react_1.createContext)(Themes.TRUSSLE_V3);
var useTheme = function () { return (0, react_1.useContext)(ThemeContext); };
exports.useTheme = useTheme;
var ThemeWrapper = function (_a) {
    var _b;
    var children = _a.children, _c = _a.theme, theme = _c === void 0 ? Themes.TRUSSLE_V3 : _c, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(style_scss_1.default.wrapper, className, (_b = {},
            _b[style_scss_1.default.defaultWrapper] = theme === Themes.TRUSSLE_V3,
            _b[style_scss_1.default.zooplaWrapper] = theme === Themes.ZOOPLA,
            _b)) },
        react_1.default.createElement(ThemeContext.Provider, { value: theme }, children)));
};
ThemeWrapper.displayName = componentName;
exports["default"] = ThemeWrapper;


/***/ }),

/***/ 34237:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Typography = void 0;
var react_1 = __importDefault(__webpack_require__(99497));
var classnames_1 = __importDefault(__webpack_require__(57485));
var styles_scss_1 = __importDefault(__webpack_require__(87947));
var variantClasses = {
    display1: styles_scss_1.default.display1Variant,
    display2: styles_scss_1.default.display2Variant,
    display3: styles_scss_1.default.display3Variant,
    h1: styles_scss_1.default.h1Variant,
    h2: styles_scss_1.default.h2Variant,
    h3: styles_scss_1.default.h3Variant,
    h4: styles_scss_1.default.h4Variant,
    h5: styles_scss_1.default.h5Variant,
    h6: styles_scss_1.default.h6Variant,
    h7: styles_scss_1.default.h7Variant,
    body1: styles_scss_1.default.body1Variant,
    body2: styles_scss_1.default.body2Variant,
    body3: styles_scss_1.default.body3Variant
};
var Typography = function (_a) {
    var variant = _a.variant, component = _a.component, _b = _a.classes, classes = _b === void 0 ? {} : _b, _c = _a.align, align = _c === void 0 ? "left" : _c, children = _a.children, _d = _a.gutterBottom, gutterBottom = _d === void 0 ? false : _d, id = _a.id, testId = _a.testId, onClick = _a.onClick;
    var variantStyle = variantClasses[variant];
    var alignStyle = styles_scss_1.default[align];
    var element = variant.startsWith("h") ? variant : "div";
    var gutter = gutterBottom ? styles_scss_1.default.gutterBottom : {};
    var elementId = id !== null ? id || "typography_".concat(variantStyle) : null;
    var elementTestId = testId
        ? "typography_component-".concat(testId)
        : "typography_component";
    return react_1.default.createElement(component || element, {
        className: (0, classnames_1.default)(variantStyle, alignStyle, gutter, classes),
        id: elementId,
        "data-testid": elementTestId,
        onClick: onClick
    }, children);
};
exports.Typography = Typography;


/***/ }),

/***/ 44432:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function beforeNow() {
    return function (value) {
        return value !== null && value < Date.now() ? "Must be after now." : "";
    };
}
exports["default"] = beforeNow;


/***/ }),

/***/ 94118:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function afterYear(year) {
    return function (value) {
        return value !== null && new Date(value).getUTCFullYear() <= year
            ? "Must be after ".concat(year, ".")
            : "";
    };
}
exports["default"] = afterYear;


/***/ }),

/***/ 4661:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function beforeNow() {
    return function (value) {
        return value !== null && value > Date.now() ? "Must be before now." : "";
    };
}
exports["default"] = beforeNow;


/***/ }),

/***/ 67233:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function beforeYear(year) {
    return function (value) {
        return value !== null && new Date(value).getUTCFullYear() >= year
            ? "Must be before ".concat(year, ".")
            : "";
    };
}
exports["default"] = beforeYear;


/***/ }),

/***/ 35903:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
// eslint-disable-next-line no-useless-escape
var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function mandatory() {
    return function (value) {
        return value !== null && !regex.test(value) ? "Not a valid email address." : "";
    };
}
exports["default"] = mandatory;


/***/ }),

/***/ 98260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/* istanbul ignore file */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withMessage = exports.mustEqual = exports.minimumLength = exports.minimumCurrency = exports.minimum = exports.maximumCurrency = exports.maximum = exports.mandatory = exports.email = exports.beforeYear = exports.beforeNow = exports.afterYear = exports.afterNow = void 0;
var afterNow_1 = __webpack_require__(44432);
Object.defineProperty(exports, "afterNow", ({ enumerable: true, get: function () { return __importDefault(afterNow_1).default; } }));
var afterYear_1 = __webpack_require__(94118);
Object.defineProperty(exports, "afterYear", ({ enumerable: true, get: function () { return __importDefault(afterYear_1).default; } }));
var beforeNow_1 = __webpack_require__(4661);
Object.defineProperty(exports, "beforeNow", ({ enumerable: true, get: function () { return __importDefault(beforeNow_1).default; } }));
var beforeYear_1 = __webpack_require__(67233);
Object.defineProperty(exports, "beforeYear", ({ enumerable: true, get: function () { return __importDefault(beforeYear_1).default; } }));
var email_1 = __webpack_require__(35903);
Object.defineProperty(exports, "email", ({ enumerable: true, get: function () { return __importDefault(email_1).default; } }));
var mandatory_1 = __webpack_require__(69355);
Object.defineProperty(exports, "mandatory", ({ enumerable: true, get: function () { return __importDefault(mandatory_1).default; } }));
var maximum_1 = __webpack_require__(57834);
Object.defineProperty(exports, "maximum", ({ enumerable: true, get: function () { return __importDefault(maximum_1).default; } }));
var maximumCurrency_1 = __webpack_require__(19865);
Object.defineProperty(exports, "maximumCurrency", ({ enumerable: true, get: function () { return __importDefault(maximumCurrency_1).default; } }));
var minimum_1 = __webpack_require__(74898);
Object.defineProperty(exports, "minimum", ({ enumerable: true, get: function () { return __importDefault(minimum_1).default; } }));
var minimumCurrency_1 = __webpack_require__(91210);
Object.defineProperty(exports, "minimumCurrency", ({ enumerable: true, get: function () { return __importDefault(minimumCurrency_1).default; } }));
var minimumLength_1 = __webpack_require__(17108);
Object.defineProperty(exports, "minimumLength", ({ enumerable: true, get: function () { return __importDefault(minimumLength_1).default; } }));
var mustEqual_1 = __webpack_require__(151);
Object.defineProperty(exports, "mustEqual", ({ enumerable: true, get: function () { return __importDefault(mustEqual_1).default; } }));
var withMessage_1 = __webpack_require__(88262);
Object.defineProperty(exports, "withMessage", ({ enumerable: true, get: function () { return __importDefault(withMessage_1).default; } }));


/***/ }),

/***/ 69355:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function mandatory() {
    return function (value) { return (value === null ? "Must enter a value." : ""); };
}
exports["default"] = mandatory;


/***/ }),

/***/ 57834:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function maximum(max) {
    return function (value) {
        // eslint-disable-next-line eqeqeq
        return value != null && value > max ? "Maximum is ".concat(max, ".") : "";
    };
}
exports["default"] = maximum;


/***/ }),

/***/ 19865:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function maximumCurrency(max) {
    return function (value) {
        return value !== null && value > max ? "Maximum is \u00A3".concat(max.toLocaleString(), ".") : "";
    };
}
exports["default"] = maximumCurrency;


/***/ }),

/***/ 74898:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function minimum(min) {
    return function (value) {
        // eslint-disable-next-line eqeqeq
        return value != null && value < min ? "Minimum is ".concat(min, ".") : "";
    };
}
exports["default"] = minimum;


/***/ }),

/***/ 91210:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function minimumCurrency(min) {
    return function (value) {
        return value !== null && value < min ? "Minimum is \u00A3".concat(min.toLocaleString(), ".") : "";
    };
}
exports["default"] = minimumCurrency;


/***/ }),

/***/ 17108:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function minimumLength(min) {
    return function (value) {
        return value !== null && value.length < min ? "Minimum length is ".concat(min, ".") : "";
    };
}
exports["default"] = minimumLength;


/***/ }),

/***/ 151:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function mustEqual(constant) {
    return function (value) {
        return value !== constant ? "Must be ".concat(constant, ".") : "";
    };
}
exports["default"] = mustEqual;


/***/ }),

/***/ 88262:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function withMessage(message, validator) {
    return function (value) {
        var error = validator(value);
        return error ? message : "";
    };
}
exports["default"] = withMessage;


/***/ }),

/***/ 84420:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "fallback-trustpilot-score.66844b0654ca9e1734bf.svg";

/***/ }),

/***/ 64356:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "avatar-x2.99608e49b2cd9d7ce659.png";

/***/ }),

/***/ 6016:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "avatar.f87936a6a63a6493bd47.png";

/***/ }),

/***/ 40699:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "monty-bot.390605c1a66cfbbf99b3.png";

/***/ }),

/***/ 70113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "rates-chart.3ec65322f0ef3f82169c.png";

/***/ }),

/***/ 64600:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "monzoKey.c1aa8393d7ddd9ddd840.png";

/***/ }),

/***/ 79939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "monzoLogo.99a313a628d91eea4ef4.png";

/***/ }),

/***/ 15755:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "moneyUmbrella.5a7de55d7e94fd196364.png";

/***/ }),

/***/ 9554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "star.e51065d7592d0dbf89a6.png";

/***/ }),

/***/ 93815:
/***/ ((module) => {

module.exports = require("@react-spring/web");

/***/ }),

/***/ 58719:
/***/ ((module) => {

module.exports = require("@trussle/react-imask");

/***/ }),

/***/ 57485:
/***/ ((module) => {

module.exports = require("classnames");

/***/ }),

/***/ 88296:
/***/ ((module) => {

module.exports = require("cookieconsent");

/***/ }),

/***/ 16060:
/***/ ((module) => {

module.exports = require("dayjs");

/***/ }),

/***/ 67850:
/***/ ((module) => {

module.exports = require("dayjs/locale/en-gb");

/***/ }),

/***/ 476:
/***/ ((module) => {

module.exports = require("dayjs/plugin/customParseFormat");

/***/ }),

/***/ 54468:
/***/ ((module) => {

module.exports = require("dayjs/plugin/utc");

/***/ }),

/***/ 89192:
/***/ ((module) => {

module.exports = require("lodash.debounce");

/***/ }),

/***/ 81805:
/***/ ((module) => {

module.exports = require("lodash.get");

/***/ }),

/***/ 88073:
/***/ ((module) => {

module.exports = require("lodash.isboolean");

/***/ }),

/***/ 76506:
/***/ ((module) => {

module.exports = require("lodash.isnumber");

/***/ }),

/***/ 34590:
/***/ ((module) => {

module.exports = require("lodash.omit");

/***/ }),

/***/ 47049:
/***/ ((module) => {

module.exports = require("lodash.pick");

/***/ }),

/***/ 39523:
/***/ ((module) => {

module.exports = require("lodash.throttle");

/***/ }),

/***/ 99497:
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ 27137:
/***/ ((module) => {

module.exports = require("react-dom");

/***/ }),

/***/ 1953:
/***/ ((module) => {

module.exports = require("react-is");

/***/ }),

/***/ 36887:
/***/ ((module) => {

module.exports = require("react-linkify");

/***/ }),

/***/ 64139:
/***/ ((module) => {

module.exports = require("react-text-mask");

/***/ }),

/***/ 54973:
/***/ ((module) => {

module.exports = require("react-use-draggable-scroll");

/***/ }),

/***/ 26893:
/***/ ((module) => {

module.exports = require("scriptjs");

/***/ }),

/***/ 39873:
/***/ ((module) => {

module.exports = require("text-mask-addons/dist/createAutoCorrectedDatePipe");

/***/ }),

/***/ 37251:
/***/ ((module) => {

module.exports = require("use-onclickoutside");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "https://02.cdn.better.co.uk/@trussle/external-components/6.45.2/";
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(80341);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;